/* THIS FILE IS AUTOGENERATED. DO NOT EDIT */

export enum STRINGS {
    ACCEPTED,
    ACCEPT_THESE_HOURS,
    ACCEPT_THE_VISIT_AT,
    ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY,
    ACCOUNT_NUMBER,
    ACCOUNT_TYPE,
    ACTIVE,
    ACTIVE_DOCUMENT,
    ADD,
    ADDITIONAL_NOTES,
    ADDRESS,
    ADDRESS2,
    ADDRESS_ERROR,
    ADDRESS_IS_NEAR,
    ADD_ANOTHER_DOCUMENT,
    ADD_ANOTHER_PERTINENT_DIAGNOSIS,
    ADD_IMAGE,
    ADD_NEW_MEDICATION,
    ADD_NOTES,
    ADD_NOTE_TO_PATIENT_PROFILE_BUTTON,
    ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE,
    ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER,
    ADD_NOTE_TO_PATIENT_PROFILE_TITLE,
    ADD_PHYSICIAN,
    ADD_YOUR_SIGNATURE,
    ADVANCED_DIRECTIVES,
    AGENCIES_CONTACT,
    AGENCY,
    AGENCY_CODE,
    AGENCY_COORDINATOR,
    AGENCY_DETAILS,
    AGENCY_HANDBOOK,
    AGENCY_ISSUES,
    AGENCY_NAME,
    AGENCY_NOTIFICATIONS,
    AGENCY_NOT_FOUND,
    AGREE_TO_MEDFLYT_TERMS,
    AIDE,
    AIRPODS,
    ALLERGIES,
    ALLOW_ACCESS_TO_MY_LOCATION,
    ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP,
    ALL_CHANGES_SAVED,
    ALL_DAY,
    ALL_DONE,
    ALL_TRANSACTIONS,
    ALL_VERIFIED_ITEMS,
    ALREADY_CLOCKED_IN,
    ALREADY_CLOCKED_IN_ANOTHER_VISIT,
    ALREADY_CLOCKED_OUT,
    ALREADY_HAVE_AN_ACCOUNT,
    AND_AMPERSAND,
    ANSWERED,
    ANSWERED_AT,
    ANSWER_INCOMPLETE_QUESTIONS,
    ANY_DURATION,
    AN_ERROR_HAS_OCCURED,
    AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET,
    APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES,
    APPLICATION_DONE,
    APPROVE,
    APPROVED,
    APPROVE_THIS_TASK,
    APPROVE_THIS_VISIT,
    APRIL,
    ARENT_YOU_MISSING_SOMETHING,
    ARE_YOU,
    ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY,
    ARE_YOU_SURE,
    ARE_YOU_SURE_REQUEST_FAR_VISIT,
    ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK,
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST,
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT,
    ARE_YOU_SURE_YOU_WANT_TO_DELETE,
    ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE,
    ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT,
    ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE,
    ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE,
    ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT,
    ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT,
    ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK,
    ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK,
    ASSIGNED,
    ASSIST,
    AS_NEEDED,
    AS_REQUESTED_BY_THE_PATIENT,
    ATTACH_A_DOCUMENT,
    AUGUST,
    AUTHENTICATION_FAILED,
    AUTH_VERIFICATION_FAIL_EXAPLINED,
    AUTOPLAY,
    AVAILABILITY,
    AVAILABLE,
    AVAILABLE_CARE_POINTS,
    AVAILABLE_ON_THE_FOLLOWING_DAYS,
    AVAILABLE_SHIFTS,
    AVAILABLE_VISITS,
    AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK,
    AWAITING_PATIENT_CONTACT,
    A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT,
    A_VERIFICATION_CODE_IS_BEING_SENT_TO,
    A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE,
    A_VISIT_BY,
    BACK,
    BACK_TO_ONBOARDING,
    BANK_INFORMATION,
    BANK_NAME,
    BASICALLY_EVERY_ACTION_COUNTS,
    BEFORE_SUBMITTING_THE_DUTIES,
    BEGIN_NOW,
    BEST_TASK_FOR_YOU,
    BETWEEN,
    BETWEEN_AND,
    BIRTHDAY,
    BLOOD_PRESSURE,
    BOROUGH,
    BUNDLES,
    BUNDLE_DESCRIPTION,
    BUNDLE_DESCRIPTION_P1,
    BUNDLE_DESCRIPTION_P2,
    BUNDLE_IS_LOCKED,
    BUNDLE_ITEM_NOT_FOUND,
    BUNDLE_NOT_FOUND,
    BUNDLE_PROGRESS,
    BUSY_ALL_DAY,
    BY,
    BY_ENROLLING_I_ACCEPT_THE,
    BY_EXISTING_VISIT,
    BY_PATIENT_NAME,
    BY_SIGNING_HERE_I_ACCEPT_THE,
    CALL,
    CALL_AGENCY,
    CALL_HOME,
    CALL_MOBILE,
    CALL_NOW,
    CALL_PATIENT,
    CALL_PATIENT_CONFIRMATION,
    CALL_PATIENT_EXPLANATION,
    CALL_PATIENT_HOME,
    CALL_PATIENT_MOBILE,
    CALL_PATIENT_NOTE,
    CALL_SUPPORT_FOR_MORE_INFO,
    CANCEL,
    CANCEL_REQUESTED_SHIFTS,
    CANCEL_VISIT,
    CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE,
    CANT_CANCEL_24_HOURS_SCHEDULED_VISIT,
    CANT_CANCEL_AT_THIS_TIME,
    CANT_CLOCK_IN,
    CANT_CLOCK_IN_AT_THIS_TIME,
    CANT_CLOCK_OUT,
    CANT_CLOCK_OUT_AT_THIS_TIME,
    CANT_CLOCK_OUT_BEFORE_VISIT_ENDED,
    CANT_REJECT_VISIT_PENDING_STATUS,
    CANT_REQUEST_JOIN_AGENCY,
    CANT_REQUEST_VISIT_PENDING_STATUS,
    CANT_SUBMIT_AN_EMPTY_FORM,
    CANT_WATCH_ON_SHIFT,
    CANT_WATCH_THIS_VIDEO,
    CAREBACK_CASH_BONUS,
    CAREBACK_POINTS,
    CAREGIVER,
    CAREGIVER_COMPLIANCE_PASSPORT,
    CAREGIVER_NAME,
    CAREGIVER_PHONE,
    CAREGIVER_SIGNATURE,
    CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG,
    CAREGIVER_SIGNATURE_IS_REQUIRED,
    CAREGIVER_SIGNATURE_REQUIRE_MSG,
    CAREGIVER_STATUS_PENDING_ERROR,
    CARE_MOMENTS,
    CASE_INFO,
    CASE_IS_TOO_FAR,
    CASE_SETTINGS,
    CATALOGUE,
    CERTIFICATION,
    CERTIFICATIONS,
    CHANGE,
    CHANGES_TO_MY_VISITS,
    CHANGES_WERE_SAVED_IN_THE_CLOUD,
    CHANGE_DOCUMENT,
    CHANGE_OF_RANKING,
    CHANGE_PHONE_NUMBER,
    CHANGE_SETTINGS,
    CHANGE_SHIFTS,
    CHANGE_TASK_TIME,
    CHANGE_VISIT_TIMES,
    CHAT,
    CHATS,
    CHAT_MESSAGES,
    CHAT_NOT_ACTIVE_MESSAGE,
    CHAT_NOT_ACTIVE_TITLE,
    CHAT_WITH_AGENCY,
    CHAT_WITH_AGENCY_ABOUT_PATIENT,
    CHAT_WITH_MEDFLYT,
    CHAT_WITH_OTHER_AGENCIES,
    CHAT_WITH_SUPPORT,
    CHAT_WITH_US,
    CHECK,
    CHECK_AGAIN,
    CHOOSE_ANOTHER_DATE,
    CHOOSE_A_PHOTO,
    CHOOSE_A_TIME_FOR_THE_VISIT,
    CHOOSE_CLOCK_TIMES,
    CHOOSE_DATE_TO_PERFORM_THIS_TASK,
    CHOOSE_FOLDER_TO_UPLOAD,
    CHOOSE_START_TIME,
    CHOOSE_THE_HOURS,
    CHOOSE_TIME,
    CHOOSE_WHEN_TO_PERFORM_THE_VISIT,
    CHOOSE_WHEN_TO_VISIT_THE_PATIENT,
    CHOOSE_WHO_TO_CONTACT,
    CHOOSING_A_WINNER,
    CHOOSING_A_WINNER_IN,
    CLEAR,
    CLICK_HERE,
    CLICK_HERE_TO_DOWNLOAD,
    CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE,
    CLICK_HERE_TO_VIEW_CERTIFICATE,
    CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE,
    CLICK_TO_REQUEST,
    CLICK_TO_SCAN_UPLOAD,
    CLICK_TO_TAKE_A_SELFIE,
    CLIMB_THE_RANKS_BY_COMPLETING_VISITS,
    CLINICAL_SUPPORT,
    CLOCKED_IN,
    CLOCKED_IN_AND_OUT,
    CLOCKED_IN_AT,
    CLOCKED_OUT,
    CLOCKED_OUT_AT,
    CLOCKING_IN,
    CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES,
    CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES,
    CLOCKING_OUT,
    CLOCK_ADDRESS_IN_RANGE,
    CLOCK_ADDRESS_NOT_IN_RANGE,
    CLOCK_IN,
    CLOCK_IN_ANYWAY,
    CLOCK_IN_AT,
    CLOCK_IN_BETWEEN,
    CLOCK_IN_OUT,
    CLOCK_IN_OUT_SUBMIT_DUTIES,
    CLOCK_IN_TIME_IS_REQUIRED,
    CLOCK_OUT,
    CLOCK_OUT_AFTER,
    CLOCK_OUT_AT,
    CLOCK_OUT_BETWEEN,
    CLOCK_OUT_TIME_IS_REQUIRED,
    CLOCK_TIMES_NOT_MOBILE,
    CLOCK_TIME_IN_RANGE,
    CLOCK_TIME_NOT_IN_RANGE,
    CLOSE,
    CLOSE_SURVEY,
    CLUSTERED_VISIT_EXPLENATION,
    CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE,
    COMBINED_CASE,
    COMING_SOON,
    COMPLETED,
    COMPLETED_DOCUMENTS,
    COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL,
    COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS,
    COMPLETE_PREVIOUS_SECTIONS_FIRST,
    COMPLETE_REGISTRATION,
    COMPLETE_REGISTRATION_PROCESS,
    COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT,
    COMPLETE_VISIT,
    COMPLETE_YOUR_ONBOARDING_ANYTIME,
    COMPLIANCE,
    COMPLIANCE_EXPIRY,
    COMPLIANCE_FORM,
    COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY,
    COMPLIANT,
    COMPLIANT_ITEMS,
    CONFIRM,
    CONFIRM_ASSESSMENT,
    CONFIRM_COPY_LAST,
    CONFIRM_COPY_LAST_TITLE,
    CONFIRM_DEPOSIT_DETAILS,
    CONFIRM_PATIENT_AVAILABILITY,
    CONFIRM_PATIENT_AVAILABILITY_MESSAGE,
    CONFIRM_RN_FLEX_VISIT,
    CONFIRM_WITHOUT_LOCATION,
    CONGRATULATIONS,
    CONGRATULATIONS_TO,
    CONNECTING_HOME,
    CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS,
    CONNECT_WITH_US_ON_FACEBOOK,
    CONNECT_WITH_US_ON_WHATSAPP,
    CONTACT,
    CONTACT_AGENCY_FOR_MORE_INFO,
    CONTACT_PATIENT,
    CONTACT_SUPPORT,
    CONTINUE,
    CONTINUE_LATER,
    CONTINUE_TO_APP,
    CONTINUE_TO_ORIENTATION,
    CONTINUE_TO_SIGN_UP,
    CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK,
    COORDINATOR,
    COORDINATOR_EMAIL,
    COORDINATOR_IN_CHARGE,
    COORDINATOR_PHONE,
    COPY,
    COPY_FROM_LAST_TIME,
    COPY_FROM_MEDICATION,
    COPY_FROM_OTHER_FORMS,
    COPY_LAST_NO_DATE_FALLBACK_APPENDED,
    COPY_MEDICATION_CHART,
    COPY_PLAN_OF_CARE,
    CORRECT,
    COURSES,
    COVID,
    COVID_REQUIRED,
    COVID_REQUIRED_EXPLAINED,
    COVID_SCREENING_CLICK_HERE,
    CREATED_AT,
    CREATE_A_NEW_ACCOUNT,
    CREATE_NEW_PLAN_OF_CARE,
    CRIMINAL_CONVICTIONS_RECORDS,
    CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT,
    CURRENT_BALANCE,
    CURRENT_VISIT,
    DATA_WILL_BE_LOST,
    DATE,
    DATES,
    DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO,
    DATE_NOT_SPECIFIED,
    DATE_OF_BIRTH,
    DATE_UNKNOWN,
    DATE_VERIFICATION,
    DAY,
    DAYS,
    DAYS_A_WEEK,
    DAYS_LEFT,
    DAYS_OF_WEEK,
    DECEMBER,
    DECLINED,
    DELETE,
    DESCRIBE_THE_PROBLEM,
    DETAILS,
    DIRECTIONS,
    DIRECT_DEPOSIT,
    DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION,
    DISCOVER_YOUR_JOURNEY,
    DISCRIMINATION,
    DISMISS,
    DISMISSED,
    DISTANCE,
    DOB,
    DOCUMENT,
    DOCUMENTS,
    DOCUMENTS_TO_COMPLETE,
    DOCUMENT_HAS_EXPIRED,
    DOCUMENT_IS_MISSING,
    DOCUMENT_REJECTED,
    DOCUMENT_SELECTED,
    DOESNT_EXPIRE,
    DOES_NOT_FIT_MY_SCHEDULE,
    DONE,
    DONT_FORGET_TO_CLOCK_IN,
    DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS,
    DONT_FORGET_TO_CLOCK_OUT,
    DONT_FORGET_TO_FILL_THE_DUTY_SHEET,
    DONT_FORGET_TO_SMILE,
    DONT_SCHEDULE_VISIT,
    DONT_SHOW_AGAIN,
    DOSE,
    DOWNLOAD_PDF,
    DO_YOU_HAVE_ANY_QUESTIONS_ASK,
    DO_YOU_WANT_THIS_VISIT,
    DUE_BETWEEN,
    DUE_BY_DATETIME,
    DUE_DATE,
    DUE_ON,
    DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO,
    DURATION,
    DURATION_PER_DAY,
    DUTIES,
    DUTIES_COMPLETED_SUCCESSFULLY,
    DUTY_SHEET_SUBMITTED,
    EACH_100_POINTS_DOLLAR,
    EACH_INVITE,
    EARLY_OR_LATE_CLOCKS,
    EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY,
    EDIT,
    EDIT_ACCOUNT_DETAILS,
    EDIT_TIMES,
    EDUCATION,
    ELECTRIC_EQUIPMENT_DEPENDENCY,
    ELIGIBLE_VISITS,
    EMAIL,
    EMAIL_QUESTION_PENDING_VERIFICATION,
    EMAIL_SUPPORT,
    EMAIL_SUPPORT_FOR_MORE_INFO,
    EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER,
    EMAIL_VERIFICATION_QUESTION_LABEL,
    EMERGENCY_CONTACTS,
    EMPTY_DURATION,
    EMPTY_PATIENT_MEDICATION_PROFILE,
    ENABLE_LOCATION_MESSAGE,
    ENABLE_LOCATION_TITLE,
    ENDING_AT,
    ENDS,
    END_DATE,
    END_TIME,
    ENROLLMENT_REQUESTED,
    ENROLL_NOW,
    ENTER_AGENCY_CODE,
    ENTER_DOCUMENT_NAME,
    ENTER_NUMBER_HERE,
    ENTER_TEXT_HERE,
    ENTER_YOUR_MOBILE_NUMBER,
    ENTER_YOUR_PIN_CODE,
    ENTITY_IS_MISSING,
    ERROR,
    ERROR_FETCHING_SLOTS,
    ERROR_LOADING_DATA,
    ERROR_REMOVING_DOCUMENT,
    ERROR_SCHEDULING_TASK,
    ERROR_SCHEDULING_TASK_MESSAGE,
    ESTIMATED_ADDRESS_WILL_BE_PROVIDED,
    ESTIMATED_TIME_OF_CLOCKING_OUT_IS,
    EVACUATION_LOCATION,
    EVACUATION_ZONE,
    EVERY_VISIT,
    EVV,
    EXCITING_NEWS_AHEAD,
    EXEMPTED,
    EXPIRED,
    EXPIRED_COMPLIANCE,
    EXPIRED_ON_DATE,
    EXPIRES_AT,
    EXPIRES_IN,
    EXPIRES_IN_ONE_DAY,
    EXPIRES_IN_X_DAYS,
    EXPIRES_ON_DATE,
    EXPIRING_COMPLIANCE,
    EXPIRING_SOON,
    EXPIRY_DATE,
    EXPLORE,
    EXPLORE_A_CAREER_ENHANCEMENTS,
    FAILED_TO_IDENTIFY_PATIENT,
    FAR_VISIT_WARNING_MODAL_TITLE,
    FAX_NUMBER,
    FEBRUARY,
    FEMALE,
    FIFTHY_DOLLAR_AMAZON_GIFT_CARD,
    FILES,
    FILE_NOT_FOUND_CONTACT_AGENCY,
    FILL,
    FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT,
    FILL_IN_THE_QUESTIONNAIRE,
    FILTERS,
    FINAL_CONFIRMATION,
    FIND_A_CARE_MOMENT,
    FIND_A_CARE_MOMENT_DESCRIPTION,
    FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE,
    FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE,
    FINISH_MY_ONBOARDING,
    FINISH_ONBOARDING_AND_GET_DOLLARS,
    FINISH_ONBOARDING_MODAL_MESSAGE,
    FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2,
    FINISH_ONBOARDING_MODAL_TITLE,
    FINISH_ONBOARDING_MODAL_TITLE_STAGE_2,
    FINISH_SHIFT,
    FINISH_THE_DOCUMENTS,
    FIRST_NAME,
    FIRST_SHIFT,
    FIVE_THOUSAND_POINTS,
    FIX,
    FIX_DOCUMENTS_DESCRIPTION,
    FIX_DOCUMENT_DESCRIPTION,
    FIX_ISSUE,
    FIX_ISSUES,
    FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT,
    FIX_SETTINGS,
    FIX_THE_DOCUMENT,
    FIX_THE_DOCUMENTS,
    FIX_YOUR_DOCUMENT,
    FIX_YOUR_DOCUMENTS,
    FLEXIBLE,
    FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT,
    FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT,
    FLEXIBLE_DAYS_VISIT,
    FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT,
    FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT,
    FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT,
    FLEXIBLE_HOURS_EXPLANATION_TEXT,
    FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT,
    FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT,
    FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT,
    FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT,
    FLEXIBLE_HOURS_PATTERN_SHIFT,
    FLEXIBLE_HOURS_VISIT,
    FLEXIBLE_VISIT,
    FLEXIBLE_VISIT_DAY_TO_CHOOSE,
    FLEXIBLE_VISIT_DETAILS,
    FLEXIBLE_VISIT_TYPE,
    FLU_SHOT,
    FLU_SHOT_SUBMITTION_MESSAGE,
    FOLLOW_US_ON_INSTAGRAM,
    FOLLOW_US_ON_TWITTER,
    FORGOT_PIN_CODE_DIALOG_MESSAGE,
    FORM_NAME,
    FOURTEEN_THOUSAND_POINTS,
    FREQUENCY,
    FRIEND,
    FROM,
    FROM_CAMERA,
    FROM_GALLERY,
    FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE,
    FUTURE_VISITS,
    GENDER,
    GENERAL,
    GENERAL_FILES,
    GENERAL_NOTES,
    GENERAL_SUPPORT,
    GET_INSTAPAY,
    GET_IT_NOW,
    GET_MONEY_FOR_THIS_VISIT_TODAY
,
    GET_NOW,
    GET_STARTED,
    GET_THE_APP,
    GET_X_NOW,
    GOOD_JOB,
    GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW,
    GOT_IT,
    GO_BACK,
    GO_TO,
    GO_TO_MEDFLYT_PASSPORT,
    GO_TO_PATIENT,
    GO_TO_PATIENT_DETAILS,
    GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION,
    GO_TO_VISIT,
    GREAT_JOB,
    GROSS_PAY,
    HAS_DNR,
    HAS_HEALTH_CARE_PROXY,
    HAVE_A_NICE_WORKING_DAY,
    HAVE_A_PLEASANT_VISIT,
    HAVE_A_QUESTION_LETS_CHAT,
    HEALTH_AGENCIES,
    HELP,
    HELP_ME_FIND_MY_AGENCY,
    HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY,
    HEY,
    HEY_THERE,
    HI,
    HIRE_DATE,
    HI_PLEASE_HELP_ME_FILL_MY_APPLICATION ,
    HOME_PHONE,
    HOUR,
    HOURS,
    HOURS_PER_DAY,
    HOURS_PER_VISIT,
    HOW_ARE_WE_CALCULATING_THE_RANK,
    HOW_CAN_WE_HELP_YOU,
    HOW_CARE_MOMENTS_WORKS,
    HOW_DID_YOU_HEAR_ABOUT_US,
    HOW_DOES_IT_WORK,
    HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS,
    HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN,
    HOW_DO_YOU_RATE_MEDFLYT,
    HOW_URGENT_IS_THE_ISSUE,
    HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT,
    HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE,
    HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT,
    HR_PER_VISIT,
    HUNDRED_DOLLARS_GIFT_CARD,
    ICD,
    ID,
    IF_YOU_CLOCK_IN_AND_OUT_ON_TIME,
    IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME,
    IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON,
    IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE,
    IF_YOU_STAY_COMPLIANT,
    IMPORTANT_INFORMATION,
    IMPORTED,
    IM_AVAILABLE,
    IM_DONE_SUBMIT,
    IM_NOT_INTERESTED,
    IM_WORKING_WITH_AN_AGENCY,
    INACTIVE,
    INCOMPLETE,
    INCORRECT,
    INCORRECT_CODE,
    INCORRECT_DIGITS,
    INCORRECT_DIGITS_EXPLAINED,
    INCORRECT_DIGITS_MESSAGE,
    INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN,
    INCORRECT_SMS_CODE,
    INCORRECT_SMS_CODE_EXPLAINED,
    INFORMATION_CENTER,
    INFORMATION_NOT_MATCH_PROFILE,
    INSERT_THEIR_REFERRAL_CODE_HERE,
    INSERVICES,
    INSTAPAY,
    INSTAPAY_HISTORY,
    INSTAPAY_TECHNICAL_ISSUE,
    INSUFFICIENT_DUTIES,
    INTERESTED_IN_THIS_BUNDLE,
    INTRODUCING,
    INVALID_DOCUMENT_NAME,
    INVALID_EMAIL,
    INVALID_FORM,
    INVALID_PHONE,
    INVALID_PHONENUMBER,
    INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN,
    INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES,
    INVITE_FRIENDS,
    IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE,
    IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT,
    IN_PROGRESS,
    ISSUES_TO_SOLVE,
    IS_DUE_IN_DAYS,
    IS_DUE_TOMORROW,
    ITEMS_THAT_WILL_EXPIRE_SOON,
    ITEMS_WITH_ISSUES,
    ITEM_IS_MISSING,
    ITEM_IS_NOT_COMPLIANT,
    ITS_NOT_ME,
    IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU,
    IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU,
    IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK,
    IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE,
    I_DONT_HAVE_MY_CODE,
    I_DONT_WANT_THIS_CASE,
    I_DONT_WANT_TO_CLOCK,
    I_FORGOT_MY_PIN_CODE,
    I_HAVE_CHANGED_MY_MIND,
    I_HAVE_READ_AND_AGREE,
    I_VERIFY_THE_TERMS,
    I_WANT_TO_CLOCK_IN_ANYWAY,
    I_WANT_TO_CLOCK_OUT_ANYWAY,
    I_WANT_TO_FINISH_MY_ONBOARDING,
    I_WILL_DO_IT_LATER,
    JANUARY,
    JOINED_DATE,
    JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT,
    JULY,
    JUNE,
    JUST_ONE_MORE_THING,
    JUST_TO_BE_SURE,
    JUST_VERIFYING_ITS_YOU,
    KEEP_UP_THE_GOOD_WORK,
    LABELS,
    LANGUAGE,
    LANGUAGES,
    LAST_NAME,
    LEARN_MORE,
    LEAVE_WITHOUT_SAVING,
    LEFT,
    LESSON,
    LESSONS,
    LETS_CONTINUE_TO_NEXT_SECTION,
    LETS_FIND_CASES,
    LETS_FIND_YOUR_FIRST_CASE,
    LETS_FIND_YOUR_FIRST_PATIENT,
    LETS_FINISH_YOUR_SHIFT,
    LETS_START,
    LETS_START_YOUR_SHIFT,
    LIKE_US_ON_FACEBOOK,
    LINKED_TO_ANOTHER_PATIENT,
    LIST,
    LISTENING___,
    LIST_OF_PATIENTS,
    LIST_OF_TASKS,
    LIST_OF_VISITS,
    LIVE_CHAT_SUPPORT,
    LIVE_CLASS,
    LIVE_CLASS_EXPLANATION,
    LIVE_EVENTS,
    LOADING,
    LOADING_LOCATION,
    LOCATION,
    LOCKED,
    LOGGING_YOU_IN,
    LOGIN,
    LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED,
    LOOKS_LIKE_MORE_THAN,
    LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION,
    MAIN_TASKS,
    MAKE_A_DIFFERENCE,
    MAKE_SURE_PICTURE_IS_CLEAR,
    MALE,
    MANUALLY_SUBMITTED_INFO,
    MAP,
    MARCH,
    MAX_TRAVEL_DISTANCE,
    MAY,
    MAYBE_LATER,
    MAY_CLOCK_IN_AT,
    MAY_CLOCK_OUT_FROM,
    MEC_WAIVER_INFORMATION,
    MEDFLYT,
    MEDFLYTS_MONTHLY_RAFFLE,
    MEDFLYT_AGENCY_HANDBOOK,
    MEDFLYT_AT_HOME_BENEFITS,
    MEDFLYT_CHALLENGE,
    MEDFLYT_HOME_CARE,
    MEDFLYT_ID_CARD,
    MEDFLYT_PASSPORT,
    MEDFLYT_PASSPORT_TERMS,
    MEDFLYT_RAFFLE,
    MEDFLYT_TEAM,
    MEDFLYT_VERSION,
    MEDICAL_FILES,
    MEDICAL_INFORMATION,
    MEDICAL_NOTES,
    MEDICATIONS,
    MESSAGE,
    MESSAGE_FOR_THE_COORDINATOR,
    MIDDLE_NAME,
    MILES_AWAY,
    MILES_BETWEEN_PATIENTS,
    MILES_SHORT,
    MINIMUM_WAGE,
    MINUTE,
    MINUTES,
    MINUTE_VISIT,
    MISSING,
    MISSING_CLOCKS,
    MISSING_PERSONAL_CARE_DUTY,
    MM_DD_YYYY,
    MOBILE_PHONE,
    MOBILITY_STATUS,
    MONTH,
    MONTHLY_RAFFLE,
    MORE_DETAILS,
    MORE_DETAILS_BELOW,
    MORE_SHIFTS_MORE_CHANCES,
    MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY,
    MUST_AGREE_TERMS,
    MUST_BE_ATLEAST_3_CHARACTERS,
    MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS,
    MUST_PICK_EXACTLY,
    MUST_START_AT_OR_AFTER,
    MUST_START_AT_OR_BEFORE,
    MUST_UPDATE_ADDRESS_TO_SEE_CASES,
    MY_AGENCIES,
    MY_ASSIGNED_VISITS,
    MY_AVAILABILITY,
    MY_BENEFITS_CARD_INFORMATION,
    MY_MEDFLYT_COMPLIANCE,
    MY_PASSPORT,
    MY_PAYROLL_HISTORY,
    MY_PAYROLL_INFORMATION,
    MY_PROFILE,
    MY_REQUESTED_VISITS,
    MY_STAFFING_PREFERENCES,
    MY_UPCOMING_VISITS_REMINDERS,
    MY_VIRTUAL_ID,
    MY_VISITS,
    NA,
    NAME,
    NEAR,
    NEED_DIRECTIONS,
    NET_PAY_FOR_PERIOD,
    NEW,
    NEW_END_TIME_X,
    NEW_MESSAGE,
    NEW_TASK,
    NEW_TASKS,
    NEW_VISITS_AVAILABLE,
    NEXT,
    NEXT_DUE,
    NEXT_LESSON,
    NEXT_SECTION,
    NEXT_TOKEN_IN,
    NEXT_YEAR,
    NO,
    NONE,
    NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT,
    NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU,
    NOTES,
    NOTIFICATIONS,
    NOTIFICATIONS_OFF,
    NOTIFICATIONS_ON,
    NOT_AVAILABLE,
    NOT_COMPLIANT,
    NOT_DUE_YET,
    NOT_ENOUGH_HOURS,
    NOT_ENOUGH_SHIFTS,
    NOT_ENOUGH_SHIFTS_MESSAGE,
    NOT_FOUND,
    NOT_INTERESTED,
    NOT_SELECTED,
    NOT_SET,
    NOT_SIGNING,
    NOT_STARTED,
    NOT_URGENT,
    NOVEMBER,
    NO_ALLERGIES,
    NO_ANSWERS_TO_COPY,
    NO_ANSWERS_TO_COPY_TITLE,
    NO_AVAILABLE_SLOTS,
    NO_BALANCE,
    NO_CHANGES_WERE_MADE,
    NO_COMPLIANT_ITEMS,
    NO_DOCUMENTS,
    NO_DOCUMENTS_AVAILABLE,
    NO_DOCUMENTS_REQUIRED,
    NO_DUTIES_REQUIRED_FOR_THIS_VISIT,
    NO_EDUCATION_LINK,
    NO_ELIGIBLE_VISITS,
    NO_END_DATE,
    NO_GENERAL_NOTES,
    NO_IN_SERVICE_VIDEOS_AVAILABLE,
    NO_ISSUES_FOUND,
    NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT,
    NO_JUST_THIS_ONE,
    NO_KEEP_THE_ORIGINAL_TIMES,
    NO_KNOWN_ALLERGIES,
    NO_LESSONS,
    NO_LESSONS_FOR_YOU_YET,
    NO_MEDICAL_INFORMATION,
    NO_NOTIFICATIONS,
    NO_PAYSTUBS_FOUND_FOR_THIS_MONTH,
    NO_PHONE,
    NO_PHYSICIAN_SELECTED,
    NO_PREVIOUS_CONVERSATIONS,
    NO_SCHEDULED_VISITS_TODAY,
    NO_SHIFTS_SELECTED,
    NO_TAKE_ME_BACK,
    NO_TESTS,
    NO_THANKS,
    NO_TIME_LIMIT,
    NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT,
    NO_VIDEOS,
    NO_VISITS_SCHEDULED,
    NO_VISITS_SCHEDULED_MESSAGE,
    NO_VISITS_SELECTED,
    NPI,
    NUM_COUNT_ITEMS,
    NUM_SHIFTS_TO_GO,
    NUM_SHIFTS_TO_WAGE,
    N_A,
    OCTOBER,
    OF,
    OF_THE_REQUIRED_PLEASE_CONTINUE,
    OF_THE_VIDEO,
    OK,
    OK_ILL_TRY_LATER,
    OK_NO_PROBLEM,
    OK_THANKS,
    ON,
    ONBOARDING,
    ONBOARDING_COMPLETED,
    ONBOARDING_COMPLETED_MESSAGE,
    ONE_DAY_TO_COMPLETE,
    ONE_DOCUMENT,
    ONE_DOCUMENT_SELECTED,
    ONE_HOUR,
    ONE_LAST_STEP,
    ONE_LESSON,
    ONE_TEST,
    ONE_THOUSAND_POINTS,
    ONE_VIDEO,
    ON_HOLD,
    ON_LEAVE,
    OOPS,
    OPEN,
    OPEN_CAMERA,
    OPEN_CERTIFICATE,
    OPEN_DEVICE_SETTINGS,
    OPEN_MAPS,
    OPEN_SETTINGS,
    OPTIONAL_TASKS,
    OR,
    OTHER,
    OTHER_PERTINENT_DIAGNOSIS,
    OTHER_REASON,
    OTHER_TASKS,
    OTHER_VISITS,
    OUTBOUND_CALL_ERROR_MESSAGE,
    OUTBOUND_CALL_ERROR_TITLE,
    OUTBOUND_CALL_PROMPT_MESSAGE,
    OUTBOUND_CALL_PROMPT_TITLE,
    OUTBOUND_CALL_SUCCESS_MESSAGE,
    OUTBOUND_CALL_SUCCESS_TITLE,
    OUT_OF,
    OUT_OF_RANGE,
    OVERDUE,
    OVERLAPPING_VISIT_ERROR,
    OVERRIDE_FORM,
    OVERRIDE_FORM_MESSAGE,
    OVER_NIGHT,
    PAGE,
    PAID,
    PAID_X_OUT_OF_Y,
    PARTIAL_SELECTION,
    PASSPORT,
    PASSPORT_TERMS_TEXT,
    PASTE,
    PAST_DUE,
    PAST_SINCE_THE_VISIT_STARTED,
    PAST_UPLOADS,
    PAST_VISITS,
    PATIENT,
    PATIENTS,
    PATIENT_ADDRESS,
    PATIENT_CANT_PHISICALLY_SIGN,
    PATIENT_CANT_SIGN,
    PATIENT_CONTACTS,
    PATIENT_DOC_NOT_SUBMITTED,
    PATIENT_DOC_SUBMISSION_MISSMATCH,
    PATIENT_DOC_SUBMITTED_SUCCESSFULY,
    PATIENT_INFO,
    PATIENT_IS_NOT_HOME,
    PATIENT_IS_NOT_SIGNING,
    PATIENT_NAME,
    PATIENT_NOT_FOUND,
    PATIENT_NOT_FOUND_EXPLAIN,
    PATIENT_NUMBER,
    PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE,
    PATIENT_PHONE,
    PATIENT_REFUSES_TO_SIGN,
    PATIENT_REPORT,
    PATIENT_REQUESTS,
    PATIENT_SCHEDULE,
    PATIENT_SIGNATURE,
    PATIENT_SIGNATURE_IS_REQUIRED,
    PATIENT_SIGNATURE_REQUIRE_MSG,
    PATIENT_SIGN_HERE,
    PATIENT_UNAVAILABLE_DURING_THESE_HOURS,
    PATIENT_VISITS,
    PAUSE_READING,
    PAYMENT_METHOD,
    PAYROLL,
    PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE,
    PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE,
    PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE,
    PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE,
    PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE,
    PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE,
    PAYROLL_STATUS_IN_PROGRESS_MESSAGE,
    PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY,
    PAYROLL_STATUS_IN_PROGRESS_TITLE,
    PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE,
    PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE,
    PAYROLL_STATUS_PAID_MODAL_MESSAGE,
    PAYROLL_STATUS_PAID_MODAL_TITLE,
    PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE,
    PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE,
    PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE,
    PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE,
    PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE,
    PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE,
    PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE,
    PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE,
    PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE,
    PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE,
    PAYSTUB,
    PAYSTUBS,
    PAY_ME_NOW,
    PAY_ME_NOW_X,
    PENDING,
    PENDING_APPLICATION,
    PENDING_APPROVAL,
    PENDING_CONFIRMATION,
    PENDING_ISSUES,
    PENDING_VERIFICATION,
    PERMANENT_VISIT_DETAILS,
    PERMANENT_VISIT_FROM,
    PERMANENT_VISIT_TYPE,
    PERMISSION_NEEDED_FOR_CAMERA,
    PERMISSION_NEEDED_FOR_CAMERA_MESSAGE,
    PERMISSION_NEEDED_FOR_PHOTOS,
    PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE,
    PERMISSION_TO_CAMERA_DENIED,
    PER_HOUR,
    PER_SHIFT,
    PER_VISIT,
    PER_WEEK,
    PHONE,
    PHONES,
    PHONE_CALL_SUPPORT,
    PHOTO_LIBRARY,
    PHYSICIAN_DETAILS,
    PICK_A_DATE,
    PICK_A_TIME,
    PLAN_OF_CARE,
    PLEASE_ASK_THE_PATIENT,
    PLEASE_CALL_PATIENT_IN_NEXT_SCREEN,
    PLEASE_CHAT_WITH_THE_AGENCY,
    PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY,
    PLEASE_CHOOSE_A_LANGUAGE,
    PLEASE_CHOOSE_A_TIME,
    PLEASE_CHOOSE_DATE_BETWEEN,
    PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES,
    PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT,
    PLEASE_CONFIRM_THE_TIMES_CHOSEN,
    PLEASE_CONFIRM_YOUR_INFORMATION,
    PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS,
    PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY,
    PLEASE_CONTACT_YOUR_AGENCY,
    PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS,
    PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY,
    PLEASE_CONTACT_YOUR_COORDINATOR,
    PLEASE_ENABLE_LOCATION,
    PLEASE_ENTER_A_VALID_PHONE_NUMBER,
    PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME,
    PLEASE_ENTER_PATIENT_NAME,
    PLEASE_ENTER_THE_PATIENT_PHONE,
    PLEASE_ENTER_YOUR_PIN_CODE,
    PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED,
    PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER,
    PLEASE_FILL_IN_YOUR_INFORMATION,
    PLEASE_FILL_REQUIRED_FIELDS,
    PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY,
    PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY,
    PLEASE_MARK_ALL_THE_REQUIRED_DUTIES,
    PLEASE_NOTE,
    PLEASE_PICK_VALID_DATES,
    PLEASE_REQUEST_EXACTLY,
    PLEASE_SELECT_AN_OPTION,
    PLEASE_SELECT_DATE_AND_TIME,
    PLEASE_SELECT_THE_PATIENT_ADDRESS,
    PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT,
    PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW,
    PLEASE_SIGN_IN_AGAIN,
    PLEASE_SPECIFY,
    PLEASE_TAKE_A_SELFIE,
    PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK,
    PLEASE_TYPE_IN_YOUR_PHONE_NUMBER,
    PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH,
    PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER,
    PLEASE_TYPE_THE_SMS_CODE,
    PLEASE_UPDATE_TO_OUR_NEWEST_VERSION,
    PLEASE_UPDATE_YOUR_ADDRESS,
    PLEASE_UPDATE_YOUR_FIRST_NAME,
    PLEASE_UPDATE_YOUR_LAST_NAME,
    PLEASE_WAIT,
    PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION,
    PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP,
    POINTS,
    POINTS_AND_REWARDS,
    POSTED_DATE,
    PREBLOCK_VISIT_EXPLANATION,
    PRESENTATION,
    PREVIOUS,
    PREVIOUS_CONVERSATIONS,
    PREVIOUS_WINNERS,
    PRE_TAXES,
    PRICE,
    PRINCIPAL_DIAGNOSIS,
    PRIORITY_CODE,
    PRIVACY_POLICY,
    PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN,
    PROBLEM_WITH_CASE_SETTINGS,
    PROCESSING,
    PROFESSIONAL_TYPE,
    PROFILE,
    PROGRESS,
    PROXY_FIRST_NAME,
    PROXY_LAST_NAME,
    PROXY_PHONE,
    PULSE,
    QUESTION,
    QUESTIONS,
    QUESTIONS_TO_COPY_FROM,
    QUESTION_NUMBER,
    QUESTION_REJECTED,
    QUIT,
    RAFFLE_ENDED,
    RAFFLE_INFO_1_DESCRIPTION,
    RAFFLE_INFO_1_TITLE,
    RAFFLE_INFO_2_DESCRIPTION,
    RAFFLE_INFO_2_TITLE,
    RAFFLE_INFO_3_DESCRIPTION,
    RAFFLE_INFO_3_TITLE,
    RAFFLE_INFO_4_DESCRIPTION,
    RAFFLE_INFO_4_TITLE,
    RAFFLE_NOW,
    RAFFLE_PRIZE,
    RANK_ACHIEVED,
    REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION,
    READY_FOR_YOUR_NEXT_TRAINING,
    READY_TO_CLOCK_IN,
    READY_TO_CLOCK_OUT,
    READ_AND_CONFIRM,
    READ_ONLY_MODE,
    READ_TEXT,
    REASON,
    RECENT_VISITS,
    RECOMMENDED,
    RECRUITMENT_MAIN_1,
    RECRUITMENT_MAIN_1_2,
    RECRUITMENT_MAIN_2,
    RECRUITMENT_MAIN_2_1,
    RECRUITMENT_MAIN_3,
    RECRUITMENT_MAIN_4,
    REFERRAL_CODE,
    REFER_ME,
    REGISTRATION,
    REGULAR_PAY,
    REJECT,
    REJECTED,
    REJECT_THIS_TASK,
    REJECT_THIS_VISIT,
    REMAINED,
    REMAINING,
    REMIND_ME_LATER,
    REMOVE,
    REMOVE_PAGE,
    REMOVE_TASK,
    REOPENED,
    REPLAY,
    REQUEST,
    REQUESTED,
    REQUESTED_LABEL_IN_CASES_LIST,
    REQUESTED_TIMES,
    REQUESTED_VISIT_CANCEL_EXPLANATION,
    REQUESTING_REFERENCE_RESPONSE,
    REQUEST_AGENCIES_MEMBERSHIP,
    REQUEST_AGENCY,
    REQUEST_AGENCY_MEMBERSHIP,
    REQUEST_DETAILS,
    REQUEST_FOR_APPOINTMENT,
    REQUEST_FRIENDSHIP,
    REQUEST_MORE_VISITS,
    REQUEST_MORE_VISITS_MESSAGE,
    REQUEST_NUMBER_SHIFTS,
    REQUEST_SELECTED_SHIFT,
    REQUEST_SELECTED_SHIFTS,
    REQUEST_SHIFTS,
    REQUEST_SINGLE_SHIFT,
    REQUEST_THE_TIMES_YOU_WANT,
    REQUEST_THIS_VISIT,
    REQUEST_TO,
    REQUEST_VISIT,
    REQUIRED,
    REQUIRED_DOCUMENTS,
    REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC,
    REQUIRED_PATIENT_DOCUMENT_TEXT,
    REQUIRED_TASKS,
    REQUIREMENTS,
    RESCHEDULE,
    RESCHEDULED_SUCCESSFULLY,
    RESCHEDULE_IN_THE_PAST_ERROR,
    RESCHEDULE_REQUESTS,
    RESET_PIN_CODE_MESSAGE,
    RESPIRATION_RATE,
    RESUBMISSION_BANNER_TITLE,
    RETAKE,
    RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION,
    RETRY,
    REVIEW_PRIVACY_POLICY,
    REVIEW_TASK,
    REVIEW_TASKS,
    RE_ENTER_YOUR_PIN_CODE,
    RN_FLEXIBLE_SHOWCASE_TEXT,
    RN_FLEX_EXPLANATION_PREFIX,
    RN_FLEX_REQUESTED_EXPLANATION,
    RN_FLEX_REQUESTED_EXPLANATION_LINE_2,
    RN_PATIENT_CONTACT_EXPLANATION,
    RN_SIGN_HERE,
    ROUTING_NUMBER,
    ROUTING_NUMBR,
    SAFETY_AND_HEALTH,
    SAVE,
    SAVE_FOR_LATER,
    SCAN_AND_UPLOAD_FILES,
    SCAN_A_PHOTO,
    SCAN_DOCUMENT,
    SCAN_NEW_DOCUMENT,
    SCAN_WITH_CAMERA,
    SCHEDULE,
    SCHEDULED,
    SCHEDULED_DATE,
    SCHEDULED_FOR,
    SCHEDULED_VISIT_COMPLETE,
    SCHEDULED_VISIT_NOT_FOUND,
    SCHEDULE_CONFIRMATION,
    SCHEDULE_FOR,
    SCHEDULE_TASK,
    SCHEDULING_PROBLEM,
    SCREENING,
    SCREENING_FOR,
    SEARCH,
    SEARCH_AGENCY,
    SEARCH_FOR_MEDICATIONS,
    SEARCH_NEARY_VISITS,
    SEARCH_PATIENT,
    SECOND_SHIFT,
    SECTION_ALREADY_COMPLETED,
    SECTION_COMPLETED_PROMPT,
    SECTION_LOCKED_PROMPT,
    SEE_ALL,
    SEE_ALL_CONVERSATIONS,
    SEE_IN_MAPS,
    SEE_LIST_OF_VISITS,
    SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT,
    SEE_YOUR_PROGRESS,
    SELECT,
    SELECTED,
    SELECTED_VISIT,
    SELECT_ALL,
    SELECT_CERTIFICATE,
    SELECT_DATE,
    SELECT_DATE_AND_TIME,
    SELECT_DOCUMENT,
    SELECT_DX_CODE,
    SELECT_FROM_LIST,
    SELECT_PERTINENT_DIAGNOSIS,
    SELECT_PHYSICIAN,
    SELECT_PRINCIPAL_DIAGNOSIS,
    SELECT_SHIFTS,
    SELECT_START_TIME,
    SELECT_SURGICAL_PROCEDURE,
    SELECT_TIME,
    SELECT_TIME_SLOT,
    SELECT_TIME_SLOT_INFO,
    SELECT_VISITS_FOR_INSTAPAY,
    SELECT_VISIT_DURATION,
    SELECT_YOUR_SCHEDULE,
    SELFIE_WITH_PATIENT,
    SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN,
    SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT,
    SEND_A_MESSAGE,
    SEND_EMAIL,
    SEND_REPORT,
    SEND_US_A_MAIL,
    SEPTEMBER,
    SETTINGS,
    SETTINGS_AND_INFO,
    SET_DOCUMENT_EXPIRY_DATE,
    SET_EXPIRATION_DATE,
    SET_YOUR_4_DIGIT_PIN_CODE,
    SHARE,
    SHARE_IDEAS_AND_GET_A_CHANCE,
    SHARE_REFERENCE_LINK,
    SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP,
    SHARE_WITH_YOUR_FRIENDS,
    SHIFT,
    SHIFTS,
    SHIFTS_DETAILS,
    SHIFT_HAS_FINISHED_IN,
    SHIFT_HAS_STARTED_IN,
    SHOULD_BE_HERE,
    SHOW_ALL_TASKS,
    SHOW_DETAILS,
    SHOW_LESS,
    SHOW_ME_CASES_IN_THE_NEXT,
    SHOW_ME_IN,
    SHOW_MORE,
    SHOW_OLD_PLAN_OF_CARE,
    SHOW_TASKS_THAT_REQUIRE_FIXES,
    SHOW_US_YOUR_SMILE,
    SIGNATURES,
    SIGNATURE_REQUIRED,
    SIGN_DECLINATION_FORM,
    SIGN_HERE,
    SIGN_IN,
    SIGN_ORIENTATION_VIDEO,
    SIGN_ORIENTATION_VIDEO_ERR,
    SIGN_OUT,
    SIGN_UP_FREE,
    SIGN_UP_ITS_FREE,
    SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE,
    SINGLE_FLEXIBLE_VISIT_EXPLANATION,
    SINGLE_VISIT_DETAILS,
    SINGLE_VISIT_FROM,
    SINGLE_VISIT_TYPE,
    SIXTY_SECONDS_AND_YOU_ARE_DONE,
    SKIP,
    SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION,
    SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS,
    SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN,
    SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES,
    SLIDE_MAIN_INFO_GO_NEXT_SCREENS,
    SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW,
    SLIDE_STEP_X_OF_COUNT,
    SMILE_FOR_US,
    SOCIAL,
    SOCIAL_MEDIA,
    SOMETHING_WENT_WRONG,
    SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS,
    SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM,
    SOME_TASKS_NEED_FIXES,
    SORRY,
    SORT,
    SPECIFIC_DAYS,
    SPEECH_RECOGNITION,
    SPLIT_SHIFTS_VISIT,
    SPREAD_THE_WORD,
    STAGE_APPROVED_MESSAGE,
    STAGE_AWAITING_APPROVAL,
    STAGE_COMPLETED_MESSAGE,
    STAGE_X_OF_TOTAL_STAGES,
    START,
    STARTING_AT,
    STARTS,
    STARTS_NEXT_WEEK,
    STARTS_TODAY_IN,
    START_APPLICATION,
    START_A_SURVEY,
    START_DATE,
    START_FILLING,
    START_NOW,
    START_SHIFT,
    START_TIME,
    START_USING_MEDFLYT_PASSPORT,
    START_WATCHING,
    START_WATCHING_ORIENTATION_VIDEOS,
    START_WORKING,
    STATUS,
    STAY_ON_TRACK,
    STAY_ON_TRACK_1_ANSWER,
    STAY_ON_TRACK_1_QUESTION,
    STAY_ON_TRACK_2_ANSWER,
    STAY_ON_TRACK_2_QUESTION,
    STAY_ON_TRACK_3_ANSWER,
    STAY_ON_TRACK_3_QUESTION,
    STAY_ON_TRACK_4_ANSWER,
    STAY_ON_TRACK_4_QUESTION,
    STAY_ON_TRACK_DESCRIPTION,
    STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS,
    STAY_TUNED_FOR_MORE_VISITS,
    STAY_TUNED_FOR_THE_NEXT_RAFFLE,
    STILL_WAITING_REFERENCE_ANSWER,
    STOP,
    STREAK_BREAK,
    STREAK_BREAK_MESSAGE,
    STREAK_BREAK_MESSAGE_2,
    SUBMIT,
    SUBMITTED_AT,
    SUBMITTED_DOCUMENTS,
    SUBMITTED_MANUALLY,
    SUBMIT_AFTER,
    SUBMIT_AT,
    SUBMIT_BY,
    SUBMIT_DUTIES,
    SUBMIT_DUTIES_BEFORE_CLOCK_OUT,
    SUBMIT_FORM,
    SUBMIT_FORMS,
    SUBMIT_MANUAL_TIMESHEET,
    SUBMIT_REQUIRED,
    SUBMIT_TEST,
    SUBMIT_TIMESHEET,
    SUBMIT_WITH_SCHEDULED_DATE,
    SUBMIT_WITH_TODAY_DATE,
    SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT,
    SUBMIT_YOUR_SIGN,
    SUBMIT_YOUR_SIGNATURE,
    SUCCESS,
    SUCCESSFULLY_CLOCKED_IN,
    SUCCESSFULLY_CLOCKED_OUT,
    SUCCESSFULY_REQUESTED,
    SURGICAL_PROCEDURE,
    SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS,
    SWITCH_VIEW,
    TAKE_A_DIFFERENT_PHOTO,
    TAKE_A_PHOTO,
    TAKE_A_SURVEY,
    TAKE_ME_TO_CASE_SETTINGS,
    TAKE_PHOTO,
    TAKE_THIS_TASK,
    TAP_HERE_TO_VIEW,
    TAP_TO_CANCEL,
    TAP_TO_CHANGE_CASE_SETTINGS,
    TASK,
    TASKS,
    TASK_ALREADY_ASSIGNED,
    TASK_COMPLETED_SUCCESSFULLY,
    TASK_INFORMATION,
    TASK_SCHEDULED,
    TASK_SCHEDULED_MESSAGE,
    TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE,
    TECHNICAL_SUPPORT,
    TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES,
    TELL_US_YOUR_AGENY_DESCRIPTION,
    TEMPERATURE,
    TEN_DOLLAR_STARBUCKS_GIFT_CARD,
    TERMINATED,
    TERMS_OF_MEDFLYT_PRIVACY_POLICY,
    TERMS_OF_USE,
    TEST,
    TESTS,
    TEST_COMPLETED,
    TEST_FAILED,
    TEST_REQUIRED,
    THANKS,
    THANK_YOU,
    THANK_YOU_FOR_YOUR_FEEDBACK,
    THATS_ME,
    THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION,
    THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS,
    THERE_ARE_NO_AGENCIES_YET,
    THERE_ARE_NO_ASSIGNED_CASES,
    THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION,
    THERE_SEEMS_TO_BE_NOTHING_HERE,
    THE_AWARDS_ARE_COMING_SOON,
    THE_BEST_PLACE_FOR_CAREGIVERS,
    THE_DUTY_SHEET_HAS_BEEN_SUBMITTED,
    THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY,
    THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW,
    THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY,
    THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING,
    THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON,
    THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS,
    THE_NEXT_WINNERS_ANNOUNCEMENT,
    THE_SELECTED_DATE_IS_EARLIER_THAN,
    THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS,
    THE_VISIT_HAS_NOT_STARTED_YET,
    THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS,
    THIS_BUNDLE_INCLUDES,
    THIS_CONVERSATION_HAS_BEEN_RESOLVED,
    THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK,
    THIS_FIELD_IS_CURRENTLY_DISABLED,
    THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT,
    THIS_IS_A_FUTURE_VISIT,
    THIS_IS_A_LIVE_CLASS_SESSION,
    THIS_MAY_TAKE_UP_TO_X_SECONDS,
    THIS_PATIENT_BELONGS_TO_AGENCY,
    THIS_PATIENT_HAS_NO_PHONE_NUMBERS,
    THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER,
    THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP,
    THIS_VISIT_CAN_BE_PERFORMED_BETWEEN,
    THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE,
    THIS_VISIT_IS_FOR_DIFFERENT_AGENCY,
    THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET,
    THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY,
    THIS_WILL_MARK_THE_VISIT_AS_MISSED,
    TIME,
    TIMESHEET_SUBMITTED,
    TIME_ESTIMATION,
    TIME_FRAME,
    TIME_LEFT,
    TIME_VARIES,
    TO,
    TODAY,
    TODAYS_DATE,
    TOKENS,
    TOO_MANY_HOURS,
    TOO_MANY_SHIFTS,
    TOO_MANY_SHIFTS_MESSAGE,
    TOP_CAREGIVERS_IN_YOUR_AREA,
    TOTAL_EARNED,
    TOTAL_SPENT,
    TO_FILL_IN_A_FORM_INSTEAD,
    TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT,
    TO_SEE_THIS_TASK_GO_TO_ASSIGNED,
    TO_SEE_THIS_VISIT_GO_TO,
    TO_UPLOAD_A_FILE_INSTEAD,
    TO_WIN_AN_IPHONE12,
    TRAINING,
    TRAININGS_FOR,
    TRAINING_CENTER,
    TRAINING_CENTER_REMINDERS,
    TRY_AGAIN,
    TYPE_AGENCY_CODE,
    TYPE_MESSAGE,
    TYPE_YOUR_ADDRESS,
    UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET,
    UNANSWERED_LAST_SECTION_FOR_NOW,
    UNAUTHORIZED,
    UNAVAILABLE_LOCATION_SERVICES_MESSAGE,
    UNDER_REVIEW,
    UNDO,
    UNIQUE_ERROR_CODE,
    UNSCHEDULE,
    UNSCHEDULE_TASK,
    UNSPECIFIED,
    UNTIL,
    UPCOMING_VISITS,
    UPDATED_AT,
    UPDATE_INFORMATION,
    UPLOAD,
    UPLOADED,
    UPLOADED_FILE_VIEW,
    UPLOADING,
    UPLOAD_A_DOCUMENT,
    UPLOAD_A_FILE,
    UPLOAD_DOCUMENT,
    UPLOAD_DOCUMENTS,
    UPLOAD_ERROR,
    UPLOAD_FILES_TO_ENSURE,
    UPLOAD_FLU_SHOT_DOCUMENT,
    UPLOAD_FROM_GALLERY,
    UPLOAD_NEW_DOCUMENT,
    UPLOAD_VIDEO,
    UPLOAD_YOUR_FILES_TO_ENSURE,
    UP_COMING_REASSESSMENTS,
    UP_TO,
    URGENT,
    USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY,
    VALID,
    VERIFIED,
    VERIFY,
    VERIFYING,
    VERIFY_YOUR_LOCATION,
    VERY_URGENT,
    VIDEO,
    VIDEOS,
    VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION,
    VIDEO_COMPLETED_SUCCESSFULLY,
    VIEW,
    VIEWED,
    VIEW_ALL,
    VIEW_ANSWERS,
    VIEW_CERTIFICATE,
    VIEW_TASK,
    VIEW_TASKS_PENDING_FOR_SCHEDULE,
    VIEW_VISIT,
    VIRTUAL_ID_CARD,
    VISIT,
    VISITS,
    VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER,
    VISITS_NEXT_MONTH,
    VISITS_OUTSIDE_YOUR_AVAILABILITY,
    VISITS_PER_WEEK,
    VISITS_WITH_ISSUES,
    VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE,
    VISIT_BY,
    VISIT_CHAT,
    VISIT_COMPLETE,
    VISIT_COMPLETED_SUCCESSFULLY,
    VISIT_COUNTS,
    VISIT_COUNTS_DESCRIPTION,
    VISIT_DATE,
    VISIT_DATES,
    VISIT_DETAILS,
    VISIT_DURATION,
    VISIT_INFORMATION,
    VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU,
    VISIT_LASTING,
    VISIT_NEXT_MONTH,
    VISIT_NOTIFICATIONS_OFF,
    VISIT_NOTIFICATIONS_ON,
    VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE,
    VISIT_NO_LONGER_AVAILABLE,
    VISIT_RATE_REQUEST_CONFIRMATION,
    VISIT_REMINDERS,
    VISIT_REQUEST_CONFIRMATION_WARNING,
    VISIT_SCHEDULE,
    VISIT_STARTED_AT,
    VISIT_STARTED_MISSING_CLOCK_IN,
    VISIT_STARTS_AT,
    VISIT_SUCESSFULLY_CANCELED,
    VISIT_TIME_ADJUSTMENT,
    VISIT_TIME_ADJUSTMENT_CONTENT_EARLY,
    VISIT_TIME_ADJUSTMENT_CONTENT_LATE,
    VISIT_TOO_SHORT,
    VISIT_TYPE,
    VISIT_WITH,
    VOUCHER,
    WAITING_FOR_APPROVAL,
    WAITING_TO_BE_SCHEDULED,
    WARNING,
    WAS_DUE_BETWEEN,
    WAS_DUE_ON,
    WATCHED,
    WATCH_HOW_IT_WORKS,
    WATCH_REQUIRED,
    WATCH_TRAINING_VIDEOS_TO_COMPLETE,
    WEEKLY_DETAILS,
    WELCOME,
    WELCOME_BACK,
    WELCOME_TO_CARE_MOMENTS,
    WELCOME_TO_MEDFLYT,
    WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE,
    WELL_BE_IN_TOUCH_SHORTLY,
    WERE_YOU_REFERRED_BY_SOMEONE,
    WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM,
    WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR,
    WE_COULDNT_FIND_YOUR_AGENCY,
    WE_GOT_YOUR_CONFIRMATION,
    WE_GOT_YOUR_RESPONSE_WAIT_HH_MM,
    WE_HAVE_ONE_MATCHING_ACCOUNT,
    WE_HAVE_X_MATCHING_ACCOUNTS,
    WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN,
    WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT,
    WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT,
    WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON,
    WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE,
    WHAT_BENEFITS_CAN_YOU_GET,
    WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK,
    WHAT_WOULD_YOU_LIKE_TO_DO_FIRST,
    WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT,
    WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR,
    WHOOPS,
    WHOS_THE_LUCKY_ONE,
    WILL_BEGIN_SHORTLY,
    WILL_EXPIRE_IN_DAYS,
    WILL_EXPIRE_TOMORROW,
    WINNER_ANNOUNCED_IN,
    WITH_CAREGIVERS,
    WORKING_WITH_AGENCY,
    WRONG_DATES_SELECTION,
    WRONG_PHONE_NUMBER,
    WRONG_PIN,
    X_DAYS_SELECTED,
    X_DAYS_TO_COMPLETE,
    X_DAYS_TO_SELECT,
    X_HOURS_SELECTED,
    X_HOURS_TO_SELECT,
    YAY_YOU_WERE_ASSIGNED_TO_A_VISIT,
    YEAR,
    YEARS_OLD,
    YES,
    YES_ADJUST_TIMES,
    YES_DELETE,
    YES_I_AM_SURE,
    YES_OVERRIDE_FORM,
    YES_REQUEST_ANYWAY,
    YES_SCHEDULE_VISIT,
    YES_THATS_ME,
    YES_UPDATE_ALL,
    YOURE_ALL_DONE_LETS_GET_YOU_WORKING,
    YOURE_IN_THE_RAFFLE,
    YOURE_NOT_IN_THE_RAFFLE,
    YOURSELF,
    YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD,
    YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE,
    YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS,
    YOUR_ANSWER_IS_CORRECT,
    YOUR_ANSWER_IS_INCORRECT,
    YOUR_COMPLIANCE,
    YOUR_COMPLIANCE_ITEM_HAS_EXPIRED,
    YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS,
    YOUR_FILE_IS_BEING_UPLOADED,
    YOUR_IN_SERVICE_IS_DUE_IN_DAYS,
    YOUR_IN_SERVICE_IS_OVER_DUE,
    YOUR_MOBILE,
    YOUR_REFERERAL_CODE,
    YOUR_TASK_HAS_BEEN_SCHEDULED_FOR,
    YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY,
    YOUVE_BEEN_SUCCESSFULLY_REFERRED,
    YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW,
    YOU_ALREADY_FAILED,
    YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT,
    YOU_ALREADY_REQUESTED_THIS_VISIT,
    YOU_ALREADY_SUCCEEDED,
    YOU_ARE_ALL_SET,
    YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION,
    YOU_ARE_COMPLIANT,
    YOU_ARE_EXEMPT_FROM_THIS_TEST,
    YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD,
    YOU_ARE_NOT_COMPLIANT,
    YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM,
    YOU_ARE_OUT_OF_COMPLIANCE,
    YOU_ARE_X_DAYS_LATE,
    YOU_CANNOT_EDIT_YOUR_ANSWERS,
    YOU_CANT_EDIT_VISIT_WITH_CICO,
    YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES,
    YOU_CANT_SIGN_BEFORE_ALL_ANSWERED,
    YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE,
    YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT,
    YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT,
    YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT,
    YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME,
    YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED,
    YOU_CAN_CONTINUE_TO_NEXT_SECTION,
    YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY,
    YOU_DIDNT_ANSWER_ALL_QUESTIONS,
    YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN,
    YOU_DONT_HAVE_ANY_CASES_YET,
    YOU_DONT_HAVE_ANY_PATIENTS_YET,
    YOU_GET_POINTS,
    YOU_GOT_THE_CASE,
    YOU_GOT_THE_CERTIFICATE,
    YOU_HAVENT_CLOCKED_IN_YET,
    YOU_HAVENT_CLOCKED_OUT_YET,
    YOU_HAVENT_UPLOADED_ANYTHING_YET,
    YOU_HAVE_COMPLETED_THIS_TEST,
    YOU_HAVE_HH_MM_TO_CONFIRM_IT,
    YOU_HAVE_MISSING_COMPLIANCE_ITEMS,
    YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW,
    YOU_HAVE_NOT_WATCHED,
    YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY,
    YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS,
    YOU_HAVE_ONE_ATTEMPT_LEFT,
    YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING,
    YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION,
    YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING,
    YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY,
    YOU_HAVE_TO_ENROLL_FIRST,
    YOU_HAVE_TO_PICK_A_CODE,
    YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT,
    YOU_HAVE_X_ATTEMPTS_LEFT,
    YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST,
    YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y,
    YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING,
    YOU_JUST_GOT_PAID,
    YOU_JUST_GOT_PROMOTED_TO,
    YOU_LOSE_POINTS,
    YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS,
    YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE,
    YOU_MAY_ONLY_SUBMIT_AFTER,
    YOU_MISSED_A_SHIFT_WITHOUT_NOTICE,
    YOU_MUST_ANSWER_ALL_THE_QUESTIONS,
    YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT,
    YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST,
    YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION,
    YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE,
    YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS,
    YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS,
    YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT,
    YOU_RECENTLY_WON_A_RAFFLE,
    YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT,
    YOU_USED_THE_CODE,
    YOU_WILL_FALL_OUT_OF_COMPLIANCE,
    YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS,
    YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS
}

export const allStrings: { [key: string]: (string | null)[] } = {
    "ar": [
        /* ACCEPTED */ "وافقت",
        /* ACCEPT_THESE_HOURS */ "تقبل هذه الساعات",
        /* ACCEPT_THE_VISIT_AT */ "قبول الزيارة في",
        /* ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY */ null,
        /* ACCOUNT_NUMBER */ null,
        /* ACCOUNT_TYPE */ null,
        /* ACTIVE */ "نشيط",
        /* ACTIVE_DOCUMENT */ "وثيقة نشطة",
        /* ADD */ "يضيف",
        /* ADDITIONAL_NOTES */ null,
        /* ADDRESS */ "تبوك",
        /* ADDRESS2 */ "سطر العنوان 2",
        /* ADDRESS_ERROR */ "خطأ العنوان",
        /* ADDRESS_IS_NEAR */ null,
        /* ADD_ANOTHER_DOCUMENT */ null,
        /* ADD_ANOTHER_PERTINENT_DIAGNOSIS */ "أضف تشخيصًا آخر ذا صلة",
        /* ADD_IMAGE */ "إضافة صورة",
        /* ADD_NEW_MEDICATION */ "أضف دواء جديد",
        /* ADD_NOTES */ "أضف ملاحظات",
        /* ADD_NOTE_TO_PATIENT_PROFILE_BUTTON */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_TITLE */ null,
        /* ADD_PHYSICIAN */ null,
        /* ADD_YOUR_SIGNATURE */ null,
        /* ADVANCED_DIRECTIVES */ null,
        /* AGENCIES_CONTACT */ "سوف تتصل بك الوكالات قريبًا",
        /* AGENCY */ "وكالة",
        /* AGENCY_CODE */ "رمز الوكالة",
        /* AGENCY_COORDINATOR */ "منسق الوكالة",
        /* AGENCY_DETAILS */ "تفاصيل الوكالة",
        /* AGENCY_HANDBOOK */ null,
        /* AGENCY_ISSUES */ null,
        /* AGENCY_NAME */ "اسم الوكالة",
        /* AGENCY_NOTIFICATIONS */ "إشعارات الوكالة",
        /* AGENCY_NOT_FOUND */ "وكالة لم يتم العثور عليها",
        /* AGREE_TO_MEDFLYT_TERMS */ "من خلال النقر على الموافقة ، أنت توافق على أنك قرأت وتوافق على شروط سياسة خصوصية Meflyt",
        /* AIDE */ null,
        /* AIRPODS */ null,
        /* ALLERGIES */ "الحساسية",
        /* ALLOW_ACCESS_TO_MY_LOCATION */ null,
        /* ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP */ null,
        /* ALL_CHANGES_SAVED */ null,
        /* ALL_DAY */ "طوال اليوم",
        /* ALL_DONE */ "كله تمام!",
        /* ALL_TRANSACTIONS */ null,
        /* ALL_VERIFIED_ITEMS */ null,
        /* ALREADY_CLOCKED_IN */ "سجلت بالفعل في.",
        /* ALREADY_CLOCKED_IN_ANOTHER_VISIT */ "لقد قمت بالفعل بتسجيل الدخول في زيارة أخرى.",
        /* ALREADY_CLOCKED_OUT */ "تم تسجيله بالفعل.",
        /* ALREADY_HAVE_AN_ACCOUNT */ "هل لديك حساب",
        /* AND_AMPERSAND */ "& &",
        /* ANSWERED */ "أجاب",
        /* ANSWERED_AT */ "أجاب في",
        /* ANSWER_INCOMPLETE_QUESTIONS */ null,
        /* ANY_DURATION */ "أي مدة",
        /* AN_ERROR_HAS_OCCURED */ "حدث خطأ.",
        /* AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET */ null,
        /* APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES */ "أبل لا تشارك بأي شكل من الأشكال مع المسابقة أو اليانصيب",
        /* APPLICATION_DONE */ "التطبيق تم!",
        /* APPROVE */ "يعتمد",
        /* APPROVED */ null,
        /* APPROVE_THIS_TASK */ null,
        /* APPROVE_THIS_VISIT */ "الموافقة على هذه الزيارة",
        /* APRIL */ "أبريل",
        /* ARENT_YOU_MISSING_SOMETHING */ null,
        /* ARE_YOU */ "هل أنت",
        /* ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY */ "هل تعمل حاليًا مع وكالة؟",
        /* ARE_YOU_SURE */ null,
        /* ARE_YOU_SURE_REQUEST_FAR_VISIT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST */ "هل أنت متأكد من أنك تريد إلغاء هذا الطلب؟",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT */ "هل أنت متأكد من أنك تريد إلغاء هذه الزيارة؟",
        /* ARE_YOU_SURE_YOU_WANT_TO_DELETE */ "هل أنت متأكد أنك تريد حذف",
        /* ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE */ "هل أنت متأكد من أنك تريد تسجيل هذه الحزمة؟",
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE */ "هل أنت متأكد أنك تريد إزالة هذه الصفحة؟",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE */ "هل أنت متأكد أنك تريد طلب هذه",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT */ "هل أنت متأكد من أنك تريد طلب هذه الزيارة؟",
        /* ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT */ "هل أنت متأكد أنك تريد الخروج؟",
        /* ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK */ null,
        /* ASSIGNED */ "تعيين",
        /* ASSIST */ "مساعدة",
        /* AS_NEEDED */ "كما هو مطلوب",
        /* AS_REQUESTED_BY_THE_PATIENT */ "حسب طلب المريض",
        /* ATTACH_A_DOCUMENT */ null,
        /* AUGUST */ "Augusy",
        /* AUTHENTICATION_FAILED */ "المصادقة فشلت",
        /* AUTH_VERIFICATION_FAIL_EXAPLINED */ "لم نتمكن من التحقق من هويتك. يرجى التواصل مع واحدة من وكالاتك للحصول على المساعدة.",
        /* AUTOPLAY */ "سيبدأ العنصر التالي",
        /* AVAILABILITY */ "توافر",
        /* AVAILABLE */ "متاح",
        /* AVAILABLE_CARE_POINTS */ null,
        /* AVAILABLE_ON_THE_FOLLOWING_DAYS */ "متاح في الأيام التالية",
        /* AVAILABLE_SHIFTS */ "التحولات المتاحة",
        /* AVAILABLE_VISITS */ "الزيارات المتاحة",
        /* AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK */ null,
        /* AWAITING_PATIENT_CONTACT */ "في انتظار الاتصال",
        /* A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT */ "خطة رعاية موجودة بالفعل لهذا المريض",
        /* A_VERIFICATION_CODE_IS_BEING_SENT_TO */ "يتم إرسال رمز التحقق إلى",
        /* A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE */ "سيتم إرسال رمز التحقق إليك عبر رسالة نصية",
        /* A_VISIT_BY */ "زيارة من قبل",
        /* BACK */ null,
        /* BACK_TO_ONBOARDING */ null,
        /* BANK_INFORMATION */ null,
        /* BANK_NAME */ null,
        /* BASICALLY_EVERY_ACTION_COUNTS */ null,
        /* BEFORE_SUBMITTING_THE_DUTIES */ null,
        /* BEGIN_NOW */ "تبدأ الآن",
        /* BEST_TASK_FOR_YOU */ null,
        /* BETWEEN */ "ما بين",
        /* BETWEEN_AND */ "و",
        /* BIRTHDAY */ "عيد ميلاد",
        /* BLOOD_PRESSURE */ "ضغط الدم",
        /* BOROUGH */ null,
        /* BUNDLES */ "حزم",
        /* BUNDLE_DESCRIPTION */ "سوف تتجول هذه الحزمة حول أي شيء تحتاج إلى معرفته حول {bundle_name} من {agency_name}.",
        /* BUNDLE_DESCRIPTION_P1 */ "تتكون هذه الحزمة من",
        /* BUNDLE_DESCRIPTION_P2 */ "العناصر. قد تتضمن بعض العناصر أيضًا اختبارًا. يرجى مشاهدة المحتوى المطلوب. بمجرد إكمال المهمة المطلوبة ، ستتلقى شهادة. حظ سعيد",
        /* BUNDLE_IS_LOCKED */ "حزمة مغلقة",
        /* BUNDLE_ITEM_NOT_FOUND */ "درس التدريب لم يتم العثور عليه",
        /* BUNDLE_NOT_FOUND */ "الدورة التدريبية لم يتم العثور عليها",
        /* BUNDLE_PROGRESS */ "تقدم حزمة",
        /* BUSY_ALL_DAY */ "مشغول طوال اليوم",
        /* BY */ "بواسطة",
        /* BY_ENROLLING_I_ACCEPT_THE */ null,
        /* BY_EXISTING_VISIT */ "بالزيارة الحالية:",
        /* BY_PATIENT_NAME */ "باسم المريض:",
        /* BY_SIGNING_HERE_I_ACCEPT_THE */ "من خلال التوقيع هنا ، أقبل",
        /* CALL */ "يتصل",
        /* CALL_AGENCY */ "وكالة الاتصال",
        /* CALL_HOME */ "اتصل بالمنزل",
        /* CALL_MOBILE */ "مكالمة الجوال",
        /* CALL_NOW */ "اتصل الان:",
        /* CALL_PATIENT */ "اتصل بالمريض",
        /* CALL_PATIENT_CONFIRMATION */ null,
        /* CALL_PATIENT_EXPLANATION */ "سوف تتلقى مكالمة بضع لحظات بعد تأكيد هذه الرسالة.",
        /* CALL_PATIENT_HOME */ "اتصل بمنزل المريض",
        /* CALL_PATIENT_MOBILE */ "اتصل بالهاتف المحمول للمريض",
        /* CALL_PATIENT_NOTE */ "اتصل بالمريض في الشاشة التالية",
        /* CALL_SUPPORT_FOR_MORE_INFO */ "استدعاء الدعم لمزيد من المعلومات",
        /* CANCEL */ "يلغي",
        /* CANCEL_REQUESTED_SHIFTS */ null,
        /* CANCEL_VISIT */ null,
        /* CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE */ null,
        /* CANT_CANCEL_24_HOURS_SCHEDULED_VISIT */ "خطأ: زيارة أقل من 24 ساعة",
        /* CANT_CANCEL_AT_THIS_TIME */ "لا يمكن الإلغاء في هذا الوقت",
        /* CANT_CLOCK_IN */ "لا يمكن الساعة في",
        /* CANT_CLOCK_IN_AT_THIS_TIME */ "لا يمكن الساعة في هذا الوقت.",
        /* CANT_CLOCK_OUT */ "لا يمكن الخروج",
        /* CANT_CLOCK_OUT_AT_THIS_TIME */ "لا يمكن الخروج في هذا الوقت.",
        /* CANT_CLOCK_OUT_BEFORE_VISIT_ENDED */ "لا يمكن الخروج قبل أن تنتهي الزيارة.",
        /* CANT_REJECT_VISIT_PENDING_STATUS */ null,
        /* CANT_REQUEST_JOIN_AGENCY */ "لا يمكنك طلب الانضمام إلى الوكالة",
        /* CANT_REQUEST_VISIT_PENDING_STATUS */ null,
        /* CANT_SUBMIT_AN_EMPTY_FORM */ "لا يمكن تقديم نموذج فارغ ، الرجاء الإجابة على الأسئلة.",
        /* CANT_WATCH_ON_SHIFT */ "تم تعطيل هذا التدريب خلال جميع التحولات 👀",
        /* CANT_WATCH_THIS_VIDEO */ "لا يمكنك مشاهدة هذا الفيديو",
        /* CAREBACK_CASH_BONUS */ null,
        /* CAREBACK_POINTS */ null,
        /* CAREGIVER */ "الراعي",
        /* CAREGIVER_COMPLIANCE_PASSPORT */ "جواز سفر امتثال مقدمي الرعاية",
        /* CAREGIVER_NAME */ "اسم مقدم الرعاية",
        /* CAREGIVER_PHONE */ "هاتف مقدم الرعاية",
        /* CAREGIVER_SIGNATURE */ null,
        /* CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG */ "يرجى التأكد من قيام كل من أنت والمريض بتوقيع خطة الرعاية",
        /* CAREGIVER_SIGNATURE_IS_REQUIRED */ null,
        /* CAREGIVER_SIGNATURE_REQUIRE_MSG */ "يرجى التأكد من تسجيل الدخول على خطة الرعاية",
        /* CAREGIVER_STATUS_PENDING_ERROR */ "غير قادر على أداء الإجراء لأن ملف التعريف الخاص بك لا يزال معلقًا.",
        /* CARE_MOMENTS */ null,
        /* CASE_INFO */ null,
        /* CASE_IS_TOO_FAR */ "القضية بعيدة جدا",
        /* CASE_SETTINGS */ "إعدادات الحالة",
        /* CATALOGUE */ "فهرس",
        /* CERTIFICATION */ "شهادة",
        /* CERTIFICATIONS */ "الشهادات",
        /* CHANGE */ "يتغيرون",
        /* CHANGES_TO_MY_VISITS */ "التغييرات في زياراتي",
        /* CHANGES_WERE_SAVED_IN_THE_CLOUD */ "تم حفظ جميع التغييرات في السحابة",
        /* CHANGE_DOCUMENT */ null,
        /* CHANGE_OF_RANKING */ null,
        /* CHANGE_PHONE_NUMBER */ "غير رقم الهاتف",
        /* CHANGE_SETTINGS */ null,
        /* CHANGE_SHIFTS */ null,
        /* CHANGE_TASK_TIME */ null,
        /* CHANGE_VISIT_TIMES */ "تغيير أوقات زيارة",
        /* CHAT */ "دردشة",
        /* CHATS */ "الدردشات",
        /* CHAT_MESSAGES */ "رسائل الدردشة",
        /* CHAT_NOT_ACTIVE_MESSAGE */ "لا يمكنك إرسال الرسائل هنا.",
        /* CHAT_NOT_ACTIVE_TITLE */ "الدردشة لم تعد نشطة",
        /* CHAT_WITH_AGENCY */ "الدردشة مع الوكالة",
        /* CHAT_WITH_AGENCY_ABOUT_PATIENT */ "الدردشة مع ٪ s حوالي ٪ s",
        /* CHAT_WITH_MEDFLYT */ null,
        /* CHAT_WITH_OTHER_AGENCIES */ null,
        /* CHAT_WITH_SUPPORT */ "الدردشة مع الدعم",
        /* CHAT_WITH_US */ "دردش معنا",
        /* CHECK */ null,
        /* CHECK_AGAIN */ null,
        /* CHOOSE_ANOTHER_DATE */ "اختر تاريخًا آخر",
        /* CHOOSE_A_PHOTO */ "اختيار صورة",
        /* CHOOSE_A_TIME_FOR_THE_VISIT */ "اختر وقتًا للزيارة",
        /* CHOOSE_CLOCK_TIMES */ null,
        /* CHOOSE_DATE_TO_PERFORM_THIS_TASK */ "اختر تاريخ تنفيذ هذه المهمة",
        /* CHOOSE_FOLDER_TO_UPLOAD */ "اختر المجلد لتحميل",
        /* CHOOSE_START_TIME */ "اختر وقت البدء",
        /* CHOOSE_THE_HOURS */ "التالي (اختر الساعات)",
        /* CHOOSE_TIME */ "اختر الوقت",
        /* CHOOSE_WHEN_TO_PERFORM_THE_VISIT */ "اختر متى تقوم بإجراء الزيارة",
        /* CHOOSE_WHEN_TO_VISIT_THE_PATIENT */ "اختر متى لزيارة المريض",
        /* CHOOSE_WHO_TO_CONTACT */ "اختر من يمكن الاتصال به",
        /* CHOOSING_A_WINNER */ null,
        /* CHOOSING_A_WINNER_IN */ null,
        /* CLEAR */ "صافي",
        /* CLICK_HERE */ null,
        /* CLICK_HERE_TO_DOWNLOAD */ "إضغط هنا للتحميل",
        /* CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE */ "انقر هنا لمشاركة رمز الإحالة الخاص بك",
        /* CLICK_HERE_TO_VIEW_CERTIFICATE */ "انقر هنا لعرض الشهادة",
        /* CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE */ "تهانينا على شهادتك الأولى 🏆🏆! انقر فوقه لعرض شهادتك الجديدة",
        /* CLICK_TO_REQUEST */ "انقر لطلب!",
        /* CLICK_TO_SCAN_UPLOAD */ "انقر للمسح الضوئي والتحميل",
        /* CLICK_TO_TAKE_A_SELFIE */ null,
        /* CLIMB_THE_RANKS_BY_COMPLETING_VISITS */ null,
        /* CLINICAL_SUPPORT */ "الدعم السريري",
        /* CLOCKED_IN */ "سجلت في",
        /* CLOCKED_IN_AND_OUT */ null,
        /* CLOCKED_IN_AT */ "سجلت في",
        /* CLOCKED_OUT */ "تم تسجيلها",
        /* CLOCKED_OUT_AT */ "سجلت في",
        /* CLOCKING_IN */ "تسجيل في ...",
        /* CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES */ null,
        /* CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES */ null,
        /* CLOCKING_OUT */ "تسجيل ...",
        /* CLOCK_ADDRESS_IN_RANGE */ null,
        /* CLOCK_ADDRESS_NOT_IN_RANGE */ null,
        /* CLOCK_IN */ "على مدار الساعة في",
        /* CLOCK_IN_ANYWAY */ null,
        /* CLOCK_IN_AT */ "الساعة في",
        /* CLOCK_IN_BETWEEN */ null,
        /* CLOCK_IN_OUT */ "الساعة داخل / خارج",
        /* CLOCK_IN_OUT_SUBMIT_DUTIES */ null,
        /* CLOCK_IN_TIME_IS_REQUIRED */ null,
        /* CLOCK_OUT */ "على مدار الساعة من",
        /* CLOCK_OUT_AFTER */ "الساعة بعد",
        /* CLOCK_OUT_AT */ "الساعة في",
        /* CLOCK_OUT_BETWEEN */ null,
        /* CLOCK_OUT_TIME_IS_REQUIRED */ null,
        /* CLOCK_TIMES_NOT_MOBILE */ null,
        /* CLOCK_TIME_IN_RANGE */ null,
        /* CLOCK_TIME_NOT_IN_RANGE */ null,
        /* CLOSE */ "يغلق",
        /* CLOSE_SURVEY */ "مسح قريب",
        /* CLUSTERED_VISIT_EXPLENATION */ "اكتشفنا أن هذه الزياراتين قريبة من بعضها البعض وتناسب جدولك اليومي. نوصي بطلب كل من هذه الزيارات معا. يمكنك أيضًا طلب كل من الزيارات بشكل فردي",
        /* CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE */ "لم يتم العثور على الرمز ، يرجى استخدام واحد آخر",
        /* COMBINED_CASE */ "حالة مجتمعة",
        /* COMING_SOON */ "قريبا",
        /* COMPLETED */ "مكتمل",
        /* COMPLETED_DOCUMENTS */ "الوثائق المكتملة",
        /* COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL */ null,
        /* COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS */ null,
        /* COMPLETE_PREVIOUS_SECTIONS_FIRST */ null,
        /* COMPLETE_REGISTRATION */ null,
        /* COMPLETE_REGISTRATION_PROCESS */ null,
        /* COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* COMPLETE_VISIT */ null,
        /* COMPLETE_YOUR_ONBOARDING_ANYTIME */ null,
        /* COMPLIANCE */ "الامتثال",
        /* COMPLIANCE_EXPIRY */ "تتطلب مقاطع الفيديو انتباهك",
        /* COMPLIANCE_FORM */ null,
        /* COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY */ null,
        /* COMPLIANT */ "متوافق",
        /* COMPLIANT_ITEMS */ null,
        /* CONFIRM */ "يتأكد",
        /* CONFIRM_ASSESSMENT */ "تأكيد التقييم",
        /* CONFIRM_COPY_LAST */ "هل أنت متأكد أنك تريد نسخ الإجابات من",
        /* CONFIRM_COPY_LAST_TITLE */ "تأكيد نسخة؟",
        /* CONFIRM_DEPOSIT_DETAILS */ null,
        /* CONFIRM_PATIENT_AVAILABILITY */ null,
        /* CONFIRM_PATIENT_AVAILABILITY_MESSAGE */ null,
        /* CONFIRM_RN_FLEX_VISIT */ "أؤكد زيارتي",
        /* CONFIRM_WITHOUT_LOCATION */ "تأكيد بدون موقع",
        /* CONGRATULATIONS */ null,
        /* CONGRATULATIONS_TO */ null,
        /* CONNECTING_HOME */ "ربط المنزل",
        /* CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS */ "ربط وكالات الصحة المنزلية مع مقدمي الرعاية",
        /* CONNECT_WITH_US_ON_FACEBOOK */ "تواصل معنا على الفيسبوك",
        /* CONNECT_WITH_US_ON_WHATSAPP */ "تواصل معنا على WhatsApp",
        /* CONTACT */ "اتصال",
        /* CONTACT_AGENCY_FOR_MORE_INFO */ "اتصل بالوكالة لمزيد من المعلومات.",
        /* CONTACT_PATIENT */ "اتصل بالمريض",
        /* CONTACT_SUPPORT */ "اتصل بالدعم",
        /* CONTINUE */ "يكمل",
        /* CONTINUE_LATER */ "نكمل لاحقا",
        /* CONTINUE_TO_APP */ null,
        /* CONTINUE_TO_ORIENTATION */ null,
        /* CONTINUE_TO_SIGN_UP */ "استمر في التسجيل",
        /* CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK */ null,
        /* COORDINATOR */ "منسق",
        /* COORDINATOR_EMAIL */ "منسق البريد الإلكتروني",
        /* COORDINATOR_IN_CHARGE */ "المنسق المسؤول",
        /* COORDINATOR_PHONE */ "هاتف المنسق",
        /* COPY */ "ينسخ",
        /* COPY_FROM_LAST_TIME */ "نسخ من آخر مرة",
        /* COPY_FROM_MEDICATION */ "نسخ من الدواء",
        /* COPY_FROM_OTHER_FORMS */ "نسخ من نماذج أخرى",
        /* COPY_LAST_NO_DATE_FALLBACK_APPENDED */ "آخر مرة",
        /* COPY_MEDICATION_CHART */ "نسخ مخطط الدواء",
        /* COPY_PLAN_OF_CARE */ "نسخة خطة الرعاية",
        /* CORRECT */ "صيح",
        /* COURSES */ "الدورات",
        /* COVID */ "Covid-19",
        /* COVID_REQUIRED */ "Covid-19 استبيان مطلوب",
        /* COVID_REQUIRED_EXPLAINED */ "لم تملأ استبيان Covid-19 اليوم. يرجى ملئها من أجل المتابعة",
        /* COVID_SCREENING_CLICK_HERE */ "فحص Covid -19 - انقر هنا",
        /* CREATED_AT */ "أنشئت في",
        /* CREATE_A_NEW_ACCOUNT */ "انشاء حساب جديد",
        /* CREATE_NEW_PLAN_OF_CARE */ "إنشاء خطة رعاية جديدة",
        /* CRIMINAL_CONVICTIONS_RECORDS */ null,
        /* CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT */ "تم تسجيلها حاليًا في زيارة مختلفة",
        /* CURRENT_BALANCE */ null,
        /* CURRENT_VISIT */ null,
        /* DATA_WILL_BE_LOST */ "سيتم فقد البيانات",
        /* DATE */ "تاريخ",
        /* DATES */ "تواريخ",
        /* DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO */ null,
        /* DATE_NOT_SPECIFIED */ "التاريخ غير محدد",
        /* DATE_OF_BIRTH */ "تاريخ الولادة",
        /* DATE_UNKNOWN */ null,
        /* DATE_VERIFICATION */ "التحقق من التاريخ",
        /* DAY */ "يوم",
        /* DAYS */ "أيام",
        /* DAYS_A_WEEK */ "أيام في الأسبوع",
        /* DAYS_LEFT */ "ايام متبقية",
        /* DAYS_OF_WEEK */ "أيام في الأسبوع",
        /* DECEMBER */ "ديسمبر",
        /* DECLINED */ "انخفض",
        /* DELETE */ "حذف",
        /* DESCRIBE_THE_PROBLEM */ "صف المشكلة",
        /* DETAILS */ "تفاصيل",
        /* DIRECTIONS */ "الاتجاهات",
        /* DIRECT_DEPOSIT */ null,
        /* DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION */ "انقطع الاتصال. تحقق من اتصال الإنترنت الخاص بك",
        /* DISCOVER_YOUR_JOURNEY */ null,
        /* DISCRIMINATION */ null,
        /* DISMISS */ "رفض",
        /* DISMISSED */ null,
        /* DISTANCE */ "مسافه: بعد",
        /* DOB */ null,
        /* DOCUMENT */ "وثيقة",
        /* DOCUMENTS */ "وثائق",
        /* DOCUMENTS_TO_COMPLETE */ null,
        /* DOCUMENT_HAS_EXPIRED */ "انتهت صلاحية الوثيقة",
        /* DOCUMENT_IS_MISSING */ "الوثيقة مفقودة",
        /* DOCUMENT_REJECTED */ "وثيقة مرفوض",
        /* DOCUMENT_SELECTED */ null,
        /* DOESNT_EXPIRE */ null,
        /* DOES_NOT_FIT_MY_SCHEDULE */ "لا يناسب جدول أعمالي",
        /* DONE */ "فعله",
        /* DONT_FORGET_TO_CLOCK_IN */ null,
        /* DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS */ null,
        /* DONT_FORGET_TO_CLOCK_OUT */ "لا تنس الساعة",
        /* DONT_FORGET_TO_FILL_THE_DUTY_SHEET */ null,
        /* DONT_FORGET_TO_SMILE */ null,
        /* DONT_SCHEDULE_VISIT */ null,
        /* DONT_SHOW_AGAIN */ "لا تظهر مرة أخرى",
        /* DOSE */ "جرعة",
        /* DOWNLOAD_PDF */ null,
        /* DO_YOU_HAVE_ANY_QUESTIONS_ASK */ null,
        /* DO_YOU_WANT_THIS_VISIT */ null,
        /* DUE_BETWEEN */ null,
        /* DUE_BY_DATETIME */ null,
        /* DUE_DATE */ "تاريخ الاستحقاق",
        /* DUE_ON */ null,
        /* DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO */ null,
        /* DURATION */ "مدة",
        /* DURATION_PER_DAY */ "المدة في اليوم",
        /* DUTIES */ null,
        /* DUTIES_COMPLETED_SUCCESSFULLY */ null,
        /* DUTY_SHEET_SUBMITTED */ "ورقة الرسوم المقدمة",
        /* EACH_100_POINTS_DOLLAR */ null,
        /* EACH_INVITE */ "كل دعوة",
        /* EARLY_OR_LATE_CLOCKS */ null,
        /* EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY */ null,
        /* EDIT */ "تعديل",
        /* EDIT_ACCOUNT_DETAILS */ null,
        /* EDIT_TIMES */ "تحرير الأوقات",
        /* EDUCATION */ "مركز تعليمي",
        /* ELECTRIC_EQUIPMENT_DEPENDENCY */ null,
        /* ELIGIBLE_VISITS */ null,
        /* EMAIL */ null,
        /* EMAIL_QUESTION_PENDING_VERIFICATION */ null,
        /* EMAIL_SUPPORT */ null,
        /* EMAIL_SUPPORT_FOR_MORE_INFO */ "دعم البريد الإلكتروني لمزيد من المعلومات",
        /* EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER */ null,
        /* EMAIL_VERIFICATION_QUESTION_LABEL */ null,
        /* EMERGENCY_CONTACTS */ null,
        /* EMPTY_DURATION */ null,
        /* EMPTY_PATIENT_MEDICATION_PROFILE */ "ملف تعريف الأدوية المريض فارغ",
        /* ENABLE_LOCATION_MESSAGE */ null,
        /* ENABLE_LOCATION_TITLE */ null,
        /* ENDING_AT */ "تنتهي في",
        /* ENDS */ "ينتهي",
        /* END_DATE */ "تاريخ الانتهاء",
        /* END_TIME */ "وقت النهاية",
        /* ENROLLMENT_REQUESTED */ "طلب الالتحاق",
        /* ENROLL_NOW */ "تسجيل الآن",
        /* ENTER_AGENCY_CODE */ "أدخل رمز الوكالة",
        /* ENTER_DOCUMENT_NAME */ "أدخل اسم المستند",
        /* ENTER_NUMBER_HERE */ "أدخل الرقم هنا",
        /* ENTER_TEXT_HERE */ "أدخل النص هنا",
        /* ENTER_YOUR_MOBILE_NUMBER */ "أدخل رقم هاتفك المحمول",
        /* ENTER_YOUR_PIN_CODE */ "أدخل رمز التعريف الشخصي الخاص بك",
        /* ENTITY_IS_MISSING */ "الحقل ٪ s مفقود. يرجى التأكد من ملأها ثم حاول مرة أخرى.",
        /* ERROR */ "خطأ",
        /* ERROR_FETCHING_SLOTS */ null,
        /* ERROR_LOADING_DATA */ null,
        /* ERROR_REMOVING_DOCUMENT */ "حدث خطأ أثناء إزالة المستند",
        /* ERROR_SCHEDULING_TASK */ null,
        /* ERROR_SCHEDULING_TASK_MESSAGE */ null,
        /* ESTIMATED_ADDRESS_WILL_BE_PROVIDED */ null,
        /* ESTIMATED_TIME_OF_CLOCKING_OUT_IS */ null,
        /* EVACUATION_LOCATION */ null,
        /* EVACUATION_ZONE */ null,
        /* EVERY_VISIT */ "كل زيارة",
        /* EVV */ null,
        /* EXCITING_NEWS_AHEAD */ null,
        /* EXEMPTED */ "معفاة",
        /* EXPIRED */ "منتهية الصلاحية",
        /* EXPIRED_COMPLIANCE */ null,
        /* EXPIRED_ON_DATE */ null,
        /* EXPIRES_AT */ "تنتهي في",
        /* EXPIRES_IN */ "ينتهي في",
        /* EXPIRES_IN_ONE_DAY */ "تنتهي في يوم واحد",
        /* EXPIRES_IN_X_DAYS */ "تنتهي في ٪ D أيام",
        /* EXPIRES_ON_DATE */ null,
        /* EXPIRING_COMPLIANCE */ null,
        /* EXPIRING_SOON */ null,
        /* EXPIRY_DATE */ "تاريخ الانتهاء",
        /* EXPLORE */ null,
        /* EXPLORE_A_CAREER_ENHANCEMENTS */ null,
        /* FAILED_TO_IDENTIFY_PATIENT */ "فشل في تحديد المريض",
        /* FAR_VISIT_WARNING_MODAL_TITLE */ null,
        /* FAX_NUMBER */ null,
        /* FEBRUARY */ "شهر فبراير",
        /* FEMALE */ "أنثى",
        /* FIFTHY_DOLLAR_AMAZON_GIFT_CARD */ null,
        /* FILES */ "الملفات",
        /* FILE_NOT_FOUND_CONTACT_AGENCY */ null,
        /* FILL */ null,
        /* FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT */ null,
        /* FILL_IN_THE_QUESTIONNAIRE */ "املأ الاستبيان",
        /* FILTERS */ "المرشحات",
        /* FINAL_CONFIRMATION */ null,
        /* FIND_A_CARE_MOMENT */ null,
        /* FIND_A_CARE_MOMENT_DESCRIPTION */ null,
        /* FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FINISH_MY_ONBOARDING */ null,
        /* FINISH_ONBOARDING_AND_GET_DOLLARS */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2 */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE_STAGE_2 */ null,
        /* FINISH_SHIFT */ null,
        /* FINISH_THE_DOCUMENTS */ null,
        /* FIRST_NAME */ "الاسم الاول",
        /* FIRST_SHIFT */ "الوردية الأولى",
        /* FIVE_THOUSAND_POINTS */ null,
        /* FIX */ null,
        /* FIX_DOCUMENTS_DESCRIPTION */ null,
        /* FIX_DOCUMENT_DESCRIPTION */ null,
        /* FIX_ISSUE */ null,
        /* FIX_ISSUES */ null,
        /* FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* FIX_SETTINGS */ "إصلاح الإعدادات",
        /* FIX_THE_DOCUMENT */ null,
        /* FIX_THE_DOCUMENTS */ null,
        /* FIX_YOUR_DOCUMENT */ null,
        /* FIX_YOUR_DOCUMENTS */ null,
        /* FLEXIBLE */ null,
        /* FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_VISIT */ "زيارة أيام مرنة",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT */ null,
        /* FLEXIBLE_HOURS_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_VISIT */ "زيارة ساعات مرنة",
        /* FLEXIBLE_VISIT */ "زيارة مرنة",
        /* FLEXIBLE_VISIT_DAY_TO_CHOOSE */ null,
        /* FLEXIBLE_VISIT_DETAILS */ "تفاصيل زيارة مرنة",
        /* FLEXIBLE_VISIT_TYPE */ "زيارة مرنة",
        /* FLU_SHOT */ null,
        /* FLU_SHOT_SUBMITTION_MESSAGE */ null,
        /* FOLLOW_US_ON_INSTAGRAM */ "متابعتنا على الانستقرام",
        /* FOLLOW_US_ON_TWITTER */ "تابعنا على تويتر",
        /* FORGOT_PIN_CODE_DIALOG_MESSAGE */ "سيتم نقلك إلى شاشة تسجيل الدخول لبدء عملية تسجيل جديدة.",
        /* FORM_NAME */ "اسم النموذج",
        /* FOURTEEN_THOUSAND_POINTS */ null,
        /* FREQUENCY */ "تكرر",
        /* FRIEND */ "صديق",
        /* FROM */ "من",
        /* FROM_CAMERA */ "من الكاميرا",
        /* FROM_GALLERY */ "من المعرض",
        /* FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE */ "الشروط والأحكام الكاملة - تحدي medflyt",
        /* FUTURE_VISITS */ null,
        /* GENDER */ "جنس تذكير أو تأنيث",
        /* GENERAL */ "عام",
        /* GENERAL_FILES */ "الملفات العامة",
        /* GENERAL_NOTES */ "ملاحظات عامة",
        /* GENERAL_SUPPORT */ null,
        /* GET_INSTAPAY */ null,
        /* GET_IT_NOW */ "احصل عليها الآن",
        /* GET_MONEY_FOR_THIS_VISIT_TODAY
 */ null,
        /* GET_NOW */ null,
        /* GET_STARTED */ null,
        /* GET_THE_APP */ "احصل على التطبيق",
        /* GET_X_NOW */ null,
        /* GOOD_JOB */ "أحسنت!",
        /* GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "أحسنت! لقد أكملت جميع الدروس في الوقت الحالي",
        /* GOT_IT */ "فهمتك",
        /* GO_BACK */ "عُد",
        /* GO_TO */ "اذهب إلى",
        /* GO_TO_MEDFLYT_PASSPORT */ "انتقل إلى جواز سفر ميدفليت",
        /* GO_TO_PATIENT */ "اذهب إلى المريض",
        /* GO_TO_PATIENT_DETAILS */ "اذهب إلى تفاصيل المريض",
        /* GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION */ null,
        /* GO_TO_VISIT */ "اذهب للزيارة",
        /* GREAT_JOB */ "عمل عظيم!",
        /* GROSS_PAY */ null,
        /* HAS_DNR */ null,
        /* HAS_HEALTH_CARE_PROXY */ null,
        /* HAVE_A_NICE_WORKING_DAY */ null,
        /* HAVE_A_PLEASANT_VISIT */ null,
        /* HAVE_A_QUESTION_LETS_CHAT */ null,
        /* HEALTH_AGENCIES */ "الوكالات الصحية",
        /* HELP */ "يساعد",
        /* HELP_ME_FIND_MY_AGENCY */ "ساعدني في العثور على وكالتي",
        /* HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY */ null,
        /* HEY */ "يا!",
        /* HEY_THERE */ "مرحبًا يا من هناك",
        /* HI */ "أهلاً",
        /* HIRE_DATE */ null,
        /* HI_PLEASE_HELP_ME_FILL_MY_APPLICATION  */ null,
        /* HOME_PHONE */ "هاتف المنزل",
        /* HOUR */ null,
        /* HOURS */ "ساعات",
        /* HOURS_PER_DAY */ "ساعة في اليوم",
        /* HOURS_PER_VISIT */ "ساعات لكل زيارة",
        /* HOW_ARE_WE_CALCULATING_THE_RANK */ null,
        /* HOW_CAN_WE_HELP_YOU */ "كيف يمكننا مساعدتك؟",
        /* HOW_CARE_MOMENTS_WORKS */ null,
        /* HOW_DID_YOU_HEAR_ABOUT_US */ "كيف سمعت عنا",
        /* HOW_DOES_IT_WORK */ null,
        /* HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS */ "كيف يشعر المريض؟ ما هي الأعراض الرئيسية؟",
        /* HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN */ "كيف تشجع المريض الذي يشعر بالانخفاض؟",
        /* HOW_DO_YOU_RATE_MEDFLYT */ "كيف تقيم ميدفليت؟",
        /* HOW_URGENT_IS_THE_ISSUE */ "ما مدى إلحاح القضية؟",
        /* HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT */ "كيف تريد الاتصال بالمريض؟",
        /* HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE */ "كيف تريد تحميل الملف؟",
        /* HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT */ null,
        /* HR_PER_VISIT */ "HR لكل زيارة",
        /* HUNDRED_DOLLARS_GIFT_CARD */ "100 دولار بطاقة هدايا Amex",
        /* ICD */ "ICD",
        /* ID */ null,
        /* IF_YOU_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON */ null,
        /* IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE */ null,
        /* IF_YOU_STAY_COMPLIANT */ null,
        /* IMPORTANT_INFORMATION */ null,
        /* IMPORTED */ "مستورد",
        /* IM_AVAILABLE */ "أنا موجود",
        /* IM_DONE_SUBMIT */ null,
        /* IM_NOT_INTERESTED */ "أنا لست مهتم",
        /* IM_WORKING_WITH_AN_AGENCY */ "أنا أعمل مع وكالة",
        /* INACTIVE */ "غير نشط",
        /* INCOMPLETE */ null,
        /* INCORRECT */ "غير صحيح",
        /* INCORRECT_CODE */ "شفرة خاطئة",
        /* INCORRECT_DIGITS */ "أرقام غير صحيحة ...",
        /* INCORRECT_DIGITS_EXPLAINED */ "آخر الأربعة أرقام التي أدخلتها غير صحيحة. يرجى الاتصال بوكالتك إذا كنت تواجه مشاكل.",
        /* INCORRECT_DIGITS_MESSAGE */ "الأرقام الأربعة الأخيرة التي أدخلتها غير صحيحة. يرجى الاتصال بوكلك إذا كنت تواجه مشاكل.",
        /* INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN */ "رمز رقم التعريف الشخصي غير صحيح. حاول مرة اخرى.",
        /* INCORRECT_SMS_CODE */ "رمز الرسائل القصيرة غير الصحيح",
        /* INCORRECT_SMS_CODE_EXPLAINED */ "لا يتطابق الرمز الذي أدخلته مع الرمز الذي أرسلناه إليك. حاول مرة اخرى.",
        /* INFORMATION_CENTER */ null,
        /* INFORMATION_NOT_MATCH_PROFILE */ null,
        /* INSERT_THEIR_REFERRAL_CODE_HERE */ "أدخل رمز الإحالة هنا!",
        /* INSERVICES */ null,
        /* INSTAPAY */ null,
        /* INSTAPAY_HISTORY */ null,
        /* INSTAPAY_TECHNICAL_ISSUE */ null,
        /* INSUFFICIENT_DUTIES */ null,
        /* INTERESTED_IN_THIS_BUNDLE */ "هل أنت مهتم بهذه الحزمة؟",
        /* INTRODUCING */ "مقدمة",
        /* INVALID_DOCUMENT_NAME */ "اسم المستند غير صالح",
        /* INVALID_EMAIL */ "بريد إلكتروني خاطئ",
        /* INVALID_FORM */ null,
        /* INVALID_PHONE */ "هاتف غير صالح",
        /* INVALID_PHONENUMBER */ "رقم الهاتف غير صحيح",
        /* INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN */ null,
        /* INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES */ "قم بدعوة مقدمي الرعاية إلى Medflyt والفوز بجوائز مذهلة",
        /* INVITE_FRIENDS */ "ادعو أصدقاء",
        /* IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE */ null,
        /* IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT */ null,
        /* IN_PROGRESS */ null,
        /* ISSUES_TO_SOLVE */ null,
        /* IS_DUE_IN_DAYS */ null,
        /* IS_DUE_TOMORROW */ null,
        /* ITEMS_THAT_WILL_EXPIRE_SOON */ null,
        /* ITEMS_WITH_ISSUES */ null,
        /* ITEM_IS_MISSING */ null,
        /* ITEM_IS_NOT_COMPLIANT */ null,
        /* ITS_NOT_ME */ "ليس انا",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU */ "يبدو أن لدينا بالفعل حساب موجود على هذا الجهاز. هل هذا أنت؟",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU */ "يبدو أن لدينا بالفعل حساب يطابق التفاصيل الخاصة بك. هل هذا أنت؟",
        /* IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK */ null,
        /* IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE */ "يبدو أنك لا تعمل مع أي وكالة. هل ترغب في الحصول على توظيف من قبل الوكالات عن طريق ملء التطبيق",
        /* I_DONT_HAVE_MY_CODE */ "ليس لدي رمز",
        /* I_DONT_WANT_THIS_CASE */ null,
        /* I_DONT_WANT_TO_CLOCK */ null,
        /* I_FORGOT_MY_PIN_CODE */ "لقد نسيت رمز الدبوس الخاص بي",
        /* I_HAVE_CHANGED_MY_MIND */ null,
        /* I_HAVE_READ_AND_AGREE */ "لقد قرات ووافقت على ال",
        /* I_VERIFY_THE_TERMS */ null,
        /* I_WANT_TO_CLOCK_IN_ANYWAY */ null,
        /* I_WANT_TO_CLOCK_OUT_ANYWAY */ null,
        /* I_WANT_TO_FINISH_MY_ONBOARDING */ null,
        /* I_WILL_DO_IT_LATER */ null,
        /* JANUARY */ "يناير",
        /* JOINED_DATE */ "تاريخ الانضمام",
        /* JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT */ null,
        /* JULY */ "يوليو",
        /* JUNE */ "يونيه",
        /* JUST_ONE_MORE_THING */ null,
        /* JUST_TO_BE_SURE */ null,
        /* JUST_VERIFYING_ITS_YOU */ "فقط تحقق من أنه أنت",
        /* KEEP_UP_THE_GOOD_WORK */ null,
        /* LABELS */ "ملصقات",
        /* LANGUAGE */ "لغة",
        /* LANGUAGES */ "اللغات",
        /* LAST_NAME */ "الكنية",
        /* LEARN_MORE */ null,
        /* LEAVE_WITHOUT_SAVING */ "ترك دون الادخار؟",
        /* LEFT */ null,
        /* LESSON */ "درس",
        /* LESSONS */ "الدروس",
        /* LETS_CONTINUE_TO_NEXT_SECTION */ null,
        /* LETS_FIND_CASES */ null,
        /* LETS_FIND_YOUR_FIRST_CASE */ null,
        /* LETS_FIND_YOUR_FIRST_PATIENT */ null,
        /* LETS_FINISH_YOUR_SHIFT */ null,
        /* LETS_START */ "لنبدأ!",
        /* LETS_START_YOUR_SHIFT */ null,
        /* LIKE_US_ON_FACEBOOK */ "اعجب بنا على الفيسبوك",
        /* LINKED_TO_ANOTHER_PATIENT */ null,
        /* LIST */ "قائمة",
        /* LISTENING___ */ null,
        /* LIST_OF_PATIENTS */ "قائمة المرضى",
        /* LIST_OF_TASKS */ "قائمة المهام",
        /* LIST_OF_VISITS */ "قائمة الزيارات",
        /* LIVE_CHAT_SUPPORT */ "دعم الدردشة المباشرة",
        /* LIVE_CLASS */ "فئة حية",
        /* LIVE_CLASS_EXPLANATION */ "ستتمكن من الانضمام إلى الفصل بمجرد بدء تشغيله. في حال فاتك ذلك - ستتمكن من مشاهدة ندوة الويب المسجلة",
        /* LIVE_EVENTS */ "أحداث حية",
        /* LOADING */ "جار التحميل",
        /* LOADING_LOCATION */ "موقع التحميل ...",
        /* LOCATION */ "موقع",
        /* LOCKED */ "مقفل",
        /* LOGGING_YOU_IN */ "تسجيل لك",
        /* LOGIN */ "تسجيل الدخول",
        /* LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED */ "يبدو أنك تحاول تسجيل الدخول من جهاز مختلف. الرجاء الإجابة على الأسئلة التالية",
        /* LOOKS_LIKE_MORE_THAN */ null,
        /* LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION */ null,
        /* MAIN_TASKS */ null,
        /* MAKE_A_DIFFERENCE */ null,
        /* MAKE_SURE_PICTURE_IS_CLEAR */ null,
        /* MALE */ "ذكر",
        /* MANUALLY_SUBMITTED_INFO */ null,
        /* MAP */ "خريطة",
        /* MARCH */ "يمشي",
        /* MAX_TRAVEL_DISTANCE */ "أقصى مسافة السفر",
        /* MAY */ "قد",
        /* MAYBE_LATER */ "ربما في وقت لاحق",
        /* MAY_CLOCK_IN_AT */ "قد ساعة في في",
        /* MAY_CLOCK_OUT_FROM */ "قد تتسابق من",
        /* MEC_WAIVER_INFORMATION */ null,
        /* MEDFLYT */ null,
        /* MEDFLYTS_MONTHLY_RAFFLE */ null,
        /* MEDFLYT_AGENCY_HANDBOOK */ null,
        /* MEDFLYT_AT_HOME_BENEFITS */ null,
        /* MEDFLYT_CHALLENGE */ "تحدي medflyt",
        /* MEDFLYT_HOME_CARE */ null,
        /* MEDFLYT_ID_CARD */ null,
        /* MEDFLYT_PASSPORT */ "جواز السفر Medflyt",
        /* MEDFLYT_PASSPORT_TERMS */ "شروط جواز السفر Medflyt",
        /* MEDFLYT_RAFFLE */ null,
        /* MEDFLYT_TEAM */ null,
        /* MEDFLYT_VERSION */ "نسخة medflyt",
        /* MEDICAL_FILES */ "الملفات الطبية",
        /* MEDICAL_INFORMATION */ "معلومات طبية",
        /* MEDICAL_NOTES */ "ملاحظات طبية",
        /* MEDICATIONS */ null,
        /* MESSAGE */ "رسالة",
        /* MESSAGE_FOR_THE_COORDINATOR */ "رسالة للمنسق",
        /* MIDDLE_NAME */ "الاسم الوسطى",
        /* MILES_AWAY */ "على بعد أميال",
        /* MILES_BETWEEN_PATIENTS */ "أميال بين المرضى",
        /* MILES_SHORT */ "مي",
        /* MINIMUM_WAGE */ null,
        /* MINUTE */ null,
        /* MINUTES */ "محضر جلسة",
        /* MINUTE_VISIT */ "زيارة دقيقة",
        /* MISSING */ "مفقود",
        /* MISSING_CLOCKS */ null,
        /* MISSING_PERSONAL_CARE_DUTY */ null,
        /* MM_DD_YYYY */ null,
        /* MOBILE_PHONE */ "هاتف محمول",
        /* MOBILITY_STATUS */ null,
        /* MONTH */ "شهر",
        /* MONTHLY_RAFFLE */ null,
        /* MORE_DETAILS */ "المزيد من التفاصيل",
        /* MORE_DETAILS_BELOW */ null,
        /* MORE_SHIFTS_MORE_CHANCES */ null,
        /* MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* MUST_AGREE_TERMS */ null,
        /* MUST_BE_ATLEAST_3_CHARACTERS */ "يجب أن تكون على الأقل 3 أحرف",
        /* MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS */ "يجب أن يكون في أحد الأيام التالية",
        /* MUST_PICK_EXACTLY */ "يجب أن تختار بالضبط",
        /* MUST_START_AT_OR_AFTER */ "يجب أن تبدأ في أو بعد",
        /* MUST_START_AT_OR_BEFORE */ "يجب أن تبدأ في أو قبل",
        /* MUST_UPDATE_ADDRESS_TO_SEE_CASES */ "يجب عليك تحديث عنوانك لرؤية الحالات!",
        /* MY_AGENCIES */ "وكالاتي",
        /* MY_ASSIGNED_VISITS */ "زياراتي المعينة",
        /* MY_AVAILABILITY */ null,
        /* MY_BENEFITS_CARD_INFORMATION */ null,
        /* MY_MEDFLYT_COMPLIANCE */ null,
        /* MY_PASSPORT */ "جواز السفر الخاص بي",
        /* MY_PAYROLL_HISTORY */ null,
        /* MY_PAYROLL_INFORMATION */ null,
        /* MY_PROFILE */ null,
        /* MY_REQUESTED_VISITS */ "زياراتي المطلوبة",
        /* MY_STAFFING_PREFERENCES */ null,
        /* MY_UPCOMING_VISITS_REMINDERS */ "زيارة تذكير",
        /* MY_VIRTUAL_ID */ null,
        /* MY_VISITS */ null,
        /* NA */ "ن/أ",
        /* NAME */ "اسم",
        /* NEAR */ null,
        /* NEED_DIRECTIONS */ "هل تحتاج إلى اتجاهات؟",
        /* NET_PAY_FOR_PERIOD */ null,
        /* NEW */ "جديد",
        /* NEW_END_TIME_X */ null,
        /* NEW_MESSAGE */ null,
        /* NEW_TASK */ "مهمة جديدة",
        /* NEW_TASKS */ "مهام جديدة",
        /* NEW_VISITS_AVAILABLE */ "زيارات جديدة متاحة",
        /* NEXT */ "التالي",
        /* NEXT_DUE */ "المقبل بسبب",
        /* NEXT_LESSON */ "الدرس التالي",
        /* NEXT_SECTION */ null,
        /* NEXT_TOKEN_IN */ null,
        /* NEXT_YEAR */ null,
        /* NO */ "رقم",
        /* NONE */ "لا أحد",
        /* NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT */ "لا أحد منهم هو أنا. انشاء حساب جديد",
        /* NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU */ "لا شيء من الحسابات التالية هو أنت",
        /* NOTES */ "ملاحظات",
        /* NOTIFICATIONS */ "إشعارات",
        /* NOTIFICATIONS_OFF */ "الإخطارات",
        /* NOTIFICATIONS_ON */ "الإخطارات على",
        /* NOT_AVAILABLE */ "غير متوفر",
        /* NOT_COMPLIANT */ "غير متوافق",
        /* NOT_DUE_YET */ null,
        /* NOT_ENOUGH_HOURS */ "لا توجد ساعات كافية",
        /* NOT_ENOUGH_SHIFTS */ "لا يكفي نوبات ...",
        /* NOT_ENOUGH_SHIFTS_MESSAGE */ "يجب عليك اختيار نوبات ٪ minshifts على الأقل من أجل طلب هذه الزيارة (لقد اخترت ٪ فقط Currentshifts ٪).",
        /* NOT_FOUND */ "لم يتم العثور على",
        /* NOT_INTERESTED */ "غير مهتم",
        /* NOT_SELECTED */ null,
        /* NOT_SET */ null,
        /* NOT_SIGNING */ null,
        /* NOT_STARTED */ null,
        /* NOT_URGENT */ "ليست عاجلة",
        /* NOVEMBER */ "شهر نوفمبر",
        /* NO_ALLERGIES */ "لا الحساسية المعروفة",
        /* NO_ANSWERS_TO_COPY */ "لا توجد إجابات للنسخ من.",
        /* NO_ANSWERS_TO_COPY_TITLE */ "فشل نسخة!",
        /* NO_AVAILABLE_SLOTS */ null,
        /* NO_BALANCE */ null,
        /* NO_CHANGES_WERE_MADE */ "لم يتم إجراء أية تغييرات",
        /* NO_COMPLIANT_ITEMS */ null,
        /* NO_DOCUMENTS */ "لا توجد مستندات",
        /* NO_DOCUMENTS_AVAILABLE */ "لا توجد مستندات متاحة",
        /* NO_DOCUMENTS_REQUIRED */ "لا توجد مستندات مطلوبة.",
        /* NO_DUTIES_REQUIRED_FOR_THIS_VISIT */ null,
        /* NO_EDUCATION_LINK */ "هل تريد تعليم مجاني؟ اتصل بالوكالين الخاص بك",
        /* NO_ELIGIBLE_VISITS */ null,
        /* NO_END_DATE */ "لا موعد نهاية",
        /* NO_GENERAL_NOTES */ "لا ملاحظات عامة",
        /* NO_IN_SERVICE_VIDEOS_AVAILABLE */ "لا توجد مقاطع فيديو في الخدمة متوفرة. يرجى الاتصال بوكالتك للحصول على التفاصيل.",
        /* NO_ISSUES_FOUND */ null,
        /* NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT */ "لا، هذا لست أنا. انشاء حساب جديد",
        /* NO_JUST_THIS_ONE */ null,
        /* NO_KEEP_THE_ORIGINAL_TIMES */ null,
        /* NO_KNOWN_ALLERGIES */ null,
        /* NO_LESSONS */ "لا دروس",
        /* NO_LESSONS_FOR_YOU_YET */ "لا دروس لك حتى الآن",
        /* NO_MEDICAL_INFORMATION */ "لا توجد معلومات طبية",
        /* NO_NOTIFICATIONS */ "لا إشعارات",
        /* NO_PAYSTUBS_FOUND_FOR_THIS_MONTH */ null,
        /* NO_PHONE */ "لا يوجد هاتف",
        /* NO_PHYSICIAN_SELECTED */ null,
        /* NO_PREVIOUS_CONVERSATIONS */ null,
        /* NO_SCHEDULED_VISITS_TODAY */ "لا توجد زيارات مجدولة اليوم",
        /* NO_SHIFTS_SELECTED */ null,
        /* NO_TAKE_ME_BACK */ null,
        /* NO_TESTS */ "لا اختبارات",
        /* NO_THANKS */ "ًلا شكرا",
        /* NO_TIME_LIMIT */ "لا يوجد حد زمني",
        /* NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT */ null,
        /* NO_VIDEOS */ "لا مقاطع فيديو",
        /* NO_VISITS_SCHEDULED */ null,
        /* NO_VISITS_SCHEDULED_MESSAGE */ null,
        /* NO_VISITS_SELECTED */ null,
        /* NPI */ null,
        /* NUM_COUNT_ITEMS */ null,
        /* NUM_SHIFTS_TO_GO */ null,
        /* NUM_SHIFTS_TO_WAGE */ null,
        /* N_A */ "ن/أ",
        /* OCTOBER */ "اكتوبر",
        /* OF */ "من",
        /* OF_THE_REQUIRED_PLEASE_CONTINUE */ "من الوقت المطلوب. يرجى مواصلة.",
        /* OF_THE_VIDEO */ "من الفيديو.",
        /* OK */ "نعم",
        /* OK_ILL_TRY_LATER */ null,
        /* OK_NO_PROBLEM */ "حسنا لا مشكلة!",
        /* OK_THANKS */ null,
        /* ON */ "على",
        /* ONBOARDING */ null,
        /* ONBOARDING_COMPLETED */ null,
        /* ONBOARDING_COMPLETED_MESSAGE */ null,
        /* ONE_DAY_TO_COMPLETE */ "يوم واحد لإكمال",
        /* ONE_DOCUMENT */ "وثيقة واحدة",
        /* ONE_DOCUMENT_SELECTED */ null,
        /* ONE_HOUR */ null,
        /* ONE_LAST_STEP */ null,
        /* ONE_LESSON */ "درس واحد",
        /* ONE_TEST */ "اختبار واحد",
        /* ONE_THOUSAND_POINTS */ null,
        /* ONE_VIDEO */ "فيديو واحد",
        /* ON_HOLD */ "في الانتظار",
        /* ON_LEAVE */ "عند المغادرة",
        /* OOPS */ "عفوًا",
        /* OPEN */ "يفتح",
        /* OPEN_CAMERA */ null,
        /* OPEN_CERTIFICATE */ null,
        /* OPEN_DEVICE_SETTINGS */ null,
        /* OPEN_MAPS */ null,
        /* OPEN_SETTINGS */ null,
        /* OPTIONAL_TASKS */ null,
        /* OR */ "أو",
        /* OTHER */ "آخر",
        /* OTHER_PERTINENT_DIAGNOSIS */ "تشخيص آخر ذي صلة",
        /* OTHER_REASON */ null,
        /* OTHER_TASKS */ null,
        /* OTHER_VISITS */ null,
        /* OUTBOUND_CALL_ERROR_MESSAGE */ null,
        /* OUTBOUND_CALL_ERROR_TITLE */ null,
        /* OUTBOUND_CALL_PROMPT_MESSAGE */ null,
        /* OUTBOUND_CALL_PROMPT_TITLE */ null,
        /* OUTBOUND_CALL_SUCCESS_MESSAGE */ null,
        /* OUTBOUND_CALL_SUCCESS_TITLE */ null,
        /* OUT_OF */ "بعيدا عن المكان",
        /* OUT_OF_RANGE */ null,
        /* OVERDUE */ null,
        /* OVERLAPPING_VISIT_ERROR */ "الزيارات متداخلة ، يرجى تحديد تاريخ أو وقت آخر.",
        /* OVERRIDE_FORM */ null,
        /* OVERRIDE_FORM_MESSAGE */ null,
        /* OVER_NIGHT */ "بين عشية وضحاها",
        /* PAGE */ "صفحة",
        /* PAID */ null,
        /* PAID_X_OUT_OF_Y */ null,
        /* PARTIAL_SELECTION */ null,
        /* PASSPORT */ "جواز سفر",
        /* PASSPORT_TERMS_TEXT */ "قم بتحميل جميع ملفاتك والملفات الطبية بسهولة لمشاركتها مع الوكالات التي تعمل معها.",
        /* PASTE */ "معجون",
        /* PAST_DUE */ "الماضي بسبب",
        /* PAST_SINCE_THE_VISIT_STARTED */ null,
        /* PAST_UPLOADS */ "التحميلات السابقة",
        /* PAST_VISITS */ null,
        /* PATIENT */ "صبور",
        /* PATIENTS */ "مرضى",
        /* PATIENT_ADDRESS */ "عنوان المريض",
        /* PATIENT_CANT_PHISICALLY_SIGN */ null,
        /* PATIENT_CANT_SIGN */ null,
        /* PATIENT_CONTACTS */ null,
        /* PATIENT_DOC_NOT_SUBMITTED */ "لم يتم تقديم وثيقة المريض بسبب خطأ",
        /* PATIENT_DOC_SUBMISSION_MISSMATCH */ "أنت على وشك إرسال النموذج ، لكن التاريخ المحدد للزيارة يختلف عن اليوم. الرجاء اختيار التاريخ الذي ترغب في الحصول عليه في النموذج",
        /* PATIENT_DOC_SUBMITTED_SUCCESSFULY */ "تم تقديم وثيقة المريض بنجاح",
        /* PATIENT_INFO */ "معلومات المريض",
        /* PATIENT_IS_NOT_HOME */ null,
        /* PATIENT_IS_NOT_SIGNING */ null,
        /* PATIENT_NAME */ "اسم المريض",
        /* PATIENT_NOT_FOUND */ "لم يتم العثور على المريض",
        /* PATIENT_NOT_FOUND_EXPLAIN */ "آسف ، يبدو أن المريض الذي كنت تبحث عنه لم يتم تعيينه لك.",
        /* PATIENT_NUMBER */ "رقم المريض",
        /* PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE */ null,
        /* PATIENT_PHONE */ "هاتف المريض",
        /* PATIENT_REFUSES_TO_SIGN */ null,
        /* PATIENT_REPORT */ "تقرير المريض",
        /* PATIENT_REQUESTS */ null,
        /* PATIENT_SCHEDULE */ null,
        /* PATIENT_SIGNATURE */ null,
        /* PATIENT_SIGNATURE_IS_REQUIRED */ null,
        /* PATIENT_SIGNATURE_REQUIRE_MSG */ "يرجى تحديد سبب عدم توقيع توقيع المريض",
        /* PATIENT_SIGN_HERE */ "علامة المريض هنا",
        /* PATIENT_UNAVAILABLE_DURING_THESE_HOURS */ null,
        /* PATIENT_VISITS */ null,
        /* PAUSE_READING */ "وقفة القراءة",
        /* PAYMENT_METHOD */ null,
        /* PAYROLL */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_TITLE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE */ null,
        /* PAYSTUB */ null,
        /* PAYSTUBS */ null,
        /* PAY_ME_NOW */ null,
        /* PAY_ME_NOW_X */ null,
        /* PENDING */ "قيد الانتظار",
        /* PENDING_APPLICATION */ "تطبيق معلق",
        /* PENDING_APPROVAL */ null,
        /* PENDING_CONFIRMATION */ null,
        /* PENDING_ISSUES */ null,
        /* PENDING_VERIFICATION */ null,
        /* PERMANENT_VISIT_DETAILS */ "تفاصيل زيارة دائمة",
        /* PERMANENT_VISIT_FROM */ "زيارة دائمة من",
        /* PERMANENT_VISIT_TYPE */ "زيارة دائمة",
        /* PERMISSION_NEEDED_FOR_CAMERA */ null,
        /* PERMISSION_NEEDED_FOR_CAMERA_MESSAGE */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE */ null,
        /* PERMISSION_TO_CAMERA_DENIED */ null,
        /* PER_HOUR */ null,
        /* PER_SHIFT */ "لكل مدة الدوام",
        /* PER_VISIT */ "لكل زيارة",
        /* PER_WEEK */ null,
        /* PHONE */ "هاتف",
        /* PHONES */ "الهواتف",
        /* PHONE_CALL_SUPPORT */ "الدعم استدعاء",
        /* PHOTO_LIBRARY */ "مكتبة الصور",
        /* PHYSICIAN_DETAILS */ null,
        /* PICK_A_DATE */ "اختر موعدًا",
        /* PICK_A_TIME */ "اختر وقتًا",
        /* PLAN_OF_CARE */ "خطة الرعاية",
        /* PLEASE_ASK_THE_PATIENT */ null,
        /* PLEASE_CALL_PATIENT_IN_NEXT_SCREEN */ "يرجى الاتصال بالمريض في الشاشة التالية",
        /* PLEASE_CHAT_WITH_THE_AGENCY */ "الرجاء الدردشة مع الوكالة",
        /* PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY */ "يرجى التأكد من أن كنت قد دخلت بشكل صحيح.",
        /* PLEASE_CHOOSE_A_LANGUAGE */ "الرجاء اختيار لغة",
        /* PLEASE_CHOOSE_A_TIME */ "الرجاء اختيار وقت",
        /* PLEASE_CHOOSE_DATE_BETWEEN */ "الرجاء اختيار التاريخ بين",
        /* PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES */ "يرجى إكمال حزم السنوات السابقة",
        /* PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT */ "يرجى مراقبة وإرسال الاختبارات لتبقى متوافقة.",
        /* PLEASE_CONFIRM_THE_TIMES_CHOSEN */ "الرجاء تأكيد الأوقات المختارة",
        /* PLEASE_CONFIRM_YOUR_INFORMATION */ "يرجى تأكيد معلوماتك",
        /* PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS */ "يرجى الاتصال بالوكالة لمزيد من التفاصيل",
        /* PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY */ "يرجى الاتصال بوكالاتك على الفور",
        /* PLEASE_CONTACT_YOUR_AGENCY */ "يرجى الاتصال بوكلك",
        /* PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS */ "يرجى الاتصال بوكالتك للحصول على عنوان",
        /* PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY */ "يرجى الاتصال على وكالتك على الفور",
        /* PLEASE_CONTACT_YOUR_COORDINATOR */ "يرجى الاتصال بالمنسق الخاص بك.",
        /* PLEASE_ENABLE_LOCATION */ "يرجى تمكين الموقع",
        /* PLEASE_ENTER_A_VALID_PHONE_NUMBER */ "يرجى إدخال رقم هاتف صالح",
        /* PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME */ "الرجاء إدخال اسم المريض الأول والأخير",
        /* PLEASE_ENTER_PATIENT_NAME */ "الرجاء إدخال اسم المريض",
        /* PLEASE_ENTER_THE_PATIENT_PHONE */ "الرجاء إدخال هاتف المريض",
        /* PLEASE_ENTER_YOUR_PIN_CODE */ "الرجاء إدخال رمز التعريف الشخصي الخاص بك",
        /* PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED */ null,
        /* PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER */ "يرجى ملء آخر 4 أرقام من رقم الهاتف",
        /* PLEASE_FILL_IN_YOUR_INFORMATION */ "يرجى ملء معلوماتك",
        /* PLEASE_FILL_REQUIRED_FIELDS */ null,
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY */ "يرجى التأكد من أنك أدخلت الرمز بشكل صحيح",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY */ "يرجى التأكد من أنك أدخلت رقم هاتفك بشكل صحيح",
        /* PLEASE_MARK_ALL_THE_REQUIRED_DUTIES */ null,
        /* PLEASE_NOTE */ "يرجى الملاحظة",
        /* PLEASE_PICK_VALID_DATES */ "الرجاء اختيار تواريخ صالحة",
        /* PLEASE_REQUEST_EXACTLY */ "الرجاء طلب بالضبط",
        /* PLEASE_SELECT_AN_OPTION */ "الرجاء تحديد خيار",
        /* PLEASE_SELECT_DATE_AND_TIME */ "الرجاء تحديد التاريخ والوقت",
        /* PLEASE_SELECT_THE_PATIENT_ADDRESS */ "الرجاء تحديد عنوان المريض",
        /* PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT */ null,
        /* PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW */ "يرجى إعداد صورة ملفك الشخصي بالنقر فوق أيقونة الكاميرا أدناه",
        /* PLEASE_SIGN_IN_AGAIN */ "الرجاء تسجيل الدخول مرة أخرى",
        /* PLEASE_SPECIFY */ null,
        /* PLEASE_TAKE_A_SELFIE */ null,
        /* PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK */ "من فضلك قل لنا متى تخطط لأداء هذه المهمة؟",
        /* PLEASE_TYPE_IN_YOUR_PHONE_NUMBER */ null,
        /* PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH */ "يرجى كتابة مدونة الوكالة التي ترغب في العمل معها",
        /* PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER */ "يرجى كتابة آخر 4 أرقام من رقم الهاتف هذا",
        /* PLEASE_TYPE_THE_SMS_CODE */ "الرجاء كتابة رمز الرسائل القصيرة",
        /* PLEASE_UPDATE_TO_OUR_NEWEST_VERSION */ "يرجى التحديث إلى أحدث إصدار لدينا",
        /* PLEASE_UPDATE_YOUR_ADDRESS */ "الرجاء تحديث عنوانك",
        /* PLEASE_UPDATE_YOUR_FIRST_NAME */ "الرجاء تحديث اسمك الأول",
        /* PLEASE_UPDATE_YOUR_LAST_NAME */ "الرجاء تحديث اسمك الأخير",
        /* PLEASE_WAIT */ "أرجو الإنتظار",
        /* PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION */ null,
        /* PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP */ null,
        /* POINTS */ "نقاط",
        /* POINTS_AND_REWARDS */ null,
        /* POSTED_DATE */ "تاريخ النشر",
        /* PREBLOCK_VISIT_EXPLANATION */ "بعد التأكيد ، سيكون لديك وقت محدود للاتصال بالمريض وتحديد الوقت للزيارة.",
        /* PRESENTATION */ "عرض",
        /* PREVIOUS */ null,
        /* PREVIOUS_CONVERSATIONS */ null,
        /* PREVIOUS_WINNERS */ null,
        /* PRE_TAXES */ null,
        /* PRICE */ "السعر",
        /* PRINCIPAL_DIAGNOSIS */ "التشخيص الرئيسي",
        /* PRIORITY_CODE */ null,
        /* PRIVACY_POLICY */ "سياسة الخصوصية",
        /* PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN */ "مشكلة في الحصول على موقعك ، يرجى المحاولة مرة أخرى. حاول تشغيل خدمات الموقع أو الخروج.",
        /* PROBLEM_WITH_CASE_SETTINGS */ "يبدو أن لديك مشكلة في إعدادات حالتك",
        /* PROCESSING */ null,
        /* PROFESSIONAL_TYPE */ "نوع احترافي",
        /* PROFILE */ "حساب تعريفي",
        /* PROGRESS */ "تقدم",
        /* PROXY_FIRST_NAME */ null,
        /* PROXY_LAST_NAME */ null,
        /* PROXY_PHONE */ null,
        /* PULSE */ "نبض",
        /* QUESTION */ "سؤال",
        /* QUESTIONS */ "أسئلة",
        /* QUESTIONS_TO_COPY_FROM */ "أسئلة للنسخ من",
        /* QUESTION_NUMBER */ null,
        /* QUESTION_REJECTED */ null,
        /* QUIT */ null,
        /* RAFFLE_ENDED */ null,
        /* RAFFLE_INFO_1_DESCRIPTION */ null,
        /* RAFFLE_INFO_1_TITLE */ null,
        /* RAFFLE_INFO_2_DESCRIPTION */ null,
        /* RAFFLE_INFO_2_TITLE */ null,
        /* RAFFLE_INFO_3_DESCRIPTION */ null,
        /* RAFFLE_INFO_3_TITLE */ null,
        /* RAFFLE_INFO_4_DESCRIPTION */ null,
        /* RAFFLE_INFO_4_TITLE */ null,
        /* RAFFLE_NOW */ null,
        /* RAFFLE_PRIZE */ null,
        /* RANK_ACHIEVED */ null,
        /* REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION */ null,
        /* READY_FOR_YOUR_NEXT_TRAINING */ "جاهز لتدريبك القادم؟",
        /* READY_TO_CLOCK_IN */ "جاهز للتسجيل في",
        /* READY_TO_CLOCK_OUT */ "جاهز للتسجيل",
        /* READ_AND_CONFIRM */ "اقرأ وتأكيد",
        /* READ_ONLY_MODE */ null,
        /* READ_TEXT */ "إقرا النص",
        /* REASON */ null,
        /* RECENT_VISITS */ null,
        /* RECOMMENDED */ null,
        /* RECRUITMENT_MAIN_1 */ "يبدو أنك",
        /* RECRUITMENT_MAIN_1_2 */ "ليس",
        /* RECRUITMENT_MAIN_2 */ "مع أي وكالة",
        /* RECRUITMENT_MAIN_2_1 */ "عمل",
        /* RECRUITMENT_MAIN_3 */ "الحصول على توظيف من قبل الوكالات",
        /* RECRUITMENT_MAIN_4 */ "عن طريق ملء التطبيق",
        /* REFERRAL_CODE */ "كود الإحالة",
        /* REFER_ME */ "أحيلني!",
        /* REGISTRATION */ null,
        /* REGULAR_PAY */ null,
        /* REJECT */ "يرفض",
        /* REJECTED */ "مرفوض",
        /* REJECT_THIS_TASK */ null,
        /* REJECT_THIS_VISIT */ "رفض هذه الزيارة",
        /* REMAINED */ "بقي",
        /* REMAINING */ "متبقي",
        /* REMIND_ME_LATER */ "ذكرني لاحقا",
        /* REMOVE */ "يزيل",
        /* REMOVE_PAGE */ "إزالة الصفحة",
        /* REMOVE_TASK */ null,
        /* REOPENED */ null,
        /* REPLAY */ null,
        /* REQUEST */ "طلب",
        /* REQUESTED */ "مطلوب",
        /* REQUESTED_LABEL_IN_CASES_LIST */ "تسمية \"المطلوبة\" في قائمة الحالات.",
        /* REQUESTED_TIMES */ "أوقات مطلوبة",
        /* REQUESTED_VISIT_CANCEL_EXPLANATION */ null,
        /* REQUESTING_REFERENCE_RESPONSE */ null,
        /* REQUEST_AGENCIES_MEMBERSHIP */ "طلب عضوية الوكالات",
        /* REQUEST_AGENCY */ "وكالة طلب",
        /* REQUEST_AGENCY_MEMBERSHIP */ "طلب عضوية الوكالة",
        /* REQUEST_DETAILS */ "طلب تفاصيل",
        /* REQUEST_FOR_APPOINTMENT */ "طلب التعيين",
        /* REQUEST_FRIENDSHIP */ "طلب الصداقة",
        /* REQUEST_MORE_VISITS */ "طلب المزيد من الزيارات",
        /* REQUEST_MORE_VISITS_MESSAGE */ null,
        /* REQUEST_NUMBER_SHIFTS */ "طلب ٪ تحولات ٪ التحولات",
        /* REQUEST_SELECTED_SHIFT */ null,
        /* REQUEST_SELECTED_SHIFTS */ null,
        /* REQUEST_SHIFTS */ "طلب التحولات",
        /* REQUEST_SINGLE_SHIFT */ "طلب تحول واحد",
        /* REQUEST_THE_TIMES_YOU_WANT */ "اطلب الأوقات التي تريدها!",
        /* REQUEST_THIS_VISIT */ "اطلب هذه الزيارة",
        /* REQUEST_TO */ "طلب إلى",
        /* REQUEST_VISIT */ "طلب زيارة",
        /* REQUIRED */ "مطلوب",
        /* REQUIRED_DOCUMENTS */ "الوتائق المطلوبة",
        /* REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC */ "بعض الحقول المطلوبة في المستند مفقودة ، يرجى العودة وملءها",
        /* REQUIRED_PATIENT_DOCUMENT_TEXT */ "يجب عليك ملء المستندات التالية في هذه الزيارة",
        /* REQUIRED_TASKS */ "المهام المطلوبة",
        /* REQUIREMENTS */ null,
        /* RESCHEDULE */ "إعادة جدولة",
        /* RESCHEDULED_SUCCESSFULLY */ "إعادة جدولة بنجاح",
        /* RESCHEDULE_IN_THE_PAST_ERROR */ "لا يمكن إعادة جدولة زيارة لتكون في الماضي.",
        /* RESCHEDULE_REQUESTS */ "إعادة جدولة الطلبات",
        /* RESET_PIN_CODE_MESSAGE */ "سيتم نقلك إلى شاشة تسجيل الدخول لبدء عملية مصادقة جديدة",
        /* RESPIRATION_RATE */ "معدل التنفس",
        /* RESUBMISSION_BANNER_TITLE */ null,
        /* RETAKE */ "استعاد",
        /* RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION */ null,
        /* RETRY */ "إعادة المحاولة",
        /* REVIEW_PRIVACY_POLICY */ "عرض سياسة الخصوصية",
        /* REVIEW_TASK */ "مراجعة مهمة",
        /* REVIEW_TASKS */ "مراجعة مهام",
        /* RE_ENTER_YOUR_PIN_CODE */ "أعد إدخال رمز التعريف الشخصي الخاص بك",
        /* RN_FLEXIBLE_SHOWCASE_TEXT */ "زيارة مرنة",
        /* RN_FLEX_EXPLANATION_PREFIX */ "هذا ال",
        /* RN_FLEX_REQUESTED_EXPLANATION */ "سيُطلب منك تحديد التاريخ والوقت اللذين يناسبك",
        /* RN_FLEX_REQUESTED_EXPLANATION_LINE_2 */ "الإطار الزمني لأداء هذه الزيارة هو ما يلي",
        /* RN_PATIENT_CONTACT_EXPLANATION */ "هذه الزيارة تتطلب منك تنسيق وقت مع المريض.\n\nانقر فوق الزر الموجود في أسفل الشاشة للاتصال بالمريض.",
        /* RN_SIGN_HERE */ "علامة RN هنا",
        /* ROUTING_NUMBER */ null,
        /* ROUTING_NUMBR */ null,
        /* SAFETY_AND_HEALTH */ null,
        /* SAVE */ "يحفظ",
        /* SAVE_FOR_LATER */ null,
        /* SCAN_AND_UPLOAD_FILES */ "مسح الملفات وتحميلها",
        /* SCAN_A_PHOTO */ "مسح الصورة",
        /* SCAN_DOCUMENT */ "مسح المستندات",
        /* SCAN_NEW_DOCUMENT */ "مسح وثيقة جديدة",
        /* SCAN_WITH_CAMERA */ "مسح مع الكاميرا",
        /* SCHEDULE */ "جدول",
        /* SCHEDULED */ null,
        /* SCHEDULED_DATE */ null,
        /* SCHEDULED_FOR */ "المقرر ل",
        /* SCHEDULED_VISIT_COMPLETE */ "زيارة مجدولة الانتهاء",
        /* SCHEDULED_VISIT_NOT_FOUND */ "زيارة مجدولة لم يتم العثور عليها ، يرجى الاتصال بالوكالة",
        /* SCHEDULE_CONFIRMATION */ null,
        /* SCHEDULE_FOR */ null,
        /* SCHEDULE_TASK */ null,
        /* SCHEDULING_PROBLEM */ "مشكلة الجدولة",
        /* SCREENING */ "تحري",
        /* SCREENING_FOR */ "فحص:",
        /* SEARCH */ "يبحث",
        /* SEARCH_AGENCY */ "وكالة البحث",
        /* SEARCH_FOR_MEDICATIONS */ "ابحث عن الأدوية ...",
        /* SEARCH_NEARY_VISITS */ null,
        /* SEARCH_PATIENT */ null,
        /* SECOND_SHIFT */ "التحول الثاني",
        /* SECTION_ALREADY_COMPLETED */ null,
        /* SECTION_COMPLETED_PROMPT */ null,
        /* SECTION_LOCKED_PROMPT */ null,
        /* SEE_ALL */ null,
        /* SEE_ALL_CONVERSATIONS */ null,
        /* SEE_IN_MAPS */ null,
        /* SEE_LIST_OF_VISITS */ "انظر قائمة الزيارات",
        /* SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT */ "شاهد المزيد من المعلومات حول متطلبات التمثيل المسبق",
        /* SEE_YOUR_PROGRESS */ null,
        /* SELECT */ "يختار",
        /* SELECTED */ null,
        /* SELECTED_VISIT */ null,
        /* SELECT_ALL */ "حدد الكل",
        /* SELECT_CERTIFICATE */ "حدد الشهادة",
        /* SELECT_DATE */ "حدد تاريخ",
        /* SELECT_DATE_AND_TIME */ null,
        /* SELECT_DOCUMENT */ null,
        /* SELECT_DX_CODE */ "حدد رمز DX",
        /* SELECT_FROM_LIST */ null,
        /* SELECT_PERTINENT_DIAGNOSIS */ "حدد التشخيص ذي الصلة",
        /* SELECT_PHYSICIAN */ null,
        /* SELECT_PRINCIPAL_DIAGNOSIS */ "حدد التشخيص الرئيسي",
        /* SELECT_SHIFTS */ null,
        /* SELECT_START_TIME */ null,
        /* SELECT_SURGICAL_PROCEDURE */ "حدد العملية الجراحية",
        /* SELECT_TIME */ "حدد الوقت",
        /* SELECT_TIME_SLOT */ null,
        /* SELECT_TIME_SLOT_INFO */ null,
        /* SELECT_VISITS_FOR_INSTAPAY */ null,
        /* SELECT_VISIT_DURATION */ null,
        /* SELECT_YOUR_SCHEDULE */ null,
        /* SELFIE_WITH_PATIENT */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT */ null,
        /* SEND_A_MESSAGE */ null,
        /* SEND_EMAIL */ "ارسل بريد الكتروني",
        /* SEND_REPORT */ "إرسال تقرير",
        /* SEND_US_A_MAIL */ "مراسلتنا على البريد الاليكتروني",
        /* SEPTEMBER */ "سبتمبر",
        /* SETTINGS */ "إعدادات",
        /* SETTINGS_AND_INFO */ null,
        /* SET_DOCUMENT_EXPIRY_DATE */ "تعيين تاريخ انتهاء صلاحية المستند",
        /* SET_EXPIRATION_DATE */ "حدد تاريخ انتهاء الصلاحية",
        /* SET_YOUR_4_DIGIT_PIN_CODE */ "اضبط رمز الدبوس المكون من 4 أرقام",
        /* SHARE */ "شارك",
        /* SHARE_IDEAS_AND_GET_A_CHANCE */ "مشاركة الأفكار واحصل على فرصة",
        /* SHARE_REFERENCE_LINK */ null,
        /* SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP */ null,
        /* SHARE_WITH_YOUR_FRIENDS */ null,
        /* SHIFT */ "تحول",
        /* SHIFTS */ null,
        /* SHIFTS_DETAILS */ null,
        /* SHIFT_HAS_FINISHED_IN */ null,
        /* SHIFT_HAS_STARTED_IN */ null,
        /* SHOULD_BE_HERE */ "يجب أن يكون هنا",
        /* SHOW_ALL_TASKS */ null,
        /* SHOW_DETAILS */ null,
        /* SHOW_LESS */ "تظهر أقل",
        /* SHOW_ME_CASES_IN_THE_NEXT */ "أرني الحالات في التالي",
        /* SHOW_ME_IN */ "أرني في",
        /* SHOW_MORE */ "أظهر المزيد",
        /* SHOW_OLD_PLAN_OF_CARE */ "أظهر خطة الرعاية القديمة",
        /* SHOW_TASKS_THAT_REQUIRE_FIXES */ null,
        /* SHOW_US_YOUR_SMILE */ "أظهر لنا ابتسامتك! 😊",
        /* SIGNATURES */ null,
        /* SIGNATURE_REQUIRED */ "التوقيع المطلوب",
        /* SIGN_DECLINATION_FORM */ null,
        /* SIGN_HERE */ "وقع هنا",
        /* SIGN_IN */ "تسجيل الدخول",
        /* SIGN_ORIENTATION_VIDEO */ "الرجاء التوقيع هنا قبل تقديمها",
        /* SIGN_ORIENTATION_VIDEO_ERR */ "الرجاء التوقيع قبل التقديم",
        /* SIGN_OUT */ "خروج",
        /* SIGN_UP_FREE */ "الاشتراك مجانا",
        /* SIGN_UP_ITS_FREE */ "اشتراك. انه مجانا!",
        /* SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE */ null,
        /* SINGLE_FLEXIBLE_VISIT_EXPLANATION */ null,
        /* SINGLE_VISIT_DETAILS */ "تفاصيل زيارة واحدة",
        /* SINGLE_VISIT_FROM */ "زيارة واحدة من",
        /* SINGLE_VISIT_TYPE */ "زيارة واحدة",
        /* SIXTY_SECONDS_AND_YOU_ARE_DONE */ null,
        /* SKIP */ "تخطى",
        /* SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION */ null,
        /* SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS */ null,
        /* SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN */ null,
        /* SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES */ null,
        /* SLIDE_MAIN_INFO_GO_NEXT_SCREENS */ null,
        /* SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW */ null,
        /* SLIDE_STEP_X_OF_COUNT */ null,
        /* SMILE_FOR_US */ "ابتسم لنا! 📷",
        /* SOCIAL */ "اجتماعي",
        /* SOCIAL_MEDIA */ "وسائل التواصل الاجتماعي",
        /* SOMETHING_WENT_WRONG */ "هناك شئ خاطئ، يرجى المحاولة فى وقت لاحق",
        /* SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS */ null,
        /* SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM */ null,
        /* SOME_TASKS_NEED_FIXES */ null,
        /* SORRY */ null,
        /* SORT */ "نوع",
        /* SPECIFIC_DAYS */ "أيام محددة",
        /* SPEECH_RECOGNITION */ null,
        /* SPLIT_SHIFTS_VISIT */ "انقسام التحولات",
        /* SPREAD_THE_WORD */ "انشر الكلمة",
        /* STAGE_APPROVED_MESSAGE */ null,
        /* STAGE_AWAITING_APPROVAL */ null,
        /* STAGE_COMPLETED_MESSAGE */ null,
        /* STAGE_X_OF_TOTAL_STAGES */ null,
        /* START */ null,
        /* STARTING_AT */ "يبدأ من",
        /* STARTS */ "يبدأ",
        /* STARTS_NEXT_WEEK */ null,
        /* STARTS_TODAY_IN */ null,
        /* START_APPLICATION */ "ابدأ التطبيق",
        /* START_A_SURVEY */ "بدء المسح!",
        /* START_DATE */ "تاريخ البدء",
        /* START_FILLING */ null,
        /* START_NOW */ null,
        /* START_SHIFT */ null,
        /* START_TIME */ "وقت البدء",
        /* START_USING_MEDFLYT_PASSPORT */ "ابدأ في استخدام جواز سفر Medflyt",
        /* START_WATCHING */ null,
        /* START_WATCHING_ORIENTATION_VIDEOS */ null,
        /* START_WORKING */ null,
        /* STATUS */ "حالة",
        /* STAY_ON_TRACK */ null,
        /* STAY_ON_TRACK_1_ANSWER */ null,
        /* STAY_ON_TRACK_1_QUESTION */ null,
        /* STAY_ON_TRACK_2_ANSWER */ null,
        /* STAY_ON_TRACK_2_QUESTION */ null,
        /* STAY_ON_TRACK_3_ANSWER */ null,
        /* STAY_ON_TRACK_3_QUESTION */ null,
        /* STAY_ON_TRACK_4_ANSWER */ null,
        /* STAY_ON_TRACK_4_QUESTION */ null,
        /* STAY_ON_TRACK_DESCRIPTION */ null,
        /* STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS */ null,
        /* STAY_TUNED_FOR_MORE_VISITS */ "ترقبوا المزيد من الزيارات",
        /* STAY_TUNED_FOR_THE_NEXT_RAFFLE */ null,
        /* STILL_WAITING_REFERENCE_ANSWER */ null,
        /* STOP */ null,
        /* STREAK_BREAK */ null,
        /* STREAK_BREAK_MESSAGE */ null,
        /* STREAK_BREAK_MESSAGE_2 */ null,
        /* SUBMIT */ "إرسال",
        /* SUBMITTED_AT */ null,
        /* SUBMITTED_DOCUMENTS */ "الوثائق المقدمة",
        /* SUBMITTED_MANUALLY */ "قدم يدويًا",
        /* SUBMIT_AFTER */ "إرسال بعد",
        /* SUBMIT_AT */ "إرسال في",
        /* SUBMIT_BY */ "إرسال بواسطة",
        /* SUBMIT_DUTIES */ null,
        /* SUBMIT_DUTIES_BEFORE_CLOCK_OUT */ null,
        /* SUBMIT_FORM */ null,
        /* SUBMIT_FORMS */ null,
        /* SUBMIT_MANUAL_TIMESHEET */ null,
        /* SUBMIT_REQUIRED */ "إرسال مطلوب",
        /* SUBMIT_TEST */ "تقديم اختبار",
        /* SUBMIT_TIMESHEET */ null,
        /* SUBMIT_WITH_SCHEDULED_DATE */ "إرسال مع التاريخ المحدد",
        /* SUBMIT_WITH_TODAY_DATE */ "إرسال مع تاريخ اليوم",
        /* SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT */ null,
        /* SUBMIT_YOUR_SIGN */ "أرسل علامةك",
        /* SUBMIT_YOUR_SIGNATURE */ "أرسل توقيعك",
        /* SUCCESS */ "النجاح",
        /* SUCCESSFULLY_CLOCKED_IN */ null,
        /* SUCCESSFULLY_CLOCKED_OUT */ null,
        /* SUCCESSFULY_REQUESTED */ "طلب بنجاح!",
        /* SURGICAL_PROCEDURE */ "العملية الجراحية",
        /* SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS */ "قم بالتبديل إلى عرض القائمة لمشاهدة زياراتك المستوردة",
        /* SWITCH_VIEW */ "عرض التبديل",
        /* TAKE_A_DIFFERENT_PHOTO */ null,
        /* TAKE_A_PHOTO */ "التقاط صورة",
        /* TAKE_A_SURVEY */ "قم بإجراء مسح وفوز بفرصة للحصول على ملف",
        /* TAKE_ME_TO_CASE_SETTINGS */ "خذني إلى إعدادات العلبة",
        /* TAKE_PHOTO */ "تصوير",
        /* TAKE_THIS_TASK */ null,
        /* TAP_HERE_TO_VIEW */ "اضغط هنا لعرض",
        /* TAP_TO_CANCEL */ "اضغط على الإلغاء",
        /* TAP_TO_CHANGE_CASE_SETTINGS */ "اضغط لتغيير إعدادات الحالة",
        /* TASK */ null,
        /* TASKS */ null,
        /* TASK_ALREADY_ASSIGNED */ null,
        /* TASK_COMPLETED_SUCCESSFULLY */ "تهانينا - أكملت هذه المهمة.",
        /* TASK_INFORMATION */ null,
        /* TASK_SCHEDULED */ null,
        /* TASK_SCHEDULED_MESSAGE */ null,
        /* TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE */ null,
        /* TECHNICAL_SUPPORT */ "دعم فني",
        /* TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES */ "أخبرنا لماذا لا تهتم حتى نتمكن من إرسال حالات أفضل لك",
        /* TELL_US_YOUR_AGENY_DESCRIPTION */ "أخبرنا اسم وكالتك واسم المنسق وسنتواصل معهم لبث الحالات المفتوحة.",
        /* TEMPERATURE */ "درجة حرارة",
        /* TEN_DOLLAR_STARBUCKS_GIFT_CARD */ null,
        /* TERMINATED */ "إنهاء",
        /* TERMS_OF_MEDFLYT_PRIVACY_POLICY */ "شروط سياسة خصوصية Medflyt",
        /* TERMS_OF_USE */ "تعليمات الاستخدام",
        /* TEST */ "امتحان",
        /* TESTS */ "الاختبارات",
        /* TEST_COMPLETED */ "اختبار الانتهاء",
        /* TEST_FAILED */ "فشل الاختبار",
        /* TEST_REQUIRED */ "الاختبار المطلوب",
        /* THANKS */ null,
        /* THANK_YOU */ "شكرًا لك!",
        /* THANK_YOU_FOR_YOUR_FEEDBACK */ "شكرا لك على ملاحظاتك.",
        /* THATS_ME */ "هذا أنا",
        /* THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION */ null,
        /* THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS */ null,
        /* THERE_ARE_NO_AGENCIES_YET */ "لا توجد وكالات حتى الآن",
        /* THERE_ARE_NO_ASSIGNED_CASES */ null,
        /* THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION */ "هناك مشكلة في اتصال الإنترنت الخاص بك",
        /* THERE_SEEMS_TO_BE_NOTHING_HERE */ "يبدو أنه لا يوجد شيء هنا ...",
        /* THE_AWARDS_ARE_COMING_SOON */ null,
        /* THE_BEST_PLACE_FOR_CAREGIVERS */ null,
        /* THE_DUTY_SHEET_HAS_BEEN_SUBMITTED */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON */ null,
        /* THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS */ null,
        /* THE_NEXT_WINNERS_ANNOUNCEMENT */ "إعلان الفائز التالي",
        /* THE_SELECTED_DATE_IS_EARLIER_THAN */ null,
        /* THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS */ "يمكن إجراء الزيارة في الأيام التالية",
        /* THE_VISIT_HAS_NOT_STARTED_YET */ null,
        /* THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS */ null,
        /* THIS_BUNDLE_INCLUDES */ "هذه الحزمة تشمل",
        /* THIS_CONVERSATION_HAS_BEEN_RESOLVED */ null,
        /* THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK */ "تتكون هذه الدورة من ٪ دروس D. حظ سعيد!",
        /* THIS_FIELD_IS_CURRENTLY_DISABLED */ "هذا الحقل معاق حاليا.",
        /* THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT */ "هذه زيارة قديمة ، غير قادر على الساعة/خارج",
        /* THIS_IS_A_FUTURE_VISIT */ null,
        /* THIS_IS_A_LIVE_CLASS_SESSION */ "هذه جلسة فئة Live {مدة} ({date_time})",
        /* THIS_MAY_TAKE_UP_TO_X_SECONDS */ null,
        /* THIS_PATIENT_BELONGS_TO_AGENCY */ null,
        /* THIS_PATIENT_HAS_NO_PHONE_NUMBERS */ "هذا المريض ليس لديه أرقام هواتف",
        /* THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER */ "هذا السؤال يقرأ فقط. لا يُسمح لك بالرد.",
        /* THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP */ null,
        /* THIS_VISIT_CAN_BE_PERFORMED_BETWEEN */ "يمكن إجراء هذه الزيارة بين",
        /* THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE */ null,
        /* THIS_VISIT_IS_FOR_DIFFERENT_AGENCY */ null,
        /* THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET */ "هذه الزيارة في المستقبل ، لا يمكنك الدخول بعد",
        /* THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY */ null,
        /* THIS_WILL_MARK_THE_VISIT_AS_MISSED */ null,
        /* TIME */ "وقت",
        /* TIMESHEET_SUBMITTED */ null,
        /* TIME_ESTIMATION */ null,
        /* TIME_FRAME */ "إطار زمني",
        /* TIME_LEFT */ "الوقت المتبقي",
        /* TIME_VARIES */ "الوقت يختلف",
        /* TO */ "ل",
        /* TODAY */ "اليوم",
        /* TODAYS_DATE */ null,
        /* TOKENS */ null,
        /* TOO_MANY_HOURS */ "عدة ساعات",
        /* TOO_MANY_SHIFTS */ "الكثير من التحولات!",
        /* TOO_MANY_SHIFTS_MESSAGE */ "يُسمح لك بالتقاط ما يصل إلى ٪ maxshifts ٪ تحولات. إذا كنت ترغب في اختيار هذا التحول ، فسيتعين عليك إلغاء تحديد إحدى التحولات المحددة بالفعل.",
        /* TOP_CAREGIVERS_IN_YOUR_AREA */ "أفضل مقدمي الرعاية في منطقتك",
        /* TOTAL_EARNED */ null,
        /* TOTAL_SPENT */ null,
        /* TO_FILL_IN_A_FORM_INSTEAD */ null,
        /* TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT */ null,
        /* TO_SEE_THIS_TASK_GO_TO_ASSIGNED */ null,
        /* TO_SEE_THIS_VISIT_GO_TO */ "لرؤية هذه الزيارة تبحث عن",
        /* TO_UPLOAD_A_FILE_INSTEAD */ null,
        /* TO_WIN_AN_IPHONE12 */ "اربح iPhone 12",
        /* TRAINING */ "تمرين",
        /* TRAININGS_FOR */ "تدريبات ل",
        /* TRAINING_CENTER */ "مركز تدريب",
        /* TRAINING_CENTER_REMINDERS */ "تذكير مركز التدريب",
        /* TRY_AGAIN */ "حاول مرة أخري",
        /* TYPE_AGENCY_CODE */ "اكتب رمز الوكالة",
        /* TYPE_MESSAGE */ "اكتب الرسالة",
        /* TYPE_YOUR_ADDRESS */ "اكتب عنوانك",
        /* UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET */ null,
        /* UNANSWERED_LAST_SECTION_FOR_NOW */ null,
        /* UNAUTHORIZED */ "غير مصرح",
        /* UNAVAILABLE_LOCATION_SERVICES_MESSAGE */ null,
        /* UNDER_REVIEW */ null,
        /* UNDO */ "الغاء التحميل",
        /* UNIQUE_ERROR_CODE */ "رمز خطأ فريد",
        /* UNSCHEDULE */ null,
        /* UNSCHEDULE_TASK */ null,
        /* UNSPECIFIED */ "غير محدد",
        /* UNTIL */ "حتى",
        /* UPCOMING_VISITS */ null,
        /* UPDATED_AT */ null,
        /* UPDATE_INFORMATION */ null,
        /* UPLOAD */ "رفع",
        /* UPLOADED */ "تم الرفع",
        /* UPLOADED_FILE_VIEW */ null,
        /* UPLOADING */ "التحميل",
        /* UPLOAD_A_DOCUMENT */ null,
        /* UPLOAD_A_FILE */ null,
        /* UPLOAD_DOCUMENT */ "وثيقة تحميل",
        /* UPLOAD_DOCUMENTS */ "تحميل المستندات",
        /* UPLOAD_ERROR */ "خطأ في تحميل",
        /* UPLOAD_FILES_TO_ENSURE */ "تحميل الملفات للتأكد",
        /* UPLOAD_FLU_SHOT_DOCUMENT */ null,
        /* UPLOAD_FROM_GALLERY */ "تحميل من المعرض",
        /* UPLOAD_NEW_DOCUMENT */ null,
        /* UPLOAD_VIDEO */ null,
        /* UPLOAD_YOUR_FILES_TO_ENSURE */ "قم بتحميل ملفاتك للتأكد",
        /* UP_COMING_REASSESSMENTS */ "إعادة تقييم القادمة",
        /* UP_TO */ null,
        /* URGENT */ null,
        /* USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY */ "تم قفل هذا المستخدم بسبب النشاط المشبوه",
        /* VALID */ "صالح",
        /* VERIFIED */ "تم التحقق",
        /* VERIFY */ "تحقق",
        /* VERIFYING */ "التحقق",
        /* VERIFY_YOUR_LOCATION */ null,
        /* VERY_URGENT */ "عاجل جدا",
        /* VIDEO */ "فيديو",
        /* VIDEOS */ "أشرطة فيديو",
        /* VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION */ "تتطلب مقاطع الفيديو في مركز التدريب انتباهك.",
        /* VIDEO_COMPLETED_SUCCESSFULLY */ "تهانينا - أكملت مشاهدة الفيديو.",
        /* VIEW */ "رأي",
        /* VIEWED */ "عرض",
        /* VIEW_ALL */ null,
        /* VIEW_ANSWERS */ null,
        /* VIEW_CERTIFICATE */ "عرض الشهادة",
        /* VIEW_TASK */ null,
        /* VIEW_TASKS_PENDING_FOR_SCHEDULE */ "عرض المهام المعلقة للجدول الزمني",
        /* VIEW_VISIT */ null,
        /* VIRTUAL_ID_CARD */ null,
        /* VISIT */ "زيارة",
        /* VISITS */ "زيارات",
        /* VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER */ null,
        /* VISITS_NEXT_MONTH */ null,
        /* VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* VISITS_PER_WEEK */ "زيارات في الأسبوع",
        /* VISITS_WITH_ISSUES */ null,
        /* VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE */ "تم تعيين الزيارة ، تحقق من ذلك في جدولك الزمني",
        /* VISIT_BY */ "زيارة",
        /* VISIT_CHAT */ "قم بزيارة الدردشة",
        /* VISIT_COMPLETE */ null,
        /* VISIT_COMPLETED_SUCCESSFULLY */ null,
        /* VISIT_COUNTS */ null,
        /* VISIT_COUNTS_DESCRIPTION */ null,
        /* VISIT_DATE */ "زيارة التاريخ",
        /* VISIT_DATES */ null,
        /* VISIT_DETAILS */ "زيارة التفاصيل",
        /* VISIT_DURATION */ null,
        /* VISIT_INFORMATION */ null,
        /* VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU */ null,
        /* VISIT_LASTING */ "زيارة دائمة",
        /* VISIT_NEXT_MONTH */ null,
        /* VISIT_NOTIFICATIONS_OFF */ "زيارة الإخطارات - قبالة",
        /* VISIT_NOTIFICATIONS_ON */ "زيارة الإخطارات - على",
        /* VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE */ "لم تسجل في هذه الزيارة بعد. هل أنت متأكد أنك تريد الساعة؟",
        /* VISIT_NO_LONGER_AVAILABLE */ "الزيارة لم تعد متوفرة",
        /* VISIT_RATE_REQUEST_CONFIRMATION */ null,
        /* VISIT_REMINDERS */ null,
        /* VISIT_REQUEST_CONFIRMATION_WARNING */ null,
        /* VISIT_SCHEDULE */ null,
        /* VISIT_STARTED_AT */ null,
        /* VISIT_STARTED_MISSING_CLOCK_IN */ null,
        /* VISIT_STARTS_AT */ null,
        /* VISIT_SUCESSFULLY_CANCELED */ "زيارة تم إلغاؤها بنجاح",
        /* VISIT_TIME_ADJUSTMENT */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_EARLY */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_LATE */ null,
        /* VISIT_TOO_SHORT */ null,
        /* VISIT_TYPE */ null,
        /* VISIT_WITH */ null,
        /* VOUCHER */ null,
        /* WAITING_FOR_APPROVAL */ "بانتظار الموافقة",
        /* WAITING_TO_BE_SCHEDULED */ "في انتظار أن تكون مجدولة",
        /* WARNING */ "تحذير!",
        /* WAS_DUE_BETWEEN */ null,
        /* WAS_DUE_ON */ null,
        /* WATCHED */ "مشاهدة",
        /* WATCH_HOW_IT_WORKS */ "شاهد كيف يعمل",
        /* WATCH_REQUIRED */ "شاهد مطلوب",
        /* WATCH_TRAINING_VIDEOS_TO_COMPLETE */ null,
        /* WEEKLY_DETAILS */ null,
        /* WELCOME */ "أهلا بك",
        /* WELCOME_BACK */ "مرحبًا بعودتك",
        /* WELCOME_TO_CARE_MOMENTS */ null,
        /* WELCOME_TO_MEDFLYT */ "مرحبًا بك في Medflyt!",
        /* WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE */ null,
        /* WELL_BE_IN_TOUCH_SHORTLY */ "سنكون على اتصال قريب.",
        /* WERE_YOU_REFERRED_BY_SOMEONE */ "هل تمت إحالتك من قبل شخص ما؟",
        /* WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM */ null,
        /* WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR */ "لم نتمكن من العثور على الدواء الذي تبحث عنه",
        /* WE_COULDNT_FIND_YOUR_AGENCY */ "لم نتمكن من العثور على وكالتك!",
        /* WE_GOT_YOUR_CONFIRMATION */ null,
        /* WE_GOT_YOUR_RESPONSE_WAIT_HH_MM */ null,
        /* WE_HAVE_ONE_MATCHING_ACCOUNT */ "لقد وجدنا حساب واحد مطابق بناءً على التفاصيل التي قدمتها. هل هذا أنت؟",
        /* WE_HAVE_X_MATCHING_ACCOUNTS */ "هل هناك فرصة أن تكون أحد الحسابات التالية؟",
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT */ null,
        /* WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT */ "لم نتمكن من تسجيل الدخول إليك. يرجى الاتصال بـ Medflyt Support",
        /* WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON */ null,
        /* WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE */ "يا لها من صورة جميلة! هل يجب أن نستمر؟",
        /* WHAT_BENEFITS_CAN_YOU_GET */ null,
        /* WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK */ null,
        /* WHAT_WOULD_YOU_LIKE_TO_DO_FIRST */ null,
        /* WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT */ "كلما رأيت زيارة مرنة ، ستتمكن من طلب الأوقات التي تناسبك",
        /* WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR */ null,
        /* WHOOPS */ "يصيح",
        /* WHOS_THE_LUCKY_ONE */ null,
        /* WILL_BEGIN_SHORTLY */ "سيبدأ قريبا",
        /* WILL_EXPIRE_IN_DAYS */ null,
        /* WILL_EXPIRE_TOMORROW */ null,
        /* WINNER_ANNOUNCED_IN */ null,
        /* WITH_CAREGIVERS */ "مع مقدمي الرعاية",
        /* WORKING_WITH_AGENCY */ "أنا أعمل مع وكالة",
        /* WRONG_DATES_SELECTION */ "اختيار التواريخ الخاطئة",
        /* WRONG_PHONE_NUMBER */ "رقم هاتف خاطئ",
        /* WRONG_PIN */ "دبوس الخطأ",
        /* X_DAYS_SELECTED */ null,
        /* X_DAYS_TO_COMPLETE */ "٪ D أيام لإكمالها",
        /* X_DAYS_TO_SELECT */ null,
        /* X_HOURS_SELECTED */ null,
        /* X_HOURS_TO_SELECT */ null,
        /* YAY_YOU_WERE_ASSIGNED_TO_A_VISIT */ null,
        /* YEAR */ "سنة",
        /* YEARS_OLD */ null,
        /* YES */ "نعم",
        /* YES_ADJUST_TIMES */ null,
        /* YES_DELETE */ null,
        /* YES_I_AM_SURE */ null,
        /* YES_OVERRIDE_FORM */ null,
        /* YES_REQUEST_ANYWAY */ null,
        /* YES_SCHEDULE_VISIT */ null,
        /* YES_THATS_ME */ "نعم أنه أنا",
        /* YES_UPDATE_ALL */ null,
        /* YOURE_ALL_DONE_LETS_GET_YOU_WORKING */ null,
        /* YOURE_IN_THE_RAFFLE */ null,
        /* YOURE_NOT_IN_THE_RAFFLE */ null,
        /* YOURSELF */ "نفسك",
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD */ null,
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE */ null,
        /* YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS */ "قد لا تكون وكالتك قد قمت بتعيين دروس لك. الرجاء المحاولة لاحقًا.",
        /* YOUR_ANSWER_IS_CORRECT */ "إجابتك صحيحة!",
        /* YOUR_ANSWER_IS_INCORRECT */ "إجابتك غير صحيحة",
        /* YOUR_COMPLIANCE */ "امتثالك",
        /* YOUR_COMPLIANCE_ITEM_HAS_EXPIRED */ null,
        /* YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS */ null,
        /* YOUR_FILE_IS_BEING_UPLOADED */ "يتم تحميل ملفك",
        /* YOUR_IN_SERVICE_IS_DUE_IN_DAYS */ null,
        /* YOUR_IN_SERVICE_IS_OVER_DUE */ null,
        /* YOUR_MOBILE */ "هاتفك النقال",
        /* YOUR_REFERERAL_CODE */ "رمز الإحالة الخاص بك",
        /* YOUR_TASK_HAS_BEEN_SCHEDULED_FOR */ null,
        /* YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY */ null,
        /* YOUVE_BEEN_SUCCESSFULLY_REFERRED */ "لقد تمت إحالتك بنجاح!",
        /* YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "لقد أكملت جميع الدروس في الوقت الحالي",
        /* YOU_ALREADY_FAILED */ "لقد فشلت بالفعل في الاختبار.",
        /* YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT */ "لديك بالفعل زيارة مجدولة لتلك الفتحة الزمنية",
        /* YOU_ALREADY_REQUESTED_THIS_VISIT */ null,
        /* YOU_ALREADY_SUCCEEDED */ "لقد نجحت بالفعل الاختبار.",
        /* YOU_ARE_ALL_SET */ null,
        /* YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION */ null,
        /* YOU_ARE_COMPLIANT */ null,
        /* YOU_ARE_EXEMPT_FROM_THIS_TEST */ "أنت معفاة من هذا الاختبار",
        /* YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD */ "لا يُسمح لك بتحرير هذا الحقل.",
        /* YOU_ARE_NOT_COMPLIANT */ null,
        /* YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM */ null,
        /* YOU_ARE_OUT_OF_COMPLIANCE */ null,
        /* YOU_ARE_X_DAYS_LATE */ "أنت ٪ D متأخرة.",
        /* YOU_CANNOT_EDIT_YOUR_ANSWERS */ null,
        /* YOU_CANT_EDIT_VISIT_WITH_CICO */ null,
        /* YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES */ "لا يمكن أن يكون لديك أكثر من تشخيصات رئيسية أو جراحية.",
        /* YOU_CANT_SIGN_BEFORE_ALL_ANSWERED */ null,
        /* YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE */ "لا يمكنك استخدام رمز ICD نفسه أكثر من مرة.",
        /* YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME */ null,
        /* YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED */ "يمكنك الاتصال بالمريض إذا لزم الأمر",
        /* YOU_CAN_CONTINUE_TO_NEXT_SECTION */ null,
        /* YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY */ null,
        /* YOU_DIDNT_ANSWER_ALL_QUESTIONS */ null,
        /* YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN */ "لم تدخل نفس رمز التعريف الشخصي. حاول مرة اخرى.",
        /* YOU_DONT_HAVE_ANY_CASES_YET */ null,
        /* YOU_DONT_HAVE_ANY_PATIENTS_YET */ null,
        /* YOU_GET_POINTS */ null,
        /* YOU_GOT_THE_CASE */ null,
        /* YOU_GOT_THE_CERTIFICATE */ "حصلت على الشهادة!",
        /* YOU_HAVENT_CLOCKED_IN_YET */ "لم تسجل بعد ذلك بعد",
        /* YOU_HAVENT_CLOCKED_OUT_YET */ "أنت لم تسجل بعد",
        /* YOU_HAVENT_UPLOADED_ANYTHING_YET */ "لم تقم بتحميل أي شيء بعد",
        /* YOU_HAVE_COMPLETED_THIS_TEST */ "لقد أكملت هذا الاختبار",
        /* YOU_HAVE_HH_MM_TO_CONFIRM_IT */ null,
        /* YOU_HAVE_MISSING_COMPLIANCE_ITEMS */ null,
        /* YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW */ null,
        /* YOU_HAVE_NOT_WATCHED */ "أنت لم تشاهد",
        /* YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY */ "ليس لديك محاولات متبقية. يرجى الاتصال بوكلك",
        /* YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS */ null,
        /* YOU_HAVE_ONE_ATTEMPT_LEFT */ "لقد تركت محاولة واحدة",
        /* YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING */ "لديك يوم واحد لإكمال هذا التدريب!",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION */ null,
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING */ "لقد أكملت هذا التدريب بنجاح 🚀",
        /* YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY */ "عليك أن تكمل هذا التدريب اليوم. أسرع - بسرعة!",
        /* YOU_HAVE_TO_ENROLL_FIRST */ "لمشاهدة هذا الدرس ، عليك التسجيل أولاً",
        /* YOU_HAVE_TO_PICK_A_CODE */ "عليك اختيار رمز.",
        /* YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_LEFT */ "لديك ٪ d محاولات ترك",
        /* YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST */ "لديك ٪ d محاولات الإجابة على هذا الاختبار",
        /* YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y */ "لديك ٪ d الإجابات الصحيحة من ٪ د",
        /* YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING */ "لديك ٪ D أيام لإكمال هذا التدريب!",
        /* YOU_JUST_GOT_PAID */ null,
        /* YOU_JUST_GOT_PROMOTED_TO */ null,
        /* YOU_LOSE_POINTS */ null,
        /* YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS */ "يمكنك تغيير إعدادات زيارتك لتلقي المزيد من الزيارات ذات الصلة",
        /* YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE */ "لا يجوز لك الإجابة على الاختبار بسبب",
        /* YOU_MAY_ONLY_SUBMIT_AFTER */ "لا يجوز لك تقديمها إلا بعد الانتهاء",
        /* YOU_MISSED_A_SHIFT_WITHOUT_NOTICE */ null,
        /* YOU_MUST_ANSWER_ALL_THE_QUESTIONS */ "يجب أن تجيب على جميع الأسئلة.",
        /* YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT */ null,
        /* YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST */ "يجب عليك مشاهدة مقاطع الفيديو السابقة أولاً",
        /* YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION */ null,
        /* YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE */ null,
        /* YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT */ null,
        /* YOU_RECENTLY_WON_A_RAFFLE */ null,
        /* YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT */ null,
        /* YOU_USED_THE_CODE */ "لقد استخدمت الرمز",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE */ null,
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS */ null,
        /* YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS */ null
    ],
    "en": [
        /* ACCEPTED */ "Accepted",
        /* ACCEPT_THESE_HOURS */ "Accept these hours",
        /* ACCEPT_THE_VISIT_AT */ "Accept the visit at",
        /* ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY */ "Account information updated successfully",
        /* ACCOUNT_NUMBER */ "Account Number",
        /* ACCOUNT_TYPE */ "Account Type",
        /* ACTIVE */ "Active",
        /* ACTIVE_DOCUMENT */ "Active Document",
        /* ADD */ "Add",
        /* ADDITIONAL_NOTES */ "Additional notes..",
        /* ADDRESS */ "Address",
        /* ADDRESS2 */ "Address line 2",
        /* ADDRESS_ERROR */ "Address error",
        /* ADDRESS_IS_NEAR */ "Address is near",
        /* ADD_ANOTHER_DOCUMENT */ "Add another document",
        /* ADD_ANOTHER_PERTINENT_DIAGNOSIS */ "Add another pertinent diagnosis",
        /* ADD_IMAGE */ "Add image",
        /* ADD_NEW_MEDICATION */ "Add new medication",
        /* ADD_NOTES */ "Add Notes",
        /* ADD_NOTE_TO_PATIENT_PROFILE_BUTTON */ "Add a note to the patient profile",
        /* ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE */ "There was problem adding your note",
        /* ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER */ "Enter note",
        /* ADD_NOTE_TO_PATIENT_PROFILE_TITLE */ "Add a note to the patient profile",
        /* ADD_PHYSICIAN */ "Add Physician",
        /* ADD_YOUR_SIGNATURE */ "Add your signature",
        /* ADVANCED_DIRECTIVES */ "Advanced Directives",
        /* AGENCIES_CONTACT */ "Agencies will contact you shortly",
        /* AGENCY */ "Agency",
        /* AGENCY_CODE */ "Agency code",
        /* AGENCY_COORDINATOR */ "Agency coordinator",
        /* AGENCY_DETAILS */ "Agency details",
        /* AGENCY_HANDBOOK */ "Agency handbook",
        /* AGENCY_ISSUES */ "There are issues on this visit that prevent it from being eligible, contact the agency for assistance",
        /* AGENCY_NAME */ "Agency name",
        /* AGENCY_NOTIFICATIONS */ "Agency Notifications",
        /* AGENCY_NOT_FOUND */ "Agency not found",
        /* AGREE_TO_MEDFLYT_TERMS */ "By clicking Approve, you agree you have read and agree to the Terms of Meflyt Privacy Policy",
        /* AIDE */ "Aide",
        /* AIRPODS */ "Airpods",
        /* ALLERGIES */ "Allergies",
        /* ALLOW_ACCESS_TO_MY_LOCATION */ "Allow access to my location",
        /* ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP */ "In order to see cases near you, please go to your phone settings and give medflyt permission to access your location.",
        /* ALL_CHANGES_SAVED */ "All changes saved",
        /* ALL_DAY */ "all day",
        /* ALL_DONE */ "All done!",
        /* ALL_TRANSACTIONS */ "All Transactions ({TRANSACTIONS_COUNT})",
        /* ALL_VERIFIED_ITEMS */ "All verified items",
        /* ALREADY_CLOCKED_IN */ "Already clocked in.",
        /* ALREADY_CLOCKED_IN_ANOTHER_VISIT */ "You are already clocked in another visit.",
        /* ALREADY_CLOCKED_OUT */ "Already clocked out.",
        /* ALREADY_HAVE_AN_ACCOUNT */ "Already have an account",
        /* AND_AMPERSAND */ "&",
        /* ANSWERED */ "Answered",
        /* ANSWERED_AT */ "Answered at",
        /* ANSWER_INCOMPLETE_QUESTIONS */ "Answer incomplete questions",
        /* ANY_DURATION */ "any duration",
        /* AN_ERROR_HAS_OCCURED */ "An error has occured.",
        /* AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET */ "An error occurred while submitting your timesheet.",
        /* APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES */ "Apple is not involved in any way with the contest or sweepstakes",
        /* APPLICATION_DONE */ "Application Done!",
        /* APPROVE */ "Approve",
        /* APPROVED */ "Approved",
        /* APPROVE_THIS_TASK */ "Approve this task",
        /* APPROVE_THIS_VISIT */ "Approve this visit",
        /* APRIL */ "April",
        /* ARENT_YOU_MISSING_SOMETHING */ "Aren’t You Missing Something?",
        /* ARE_YOU */ "Are you",
        /* ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY */ "Are you currently working with an agency?",
        /* ARE_YOU_SURE */ "Are Your Sure?",
        /* ARE_YOU_SURE_REQUEST_FAR_VISIT */ "Are you sure you will be able to attend this visit?",
        /* ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK */ "Are you sure you want to approve this task?",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST */ "Are you sure you want to cancel this request?",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT */ "Are you sure you want to cancel this visit?",
        /* ARE_YOU_SURE_YOU_WANT_TO_DELETE */ "Are you sure you want to delete",
        /* ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE */ "Are you sure you want to enroll this bundle?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT */ "Are you sure you want to remove this document?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE */ "Are you sure you want to remove this page?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE */ "Are you sure you want to request these",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT */ "Are you sure you want to request this visit?",
        /* ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT */ "Are you sure you want to sign out?",
        /* ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK */ "Are you sure you want to take this task?",
        /* ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK */ "Are you sure you want to unschedule this task",
        /* ASSIGNED */ "Assigned",
        /* ASSIST */ "Assist",
        /* AS_NEEDED */ "As needed",
        /* AS_REQUESTED_BY_THE_PATIENT */ "As requested by the patient",
        /* ATTACH_A_DOCUMENT */ "Attach a document",
        /* AUGUST */ "Augusy",
        /* AUTHENTICATION_FAILED */ "Authentication failed",
        /* AUTH_VERIFICATION_FAIL_EXAPLINED */ "We couldn’t verify your identity. Please reach out to one of your agencies for assistance.",
        /* AUTOPLAY */ "The next item will start in",
        /* AVAILABILITY */ "Availability",
        /* AVAILABLE */ "Available",
        /* AVAILABLE_CARE_POINTS */ "Available Care points",
        /* AVAILABLE_ON_THE_FOLLOWING_DAYS */ "Available on the following days",
        /* AVAILABLE_SHIFTS */ "Available shifts",
        /* AVAILABLE_VISITS */ "Available Visits",
        /* AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK */ "Avoid missed visits to keep your rank",
        /* AWAITING_PATIENT_CONTACT */ "Awaiting contact",
        /* A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT */ "A plan of care already exists for this patient",
        /* A_VERIFICATION_CODE_IS_BEING_SENT_TO */ "A verification code is being sent to",
        /* A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE */ "A verification code will be sent to you via text message",
        /* A_VISIT_BY */ "A visit by",
        /* BACK */ "Back",
        /* BACK_TO_ONBOARDING */ "Back to onboarding",
        /* BANK_INFORMATION */ "Bank Information",
        /* BANK_NAME */ "Bank Name",
        /* BASICALLY_EVERY_ACTION_COUNTS */ "Basically every action counts 😊",
        /* BEFORE_SUBMITTING_THE_DUTIES */ "Before submitting the duties",
        /* BEGIN_NOW */ "Begin now",
        /* BEST_TASK_FOR_YOU */ "Best task for you",
        /* BETWEEN */ "between",
        /* BETWEEN_AND */ "and",
        /* BIRTHDAY */ "Birthday",
        /* BLOOD_PRESSURE */ "Blood Pressure",
        /* BOROUGH */ "Borough",
        /* BUNDLES */ "Bundles",
        /* BUNDLE_DESCRIPTION */ "This bundle will walk you through about anything you need to know about {bundle_name} from {agency_name}.",
        /* BUNDLE_DESCRIPTION_P1 */ "This bundle consists of",
        /* BUNDLE_DESCRIPTION_P2 */ "items. Some items might also include a test. Please watch the required content. Once you complete the required task you will receive a certificate. Good luck",
        /* BUNDLE_IS_LOCKED */ "Bundle is locked",
        /* BUNDLE_ITEM_NOT_FOUND */ "Training lesson not found",
        /* BUNDLE_NOT_FOUND */ "Training course not found",
        /* BUNDLE_PROGRESS */ "Bundle Progress",
        /* BUSY_ALL_DAY */ "Busy all day",
        /* BY */ "By",
        /* BY_ENROLLING_I_ACCEPT_THE */ "By enrolling I accept the",
        /* BY_EXISTING_VISIT */ "By existing visit:",
        /* BY_PATIENT_NAME */ "By patient name:",
        /* BY_SIGNING_HERE_I_ACCEPT_THE */ "By signing here I accept the",
        /* CALL */ "Call",
        /* CALL_AGENCY */ "Call agency",
        /* CALL_HOME */ "Call home",
        /* CALL_MOBILE */ "Call mobile",
        /* CALL_NOW */ "Call now:",
        /* CALL_PATIENT */ "Call patient",
        /* CALL_PATIENT_CONFIRMATION */ "This visit with {{patientName}} is planned for {{dateTime}} and is less than {{hours}} hours away.\n\nPlease confirm with the patient to ensure this time works before finalizing the schedule.",
        /* CALL_PATIENT_EXPLANATION */ "You will recieve a call a few moments after confirming this message.",
        /* CALL_PATIENT_HOME */ "Call patient's home",
        /* CALL_PATIENT_MOBILE */ "Call patient's mobile",
        /* CALL_PATIENT_NOTE */ "Contact patient in the next screen",
        /* CALL_SUPPORT_FOR_MORE_INFO */ "Call support for more info",
        /* CANCEL */ "Cancel",
        /* CANCEL_REQUESTED_SHIFTS */ "Cancel Requested Shifts",
        /* CANCEL_VISIT */ "Cancel visit",
        /* CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE */ "You cannot edit your answers in read only mode.",
        /* CANT_CANCEL_24_HOURS_SCHEDULED_VISIT */ "Error: Visit is less than 24 hours away",
        /* CANT_CANCEL_AT_THIS_TIME */ "Can't cancel at this time",
        /* CANT_CLOCK_IN */ "Can't clock in",
        /* CANT_CLOCK_IN_AT_THIS_TIME */ "Can't clock in at this time.",
        /* CANT_CLOCK_OUT */ "Can't clock out",
        /* CANT_CLOCK_OUT_AT_THIS_TIME */ "Can't clock out at this time.",
        /* CANT_CLOCK_OUT_BEFORE_VISIT_ENDED */ "Can't clock out before the visit has ended.",
        /* CANT_REJECT_VISIT_PENDING_STATUS */ "You can't reject visits yet. Please complete the registration process",
        /* CANT_REQUEST_JOIN_AGENCY */ "Can't request to join agency",
        /* CANT_REQUEST_VISIT_PENDING_STATUS */ "You can't request visits yet. Please complete the registration process",
        /* CANT_SUBMIT_AN_EMPTY_FORM */ "Cant submit an empty form, please answer the questions.",
        /* CANT_WATCH_ON_SHIFT */ "This training is disabled during all shifts 👀",
        /* CANT_WATCH_THIS_VIDEO */ "Can't Watch this Video",
        /* CAREBACK_CASH_BONUS */ "CareBack - cash bonus!",
        /* CAREBACK_POINTS */ "Careback Points",
        /* CAREGIVER */ "Caregiver",
        /* CAREGIVER_COMPLIANCE_PASSPORT */ "Caregiver Compliance Passport",
        /* CAREGIVER_NAME */ "Caregiver name",
        /* CAREGIVER_PHONE */ "Caregiver phone",
        /* CAREGIVER_SIGNATURE */ "Caregiver signature",
        /* CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG */ "Please make sure both you and the patient have signed the plan of care",
        /* CAREGIVER_SIGNATURE_IS_REQUIRED */ "Caregiver signature is required",
        /* CAREGIVER_SIGNATURE_REQUIRE_MSG */ "Please make sure you sign on the plan of care",
        /* CAREGIVER_STATUS_PENDING_ERROR */ "Unable to perform action because your profile is still pending.",
        /* CARE_MOMENTS */ "Care Moments",
        /* CASE_INFO */ "Case info",
        /* CASE_IS_TOO_FAR */ "Case is too far",
        /* CASE_SETTINGS */ "Case Settings",
        /* CATALOGUE */ "Catalogue",
        /* CERTIFICATION */ "Certification",
        /* CERTIFICATIONS */ "Certifications",
        /* CHANGE */ "Change",
        /* CHANGES_TO_MY_VISITS */ "Changes to My Visits",
        /* CHANGES_WERE_SAVED_IN_THE_CLOUD */ "All changes were saved in the cloud",
        /* CHANGE_DOCUMENT */ "Change document",
        /* CHANGE_OF_RANKING */ "Change of Ranking",
        /* CHANGE_PHONE_NUMBER */ "Change Phone Number",
        /* CHANGE_SETTINGS */ "Change settings",
        /* CHANGE_SHIFTS */ "Change Shifts",
        /* CHANGE_TASK_TIME */ "Change Task Time",
        /* CHANGE_VISIT_TIMES */ "Change visit times",
        /* CHAT */ "Chat",
        /* CHATS */ "Chats",
        /* CHAT_MESSAGES */ "Chat Messages",
        /* CHAT_NOT_ACTIVE_MESSAGE */ "You can't send messages here.",
        /* CHAT_NOT_ACTIVE_TITLE */ "Chat is no longer active",
        /* CHAT_WITH_AGENCY */ "Chat with agency",
        /* CHAT_WITH_AGENCY_ABOUT_PATIENT */ "Chat with %s about %s",
        /* CHAT_WITH_MEDFLYT */ "Chat with Medflyt",
        /* CHAT_WITH_OTHER_AGENCIES */ "Chat With Other Agencies",
        /* CHAT_WITH_SUPPORT */ "Chat with Support",
        /* CHAT_WITH_US */ "Chat with us",
        /* CHECK */ "Check",
        /* CHECK_AGAIN */ "Check location again",
        /* CHOOSE_ANOTHER_DATE */ "Choose another date",
        /* CHOOSE_A_PHOTO */ "Choose a photo",
        /* CHOOSE_A_TIME_FOR_THE_VISIT */ "Choose a time for the visit",
        /* CHOOSE_CLOCK_TIMES */ "Choose clock times",
        /* CHOOSE_DATE_TO_PERFORM_THIS_TASK */ "Choose date to perform this task",
        /* CHOOSE_FOLDER_TO_UPLOAD */ "Choose folder to upload",
        /* CHOOSE_START_TIME */ "Choose start time",
        /* CHOOSE_THE_HOURS */ "Next (Choose the hours)",
        /* CHOOSE_TIME */ "Choose time",
        /* CHOOSE_WHEN_TO_PERFORM_THE_VISIT */ "Choose when to perform the visit",
        /* CHOOSE_WHEN_TO_VISIT_THE_PATIENT */ "Choose when to visit the patient",
        /* CHOOSE_WHO_TO_CONTACT */ "Choose who to contact",
        /* CHOOSING_A_WINNER */ "Choosing a winner",
        /* CHOOSING_A_WINNER_IN */ "Choosing a winner in",
        /* CLEAR */ "Clear",
        /* CLICK_HERE */ "click here",
        /* CLICK_HERE_TO_DOWNLOAD */ "Click here to download",
        /* CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE */ "Click here to share your referral code",
        /* CLICK_HERE_TO_VIEW_CERTIFICATE */ "CLICK HERE TO VIEW CERTIFICATE",
        /* CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE */ "Congratulations on your first Certificate 🏆🏆! click on it to view your new certificate",
        /* CLICK_TO_REQUEST */ "Click to request!",
        /* CLICK_TO_SCAN_UPLOAD */ "Click to scan & upload",
        /* CLICK_TO_TAKE_A_SELFIE */ "Click to take a selfie",
        /* CLIMB_THE_RANKS_BY_COMPLETING_VISITS */ "Climb the ranks by completing visits",
        /* CLINICAL_SUPPORT */ "Clinical Support",
        /* CLOCKED_IN */ "Clocked in",
        /* CLOCKED_IN_AND_OUT */ "Clocked in & out",
        /* CLOCKED_IN_AT */ "Clocked in at",
        /* CLOCKED_OUT */ "Clocked Out",
        /* CLOCKED_OUT_AT */ "Clocked out at",
        /* CLOCKING_IN */ "Clocking in...",
        /* CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES */ "Clocking in not in time causes issues",
        /* CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES */ "Clocking in / out not in the visit’s location can cause issues",
        /* CLOCKING_OUT */ "Clocking out...",
        /* CLOCK_ADDRESS_IN_RANGE */ "Clock {CLOCK_TYPE} address is in range",
        /* CLOCK_ADDRESS_NOT_IN_RANGE */ "Clock {CLOCK_TYPE} address is not in range",
        /* CLOCK_IN */ "Clock In",
        /* CLOCK_IN_ANYWAY */ "Clock in anyway",
        /* CLOCK_IN_AT */ "Clock in at",
        /* CLOCK_IN_BETWEEN */ "Clock in between",
        /* CLOCK_IN_OUT */ "Clock in / out",
        /* CLOCK_IN_OUT_SUBMIT_DUTIES */ "Clock In / Out and Submit Duties",
        /* CLOCK_IN_TIME_IS_REQUIRED */ "Clock in time is required",
        /* CLOCK_OUT */ "Clock Out",
        /* CLOCK_OUT_AFTER */ "Clock out after",
        /* CLOCK_OUT_AT */ "Clock out at",
        /* CLOCK_OUT_BETWEEN */ "Clock out between",
        /* CLOCK_OUT_TIME_IS_REQUIRED */ "Clock out time is required",
        /* CLOCK_TIMES_NOT_MOBILE */ "Looks like one of the clock in or out wasn’t done through the mobile app",
        /* CLOCK_TIME_IN_RANGE */ "Clock {CLOCK_TYPE} time is in range.",
        /* CLOCK_TIME_NOT_IN_RANGE */ "Clock {CLOCK_TYPE} time is not in range.",
        /* CLOSE */ "Close",
        /* CLOSE_SURVEY */ "Close survey",
        /* CLUSTERED_VISIT_EXPLENATION */ "We detected that these 2 visits are close together and fit your daily schedule. We recommend to request both of these visits together. You may also request each of the visits individually",
        /* CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE */ "Code not found, please use another one",
        /* COMBINED_CASE */ "Combined case",
        /* COMING_SOON */ "Coming soon",
        /* COMPLETED */ "Completed",
        /* COMPLETED_DOCUMENTS */ "Completed Documents",
        /* COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL */ "Complete all the documents before payroll",
        /* COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS */ "Complete more shifts to earn more tokens and increase your chance!",
        /* COMPLETE_PREVIOUS_SECTIONS_FIRST */ "Please complete previous sections first",
        /* COMPLETE_REGISTRATION */ "Complete registration",
        /* COMPLETE_REGISTRATION_PROCESS */ "Complete Registration Process",
        /* COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT */ "Complete the application",
        /* COMPLETE_VISIT */ "Complete visit",
        /* COMPLETE_YOUR_ONBOARDING_ANYTIME */ "Complete your onboarding anytime!",
        /* COMPLIANCE */ "Compliance",
        /* COMPLIANCE_EXPIRY */ "Videos require your attention",
        /* COMPLIANCE_FORM */ "Compliance Form",
        /* COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY */ "Your compliance form has been submitted successfully!",
        /* COMPLIANT */ "Compliant",
        /* COMPLIANT_ITEMS */ "Compliant items",
        /* CONFIRM */ "Confirm",
        /* CONFIRM_ASSESSMENT */ "Confirm Assessment",
        /* CONFIRM_COPY_LAST */ "Are you sure you want to copy answers from",
        /* CONFIRM_COPY_LAST_TITLE */ "Confirm copy?",
        /* CONFIRM_DEPOSIT_DETAILS */ "Please confirm your direct deposit information",
        /* CONFIRM_PATIENT_AVAILABILITY */ "Confirm Patient Availability",
        /* CONFIRM_PATIENT_AVAILABILITY_MESSAGE */ "You just spoke with {{patientName}} about the planned visit on {{dateTime}}. Did they confirm that this time works for them?",
        /* CONFIRM_RN_FLEX_VISIT */ "I confirm my visit",
        /* CONFIRM_WITHOUT_LOCATION */ "Confirm without location",
        /* CONGRATULATIONS */ "Congratulations!",
        /* CONGRATULATIONS_TO */ "Congratulations to",
        /* CONNECTING_HOME */ "Connecting Home",
        /* CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS */ "Connecting home health agencies with caregivers",
        /* CONNECT_WITH_US_ON_FACEBOOK */ "Connect with us on Facebook",
        /* CONNECT_WITH_US_ON_WHATSAPP */ "Connect with us on WhatsApp",
        /* CONTACT */ "Contact",
        /* CONTACT_AGENCY_FOR_MORE_INFO */ "Contact the agency for more info.",
        /* CONTACT_PATIENT */ "Contact patient",
        /* CONTACT_SUPPORT */ "Contact Support",
        /* CONTINUE */ "Continue",
        /* CONTINUE_LATER */ "Continue Later",
        /* CONTINUE_TO_APP */ "Continue to app",
        /* CONTINUE_TO_ORIENTATION */ "Continue to orientation",
        /* CONTINUE_TO_SIGN_UP */ "Continue to sign up",
        /* CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK */ "Continue with your visits streak and you will get back to the next rank",
        /* COORDINATOR */ "Coordinator",
        /* COORDINATOR_EMAIL */ "Coordinator e-mail",
        /* COORDINATOR_IN_CHARGE */ "Coordinator in charge",
        /* COORDINATOR_PHONE */ "Coordinator phone",
        /* COPY */ "Copy",
        /* COPY_FROM_LAST_TIME */ "Copy from last time",
        /* COPY_FROM_MEDICATION */ "Copy from medication",
        /* COPY_FROM_OTHER_FORMS */ "Copy from other forms",
        /* COPY_LAST_NO_DATE_FALLBACK_APPENDED */ "last time",
        /* COPY_MEDICATION_CHART */ "Copy Medication Chart",
        /* COPY_PLAN_OF_CARE */ "Copy Plan Of Care",
        /* CORRECT */ "Correct",
        /* COURSES */ "Courses",
        /* COVID */ "COVID-19",
        /* COVID_REQUIRED */ "COVID-19 questionnaire required",
        /* COVID_REQUIRED_EXPLAINED */ "You haven't filled in the COVID-19 questionnaire today. Please fill it in order to continue",
        /* COVID_SCREENING_CLICK_HERE */ "COVID-19 Screening - Click Here",
        /* CREATED_AT */ "Created at",
        /* CREATE_A_NEW_ACCOUNT */ "Create a new account",
        /* CREATE_NEW_PLAN_OF_CARE */ "Create a new plan of care",
        /* CRIMINAL_CONVICTIONS_RECORDS */ "Criminal Convictions Records",
        /* CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT */ "Currently clocked in to a different visit",
        /* CURRENT_BALANCE */ "Current Balance",
        /* CURRENT_VISIT */ "Current visit",
        /* DATA_WILL_BE_LOST */ "Data will be lost",
        /* DATE */ "Date",
        /* DATES */ "Dates",
        /* DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO */ "Dates range to complete the task: %start% to %end%",
        /* DATE_NOT_SPECIFIED */ "Date not specified",
        /* DATE_OF_BIRTH */ "Date of Birth",
        /* DATE_UNKNOWN */ "Date unknown",
        /* DATE_VERIFICATION */ "Date Verification",
        /* DAY */ "Day",
        /* DAYS */ "days",
        /* DAYS_A_WEEK */ "Days a week",
        /* DAYS_LEFT */ "Days left",
        /* DAYS_OF_WEEK */ "Days a week",
        /* DECEMBER */ "December",
        /* DECLINED */ "Declined",
        /* DELETE */ "Delete",
        /* DESCRIBE_THE_PROBLEM */ "Describe The Problem",
        /* DETAILS */ "Details",
        /* DIRECTIONS */ "Directions",
        /* DIRECT_DEPOSIT */ "Direct deposit",
        /* DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION */ "Disconnected. Check your internet connection",
        /* DISCOVER_YOUR_JOURNEY */ "Discover Your Journey",
        /* DISCRIMINATION */ "Discrimination",
        /* DISMISS */ "Dismiss",
        /* DISMISSED */ "Dismissed",
        /* DISTANCE */ "Distance",
        /* DOB */ "DOB",
        /* DOCUMENT */ "Document",
        /* DOCUMENTS */ "Documents",
        /* DOCUMENTS_TO_COMPLETE */ "documents to complete",
        /* DOCUMENT_HAS_EXPIRED */ "Document has expired",
        /* DOCUMENT_IS_MISSING */ "Document is missing",
        /* DOCUMENT_REJECTED */ "Document rejected",
        /* DOCUMENT_SELECTED */ "Document selected",
        /* DOESNT_EXPIRE */ "Doesn't expire",
        /* DOES_NOT_FIT_MY_SCHEDULE */ "Does not fit my schedule",
        /* DONE */ "Done",
        /* DONT_FORGET_TO_CLOCK_IN */ "Don't forget to clock in",
        /* DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS */ "Don’t forget to clock in, clock out and complete all tasks",
        /* DONT_FORGET_TO_CLOCK_OUT */ "Don't forget to clock out",
        /* DONT_FORGET_TO_FILL_THE_DUTY_SHEET */ "Time to complete the tasks!",
        /* DONT_FORGET_TO_SMILE */ "Dont forget to smile 🙂",
        /* DONT_SCHEDULE_VISIT */ "Don't schedule the visit",
        /* DONT_SHOW_AGAIN */ "Don't show again",
        /* DOSE */ "Dose",
        /* DOWNLOAD_PDF */ "Download PDF",
        /* DO_YOU_HAVE_ANY_QUESTIONS_ASK */ "do you have any questions? Ask",
        /* DO_YOU_WANT_THIS_VISIT */ "Do you want this visit?",
        /* DUE_BETWEEN */ "Due between {dateFrom} and {dateTo}",
        /* DUE_BY_DATETIME */ "Due by {DATETIME}",
        /* DUE_DATE */ "Due date",
        /* DUE_ON */ "Due on",
        /* DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO */ "Due to a missed visit, your rank has changed to",
        /* DURATION */ "Duration",
        /* DURATION_PER_DAY */ "Duration per day",
        /* DUTIES */ "Duties",
        /* DUTIES_COMPLETED_SUCCESSFULLY */ "Duties completed successfully",
        /* DUTY_SHEET_SUBMITTED */ "Duty sheet submitted",
        /* EACH_100_POINTS_DOLLAR */ "each 100 points = $1",
        /* EACH_INVITE */ "Each Invite",
        /* EARLY_OR_LATE_CLOCKS */ "It looks like the clock in/out times are more than 15 minutes before/after the visit time",
        /* EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY */ "Earn more: higher ranks means higher pay",
        /* EDIT */ "Edit",
        /* EDIT_ACCOUNT_DETAILS */ "Edit account details",
        /* EDIT_TIMES */ "Edit times",
        /* EDUCATION */ "Education Center",
        /* ELECTRIC_EQUIPMENT_DEPENDENCY */ "Electric Equipment Dependency",
        /* ELIGIBLE_VISITS */ "Eligible visits",
        /* EMAIL */ "Email",
        /* EMAIL_QUESTION_PENDING_VERIFICATION */ "This question awaits your verification. Check the email we sent to this address for instructions.",
        /* EMAIL_SUPPORT */ "Email Support",
        /* EMAIL_SUPPORT_FOR_MORE_INFO */ "Email support for more info",
        /* EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER */ "If you've changed your phone number and can't log in, please email our support team. We'll update your profile with your new number as soon as possible.",
        /* EMAIL_VERIFICATION_QUESTION_LABEL */ "A verification email will be sent to this address. Please verify it withing 30 minutes.",
        /* EMERGENCY_CONTACTS */ "Emergency Contacts",
        /* EMPTY_DURATION */ "Empty Duration",
        /* EMPTY_PATIENT_MEDICATION_PROFILE */ "Patient medication profile is empty",
        /* ENABLE_LOCATION_MESSAGE */ "To continue, please enable Location Services in your device settings.",
        /* ENABLE_LOCATION_TITLE */ "Enable Location Services",
        /* ENDING_AT */ "Ending at",
        /* ENDS */ "Ends",
        /* END_DATE */ "End date",
        /* END_TIME */ "End time",
        /* ENROLLMENT_REQUESTED */ "Enrollment requested",
        /* ENROLL_NOW */ "Enroll now",
        /* ENTER_AGENCY_CODE */ "Enter agency code",
        /* ENTER_DOCUMENT_NAME */ "Enter document name",
        /* ENTER_NUMBER_HERE */ "Enter number here",
        /* ENTER_TEXT_HERE */ "Enter text here",
        /* ENTER_YOUR_MOBILE_NUMBER */ "Enter your mobile number",
        /* ENTER_YOUR_PIN_CODE */ "Enter your PIN code",
        /* ENTITY_IS_MISSING */ "The %s field is missing. Please make sure it's filled and then try again.",
        /* ERROR */ "Error",
        /* ERROR_FETCHING_SLOTS */ "An error occurred while fetching available time slots. Please try again later.",
        /* ERROR_LOADING_DATA */ "Error Loading Data",
        /* ERROR_REMOVING_DOCUMENT */ "Error occured while removing document",
        /* ERROR_SCHEDULING_TASK */ "Error Scheduling Task",
        /* ERROR_SCHEDULING_TASK_MESSAGE */ "There was an error scheduling the task. Please try again.",
        /* ESTIMATED_ADDRESS_WILL_BE_PROVIDED */ "Estimated address - exact address provided upson assignment",
        /* ESTIMATED_TIME_OF_CLOCKING_OUT_IS */ "Estimated time of Clocking Out is",
        /* EVACUATION_LOCATION */ "Evacuation Location",
        /* EVACUATION_ZONE */ "Evacuation Zone",
        /* EVERY_VISIT */ "Every visit",
        /* EVV */ "EVV",
        /* EXCITING_NEWS_AHEAD */ "Exciting News Ahead!",
        /* EXEMPTED */ "Exempted",
        /* EXPIRED */ "Expired",
        /* EXPIRED_COMPLIANCE */ "Expired compliance",
        /* EXPIRED_ON_DATE */ "Expired on %date%",
        /* EXPIRES_AT */ "Expires at",
        /* EXPIRES_IN */ "Expires in",
        /* EXPIRES_IN_ONE_DAY */ "Expires in one day",
        /* EXPIRES_IN_X_DAYS */ "Expires in %d days",
        /* EXPIRES_ON_DATE */ "Expires on %date%",
        /* EXPIRING_COMPLIANCE */ "Expiring compliance",
        /* EXPIRING_SOON */ "Expiring soon",
        /* EXPIRY_DATE */ "Expiry date",
        /* EXPLORE */ "Explore",
        /* EXPLORE_A_CAREER_ENHANCEMENTS */ "Explore a career enhancement program designed to recognize your dedication and elevate your caregiving experience.",
        /* FAILED_TO_IDENTIFY_PATIENT */ "Failed to identify patient",
        /* FAR_VISIT_WARNING_MODAL_TITLE */ "This visit is very far from your address",
        /* FAX_NUMBER */ "Fax Number",
        /* FEBRUARY */ "February",
        /* FEMALE */ "Female",
        /* FIFTHY_DOLLAR_AMAZON_GIFT_CARD */ "$50 Amazon gift card",
        /* FILES */ "files",
        /* FILE_NOT_FOUND_CONTACT_AGENCY */ "File not found, please contact your agency",
        /* FILL */ "Fill",
        /* FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT */ "Fill in the form to submit the document",
        /* FILL_IN_THE_QUESTIONNAIRE */ "Fill in the questionnaire",
        /* FILTERS */ "Filters",
        /* FINAL_CONFIRMATION */ "Final confirmation",
        /* FIND_A_CARE_MOMENT */ "Find a Care Moment",
        /* FIND_A_CARE_MOMENT_DESCRIPTION */ "Browse available Care Moments and select one that fits your schedule.",
        /* FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE */ "Find more cases in the available visits page",
        /* FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE */ "Find new patients in the available visits page",
        /* FINISH_MY_ONBOARDING */ "Finish my onboarding",
        /* FINISH_ONBOARDING_AND_GET_DOLLARS */ "Finish the onboarding and get $150",
        /* FINISH_ONBOARDING_MODAL_MESSAGE */ "You’re one step closer of getting many cases! Please finish your oboarding and get $!",
        /* FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2 */ "You can now request the cases you like, and make sure to fill all the additional documents before your first case",
        /* FINISH_ONBOARDING_MODAL_TITLE */ "We're excited to have you here, %name%!",
        /* FINISH_ONBOARDING_MODAL_TITLE_STAGE_2 */ "START REQUESTING CASES! 🚀",
        /* FINISH_SHIFT */ "Finish shift",
        /* FINISH_THE_DOCUMENTS */ "Finish the documents",
        /* FIRST_NAME */ "First name",
        /* FIRST_SHIFT */ "First shift",
        /* FIVE_THOUSAND_POINTS */ "5000 points",
        /* FIX */ "Fix",
        /* FIX_DOCUMENTS_DESCRIPTION */ "There are documents that require a change, please fix them and re-submit",
        /* FIX_DOCUMENT_DESCRIPTION */ "There is a document that requires a change, please fix it and re-submit",
        /* FIX_ISSUE */ "Fix issue",
        /* FIX_ISSUES */ "Fix issues",
        /* FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT */ "Fix it now!",
        /* FIX_SETTINGS */ "Fix settings",
        /* FIX_THE_DOCUMENT */ "Fix The Document",
        /* FIX_THE_DOCUMENTS */ "Fix The Documents",
        /* FIX_YOUR_DOCUMENT */ "Fix your document!",
        /* FIX_YOUR_DOCUMENTS */ "Fix your documents!",
        /* FLEXIBLE */ "Flexible",
        /* FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT */ "This visit is {HOURS_PER_WEEK} hours per week, Select which days and hours you want to work 🙂",
        /* FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT */ "This visit requires up to {NUM_OF_SHIFTS} shifts a week, hours are {START_TIME} to {END_TIME}.\nSelect the days you want to work",
        /* FLEXIBLE_DAYS_VISIT */ "Flexible days visit",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT */ "This visit has {TOTAL_SHIFTS_NUMBER} shifts: \n{SHIFTS_TO_CHOOSE} and {LAST_SHIFT_TO_CHOOSE}. \nSelect which days and hours you want to work 🙂",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT */ "{NUM_OF_SHIFTS} shifts of {NUM_OF_HOURS} hours",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT */ "{NUM_OF_SHIFTS} shift of {NUM_OF_HOURS} hours",
        /* FLEXIBLE_HOURS_EXPLANATION_TEXT */ "This visit is on {DAYS_TO_CHOOSE} and {LAST_DAY_TO_CHOOSE}.\nThe hours are whatever works for you!",
        /* FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT */ "This visit is {SHIFTS_TO_CHOOSE}.\nThe hours are whatever works for you!",
        /* FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT */ "This visit is {SHIFTS_TO_CHOOSE} and {LAST_SHIFT_TO_CHOOSE}. \nThe hours are whatever works for you!",
        /* FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT */ "This visit is on {DAYS_TO_CHOOSE}. \nThe hours are whatever works for you!",
        /* FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT */ "This visit has {SHIFTS_TO_CHOOSE}.\nSelect which days and hours you want to work 🙂",
        /* FLEXIBLE_HOURS_PATTERN_SHIFT */ "{NUM_OF_HOURS} hours on {DAY_OF_WEEK}",
        /* FLEXIBLE_HOURS_VISIT */ "Flexible hours visit",
        /* FLEXIBLE_VISIT */ "Flexible visit",
        /* FLEXIBLE_VISIT_DAY_TO_CHOOSE */ "{DAY}s",
        /* FLEXIBLE_VISIT_DETAILS */ "Flexible visit details",
        /* FLEXIBLE_VISIT_TYPE */ "Flexible Visit",
        /* FLU_SHOT */ "Flu Shot",
        /* FLU_SHOT_SUBMITTION_MESSAGE */ "Please sign the declination form for this flu season. If you have already received a flu shot for the current season, please upload the document.",
        /* FOLLOW_US_ON_INSTAGRAM */ "Follow us on Instagram",
        /* FOLLOW_US_ON_TWITTER */ "Follow us on Twitter",
        /* FORGOT_PIN_CODE_DIALOG_MESSAGE */ "You will be taken to the login screen to start a new registration process.",
        /* FORM_NAME */ "Form name",
        /* FOURTEEN_THOUSAND_POINTS */ "14000 points",
        /* FREQUENCY */ "Frequency",
        /* FRIEND */ "Friend",
        /* FROM */ "From",
        /* FROM_CAMERA */ "From Camera",
        /* FROM_GALLERY */ "From Gallery",
        /* FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE */ "Full terms and conditions - MedFlyt Challenge",
        /* FUTURE_VISITS */ "Future visits",
        /* GENDER */ "Gender",
        /* GENERAL */ "General",
        /* GENERAL_FILES */ "General files",
        /* GENERAL_NOTES */ "General notes",
        /* GENERAL_SUPPORT */ "General Support",
        /* GET_INSTAPAY */ "Get InstaPay",
        /* GET_IT_NOW */ "Get it now",
        /* GET_MONEY_FOR_THIS_VISIT_TODAY
 */ "Get paid for this visit now!",
        /* GET_NOW */ "Get now!",
        /* GET_STARTED */ "Get Started",
        /* GET_THE_APP */ "Get the app",
        /* GET_X_NOW */ "Get {x} now!",
        /* GOOD_JOB */ "Good job!",
        /* GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "Good job! You've completed all the lessons for now",
        /* GOT_IT */ "Got it",
        /* GO_BACK */ "Go back",
        /* GO_TO */ "Go to",
        /* GO_TO_MEDFLYT_PASSPORT */ "Go to MedFlyt Passport",
        /* GO_TO_PATIENT */ "Go to patient",
        /* GO_TO_PATIENT_DETAILS */ "Go to patient details",
        /* GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION */ "Please open the settings and enable camera access",
        /* GO_TO_VISIT */ "Go to visit",
        /* GREAT_JOB */ "Great Job!",
        /* GROSS_PAY */ "Gross pay",
        /* HAS_DNR */ "Has DNR",
        /* HAS_HEALTH_CARE_PROXY */ "Has Health Care Proxy",
        /* HAVE_A_NICE_WORKING_DAY */ "Have a nice working day!",
        /* HAVE_A_PLEASANT_VISIT */ "Have a pleasant visit!",
        /* HAVE_A_QUESTION_LETS_CHAT */ "Have a question? Let's chat!",
        /* HEALTH_AGENCIES */ "Health Agencies",
        /* HELP */ "Help",
        /* HELP_ME_FIND_MY_AGENCY */ "Help me find my agency",
        /* HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY */ "Here is what you need to know about our agency!",
        /* HEY */ "Hey!",
        /* HEY_THERE */ "Hey there",
        /* HI */ "Hi",
        /* HIRE_DATE */ "Hire Date",
        /* HI_PLEASE_HELP_ME_FILL_MY_APPLICATION  */ "Hi! Could you please help me complete my Medflyt At Home application? Just click the link. Thank you!",
        /* HOME_PHONE */ "Home phone",
        /* HOUR */ "hour",
        /* HOURS */ "Hours",
        /* HOURS_PER_DAY */ "Hours per day",
        /* HOURS_PER_VISIT */ "Hours per visit",
        /* HOW_ARE_WE_CALCULATING_THE_RANK */ "How are we calculating the rank?",
        /* HOW_CAN_WE_HELP_YOU */ "How can we help you?",
        /* HOW_CARE_MOMENTS_WORKS */ "How Care Moments Works",
        /* HOW_DID_YOU_HEAR_ABOUT_US */ "How did you hear about us",
        /* HOW_DOES_IT_WORK */ "How does it work?",
        /* HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS */ "How does the patient feel? What are the main symptoms?",
        /* HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN */ "How do you encourage a patient who is feeling down?",
        /* HOW_DO_YOU_RATE_MEDFLYT */ "How do you rate Medflyt?",
        /* HOW_URGENT_IS_THE_ISSUE */ "How Urgent Is The Issue?",
        /* HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT */ "How would you like to call the patient?",
        /* HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE */ "How would you like to upload the file?",
        /* HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT */ "How would you like to upload the document?",
        /* HR_PER_VISIT */ "Hr Per Visit",
        /* HUNDRED_DOLLARS_GIFT_CARD */ "$100 Amex gift card",
        /* ICD */ "ICD",
        /* ID */ "ID",
        /* IF_YOU_CLOCK_IN_AND_OUT_ON_TIME */ "If you clock in and out on time",
        /* IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME */ "If you don’t clock in and out on time",
        /* IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON */ "If you miss a visit for a non-legit reason",
        /* IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE */ "If you request more visits while your schedule is free",
        /* IF_YOU_STAY_COMPLIANT */ "If you stay compliant",
        /* IMPORTANT_INFORMATION */ "Important information",
        /* IMPORTED */ "Imported",
        /* IM_AVAILABLE */ "I’m available",
        /* IM_DONE_SUBMIT */ "I'm Done! Submit",
        /* IM_NOT_INTERESTED */ "I’m not interested",
        /* IM_WORKING_WITH_AN_AGENCY */ "I'm working with an agency",
        /* INACTIVE */ "Inactive",
        /* INCOMPLETE */ "Incomplete",
        /* INCORRECT */ "Incorrect",
        /* INCORRECT_CODE */ "Incorrect Code",
        /* INCORRECT_DIGITS */ "Incorrect digits...",
        /* INCORRECT_DIGITS_EXPLAINED */ "The last 4 digits you've entered are incorrect. Please contact your agency if you’re having troubles.",
        /* INCORRECT_DIGITS_MESSAGE */ "The last four digits you entered are incorrect. Please contact your agency if you're having troubles.",
        /* INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN */ "Incorrect PIN code. Please try again.",
        /* INCORRECT_SMS_CODE */ "Incorrect SMS code",
        /* INCORRECT_SMS_CODE_EXPLAINED */ "The code you have entered does not match the code we have sent to you. Please try again.",
        /* INFORMATION_CENTER */ "Information Center",
        /* INFORMATION_NOT_MATCH_PROFILE */ "The information in this section doesn't match the patient profile anymore",
        /* INSERT_THEIR_REFERRAL_CODE_HERE */ "Insert their referral code here!",
        /* INSERVICES */ "In-services",
        /* INSTAPAY */ "InstaPay",
        /* INSTAPAY_HISTORY */ "InstaPay History",
        /* INSTAPAY_TECHNICAL_ISSUE */ "Technical issue",
        /* INSUFFICIENT_DUTIES */ "The duties that were done in the visit aren't sufficient enough",
        /* INTERESTED_IN_THIS_BUNDLE */ "Interested in this bundle?",
        /* INTRODUCING */ "Introducing",
        /* INVALID_DOCUMENT_NAME */ "Invalid document name",
        /* INVALID_EMAIL */ "Invalid Email",
        /* INVALID_FORM */ "Invalid Form",
        /* INVALID_PHONE */ "Invalid Phone",
        /* INVALID_PHONENUMBER */ "Invalid phone number",
        /* INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN */ "Invalid SSN, please check and try again",
        /* INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES */ "Invite caregivers to MedFlyt and win amazing prizes",
        /* INVITE_FRIENDS */ "Invite Friends",
        /* IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE */ "In order to answer this question please update to our newest version from the store",
        /* IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT */ "In order to get InstaPaid, you need to select at least one visit.",
        /* IN_PROGRESS */ "In progress",
        /* ISSUES_TO_SOLVE */ "Issues to solve",
        /* IS_DUE_IN_DAYS */ "Is due in %days% days",
        /* IS_DUE_TOMORROW */ "Is due tomorrow",
        /* ITEMS_THAT_WILL_EXPIRE_SOON */ "Items that will expire soon",
        /* ITEMS_WITH_ISSUES */ "Items with issues",
        /* ITEM_IS_MISSING */ "Item is missing",
        /* ITEM_IS_NOT_COMPLIANT */ "Item is not compliant",
        /* ITS_NOT_ME */ "It's not me",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU */ "It appears that we already have an account that exists on this device. Is that you?",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU */ "It appears that we already have an account that matches your details. Is that you?",
        /* IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK */ "It appears you have no visits this week.",
        /* IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE */ "It looks like your'e not working with any agency. Would you like to get hired by agencies by filling an application",
        /* I_DONT_HAVE_MY_CODE */ "I don't have a code",
        /* I_DONT_WANT_THIS_CASE */ "I don’t want this case",
        /* I_DONT_WANT_TO_CLOCK */ "I don't want to clock",
        /* I_FORGOT_MY_PIN_CODE */ "I forgot my PIN code",
        /* I_HAVE_CHANGED_MY_MIND */ "I have changed my mind",
        /* I_HAVE_READ_AND_AGREE */ "I have read and agree to the",
        /* I_VERIFY_THE_TERMS */ "I agree to the terms and conditions",
        /* I_WANT_TO_CLOCK_IN_ANYWAY */ "I want to clock in anyway",
        /* I_WANT_TO_CLOCK_OUT_ANYWAY */ "I want to clock out anyway",
        /* I_WANT_TO_FINISH_MY_ONBOARDING */ "I want to finish my onboarding",
        /* I_WILL_DO_IT_LATER */ "I'll do it later",
        /* JANUARY */ "January",
        /* JOINED_DATE */ "Joined date",
        /* JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT */ "Available now and for the next few months!",
        /* JULY */ "July",
        /* JUNE */ "June",
        /* JUST_ONE_MORE_THING */ "Just one more thing",
        /* JUST_TO_BE_SURE */ "Just to be sure...",
        /* JUST_VERIFYING_ITS_YOU */ "Just verifying it's you",
        /* KEEP_UP_THE_GOOD_WORK */ "Keep up the good work!",
        /* LABELS */ "Labels",
        /* LANGUAGE */ "Language",
        /* LANGUAGES */ "Languages",
        /* LAST_NAME */ "Last name",
        /* LEARN_MORE */ "Learn more",
        /* LEAVE_WITHOUT_SAVING */ "Leave without saving?",
        /* LEFT */ "left",
        /* LESSON */ "Lesson",
        /* LESSONS */ "Lessons",
        /* LETS_CONTINUE_TO_NEXT_SECTION */ "Let’s continue to the next section!",
        /* LETS_FIND_CASES */ "Let’s find cases!",
        /* LETS_FIND_YOUR_FIRST_CASE */ "Let's find your first case!",
        /* LETS_FIND_YOUR_FIRST_PATIENT */ "Let's find your first patient!",
        /* LETS_FINISH_YOUR_SHIFT */ "Let's finish your shift",
        /* LETS_START */ "Let's Start!",
        /* LETS_START_YOUR_SHIFT */ "Let's start your shift",
        /* LIKE_US_ON_FACEBOOK */ "Like us on Facebook",
        /* LINKED_TO_ANOTHER_PATIENT */ "Linked to another patient",
        /* LIST */ "List",
        /* LISTENING___ */ "Listening...",
        /* LIST_OF_PATIENTS */ "List of Patients",
        /* LIST_OF_TASKS */ "List of Tasks",
        /* LIST_OF_VISITS */ "List of Visits",
        /* LIVE_CHAT_SUPPORT */ "Live chat support",
        /* LIVE_CLASS */ "Live Class",
        /* LIVE_CLASS_EXPLANATION */ "You will be able to join the class once it starts. In case you missed it - you will be able to watch the recorded webinar",
        /* LIVE_EVENTS */ "Live events",
        /* LOADING */ "Loading",
        /* LOADING_LOCATION */ "Loading location...",
        /* LOCATION */ "Location",
        /* LOCKED */ "Locked",
        /* LOGGING_YOU_IN */ "Logging you in",
        /* LOGIN */ "Log in",
        /* LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED */ "it seems that you have been trying to login from a different device. please answer the following questions",
        /* LOOKS_LIKE_MORE_THAN */ "Looks like more than",
        /* LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION */ "Looks like you are too far from the visit's location!",
        /* MAIN_TASKS */ "Main tasks",
        /* MAKE_A_DIFFERENCE */ "Make a difference!",
        /* MAKE_SURE_PICTURE_IS_CLEAR */ "Make sure that the picture is not blurred and that you can read the text",
        /* MALE */ "Male",
        /* MANUALLY_SUBMITTED_INFO */ "Manually submitted info",
        /* MAP */ "Map",
        /* MARCH */ "March",
        /* MAX_TRAVEL_DISTANCE */ "Max travel distance",
        /* MAY */ "May",
        /* MAYBE_LATER */ "Maybe later",
        /* MAY_CLOCK_IN_AT */ "May clock in at",
        /* MAY_CLOCK_OUT_FROM */ "May clock out from",
        /* MEC_WAIVER_INFORMATION */ "MEC waiver information",
        /* MEDFLYT */ "Medflyt",
        /* MEDFLYTS_MONTHLY_RAFFLE */ "Medflyt's monthly raffle",
        /* MEDFLYT_AGENCY_HANDBOOK */ "Medflyt Agency Handbook",
        /* MEDFLYT_AT_HOME_BENEFITS */ "Medflyt at home benefits",
        /* MEDFLYT_CHALLENGE */ "MedFlyt Challenge",
        /* MEDFLYT_HOME_CARE */ "Medflyt Home Care",
        /* MEDFLYT_ID_CARD */ "Medflyt ID Card",
        /* MEDFLYT_PASSPORT */ "Medflyt Passport",
        /* MEDFLYT_PASSPORT_TERMS */ "MedFlyt Passport Terms",
        /* MEDFLYT_RAFFLE */ "Medflyt Raffle",
        /* MEDFLYT_TEAM */ "Medflyt team",
        /* MEDFLYT_VERSION */ "MedFlyt version",
        /* MEDICAL_FILES */ "Medical files",
        /* MEDICAL_INFORMATION */ "Medical information",
        /* MEDICAL_NOTES */ "Medical Notes",
        /* MEDICATIONS */ "Medications",
        /* MESSAGE */ "Message",
        /* MESSAGE_FOR_THE_COORDINATOR */ "Message for the coordinator",
        /* MIDDLE_NAME */ "Middle Name",
        /* MILES_AWAY */ "Miles away",
        /* MILES_BETWEEN_PATIENTS */ "Miles between patients",
        /* MILES_SHORT */ "Mi.",
        /* MINIMUM_WAGE */ "Minimum Wage",
        /* MINUTE */ "minute",
        /* MINUTES */ "Minutes",
        /* MINUTE_VISIT */ "minute visit",
        /* MISSING */ "Missing",
        /* MISSING_CLOCKS */ "Missing clocks",
        /* MISSING_PERSONAL_CARE_DUTY */ "No personal care duty was done during the visit",
        /* MM_DD_YYYY */ "mm/dd/yyyy",
        /* MOBILE_PHONE */ "Mobile phone",
        /* MOBILITY_STATUS */ "Mobility Status",
        /* MONTH */ "Month",
        /* MONTHLY_RAFFLE */ "Monthly Raffle",
        /* MORE_DETAILS */ "More Details",
        /* MORE_DETAILS_BELOW */ "More details below",
        /* MORE_SHIFTS_MORE_CHANCES */ "More shifts = More chances!",
        /* MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY */ "More visits outside your availability",
        /* MUST_AGREE_TERMS */ "You have to agree to the terms of use and the privacy policy by selecting the checkbox.",
        /* MUST_BE_ATLEAST_3_CHARACTERS */ "Must be atleast 3 characters",
        /* MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS */ "Must be in one of the following days",
        /* MUST_PICK_EXACTLY */ "Must pick exactly",
        /* MUST_START_AT_OR_AFTER */ "must start AT or AFTER",
        /* MUST_START_AT_OR_BEFORE */ "must start AT or BEFORE",
        /* MUST_UPDATE_ADDRESS_TO_SEE_CASES */ "You must update your address to see cases!",
        /* MY_AGENCIES */ "My Agencies",
        /* MY_ASSIGNED_VISITS */ "My Assigned Visits",
        /* MY_AVAILABILITY */ "My Availability",
        /* MY_BENEFITS_CARD_INFORMATION */ "My Benefits Card Information",
        /* MY_MEDFLYT_COMPLIANCE */ "My Medflyt Compliance",
        /* MY_PASSPORT */ "My Passport",
        /* MY_PAYROLL_HISTORY */ "My Payroll History",
        /* MY_PAYROLL_INFORMATION */ "My Payroll Information",
        /* MY_PROFILE */ "My profile",
        /* MY_REQUESTED_VISITS */ "My Requested Visits",
        /* MY_STAFFING_PREFERENCES */ "My Staffing Preferences",
        /* MY_UPCOMING_VISITS_REMINDERS */ "Visit Reminders",
        /* MY_VIRTUAL_ID */ "My Virtual ID",
        /* MY_VISITS */ "My visits",
        /* NA */ "N/A",
        /* NAME */ "Name",
        /* NEAR */ "Near",
        /* NEED_DIRECTIONS */ "Need directions?",
        /* NET_PAY_FOR_PERIOD */ "Net pay for period",
        /* NEW */ "New",
        /* NEW_END_TIME_X */ "New end time: {visitEndTime}",
        /* NEW_MESSAGE */ "New Message",
        /* NEW_TASK */ "New task",
        /* NEW_TASKS */ "New tasks",
        /* NEW_VISITS_AVAILABLE */ "New Visits Available",
        /* NEXT */ "Next",
        /* NEXT_DUE */ "Next Due",
        /* NEXT_LESSON */ "Next lesson",
        /* NEXT_SECTION */ "Next stage",
        /* NEXT_TOKEN_IN */ "Next token in",
        /* NEXT_YEAR */ "next year",
        /* NO */ "No",
        /* NONE */ "None",
        /* NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT */ "None of them is me. Create new account",
        /* NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU */ "None of the following accounts is you",
        /* NOTES */ "Notes",
        /* NOTIFICATIONS */ "Notifications",
        /* NOTIFICATIONS_OFF */ "Notifications off",
        /* NOTIFICATIONS_ON */ "Notifications on",
        /* NOT_AVAILABLE */ "not available",
        /* NOT_COMPLIANT */ "Not Compliant",
        /* NOT_DUE_YET */ "Not due yet",
        /* NOT_ENOUGH_HOURS */ "Not enough hours",
        /* NOT_ENOUGH_SHIFTS */ "Not enough shifts...",
        /* NOT_ENOUGH_SHIFTS_MESSAGE */ "You have to pick at least %minShifts% shifts in order to request this visit (you picked only %currentShifts%).",
        /* NOT_FOUND */ "Not found",
        /* NOT_INTERESTED */ "Not interested",
        /* NOT_SELECTED */ "Not Selected",
        /* NOT_SET */ "Not Set",
        /* NOT_SIGNING */ "Not signing",
        /* NOT_STARTED */ "Not started",
        /* NOT_URGENT */ "Not Urgent",
        /* NOVEMBER */ "November",
        /* NO_ALLERGIES */ "No known allergies",
        /* NO_ANSWERS_TO_COPY */ "There are no answers to copy from.",
        /* NO_ANSWERS_TO_COPY_TITLE */ "Copy failed!",
        /* NO_AVAILABLE_SLOTS */ "No available slots",
        /* NO_BALANCE */ "No balance",
        /* NO_CHANGES_WERE_MADE */ "No changes were made",
        /* NO_COMPLIANT_ITEMS */ "No compliant items",
        /* NO_DOCUMENTS */ "No documents",
        /* NO_DOCUMENTS_AVAILABLE */ "No documents available",
        /* NO_DOCUMENTS_REQUIRED */ "No documents required.",
        /* NO_DUTIES_REQUIRED_FOR_THIS_VISIT */ "No duties required for this visit",
        /* NO_EDUCATION_LINK */ "Do you want free education? Contact your agency",
        /* NO_ELIGIBLE_VISITS */ "No eligible visits",
        /* NO_END_DATE */ "No end date",
        /* NO_GENERAL_NOTES */ "No general notes",
        /* NO_IN_SERVICE_VIDEOS_AVAILABLE */ "No in-service videos available.  Please contact your agency for details.",
        /* NO_ISSUES_FOUND */ "No issues found.",
        /* NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT */ "No, it's not me. Create new account",
        /* NO_JUST_THIS_ONE */ "No, just this one",
        /* NO_KEEP_THE_ORIGINAL_TIMES */ "No, keep the original times",
        /* NO_KNOWN_ALLERGIES */ "No known allergies",
        /* NO_LESSONS */ "No lessons",
        /* NO_LESSONS_FOR_YOU_YET */ "No lessons for you yet",
        /* NO_MEDICAL_INFORMATION */ "No medical information",
        /* NO_NOTIFICATIONS */ "No notifications",
        /* NO_PAYSTUBS_FOUND_FOR_THIS_MONTH */ "No paystub found for this month.",
        /* NO_PHONE */ "No phone",
        /* NO_PHYSICIAN_SELECTED */ "No Phycisian Selected",
        /* NO_PREVIOUS_CONVERSATIONS */ "No previous conversations",
        /* NO_SCHEDULED_VISITS_TODAY */ "No scheduled visits today",
        /* NO_SHIFTS_SELECTED */ "Not shifts selected",
        /* NO_TAKE_ME_BACK */ "No, take me back",
        /* NO_TESTS */ "No tests",
        /* NO_THANKS */ "No thanks",
        /* NO_TIME_LIMIT */ "No time limit",
        /* NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT */ "No upcoming expiration dates to worry about.",
        /* NO_VIDEOS */ "No videos",
        /* NO_VISITS_SCHEDULED */ "No visits scheduled",
        /* NO_VISITS_SCHEDULED_MESSAGE */ "Patient has no visits scheduled in the near future",
        /* NO_VISITS_SELECTED */ "No visits selected",
        /* NPI */ "NPI",
        /* NUM_COUNT_ITEMS */ "{count} items",
        /* NUM_SHIFTS_TO_GO */ "{numShifts} shifts to go",
        /* NUM_SHIFTS_TO_WAGE */ "{numShifts} shifts to {wage}",
        /* N_A */ "N/A",
        /* OCTOBER */ "October",
        /* OF */ "of",
        /* OF_THE_REQUIRED_PLEASE_CONTINUE */ "of the required time. Please continue.",
        /* OF_THE_VIDEO */ "of the video.",
        /* OK */ "OK",
        /* OK_ILL_TRY_LATER */ "OK I'll try later",
        /* OK_NO_PROBLEM */ "Ok, no problem!",
        /* OK_THANKS */ "Ok, Thanks!",
        /* ON */ "On",
        /* ONBOARDING */ "Onboarding",
        /* ONBOARDING_COMPLETED */ "Onboarding completed",
        /* ONBOARDING_COMPLETED_MESSAGE */ "You have completed all sections of the onboarding process. You can start watching the orientation videos now.",
        /* ONE_DAY_TO_COMPLETE */ "One day to complete",
        /* ONE_DOCUMENT */ "One document",
        /* ONE_DOCUMENT_SELECTED */ "1 document selected",
        /* ONE_HOUR */ "1 hour",
        /* ONE_LAST_STEP */ "One last step",
        /* ONE_LESSON */ "One lesson",
        /* ONE_TEST */ "One test",
        /* ONE_THOUSAND_POINTS */ "1000 points",
        /* ONE_VIDEO */ "One video",
        /* ON_HOLD */ "On Hold",
        /* ON_LEAVE */ "On Leave",
        /* OOPS */ "Oops",
        /* OPEN */ "Open",
        /* OPEN_CAMERA */ "Open camera",
        /* OPEN_CERTIFICATE */ "Open certificate",
        /* OPEN_DEVICE_SETTINGS */ "Open device settings",
        /* OPEN_MAPS */ "Open Maps",
        /* OPEN_SETTINGS */ "Open settings",
        /* OPTIONAL_TASKS */ "Optional Tasks",
        /* OR */ "or",
        /* OTHER */ "Other",
        /* OTHER_PERTINENT_DIAGNOSIS */ "Other Pertinent Diagnosis",
        /* OTHER_REASON */ "Other reason",
        /* OTHER_TASKS */ "Other tasks",
        /* OTHER_VISITS */ "Other visits",
        /* OUTBOUND_CALL_ERROR_MESSAGE */ "An error occurred while trying to call to {{name}}.",
        /* OUTBOUND_CALL_ERROR_TITLE */ "Error",
        /* OUTBOUND_CALL_PROMPT_MESSAGE */ "When pressing the call button, An incoming call will connect you to {{name}}.\n\nWe will call you at {{number}}",
        /* OUTBOUND_CALL_PROMPT_TITLE */ "Call {{name}}?",
        /* OUTBOUND_CALL_SUCCESS_MESSAGE */ "Once you pick up, you will be connected to {{name}}.",
        /* OUTBOUND_CALL_SUCCESS_TITLE */ "Expect an incoming call...",
        /* OUT_OF */ "out of",
        /* OUT_OF_RANGE */ "Your clock in/out was done too far from the visit's address",
        /* OVERDUE */ "Overdue",
        /* OVERLAPPING_VISIT_ERROR */ "Visits are overlapping, please select another date or time.",
        /* OVERRIDE_FORM */ "Override form?",
        /* OVERRIDE_FORM_MESSAGE */ "Uploading a file will override the current form and delete all the answers. Are you sure?",
        /* OVER_NIGHT */ "Overnight",
        /* PAGE */ "Page",
        /* PAID */ "Paid",
        /* PAID_X_OUT_OF_Y */ "Paid {x} out of {y}",
        /* PARTIAL_SELECTION */ "Partial Selection",
        /* PASSPORT */ "Passport",
        /* PASSPORT_TERMS_TEXT */ "Easily upload all your compliance & medical files to share with agencies your are working with.",
        /* PASTE */ "Paste",
        /* PAST_DUE */ "Past due",
        /* PAST_SINCE_THE_VISIT_STARTED */ "past since the visit started",
        /* PAST_UPLOADS */ "Past Uploads",
        /* PAST_VISITS */ "Past visits",
        /* PATIENT */ "Patient",
        /* PATIENTS */ "Patients",
        /* PATIENT_ADDRESS */ "Patient address",
        /* PATIENT_CANT_PHISICALLY_SIGN */ "Patient physically unable to sign",
        /* PATIENT_CANT_SIGN */ "Patient can't sign",
        /* PATIENT_CONTACTS */ "Patient contacts",
        /* PATIENT_DOC_NOT_SUBMITTED */ "The patient document was not submitted due to an error",
        /* PATIENT_DOC_SUBMISSION_MISSMATCH */ "You are about to submit the form, but the scheduled date of the visit is different than today. Please choose the date you would like to have on the form",
        /* PATIENT_DOC_SUBMITTED_SUCCESSFULY */ "The patient document was submitted successfully",
        /* PATIENT_INFO */ "Patient info",
        /* PATIENT_IS_NOT_HOME */ "Patient is not home",
        /* PATIENT_IS_NOT_SIGNING */ "Patient is not signing",
        /* PATIENT_NAME */ "Patient name",
        /* PATIENT_NOT_FOUND */ "Patient not found",
        /* PATIENT_NOT_FOUND_EXPLAIN */ "Sorry, it looks like the patient you were looking for is not assigned to you.",
        /* PATIENT_NUMBER */ "Patient number",
        /* PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE */ "This patient is still pending approval from the insurance company. Start date might change",
        /* PATIENT_PHONE */ "Patient phone",
        /* PATIENT_REFUSES_TO_SIGN */ "Patient refuses to sign",
        /* PATIENT_REPORT */ "Patient Report",
        /* PATIENT_REQUESTS */ "Patient requests",
        /* PATIENT_SCHEDULE */ "Patient schedule",
        /* PATIENT_SIGNATURE */ "Patient signature",
        /* PATIENT_SIGNATURE_IS_REQUIRED */ "Patient signature is required",
        /* PATIENT_SIGNATURE_REQUIRE_MSG */ "Please specify a reason why the patient signature is unsigned",
        /* PATIENT_SIGN_HERE */ "Patient sign here",
        /* PATIENT_UNAVAILABLE_DURING_THESE_HOURS */ "Patient is unavailable during these hours",
        /* PATIENT_VISITS */ "Patient visits",
        /* PAUSE_READING */ "Pause Reading",
        /* PAYMENT_METHOD */ "Payment method",
        /* PAYROLL */ "Payroll",
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE */ "The clock in/out for this visit was not recorded through the mobile app",
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE */ "Clock in/out wasn’t done through the mobile app",
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE */ "Clock in/out time is more than 15 minutes early/late",
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE */ "Clock in/out too far from schedule",
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE */ "The issue can be missing EVV information, Clock-in / out hours doesn’t match, clock in / out location is out of range and more.",
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE */ "There is an issue that is preventing payment for this visit",
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE */ "We are processing your payment transaction, You should see the money in your bank account by {PROCESS_TIME} 🙏🏼",
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY */ "We are processing your payment transaction, the transfer will be delayed due to the banking holiday and you should see the money in your bank account by {PROCESS_TIME} 🙏🏼",
        /* PAYROLL_STATUS_IN_PROGRESS_TITLE */ "In Progress",
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE */ "It seems like this visit is missing either clock in or out.",
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE */ "Missing clock in or out",
        /* PAYROLL_STATUS_PAID_MODAL_MESSAGE */ "The rest of the amount will be paid on the weekly paycheck",
        /* PAYROLL_STATUS_PAID_MODAL_TITLE */ "This visit was 80% paid through our InstaPay service ({x})",
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE */ "The issue can be missing EVV information, Clock-in / out hours doesn't match, clock in / out location is out of range and more.",
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE */ "You can’t get Instapay for this visit 🙏🏼",
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE */ "Please note that the amount presented is before tax reductions.",
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE */ "This visit will be paid in your weekly paycheck",
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE */ "There was a technical issue, please contact the chat support to get more details",
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE */ "Technical Issue",
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE */ "Once the shift will be over and we will get the needed EVV data you can claim this visit for InstaPay.",
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE */ "You still didn’t attend this visit.",
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE */ "The total duration of this visit is shorter than the scheduled time.",
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE */ "Short Visit Duration",
        /* PAYSTUB */ "Paystub",
        /* PAYSTUBS */ "Paystubs",
        /* PAY_ME_NOW */ "Pay me now!",
        /* PAY_ME_NOW_X */ "Pay me now {x}!!!",
        /* PENDING */ "Pending",
        /* PENDING_APPLICATION */ "Pending application",
        /* PENDING_APPROVAL */ "Pending approval",
        /* PENDING_CONFIRMATION */ "Pending Confirmation",
        /* PENDING_ISSUES */ "Pending issues",
        /* PENDING_VERIFICATION */ "Pending Verification",
        /* PERMANENT_VISIT_DETAILS */ "Permanent visit details",
        /* PERMANENT_VISIT_FROM */ "Permanent visit from",
        /* PERMANENT_VISIT_TYPE */ "Permanent Visit",
        /* PERMISSION_NEEDED_FOR_CAMERA */ "📸 Permission Needed for Camera",
        /* PERMISSION_NEEDED_FOR_CAMERA_MESSAGE */ "It looks like we can't access your camera. To snap photos, please enable camera access in your settings.",
        /* PERMISSION_NEEDED_FOR_PHOTOS */ "🖼️ Permission Needed for Photos",
        /* PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE */ "It looks like we can't access your photos. Please enable access in your settings.",
        /* PERMISSION_TO_CAMERA_DENIED */ "Permission to camera denied",
        /* PER_HOUR */ "per hour",
        /* PER_SHIFT */ "Per shift",
        /* PER_VISIT */ "per visit",
        /* PER_WEEK */ "per week",
        /* PHONE */ "Phone",
        /* PHONES */ "Phones",
        /* PHONE_CALL_SUPPORT */ "Call support",
        /* PHOTO_LIBRARY */ "Photo library",
        /* PHYSICIAN_DETAILS */ "Physician Details",
        /* PICK_A_DATE */ "Pick a date",
        /* PICK_A_TIME */ "Pick a time",
        /* PLAN_OF_CARE */ "Plan of care",
        /* PLEASE_ASK_THE_PATIENT */ "Please ask the patient",
        /* PLEASE_CALL_PATIENT_IN_NEXT_SCREEN */ "Please call the patient in the next screen",
        /* PLEASE_CHAT_WITH_THE_AGENCY */ "Please chat with the agency",
        /* PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY */ "Please check that you have entered it correctly.",
        /* PLEASE_CHOOSE_A_LANGUAGE */ "Please choose a language",
        /* PLEASE_CHOOSE_A_TIME */ "Please choose a time",
        /* PLEASE_CHOOSE_DATE_BETWEEN */ "Please choose date between",
        /* PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES */ "Please complete previous years bundles",
        /* PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT */ "Please watch and submit the tests to remain compliant.",
        /* PLEASE_CONFIRM_THE_TIMES_CHOSEN */ "Please confirm the times chosen",
        /* PLEASE_CONFIRM_YOUR_INFORMATION */ "Please confirm your information",
        /* PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS */ "Please contact the agency for more details",
        /* PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY */ "Please contact your agencies immediately",
        /* PLEASE_CONTACT_YOUR_AGENCY */ "Please contact your agency",
        /* PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS */ "Please contact your agency for an address",
        /* PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY */ "Please contact your agency immediately",
        /* PLEASE_CONTACT_YOUR_COORDINATOR */ "Please contact your coordinator.",
        /* PLEASE_ENABLE_LOCATION */ "Please enable location",
        /* PLEASE_ENTER_A_VALID_PHONE_NUMBER */ "Please enter a valid phone number",
        /* PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME */ "Please enter patient's first and last name",
        /* PLEASE_ENTER_PATIENT_NAME */ "Please enter patient name",
        /* PLEASE_ENTER_THE_PATIENT_PHONE */ "Please enter the patient phone",
        /* PLEASE_ENTER_YOUR_PIN_CODE */ "Please Enter your PIN code",
        /* PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED */ "Please explain why it wasn’t completed",
        /* PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER */ "Please fill in the last 4 digits of the phone number",
        /* PLEASE_FILL_IN_YOUR_INFORMATION */ "Please fill in your information",
        /* PLEASE_FILL_REQUIRED_FIELDS */ "Please fill out all required fields",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY */ "Please make sure you have entered the code correctly",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY */ "Please make sure you have entered your phone number correctly",
        /* PLEASE_MARK_ALL_THE_REQUIRED_DUTIES */ "Please mark all the required duties as completed / not completed.If not completed - please leave a note explaining why wasn’t completed🙏🏼",
        /* PLEASE_NOTE */ "Please note",
        /* PLEASE_PICK_VALID_DATES */ "Please pick valid dates",
        /* PLEASE_REQUEST_EXACTLY */ "Please request exactly",
        /* PLEASE_SELECT_AN_OPTION */ "Please select an option",
        /* PLEASE_SELECT_DATE_AND_TIME */ "Please select date and time",
        /* PLEASE_SELECT_THE_PATIENT_ADDRESS */ "Please select the patient address",
        /* PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT */ "Please send us a message to reinstate it",
        /* PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW */ "Please set up your profile photo by clicking on the camera icon below",
        /* PLEASE_SIGN_IN_AGAIN */ "Please sign in again",
        /* PLEASE_SPECIFY */ "Please specify",
        /* PLEASE_TAKE_A_SELFIE */ "Please take a selfie",
        /* PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK */ "Please tell us when do you plan to perform this task?",
        /* PLEASE_TYPE_IN_YOUR_PHONE_NUMBER */ "Please type in your phone number",
        /* PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH */ "Please type the code of the agency you would like to work with",
        /* PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER */ "Please type the last 4 digits of this phone number",
        /* PLEASE_TYPE_THE_SMS_CODE */ "Please Type the SMS Code",
        /* PLEASE_UPDATE_TO_OUR_NEWEST_VERSION */ "Please update to our newest version",
        /* PLEASE_UPDATE_YOUR_ADDRESS */ "Please update your address",
        /* PLEASE_UPDATE_YOUR_FIRST_NAME */ "Please update your first name",
        /* PLEASE_UPDATE_YOUR_LAST_NAME */ "Please update your last name",
        /* PLEASE_WAIT */ "Please wait",
        /* PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION */ "Please wait while we're validating your location",
        /* PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP */ "Please watch the full video to proceed to the app",
        /* POINTS */ "Points",
        /* POINTS_AND_REWARDS */ "Points & Rewards",
        /* POSTED_DATE */ "Posted Date",
        /* PREBLOCK_VISIT_EXPLANATION */ "After confirming, you will have limited time to contact the patient and select the time for the visit.",
        /* PRESENTATION */ "Presentation",
        /* PREVIOUS */ "Previous",
        /* PREVIOUS_CONVERSATIONS */ "Previous conversations",
        /* PREVIOUS_WINNERS */ "Previous Winners",
        /* PRE_TAXES */ "pre taxes",
        /* PRICE */ "Price",
        /* PRINCIPAL_DIAGNOSIS */ "Principal Diagnosis",
        /* PRIORITY_CODE */ "Priority Code",
        /* PRIVACY_POLICY */ "Privacy policy",
        /* PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN */ "Problem getting your location, please try again. Try turning location services on, or going outside.",
        /* PROBLEM_WITH_CASE_SETTINGS */ "Looks like you have a problem with your case settings",
        /* PROCESSING */ "Processing",
        /* PROFESSIONAL_TYPE */ "Professional Type",
        /* PROFILE */ "Profile",
        /* PROGRESS */ "Progress",
        /* PROXY_FIRST_NAME */ "Proxy First Name",
        /* PROXY_LAST_NAME */ "Proxy Last Name",
        /* PROXY_PHONE */ "Proxy Phone Number",
        /* PULSE */ "Pulse",
        /* QUESTION */ "Question",
        /* QUESTIONS */ "Questions",
        /* QUESTIONS_TO_COPY_FROM */ "Questions to copy from",
        /* QUESTION_NUMBER */ "Question number",
        /* QUESTION_REJECTED */ "Question rejected",
        /* QUIT */ "Quit",
        /* RAFFLE_ENDED */ "Raffle ended",
        /* RAFFLE_INFO_1_DESCRIPTION */ "We are giving away prizes to the caregivers that will win the raffle! Every raffle a different prize 🙂",
        /* RAFFLE_INFO_1_TITLE */ "Medflyt Raffle!",
        /* RAFFLE_INFO_2_DESCRIPTION */ "To be eligible, you have to work more than 10 visits with Medflyt At Home.\nAnd for every raffle, each 5 visits you make increase your chance of winning the prize! 🏆\nEvery 5 visits = 1 ticket to the raffle.\nYou will get a push notification at the time of the raffle, so enter the app to see if you are the big winner 🎉",
        /* RAFFLE_INFO_2_TITLE */ "How to enter the raffle?",
        /* RAFFLE_INFO_3_DESCRIPTION */ "We will contact you to verify some details and then the prize will be on its way to you!\nOnce you have won a prize in the raffle, you can re-join only 3 raffles later, so that other caregivers can win as well.",
        /* RAFFLE_INFO_3_TITLE */ "I WON! What's next?",
        /* RAFFLE_INFO_4_DESCRIPTION */ "Go get more visits and the increase your chances 💃",
        /* RAFFLE_INFO_4_TITLE */ "SO WHAT ARE YOU WAITING FOR?!?!",
        /* RAFFLE_NOW */ "Now!",
        /* RAFFLE_PRIZE */ "Raffle Prize",
        /* RANK_ACHIEVED */ "Rank achieved",
        /* REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION */ "Reach new ranks for exciting rewards and recognition.",
        /* READY_FOR_YOUR_NEXT_TRAINING */ "Ready for your next training?",
        /* READY_TO_CLOCK_IN */ "Ready to Clock In",
        /* READY_TO_CLOCK_OUT */ "Ready to Clock Out",
        /* READ_AND_CONFIRM */ "Read & Confirm",
        /* READ_ONLY_MODE */ "Read only mode",
        /* READ_TEXT */ "Read Text",
        /* REASON */ "Reason",
        /* RECENT_VISITS */ "Recent visits",
        /* RECOMMENDED */ "Recommended",
        /* RECRUITMENT_MAIN_1 */ "Looks like you are",
        /* RECRUITMENT_MAIN_1_2 */ "not",
        /* RECRUITMENT_MAIN_2 */ "with any agency",
        /* RECRUITMENT_MAIN_2_1 */ "working",
        /* RECRUITMENT_MAIN_3 */ "Get hired by agencies",
        /* RECRUITMENT_MAIN_4 */ "by filling an application",
        /* REFERRAL_CODE */ "Referral code",
        /* REFER_ME */ "Refer me!",
        /* REGISTRATION */ "Registration",
        /* REGULAR_PAY */ "Regular pay",
        /* REJECT */ "Reject",
        /* REJECTED */ "Rejected",
        /* REJECT_THIS_TASK */ "Reject this task",
        /* REJECT_THIS_VISIT */ "Reject this visit",
        /* REMAINED */ "remained",
        /* REMAINING */ "Remaining",
        /* REMIND_ME_LATER */ "Remind Me Later",
        /* REMOVE */ "Remove",
        /* REMOVE_PAGE */ "Remove page",
        /* REMOVE_TASK */ "Remove Task",
        /* REOPENED */ "Reopened",
        /* REPLAY */ "Replay",
        /* REQUEST */ "Request",
        /* REQUESTED */ "Requested",
        /* REQUESTED_LABEL_IN_CASES_LIST */ "\"Requested\" label in cases list.",
        /* REQUESTED_TIMES */ "Requested times",
        /* REQUESTED_VISIT_CANCEL_EXPLANATION */ "If you'd like to make changes to the times, just go ahead and cancel your current request (using the button below) and then submit a new one.",
        /* REQUESTING_REFERENCE_RESPONSE */ "Requesting Reference Response",
        /* REQUEST_AGENCIES_MEMBERSHIP */ "Request agencies membership",
        /* REQUEST_AGENCY */ "Request agency",
        /* REQUEST_AGENCY_MEMBERSHIP */ "Request agency membership",
        /* REQUEST_DETAILS */ "Request details",
        /* REQUEST_FOR_APPOINTMENT */ "request for appointment",
        /* REQUEST_FRIENDSHIP */ "Request Friendship",
        /* REQUEST_MORE_VISITS */ "Request more visits",
        /* REQUEST_MORE_VISITS_MESSAGE */ "It looks like you are not assigned to any visits this week, come back later! 🙂",
        /* REQUEST_NUMBER_SHIFTS */ "Request %shifts% shifts",
        /* REQUEST_SELECTED_SHIFT */ "Request Selected Shift",
        /* REQUEST_SELECTED_SHIFTS */ "Request Selected Shifts",
        /* REQUEST_SHIFTS */ "Request shifts",
        /* REQUEST_SINGLE_SHIFT */ "Request a single shift",
        /* REQUEST_THE_TIMES_YOU_WANT */ "Request the times you want!",
        /* REQUEST_THIS_VISIT */ "Request this visit",
        /* REQUEST_TO */ "Request to",
        /* REQUEST_VISIT */ "Request visit",
        /* REQUIRED */ "Required",
        /* REQUIRED_DOCUMENTS */ "Required documents",
        /* REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC */ "Some required fields in the document are missing, please go back and fill them",
        /* REQUIRED_PATIENT_DOCUMENT_TEXT */ "You're required to fill the following documents on this visit",
        /* REQUIRED_TASKS */ "Required Tasks",
        /* REQUIREMENTS */ "Requirements",
        /* RESCHEDULE */ "Reschedule",
        /* RESCHEDULED_SUCCESSFULLY */ "Rescheduled successfully",
        /* RESCHEDULE_IN_THE_PAST_ERROR */ "Can't reschedule a visit to be in the past.",
        /* RESCHEDULE_REQUESTS */ "Reschedule Requests",
        /* RESET_PIN_CODE_MESSAGE */ "You will be taken to the login screen to start a new authentication process",
        /* RESPIRATION_RATE */ "Respiration Rate",
        /* RESUBMISSION_BANNER_TITLE */ "This document requires changes",
        /* RETAKE */ "Retake",
        /* RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION */ "Retaliatory action by employers; prohibition",
        /* RETRY */ "Retry",
        /* REVIEW_PRIVACY_POLICY */ "View Privacy Policy",
        /* REVIEW_TASK */ "Review Task",
        /* REVIEW_TASKS */ "Review Tasks",
        /* RE_ENTER_YOUR_PIN_CODE */ "Re-enter your PIN code",
        /* RN_FLEXIBLE_SHOWCASE_TEXT */ "Flexible Visit",
        /* RN_FLEX_EXPLANATION_PREFIX */ "This is a",
        /* RN_FLEX_REQUESTED_EXPLANATION */ "You will be requested to select the date and time that suits you",
        /* RN_FLEX_REQUESTED_EXPLANATION_LINE_2 */ "The time frame to perform this visit is the following",
        /* RN_PATIENT_CONTACT_EXPLANATION */ "This visit requires you to coordinate a time with the patient.\n\nClick on the button on the bottom of the screen to contact the patient.",
        /* RN_SIGN_HERE */ "RN sign here",
        /* ROUTING_NUMBER */ "Routing Number",
        /* ROUTING_NUMBR */ "Routing Number",
        /* SAFETY_AND_HEALTH */ "Safety & Health",
        /* SAVE */ "Save",
        /* SAVE_FOR_LATER */ "Save for later!",
        /* SCAN_AND_UPLOAD_FILES */ "Scan & upload files",
        /* SCAN_A_PHOTO */ "Scan a photo",
        /* SCAN_DOCUMENT */ "Scan documents",
        /* SCAN_NEW_DOCUMENT */ "Scan new document",
        /* SCAN_WITH_CAMERA */ "Scan with camera",
        /* SCHEDULE */ "Schedule",
        /* SCHEDULED */ "Scheduled",
        /* SCHEDULED_DATE */ "Scheduled date",
        /* SCHEDULED_FOR */ "Scheduled for",
        /* SCHEDULED_VISIT_COMPLETE */ "Scheduled visit completed",
        /* SCHEDULED_VISIT_NOT_FOUND */ "Scheduled visit not found, please contact the agency",
        /* SCHEDULE_CONFIRMATION */ "Are you sure you want to schedule this task for {{dateTime}}?\n\nWe will contact the patient to confirm visit date and time",
        /* SCHEDULE_FOR */ "Schedule for {{date}}",
        /* SCHEDULE_TASK */ "Schedule Task",
        /* SCHEDULING_PROBLEM */ "Scheduling problem",
        /* SCREENING */ "Screening",
        /* SCREENING_FOR */ "Screening for:",
        /* SEARCH */ "Search",
        /* SEARCH_AGENCY */ "Search agency",
        /* SEARCH_FOR_MEDICATIONS */ "Search for medications...",
        /* SEARCH_NEARY_VISITS */ "Search nearby visits...",
        /* SEARCH_PATIENT */ "Search patient...",
        /* SECOND_SHIFT */ "Second shift",
        /* SECTION_ALREADY_COMPLETED */ "This section was already completed",
        /* SECTION_COMPLETED_PROMPT */ "You have already completed this section",
        /* SECTION_LOCKED_PROMPT */ "Please complete the rest of the application before starting this section",
        /* SEE_ALL */ "See all",
        /* SEE_ALL_CONVERSATIONS */ "See all conversations",
        /* SEE_IN_MAPS */ "See in maps",
        /* SEE_LIST_OF_VISITS */ "See list of visits",
        /* SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT */ "See more information about the pre-screeining requirement",
        /* SEE_YOUR_PROGRESS */ "See your progress",
        /* SELECT */ "Select",
        /* SELECTED */ "Selected",
        /* SELECTED_VISIT */ "Selected visit",
        /* SELECT_ALL */ "Select All",
        /* SELECT_CERTIFICATE */ "Select certificate",
        /* SELECT_DATE */ "Select date",
        /* SELECT_DATE_AND_TIME */ "Select date & time",
        /* SELECT_DOCUMENT */ "Select document",
        /* SELECT_DX_CODE */ "Select DX code",
        /* SELECT_FROM_LIST */ "Select From The List",
        /* SELECT_PERTINENT_DIAGNOSIS */ "Select pertinent diagnosis",
        /* SELECT_PHYSICIAN */ "Select Physician",
        /* SELECT_PRINCIPAL_DIAGNOSIS */ "Select principal diagnosis",
        /* SELECT_SHIFTS */ "Select Shifts",
        /* SELECT_START_TIME */ "Select start time",
        /* SELECT_SURGICAL_PROCEDURE */ "Select surgical procedure",
        /* SELECT_TIME */ "Select time",
        /* SELECT_TIME_SLOT */ "Select time slot",
        /* SELECT_TIME_SLOT_INFO */ "Once you select the date and time, we will contact the patient to get a confirmation",
        /* SELECT_VISITS_FOR_INSTAPAY */ "Select visits for instapay",
        /* SELECT_VISIT_DURATION */ "Select visit duration",
        /* SELECT_YOUR_SCHEDULE */ "Select your schedule",
        /* SELFIE_WITH_PATIENT */ "Selfie with patient",
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN */ "It's time to clock in. Please take a quick selfie with your patient to complete the process.",
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT */ "It's time to clock out. Please take a quick selfie with your patient to complete the process.",
        /* SEND_A_MESSAGE */ "Send a message",
        /* SEND_EMAIL */ "Send Email",
        /* SEND_REPORT */ "Send report",
        /* SEND_US_A_MAIL */ "Send us an email",
        /* SEPTEMBER */ "September",
        /* SETTINGS */ "Settings",
        /* SETTINGS_AND_INFO */ "Settings and Info",
        /* SET_DOCUMENT_EXPIRY_DATE */ "Set document expiry date",
        /* SET_EXPIRATION_DATE */ "Set expiration date",
        /* SET_YOUR_4_DIGIT_PIN_CODE */ "Set your 4-digit PIN code",
        /* SHARE */ "Share",
        /* SHARE_IDEAS_AND_GET_A_CHANCE */ "Share ideas and get a chance to",
        /* SHARE_REFERENCE_LINK */ "Share reference link",
        /* SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP */ "Share the reference link to speed things up!",
        /* SHARE_WITH_YOUR_FRIENDS */ "Share with your friends!",
        /* SHIFT */ "Shift",
        /* SHIFTS */ "Shifts",
        /* SHIFTS_DETAILS */ "Shifts details",
        /* SHIFT_HAS_FINISHED_IN */ "Shift ended at",
        /* SHIFT_HAS_STARTED_IN */ "Shift started at",
        /* SHOULD_BE_HERE */ "should be here",
        /* SHOW_ALL_TASKS */ "Show all tasks",
        /* SHOW_DETAILS */ "Show details",
        /* SHOW_LESS */ "Show less",
        /* SHOW_ME_CASES_IN_THE_NEXT */ "Show me cases in the next",
        /* SHOW_ME_IN */ "Show me in",
        /* SHOW_MORE */ "Show more",
        /* SHOW_OLD_PLAN_OF_CARE */ "Show old plan of care",
        /* SHOW_TASKS_THAT_REQUIRE_FIXES */ "Show tasks that require fixes",
        /* SHOW_US_YOUR_SMILE */ "Show us your smile! 😊",
        /* SIGNATURES */ "Signatures",
        /* SIGNATURE_REQUIRED */ "Signature Required",
        /* SIGN_DECLINATION_FORM */ "Sign Declination Form",
        /* SIGN_HERE */ "Sign Here",
        /* SIGN_IN */ "Sign-In",
        /* SIGN_ORIENTATION_VIDEO */ "Please sign here before submitting",
        /* SIGN_ORIENTATION_VIDEO_ERR */ "Please sign before submitting",
        /* SIGN_OUT */ "Sign Out",
        /* SIGN_UP_FREE */ "Sign up free",
        /* SIGN_UP_ITS_FREE */ "Sign up. it's free!",
        /* SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE */ "Since you clocked in & out on time you can get 80% of the shift's payment today :)",
        /* SINGLE_FLEXIBLE_VISIT_EXPLANATION */ "This is a single visit for {{durationHours}} hours on {{date}}.\nThe hours are whatever works for you!",
        /* SINGLE_VISIT_DETAILS */ "Single visit details",
        /* SINGLE_VISIT_FROM */ "Single visit from",
        /* SINGLE_VISIT_TYPE */ "Single Visit",
        /* SIXTY_SECONDS_AND_YOU_ARE_DONE */ "✍🏻 60 seconds & you're done!",
        /* SKIP */ "Skip",
        /* SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION */ "The exact address will be provided after the final confirmation",
        /* SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS */ "We need to get confirmation from more people as well that might change the visit, we will update you in the next few hours",
        /* SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN */ "You can view all the information on the assigned visits screen. Good luck!",
        /* SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES */ "Please notice – if you don’t show up to the visit (unless for specific reasons) you won’t be able to get more cases in this agency and you will be terminated!",
        /* SLIDE_MAIN_INFO_GO_NEXT_SCREENS */ "Please go over the information in the next screens to make sure you can start working on this case",
        /* SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW */ "All you need to know about your new visit!",
        /* SLIDE_STEP_X_OF_COUNT */ "STEP %step% OF %steps_count%",
        /* SMILE_FOR_US */ "Smile for us! 📷",
        /* SOCIAL */ "Social",
        /* SOCIAL_MEDIA */ "Social media",
        /* SOMETHING_WENT_WRONG */ "Something went wrong, please try again later",
        /* SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS */ "Revised Questions Appear in Other Documents",
        /* SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM */ "Some questions also appear in {{documents_count}} other documents: {{documents_name}}.\nWould you like to update the answer in all of them?",
        /* SOME_TASKS_NEED_FIXES */ "Some tasks need fixes",
        /* SORRY */ "Sorry",
        /* SORT */ "Sort",
        /* SPECIFIC_DAYS */ "Specific days",
        /* SPEECH_RECOGNITION */ "Speech Recognition",
        /* SPLIT_SHIFTS_VISIT */ "Split shifts",
        /* SPREAD_THE_WORD */ "Spread the word",
        /* STAGE_APPROVED_MESSAGE */ "We have approved this question",
        /* STAGE_AWAITING_APPROVAL */ "This question is awaiting approval from the agency. Our team will review it shortly",
        /* STAGE_COMPLETED_MESSAGE */ "You have completed this question",
        /* STAGE_X_OF_TOTAL_STAGES */ "of",
        /* START */ "Start",
        /* STARTING_AT */ "Starting at",
        /* STARTS */ "Starts",
        /* STARTS_NEXT_WEEK */ "Starts next week",
        /* STARTS_TODAY_IN */ "Starts today in {{time}}",
        /* START_APPLICATION */ "Start Application",
        /* START_A_SURVEY */ "Start survey!",
        /* START_DATE */ "Start date",
        /* START_FILLING */ "Start filling",
        /* START_NOW */ "Start Now",
        /* START_SHIFT */ "Start shift",
        /* START_TIME */ "Start time",
        /* START_USING_MEDFLYT_PASSPORT */ "Start using MedFlyt Passport",
        /* START_WATCHING */ "Start watching!",
        /* START_WATCHING_ORIENTATION_VIDEOS */ "Start watching your orientation videos",
        /* START_WORKING */ "Start working",
        /* STATUS */ "Status",
        /* STAY_ON_TRACK */ "Stay on Track",
        /* STAY_ON_TRACK_1_ANSWER */ "If you inform us over 24h before the visit, your streak remains.",
        /* STAY_ON_TRACK_1_QUESTION */ "Notified More Than 24h",
        /* STAY_ON_TRACK_2_ANSWER */ "Notify us 3-24h before the visit, and your streak breaks, resetting visits in the current rank.",
        /* STAY_ON_TRACK_2_QUESTION */ "Notified Less Than 24h, More Than 3h",
        /* STAY_ON_TRACK_3_ANSWER */ "Notify us less than 3h before the visit, and your streak breaks, dropping you a rank.",
        /* STAY_ON_TRACK_3_QUESTION */ "Notified Less Than 3h",
        /* STAY_ON_TRACK_4_ANSWER */ "Fail to notify before the visit starts, and your streak breaks, resetting you to the first rank.",
        /* STAY_ON_TRACK_4_QUESTION */ "No Call No Show",
        /* STAY_ON_TRACK_DESCRIPTION */ "Missing a visit without an approved reason will break your visits streak!",
        /* STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS */ "Stay tuned for more cases or tap to change case settings",
        /* STAY_TUNED_FOR_MORE_VISITS */ "Stay tuned for more visits",
        /* STAY_TUNED_FOR_THE_NEXT_RAFFLE */ "Stay tuned for the next raffle!",
        /* STILL_WAITING_REFERENCE_ANSWER */ "We are still waiting for answers from your reference -{REFERENCE_NAME} - {REFERENCE_PHONE_NUMBER}Please contact them and make sure that they are replying to our emails 🙏🏼",
        /* STOP */ "Stop",
        /* STREAK_BREAK */ "Streak Break",
        /* STREAK_BREAK_MESSAGE */ "Due to a missed visit your streak was broken, and your rank was reset.",
        /* STREAK_BREAK_MESSAGE_2 */ "Continue with your visits streak and you keep on going!",
        /* SUBMIT */ "Submit",
        /* SUBMITTED_AT */ "Submitted at",
        /* SUBMITTED_DOCUMENTS */ "Submitted Documents",
        /* SUBMITTED_MANUALLY */ "Submitted Manually",
        /* SUBMIT_AFTER */ "Submit after",
        /* SUBMIT_AT */ "Submit at",
        /* SUBMIT_BY */ "Submit by",
        /* SUBMIT_DUTIES */ "Submit duties",
        /* SUBMIT_DUTIES_BEFORE_CLOCK_OUT */ "Please submit the visit’s duties before clocking out",
        /* SUBMIT_FORM */ "Submit form",
        /* SUBMIT_FORMS */ "Submit forms",
        /* SUBMIT_MANUAL_TIMESHEET */ "Submit manual timesheet",
        /* SUBMIT_REQUIRED */ "Submit Required",
        /* SUBMIT_TEST */ "Submit Test",
        /* SUBMIT_TIMESHEET */ "Submit timesheet",
        /* SUBMIT_WITH_SCHEDULED_DATE */ "Submit with the scheduled date",
        /* SUBMIT_WITH_TODAY_DATE */ "Submit with today's date",
        /* SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT */ "Submit your documents to get compliant",
        /* SUBMIT_YOUR_SIGN */ "Submit Your Sign",
        /* SUBMIT_YOUR_SIGNATURE */ "Submit your signature",
        /* SUCCESS */ "Success",
        /* SUCCESSFULLY_CLOCKED_IN */ "Successfully clocked in",
        /* SUCCESSFULLY_CLOCKED_OUT */ "Successfully clocked out",
        /* SUCCESSFULY_REQUESTED */ "Successfully requested!",
        /* SURGICAL_PROCEDURE */ "Surgical Procedure",
        /* SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS */ "Switch to list view to see your imported visits",
        /* SWITCH_VIEW */ "Switch view",
        /* TAKE_A_DIFFERENT_PHOTO */ "Take a different photo",
        /* TAKE_A_PHOTO */ "Take a Photo",
        /* TAKE_A_SURVEY */ "Take a survey and win a chance to get a",
        /* TAKE_ME_TO_CASE_SETTINGS */ "Take me to case settings",
        /* TAKE_PHOTO */ "Take photo",
        /* TAKE_THIS_TASK */ "Take this task",
        /* TAP_HERE_TO_VIEW */ "Tap Here To View",
        /* TAP_TO_CANCEL */ "Tap to cancel",
        /* TAP_TO_CHANGE_CASE_SETTINGS */ "Tap to change case settings",
        /* TASK */ "Task",
        /* TASKS */ "Tasks",
        /* TASK_ALREADY_ASSIGNED */ "A different nurse already took this task, go back to the list and request a different one 🙂",
        /* TASK_COMPLETED_SUCCESSFULLY */ "Congratulations 💪🏻You completed this task.",
        /* TASK_INFORMATION */ "Task information",
        /* TASK_SCHEDULED */ "Task Scheduled",
        /* TASK_SCHEDULED_MESSAGE */ "We will notify the patient, and will let you know once they confirm",
        /* TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE */ "Task was removed from your schedule",
        /* TECHNICAL_SUPPORT */ "Technical Support",
        /* TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES */ "Tell us why you are not interested so we can send you better cases",
        /* TELL_US_YOUR_AGENY_DESCRIPTION */ "Tell us your agency name, coordinator name and we’ll contact them to broadcast open cases.",
        /* TEMPERATURE */ "Temperature",
        /* TEN_DOLLAR_STARBUCKS_GIFT_CARD */ "$10 Starbucks gift card",
        /* TERMINATED */ "Terminated",
        /* TERMS_OF_MEDFLYT_PRIVACY_POLICY */ "Terms of Medflyt Privacy Policy",
        /* TERMS_OF_USE */ "Terms of use",
        /* TEST */ "Test",
        /* TESTS */ "Tests",
        /* TEST_COMPLETED */ "Test completed",
        /* TEST_FAILED */ "Test Failed",
        /* TEST_REQUIRED */ "Test Required",
        /* THANKS */ "Thanks!",
        /* THANK_YOU */ "Thank you!",
        /* THANK_YOU_FOR_YOUR_FEEDBACK */ "Thank you for your feedback.",
        /* THATS_ME */ "That's me",
        /* THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION */ "There's %countdown% hours until final confirmation.",
        /* THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS */ "There are issues with some of your visits.",
        /* THERE_ARE_NO_AGENCIES_YET */ "There are no agencies yet",
        /* THERE_ARE_NO_ASSIGNED_CASES */ "There are no assigned cases",
        /* THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION */ "There is a problem with your internet connection",
        /* THERE_SEEMS_TO_BE_NOTHING_HERE */ "There seems to be nothing here...",
        /* THE_AWARDS_ARE_COMING_SOON */ "The awards are coming soon!",
        /* THE_BEST_PLACE_FOR_CAREGIVERS */ "The best place for caregivers",
        /* THE_DUTY_SHEET_HAS_BEEN_SUBMITTED */ "Well done! The duty sheet has been submitted.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY */ "The money will be transferred by 12:30 PM today.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW */ "The money will be transferred by 12:30 PM tomorrow.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY */ "The money will be transferred by 6 PM today.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING */ "The money will be transferred by Monday morning.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON */ "The money will be transferred to you soon.",
        /* THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS */ "The more visits you complete, the higher your earnings",
        /* THE_NEXT_WINNERS_ANNOUNCEMENT */ "The next winner’s announcement",
        /* THE_SELECTED_DATE_IS_EARLIER_THAN */ "The selected date is earlier than the minimum allowed date. Please choose a date on or after {date}",
        /* THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS */ "The visit can be performed on the following days",
        /* THE_VISIT_HAS_NOT_STARTED_YET */ "The visit has not started yet!",
        /* THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS */ "This benefit will be offered for the next few months. Start collecting your visits.",
        /* THIS_BUNDLE_INCLUDES */ "This bundle includes",
        /* THIS_CONVERSATION_HAS_BEEN_RESOLVED */ "This conversation has been resolved. Please start a new conversation to continue",
        /* THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK */ "This course consists of %d lessons. Good luck!",
        /* THIS_FIELD_IS_CURRENTLY_DISABLED */ "This field is currently disabled.",
        /* THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT */ "This is an old visit, unable to clock in/out",
        /* THIS_IS_A_FUTURE_VISIT */ "This is a future visit, you can only start this visit on {start_date} at {start_time}.",
        /* THIS_IS_A_LIVE_CLASS_SESSION */ "This is a {duration} live class session ({date_time})",
        /* THIS_MAY_TAKE_UP_TO_X_SECONDS */ "This may take up to {SECONDS} seconds",
        /* THIS_PATIENT_BELONGS_TO_AGENCY */ "This patient belongs to agency: {{agencyName}}",
        /* THIS_PATIENT_HAS_NO_PHONE_NUMBERS */ "This patient has no phone numbers",
        /* THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER */ "This question is read only. You are not allowed to answer.",
        /* THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP */ "This task is overdue! schedule as soon as possible",
        /* THIS_VISIT_CAN_BE_PERFORMED_BETWEEN */ "This visit can be performed between",
        /* THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE */ "This visit does not require any tasks to be done",
        /* THIS_VISIT_IS_FOR_DIFFERENT_AGENCY */ "This visit is for agency: {{agencyName}}",
        /* THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET */ "This visit is in the future, you can not clock in yet",
        /* THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY */ "This will allow you to easily access your InstaPay 💸💸",
        /* THIS_WILL_MARK_THE_VISIT_AS_MISSED */ "This will mark the visit as missed and you will be paid for travel time",
        /* TIME */ "Time",
        /* TIMESHEET_SUBMITTED */ "Timesheet submitted",
        /* TIME_ESTIMATION */ "Time estimation",
        /* TIME_FRAME */ "Time Frame",
        /* TIME_LEFT */ "Time left",
        /* TIME_VARIES */ "Time varies",
        /* TO */ "To",
        /* TODAY */ "Today",
        /* TODAYS_DATE */ "Today's date",
        /* TOKENS */ "tokens",
        /* TOO_MANY_HOURS */ "Too many hours",
        /* TOO_MANY_SHIFTS */ "Too many shifts!",
        /* TOO_MANY_SHIFTS_MESSAGE */ "You are allowed to pick up to %maxShifts% shifts. If you want to pick this shift, you will have to deselect one of your already selected shifts.",
        /* TOP_CAREGIVERS_IN_YOUR_AREA */ "Top caregivers in your area",
        /* TOTAL_EARNED */ "Total Earned",
        /* TOTAL_SPENT */ "Total Spent",
        /* TO_FILL_IN_A_FORM_INSTEAD */ "To fill in a form instead,",
        /* TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT */ "To get paid on time - you need to clock in and out.",
        /* TO_SEE_THIS_TASK_GO_TO_ASSIGNED */ "To see this task go to \"Assigned\" tab",
        /* TO_SEE_THIS_VISIT_GO_TO */ "To see this visit look for",
        /* TO_UPLOAD_A_FILE_INSTEAD */ "To upload a file instead,",
        /* TO_WIN_AN_IPHONE12 */ "Win an iPhone 12",
        /* TRAINING */ "Training",
        /* TRAININGS_FOR */ "Trainings for",
        /* TRAINING_CENTER */ "Training Center",
        /* TRAINING_CENTER_REMINDERS */ "Training Center Reminders",
        /* TRY_AGAIN */ "Try again",
        /* TYPE_AGENCY_CODE */ "Type agency code",
        /* TYPE_MESSAGE */ "Type message",
        /* TYPE_YOUR_ADDRESS */ "Type in your address",
        /* UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET */ "The duty sheet has been submitted. You are not allowed to edit it.",
        /* UNANSWERED_LAST_SECTION_FOR_NOW */ "This is the last section for now, and you didn't answer all the questions. You can go back and complete them or come back later",
        /* UNAUTHORIZED */ "Unauthorized",
        /* UNAVAILABLE_LOCATION_SERVICES_MESSAGE */ "It looks like we can't access your device location. Please make sure your location services are turned on and are available.",
        /* UNDER_REVIEW */ "Under review",
        /* UNDO */ "Undo",
        /* UNIQUE_ERROR_CODE */ "Unique error code",
        /* UNSCHEDULE */ "Unschedule",
        /* UNSCHEDULE_TASK */ "Unschedule task",
        /* UNSPECIFIED */ "Unspecified",
        /* UNTIL */ "Until",
        /* UPCOMING_VISITS */ "Upcoming visits",
        /* UPDATED_AT */ "Updated At",
        /* UPDATE_INFORMATION */ "Update Information",
        /* UPLOAD */ "Upload",
        /* UPLOADED */ "Uploaded",
        /* UPLOADED_FILE_VIEW */ "Uploaded File View",
        /* UPLOADING */ "Uploading",
        /* UPLOAD_A_DOCUMENT */ "Upload a document",
        /* UPLOAD_A_FILE */ "Upload a file",
        /* UPLOAD_DOCUMENT */ "Upload document",
        /* UPLOAD_DOCUMENTS */ "Upload documents",
        /* UPLOAD_ERROR */ "Upload error",
        /* UPLOAD_FILES_TO_ENSURE */ "Upload files to ensure",
        /* UPLOAD_FLU_SHOT_DOCUMENT */ "Upload Flu Shot Document",
        /* UPLOAD_FROM_GALLERY */ "Upload from gallery",
        /* UPLOAD_NEW_DOCUMENT */ "Upload new document",
        /* UPLOAD_VIDEO */ "Upload video",
        /* UPLOAD_YOUR_FILES_TO_ENSURE */ "Upload your files to ensure",
        /* UP_COMING_REASSESSMENTS */ "Upcoming reassessments",
        /* UP_TO */ "Up to",
        /* URGENT */ "Urgent",
        /* USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY */ "This user has been locked due to suspicious activity",
        /* VALID */ "Valid",
        /* VERIFIED */ "Verified",
        /* VERIFY */ "Verify",
        /* VERIFYING */ "Verifying",
        /* VERIFY_YOUR_LOCATION */ "Verify your location",
        /* VERY_URGENT */ "Very Urgent",
        /* VIDEO */ "Video",
        /* VIDEOS */ "Videos",
        /* VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION */ "videos in training center require your attention.",
        /* VIDEO_COMPLETED_SUCCESSFULLY */ "Congratulations 💪🏻You completed watching the video.",
        /* VIEW */ "View",
        /* VIEWED */ "Viewed",
        /* VIEW_ALL */ "View all",
        /* VIEW_ANSWERS */ "View answers",
        /* VIEW_CERTIFICATE */ "View Certificate",
        /* VIEW_TASK */ "View Task",
        /* VIEW_TASKS_PENDING_FOR_SCHEDULE */ "View tasks pending for schedule",
        /* VIEW_VISIT */ "View visit",
        /* VIRTUAL_ID_CARD */ "Virtual ID card",
        /* VISIT */ "Visit",
        /* VISITS */ "visits",
        /* VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER */ "Search your address for visits near you...",
        /* VISITS_NEXT_MONTH */ "visits next month",
        /* VISITS_OUTSIDE_YOUR_AVAILABILITY */ "Visits outside your availability",
        /* VISITS_PER_WEEK */ "Visits per week",
        /* VISITS_WITH_ISSUES */ "Visits with issues",
        /* VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE */ "Visit is assigned, check it out in your schedule",
        /* VISIT_BY */ "Visit by",
        /* VISIT_CHAT */ "Visit Chat",
        /* VISIT_COMPLETE */ "You have completed this visit!",
        /* VISIT_COMPLETED_SUCCESSFULLY */ "Visit completed successfully",
        /* VISIT_COUNTS */ "Visit Counts",
        /* VISIT_COUNTS_DESCRIPTION */ "Each rank requires 5-25 visits. Keep up the great work to move up.",
        /* VISIT_DATE */ "Visit date",
        /* VISIT_DATES */ "Visit dates",
        /* VISIT_DETAILS */ "Visit Details",
        /* VISIT_DURATION */ "Visit duration",
        /* VISIT_INFORMATION */ "Visit information",
        /* VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU */ "The visit is near {ADDRESS} which is {MILES} miles away from you.",
        /* VISIT_LASTING */ "Visit lasting",
        /* VISIT_NEXT_MONTH */ "visit next month",
        /* VISIT_NOTIFICATIONS_OFF */ "Visit notifications - OFF",
        /* VISIT_NOTIFICATIONS_ON */ "Visit notifications - ON",
        /* VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE */ "You haven't clocked in this visit yet. Are you sure you want to clock out?",
        /* VISIT_NO_LONGER_AVAILABLE */ "Visit no longer available",
        /* VISIT_RATE_REQUEST_CONFIRMATION */ "The rate is {VISIT_RATE}$, estimated {ESTIMATED_SALARY}$ per week.",
        /* VISIT_REMINDERS */ "Visit Reminders",
        /* VISIT_REQUEST_CONFIRMATION_WARNING */ "Only request the case if you intent to take it. Refusing a case after requesting can affect your rating in the agency.",
        /* VISIT_SCHEDULE */ "Visit schedule",
        /* VISIT_STARTED_AT */ "Visit started at",
        /* VISIT_STARTED_MISSING_CLOCK_IN */ "Visit started, missing clock in",
        /* VISIT_STARTS_AT */ "Visit starts at",
        /* VISIT_SUCESSFULLY_CANCELED */ "Visit successfully canceled",
        /* VISIT_TIME_ADJUSTMENT */ "Visit time adjustment",
        /* VISIT_TIME_ADJUSTMENT_CONTENT_EARLY */ "Your clock in time is earlier than the scheduled time, no worries :) Would you like to adjust the visit end time accordingly?",
        /* VISIT_TIME_ADJUSTMENT_CONTENT_LATE */ "Your clock in time is later than the scheduled time, no worries :) Would you like to adjust the visit end time accordingly?",
        /* VISIT_TOO_SHORT */ "The total time of the visit according to the clock in and out doesn’t match the scheduled time",
        /* VISIT_TYPE */ "Visit type",
        /* VISIT_WITH */ "Visit with",
        /* VOUCHER */ "Voucher",
        /* WAITING_FOR_APPROVAL */ "Waiting for approval",
        /* WAITING_TO_BE_SCHEDULED */ "waiting to be scheduled",
        /* WARNING */ "Warning!",
        /* WAS_DUE_BETWEEN */ "Was due between {dateFrom} and {dateTo}",
        /* WAS_DUE_ON */ "Was due on",
        /* WATCHED */ "Watched",
        /* WATCH_HOW_IT_WORKS */ "Watch how it works",
        /* WATCH_REQUIRED */ "Watch Required",
        /* WATCH_TRAINING_VIDEOS_TO_COMPLETE */ "🎥 Watch training videos to complete",
        /* WEEKLY_DETAILS */ "Weekly details",
        /* WELCOME */ "Welcome",
        /* WELCOME_BACK */ "Welcome back",
        /* WELCOME_TO_CARE_MOMENTS */ "Welcome to Care Moments",
        /* WELCOME_TO_MEDFLYT */ "Welcome to MedFlyt!",
        /* WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE */ "We'll be happy to assign you to this visit! but first, you must finish the onboarding.\r\n            It's really easy 🥰",
        /* WELL_BE_IN_TOUCH_SHORTLY */ "We'll be in touch shortly.",
        /* WERE_YOU_REFERRED_BY_SOMEONE */ "Were you referred by someone?",
        /* WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM */ "We are missing the record for your %compliance_item%. Let's fix it!",
        /* WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR */ "We couldn't find the medication you're looking for",
        /* WE_COULDNT_FIND_YOUR_AGENCY */ "We couldn't find your agency!",
        /* WE_GOT_YOUR_CONFIRMATION */ "We got your confirmation!",
        /* WE_GOT_YOUR_RESPONSE_WAIT_HH_MM */ "We got your response! You have %countdown% until the final confirmation 🤩",
        /* WE_HAVE_ONE_MATCHING_ACCOUNT */ "We have found one matching account based on details you have provided. is that you?",
        /* WE_HAVE_X_MATCHING_ACCOUNTS */ "Is there a chance that one of the following accounts is you?",
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN */ "We need a selfie to verify your identity before you clock in",
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT */ "We need a selfie to verify your identity before you clock out",
        /* WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT */ "We were unable to log you in. Please contact MedFlyt support",
        /* WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON */ "We will send you the final confirmation soon",
        /* WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE */ "What a nice photo! Should we continue?",
        /* WHAT_BENEFITS_CAN_YOU_GET */ "What benefits can you get?",
        /* WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK */ "What is the reason you want to remove the task",
        /* WHAT_WOULD_YOU_LIKE_TO_DO_FIRST */ "What would you like to do first?",
        /* WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT */ "Whenever you see a flexible visit you'll be able to request the times that fit you",
        /* WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR */ "Which visits would you like to get InstaPay for?",
        /* WHOOPS */ "Whoops",
        /* WHOS_THE_LUCKY_ONE */ "Who's the Lucky One?",
        /* WILL_BEGIN_SHORTLY */ "will begin shortly",
        /* WILL_EXPIRE_IN_DAYS */ "Will expire in %days% days",
        /* WILL_EXPIRE_TOMORROW */ "Will expire tomorrow",
        /* WINNER_ANNOUNCED_IN */ "Winner announced in",
        /* WITH_CAREGIVERS */ "With Caregivers",
        /* WORKING_WITH_AGENCY */ "I'm working with an agency",
        /* WRONG_DATES_SELECTION */ "Wrong Dates Selection",
        /* WRONG_PHONE_NUMBER */ "Wrong Phone Number",
        /* WRONG_PIN */ "Wrong PIN",
        /* X_DAYS_SELECTED */ "%x% days selected",
        /* X_DAYS_TO_COMPLETE */ "%d days to complete",
        /* X_DAYS_TO_SELECT */ "%x% days to select",
        /* X_HOURS_SELECTED */ "%x% hours selected",
        /* X_HOURS_TO_SELECT */ "%x% hours to select",
        /* YAY_YOU_WERE_ASSIGNED_TO_A_VISIT */ "Yay you were assigned to a visit",
        /* YEAR */ "Year",
        /* YEARS_OLD */ "Years old",
        /* YES */ "Yes",
        /* YES_ADJUST_TIMES */ "Yes, adjust times",
        /* YES_DELETE */ "Yes, delete",
        /* YES_I_AM_SURE */ "Yes, I am sure",
        /* YES_OVERRIDE_FORM */ "Yes, Override form",
        /* YES_REQUEST_ANYWAY */ "Yes, request anyway",
        /* YES_SCHEDULE_VISIT */ "Yes, Schedule the visit",
        /* YES_THATS_ME */ "Yes, that's me",
        /* YES_UPDATE_ALL */ "Yes, update all",
        /* YOURE_ALL_DONE_LETS_GET_YOU_WORKING */ "You're all done! Let's get you working! 😁",
        /* YOURE_IN_THE_RAFFLE */ "You're in the raffle!",
        /* YOURE_NOT_IN_THE_RAFFLE */ "You're not in the raffle!",
        /* YOURSELF */ "Yourself",
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD */ "Your account is currently on hold",
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE */ "Your account is currently on leave",
        /* YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS */ "Your agency may not have assigned you lessons. Please try later.",
        /* YOUR_ANSWER_IS_CORRECT */ "Your answer is correct!",
        /* YOUR_ANSWER_IS_INCORRECT */ "Your answer is incorrect",
        /* YOUR_COMPLIANCE */ "Your compliance",
        /* YOUR_COMPLIANCE_ITEM_HAS_EXPIRED */ "Your %compliance_item% has expired. Please get a new one and upload through the app",
        /* YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS */ "Your %compliance_item% is due in %days% days. Please get a new one and upload through the app",
        /* YOUR_FILE_IS_BEING_UPLOADED */ "Your file is being uploaded",
        /* YOUR_IN_SERVICE_IS_DUE_IN_DAYS */ "Your in-service is due in %days% days. Complete it now to stay compliant!",
        /* YOUR_IN_SERVICE_IS_OVER_DUE */ "Your in-service is over due, you have to complete it ASAP to be compliant.",
        /* YOUR_MOBILE */ "Your Mobile",
        /* YOUR_REFERERAL_CODE */ "Your referral code",
        /* YOUR_TASK_HAS_BEEN_SCHEDULED_FOR */ "Your task has been scheduled for {{dateTime}}",
        /* YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY */ "Your timesheet has been submitted successfully.",
        /* YOUVE_BEEN_SUCCESSFULLY_REFERRED */ "You’ve been successfully referred!",
        /* YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "You've completed all the lessons for now",
        /* YOU_ALREADY_FAILED */ "you already failed the test.",
        /* YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT */ "You already have a visit scheduled for that time slot",
        /* YOU_ALREADY_REQUESTED_THIS_VISIT */ "You already requested this visit!",
        /* YOU_ALREADY_SUCCEEDED */ "you already succeeded the test.",
        /* YOU_ARE_ALL_SET */ "You're all set.",
        /* YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION */ "You’re being redirected to the next section!",
        /* YOU_ARE_COMPLIANT */ "You are compliant",
        /* YOU_ARE_EXEMPT_FROM_THIS_TEST */ "you are exempt from this test",
        /* YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD */ "You are not allowed to edit this field.",
        /* YOU_ARE_NOT_COMPLIANT */ "You are not compliant",
        /* YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM */ "You are not compliant, and it may prevent you from attending more visits in the near future. In order to keep working, let's solve your compliance issues!",
        /* YOU_ARE_OUT_OF_COMPLIANCE */ "You are out of compliance. Go to the compliance page to learn more",
        /* YOU_ARE_X_DAYS_LATE */ "You're %d days late.",
        /* YOU_CANNOT_EDIT_YOUR_ANSWERS */ "You cannot edit your answers",
        /* YOU_CANT_EDIT_VISIT_WITH_CICO */ "You can’t edit a visit with a clock in or out",
        /* YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES */ "You can't have more than one principal or surgical diagnoses.",
        /* YOU_CANT_SIGN_BEFORE_ALL_ANSWERED */ "You can sign this document only when all the questions are completed",
        /* YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE */ "You can't use the same ICD code more than once.",
        /* YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT */ "You can choose which days and hours!",
        /* YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT */ "You can choose which days!",
        /* YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT */ "You can choose which hours!",
        /* YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME */ "You can collect your points in the meantime 🥳",
        /* YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED */ "You can contact the patient if needed",
        /* YOU_CAN_CONTINUE_TO_NEXT_SECTION */ "In the meantime you can continue to the next section!",
        /* YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY */ "You currently don't have enough balance to get InstaPaid.",
        /* YOU_DIDNT_ANSWER_ALL_QUESTIONS */ "You didn't answer all the questions, you can come back to them later.",
        /* YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN */ "You did not enter the same PIN code. Please try again.",
        /* YOU_DONT_HAVE_ANY_CASES_YET */ "You don’t have any cases yet",
        /* YOU_DONT_HAVE_ANY_PATIENTS_YET */ "You don't have any patients yet",
        /* YOU_GET_POINTS */ "You get points:",
        /* YOU_GOT_THE_CASE */ "You got the case!",
        /* YOU_GOT_THE_CERTIFICATE */ "You got the certificate!",
        /* YOU_HAVENT_CLOCKED_IN_YET */ "You haven't clocked in yet",
        /* YOU_HAVENT_CLOCKED_OUT_YET */ "You haven't clocked out yet",
        /* YOU_HAVENT_UPLOADED_ANYTHING_YET */ "You haven't uploaded anything yet",
        /* YOU_HAVE_COMPLETED_THIS_TEST */ "You have completed this test",
        /* YOU_HAVE_HH_MM_TO_CONFIRM_IT */ "You have %countdown% to confirm it!",
        /* YOU_HAVE_MISSING_COMPLIANCE_ITEMS */ "You have missing compliance items. Go to the compliance page to learn more",
        /* YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW */ "You have more than 1 shift that is active now",
        /* YOU_HAVE_NOT_WATCHED */ "you have not watched",
        /* YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY */ "You have no attempts left. Please contact your agency",
        /* YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS */ "You have no tokens. Complete more shifts to earn tokens!",
        /* YOU_HAVE_ONE_ATTEMPT_LEFT */ "You have one attempt left",
        /* YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING */ "You have one day to complete this training!",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION */ "You have successfully completed the %section%",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING */ "You have successfully completed this training 🚀",
        /* YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY */ "You have to complete this training today. Hurry up!",
        /* YOU_HAVE_TO_ENROLL_FIRST */ "IN ORDER TO WATCH THIS LESSON, YOU HAVE TO ENROLL FIRST",
        /* YOU_HAVE_TO_PICK_A_CODE */ "You have to pick a code.",
        /* YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT */ "You have to select at least one shift",
        /* YOU_HAVE_X_ATTEMPTS_LEFT */ "You have %d attempts left",
        /* YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST */ "You have %d attempts to answer this test",
        /* YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y */ "You have %d correct answers out of %d",
        /* YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING */ "You have %d days to complete this training!",
        /* YOU_JUST_GOT_PAID */ "YOU JUST GOT PAID 🥳",
        /* YOU_JUST_GOT_PROMOTED_TO */ "You just got promoted to",
        /* YOU_LOSE_POINTS */ "You lose points:",
        /* YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS */ "You may change your visit settings to receive more relevant visits",
        /* YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE */ "You may not answer the test because",
        /* YOU_MAY_ONLY_SUBMIT_AFTER */ "You may only submit after completing",
        /* YOU_MISSED_A_SHIFT_WITHOUT_NOTICE */ "You missed a shift without notice. You're out of this raffle",
        /* YOU_MUST_ANSWER_ALL_THE_QUESTIONS */ "You must answer all the questions.",
        /* YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT */ "You must submit all the duties before clocking out",
        /* YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST */ "You Must watch the previous videos first",
        /* YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION */ "You need to allow access to your GPS location. Otherwise, you won’t be able to clock in or out.",
        /* YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE */ "You need to complete {shifts} more shifts to enter the raffle",
        /* YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS */ "You need to enter a note to all the required tasks that are not completed, explaining why you didn’t complete this task 🙏🏼",
        /* YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS */ "You need to mark all the required tasks as completed or not completed 🙏🏼",
        /* YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT */ "You need to submit all the documents before you can clock out",
        /* YOU_RECENTLY_WON_A_RAFFLE */ "You recently won a raffle",
        /* YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT */ "You should wear your mask the whole visit",
        /* YOU_USED_THE_CODE */ "You used the code",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE */ "You will fall out of compliance in %days% days. Go to the compliance page to learn more",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS */ "You will fall out of compliance in %days% days. You may not be able to attend visits once you are not compliant.",
        /* YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS */ "you will see the money in your account in the next 24 hours."
    ],
    "es": [
        /* ACCEPTED */ "Aceptada",
        /* ACCEPT_THESE_HOURS */ "Aceptar estas horas",
        /* ACCEPT_THE_VISIT_AT */ "Aceptar la visita a las",
        /* ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY */ null,
        /* ACCOUNT_NUMBER */ "Número de cuenta",
        /* ACCOUNT_TYPE */ "Tipo de cuenta",
        /* ACTIVE */ "Activo",
        /* ACTIVE_DOCUMENT */ "Documento activo",
        /* ADD */ "Agregar",
        /* ADDITIONAL_NOTES */ null,
        /* ADDRESS */ "Domicilio",
        /* ADDRESS2 */ "Dirección 2",
        /* ADDRESS_ERROR */ "Error en la dirección",
        /* ADDRESS_IS_NEAR */ null,
        /* ADD_ANOTHER_DOCUMENT */ "Agregar otro documento",
        /* ADD_ANOTHER_PERTINENT_DIAGNOSIS */ "Agregar otro diagnóstico pertinente",
        /* ADD_IMAGE */ "Añadir imagen",
        /* ADD_NEW_MEDICATION */ "Agregar nueva medicación",
        /* ADD_NOTES */ "Añadir notas",
        /* ADD_NOTE_TO_PATIENT_PROFILE_BUTTON */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_TITLE */ null,
        /* ADD_PHYSICIAN */ null,
        /* ADD_YOUR_SIGNATURE */ "Agrega tu firma",
        /* ADVANCED_DIRECTIVES */ null,
        /* AGENCIES_CONTACT */ "Las agencias se pondrán en contacto con usted enseguida",
        /* AGENCY */ "Agencia",
        /* AGENCY_CODE */ "Código de la agencia",
        /* AGENCY_COORDINATOR */ "Coordinador de la agencia",
        /* AGENCY_DETAILS */ "Información de la agencia",
        /* AGENCY_HANDBOOK */ "Manual de la agencia",
        /* AGENCY_ISSUES */ null,
        /* AGENCY_NAME */ "Nombre de la agencia",
        /* AGENCY_NOTIFICATIONS */ "Notificaciones de la agencia",
        /* AGENCY_NOT_FOUND */ "Agencia no encontrada",
        /* AGREE_TO_MEDFLYT_TERMS */ "Al hacer clic en Aprobar, acepta que ha leído y acepta los Términos de la política de privacidad de Meflyt",
        /* AIDE */ null,
        /* AIRPODS */ "Airpods",
        /* ALLERGIES */ "Alergias",
        /* ALLOW_ACCESS_TO_MY_LOCATION */ "Permitir acceso a mi ubicación",
        /* ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP */ null,
        /* ALL_CHANGES_SAVED */ null,
        /* ALL_DAY */ "todo el día",
        /* ALL_DONE */ "¡Todo listo!",
        /* ALL_TRANSACTIONS */ null,
        /* ALL_VERIFIED_ITEMS */ null,
        /* ALREADY_CLOCKED_IN */ "Ya está registrado.",
        /* ALREADY_CLOCKED_IN_ANOTHER_VISIT */ "Ya está registrado en otra consulta.",
        /* ALREADY_CLOCKED_OUT */ "Ya ha registrado su salida.",
        /* ALREADY_HAVE_AN_ACCOUNT */ "Ya tienes una cuenta",
        /* AND_AMPERSAND */ "y",
        /* ANSWERED */ "Respondido",
        /* ANSWERED_AT */ "Respondido a las",
        /* ANSWER_INCOMPLETE_QUESTIONS */ "Responder preguntas incompletas",
        /* ANY_DURATION */ "cualquier duración",
        /* AN_ERROR_HAS_OCCURED */ "Se produjo un error.",
        /* AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET */ "Se produjo un error al enviar su hoja de tiempo.",
        /* APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES */ "Apple no está involucrado de forma alguna con el concurso o sorteo",
        /* APPLICATION_DONE */ "¡Postulación lista!",
        /* APPROVE */ "Aprobar",
        /* APPROVED */ "Aprobado",
        /* APPROVE_THIS_TASK */ "Aprobar esta tarea",
        /* APPROVE_THIS_VISIT */ "Aprobar esta visita",
        /* APRIL */ "Abril",
        /* ARENT_YOU_MISSING_SOMETHING */ null,
        /* ARE_YOU */ "Eres",
        /* ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY */ "¿Actualmente está trabajando con una agencia?",
        /* ARE_YOU_SURE */ null,
        /* ARE_YOU_SURE_REQUEST_FAR_VISIT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK */ "¿Estás seguro de que quieres aprobar esta tarea?",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST */ "¿Está seguro de que desea cancelar esta solicitud?",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT */ "¿Está seguro de que desea cancelar esta visita?",
        /* ARE_YOU_SURE_YOU_WANT_TO_DELETE */ "¿Está seguro de que desea eliminar?",
        /* ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE */ "¿Estás seguro de que quieres inscribir este paquete?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT */ "¿Estás seguro de que quieres eliminar este documento?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE */ "¿Está seguro de que quiere eliminar esta página?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE */ "¿Está seguro de que desea solicitar estas",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT */ "¿Está seguro de que desea solicitar esta visita?",
        /* ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT */ "¿En verdad desea cerrar sesión?",
        /* ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK */ "¿Estás seguro de que quieres desenredar esta tarea?",
        /* ASSIGNED */ "Asignado",
        /* ASSIST */ "Asistir",
        /* AS_NEEDED */ "Según sea necesario",
        /* AS_REQUESTED_BY_THE_PATIENT */ "A solicitud del cliente",
        /* ATTACH_A_DOCUMENT */ "Adjuntar un documento",
        /* AUGUST */ "Augurio",
        /* AUTHENTICATION_FAILED */ "La autenticación falló",
        /* AUTH_VERIFICATION_FAIL_EXAPLINED */ "No pudimos verificar su identidad. Comuníquese con una de sus agencias para obtener ayuda.",
        /* AUTOPLAY */ "El próximo elemento comenzará en",
        /* AVAILABILITY */ "Disponibilidad",
        /* AVAILABLE */ "Disponible",
        /* AVAILABLE_CARE_POINTS */ "Puntos de atención disponibles",
        /* AVAILABLE_ON_THE_FOLLOWING_DAYS */ "Disponible los siguientes días",
        /* AVAILABLE_SHIFTS */ "Turnos disponibles",
        /* AVAILABLE_VISITS */ null,
        /* AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK */ null,
        /* AWAITING_PATIENT_CONTACT */ "Esperando contacto",
        /* A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT */ "Ya existe un plan de atención para este paciente",
        /* A_VERIFICATION_CODE_IS_BEING_SENT_TO */ "Se está enviado un código de verificación a",
        /* A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE */ "Se le enviará un código de verificación por mensaje de texto.",
        /* A_VISIT_BY */ "Una visita de",
        /* BACK */ null,
        /* BACK_TO_ONBOARDING */ "Volver a la incorporación",
        /* BANK_INFORMATION */ null,
        /* BANK_NAME */ "Nombre del banco",
        /* BASICALLY_EVERY_ACTION_COUNTS */ "Básicamente cada acción cuenta 😊",
        /* BEFORE_SUBMITTING_THE_DUTIES */ null,
        /* BEGIN_NOW */ "Empieza ahora",
        /* BEST_TASK_FOR_YOU */ null,
        /* BETWEEN */ "entre",
        /* BETWEEN_AND */ "y",
        /* BIRTHDAY */ "Cumpleaños",
        /* BLOOD_PRESSURE */ "Presión arterial",
        /* BOROUGH */ null,
        /* BUNDLES */ "manojos",
        /* BUNDLE_DESCRIPTION */ "Este paquete lo guiará sobre cualquier cosa que necesite saber sobre {Bundle_name} de {agencia_name}.",
        /* BUNDLE_DESCRIPTION_P1 */ "Este conjunto consta de",
        /* BUNDLE_DESCRIPTION_P2 */ "artículos. Algunos artículos también pueden incluir una prueba. Vea el contenido requerido. Después de completar la tarea requerida, recibirá un certificado. Buena suerte.",
        /* BUNDLE_IS_LOCKED */ "El paquete está bloqueado",
        /* BUNDLE_ITEM_NOT_FOUND */ "Lección de entrenamiento no encontrada",
        /* BUNDLE_NOT_FOUND */ "Curso de entrenamiento no encontrado",
        /* BUNDLE_PROGRESS */ "Progreso del conjunto",
        /* BUSY_ALL_DAY */ "Ocupado todo el día",
        /* BY */ "Por",
        /* BY_ENROLLING_I_ACCEPT_THE */ "Inscrito, acepto el",
        /* BY_EXISTING_VISIT */ "Por consulta vigente:",
        /* BY_PATIENT_NAME */ "Por el nombre del paciente:",
        /* BY_SIGNING_HERE_I_ACCEPT_THE */ "Al firmar aquí, acepto",
        /* CALL */ "Llamar",
        /* CALL_AGENCY */ "Llamarle a la agencia",
        /* CALL_HOME */ "Llamar a casa",
        /* CALL_MOBILE */ "Llamar al teléfono móvil",
        /* CALL_NOW */ "Llame ahora:",
        /* CALL_PATIENT */ "Llamarle al paciente",
        /* CALL_PATIENT_CONFIRMATION */ null,
        /* CALL_PATIENT_EXPLANATION */ "Recibirá una llamada unos momentos después de confirmar este mensaje.",
        /* CALL_PATIENT_HOME */ "Llamar al domicilio del paciente",
        /* CALL_PATIENT_MOBILE */ "Llamar al teléfono móvil del paciente",
        /* CALL_PATIENT_NOTE */ "Contacte al paciente en la siguiente pantalla",
        /* CALL_SUPPORT_FOR_MORE_INFO */ "Comuníquese con el departamento de asistencia para obtener más información",
        /* CANCEL */ "Cancelar",
        /* CANCEL_REQUESTED_SHIFTS */ "Cancelar cambios solicitados",
        /* CANCEL_VISIT */ "Cancelar visita",
        /* CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE */ "No puede editar sus respuestas en modo de solo lectura.",
        /* CANT_CANCEL_24_HOURS_SCHEDULED_VISIT */ "Error: faltan menos de 24 horas para la consulta",
        /* CANT_CANCEL_AT_THIS_TIME */ "No es posible cancelar en este momento.",
        /* CANT_CLOCK_IN */ "No es posible registrar la llegada",
        /* CANT_CLOCK_IN_AT_THIS_TIME */ "No es posible registrar su llegada en este momento.",
        /* CANT_CLOCK_OUT */ "No es posible registrar la salida",
        /* CANT_CLOCK_OUT_AT_THIS_TIME */ "No puede registrar su salida en este momento.",
        /* CANT_CLOCK_OUT_BEFORE_VISIT_ENDED */ "No puede registrar su salida antes de que termine la consulta.",
        /* CANT_REJECT_VISIT_PENDING_STATUS */ "Todavía no puedes rechazar las visitas. Complete el proceso de registro",
        /* CANT_REQUEST_JOIN_AGENCY */ "No puedo solicitar unirme a la agencia",
        /* CANT_REQUEST_VISIT_PENDING_STATUS */ "Todavía no puede solicitar visitas. Complete el proceso de registro",
        /* CANT_SUBMIT_AN_EMPTY_FORM */ "No puedo enviar un formulario vacío, responda las preguntas.",
        /* CANT_WATCH_ON_SHIFT */ "Esta capacitación está desactivada durante todos los turnos 👀",
        /* CANT_WATCH_THIS_VIDEO */ "No puedo ver este video",
        /* CAREBACK_CASH_BONUS */ "Cuidado - ¡Bonificación en efectivo!",
        /* CAREBACK_POINTS */ "Puntos de cuidado",
        /* CAREGIVER */ "Profesional de la salud",
        /* CAREGIVER_COMPLIANCE_PASSPORT */ "Cartilla de cumplimiento del profesional de la salud",
        /* CAREGIVER_NAME */ "Nombre del cuidador",
        /* CAREGIVER_PHONE */ "Teléfono del cuidador",
        /* CAREGIVER_SIGNATURE */ "Firma del cuidador",
        /* CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG */ "Asegúrese de que tanto usted como el paciente hayan firmado el plan de atención médica",
        /* CAREGIVER_SIGNATURE_IS_REQUIRED */ "Se requiere la firma del cuidador",
        /* CAREGIVER_SIGNATURE_REQUIRE_MSG */ "Asegúrese de firmar en el plan de atención médica",
        /* CAREGIVER_STATUS_PENDING_ERROR */ "No se puede realizar ninguna acción porque su perfil aún está pendiente.",
        /* CARE_MOMENTS */ null,
        /* CASE_INFO */ "Información de casos",
        /* CASE_IS_TOO_FAR */ "El caso está muy lejos.",
        /* CASE_SETTINGS */ "Ajustes de caso",
        /* CATALOGUE */ "Catálogo",
        /* CERTIFICATION */ "Certificación",
        /* CERTIFICATIONS */ "Certificaciones",
        /* CHANGE */ "Cambiar",
        /* CHANGES_TO_MY_VISITS */ "Cambios a mis visitas",
        /* CHANGES_WERE_SAVED_IN_THE_CLOUD */ "Todos los cambios se guardaron en la nube",
        /* CHANGE_DOCUMENT */ "Documento de cambio",
        /* CHANGE_OF_RANKING */ null,
        /* CHANGE_PHONE_NUMBER */ "Cambiar número de teléfono",
        /* CHANGE_SETTINGS */ "Cambiar ajustes",
        /* CHANGE_SHIFTS */ "Cambio de cambios",
        /* CHANGE_TASK_TIME */ null,
        /* CHANGE_VISIT_TIMES */ "Cambiar horas de visita",
        /* CHAT */ "Chat",
        /* CHATS */ "Chats",
        /* CHAT_MESSAGES */ "Mensajes de chat",
        /* CHAT_NOT_ACTIVE_MESSAGE */ "No puede enviar mensajes aquí.",
        /* CHAT_NOT_ACTIVE_TITLE */ "El chat ya no está activo",
        /* CHAT_WITH_AGENCY */ "Chatear con la agencia",
        /* CHAT_WITH_AGENCY_ABOUT_PATIENT */ "Chatear con %s sobre %s",
        /* CHAT_WITH_MEDFLYT */ "Chatear con Medflyt",
        /* CHAT_WITH_OTHER_AGENCIES */ "Chatear con otras agencias",
        /* CHAT_WITH_SUPPORT */ "Chatear con soporte técnico",
        /* CHAT_WITH_US */ "habla con nosotros",
        /* CHECK */ null,
        /* CHECK_AGAIN */ null,
        /* CHOOSE_ANOTHER_DATE */ "Elija otra fecha",
        /* CHOOSE_A_PHOTO */ "Elige una foto",
        /* CHOOSE_A_TIME_FOR_THE_VISIT */ "Elija una hora para la visita",
        /* CHOOSE_CLOCK_TIMES */ "Elige horarios de reloj",
        /* CHOOSE_DATE_TO_PERFORM_THIS_TASK */ "Elija Fecha para realizar esta tarea",
        /* CHOOSE_FOLDER_TO_UPLOAD */ "Elija la carpeta para cargar",
        /* CHOOSE_START_TIME */ "Elegir la hora de inicio",
        /* CHOOSE_THE_HOURS */ "Siguiente (elija las horas)",
        /* CHOOSE_TIME */ "Elige el tiempo",
        /* CHOOSE_WHEN_TO_PERFORM_THE_VISIT */ "Elija cuándo realizar la visita",
        /* CHOOSE_WHEN_TO_VISIT_THE_PATIENT */ "Elija cuándo visitar al paciente",
        /* CHOOSE_WHO_TO_CONTACT */ "Elija a quién contactar",
        /* CHOOSING_A_WINNER */ null,
        /* CHOOSING_A_WINNER_IN */ null,
        /* CLEAR */ "Borrar",
        /* CLICK_HERE */ null,
        /* CLICK_HERE_TO_DOWNLOAD */ "Haga clic aquí para descargar.",
        /* CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE */ "Haga clic aquí para compartir su código de recomendación.",
        /* CLICK_HERE_TO_VIEW_CERTIFICATE */ "HAGA CLIC AQUÍ PARA VER EL CERTIFICADO",
        /* CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE */ "¡Felicitaciones por su primer certificado 🏆🏆! Haga clic sobre su nuevo certificado para verlo",
        /* CLICK_TO_REQUEST */ "¡Haga clic para solicitar!",
        /* CLICK_TO_SCAN_UPLOAD */ "Haga clic para escanear y cargar",
        /* CLICK_TO_TAKE_A_SELFIE */ "Haga clic para tomar una selfie",
        /* CLIMB_THE_RANKS_BY_COMPLETING_VISITS */ null,
        /* CLINICAL_SUPPORT */ "Apoyo clínico",
        /* CLOCKED_IN */ "Llegada registrada",
        /* CLOCKED_IN_AND_OUT */ null,
        /* CLOCKED_IN_AT */ "Llegada registrada a las",
        /* CLOCKED_OUT */ "Salida registrada",
        /* CLOCKED_OUT_AT */ "Salida registrada a las",
        /* CLOCKING_IN */ "Registrando llegada...",
        /* CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES */ "El registro no en el tiempo causa problemas",
        /* CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES */ "Introducir / salir no en la ubicación de la visita puede causar problemas",
        /* CLOCKING_OUT */ "Registrando salida...",
        /* CLOCK_ADDRESS_IN_RANGE */ null,
        /* CLOCK_ADDRESS_NOT_IN_RANGE */ null,
        /* CLOCK_IN */ "Registrar llegada",
        /* CLOCK_IN_ANYWAY */ "Reloj de todos modos de todos modos",
        /* CLOCK_IN_AT */ "Entrar a las",
        /* CLOCK_IN_BETWEEN */ "Reloj en el medio",
        /* CLOCK_IN_OUT */ "Registrar llegada/salida",
        /* CLOCK_IN_OUT_SUBMIT_DUTIES */ "Reloj In / Out and Envíe las tareas",
        /* CLOCK_IN_TIME_IS_REQUIRED */ "Se requiere el reloj en el tiempo",
        /* CLOCK_OUT */ "Registrar salida",
        /* CLOCK_OUT_AFTER */ "Salir después de",
        /* CLOCK_OUT_AT */ "Salir a las",
        /* CLOCK_OUT_BETWEEN */ "Vigilar entre",
        /* CLOCK_OUT_TIME_IS_REQUIRED */ "Se requiere tiempo de salida del reloj",
        /* CLOCK_TIMES_NOT_MOBILE */ null,
        /* CLOCK_TIME_IN_RANGE */ null,
        /* CLOCK_TIME_NOT_IN_RANGE */ null,
        /* CLOSE */ "Cerca",
        /* CLOSE_SURVEY */ "Encuesta cercana",
        /* CLUSTERED_VISIT_EXPLENATION */ "Detectamos que estas 2 visitas están cerca una de la otra y entran en su cronograma diario. Le recomendamos solicitar estas visitas juntas. También puede solicitar las visitas por separado.",
        /* CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE */ "No se encontró el código. Por favor, use otro.",
        /* COMBINED_CASE */ "Caso combinado",
        /* COMING_SOON */ "Muy pronto",
        /* COMPLETED */ "Completo",
        /* COMPLETED_DOCUMENTS */ "Documentos completados",
        /* COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL */ "Complete todos los documentos antes de la nómina",
        /* COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS */ null,
        /* COMPLETE_PREVIOUS_SECTIONS_FIRST */ "Complete primero las secciones anteriores",
        /* COMPLETE_REGISTRATION */ "Registro completo",
        /* COMPLETE_REGISTRATION_PROCESS */ "Proceso de registro completo",
        /* COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT */ "Completa la solicitud",
        /* COMPLETE_VISIT */ "Visita completa",
        /* COMPLETE_YOUR_ONBOARDING_ANYTIME */ "¡Complete su incorporación en cualquier momento!",
        /* COMPLIANCE */ "Cumplimiento",
        /* COMPLIANCE_EXPIRY */ "Los videos requieren tu atención",
        /* COMPLIANCE_FORM */ "Formulario de cumplimiento",
        /* COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY */ "¡Su formulario de cumplimiento se ha presentado con éxito!",
        /* COMPLIANT */ "Cumplimiento",
        /* COMPLIANT_ITEMS */ "Artículos que cumplen",
        /* CONFIRM */ "Confirmar",
        /* CONFIRM_ASSESSMENT */ "Confirmar evaluación",
        /* CONFIRM_COPY_LAST */ "¿Está seguro de que desea copiar las respuestas de",
        /* CONFIRM_COPY_LAST_TITLE */ "¿Confirmar la copia?",
        /* CONFIRM_DEPOSIT_DETAILS */ "Confirme la información de su depósito directo",
        /* CONFIRM_PATIENT_AVAILABILITY */ null,
        /* CONFIRM_PATIENT_AVAILABILITY_MESSAGE */ null,
        /* CONFIRM_RN_FLEX_VISIT */ "Confirmo mi visita",
        /* CONFIRM_WITHOUT_LOCATION */ "Confirmar sin ubicación",
        /* CONGRATULATIONS */ "¡Felicidades!",
        /* CONGRATULATIONS_TO */ null,
        /* CONNECTING_HOME */ "Conectamos a agencias",
        /* CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS */ "Conectar agencias de salud en el hogar con cuidadores",
        /* CONNECT_WITH_US_ON_FACEBOOK */ "Conectate con nosotros en Facebook",
        /* CONNECT_WITH_US_ON_WHATSAPP */ "Conéctese con nosotros en WhatsApp",
        /* CONTACT */ "Contactar",
        /* CONTACT_AGENCY_FOR_MORE_INFO */ "Comuníquese con la agencia para más información.",
        /* CONTACT_PATIENT */ "Contactar al paciente",
        /* CONTACT_SUPPORT */ "Comuníquese con el área de soporte",
        /* CONTINUE */ "Continuar",
        /* CONTINUE_LATER */ "Continuar más tarde",
        /* CONTINUE_TO_APP */ "Continuar aplicando",
        /* CONTINUE_TO_ORIENTATION */ "Continuar con la orientación",
        /* CONTINUE_TO_SIGN_UP */ "Continúa inscribiendo",
        /* CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK */ null,
        /* COORDINATOR */ "Coordinador",
        /* COORDINATOR_EMAIL */ "Correo electrónico del coordinador",
        /* COORDINATOR_IN_CHARGE */ "Coordinador en cargo",
        /* COORDINATOR_PHONE */ "Teléfono del coordinador",
        /* COPY */ "Copiar",
        /* COPY_FROM_LAST_TIME */ "Copiar de la última vez",
        /* COPY_FROM_MEDICATION */ "Copia de la medicación",
        /* COPY_FROM_OTHER_FORMS */ "Copiar de otros formularios",
        /* COPY_LAST_NO_DATE_FALLBACK_APPENDED */ "última vez",
        /* COPY_MEDICATION_CHART */ "Copiar planilla de medicación",
        /* COPY_PLAN_OF_CARE */ "Copiar plan de atención médica",
        /* CORRECT */ "Correcto",
        /* COURSES */ "Cursos",
        /* COVID */ "COVID-19",
        /* COVID_REQUIRED */ "El cuestionario de COVID-19 es obligatorio",
        /* COVID_REQUIRED_EXPLAINED */ "No ha completado el cuestionario de COVID-19 hoy. Complételo para continuar",
        /* COVID_SCREENING_CLICK_HERE */ "Examen de COVID-19, haga clic aquí",
        /* CREATED_AT */ "Creada a las",
        /* CREATE_A_NEW_ACCOUNT */ "Crea una cuenta nueva",
        /* CREATE_NEW_PLAN_OF_CARE */ "Crear un nuevo plan de atención",
        /* CRIMINAL_CONVICTIONS_RECORDS */ "Registros de condenas penales",
        /* CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT */ "Actualmente está registrado en otra visita.",
        /* CURRENT_BALANCE */ null,
        /* CURRENT_VISIT */ "Visita actual",
        /* DATA_WILL_BE_LOST */ "Se perderán los datos",
        /* DATE */ "Fecha",
        /* DATES */ "Fechas",
        /* DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO */ "Rango de fechas para completar la tarea: %inicio %a %final %",
        /* DATE_NOT_SPECIFIED */ "Fecha no especificada",
        /* DATE_OF_BIRTH */ "Fecha de nacimiento",
        /* DATE_UNKNOWN */ null,
        /* DATE_VERIFICATION */ "Verificación de fecha",
        /* DAY */ "Día",
        /* DAYS */ "días",
        /* DAYS_A_WEEK */ "Días a la semana",
        /* DAYS_LEFT */ "Días restantes",
        /* DAYS_OF_WEEK */ "Días por semana",
        /* DECEMBER */ "Diciembre",
        /* DECLINED */ "Rechazado",
        /* DELETE */ "Eliminar",
        /* DESCRIBE_THE_PROBLEM */ "Describe el problema",
        /* DETAILS */ "detalles",
        /* DIRECTIONS */ "Instrucciones",
        /* DIRECT_DEPOSIT */ null,
        /* DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION */ "Desconectado. Verifique su conexión a Internet.",
        /* DISCOVER_YOUR_JOURNEY */ null,
        /* DISCRIMINATION */ "Discriminación",
        /* DISMISS */ "Despedir",
        /* DISMISSED */ "Despedido",
        /* DISTANCE */ "Distancia",
        /* DOB */ "DoB",
        /* DOCUMENT */ "Documento",
        /* DOCUMENTS */ "Documentos",
        /* DOCUMENTS_TO_COMPLETE */ null,
        /* DOCUMENT_HAS_EXPIRED */ "El documento ha caducado",
        /* DOCUMENT_IS_MISSING */ "El documento está faltando",
        /* DOCUMENT_REJECTED */ "Documento rechazado",
        /* DOCUMENT_SELECTED */ "Documento seleccionado",
        /* DOESNT_EXPIRE */ "No expira",
        /* DOES_NOT_FIT_MY_SCHEDULE */ "No se ajusta a mi horario.",
        /* DONE */ "Listo",
        /* DONT_FORGET_TO_CLOCK_IN */ "No te olvides de registrar",
        /* DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS */ "No te olvides de registrar, registrar y completar todas las tareas",
        /* DONT_FORGET_TO_CLOCK_OUT */ "No olvide registrar su salida.",
        /* DONT_FORGET_TO_FILL_THE_DUTY_SHEET */ "¡Es hora de completar las tareas!",
        /* DONT_FORGET_TO_SMILE */ null,
        /* DONT_SCHEDULE_VISIT */ null,
        /* DONT_SHOW_AGAIN */ "No te muestres de nuevo",
        /* DOSE */ "Dosis",
        /* DOWNLOAD_PDF */ "Descargar PDF",
        /* DO_YOU_HAVE_ANY_QUESTIONS_ASK */ "¿Tiene usted alguna pregunta? Preguntar",
        /* DO_YOU_WANT_THIS_VISIT */ "¿Quieres esta visita?",
        /* DUE_BETWEEN */ null,
        /* DUE_BY_DATETIME */ null,
        /* DUE_DATE */ "Fecha de vencimiento",
        /* DUE_ON */ null,
        /* DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO */ null,
        /* DURATION */ "Duración",
        /* DURATION_PER_DAY */ "Duración por día",
        /* DUTIES */ null,
        /* DUTIES_COMPLETED_SUCCESSFULLY */ "Deberes completadas con éxito",
        /* DUTY_SHEET_SUBMITTED */ "Hoja de tareas enviada",
        /* EACH_100_POINTS_DOLLAR */ "cada 100 puntos = $ 1",
        /* EACH_INVITE */ "Cada invitación",
        /* EARLY_OR_LATE_CLOCKS */ null,
        /* EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY */ null,
        /* EDIT */ "Editar",
        /* EDIT_ACCOUNT_DETAILS */ null,
        /* EDIT_TIMES */ "Editar horas",
        /* EDUCATION */ "Centro de educación",
        /* ELECTRIC_EQUIPMENT_DEPENDENCY */ "Dependencia del equipo eléctrico",
        /* ELIGIBLE_VISITS */ "Visitas elegibles",
        /* EMAIL */ "Correo electrónico",
        /* EMAIL_QUESTION_PENDING_VERIFICATION */ null,
        /* EMAIL_SUPPORT */ null,
        /* EMAIL_SUPPORT_FOR_MORE_INFO */ "Escriba un mensaje de correo electrónico al departamento de asistencia para obtener más información",
        /* EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER */ null,
        /* EMAIL_VERIFICATION_QUESTION_LABEL */ null,
        /* EMERGENCY_CONTACTS */ null,
        /* EMPTY_DURATION */ "Duración vacía",
        /* EMPTY_PATIENT_MEDICATION_PROFILE */ "El perfil de la medicación del paciente está vacío",
        /* ENABLE_LOCATION_MESSAGE */ null,
        /* ENABLE_LOCATION_TITLE */ null,
        /* ENDING_AT */ "Finalizando a las",
        /* ENDS */ "Termina",
        /* END_DATE */ "Fecha de finalización",
        /* END_TIME */ "Hora de finalización",
        /* ENROLLMENT_REQUESTED */ "Inscripción solicitada",
        /* ENROLL_NOW */ "Enlístate ahora",
        /* ENTER_AGENCY_CODE */ "Introduzca el código de la agencia",
        /* ENTER_DOCUMENT_NAME */ "Ingresar el nombre del documento",
        /* ENTER_NUMBER_HERE */ "Introduzca el número aquí",
        /* ENTER_TEXT_HERE */ "Introduzca el texto aquí",
        /* ENTER_YOUR_MOBILE_NUMBER */ "Introduzca su número de teléfono celular.",
        /* ENTER_YOUR_PIN_CODE */ "Ingrese su código PIN",
        /* ENTITY_IS_MISSING */ "Falta el campo %s. Asegúrese de que esté lleno y luego vuelva a intentarlo.",
        /* ERROR */ "Error",
        /* ERROR_FETCHING_SLOTS */ null,
        /* ERROR_LOADING_DATA */ null,
        /* ERROR_REMOVING_DOCUMENT */ "Se produjo un error al eliminar el documento",
        /* ERROR_SCHEDULING_TASK */ null,
        /* ERROR_SCHEDULING_TASK_MESSAGE */ null,
        /* ESTIMATED_ADDRESS_WILL_BE_PROVIDED */ null,
        /* ESTIMATED_TIME_OF_CLOCKING_OUT_IS */ "El tiempo estimado de la eliminación es",
        /* EVACUATION_LOCATION */ "Ubicación de evacuación",
        /* EVACUATION_ZONE */ "Zona de evacuación",
        /* EVERY_VISIT */ "Todas las visitas",
        /* EVV */ "Evv",
        /* EXCITING_NEWS_AHEAD */ null,
        /* EXEMPTED */ "Exento",
        /* EXPIRED */ "Vencido",
        /* EXPIRED_COMPLIANCE */ "Cumplimiento vencido",
        /* EXPIRED_ON_DATE */ "Expirado en %fecha %",
        /* EXPIRES_AT */ "Caduca el",
        /* EXPIRES_IN */ "Caduca el",
        /* EXPIRES_IN_ONE_DAY */ "Vence en un día",
        /* EXPIRES_IN_X_DAYS */ "Vence en %d días",
        /* EXPIRES_ON_DATE */ "Expira en %fecha %",
        /* EXPIRING_COMPLIANCE */ "Cumplimiento que vence",
        /* EXPIRING_SOON */ null,
        /* EXPIRY_DATE */ "Fecha de vencimiento",
        /* EXPLORE */ null,
        /* EXPLORE_A_CAREER_ENHANCEMENTS */ null,
        /* FAILED_TO_IDENTIFY_PATIENT */ "No se pudo identificar al paciente",
        /* FAR_VISIT_WARNING_MODAL_TITLE */ null,
        /* FAX_NUMBER */ null,
        /* FEBRUARY */ "Febrero",
        /* FEMALE */ "Mujer",
        /* FIFTHY_DOLLAR_AMAZON_GIFT_CARD */ "Tarjeta de regalo de Amazon $ 50",
        /* FILES */ "archivos",
        /* FILE_NOT_FOUND_CONTACT_AGENCY */ "Archivo no encontrado, comuníquese con su agencia",
        /* FILL */ null,
        /* FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT */ null,
        /* FILL_IN_THE_QUESTIONNAIRE */ "Complete el cuestionario",
        /* FILTERS */ "Filtros",
        /* FINAL_CONFIRMATION */ "Confirmación final",
        /* FIND_A_CARE_MOMENT */ null,
        /* FIND_A_CARE_MOMENT_DESCRIPTION */ null,
        /* FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE */ "Encuentre más casos en la página de visitas disponibles",
        /* FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE */ "Encuentre nuevos pacientes en la página de visitas disponibles",
        /* FINISH_MY_ONBOARDING */ "Terminar mi incorporación",
        /* FINISH_ONBOARDING_AND_GET_DOLLARS */ "Termine la incorporación y obtenga $ 150",
        /* FINISH_ONBOARDING_MODAL_MESSAGE */ "¡Estás un paso más cerca de obtener muchos casos! ¡Termine su oboarding y obtenga $!",
        /* FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2 */ "Ahora puede solicitar los casos que desee y asegúrese de completar todos los documentos adicionales antes de su primer caso.",
        /* FINISH_ONBOARDING_MODAL_TITLE */ "Estamos emocionados de tenerte aquí, %Name %!",
        /* FINISH_ONBOARDING_MODAL_TITLE_STAGE_2 */ "¡Empiece a requerir casos! 🚀",
        /* FINISH_SHIFT */ null,
        /* FINISH_THE_DOCUMENTS */ "Terminar los documentos",
        /* FIRST_NAME */ "Nombre",
        /* FIRST_SHIFT */ "Primer turno",
        /* FIVE_THOUSAND_POINTS */ "5000 puntos",
        /* FIX */ null,
        /* FIX_DOCUMENTS_DESCRIPTION */ null,
        /* FIX_DOCUMENT_DESCRIPTION */ null,
        /* FIX_ISSUE */ null,
        /* FIX_ISSUES */ null,
        /* FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT */ "¡Arréglalo ahora!",
        /* FIX_SETTINGS */ "Corregir configuración",
        /* FIX_THE_DOCUMENT */ null,
        /* FIX_THE_DOCUMENTS */ null,
        /* FIX_YOUR_DOCUMENT */ null,
        /* FIX_YOUR_DOCUMENTS */ null,
        /* FLEXIBLE */ "Flexible",
        /* FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT */ "Esta visita es {horas_per_week} horas por semana, seleccione qué días y horas desea trabajar 🙂",
        /* FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT */ "Esta visita requiere hasta {num_of_shifts} turnos por semana, las horas son {start_time} a {end_time}.\nSeleccione los días que desea trabajar",
        /* FLEXIBLE_DAYS_VISIT */ "Consulta con días flexibles",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT */ "Esta visita tiene {Total_shifts_Number} Shifts:\n{Shifts_To_Choose} y {last_shift_to_choose}.\nSeleccione qué días y horas desea trabajar 🙂",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT */ "{Num_of_shifts} turnos de {num_of_hours} horas",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT */ "{Num_of_shifts} cambio de {num_of_hours} horas",
        /* FLEXIBLE_HOURS_EXPLANATION_TEXT */ "Esta visita está en {días_to_choose} y {last_day_to_choose}.\n¡Las horas son lo que funcione para ti!",
        /* FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT */ "Esta visita es {Shifts_to_Choose}.\n¡Las horas son lo que funcione para ti!",
        /* FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT */ "Esta visita es {shifts_to_choose} y {last_shift_to_choose}.\n¡Las horas son lo que funcione para ti!",
        /* FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT */ "Esta visita está en {días_to_choose}.\n¡Las horas son lo que funcione para ti!",
        /* FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT */ "Esta visita tiene {Shifts_to_Choose}.\nSeleccione qué días y horas desea trabajar 🙂",
        /* FLEXIBLE_HOURS_PATTERN_SHIFT */ "{Num_of_hours} horas en {day_of_week}",
        /* FLEXIBLE_HOURS_VISIT */ "Consulta con horario flexible",
        /* FLEXIBLE_VISIT */ "Visita flexible",
        /* FLEXIBLE_VISIT_DAY_TO_CHOOSE */ "{Días",
        /* FLEXIBLE_VISIT_DETAILS */ "Detalles de la visita flexibles",
        /* FLEXIBLE_VISIT_TYPE */ "Visita flexible",
        /* FLU_SHOT */ null,
        /* FLU_SHOT_SUBMITTION_MESSAGE */ null,
        /* FOLLOW_US_ON_INSTAGRAM */ "Síganos en Instagram.",
        /* FOLLOW_US_ON_TWITTER */ "Síganos en Twitter.",
        /* FORGOT_PIN_CODE_DIALOG_MESSAGE */ "Por favor, tenga en cuenta que será dirigido a la pantalla de inicio de sesión para comenzar un nuevo proceso de registro.",
        /* FORM_NAME */ "Nombre del formulario",
        /* FOURTEEN_THOUSAND_POINTS */ "14000 puntos",
        /* FREQUENCY */ "Frecuencia",
        /* FRIEND */ "Amigo",
        /* FROM */ "Desde",
        /* FROM_CAMERA */ "De la cámara",
        /* FROM_GALLERY */ "De la galería",
        /* FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE */ "Términos y condiciones completos - Desafío MedFlyt",
        /* FUTURE_VISITS */ "Visitas futuras",
        /* GENDER */ "Sexo",
        /* GENERAL */ "General",
        /* GENERAL_FILES */ "Archivos generales",
        /* GENERAL_NOTES */ "Notas generales",
        /* GENERAL_SUPPORT */ "Apoyo general",
        /* GET_INSTAPAY */ "Obtener Instapay",
        /* GET_IT_NOW */ "Consiguelo ahora",
        /* GET_MONEY_FOR_THIS_VISIT_TODAY
 */ "¡Te paguen por esta visita ahora!",
        /* GET_NOW */ "¡Llegue ahora!",
        /* GET_STARTED */ null,
        /* GET_THE_APP */ "Obtener la aplicación",
        /* GET_X_NOW */ "¡Obtén {x} ahora!",
        /* GOOD_JOB */ "¡Buen trabajo!",
        /* GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "¡Buen trabajo! Ha completado todas las lecciones por ahora",
        /* GOT_IT */ "Entendido",
        /* GO_BACK */ "Volver",
        /* GO_TO */ "Ir a",
        /* GO_TO_MEDFLYT_PASSPORT */ "Ir a Medflyt Passport",
        /* GO_TO_PATIENT */ "Ir al paciente",
        /* GO_TO_PATIENT_DETAILS */ "Ir a los detalles del paciente",
        /* GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION */ null,
        /* GO_TO_VISIT */ "Ir a la visita",
        /* GREAT_JOB */ "¡Excelente trabajo!",
        /* GROSS_PAY */ null,
        /* HAS_DNR */ null,
        /* HAS_HEALTH_CARE_PROXY */ null,
        /* HAVE_A_NICE_WORKING_DAY */ "¡Que tengas un buen día de trabajo!",
        /* HAVE_A_PLEASANT_VISIT */ "¡Que tengas una visita agradable!",
        /* HAVE_A_QUESTION_LETS_CHAT */ "¿Tengo una pregunta? ¡Charlemos!",
        /* HEALTH_AGENCIES */ "de cuidado en el hogar",
        /* HELP */ "Ayuda",
        /* HELP_ME_FIND_MY_AGENCY */ "Necesito ayuda para encontrar mi agencia",
        /* HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY */ "¡Esto es lo que necesita saber sobre nuestra agencia!",
        /* HEY */ "¡Hey!",
        /* HEY_THERE */ "Hola",
        /* HI */ "Hola",
        /* HIRE_DATE */ "Fecha de contratación",
        /* HI_PLEASE_HELP_ME_FILL_MY_APPLICATION  */ null,
        /* HOME_PHONE */ "Teléfono de casa",
        /* HOUR */ null,
        /* HOURS */ "Horas",
        /* HOURS_PER_DAY */ "Horas por día",
        /* HOURS_PER_VISIT */ "Horas por visita",
        /* HOW_ARE_WE_CALCULATING_THE_RANK */ "¿Cómo estamos calculando el rango?",
        /* HOW_CAN_WE_HELP_YOU */ "¿Cómo podemos ayudarle?",
        /* HOW_CARE_MOMENTS_WORKS */ null,
        /* HOW_DID_YOU_HEAR_ABOUT_US */ "Cómo se enteró de nosotros",
        /* HOW_DOES_IT_WORK */ null,
        /* HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS */ "¿Cómo se siente el paciente? ¿Cuáles son los principales síntomas?",
        /* HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN */ "¿Cómo alienta a un paciente que se siente deprimido?",
        /* HOW_DO_YOU_RATE_MEDFLYT */ "¿Qué calificación le daría a Medflyt?",
        /* HOW_URGENT_IS_THE_ISSUE */ "¿Qué tan urgente es el problema?",
        /* HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT */ "¿Cómo le gustaría llamar al paciente?",
        /* HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE */ "¿Cómo le gustaría cargar el archivo?",
        /* HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT */ null,
        /* HR_PER_VISIT */ "Horas por consulta",
        /* HUNDRED_DOLLARS_GIFT_CARD */ "Tarjeta de regalo de $ 100 amex",
        /* ICD */ "ICD",
        /* ID */ "IDENTIFICACIÓN",
        /* IF_YOU_CLOCK_IN_AND_OUT_ON_TIME */ "Si ingresa y sale a tiempo",
        /* IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME */ "Si no registra dentro y fuera a tiempo",
        /* IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON */ "Si pierde una visita por una razón no legítima",
        /* IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE */ "Si solicita más visitas mientras su horario es gratuito",
        /* IF_YOU_STAY_COMPLIANT */ "Si te mantienes cumpliendo",
        /* IMPORTANT_INFORMATION */ "Información importante",
        /* IMPORTED */ "Importado",
        /* IM_AVAILABLE */ "Estoy disponible",
        /* IM_DONE_SUBMIT */ "¡He terminado! Entregar",
        /* IM_NOT_INTERESTED */ "No me interesa",
        /* IM_WORKING_WITH_AN_AGENCY */ "Estoy trabajando con una agencia",
        /* INACTIVE */ "Inactivo",
        /* INCOMPLETE */ "Incompleto",
        /* INCORRECT */ "Incorrecto",
        /* INCORRECT_CODE */ "Código incorrecto",
        /* INCORRECT_DIGITS */ "Dígitos incorrectos ...",
        /* INCORRECT_DIGITS_EXPLAINED */ "Los últimos 4 dígitos que ha ingresado son incorrectos. Póngase en contacto con su agencia si tiene problemas.",
        /* INCORRECT_DIGITS_MESSAGE */ "Los últimos cuatro dígitos que ingresó son incorrectos. Póngase en contacto con su agencia si tiene problemas.",
        /* INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN */ "Código PIN incorrecto. Por favor, inténtelo de nuevo.",
        /* INCORRECT_SMS_CODE */ "Código SMS incorrecto",
        /* INCORRECT_SMS_CODE_EXPLAINED */ "El código que ha ingresado no coincide con el código que le hemos enviado. Inténtalo de nuevo.",
        /* INFORMATION_CENTER */ "Centro de Información",
        /* INFORMATION_NOT_MATCH_PROFILE */ "La información en esta sección ya no coincide con el perfil del paciente",
        /* INSERT_THEIR_REFERRAL_CODE_HERE */ "¡Introduzca aquí su código de recomendación!",
        /* INSERVICES */ null,
        /* INSTAPAY */ "Instapay",
        /* INSTAPAY_HISTORY */ null,
        /* INSTAPAY_TECHNICAL_ISSUE */ null,
        /* INSUFFICIENT_DUTIES */ null,
        /* INTERESTED_IN_THIS_BUNDLE */ "¿Interesado en este paquete?",
        /* INTRODUCING */ "Introducción",
        /* INVALID_DOCUMENT_NAME */ "Nombre de documento no válido",
        /* INVALID_EMAIL */ "Correo electrónico no válido",
        /* INVALID_FORM */ "Forma invalida",
        /* INVALID_PHONE */ "Teléfono no válido",
        /* INVALID_PHONENUMBER */ "Numero de telefono invalido",
        /* INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN */ "SSN no válido, verifique y vuelva a intentarlo",
        /* INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES */ "Invite a cuidadores a MedFlyt y gane increíbles premios.",
        /* INVITE_FRIENDS */ "Invitar amigos",
        /* IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE */ "Para responder a esta pregunta, actualice a nuestra versión más reciente de la tienda.",
        /* IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT */ "Para obtener Instapaid, debe seleccionar al menos una visita.",
        /* IN_PROGRESS */ "En curso",
        /* ISSUES_TO_SOLVE */ null,
        /* IS_DUE_IN_DAYS */ "Vence en % % % días",
        /* IS_DUE_TOMORROW */ "Vencerá mañana",
        /* ITEMS_THAT_WILL_EXPIRE_SOON */ "Artículos que caducarán pronto",
        /* ITEMS_WITH_ISSUES */ "Elementos con problemas",
        /* ITEM_IS_MISSING */ "Falta el artículo",
        /* ITEM_IS_NOT_COMPLIANT */ "El artículo no cumple",
        /* ITS_NOT_ME */ "No soy yo",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU */ "Parece que ya tenemos una cuenta que existe en este dispositivo. ¿Eres tu?",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU */ "Parece que ya tenemos una cuenta que coincide con sus datos. ¿Eres tu?",
        /* IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK */ "Parece que no tiene visitas esta semana.",
        /* IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE */ "Parece que no estás trabajando con ninguna agencia. ¿Le gustaría ser contratado por las agencias llenando una solicitud?",
        /* I_DONT_HAVE_MY_CODE */ "No tengo un código",
        /* I_DONT_WANT_THIS_CASE */ "No quiero este caso",
        /* I_DONT_WANT_TO_CLOCK */ "No quiero registrar",
        /* I_FORGOT_MY_PIN_CODE */ "Olvidé mi código PIN.",
        /* I_HAVE_CHANGED_MY_MIND */ "he cambiado de opinión",
        /* I_HAVE_READ_AND_AGREE */ "he leído y estoy de acuerdo con",
        /* I_VERIFY_THE_TERMS */ "Estoy de acuerdo con los términos y condiciones",
        /* I_WANT_TO_CLOCK_IN_ANYWAY */ "Quiero registrar de todos modos",
        /* I_WANT_TO_CLOCK_OUT_ANYWAY */ "Quiero salir de todos modos",
        /* I_WANT_TO_FINISH_MY_ONBOARDING */ "Quiero terminar mi incorporación",
        /* I_WILL_DO_IT_LATER */ "lo haré después",
        /* JANUARY */ "Enero",
        /* JOINED_DATE */ "Fecha de inscripción",
        /* JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT */ null,
        /* JULY */ "Julio",
        /* JUNE */ "Junio",
        /* JUST_ONE_MORE_THING */ "Solo una cosa más",
        /* JUST_TO_BE_SURE */ "Sólo para estar seguro...",
        /* JUST_VERIFYING_ITS_YOU */ "Solo verificando que eres tú",
        /* KEEP_UP_THE_GOOD_WORK */ null,
        /* LABELS */ "Etiquetas",
        /* LANGUAGE */ "idioma",
        /* LANGUAGES */ "Idiomas",
        /* LAST_NAME */ "Apellido",
        /* LEARN_MORE */ "Aprende más",
        /* LEAVE_WITHOUT_SAVING */ "¿Salir sin guardar?",
        /* LEFT */ null,
        /* LESSON */ "Lección",
        /* LESSONS */ "Lecciones",
        /* LETS_CONTINUE_TO_NEXT_SECTION */ "¡Continuemos a la siguiente sección!",
        /* LETS_FIND_CASES */ "¡Encontremos casos!",
        /* LETS_FIND_YOUR_FIRST_CASE */ "¡Encontremos tu primer caso!",
        /* LETS_FIND_YOUR_FIRST_PATIENT */ "¡Encontremos a su primer paciente!",
        /* LETS_FINISH_YOUR_SHIFT */ null,
        /* LETS_START */ "¡Empecemos!",
        /* LETS_START_YOUR_SHIFT */ null,
        /* LIKE_US_ON_FACEBOOK */ "Denos un \"Me gusta\" en Facebook.",
        /* LINKED_TO_ANOTHER_PATIENT */ null,
        /* LIST */ "Lista",
        /* LISTENING___ */ null,
        /* LIST_OF_PATIENTS */ "Lista de pacientes",
        /* LIST_OF_TASKS */ "Lista de tareas",
        /* LIST_OF_VISITS */ "Lista de visitas",
        /* LIVE_CHAT_SUPPORT */ "Asistencia en chat en vivo",
        /* LIVE_CLASS */ "Clase en vivo",
        /* LIVE_CLASS_EXPLANATION */ "Podrá unirse a la clase una vez que comience. En caso de que te lo hayas perdido, podrás ver el seminario web grabado",
        /* LIVE_EVENTS */ "Eventos en vivo",
        /* LOADING */ "Cargando",
        /* LOADING_LOCATION */ "Cargando ubicación...",
        /* LOCATION */ "Ubicación",
        /* LOCKED */ "Ingreso registrado",
        /* LOGGING_YOU_IN */ "Registrando",
        /* LOGIN */ "Acceso",
        /* LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED */ "Parece que has estado tratando de iniciar sesión desde un dispositivo diferente. Por favor, conteste a las siguientes preguntas",
        /* LOOKS_LIKE_MORE_THAN */ "Parece más de",
        /* LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION */ "¡Parece que estás demasiado lejos de la ubicación de la visita!",
        /* MAIN_TASKS */ "Tareas principales",
        /* MAKE_A_DIFFERENCE */ null,
        /* MAKE_SURE_PICTURE_IS_CLEAR */ "Asegúrese de que la imagen no esté borrosa y que pueda leer el texto",
        /* MALE */ "Hombre",
        /* MANUALLY_SUBMITTED_INFO */ "Información enviada manualmente",
        /* MAP */ "Mapa",
        /* MARCH */ "Marzo",
        /* MAX_TRAVEL_DISTANCE */ "Distancia máxima de viaje",
        /* MAY */ "Puede",
        /* MAYBE_LATER */ "quizás en otro momento",
        /* MAY_CLOCK_IN_AT */ "Puede registrar su llegada a las",
        /* MAY_CLOCK_OUT_FROM */ "Puede registrar su salida a partir de las",
        /* MEC_WAIVER_INFORMATION */ null,
        /* MEDFLYT */ "Medflyt",
        /* MEDFLYTS_MONTHLY_RAFFLE */ null,
        /* MEDFLYT_AGENCY_HANDBOOK */ "Manual de la Agencia Medflyt",
        /* MEDFLYT_AT_HOME_BENEFITS */ null,
        /* MEDFLYT_CHALLENGE */ "Reto de MedFlyt",
        /* MEDFLYT_HOME_CARE */ "Medflyt cuidado doméstico",
        /* MEDFLYT_ID_CARD */ "Tarjeta de identificación de Medflyt",
        /* MEDFLYT_PASSPORT */ "Cartilla de Medflyt",
        /* MEDFLYT_PASSPORT_TERMS */ "Términos de pasaporte de Medflyt",
        /* MEDFLYT_RAFFLE */ null,
        /* MEDFLYT_TEAM */ "Equipo de Medflyt",
        /* MEDFLYT_VERSION */ "Versión de MedFlyt",
        /* MEDICAL_FILES */ "Archivos médicos",
        /* MEDICAL_INFORMATION */ "Información médica",
        /* MEDICAL_NOTES */ "Notas médicas",
        /* MEDICATIONS */ null,
        /* MESSAGE */ "Mensaje",
        /* MESSAGE_FOR_THE_COORDINATOR */ "Mensaje para el coordinador",
        /* MIDDLE_NAME */ "Segundo nombre",
        /* MILES_AWAY */ "millas de distancia",
        /* MILES_BETWEEN_PATIENTS */ "millas entre pacientes",
        /* MILES_SHORT */ "millas",
        /* MINIMUM_WAGE */ "Salario mínimo",
        /* MINUTE */ null,
        /* MINUTES */ "Minutos",
        /* MINUTE_VISIT */ "minutos por visita",
        /* MISSING */ "Falta",
        /* MISSING_CLOCKS */ "Relojes faltantes",
        /* MISSING_PERSONAL_CARE_DUTY */ null,
        /* MM_DD_YYYY */ "mm/dd/yyyy",
        /* MOBILE_PHONE */ "Teléfono móvil",
        /* MOBILITY_STATUS */ "Estado de movilidad",
        /* MONTH */ "Mes",
        /* MONTHLY_RAFFLE */ null,
        /* MORE_DETAILS */ "Más información",
        /* MORE_DETAILS_BELOW */ "Más detalles a continuación",
        /* MORE_SHIFTS_MORE_CHANCES */ null,
        /* MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* MUST_AGREE_TERMS */ "Debe aceptar los Términos de uso y la Política de privacidad seleccionando la casilla de verificación.",
        /* MUST_BE_ATLEAST_3_CHARACTERS */ "Debe tener 3 caracteres como mínimo",
        /* MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS */ "Debe ser uno de los días siguientes",
        /* MUST_PICK_EXACTLY */ "Debe elegir exactamente",
        /* MUST_START_AT_OR_AFTER */ "debe comenzar A o DESPUÉS de las",
        /* MUST_START_AT_OR_BEFORE */ "debe comenzar A o ANTES de las",
        /* MUST_UPDATE_ADDRESS_TO_SEE_CASES */ "¡Debe actualizar su dirección para ver casos!",
        /* MY_AGENCIES */ "Mis agencias",
        /* MY_ASSIGNED_VISITS */ "Mis visitas asignadas",
        /* MY_AVAILABILITY */ null,
        /* MY_BENEFITS_CARD_INFORMATION */ null,
        /* MY_MEDFLYT_COMPLIANCE */ "Mi cumplimiento de Medflyt",
        /* MY_PASSPORT */ "Mi cartilla",
        /* MY_PAYROLL_HISTORY */ null,
        /* MY_PAYROLL_INFORMATION */ "Mi información de nómina",
        /* MY_PROFILE */ null,
        /* MY_REQUESTED_VISITS */ "Mis visitas solicitadas",
        /* MY_STAFFING_PREFERENCES */ null,
        /* MY_UPCOMING_VISITS_REMINDERS */ "Visitar recordatorios",
        /* MY_VIRTUAL_ID */ "Mi identificación virtual",
        /* MY_VISITS */ null,
        /* NA */ "N/D",
        /* NAME */ "Nombre",
        /* NEAR */ "Cerca",
        /* NEED_DIRECTIONS */ "¿Necesita indicaciones?",
        /* NET_PAY_FOR_PERIOD */ null,
        /* NEW */ "Nuevo",
        /* NEW_END_TIME_X */ null,
        /* NEW_MESSAGE */ "Nuevo mensaje",
        /* NEW_TASK */ "Nueva tarea",
        /* NEW_TASKS */ "Nuevas tareas",
        /* NEW_VISITS_AVAILABLE */ "Nuevas visitas disponibles",
        /* NEXT */ "Siguiente",
        /* NEXT_DUE */ "Próximo vencimiento",
        /* NEXT_LESSON */ "Siguiente lección",
        /* NEXT_SECTION */ "Siguiente etapa",
        /* NEXT_TOKEN_IN */ null,
        /* NEXT_YEAR */ "el próximo año",
        /* NO */ "No",
        /* NONE */ "Ninguno",
        /* NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT */ "Ninguno de ellos soy yo. Crear una nueva cuenta",
        /* NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU */ "Ninguna de las siguientes cuentas eres tú",
        /* NOTES */ "Notas",
        /* NOTIFICATIONS */ "Notificaciones",
        /* NOTIFICATIONS_OFF */ "Notificaciones",
        /* NOTIFICATIONS_ON */ "Notificaciones",
        /* NOT_AVAILABLE */ "No disponible",
        /* NOT_COMPLIANT */ "No conforme",
        /* NOT_DUE_YET */ null,
        /* NOT_ENOUGH_HOURS */ "Son muy pocas horas.",
        /* NOT_ENOUGH_SHIFTS */ "No hay suficientes turnos...",
        /* NOT_ENOUGH_SHIFTS_MESSAGE */ "Debe solicitar al menos %minShifts% turnos para pedir esta consulta (usted eligió solo %currentShifts%).",
        /* NOT_FOUND */ "Extraviado",
        /* NOT_INTERESTED */ "No me interesa",
        /* NOT_SELECTED */ null,
        /* NOT_SET */ null,
        /* NOT_SIGNING */ "No firmando",
        /* NOT_STARTED */ null,
        /* NOT_URGENT */ "No urgente",
        /* NOVEMBER */ "Noviembre",
        /* NO_ALLERGIES */ "No hay alergias conocidas",
        /* NO_ANSWERS_TO_COPY */ "No hay respuestas de donde copiar.",
        /* NO_ANSWERS_TO_COPY_TITLE */ "¡Falló la copia!",
        /* NO_AVAILABLE_SLOTS */ null,
        /* NO_BALANCE */ "Sin equilibrio",
        /* NO_CHANGES_WERE_MADE */ "No se han hecho cambios.",
        /* NO_COMPLIANT_ITEMS */ null,
        /* NO_DOCUMENTS */ "Sin documentos",
        /* NO_DOCUMENTS_AVAILABLE */ "No hay documentos disponibles",
        /* NO_DOCUMENTS_REQUIRED */ "No se requiere ningún documento.",
        /* NO_DUTIES_REQUIRED_FOR_THIS_VISIT */ null,
        /* NO_EDUCATION_LINK */ "¿Quiere educación gratis? Comuníquese con su agencia.",
        /* NO_ELIGIBLE_VISITS */ null,
        /* NO_END_DATE */ "Sin fecha de finalización",
        /* NO_GENERAL_NOTES */ "No hay notas generales",
        /* NO_IN_SERVICE_VIDEOS_AVAILABLE */ "No hay videos de servicio disponibles. Comuníquese con su agencia para ver los detalles.",
        /* NO_ISSUES_FOUND */ null,
        /* NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT */ "No, no soy yo. Crear una nueva cuenta",
        /* NO_JUST_THIS_ONE */ null,
        /* NO_KEEP_THE_ORIGINAL_TIMES */ null,
        /* NO_KNOWN_ALLERGIES */ "No hay alergias conocidas",
        /* NO_LESSONS */ "Ninguna lección",
        /* NO_LESSONS_FOR_YOU_YET */ "Aún no hay lecciones para usted",
        /* NO_MEDICAL_INFORMATION */ "Sin información médica",
        /* NO_NOTIFICATIONS */ "Sin notificaciones",
        /* NO_PAYSTUBS_FOUND_FOR_THIS_MONTH */ null,
        /* NO_PHONE */ "Falta el número de teléfono",
        /* NO_PHYSICIAN_SELECTED */ null,
        /* NO_PREVIOUS_CONVERSATIONS */ "No hay conversaciones anteriores",
        /* NO_SCHEDULED_VISITS_TODAY */ "No hay consultas programadas para hoy",
        /* NO_SHIFTS_SELECTED */ "No cambios seleccionados",
        /* NO_TAKE_ME_BACK */ null,
        /* NO_TESTS */ "Sin pruebas",
        /* NO_THANKS */ "No, gracias",
        /* NO_TIME_LIMIT */ "Sin límite de tiempo",
        /* NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT */ null,
        /* NO_VIDEOS */ "Sin videos",
        /* NO_VISITS_SCHEDULED */ null,
        /* NO_VISITS_SCHEDULED_MESSAGE */ null,
        /* NO_VISITS_SELECTED */ "No hay visitas seleccionadas",
        /* NPI */ null,
        /* NUM_COUNT_ITEMS */ null,
        /* NUM_SHIFTS_TO_GO */ null,
        /* NUM_SHIFTS_TO_WAGE */ null,
        /* N_A */ "N / A",
        /* OCTOBER */ "Octubre",
        /* OF */ "De",
        /* OF_THE_REQUIRED_PLEASE_CONTINUE */ "del tiempo requerido. Por favor, continúe",
        /* OF_THE_VIDEO */ "del video",
        /* OK */ "Aceptar",
        /* OK_ILL_TRY_LATER */ "Ok, lo intentaré más tarde",
        /* OK_NO_PROBLEM */ "¡De acuerdo, no hay problema!",
        /* OK_THANKS */ "¡Bueno, gracias!",
        /* ON */ "El",
        /* ONBOARDING */ "Inducción",
        /* ONBOARDING_COMPLETED */ "Incorporación completada",
        /* ONBOARDING_COMPLETED_MESSAGE */ "Ha completado todas las secciones del proceso de incorporación. Puedes comenzar a ver los videos de orientación ahora.",
        /* ONE_DAY_TO_COMPLETE */ "Un día para completar",
        /* ONE_DOCUMENT */ "Un documento",
        /* ONE_DOCUMENT_SELECTED */ "1 documento seleccionado",
        /* ONE_HOUR */ "1 hora",
        /* ONE_LAST_STEP */ "Un último paso",
        /* ONE_LESSON */ "Una lección",
        /* ONE_TEST */ "Una prueba",
        /* ONE_THOUSAND_POINTS */ "1000 puntos",
        /* ONE_VIDEO */ "Un video",
        /* ON_HOLD */ "Pendiente",
        /* ON_LEAVE */ "En descanso",
        /* OOPS */ "Ups",
        /* OPEN */ "Abierto",
        /* OPEN_CAMERA */ "Cámara abierta",
        /* OPEN_CERTIFICATE */ "Certificado abierto",
        /* OPEN_DEVICE_SETTINGS */ null,
        /* OPEN_MAPS */ null,
        /* OPEN_SETTINGS */ "Configuración abierta",
        /* OPTIONAL_TASKS */ null,
        /* OR */ "o",
        /* OTHER */ "Otro",
        /* OTHER_PERTINENT_DIAGNOSIS */ "Otro diagnóstico pertinente",
        /* OTHER_REASON */ null,
        /* OTHER_TASKS */ null,
        /* OTHER_VISITS */ null,
        /* OUTBOUND_CALL_ERROR_MESSAGE */ null,
        /* OUTBOUND_CALL_ERROR_TITLE */ null,
        /* OUTBOUND_CALL_PROMPT_MESSAGE */ null,
        /* OUTBOUND_CALL_PROMPT_TITLE */ null,
        /* OUTBOUND_CALL_SUCCESS_MESSAGE */ null,
        /* OUTBOUND_CALL_SUCCESS_TITLE */ null,
        /* OUT_OF */ "de",
        /* OUT_OF_RANGE */ null,
        /* OVERDUE */ null,
        /* OVERLAPPING_VISIT_ERROR */ "Las consultas se superponen, seleccione otra fecha u hora.",
        /* OVERRIDE_FORM */ null,
        /* OVERRIDE_FORM_MESSAGE */ null,
        /* OVER_NIGHT */ "Por la noche",
        /* PAGE */ "Página",
        /* PAID */ "Pagado",
        /* PAID_X_OUT_OF_Y */ "Pagado {x} de {y}",
        /* PARTIAL_SELECTION */ "Selección parcial",
        /* PASSPORT */ "Pasaporte",
        /* PASSPORT_TERMS_TEXT */ "Cargue fácilmente todo su cumplimiento y archivos médicos para compartir con agencias con las que está trabajando.",
        /* PASTE */ "Pegar",
        /* PAST_DUE */ "Vencido",
        /* PAST_SINCE_THE_VISIT_STARTED */ "pasado desde que comenzó la visita",
        /* PAST_UPLOADS */ "Cargas anteriores",
        /* PAST_VISITS */ "Visitas pasadas",
        /* PATIENT */ "Paciente",
        /* PATIENTS */ "Pacientes",
        /* PATIENT_ADDRESS */ "Domicilio del paciente",
        /* PATIENT_CANT_PHISICALLY_SIGN */ null,
        /* PATIENT_CANT_SIGN */ null,
        /* PATIENT_CONTACTS */ null,
        /* PATIENT_DOC_NOT_SUBMITTED */ "El documento del paciente no se envió debido a un error",
        /* PATIENT_DOC_SUBMISSION_MISSMATCH */ "Está a punto de enviar el formulario, pero la fecha programada de la consulta es diferente a la actual. Elija la fecha que le gustaría tener en el formulario",
        /* PATIENT_DOC_SUBMITTED_SUCCESSFULY */ "El documento del paciente se envió correctamente",
        /* PATIENT_INFO */ "Datos del paciente",
        /* PATIENT_IS_NOT_HOME */ null,
        /* PATIENT_IS_NOT_SIGNING */ "El paciente no está firmando",
        /* PATIENT_NAME */ "Nombre del paciente",
        /* PATIENT_NOT_FOUND */ "Paciente no encontrado",
        /* PATIENT_NOT_FOUND_EXPLAIN */ "Lo siento, parece que el paciente que estaba buscando no se le asigna.",
        /* PATIENT_NUMBER */ "Paciente número",
        /* PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE */ "Este paciente aún está pendiente de aprobación de la compañía de seguros. La fecha de inicio puede cambiar",
        /* PATIENT_PHONE */ "Teléfono del paciente",
        /* PATIENT_REFUSES_TO_SIGN */ null,
        /* PATIENT_REPORT */ "Informe del paciente",
        /* PATIENT_REQUESTS */ "Solicitudes de pacientes",
        /* PATIENT_SCHEDULE */ null,
        /* PATIENT_SIGNATURE */ "Firma del paciente",
        /* PATIENT_SIGNATURE_IS_REQUIRED */ "Se requiere la firma del paciente",
        /* PATIENT_SIGNATURE_REQUIRE_MSG */ "Especifique una razón por la cual la firma del paciente no se encuentra",
        /* PATIENT_SIGN_HERE */ "Firma del cliente",
        /* PATIENT_UNAVAILABLE_DURING_THESE_HOURS */ null,
        /* PATIENT_VISITS */ null,
        /* PAUSE_READING */ "Pausa de lectura",
        /* PAYMENT_METHOD */ null,
        /* PAYROLL */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE */ "Al problema le puede faltar información EVV, las horas de reloj / salida no coinciden, la ubicación de entrada / salida de reloj está fuera de alcance y más.",
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE */ "Hay un problema que está impediendo el pago de esta visita.",
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE */ "Estamos procesando su transacción de pago, Debería ver el dinero en su cuenta bancaria para {PROCESS_TIME} 🙏🏼",
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_TITLE */ "En curso",
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE */ "Parece que esta visita le falta reloj adentro o hacia afuera.",
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE */ "Falta el reloj dentro o fuera",
        /* PAYROLL_STATUS_PAID_MODAL_MESSAGE */ "El resto de la cantidad ({x}) se pagará en el cheque de pago semanal",
        /* PAYROLL_STATUS_PAID_MODAL_TITLE */ "Esta visita fue pagada al 80% a través de nuestro servicio Instapay ({x})",
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE */ "Al problema le puede faltar información EVV, las horas de reloj / salida no coinciden, la ubicación de entrada / salida del reloj está fuera de alcance y más.",
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE */ "Tenga en cuenta que la cantidad presentada es antes de las reducciones de impuestos.",
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE */ "Esta visita se pagará en su cheque de pago semanal.",
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE */ "Una vez que terminará el cambio y obtendremos los datos de EVV necesarios, puede reclamar esta visita a Instapay.",
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE */ "Todavía no asististe a esta visita.",
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE */ null,
        /* PAYSTUB */ null,
        /* PAYSTUBS */ null,
        /* PAY_ME_NOW */ "¡Pagame ahora!",
        /* PAY_ME_NOW_X */ "Pagame ahora {x} !!!",
        /* PENDING */ "Pendiente",
        /* PENDING_APPLICATION */ "Solicitud pendiente",
        /* PENDING_APPROVAL */ "Aprobación pendiente",
        /* PENDING_CONFIRMATION */ "Confirmación pendiente",
        /* PENDING_ISSUES */ "Asuntos pendientes",
        /* PENDING_VERIFICATION */ null,
        /* PERMANENT_VISIT_DETAILS */ "Información de la visita regular",
        /* PERMANENT_VISIT_FROM */ "Visita regular de",
        /* PERMANENT_VISIT_TYPE */ "Visita permanente",
        /* PERMISSION_NEEDED_FOR_CAMERA */ null,
        /* PERMISSION_NEEDED_FOR_CAMERA_MESSAGE */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE */ null,
        /* PERMISSION_TO_CAMERA_DENIED */ null,
        /* PER_HOUR */ null,
        /* PER_SHIFT */ "Por turno",
        /* PER_VISIT */ "por visita",
        /* PER_WEEK */ "por semana",
        /* PHONE */ "Teléfono",
        /* PHONES */ "Teléfonos",
        /* PHONE_CALL_SUPPORT */ "Llamar al departamento de asistencia",
        /* PHOTO_LIBRARY */ "librería fotográfica",
        /* PHYSICIAN_DETAILS */ null,
        /* PICK_A_DATE */ "Elija una fecha",
        /* PICK_A_TIME */ "Elegir una hora",
        /* PLAN_OF_CARE */ "Plan de atención",
        /* PLEASE_ASK_THE_PATIENT */ null,
        /* PLEASE_CALL_PATIENT_IN_NEXT_SCREEN */ "Llame al paciente en la siguiente pantalla",
        /* PLEASE_CHAT_WITH_THE_AGENCY */ "Por favor chatee con la agencia",
        /* PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY */ "Verifique que lo haya ingresado correctamente.",
        /* PLEASE_CHOOSE_A_LANGUAGE */ "Seleccione un idioma.",
        /* PLEASE_CHOOSE_A_TIME */ "Elija una hora",
        /* PLEASE_CHOOSE_DATE_BETWEEN */ "Elija la fecha entre",
        /* PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES */ "Complete los paquetes de años anteriores",
        /* PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT */ "Por favor mire y envíe las pruebas para seguir cumpliendo.",
        /* PLEASE_CONFIRM_THE_TIMES_CHOSEN */ "Por favor, confirme las horas elegidas",
        /* PLEASE_CONFIRM_YOUR_INFORMATION */ "Por favor, confirme su información.",
        /* PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS */ "Póngase en contacto con la agencia para recibir más detalles.",
        /* PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY */ "Por favor contacte a sus agencias inmediatamente",
        /* PLEASE_CONTACT_YOUR_AGENCY */ "Póngase en contacto con su agencia",
        /* PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS */ "Póngase en contacto con su agencia para una dirección",
        /* PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY */ "Comuníquese con su agencia inmediatamente",
        /* PLEASE_CONTACT_YOUR_COORDINATOR */ "Comuníquese con su coordinador.",
        /* PLEASE_ENABLE_LOCATION */ "Habilite la ubicación",
        /* PLEASE_ENTER_A_VALID_PHONE_NUMBER */ "Introduzca un número de teléfono válido",
        /* PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME */ "Ingrese el nombre y apellido del paciente",
        /* PLEASE_ENTER_PATIENT_NAME */ "Ingrese el nombre del paciente",
        /* PLEASE_ENTER_THE_PATIENT_PHONE */ "Ingrese el teléfono del paciente",
        /* PLEASE_ENTER_YOUR_PIN_CODE */ "Introduzca su código PIN.",
        /* PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED */ null,
        /* PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER */ "Complete los últimos 4 dígitos del número de teléfono",
        /* PLEASE_FILL_IN_YOUR_INFORMATION */ "Llene su información.",
        /* PLEASE_FILL_REQUIRED_FIELDS */ "Por favor llene todos los campos requeridos",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY */ "Asegúrese de haber ingresado el código correctamente",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY */ "Asegúrese de haber ingresado su número de teléfono correctamente",
        /* PLEASE_MARK_ALL_THE_REQUIRED_DUTIES */ null,
        /* PLEASE_NOTE */ "Tenga en cuenta",
        /* PLEASE_PICK_VALID_DATES */ "Por favor, seleccione fechas válidas.",
        /* PLEASE_REQUEST_EXACTLY */ "Por favor, solicite exactamente",
        /* PLEASE_SELECT_AN_OPTION */ "Por favor seleccione una opción",
        /* PLEASE_SELECT_DATE_AND_TIME */ "Seleccione la fecha y la hora",
        /* PLEASE_SELECT_THE_PATIENT_ADDRESS */ "Seleccione la dirección del paciente",
        /* PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT */ null,
        /* PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW */ "Establezca su foto de perfil haciendo clic en el ícono de la cámara que aparece abajo.",
        /* PLEASE_SIGN_IN_AGAIN */ "Por favor, inicie sesión nuevamente",
        /* PLEASE_SPECIFY */ null,
        /* PLEASE_TAKE_A_SELFIE */ null,
        /* PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK */ "Por favor, díganos cuándo planea realizar esta tarea.",
        /* PLEASE_TYPE_IN_YOUR_PHONE_NUMBER */ "Escriba su número de teléfono",
        /* PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH */ "Por favor, escriba el código de la agencia con la que le gustaría trabajar.",
        /* PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER */ "Escriba los últimos 4 dígitos de este número de teléfono",
        /* PLEASE_TYPE_THE_SMS_CODE */ "Por favor, escriba el código SMS.",
        /* PLEASE_UPDATE_TO_OUR_NEWEST_VERSION */ "Por favor, actualícese a nuestra versión más nueva.",
        /* PLEASE_UPDATE_YOUR_ADDRESS */ "Por favor, actualice su domicilio.",
        /* PLEASE_UPDATE_YOUR_FIRST_NAME */ "Por favor, actualice su nombre.",
        /* PLEASE_UPDATE_YOUR_LAST_NAME */ "Por favor, actualice su apellido.",
        /* PLEASE_WAIT */ "Espere por favor",
        /* PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION */ null,
        /* PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP */ "Mire el video completo para proceder a la aplicación",
        /* POINTS */ "Puntos",
        /* POINTS_AND_REWARDS */ "Puntos y recompensas",
        /* POSTED_DATE */ "Fecha de publicación",
        /* PREBLOCK_VISIT_EXPLANATION */ "Después de confirmar, tendrá un plazo limitado para comunicarse con el paciente y seleccionar la hora para la visita.",
        /* PRESENTATION */ "Presentación",
        /* PREVIOUS */ "Anterior",
        /* PREVIOUS_CONVERSATIONS */ "Conversaciones anteriores",
        /* PREVIOUS_WINNERS */ null,
        /* PRE_TAXES */ "previos a los impuestos",
        /* PRICE */ "Precio",
        /* PRINCIPAL_DIAGNOSIS */ "Diagnóstico principal",
        /* PRIORITY_CODE */ "Código de prioridad",
        /* PRIVACY_POLICY */ "la política de privacidad",
        /* PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN */ "Se produjo un problema al obtener su ubicación. Por favor, intente nuevamente. Intente activar los servicios de ubicación o salir al exterior.",
        /* PROBLEM_WITH_CASE_SETTINGS */ "Parece que tiene un problema con la configuración de su caso",
        /* PROCESSING */ "Procesando",
        /* PROFESSIONAL_TYPE */ "Tipo de profesional",
        /* PROFILE */ "Perfil",
        /* PROGRESS */ null,
        /* PROXY_FIRST_NAME */ null,
        /* PROXY_LAST_NAME */ null,
        /* PROXY_PHONE */ null,
        /* PULSE */ "Legumbres",
        /* QUESTION */ "Pregunta",
        /* QUESTIONS */ "Preguntas",
        /* QUESTIONS_TO_COPY_FROM */ "Preguntas para copiar",
        /* QUESTION_NUMBER */ null,
        /* QUESTION_REJECTED */ "Pregunta rechazada",
        /* QUIT */ "Abandonar",
        /* RAFFLE_ENDED */ null,
        /* RAFFLE_INFO_1_DESCRIPTION */ null,
        /* RAFFLE_INFO_1_TITLE */ null,
        /* RAFFLE_INFO_2_DESCRIPTION */ null,
        /* RAFFLE_INFO_2_TITLE */ null,
        /* RAFFLE_INFO_3_DESCRIPTION */ null,
        /* RAFFLE_INFO_3_TITLE */ null,
        /* RAFFLE_INFO_4_DESCRIPTION */ null,
        /* RAFFLE_INFO_4_TITLE */ null,
        /* RAFFLE_NOW */ null,
        /* RAFFLE_PRIZE */ null,
        /* RANK_ACHIEVED */ null,
        /* REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION */ null,
        /* READY_FOR_YOUR_NEXT_TRAINING */ "¿Listo para su próxima capacitación?",
        /* READY_TO_CLOCK_IN */ "Listo para registrar",
        /* READY_TO_CLOCK_OUT */ "Listo para salir",
        /* READ_AND_CONFIRM */ "Leer y confirmar",
        /* READ_ONLY_MODE */ "Solo leer modo",
        /* READ_TEXT */ "Lea el texto",
        /* REASON */ "Razón",
        /* RECENT_VISITS */ "Visitas recientes",
        /* RECOMMENDED */ null,
        /* RECRUITMENT_MAIN_1 */ "Parece que",
        /* RECRUITMENT_MAIN_1_2 */ "no está",
        /* RECRUITMENT_MAIN_2 */ "con ninguna agencia.",
        /* RECRUITMENT_MAIN_2_1 */ "trabajando",
        /* RECRUITMENT_MAIN_3 */ "Puede ser contratado por las agencias",
        /* RECRUITMENT_MAIN_4 */ "completando una postulación",
        /* REFERRAL_CODE */ "Código de recomendación",
        /* REFER_ME */ "¡Recomiéndame!",
        /* REGISTRATION */ "Registro",
        /* REGULAR_PAY */ "Salario regular",
        /* REJECT */ "Rechazar",
        /* REJECTED */ "Rechazada",
        /* REJECT_THIS_TASK */ "Rechazar esta tarea",
        /* REJECT_THIS_VISIT */ "Rechazar esta visita",
        /* REMAINED */ "se mantuvo",
        /* REMAINING */ "Restante",
        /* REMIND_ME_LATER */ "Recuérdame más tarde",
        /* REMOVE */ "Eliminar",
        /* REMOVE_PAGE */ "Eliminar página",
        /* REMOVE_TASK */ null,
        /* REOPENED */ null,
        /* REPLAY */ "Repetición",
        /* REQUEST */ "Solicitar",
        /* REQUESTED */ "Solicitado",
        /* REQUESTED_LABEL_IN_CASES_LIST */ "la etiqueta \"Solicitadas\" en la lista de casos.",
        /* REQUESTED_TIMES */ "Horas solicitadas",
        /* REQUESTED_VISIT_CANCEL_EXPLANATION */ null,
        /* REQUESTING_REFERENCE_RESPONSE */ null,
        /* REQUEST_AGENCIES_MEMBERSHIP */ "Solicitar membresía a agencias",
        /* REQUEST_AGENCY */ "Solicitar agencia",
        /* REQUEST_AGENCY_MEMBERSHIP */ "Solicitar membresía de la agencia",
        /* REQUEST_DETAILS */ "Información de la solicitud",
        /* REQUEST_FOR_APPOINTMENT */ "solicitud de cita",
        /* REQUEST_FRIENDSHIP */ "Solicitar amistad",
        /* REQUEST_MORE_VISITS */ "Solicitar más visitas",
        /* REQUEST_MORE_VISITS_MESSAGE */ "Parece que no te asignan ninguna visita esta semana, ¡vuelve más tarde! 🙂",
        /* REQUEST_NUMBER_SHIFTS */ "Solicitar %shifts% turnos",
        /* REQUEST_SELECTED_SHIFT */ "Solicitar el cambio seleccionado",
        /* REQUEST_SELECTED_SHIFTS */ "Solicitar cambios seleccionados",
        /* REQUEST_SHIFTS */ "Solicitar turnos",
        /* REQUEST_SINGLE_SHIFT */ "Solicitar un solo turno",
        /* REQUEST_THE_TIMES_YOU_WANT */ "¡Solicite las horas que desee!",
        /* REQUEST_THIS_VISIT */ "Solicitar esta visita",
        /* REQUEST_TO */ "Solicitud para",
        /* REQUEST_VISIT */ "Solicitar visita",
        /* REQUIRED */ "obligatorio",
        /* REQUIRED_DOCUMENTS */ "Documentos obligatorios",
        /* REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC */ "Faltan algunos campos obligatorios en el documento. Por favor, vuelva y complételos",
        /* REQUIRED_PATIENT_DOCUMENT_TEXT */ "Debe completar los siguientes documentos en esta visita",
        /* REQUIRED_TASKS */ "Tareas requeridas",
        /* REQUIREMENTS */ "Requisitos",
        /* RESCHEDULE */ "Reprogramar",
        /* RESCHEDULED_SUCCESSFULLY */ "Se ha reprogramado con éxito",
        /* RESCHEDULE_IN_THE_PAST_ERROR */ "No se puede reprogramar una consulta al pasado.",
        /* RESCHEDULE_REQUESTS */ "Reprogramar solicitudes",
        /* RESET_PIN_CODE_MESSAGE */ "Se lo llevará a la pantalla de inicio de sesión para iniciar un nuevo proceso de autenticación",
        /* RESPIRATION_RATE */ "Ritmo respiratorio",
        /* RESUBMISSION_BANNER_TITLE */ null,
        /* RETAKE */ "Hacer de nuevo",
        /* RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION */ "Acción de represalia por parte de los empleadores; prohibición",
        /* RETRY */ "Reintentar",
        /* REVIEW_PRIVACY_POLICY */ "Ver Política de privacidad",
        /* REVIEW_TASK */ "Tarea de revisión",
        /* REVIEW_TASKS */ "Revisar tareas",
        /* RE_ENTER_YOUR_PIN_CODE */ "Vuelva a introducir su código PIN.",
        /* RN_FLEXIBLE_SHOWCASE_TEXT */ "Visita flexible",
        /* RN_FLEX_EXPLANATION_PREFIX */ "Esto es",
        /* RN_FLEX_REQUESTED_EXPLANATION */ "Se le solicitará que seleccione la fecha y la hora que prefiera",
        /* RN_FLEX_REQUESTED_EXPLANATION_LINE_2 */ "El plazo para llevar a cabo esta visita es el siguiente",
        /* RN_PATIENT_CONTACT_EXPLANATION */ "Esta visita requiere que coordine una hora con el paciente.\n\nHaga clic en el botón en la parte inferior de la pantalla para ponerse en contacto con el paciente.",
        /* RN_SIGN_HERE */ "Firma del enfermero registrado",
        /* ROUTING_NUMBER */ "Número de enrutamiento",
        /* ROUTING_NUMBR */ "Número de enrutamiento",
        /* SAFETY_AND_HEALTH */ "Seguridad y salud",
        /* SAVE */ "Guardar",
        /* SAVE_FOR_LATER */ "¡Guardar para más adelante!",
        /* SCAN_AND_UPLOAD_FILES */ "Escanear y cargar archivos",
        /* SCAN_A_PHOTO */ "Escanear una foto",
        /* SCAN_DOCUMENT */ "Escanear documentos",
        /* SCAN_NEW_DOCUMENT */ "Escanear nuevo documento",
        /* SCAN_WITH_CAMERA */ "Escanear con cámara",
        /* SCHEDULE */ "Programar",
        /* SCHEDULED */ null,
        /* SCHEDULED_DATE */ "Cita agendada",
        /* SCHEDULED_FOR */ "Programado para",
        /* SCHEDULED_VISIT_COMPLETE */ "Consulta programada completada",
        /* SCHEDULED_VISIT_NOT_FOUND */ "No se encontró la visita programada, comuníquese con la agencia",
        /* SCHEDULE_CONFIRMATION */ null,
        /* SCHEDULE_FOR */ null,
        /* SCHEDULE_TASK */ null,
        /* SCHEDULING_PROBLEM */ "Problema de programación",
        /* SCREENING */ "Examen",
        /* SCREENING_FOR */ "Examen de:",
        /* SEARCH */ "Buscar",
        /* SEARCH_AGENCY */ "Buscar agencia",
        /* SEARCH_FOR_MEDICATIONS */ "Buscar medicamentos...",
        /* SEARCH_NEARY_VISITS */ null,
        /* SEARCH_PATIENT */ null,
        /* SECOND_SHIFT */ "Segundo turno",
        /* SECTION_ALREADY_COMPLETED */ "Esta sección ya estaba completada",
        /* SECTION_COMPLETED_PROMPT */ null,
        /* SECTION_LOCKED_PROMPT */ null,
        /* SEE_ALL */ null,
        /* SEE_ALL_CONVERSATIONS */ "Ver todas las conversaciones",
        /* SEE_IN_MAPS */ null,
        /* SEE_LIST_OF_VISITS */ "Ver lista de visitas",
        /* SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT */ "Consulte más información sobre el requisito previo",
        /* SEE_YOUR_PROGRESS */ null,
        /* SELECT */ "Seleccionar",
        /* SELECTED */ null,
        /* SELECTED_VISIT */ "Visita seleccionada",
        /* SELECT_ALL */ "Seleccionar todo",
        /* SELECT_CERTIFICATE */ "Seleccionar certificado",
        /* SELECT_DATE */ "Seleccionar fecha",
        /* SELECT_DATE_AND_TIME */ "Seleccione Fecha y hora",
        /* SELECT_DOCUMENT */ "Seleccionar documento",
        /* SELECT_DX_CODE */ "Seleccionar código DX",
        /* SELECT_FROM_LIST */ null,
        /* SELECT_PERTINENT_DIAGNOSIS */ "Seleccionar diagnóstico pertinente",
        /* SELECT_PHYSICIAN */ null,
        /* SELECT_PRINCIPAL_DIAGNOSIS */ "Seleccionar diagnóstico principal",
        /* SELECT_SHIFTS */ "Seleccionar cambios",
        /* SELECT_START_TIME */ null,
        /* SELECT_SURGICAL_PROCEDURE */ "Seleccionar procedimiento quirúrgico",
        /* SELECT_TIME */ "Seleccione la hora",
        /* SELECT_TIME_SLOT */ null,
        /* SELECT_TIME_SLOT_INFO */ null,
        /* SELECT_VISITS_FOR_INSTAPAY */ null,
        /* SELECT_VISIT_DURATION */ "Seleccione la duración de la visita",
        /* SELECT_YOUR_SCHEDULE */ "Seleccione su horario",
        /* SELFIE_WITH_PATIENT */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT */ null,
        /* SEND_A_MESSAGE */ "Enviar un mensaje",
        /* SEND_EMAIL */ "Enviar correo electrónico",
        /* SEND_REPORT */ "Enviar informe",
        /* SEND_US_A_MAIL */ "Envíenos un correo electrónico.",
        /* SEPTEMBER */ "Septiembre",
        /* SETTINGS */ "Ajustes",
        /* SETTINGS_AND_INFO */ null,
        /* SET_DOCUMENT_EXPIRY_DATE */ "Establecer fecha de caducidad del documento",
        /* SET_EXPIRATION_DATE */ "Establecer fecha de caducidad",
        /* SET_YOUR_4_DIGIT_PIN_CODE */ "Establezca su código PIN de 4 dígitos.",
        /* SHARE */ "Compartir",
        /* SHARE_IDEAS_AND_GET_A_CHANCE */ "Compartir ideas y tener la oportunidad de",
        /* SHARE_REFERENCE_LINK */ null,
        /* SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP */ null,
        /* SHARE_WITH_YOUR_FRIENDS */ "¡Compartir con tus amigos!",
        /* SHIFT */ "Turno",
        /* SHIFTS */ "Turno",
        /* SHIFTS_DETAILS */ "Detalles de cambios",
        /* SHIFT_HAS_FINISHED_IN */ "El cambio terminó en",
        /* SHIFT_HAS_STARTED_IN */ "El cambio comenzó a",
        /* SHOULD_BE_HERE */ "Debería estar aquí",
        /* SHOW_ALL_TASKS */ null,
        /* SHOW_DETAILS */ "Mostrar detalles",
        /* SHOW_LESS */ "Mostrar menos",
        /* SHOW_ME_CASES_IN_THE_NEXT */ "Mostrarme casos en los próximos",
        /* SHOW_ME_IN */ "Muéstrame cómo llegar",
        /* SHOW_MORE */ "Mostrar más",
        /* SHOW_OLD_PLAN_OF_CARE */ "Mostrar plan de atención anterior",
        /* SHOW_TASKS_THAT_REQUIRE_FIXES */ null,
        /* SHOW_US_YOUR_SMILE */ "¡Muéstranos tu sonrisa! 😊",
        /* SIGNATURES */ "Firmas",
        /* SIGNATURE_REQUIRED */ "Firma requerida",
        /* SIGN_DECLINATION_FORM */ null,
        /* SIGN_HERE */ "Firme aquí",
        /* SIGN_IN */ "Iniciar sesión",
        /* SIGN_ORIENTATION_VIDEO */ "Firme aquí antes de enviar",
        /* SIGN_ORIENTATION_VIDEO_ERR */ "Firme antes de enviar",
        /* SIGN_OUT */ "Cerrar sesión",
        /* SIGN_UP_FREE */ "Regístrate gratis",
        /* SIGN_UP_ITS_FREE */ "Inscribirse. ¡es gratis!",
        /* SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE */ "Dado que registró y salió a tiempo, puede obtener el 80% del pago del turno hoy :)",
        /* SINGLE_FLEXIBLE_VISIT_EXPLANATION */ null,
        /* SINGLE_VISIT_DETAILS */ "Información de la visita única",
        /* SINGLE_VISIT_FROM */ "Visita única de",
        /* SINGLE_VISIT_TYPE */ "Visita única",
        /* SIXTY_SECONDS_AND_YOU_ARE_DONE */ null,
        /* SKIP */ "Omitir",
        /* SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION */ "La dirección exacta se proporcionará después de la confirmación final",
        /* SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS */ "Necesitamos obtener la confirmación de más personas que puedan cambiar la visita, lo actualizaremos en las próximas horas.",
        /* SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN */ "Puede ver toda la información en la pantalla de visitas asignadas. ¡Buena suerte!",
        /* SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES */ "Observe: si no presenta la visita (a menos que por razones específicas) no podrá obtener más casos en esta agencia y será finalizado.",
        /* SLIDE_MAIN_INFO_GO_NEXT_SCREENS */ "Revise la información en las próximas pantallas para asegurarse de que pueda comenzar a trabajar en este caso.",
        /* SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW */ "¡Todo lo que necesitas saber sobre tu nueva visita!",
        /* SLIDE_STEP_X_OF_COUNT */ "Paso %paso %de %Steps_Count %",
        /* SMILE_FOR_US */ "¡Sonríe para nosotros! 📷",
        /* SOCIAL */ "Social",
        /* SOCIAL_MEDIA */ "Medios de comunicación social",
        /* SOMETHING_WENT_WRONG */ "Algo salió mal. Inténtelo nuevamente más tarde",
        /* SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS */ null,
        /* SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM */ null,
        /* SOME_TASKS_NEED_FIXES */ null,
        /* SORRY */ "Lo siento",
        /* SORT */ "Ordenar",
        /* SPECIFIC_DAYS */ "Días específicos",
        /* SPEECH_RECOGNITION */ null,
        /* SPLIT_SHIFTS_VISIT */ "Turnos fraccionados",
        /* SPREAD_THE_WORD */ "Corra la voz",
        /* STAGE_APPROVED_MESSAGE */ null,
        /* STAGE_AWAITING_APPROVAL */ null,
        /* STAGE_COMPLETED_MESSAGE */ null,
        /* STAGE_X_OF_TOTAL_STAGES */ "de",
        /* START */ null,
        /* STARTING_AT */ "Empezando a las",
        /* STARTS */ "Inicia",
        /* STARTS_NEXT_WEEK */ null,
        /* STARTS_TODAY_IN */ null,
        /* START_APPLICATION */ "Iniciar postulación",
        /* START_A_SURVEY */ "¡Empezar encuesta!",
        /* START_DATE */ "Fecha de inicio",
        /* START_FILLING */ null,
        /* START_NOW */ "Empezar ahora",
        /* START_SHIFT */ null,
        /* START_TIME */ "Hora de inicio",
        /* START_USING_MEDFLYT_PASSPORT */ "Comience a usar Passport de Medflyt",
        /* START_WATCHING */ "¡Empiece a mirar!",
        /* START_WATCHING_ORIENTATION_VIDEOS */ "Empiece a ver sus videos de orientación",
        /* START_WORKING */ "Empezar a trabajar",
        /* STATUS */ "Estado",
        /* STAY_ON_TRACK */ null,
        /* STAY_ON_TRACK_1_ANSWER */ null,
        /* STAY_ON_TRACK_1_QUESTION */ null,
        /* STAY_ON_TRACK_2_ANSWER */ null,
        /* STAY_ON_TRACK_2_QUESTION */ null,
        /* STAY_ON_TRACK_3_ANSWER */ null,
        /* STAY_ON_TRACK_3_QUESTION */ null,
        /* STAY_ON_TRACK_4_ANSWER */ null,
        /* STAY_ON_TRACK_4_QUESTION */ null,
        /* STAY_ON_TRACK_DESCRIPTION */ null,
        /* STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS */ "Estén atentos para más casos o toque para cambiar la configuración de la caja",
        /* STAY_TUNED_FOR_MORE_VISITS */ "Quédese al pendiente para más visitas",
        /* STAY_TUNED_FOR_THE_NEXT_RAFFLE */ null,
        /* STILL_WAITING_REFERENCE_ANSWER */ null,
        /* STOP */ null,
        /* STREAK_BREAK */ null,
        /* STREAK_BREAK_MESSAGE */ null,
        /* STREAK_BREAK_MESSAGE_2 */ null,
        /* SUBMIT */ "Enviar",
        /* SUBMITTED_AT */ "Enviado a",
        /* SUBMITTED_DOCUMENTS */ "Documentos presentados",
        /* SUBMITTED_MANUALLY */ "Enviado manualmente",
        /* SUBMIT_AFTER */ "Enviar después de",
        /* SUBMIT_AT */ "Enviar a",
        /* SUBMIT_BY */ "Enviar por",
        /* SUBMIT_DUTIES */ "Enviar tareas",
        /* SUBMIT_DUTIES_BEFORE_CLOCK_OUT */ "Envíe las tareas de la visita antes de bloquear",
        /* SUBMIT_FORM */ "Formulario de envío",
        /* SUBMIT_FORMS */ null,
        /* SUBMIT_MANUAL_TIMESHEET */ "Envíe la hoja de tiempo manual",
        /* SUBMIT_REQUIRED */ "El envío es obligatorio",
        /* SUBMIT_TEST */ "Enviar prueba",
        /* SUBMIT_TIMESHEET */ "Enviar hojas de tiempo",
        /* SUBMIT_WITH_SCHEDULED_DATE */ "Enviar con la fecha programada",
        /* SUBMIT_WITH_TODAY_DATE */ "Enviar con la fecha de hoy",
        /* SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT */ null,
        /* SUBMIT_YOUR_SIGN */ "Envíe su firma",
        /* SUBMIT_YOUR_SIGNATURE */ "Envíe su firma",
        /* SUCCESS */ "Éxito",
        /* SUCCESSFULLY_CLOCKED_IN */ "Con éxito registrado en",
        /* SUCCESSFULLY_CLOCKED_OUT */ "Registrado con éxito",
        /* SUCCESSFULY_REQUESTED */ "¡La solicitud se envió correctamente!",
        /* SURGICAL_PROCEDURE */ "Procedimiento quirúrgico",
        /* SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS */ "Cambie a la vista de lista para ver sus visitas importadas",
        /* SWITCH_VIEW */ "Cambiar vista",
        /* TAKE_A_DIFFERENT_PHOTO */ "Toma una foto diferente",
        /* TAKE_A_PHOTO */ "Tomar una foto",
        /* TAKE_A_SURVEY */ "Tome una encuesta y gane la oportunidad de obtener un",
        /* TAKE_ME_TO_CASE_SETTINGS */ "Ir a la configuración de casos",
        /* TAKE_PHOTO */ "Tomar foto",
        /* TAKE_THIS_TASK */ null,
        /* TAP_HERE_TO_VIEW */ "Pulse aquí para ver",
        /* TAP_TO_CANCEL */ "Toque para cancelar",
        /* TAP_TO_CHANGE_CASE_SETTINGS */ "Haga clic para cambiar los ajustes del caso",
        /* TASK */ "Tarea",
        /* TASKS */ "Tareas",
        /* TASK_ALREADY_ASSIGNED */ null,
        /* TASK_COMPLETED_SUCCESSFULLY */ "Felicitaciones🎉💪🏻Ha completado esta tarea",
        /* TASK_INFORMATION */ null,
        /* TASK_SCHEDULED */ null,
        /* TASK_SCHEDULED_MESSAGE */ null,
        /* TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE */ null,
        /* TECHNICAL_SUPPORT */ "Soporte técnico",
        /* TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES */ "Díganos por qué no le interesa y así podremos enviarle mejores casos.",
        /* TELL_US_YOUR_AGENY_DESCRIPTION */ "Díganos el nombre de su agencia, el nombre del coordinador y nos comunicaremos con ellos para transmitir casos abiertos.",
        /* TEMPERATURE */ "Temperatura",
        /* TEN_DOLLAR_STARBUCKS_GIFT_CARD */ "Tarjeta de regalo de $ 10 Starbucks",
        /* TERMINATED */ "Despedido",
        /* TERMS_OF_MEDFLYT_PRIVACY_POLICY */ "Términos de la política de privacidad de Medflyt",
        /* TERMS_OF_USE */ "los términos de uso",
        /* TEST */ "Prueba",
        /* TESTS */ "Pruebas",
        /* TEST_COMPLETED */ "Prueba completada",
        /* TEST_FAILED */ "No aprobó la prueba",
        /* TEST_REQUIRED */ "Se necesita una prueba",
        /* THANKS */ "¡Gracias!",
        /* THANK_YOU */ "¡Gracias!",
        /* THANK_YOU_FOR_YOUR_FEEDBACK */ "Gracias por sus comentarios.",
        /* THATS_ME */ "Ese soy yo",
        /* THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION */ null,
        /* THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS */ null,
        /* THERE_ARE_NO_AGENCIES_YET */ "Aún no hay agencias.",
        /* THERE_ARE_NO_ASSIGNED_CASES */ "No hay casos asignados",
        /* THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION */ "Hubo un problema con su conexión a Internet.",
        /* THERE_SEEMS_TO_BE_NOTHING_HERE */ "Parece que no hay nada aquí...",
        /* THE_AWARDS_ARE_COMING_SOON */ "¡Los premios llegarán pronto!",
        /* THE_BEST_PLACE_FOR_CAREGIVERS */ "El mejor lugar para los cuidadores",
        /* THE_DUTY_SHEET_HAS_BEEN_SUBMITTED */ "¡Bien hecho! La hoja de servicio ha sido presentada.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON */ null,
        /* THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS */ null,
        /* THE_NEXT_WINNERS_ANNOUNCEMENT */ "Anuncio del próximo ganador",
        /* THE_SELECTED_DATE_IS_EARLIER_THAN */ null,
        /* THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS */ "La visita puede realizarse los siguientes días",
        /* THE_VISIT_HAS_NOT_STARTED_YET */ "¡La visita aún no ha comenzado!",
        /* THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS */ null,
        /* THIS_BUNDLE_INCLUDES */ "Este paquete incluye",
        /* THIS_CONVERSATION_HAS_BEEN_RESOLVED */ "Esta conversación se ha resuelto. Comience una nueva conversación para continuar",
        /* THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK */ "Este curso consta de %d lecciones. ¡Buena suerte!",
        /* THIS_FIELD_IS_CURRENTLY_DISABLED */ "Este campo está actualmente deshabilitado.",
        /* THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT */ "Esta es una visita vieja. No es posible registrar llegada/salida.",
        /* THIS_IS_A_FUTURE_VISIT */ "Esta es una visita futura, solo puede comenzar esta visita en {start_date} en {start_time}.",
        /* THIS_IS_A_LIVE_CLASS_SESSION */ "Esta es una sesión de clase en vivo {duración} ({date_time})",
        /* THIS_MAY_TAKE_UP_TO_X_SECONDS */ null,
        /* THIS_PATIENT_BELONGS_TO_AGENCY */ null,
        /* THIS_PATIENT_HAS_NO_PHONE_NUMBERS */ "Este paciente no tiene números de teléfono",
        /* THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER */ "Esta pregunta es solo leída. No se le permite responder.",
        /* THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP */ null,
        /* THIS_VISIT_CAN_BE_PERFORMED_BETWEEN */ "Esta visita puede llevarse a cabo entre",
        /* THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE */ "Esta visita no requiere que se realicen ninguna tarea",
        /* THIS_VISIT_IS_FOR_DIFFERENT_AGENCY */ null,
        /* THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET */ "Esta visita es en el futuro, no puede registrar su llegada todavía.",
        /* THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY */ null,
        /* THIS_WILL_MARK_THE_VISIT_AS_MISSED */ null,
        /* TIME */ "Tiempo",
        /* TIMESHEET_SUBMITTED */ "Hojas de tiempo enviadas",
        /* TIME_ESTIMATION */ "Estimación de tiempo",
        /* TIME_FRAME */ "Plazo",
        /* TIME_LEFT */ "Tiempo restante",
        /* TIME_VARIES */ "La hora varía",
        /* TO */ "Hasta:",
        /* TODAY */ "Hoy",
        /* TODAYS_DATE */ "Fecha",
        /* TOKENS */ null,
        /* TOO_MANY_HOURS */ "Son demasiadas horas.",
        /* TOO_MANY_SHIFTS */ "¡Demasiados turnos!",
        /* TOO_MANY_SHIFTS_MESSAGE */ "Se le permite elegir hasta %maxShifts% turnos. Si desea elegir este turno, deberá anular la selección de uno de los turnos ya seleccionados.",
        /* TOP_CAREGIVERS_IN_YOUR_AREA */ "Mejores cuidadores en su área",
        /* TOTAL_EARNED */ null,
        /* TOTAL_SPENT */ null,
        /* TO_FILL_IN_A_FORM_INSTEAD */ null,
        /* TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT */ "Para recibir el tiempo a tiempo, debe ingresar y salir.",
        /* TO_SEE_THIS_TASK_GO_TO_ASSIGNED */ "Para ver esta tarea, vaya a la pestaña \"Asignada\"",
        /* TO_SEE_THIS_VISIT_GO_TO */ "Para ver esta visita, busque",
        /* TO_UPLOAD_A_FILE_INSTEAD */ null,
        /* TO_WIN_AN_IPHONE12 */ "Gana un iPhone 12",
        /* TRAINING */ "Capacitación",
        /* TRAININGS_FOR */ "Capacitaciones para",
        /* TRAINING_CENTER */ "Centro de formación",
        /* TRAINING_CENTER_REMINDERS */ "Recordatorios del centro de entrenamiento",
        /* TRY_AGAIN */ "Intentar otra vez",
        /* TYPE_AGENCY_CODE */ "Escriba el código de la agencia",
        /* TYPE_MESSAGE */ "Escriba el mensaje",
        /* TYPE_YOUR_ADDRESS */ "Escriba su dirección",
        /* UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET */ "La hoja de servicio ha sido presentada. No se le permite editarlo.",
        /* UNANSWERED_LAST_SECTION_FOR_NOW */ "Esta es la última sección por ahora, y no respondió todas las preguntas. Puedes regresar y completarlos o volver más tarde",
        /* UNAUTHORIZED */ "No autorizado",
        /* UNAVAILABLE_LOCATION_SERVICES_MESSAGE */ "Parece que no podemos acceder a la ubicación de su dispositivo. Asegúrese de que sus servicios de ubicación estén activados y estén disponibles.",
        /* UNDER_REVIEW */ null,
        /* UNDO */ "Deshacer",
        /* UNIQUE_ERROR_CODE */ "Código de error único",
        /* UNSCHEDULE */ "No estruendo",
        /* UNSCHEDULE_TASK */ "Tarea de no programación",
        /* UNSPECIFIED */ "No especificado",
        /* UNTIL */ "Hasta",
        /* UPCOMING_VISITS */ "Próximas visitas",
        /* UPDATED_AT */ null,
        /* UPDATE_INFORMATION */ "Actualizar información",
        /* UPLOAD */ "Cargar",
        /* UPLOADED */ "Cargado",
        /* UPLOADED_FILE_VIEW */ "Vista de archivo cargada",
        /* UPLOADING */ "Cargando",
        /* UPLOAD_A_DOCUMENT */ null,
        /* UPLOAD_A_FILE */ null,
        /* UPLOAD_DOCUMENT */ "Subir documento",
        /* UPLOAD_DOCUMENTS */ "Cargar documentos",
        /* UPLOAD_ERROR */ "Error en la carga",
        /* UPLOAD_FILES_TO_ENSURE */ "Cargue los archivos para su seguridad",
        /* UPLOAD_FLU_SHOT_DOCUMENT */ null,
        /* UPLOAD_FROM_GALLERY */ "Subiendo desde la galería",
        /* UPLOAD_NEW_DOCUMENT */ null,
        /* UPLOAD_VIDEO */ "Subir video",
        /* UPLOAD_YOUR_FILES_TO_ENSURE */ "Cargue sus archivos para su seguridad",
        /* UP_COMING_REASSESSMENTS */ "Próximas reevaluaciones",
        /* UP_TO */ "Hasta",
        /* URGENT */ null,
        /* USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY */ "Este usuario se ha bloqueado debido a actividad sospechosa",
        /* VALID */ "Válido",
        /* VERIFIED */ "Verificado",
        /* VERIFY */ "Verificar",
        /* VERIFYING */ "Verificación",
        /* VERIFY_YOUR_LOCATION */ "Verifique su ubicación",
        /* VERY_URGENT */ "Muy urgente",
        /* VIDEO */ "Video",
        /* VIDEOS */ "Videos",
        /* VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION */ "Los videos en el centro de entrenamiento requieren su atención.",
        /* VIDEO_COMPLETED_SUCCESSFULLY */ "Felicitaciones 🎉💪🏻Ha terminado de ver el video.",
        /* VIEW */ "Ver",
        /* VIEWED */ "Visto",
        /* VIEW_ALL */ null,
        /* VIEW_ANSWERS */ null,
        /* VIEW_CERTIFICATE */ "Ver certificado",
        /* VIEW_TASK */ null,
        /* VIEW_TASKS_PENDING_FOR_SCHEDULE */ "Ver tareas pendientes para el horario",
        /* VIEW_VISIT */ null,
        /* VIRTUAL_ID_CARD */ "Tarjeta de identificación virtual",
        /* VISIT */ "Visita",
        /* VISITS */ "visitas",
        /* VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER */ "Busque en su dirección las visitas cerca de usted ...",
        /* VISITS_NEXT_MONTH */ null,
        /* VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* VISITS_PER_WEEK */ "Consultas por semana",
        /* VISITS_WITH_ISSUES */ null,
        /* VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE */ "La consulta ha sido asignada, dele un vistazo en su agenda",
        /* VISIT_BY */ "Visita de/Visitar a más tardar",
        /* VISIT_CHAT */ "Visitar el chat",
        /* VISIT_COMPLETE */ "¡Has completado esta visita!",
        /* VISIT_COMPLETED_SUCCESSFULLY */ "Visita completada con éxito",
        /* VISIT_COUNTS */ null,
        /* VISIT_COUNTS_DESCRIPTION */ null,
        /* VISIT_DATE */ "Fecha de la visita",
        /* VISIT_DATES */ "Fechas de visita",
        /* VISIT_DETAILS */ "Detalles de la visita",
        /* VISIT_DURATION */ "Visitar duración",
        /* VISIT_INFORMATION */ null,
        /* VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU */ null,
        /* VISIT_LASTING */ "Duración de la visita",
        /* VISIT_NEXT_MONTH */ null,
        /* VISIT_NOTIFICATIONS_OFF */ "Notificaciones de visita - DESACTIVADAS",
        /* VISIT_NOTIFICATIONS_ON */ "Notificaciones de visita - ACTIVADAS",
        /* VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE */ "Aún no ha registrado esta consulta. ¿Estás seguro de que quiere registrar su salida?",
        /* VISIT_NO_LONGER_AVAILABLE */ "La visita ya no está disponible",
        /* VISIT_RATE_REQUEST_CONFIRMATION */ null,
        /* VISIT_REMINDERS */ "Visitar recordatorios",
        /* VISIT_REQUEST_CONFIRMATION_WARNING */ null,
        /* VISIT_SCHEDULE */ "Programa de visitas",
        /* VISIT_STARTED_AT */ "La visita comenzó en",
        /* VISIT_STARTED_MISSING_CLOCK_IN */ "VISIS COMENZAR, FALLA RELOJ EN",
        /* VISIT_STARTS_AT */ "La visita comienza en",
        /* VISIT_SUCESSFULLY_CANCELED */ "Consulta cancelada con éxito",
        /* VISIT_TIME_ADJUSTMENT */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_EARLY */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_LATE */ null,
        /* VISIT_TOO_SHORT */ null,
        /* VISIT_TYPE */ null,
        /* VISIT_WITH */ null,
        /* VOUCHER */ null,
        /* WAITING_FOR_APPROVAL */ "Esperando aprobación",
        /* WAITING_TO_BE_SCHEDULED */ "esperando ser programado",
        /* WARNING */ "¡Advertencia!",
        /* WAS_DUE_BETWEEN */ null,
        /* WAS_DUE_ON */ null,
        /* WATCHED */ "Visto",
        /* WATCH_HOW_IT_WORKS */ "Mira cómo funciona",
        /* WATCH_REQUIRED */ "El reloj es obligatorio",
        /* WATCH_TRAINING_VIDEOS_TO_COMPLETE */ null,
        /* WEEKLY_DETAILS */ "Detalles semanales",
        /* WELCOME */ "Bienvenido",
        /* WELCOME_BACK */ "Bienvenido de nuevo",
        /* WELCOME_TO_CARE_MOMENTS */ null,
        /* WELCOME_TO_MEDFLYT */ "¡Bienvenido a Medflyt!",
        /* WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE */ "¡Estaremos encantados de asignarte a esta visita! Pero primero, debes terminar la incorporación.\r\n            Es realmente fácil 🥰",
        /* WELL_BE_IN_TOUCH_SHORTLY */ "Nos pondremos en contacto con usted a la brevedad.",
        /* WERE_YOU_REFERRED_BY_SOMEONE */ "¿Alguien le hizo la recomendación?",
        /* WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM */ "Nos estamos perdiendo el récord de su %compliance_item%.",
        /* WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR */ "No pudimos encontrar la página que está buscando",
        /* WE_COULDNT_FIND_YOUR_AGENCY */ "¡No pudimos encontrar su agencia!",
        /* WE_GOT_YOUR_CONFIRMATION */ null,
        /* WE_GOT_YOUR_RESPONSE_WAIT_HH_MM */ "¡Recibimos tu respuesta! Tiene % cuenta de cuenta regresiva hasta la confirmación final 🤩",
        /* WE_HAVE_ONE_MATCHING_ACCOUNT */ "Hemos encontrado una cuenta coincidente basada en los detalles que ha proporcionado. ¿Eres tu?",
        /* WE_HAVE_X_MATCHING_ACCOUNTS */ "¿Existe la posibilidad de que una de las siguientes cuentas sea usted?",
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT */ null,
        /* WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT */ "No pudimos iniciarlo. Por favor, comuníquese con Medflyt Support",
        /* WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON */ "Te enviaremos la confirmación final pronto",
        /* WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE */ "¡Qué bonita foto! ¿Deberíamos continuar?",
        /* WHAT_BENEFITS_CAN_YOU_GET */ null,
        /* WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK */ null,
        /* WHAT_WOULD_YOU_LIKE_TO_DO_FIRST */ null,
        /* WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT */ "Siempre que vea una visita flexible, podrá solicitar las horas que se adapten a sus necesidades",
        /* WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR */ "¿Para qué visitas le gustaría obtener Instapay?",
        /* WHOOPS */ "Ups",
        /* WHOS_THE_LUCKY_ONE */ null,
        /* WILL_BEGIN_SHORTLY */ "Comenzará en breve",
        /* WILL_EXPIRE_IN_DAYS */ "Expirará en % días % días",
        /* WILL_EXPIRE_TOMORROW */ "Caducará mañana",
        /* WINNER_ANNOUNCED_IN */ null,
        /* WITH_CAREGIVERS */ "con cuidadores",
        /* WORKING_WITH_AGENCY */ "Estoy trabajando con una agencia",
        /* WRONG_DATES_SELECTION */ "Selección de fechas incorrectas",
        /* WRONG_PHONE_NUMBER */ "Número de teléfono equivocado",
        /* WRONG_PIN */ "Código PIN incorrecto.",
        /* X_DAYS_SELECTED */ "% x% días seleccionados",
        /* X_DAYS_TO_COMPLETE */ "%d días para completar",
        /* X_DAYS_TO_SELECT */ "% x% días para seleccionar",
        /* X_HOURS_SELECTED */ "% x% horas seleccionadas",
        /* X_HOURS_TO_SELECT */ "% x% horas para seleccionar",
        /* YAY_YOU_WERE_ASSIGNED_TO_A_VISIT */ "Yay te asignaron a una visita",
        /* YEAR */ "Año",
        /* YEARS_OLD */ "Años",
        /* YES */ "Sí",
        /* YES_ADJUST_TIMES */ null,
        /* YES_DELETE */ "Si, eliminar",
        /* YES_I_AM_SURE */ "Sí, estoy seguro",
        /* YES_OVERRIDE_FORM */ null,
        /* YES_REQUEST_ANYWAY */ null,
        /* YES_SCHEDULE_VISIT */ null,
        /* YES_THATS_ME */ "Sí, soy yo",
        /* YES_UPDATE_ALL */ null,
        /* YOURE_ALL_DONE_LETS_GET_YOU_WORKING */ "¡Ya has terminado! ¡Vamos a trabajar! 😁",
        /* YOURE_IN_THE_RAFFLE */ null,
        /* YOURE_NOT_IN_THE_RAFFLE */ null,
        /* YOURSELF */ "Usted mismo",
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD */ null,
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE */ null,
        /* YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS */ "Es posible que su agencia no le haya asignado lecciones. Inténtelo más tarde.",
        /* YOUR_ANSWER_IS_CORRECT */ "¡Su respuesta es correcta!",
        /* YOUR_ANSWER_IS_INCORRECT */ "Su respuesta es incorrecta",
        /* YOUR_COMPLIANCE */ "Su conformidad",
        /* YOUR_COMPLIANCE_ITEM_HAS_EXPIRED */ "Su % de cumplimiento_item % ha expirado. Obtenga uno nuevo y suba a través de la aplicación",
        /* YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS */ "Su % de cumplimiento_item % se debe en % días % días. Obtenga uno nuevo y suba a través de la aplicación",
        /* YOUR_FILE_IS_BEING_UPLOADED */ "Su archivo se está cargando",
        /* YOUR_IN_SERVICE_IS_DUE_IN_DAYS */ null,
        /* YOUR_IN_SERVICE_IS_OVER_DUE */ null,
        /* YOUR_MOBILE */ "Su teléfono celular",
        /* YOUR_REFERERAL_CODE */ "Su código de recomendación",
        /* YOUR_TASK_HAS_BEEN_SCHEDULED_FOR */ null,
        /* YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY */ "Su hojas de tiempo se ha enviado con éxito.",
        /* YOUVE_BEEN_SUCCESSFULLY_REFERRED */ "¡Ha sido recomendado de forma exitosa!",
        /* YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "Ha completado todas las lecciones por ahora",
        /* YOU_ALREADY_FAILED */ "ya ha fallado la prueba.",
        /* YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT */ "Ya tiene una visita programada para esa hora",
        /* YOU_ALREADY_REQUESTED_THIS_VISIT */ null,
        /* YOU_ALREADY_SUCCEEDED */ "ya ha aprobado la prueba.",
        /* YOU_ARE_ALL_SET */ null,
        /* YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION */ "¡Estás siendo redirigido a la siguiente sección!",
        /* YOU_ARE_COMPLIANT */ "Eres cumplido",
        /* YOU_ARE_EXEMPT_FROM_THIS_TEST */ "Usted está exento de esta prueba",
        /* YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD */ "No se le permite editar este campo.",
        /* YOU_ARE_NOT_COMPLIANT */ "No eres cumplido",
        /* YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM */ null,
        /* YOU_ARE_OUT_OF_COMPLIANCE */ "No cumples. Vaya a la página de cumplimiento para obtener más información",
        /* YOU_ARE_X_DAYS_LATE */ "Tiene %d días de retraso.",
        /* YOU_CANNOT_EDIT_YOUR_ANSWERS */ "No puede editar sus respuestas.",
        /* YOU_CANT_EDIT_VISIT_WITH_CICO */ null,
        /* YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES */ "No puede tener más de un diagnóstico principal o quirúrgico.",
        /* YOU_CANT_SIGN_BEFORE_ALL_ANSWERED */ "Puede firmar este documento solo cuando se completen todas las preguntas.",
        /* YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE */ "No puede usar el mismo código ICD más de una vez.",
        /* YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT */ "¡Puedes elegir qué días y horas!",
        /* YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT */ "¡Puedes elegir qué días!",
        /* YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT */ "¡Puedes elegir qué horas!",
        /* YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME */ "Mientras tanto, puedes recolectar tus puntos 🥳",
        /* YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED */ "Puede contactar al paciente si es necesario",
        /* YOU_CAN_CONTINUE_TO_NEXT_SECTION */ "¡Mientras tanto, puedes continuar con la siguiente sección!",
        /* YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY */ "Actualmente no tiene suficiente equilibrio para obtener Instapaid.",
        /* YOU_DIDNT_ANSWER_ALL_QUESTIONS */ "No respondiste a todas las preguntas, puedes volver a ellas más tarde.",
        /* YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN */ "No introdujo el mismo código PIN. Por favor, inténtelo de nuevo.",
        /* YOU_DONT_HAVE_ANY_CASES_YET */ "Aún no tienes casos",
        /* YOU_DONT_HAVE_ANY_PATIENTS_YET */ "Todavía no tienes pacientes",
        /* YOU_GET_POINTS */ "Obtienes puntos:",
        /* YOU_GOT_THE_CASE */ "¡Tienes el caso!",
        /* YOU_GOT_THE_CERTIFICATE */ "¡Ya tiene el certificado!",
        /* YOU_HAVENT_CLOCKED_IN_YET */ "Aún no se ha registrado",
        /* YOU_HAVENT_CLOCKED_OUT_YET */ "Aún no ha registrado su salida",
        /* YOU_HAVENT_UPLOADED_ANYTHING_YET */ "Aún no ha cargado nada",
        /* YOU_HAVE_COMPLETED_THIS_TEST */ "Has completado esta prueba",
        /* YOU_HAVE_HH_MM_TO_CONFIRM_IT */ "¡Tienes % Countdown % para confirmarlo!",
        /* YOU_HAVE_MISSING_COMPLIANCE_ITEMS */ "Te falta elementos de cumplimiento. Vaya a la página de cumplimiento para obtener más información",
        /* YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW */ null,
        /* YOU_HAVE_NOT_WATCHED */ "no ha visto",
        /* YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY */ "No te quedan intentos. Póngase en contacto con su agencia",
        /* YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS */ null,
        /* YOU_HAVE_ONE_ATTEMPT_LEFT */ "Te queda un intento",
        /* YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING */ "¡Tiene un día para completar esta capacitación!",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION */ "Ha completado con éxito la sección % %",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING */ "Usted ha finalizado con éxito esta capacitación 🚀",
        /* YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY */ "Tiene que completar esta capacitación hoy. ¡Dese prisa!",
        /* YOU_HAVE_TO_ENROLL_FIRST */ "Para ver esta lección, primero debes inscribirte",
        /* YOU_HAVE_TO_PICK_A_CODE */ "Tienes que elegir un código.",
        /* YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT */ "Tienes que seleccionar al menos un turno",
        /* YOU_HAVE_X_ATTEMPTS_LEFT */ "Le quedan %d intentos",
        /* YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST */ "Tienes %d intentos de responder a esta prueba",
        /* YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y */ "Tienes %d respuestas correctas de %d",
        /* YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING */ "¡Tiene %d días para completar esta capacitación!",
        /* YOU_JUST_GOT_PAID */ "Te acabas de pagar 🥳",
        /* YOU_JUST_GOT_PROMOTED_TO */ null,
        /* YOU_LOSE_POINTS */ "Pierdes puntos:",
        /* YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS */ "Puede cambiar su configuración de visitas para recibir visitas más relevantes",
        /* YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE */ "No puede responder a la prueba porque",
        /* YOU_MAY_ONLY_SUBMIT_AFTER */ "Solo puede enviarlo después de completar",
        /* YOU_MISSED_A_SHIFT_WITHOUT_NOTICE */ null,
        /* YOU_MUST_ANSWER_ALL_THE_QUESTIONS */ "Debe responder a todas las preguntas",
        /* YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT */ null,
        /* YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST */ "Primero debe ver los videos anteriores",
        /* YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION */ "Debe permitir el acceso a su ubicación GPS. De lo contrario, no podrá ingresar o salir.",
        /* YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE */ null,
        /* YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT */ null,
        /* YOU_RECENTLY_WON_A_RAFFLE */ null,
        /* YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT */ "Debes usar tu máscara toda la visita",
        /* YOU_USED_THE_CODE */ "Usó el código",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE */ "Se quedará sin cumplimiento en un % de días % de días. Vaya a la página de cumplimiento para obtener más información",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS */ null,
        /* YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS */ "Verá el dinero en su cuenta en las próximas 24 horas."
    ],
    "fr": [
        /* ACCEPTED */ "Accepté",
        /* ACCEPT_THESE_HOURS */ "Aksepte lè sa yo",
        /* ACCEPT_THE_VISIT_AT */ "Asepte vizit la",
        /* ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY */ null,
        /* ACCOUNT_NUMBER */ null,
        /* ACCOUNT_TYPE */ null,
        /* ACTIVE */ "ACTIF",
        /* ACTIVE_DOCUMENT */ "Aktive Dokiman an",
        /* ADD */ "Ajoute",
        /* ADDITIONAL_NOTES */ null,
        /* ADDRESS */ "Adresse",
        /* ADDRESS2 */ null,
        /* ADDRESS_ERROR */ "Erè nan adrès la",
        /* ADDRESS_IS_NEAR */ null,
        /* ADD_ANOTHER_DOCUMENT */ null,
        /* ADD_ANOTHER_PERTINENT_DIAGNOSIS */ null,
        /* ADD_IMAGE */ "Ajoute imaj la",
        /* ADD_NEW_MEDICATION */ "Ajoute nouvo medikaman",
        /* ADD_NOTES */ "Ajoute Nòt yo",
        /* ADD_NOTE_TO_PATIENT_PROFILE_BUTTON */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_TITLE */ null,
        /* ADD_PHYSICIAN */ null,
        /* ADD_YOUR_SIGNATURE */ null,
        /* ADVANCED_DIRECTIVES */ null,
        /* AGENCIES_CONTACT */ "Ajans yo pral kontakte w talè konsa",
        /* AGENCY */ "Ajans",
        /* AGENCY_CODE */ "Code D'agence",
        /* AGENCY_COORDINATOR */ "Ajans kowòdinatè",
        /* AGENCY_DETAILS */ "Détails de l'agence",
        /* AGENCY_HANDBOOK */ null,
        /* AGENCY_ISSUES */ null,
        /* AGENCY_NAME */ "Non ajans lan",
        /* AGENCY_NOTIFICATIONS */ null,
        /* AGENCY_NOT_FOUND */ null,
        /* AGREE_TO_MEDFLYT_TERMS */ "Klike sou apwouv, ou dakò ou te li epi dakò tèm Meflyt politik privasite a",
        /* AIDE */ null,
        /* AIRPODS */ null,
        /* ALLERGIES */ null,
        /* ALLOW_ACCESS_TO_MY_LOCATION */ null,
        /* ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP */ null,
        /* ALL_CHANGES_SAVED */ null,
        /* ALL_DAY */ "toute la journée",
        /* ALL_DONE */ null,
        /* ALL_TRANSACTIONS */ null,
        /* ALL_VERIFIED_ITEMS */ null,
        /* ALREADY_CLOCKED_IN */ "Ou te deja ladan l.",
        /* ALREADY_CLOCKED_IN_ANOTHER_VISIT */ "Ou deja nan yon lòt vizit.",
        /* ALREADY_CLOCKED_OUT */ "deja pwograme l",
        /* ALREADY_HAVE_AN_ACCOUNT */ null,
        /* AND_AMPERSAND */ "et la",
        /* ANSWERED */ "Réponse obtenue",
        /* ANSWERED_AT */ "Te reponn",
        /* ANSWER_INCOMPLETE_QUESTIONS */ null,
        /* ANY_DURATION */ "toute les durée",
        /* AN_ERROR_HAS_OCCURED */ "Gen yon erè ki te fèt",
        /* AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET */ null,
        /* APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES */ "Apple pa enplike nan okenn fason konkou a oswa tiraj osò a",
        /* APPLICATION_DONE */ "Aplikasyon an Fini!",
        /* APPROVE */ "Apwouve",
        /* APPROVED */ null,
        /* APPROVE_THIS_TASK */ null,
        /* APPROVE_THIS_VISIT */ null,
        /* APRIL */ null,
        /* ARENT_YOU_MISSING_SOMETHING */ null,
        /* ARE_YOU */ null,
        /* ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY */ "Èske kounye a w ap travay ak yon ajans?",
        /* ARE_YOU_SURE */ null,
        /* ARE_YOU_SURE_REQUEST_FAR_VISIT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST */ "Êtes-vous certain de vouloir annuler votre demande",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT */ "Èske sèten ou vle anile vizit sa?",
        /* ARE_YOU_SURE_YOU_WANT_TO_DELETE */ "Èske w sèten ou vle efase l?",
        /* ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE */ "Èske w sèten ou vle deplase paj sa?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE */ "Èske w sèten ou vle mande sa yo?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT */ "Êtes-vous sûr de vouloir demander cette visite ?",
        /* ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT */ "Êtes-vous sûr(e) de vouloir vous déconnecter ?",
        /* ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK */ null,
        /* ASSIGNED */ "AFFECTÉ",
        /* ASSIST */ "èd",
        /* AS_NEEDED */ null,
        /* AS_REQUESTED_BY_THE_PATIENT */ "Jan pasyan an mande l la",
        /* ATTACH_A_DOCUMENT */ null,
        /* AUGUST */ null,
        /* AUTHENTICATION_FAILED */ null,
        /* AUTH_VERIFICATION_FAIL_EXAPLINED */ null,
        /* AUTOPLAY */ "Pwochen eleman pral kòmanse nan",
        /* AVAILABILITY */ "Disponibilité",
        /* AVAILABLE */ "Disponib",
        /* AVAILABLE_CARE_POINTS */ null,
        /* AVAILABLE_ON_THE_FOLLOWING_DAYS */ "Disponib nan jou sa yo",
        /* AVAILABLE_SHIFTS */ "Pòs ki disponib yo",
        /* AVAILABLE_VISITS */ "Vizit ki disponib yo",
        /* AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK */ null,
        /* AWAITING_PATIENT_CONTACT */ "Kontak ki rete",
        /* A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT */ "Gen yon plan pou swen ki deja egziste pou pasyan sa",
        /* A_VERIFICATION_CODE_IS_BEING_SENT_TO */ "Un code de vérification est envoyé au",
        /* A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE */ "Un code de vérification vous sera envoyé par SMS",
        /* A_VISIT_BY */ "Yon vizit pa",
        /* BACK */ null,
        /* BACK_TO_ONBOARDING */ null,
        /* BANK_INFORMATION */ null,
        /* BANK_NAME */ null,
        /* BASICALLY_EVERY_ACTION_COUNTS */ null,
        /* BEFORE_SUBMITTING_THE_DUTIES */ null,
        /* BEGIN_NOW */ null,
        /* BEST_TASK_FOR_YOU */ null,
        /* BETWEEN */ "entre",
        /* BETWEEN_AND */ "et",
        /* BIRTHDAY */ "Date de naissance",
        /* BLOOD_PRESSURE */ null,
        /* BOROUGH */ null,
        /* BUNDLES */ null,
        /* BUNDLE_DESCRIPTION */ null,
        /* BUNDLE_DESCRIPTION_P1 */ "regwoupman sa ki gen eleman yo.",
        /* BUNDLE_DESCRIPTION_P2 */ "Kèk eleman ta kapab gen yon tès tou. Tanpri gade kontni yo mande a. Yon fwa w fini travay la ou pral resevwa yon",
        /* BUNDLE_IS_LOCKED */ null,
        /* BUNDLE_ITEM_NOT_FOUND */ null,
        /* BUNDLE_NOT_FOUND */ null,
        /* BUNDLE_PROGRESS */ "Regwoupe pwogrè a",
        /* BUSY_ALL_DAY */ "Occupé toute la journée",
        /* BY */ null,
        /* BY_ENROLLING_I_ACCEPT_THE */ null,
        /* BY_EXISTING_VISIT */ "Vizit ki egziste:",
        /* BY_PATIENT_NAME */ "Non pasyan an:",
        /* BY_SIGNING_HERE_I_ACCEPT_THE */ "En signant ici, j'accepte les",
        /* CALL */ null,
        /* CALL_AGENCY */ "Appeler l'agence",
        /* CALL_HOME */ "Rele lakay",
        /* CALL_MOBILE */ "Rele sou mobil",
        /* CALL_NOW */ "Rele kounye a:",
        /* CALL_PATIENT */ "Appeler le patient",
        /* CALL_PATIENT_CONFIRMATION */ null,
        /* CALL_PATIENT_EXPLANATION */ "Ou pral resevwa yon apèl nan kèk moman apre w fin konfime mesaj sa.",
        /* CALL_PATIENT_HOME */ "Rele lakay pasyan an",
        /* CALL_PATIENT_MOBILE */ "Rele pasyan an sou mobil li",
        /* CALL_PATIENT_NOTE */ "Kontakte pasyan an nan pwochen ekran an",
        /* CALL_SUPPORT_FOR_MORE_INFO */ "Rele sipò pou plis enfòmasyon",
        /* CANCEL */ "Annuler",
        /* CANCEL_REQUESTED_SHIFTS */ null,
        /* CANCEL_VISIT */ null,
        /* CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE */ null,
        /* CANT_CANCEL_24_HOURS_SCHEDULED_VISIT */ "Erè: Vizit se mwens pase 24 è",
        /* CANT_CANCEL_AT_THIS_TIME */ "Impossible d'annuler à cette heure-ci.",
        /* CANT_CLOCK_IN */ "Impossible d'effectuer le pointage d'arrivée",
        /* CANT_CLOCK_IN_AT_THIS_TIME */ "Impossible d'effectuer le pointage d'arrivée à cette heure-ci.",
        /* CANT_CLOCK_OUT */ "Impossible d'effectuer le pointage de départ",
        /* CANT_CLOCK_OUT_AT_THIS_TIME */ "Pa ka soti nan moman sa",
        /* CANT_CLOCK_OUT_BEFORE_VISIT_ENDED */ "Ou pa ka soti anvan vizit la fini",
        /* CANT_REJECT_VISIT_PENDING_STATUS */ null,
        /* CANT_REQUEST_JOIN_AGENCY */ "Pa kapab mande pou jwenn ajans lan",
        /* CANT_REQUEST_VISIT_PENDING_STATUS */ null,
        /* CANT_SUBMIT_AN_EMPTY_FORM */ null,
        /* CANT_WATCH_ON_SHIFT */ "Fòmasyon sa dezaktive pandan tout travay yo 👀",
        /* CANT_WATCH_THIS_VIDEO */ "Pa kapab gade Videyo sa",
        /* CAREBACK_CASH_BONUS */ null,
        /* CAREBACK_POINTS */ null,
        /* CAREGIVER */ "Moun k ap bay swen",
        /* CAREGIVER_COMPLIANCE_PASSPORT */ "Paspò konfòmite moun k ap bay swen an",
        /* CAREGIVER_NAME */ "Non moun k ap pran swen l lan",
        /* CAREGIVER_PHONE */ "Telefòn moun kap pran swen l lan",
        /* CAREGIVER_SIGNATURE */ null,
        /* CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG */ "Tanpri asire w nou toude ou menm ak pasyan an nou siyen plan swen an",
        /* CAREGIVER_SIGNATURE_IS_REQUIRED */ null,
        /* CAREGIVER_SIGNATURE_REQUIRE_MSG */ "Tanpri asire w ou siyen plan swen an",
        /* CAREGIVER_STATUS_PENDING_ERROR */ "Ou pa kapab reyalize okenn aksyon paske yo toujou ap tann pwofil ou",
        /* CARE_MOMENTS */ null,
        /* CASE_INFO */ null,
        /* CASE_IS_TOO_FAR */ "Le patient est trop éloigné",
        /* CASE_SETTINGS */ "Paramètres du patient",
        /* CATALOGUE */ null,
        /* CERTIFICATION */ null,
        /* CERTIFICATIONS */ null,
        /* CHANGE */ null,
        /* CHANGES_TO_MY_VISITS */ null,
        /* CHANGES_WERE_SAVED_IN_THE_CLOUD */ "Yo te sere tout chanjman yo nan nyaj la",
        /* CHANGE_DOCUMENT */ null,
        /* CHANGE_OF_RANKING */ null,
        /* CHANGE_PHONE_NUMBER */ "Changer votre numéro de téléphone",
        /* CHANGE_SETTINGS */ null,
        /* CHANGE_SHIFTS */ null,
        /* CHANGE_TASK_TIME */ null,
        /* CHANGE_VISIT_TIMES */ "Changer les horaires de la visite",
        /* CHAT */ "Chat",
        /* CHATS */ "Discussions",
        /* CHAT_MESSAGES */ null,
        /* CHAT_NOT_ACTIVE_MESSAGE */ "Ou pa kapab voye mesaj yo la.",
        /* CHAT_NOT_ACTIVE_TITLE */ "Chat la pa aktif ankò",
        /* CHAT_WITH_AGENCY */ "Tchatter avec l'agence",
        /* CHAT_WITH_AGENCY_ABOUT_PATIENT */ null,
        /* CHAT_WITH_MEDFLYT */ null,
        /* CHAT_WITH_OTHER_AGENCIES */ null,
        /* CHAT_WITH_SUPPORT */ "Chat ak sipò a",
        /* CHAT_WITH_US */ null,
        /* CHECK */ null,
        /* CHECK_AGAIN */ null,
        /* CHOOSE_ANOTHER_DATE */ "Chwazi yon lòt dat",
        /* CHOOSE_A_PHOTO */ null,
        /* CHOOSE_A_TIME_FOR_THE_VISIT */ "Chwazi yon lè pou vizit la",
        /* CHOOSE_CLOCK_TIMES */ null,
        /* CHOOSE_DATE_TO_PERFORM_THIS_TASK */ null,
        /* CHOOSE_FOLDER_TO_UPLOAD */ "chwazi dosye pou telechaje",
        /* CHOOSE_START_TIME */ "Chwazi lè pou kòmanse",
        /* CHOOSE_THE_HOURS */ "Pwochen (Chwazi lè yo)",
        /* CHOOSE_TIME */ null,
        /* CHOOSE_WHEN_TO_PERFORM_THE_VISIT */ "Chwazi ki lè pou fè vizit la",
        /* CHOOSE_WHEN_TO_VISIT_THE_PATIENT */ "Chwazi lè pou vizite pasyan an",
        /* CHOOSE_WHO_TO_CONTACT */ "Chwazi moun pou kontakte",
        /* CHOOSING_A_WINNER */ null,
        /* CHOOSING_A_WINNER_IN */ null,
        /* CLEAR */ "Klè",
        /* CLICK_HERE */ null,
        /* CLICK_HERE_TO_DOWNLOAD */ "Cliquez ici afin de télécharger",
        /* CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE */ "Cliquez ici afin de partager votre code de parrainage",
        /* CLICK_HERE_TO_VIEW_CERTIFICATE */ "KLIKE ISIT LA POU WÈ SÈTIFIKA A",
        /* CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE */ "Felisitasyon pou premye sètifika w la 🏆🏆! klike sou li pou wè nouvo sètifika w la",
        /* CLICK_TO_REQUEST */ "Cliquez pour le demander !",
        /* CLICK_TO_SCAN_UPLOAD */ "Klike pou eskane & telechaje",
        /* CLICK_TO_TAKE_A_SELFIE */ null,
        /* CLIMB_THE_RANKS_BY_COMPLETING_VISITS */ null,
        /* CLINICAL_SUPPORT */ "Sipò Klinik",
        /* CLOCKED_IN */ "Pointage d'arrivée effectué",
        /* CLOCKED_IN_AND_OUT */ null,
        /* CLOCKED_IN_AT */ "Pointage d'arrivée effectué à",
        /* CLOCKED_OUT */ "te soti",
        /* CLOCKED_OUT_AT */ "Pointage de départ effectué à",
        /* CLOCKING_IN */ "Pointage d'arrivée en cours...",
        /* CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES */ null,
        /* CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES */ null,
        /* CLOCKING_OUT */ "Pointage de départ en cours...",
        /* CLOCK_ADDRESS_IN_RANGE */ null,
        /* CLOCK_ADDRESS_NOT_IN_RANGE */ null,
        /* CLOCK_IN */ "Pointage d'arrivée",
        /* CLOCK_IN_ANYWAY */ null,
        /* CLOCK_IN_AT */ "Antre nan",
        /* CLOCK_IN_BETWEEN */ null,
        /* CLOCK_IN_OUT */ "Pointage d'arrivée / de départ",
        /* CLOCK_IN_OUT_SUBMIT_DUTIES */ null,
        /* CLOCK_IN_TIME_IS_REQUIRED */ null,
        /* CLOCK_OUT */ "Pointage de départ",
        /* CLOCK_OUT_AFTER */ "Soti apre",
        /* CLOCK_OUT_AT */ "Soti nan",
        /* CLOCK_OUT_BETWEEN */ null,
        /* CLOCK_OUT_TIME_IS_REQUIRED */ null,
        /* CLOCK_TIMES_NOT_MOBILE */ null,
        /* CLOCK_TIME_IN_RANGE */ null,
        /* CLOCK_TIME_NOT_IN_RANGE */ null,
        /* CLOSE */ null,
        /* CLOSE_SURVEY */ null,
        /* CLUSTERED_VISIT_EXPLENATION */ "Nou detekte sa yo, 2 vizit pre youn ak lòt epi yo antre nan orè a chak jou. Nou rekòmande pou solisite vizit sa yo ansanm. Konsa tou ou ka solisite vizit yo separeman",
        /* CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE */ "Code introuvable : veuillez en utiliser un autre.",
        /* COMBINED_CASE */ "Ka ki konbine",
        /* COMING_SOON */ null,
        /* COMPLETED */ "te fini",
        /* COMPLETED_DOCUMENTS */ "Konplete dokiman yo",
        /* COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL */ null,
        /* COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS */ null,
        /* COMPLETE_PREVIOUS_SECTIONS_FIRST */ null,
        /* COMPLETE_REGISTRATION */ null,
        /* COMPLETE_REGISTRATION_PROCESS */ null,
        /* COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* COMPLETE_VISIT */ null,
        /* COMPLETE_YOUR_ONBOARDING_ANYTIME */ null,
        /* COMPLIANCE */ "Konfòmite",
        /* COMPLIANCE_EXPIRY */ "Videyo yo bezwen atansyon w",
        /* COMPLIANCE_FORM */ null,
        /* COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY */ null,
        /* COMPLIANT */ "konfòme",
        /* COMPLIANT_ITEMS */ null,
        /* CONFIRM */ "Konfime",
        /* CONFIRM_ASSESSMENT */ "Konfime Evalyasyon an",
        /* CONFIRM_COPY_LAST */ "Èske w sèten ou vle kopye repons yo",
        /* CONFIRM_COPY_LAST_TITLE */ "Konfime Kopi a?",
        /* CONFIRM_DEPOSIT_DETAILS */ null,
        /* CONFIRM_PATIENT_AVAILABILITY */ null,
        /* CONFIRM_PATIENT_AVAILABILITY_MESSAGE */ null,
        /* CONFIRM_RN_FLEX_VISIT */ "Mwen konfime vizit mwen an",
        /* CONFIRM_WITHOUT_LOCATION */ "Konfime San lokasyon",
        /* CONGRATULATIONS */ null,
        /* CONGRATULATIONS_TO */ null,
        /* CONNECTING_HOME */ "Connexion à la maison",
        /* CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS */ null,
        /* CONNECT_WITH_US_ON_FACEBOOK */ null,
        /* CONNECT_WITH_US_ON_WHATSAPP */ null,
        /* CONTACT */ "Kontak",
        /* CONTACT_AGENCY_FOR_MORE_INFO */ "Contactez l'agence pour obtenir plus d'informations.",
        /* CONTACT_PATIENT */ "Kontakte pasyan an",
        /* CONTACT_SUPPORT */ "Kontakte Sipò",
        /* CONTINUE */ null,
        /* CONTINUE_LATER */ "kontinye pita",
        /* CONTINUE_TO_APP */ null,
        /* CONTINUE_TO_ORIENTATION */ null,
        /* CONTINUE_TO_SIGN_UP */ null,
        /* CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK */ null,
        /* COORDINATOR */ null,
        /* COORDINATOR_EMAIL */ "imel kowòdinatè a",
        /* COORDINATOR_IN_CHARGE */ "Coordinateur en charge",
        /* COORDINATOR_PHONE */ "telefòn kowòdinatè a",
        /* COPY */ "Kopi",
        /* COPY_FROM_LAST_TIME */ "Kopi dènye fwa a",
        /* COPY_FROM_MEDICATION */ "Kopi medikaman an",
        /* COPY_FROM_OTHER_FORMS */ "Kopi ki soti nan lòt fòm yo",
        /* COPY_LAST_NO_DATE_FALLBACK_APPENDED */ "dènye fwa",
        /* COPY_MEDICATION_CHART */ "Kopye Tablo Medikaman an",
        /* COPY_PLAN_OF_CARE */ "Kopye Plan Swen an",
        /* CORRECT */ "Kòrèk",
        /* COURSES */ null,
        /* COVID */ "COVID-19 la",
        /* COVID_REQUIRED */ "COVID-19 kesyonè yo mande yo",
        /* COVID_REQUIRED_EXPLAINED */ "ou pa t ranpli kesyonè COVID-19 la jodi a. Tanpri ranpli l nan lòd pou kontinye",
        /* COVID_SCREENING_CLICK_HERE */ "Retransmisyon COVID-19 - klike la",
        /* CREATED_AT */ "Créé à",
        /* CREATE_A_NEW_ACCOUNT */ null,
        /* CREATE_NEW_PLAN_OF_CARE */ "Kreye yon nouvo plan pou swen",
        /* CRIMINAL_CONVICTIONS_RECORDS */ null,
        /* CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT */ "Vous avez effectué le pointage d'arrivée d'une autre visite qui est toujours en cours",
        /* CURRENT_BALANCE */ null,
        /* CURRENT_VISIT */ null,
        /* DATA_WILL_BE_LOST */ "Done yo ap pèdi",
        /* DATE */ "Dat",
        /* DATES */ "Dat yo",
        /* DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO */ null,
        /* DATE_NOT_SPECIFIED */ null,
        /* DATE_OF_BIRTH */ null,
        /* DATE_UNKNOWN */ null,
        /* DATE_VERIFICATION */ "Dat Verifikasyon",
        /* DAY */ null,
        /* DAYS */ "jou yo",
        /* DAYS_A_WEEK */ "Jou yo nan yon semèn",
        /* DAYS_LEFT */ "Jou ki rete yo",
        /* DAYS_OF_WEEK */ "Jours par semaine",
        /* DECEMBER */ null,
        /* DECLINED */ "vyeyès",
        /* DELETE */ "Supprimer",
        /* DESCRIBE_THE_PROBLEM */ null,
        /* DETAILS */ "detay yo",
        /* DIRECTIONS */ "Direksyon yo",
        /* DIRECT_DEPOSIT */ null,
        /* DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION */ "Déconnecté. Vérifiez votre connexion internet.",
        /* DISCOVER_YOUR_JOURNEY */ null,
        /* DISCRIMINATION */ null,
        /* DISMISS */ null,
        /* DISMISSED */ null,
        /* DISTANCE */ "Distance",
        /* DOB */ null,
        /* DOCUMENT */ null,
        /* DOCUMENTS */ "Dokiman yo",
        /* DOCUMENTS_TO_COMPLETE */ null,
        /* DOCUMENT_HAS_EXPIRED */ "Dokiman te ekspire",
        /* DOCUMENT_IS_MISSING */ "Dokiman manke",
        /* DOCUMENT_REJECTED */ "Dokiman yo te rejte",
        /* DOCUMENT_SELECTED */ null,
        /* DOESNT_EXPIRE */ null,
        /* DOES_NOT_FIT_MY_SCHEDULE */ "Incompatible avec mon emploi du temps",
        /* DONE */ "Fini",
        /* DONT_FORGET_TO_CLOCK_IN */ null,
        /* DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS */ null,
        /* DONT_FORGET_TO_CLOCK_OUT */ "N'oubliez pas d'effectuer le pointage de départ",
        /* DONT_FORGET_TO_FILL_THE_DUTY_SHEET */ null,
        /* DONT_FORGET_TO_SMILE */ null,
        /* DONT_SCHEDULE_VISIT */ null,
        /* DONT_SHOW_AGAIN */ null,
        /* DOSE */ "Dòz",
        /* DOWNLOAD_PDF */ null,
        /* DO_YOU_HAVE_ANY_QUESTIONS_ASK */ null,
        /* DO_YOU_WANT_THIS_VISIT */ null,
        /* DUE_BETWEEN */ null,
        /* DUE_BY_DATETIME */ null,
        /* DUE_DATE */ null,
        /* DUE_ON */ null,
        /* DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO */ null,
        /* DURATION */ null,
        /* DURATION_PER_DAY */ "Dire pa jou",
        /* DUTIES */ null,
        /* DUTIES_COMPLETED_SUCCESSFULLY */ null,
        /* DUTY_SHEET_SUBMITTED */ "Yo te voye fèy papye",
        /* EACH_100_POINTS_DOLLAR */ null,
        /* EACH_INVITE */ "Chaque invitation",
        /* EARLY_OR_LATE_CLOCKS */ null,
        /* EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY */ null,
        /* EDIT */ "modifye",
        /* EDIT_ACCOUNT_DETAILS */ null,
        /* EDIT_TIMES */ "Edite lè yo",
        /* EDUCATION */ "Sant Edikasyon an",
        /* ELECTRIC_EQUIPMENT_DEPENDENCY */ null,
        /* ELIGIBLE_VISITS */ null,
        /* EMAIL */ null,
        /* EMAIL_QUESTION_PENDING_VERIFICATION */ null,
        /* EMAIL_SUPPORT */ null,
        /* EMAIL_SUPPORT_FOR_MORE_INFO */ "Voye imel bay sipò pou plis enfòmasyon",
        /* EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER */ null,
        /* EMAIL_VERIFICATION_QUESTION_LABEL */ null,
        /* EMERGENCY_CONTACTS */ null,
        /* EMPTY_DURATION */ null,
        /* EMPTY_PATIENT_MEDICATION_PROFILE */ "Pwofil medikaman pasyan an vid",
        /* ENABLE_LOCATION_MESSAGE */ null,
        /* ENABLE_LOCATION_TITLE */ null,
        /* ENDING_AT */ "Fini",
        /* ENDS */ "Se termine",
        /* END_DATE */ "Date de fin",
        /* END_TIME */ "Heure de fin",
        /* ENROLLMENT_REQUESTED */ null,
        /* ENROLL_NOW */ null,
        /* ENTER_AGENCY_CODE */ "Antre kòd ajans lan",
        /* ENTER_DOCUMENT_NAME */ "Antre non dokiman an",
        /* ENTER_NUMBER_HERE */ "Antre nimewo a la",
        /* ENTER_TEXT_HERE */ "Antre tèks la la",
        /* ENTER_YOUR_MOBILE_NUMBER */ "Veuillez saisir votre numéro de portable",
        /* ENTER_YOUR_PIN_CODE */ null,
        /* ENTITY_IS_MISSING */ null,
        /* ERROR */ "Erreur",
        /* ERROR_FETCHING_SLOTS */ null,
        /* ERROR_LOADING_DATA */ null,
        /* ERROR_REMOVING_DOCUMENT */ "Erè ki fèt pandan y ap deplase dokiman an",
        /* ERROR_SCHEDULING_TASK */ null,
        /* ERROR_SCHEDULING_TASK_MESSAGE */ null,
        /* ESTIMATED_ADDRESS_WILL_BE_PROVIDED */ null,
        /* ESTIMATED_TIME_OF_CLOCKING_OUT_IS */ null,
        /* EVACUATION_LOCATION */ null,
        /* EVACUATION_ZONE */ null,
        /* EVERY_VISIT */ "Chak vizit",
        /* EVV */ null,
        /* EXCITING_NEWS_AHEAD */ null,
        /* EXEMPTED */ "akòde",
        /* EXPIRED */ "ekspire",
        /* EXPIRED_COMPLIANCE */ null,
        /* EXPIRED_ON_DATE */ null,
        /* EXPIRES_AT */ "ekspire nan",
        /* EXPIRES_IN */ "dat ekspirasyon",
        /* EXPIRES_IN_ONE_DAY */ "ekspire nan yon jou",
        /* EXPIRES_IN_X_DAYS */ "Ekspire nan %d jou yo",
        /* EXPIRES_ON_DATE */ null,
        /* EXPIRING_COMPLIANCE */ null,
        /* EXPIRING_SOON */ null,
        /* EXPIRY_DATE */ "Dat ekspirasyon",
        /* EXPLORE */ null,
        /* EXPLORE_A_CAREER_ENHANCEMENTS */ null,
        /* FAILED_TO_IDENTIFY_PATIENT */ "echwe pou idantifye pasyan an",
        /* FAR_VISIT_WARNING_MODAL_TITLE */ null,
        /* FAX_NUMBER */ null,
        /* FEBRUARY */ null,
        /* FEMALE */ "Femme",
        /* FIFTHY_DOLLAR_AMAZON_GIFT_CARD */ null,
        /* FILES */ null,
        /* FILE_NOT_FOUND_CONTACT_AGENCY */ null,
        /* FILL */ null,
        /* FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT */ null,
        /* FILL_IN_THE_QUESTIONNAIRE */ "ranpli kesyonè a",
        /* FILTERS */ "filtè yo",
        /* FINAL_CONFIRMATION */ null,
        /* FIND_A_CARE_MOMENT */ null,
        /* FIND_A_CARE_MOMENT_DESCRIPTION */ null,
        /* FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FINISH_MY_ONBOARDING */ null,
        /* FINISH_ONBOARDING_AND_GET_DOLLARS */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2 */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE_STAGE_2 */ null,
        /* FINISH_SHIFT */ null,
        /* FINISH_THE_DOCUMENTS */ null,
        /* FIRST_NAME */ "Prénom",
        /* FIRST_SHIFT */ "Premye pòs",
        /* FIVE_THOUSAND_POINTS */ null,
        /* FIX */ null,
        /* FIX_DOCUMENTS_DESCRIPTION */ null,
        /* FIX_DOCUMENT_DESCRIPTION */ null,
        /* FIX_ISSUE */ null,
        /* FIX_ISSUES */ null,
        /* FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* FIX_SETTINGS */ "Ranje konfigirasyon an",
        /* FIX_THE_DOCUMENT */ null,
        /* FIX_THE_DOCUMENTS */ null,
        /* FIX_YOUR_DOCUMENT */ null,
        /* FIX_YOUR_DOCUMENTS */ null,
        /* FLEXIBLE */ null,
        /* FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_VISIT */ "Jou vizit ki fleksib yo",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT */ null,
        /* FLEXIBLE_HOURS_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_VISIT */ "Lè vizit ki fleksib yo",
        /* FLEXIBLE_VISIT */ "vizit ki fleksib",
        /* FLEXIBLE_VISIT_DAY_TO_CHOOSE */ null,
        /* FLEXIBLE_VISIT_DETAILS */ "Detay sou vizit ki fleksib yo",
        /* FLEXIBLE_VISIT_TYPE */ "Vizit ki Fleksib",
        /* FLU_SHOT */ null,
        /* FLU_SHOT_SUBMITTION_MESSAGE */ null,
        /* FOLLOW_US_ON_INSTAGRAM */ "Suivez-nous sur Instagram",
        /* FOLLOW_US_ON_TWITTER */ "Suivez-nous sur Twitter",
        /* FORGOT_PIN_CODE_DIALOG_MESSAGE */ "Remarque : vous serez redirigé vers l'écran de connexion pour commencer une nouvelle procédure d'inscription",
        /* FORM_NAME */ "non fòmilè a",
        /* FOURTEEN_THOUSAND_POINTS */ null,
        /* FREQUENCY */ "Frekans lan",
        /* FRIEND */ null,
        /* FROM */ "depi",
        /* FROM_CAMERA */ "Depuis votre appareil photo",
        /* FROM_GALLERY */ "Depuis votre galerie de photos",
        /* FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE */ "Tèm ak kondisyon ki konplè - Defi MedFly",
        /* FUTURE_VISITS */ null,
        /* GENDER */ "Sexe",
        /* GENERAL */ "Généralités",
        /* GENERAL_FILES */ "Fichye jeneral yo",
        /* GENERAL_NOTES */ "Notes générales",
        /* GENERAL_SUPPORT */ null,
        /* GET_INSTAPAY */ null,
        /* GET_IT_NOW */ null,
        /* GET_MONEY_FOR_THIS_VISIT_TODAY
 */ null,
        /* GET_NOW */ null,
        /* GET_STARTED */ null,
        /* GET_THE_APP */ null,
        /* GET_X_NOW */ null,
        /* GOOD_JOB */ "Bon travay!",
        /* GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "Bon travay! ou te fini ak tout leson yo kounye a",
        /* GOT_IT */ "M konprann",
        /* GO_BACK */ "Revenir en arrière",
        /* GO_TO */ "Ale",
        /* GO_TO_MEDFLYT_PASSPORT */ null,
        /* GO_TO_PATIENT */ "Al jwenn pasyan an",
        /* GO_TO_PATIENT_DETAILS */ "Al jwenn detay pasyan an",
        /* GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION */ null,
        /* GO_TO_VISIT */ "Al nan vizit la",
        /* GREAT_JOB */ "Bon Travay!",
        /* GROSS_PAY */ null,
        /* HAS_DNR */ null,
        /* HAS_HEALTH_CARE_PROXY */ null,
        /* HAVE_A_NICE_WORKING_DAY */ null,
        /* HAVE_A_PLEASANT_VISIT */ null,
        /* HAVE_A_QUESTION_LETS_CHAT */ null,
        /* HEALTH_AGENCIES */ "Agences de santé",
        /* HELP */ "Aide",
        /* HELP_ME_FIND_MY_AGENCY */ "Ede m jwenn ajans mwen an",
        /* HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY */ null,
        /* HEY */ "Hé !",
        /* HEY_THERE */ null,
        /* HI */ "Hi",
        /* HIRE_DATE */ null,
        /* HI_PLEASE_HELP_ME_FILL_MY_APPLICATION  */ null,
        /* HOME_PHONE */ "Téléphone domicile",
        /* HOUR */ null,
        /* HOURS */ null,
        /* HOURS_PER_DAY */ "Heures par jour",
        /* HOURS_PER_VISIT */ "Heures par visite",
        /* HOW_ARE_WE_CALCULATING_THE_RANK */ null,
        /* HOW_CAN_WE_HELP_YOU */ "Kijan n kapab ede w?",
        /* HOW_CARE_MOMENTS_WORKS */ null,
        /* HOW_DID_YOU_HEAR_ABOUT_US */ null,
        /* HOW_DOES_IT_WORK */ null,
        /* HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS */ null,
        /* HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN */ null,
        /* HOW_DO_YOU_RATE_MEDFLYT */ "Kòman w t ap evalye Medflyt?",
        /* HOW_URGENT_IS_THE_ISSUE */ null,
        /* HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT */ "Kijan w ta renmen rele pasyan an?",
        /* HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE */ null,
        /* HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT */ null,
        /* HR_PER_VISIT */ "lè pa vizit",
        /* HUNDRED_DOLLARS_GIFT_CARD */ null,
        /* ICD */ null,
        /* ID */ null,
        /* IF_YOU_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON */ null,
        /* IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE */ null,
        /* IF_YOU_STAY_COMPLIANT */ null,
        /* IMPORTANT_INFORMATION */ null,
        /* IMPORTED */ "Importé",
        /* IM_AVAILABLE */ "Je suis disponible",
        /* IM_DONE_SUBMIT */ null,
        /* IM_NOT_INTERESTED */ null,
        /* IM_WORKING_WITH_AN_AGENCY */ null,
        /* INACTIVE */ "INACTIF",
        /* INCOMPLETE */ null,
        /* INCORRECT */ "Enkòrèk",
        /* INCORRECT_CODE */ "Code incorrect",
        /* INCORRECT_DIGITS */ null,
        /* INCORRECT_DIGITS_EXPLAINED */ null,
        /* INCORRECT_DIGITS_MESSAGE */ null,
        /* INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN */ "Code PIN incorrect. Veuillez réessayer.",
        /* INCORRECT_SMS_CODE */ null,
        /* INCORRECT_SMS_CODE_EXPLAINED */ null,
        /* INFORMATION_CENTER */ null,
        /* INFORMATION_NOT_MATCH_PROFILE */ null,
        /* INSERT_THEIR_REFERRAL_CODE_HERE */ "Insérez son code de parrainage ici !",
        /* INSERVICES */ null,
        /* INSTAPAY */ null,
        /* INSTAPAY_HISTORY */ null,
        /* INSTAPAY_TECHNICAL_ISSUE */ null,
        /* INSUFFICIENT_DUTIES */ null,
        /* INTERESTED_IN_THIS_BUNDLE */ null,
        /* INTRODUCING */ null,
        /* INVALID_DOCUMENT_NAME */ "non dokiman an pa valid",
        /* INVALID_EMAIL */ "imel ki pa valid",
        /* INVALID_FORM */ null,
        /* INVALID_PHONE */ "telefòn ki pa valid",
        /* INVALID_PHONENUMBER */ null,
        /* INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN */ null,
        /* INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES */ "Invitez des professionnels de santé à rejoindre Medflyt et gagnez des récompenses incroyables",
        /* INVITE_FRIENDS */ "Invitez des amis",
        /* IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE */ null,
        /* IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT */ null,
        /* IN_PROGRESS */ null,
        /* ISSUES_TO_SOLVE */ null,
        /* IS_DUE_IN_DAYS */ null,
        /* IS_DUE_TOMORROW */ null,
        /* ITEMS_THAT_WILL_EXPIRE_SOON */ null,
        /* ITEMS_WITH_ISSUES */ null,
        /* ITEM_IS_MISSING */ null,
        /* ITEM_IS_NOT_COMPLIANT */ null,
        /* ITS_NOT_ME */ null,
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU */ null,
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU */ null,
        /* IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK */ null,
        /* IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE */ null,
        /* I_DONT_HAVE_MY_CODE */ "Mwen pa gen yon kòd",
        /* I_DONT_WANT_THIS_CASE */ null,
        /* I_DONT_WANT_TO_CLOCK */ null,
        /* I_FORGOT_MY_PIN_CODE */ "J'ai oublié mon code PIN",
        /* I_HAVE_CHANGED_MY_MIND */ null,
        /* I_HAVE_READ_AND_AGREE */ null,
        /* I_VERIFY_THE_TERMS */ null,
        /* I_WANT_TO_CLOCK_IN_ANYWAY */ null,
        /* I_WANT_TO_CLOCK_OUT_ANYWAY */ null,
        /* I_WANT_TO_FINISH_MY_ONBOARDING */ null,
        /* I_WILL_DO_IT_LATER */ null,
        /* JANUARY */ null,
        /* JOINED_DATE */ "Date d'inscription",
        /* JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT */ null,
        /* JULY */ null,
        /* JUNE */ null,
        /* JUST_ONE_MORE_THING */ null,
        /* JUST_TO_BE_SURE */ null,
        /* JUST_VERIFYING_ITS_YOU */ null,
        /* KEEP_UP_THE_GOOD_WORK */ null,
        /* LABELS */ "Etikèt yo",
        /* LANGUAGE */ "Lang",
        /* LANGUAGES */ "Langues",
        /* LAST_NAME */ "Nom de famille",
        /* LEARN_MORE */ null,
        /* LEAVE_WITHOUT_SAVING */ "Èske w soti san sovgade?",
        /* LEFT */ null,
        /* LESSON */ null,
        /* LESSONS */ "Leson yo",
        /* LETS_CONTINUE_TO_NEXT_SECTION */ null,
        /* LETS_FIND_CASES */ null,
        /* LETS_FIND_YOUR_FIRST_CASE */ null,
        /* LETS_FIND_YOUR_FIRST_PATIENT */ null,
        /* LETS_FINISH_YOUR_SHIFT */ null,
        /* LETS_START */ null,
        /* LETS_START_YOUR_SHIFT */ null,
        /* LIKE_US_ON_FACEBOOK */ "Aimez notre page Facebook",
        /* LINKED_TO_ANOTHER_PATIENT */ null,
        /* LIST */ "Lis",
        /* LISTENING___ */ null,
        /* LIST_OF_PATIENTS */ null,
        /* LIST_OF_TASKS */ null,
        /* LIST_OF_VISITS */ null,
        /* LIVE_CHAT_SUPPORT */ "sipò sou chat an dirèk",
        /* LIVE_CLASS */ null,
        /* LIVE_CLASS_EXPLANATION */ null,
        /* LIVE_EVENTS */ null,
        /* LOADING */ "Chargement en cours",
        /* LOADING_LOCATION */ "Chargement de la localisation...",
        /* LOCATION */ "Lieu",
        /* LOCKED */ "fèmen",
        /* LOGGING_YOU_IN */ null,
        /* LOGIN */ null,
        /* LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED */ null,
        /* LOOKS_LIKE_MORE_THAN */ null,
        /* LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION */ null,
        /* MAIN_TASKS */ null,
        /* MAKE_A_DIFFERENCE */ null,
        /* MAKE_SURE_PICTURE_IS_CLEAR */ null,
        /* MALE */ "Homme",
        /* MANUALLY_SUBMITTED_INFO */ null,
        /* MAP */ "Kat",
        /* MARCH */ null,
        /* MAX_TRAVEL_DISTANCE */ "Distance de déplacement maximale",
        /* MAY */ null,
        /* MAYBE_LATER */ "petèt pita",
        /* MAY_CLOCK_IN_AT */ "Peut effectuer le pointage d'arrivée à",
        /* MAY_CLOCK_OUT_FROM */ "Peut effectuer le pointage de départ à partir de",
        /* MEC_WAIVER_INFORMATION */ null,
        /* MEDFLYT */ null,
        /* MEDFLYTS_MONTHLY_RAFFLE */ null,
        /* MEDFLYT_AGENCY_HANDBOOK */ null,
        /* MEDFLYT_AT_HOME_BENEFITS */ null,
        /* MEDFLYT_CHALLENGE */ "Défi Medflyt",
        /* MEDFLYT_HOME_CARE */ null,
        /* MEDFLYT_ID_CARD */ null,
        /* MEDFLYT_PASSPORT */ "Paspò medflyt",
        /* MEDFLYT_PASSPORT_TERMS */ null,
        /* MEDFLYT_RAFFLE */ null,
        /* MEDFLYT_TEAM */ null,
        /* MEDFLYT_VERSION */ "Version Medflyt",
        /* MEDICAL_FILES */ "Dosye medikal yo",
        /* MEDICAL_INFORMATION */ "Données médicales",
        /* MEDICAL_NOTES */ null,
        /* MEDICATIONS */ null,
        /* MESSAGE */ "Message",
        /* MESSAGE_FOR_THE_COORDINATOR */ "Message destiné au coordinateur",
        /* MIDDLE_NAME */ "Deuxième prénom",
        /* MILES_AWAY */ "À {number} kilomètres",
        /* MILES_BETWEEN_PATIENTS */ "Plizyè kilomèt ant pasyan yo",
        /* MILES_SHORT */ "Mi.",
        /* MINIMUM_WAGE */ null,
        /* MINUTE */ null,
        /* MINUTES */ "Minit yo",
        /* MINUTE_VISIT */ "minit vizit la",
        /* MISSING */ "Manke",
        /* MISSING_CLOCKS */ null,
        /* MISSING_PERSONAL_CARE_DUTY */ null,
        /* MM_DD_YYYY */ null,
        /* MOBILE_PHONE */ "Telefòn mobil",
        /* MOBILITY_STATUS */ null,
        /* MONTH */ "Mwa",
        /* MONTHLY_RAFFLE */ null,
        /* MORE_DETAILS */ "Plus de détails",
        /* MORE_DETAILS_BELOW */ null,
        /* MORE_SHIFTS_MORE_CHANCES */ null,
        /* MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* MUST_AGREE_TERMS */ null,
        /* MUST_BE_ATLEAST_3_CHARACTERS */ "Li dwe gen omwen 3 karaktè",
        /* MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS */ "Li dwe nan youn nan jou sa yo",
        /* MUST_PICK_EXACTLY */ "Dwe chwazi egzakteman",
        /* MUST_START_AT_OR_AFTER */ "Dwe kòmanse NAN oswa APRE",
        /* MUST_START_AT_OR_BEFORE */ "Dwe kòmanse NAN oswa ANVAN",
        /* MUST_UPDATE_ADDRESS_TO_SEE_CASES */ "Ou dwe aktyalize adrès ou a pou wè ka yo!",
        /* MY_AGENCIES */ "Mes agences",
        /* MY_ASSIGNED_VISITS */ "Les consultations qu'on m'a assignées",
        /* MY_AVAILABILITY */ null,
        /* MY_BENEFITS_CARD_INFORMATION */ null,
        /* MY_MEDFLYT_COMPLIANCE */ null,
        /* MY_PASSPORT */ "Paspò m",
        /* MY_PAYROLL_HISTORY */ null,
        /* MY_PAYROLL_INFORMATION */ null,
        /* MY_PROFILE */ null,
        /* MY_REQUESTED_VISITS */ "Les consultations que j'ai demandées",
        /* MY_STAFFING_PREFERENCES */ null,
        /* MY_UPCOMING_VISITS_REMINDERS */ null,
        /* MY_VIRTUAL_ID */ null,
        /* MY_VISITS */ null,
        /* NA */ "N/A",
        /* NAME */ "Non",
        /* NEAR */ null,
        /* NEED_DIRECTIONS */ "Besoin d'instructions ?",
        /* NET_PAY_FOR_PERIOD */ null,
        /* NEW */ "NOUVEAU",
        /* NEW_END_TIME_X */ null,
        /* NEW_MESSAGE */ null,
        /* NEW_TASK */ null,
        /* NEW_TASKS */ null,
        /* NEW_VISITS_AVAILABLE */ null,
        /* NEXT */ "SUIVANT",
        /* NEXT_DUE */ "Pwochen etap",
        /* NEXT_LESSON */ null,
        /* NEXT_SECTION */ null,
        /* NEXT_TOKEN_IN */ null,
        /* NEXT_YEAR */ null,
        /* NO */ "Non",
        /* NONE */ "Okenn",
        /* NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT */ null,
        /* NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU */ null,
        /* NOTES */ "Nòt yo",
        /* NOTIFICATIONS */ "Notifications",
        /* NOTIFICATIONS_OFF */ null,
        /* NOTIFICATIONS_ON */ null,
        /* NOT_AVAILABLE */ "indisponible",
        /* NOT_COMPLIANT */ "pa konfòme",
        /* NOT_DUE_YET */ null,
        /* NOT_ENOUGH_HOURS */ "Pas assez d'heures",
        /* NOT_ENOUGH_SHIFTS */ "Pa gen ase pòs...",
        /* NOT_ENOUGH_SHIFTS_MESSAGE */ "Ou pran omwen %pòs minimòm yo% pòs yo yon fason pou mande vizit sa (ou te pran sèlman %pòs kounya yo%).",
        /* NOT_FOUND */ null,
        /* NOT_INTERESTED */ "Pas intéressé",
        /* NOT_SELECTED */ null,
        /* NOT_SET */ null,
        /* NOT_SIGNING */ null,
        /* NOT_STARTED */ null,
        /* NOT_URGENT */ null,
        /* NOVEMBER */ null,
        /* NO_ALLERGIES */ null,
        /* NO_ANSWERS_TO_COPY */ "kote ki pa gen repons pou kopye",
        /* NO_ANSWERS_TO_COPY_TITLE */ "Kopi a echwe!",
        /* NO_AVAILABLE_SLOTS */ null,
        /* NO_BALANCE */ null,
        /* NO_CHANGES_WERE_MADE */ "Aucun changement effectué",
        /* NO_COMPLIANT_ITEMS */ null,
        /* NO_DOCUMENTS */ null,
        /* NO_DOCUMENTS_AVAILABLE */ "dokiman yo pa disponib",
        /* NO_DOCUMENTS_REQUIRED */ "Pa bezwen dokiman yo",
        /* NO_DUTIES_REQUIRED_FOR_THIS_VISIT */ null,
        /* NO_EDUCATION_LINK */ "Èske w vle edikasyon gratis? Kontakte ajans ou an",
        /* NO_ELIGIBLE_VISITS */ null,
        /* NO_END_DATE */ "san dat pou fini",
        /* NO_GENERAL_NOTES */ "Pa gen nòt jeneral",
        /* NO_IN_SERVICE_VIDEOS_AVAILABLE */ "Pa gen videyo sèvis ki disponib. Tanpri kontakte ajans ou an pou detay yo.",
        /* NO_ISSUES_FOUND */ null,
        /* NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT */ null,
        /* NO_JUST_THIS_ONE */ null,
        /* NO_KEEP_THE_ORIGINAL_TIMES */ null,
        /* NO_KNOWN_ALLERGIES */ null,
        /* NO_LESSONS */ null,
        /* NO_LESSONS_FOR_YOU_YET */ "Poko gen leson pou ou",
        /* NO_MEDICAL_INFORMATION */ "Pas de données médicales",
        /* NO_NOTIFICATIONS */ "Pas de notifications",
        /* NO_PAYSTUBS_FOUND_FOR_THIS_MONTH */ null,
        /* NO_PHONE */ "Pa gen telefòn",
        /* NO_PHYSICIAN_SELECTED */ null,
        /* NO_PREVIOUS_CONVERSATIONS */ null,
        /* NO_SCHEDULED_VISITS_TODAY */ "Pa gen vizit ki pwograme pou jodi a",
        /* NO_SHIFTS_SELECTED */ null,
        /* NO_TAKE_ME_BACK */ null,
        /* NO_TESTS */ null,
        /* NO_THANKS */ "Non Merci",
        /* NO_TIME_LIMIT */ null,
        /* NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT */ null,
        /* NO_VIDEOS */ null,
        /* NO_VISITS_SCHEDULED */ null,
        /* NO_VISITS_SCHEDULED_MESSAGE */ null,
        /* NO_VISITS_SELECTED */ null,
        /* NPI */ null,
        /* NUM_COUNT_ITEMS */ null,
        /* NUM_SHIFTS_TO_GO */ null,
        /* NUM_SHIFTS_TO_WAGE */ null,
        /* N_A */ null,
        /* OCTOBER */ null,
        /* OF */ "dat",
        /* OF_THE_REQUIRED_PLEASE_CONTINUE */ "fè l nan lè yo mande a. Tanpri kontinye.",
        /* OF_THE_VIDEO */ "videyo a",
        /* OK */ "OK",
        /* OK_ILL_TRY_LATER */ null,
        /* OK_NO_PROBLEM */ "Ok, pa gen pwoblèm",
        /* OK_THANKS */ null,
        /* ON */ "nan",
        /* ONBOARDING */ null,
        /* ONBOARDING_COMPLETED */ null,
        /* ONBOARDING_COMPLETED_MESSAGE */ null,
        /* ONE_DAY_TO_COMPLETE */ "Yon jou pou fini",
        /* ONE_DOCUMENT */ null,
        /* ONE_DOCUMENT_SELECTED */ null,
        /* ONE_HOUR */ null,
        /* ONE_LAST_STEP */ null,
        /* ONE_LESSON */ null,
        /* ONE_TEST */ null,
        /* ONE_THOUSAND_POINTS */ null,
        /* ONE_VIDEO */ null,
        /* ON_HOLD */ "EN ATTENTE",
        /* ON_LEAVE */ "En congé",
        /* OOPS */ null,
        /* OPEN */ null,
        /* OPEN_CAMERA */ null,
        /* OPEN_CERTIFICATE */ null,
        /* OPEN_DEVICE_SETTINGS */ null,
        /* OPEN_MAPS */ null,
        /* OPEN_SETTINGS */ null,
        /* OPTIONAL_TASKS */ null,
        /* OR */ "ou",
        /* OTHER */ "Lòt",
        /* OTHER_PERTINENT_DIAGNOSIS */ null,
        /* OTHER_REASON */ null,
        /* OTHER_TASKS */ null,
        /* OTHER_VISITS */ null,
        /* OUTBOUND_CALL_ERROR_MESSAGE */ null,
        /* OUTBOUND_CALL_ERROR_TITLE */ null,
        /* OUTBOUND_CALL_PROMPT_MESSAGE */ null,
        /* OUTBOUND_CALL_PROMPT_TITLE */ null,
        /* OUTBOUND_CALL_SUCCESS_MESSAGE */ null,
        /* OUTBOUND_CALL_SUCCESS_TITLE */ null,
        /* OUT_OF */ "Nenpòt",
        /* OUT_OF_RANGE */ null,
        /* OVERDUE */ null,
        /* OVERLAPPING_VISIT_ERROR */ "Vizit yo rekouvri, tanpri chwazi yon lòt dat oswa lè.",
        /* OVERRIDE_FORM */ null,
        /* OVERRIDE_FORM_MESSAGE */ null,
        /* OVER_NIGHT */ "Lannuit lan",
        /* PAGE */ "Paj",
        /* PAID */ null,
        /* PAID_X_OUT_OF_Y */ null,
        /* PARTIAL_SELECTION */ null,
        /* PASSPORT */ null,
        /* PASSPORT_TERMS_TEXT */ null,
        /* PASTE */ "Kole",
        /* PAST_DUE */ "Pase kòmsadwa",
        /* PAST_SINCE_THE_VISIT_STARTED */ null,
        /* PAST_UPLOADS */ "telechajman yo fini",
        /* PAST_VISITS */ null,
        /* PATIENT */ "Patient",
        /* PATIENTS */ null,
        /* PATIENT_ADDRESS */ "Adresse du patient",
        /* PATIENT_CANT_PHISICALLY_SIGN */ null,
        /* PATIENT_CANT_SIGN */ null,
        /* PATIENT_CONTACTS */ null,
        /* PATIENT_DOC_NOT_SUBMITTED */ "Akoz yon erè yo pa t voye dokiman pasyan an",
        /* PATIENT_DOC_SUBMISSION_MISSMATCH */ "Ou sou wout pou voye fòm nan, men orè vizit la diferan jodi a. Tanpri chwazi dat ou ta renmen gen youn",
        /* PATIENT_DOC_SUBMITTED_SUCCESSFULY */ "Yo voye dokiman pasyan an kòrèkteman",
        /* PATIENT_INFO */ "Données du patient",
        /* PATIENT_IS_NOT_HOME */ null,
        /* PATIENT_IS_NOT_SIGNING */ null,
        /* PATIENT_NAME */ "Nom du patient",
        /* PATIENT_NOT_FOUND */ null,
        /* PATIENT_NOT_FOUND_EXPLAIN */ null,
        /* PATIENT_NUMBER */ "Nimewo pasyan an",
        /* PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE */ null,
        /* PATIENT_PHONE */ "Numéro de téléphone du patient",
        /* PATIENT_REFUSES_TO_SIGN */ null,
        /* PATIENT_REPORT */ null,
        /* PATIENT_REQUESTS */ null,
        /* PATIENT_SCHEDULE */ null,
        /* PATIENT_SIGNATURE */ null,
        /* PATIENT_SIGNATURE_IS_REQUIRED */ null,
        /* PATIENT_SIGNATURE_REQUIRE_MSG */ "Tanpri bay rezon espesifik poukisa pasyan an pa siyen",
        /* PATIENT_SIGN_HERE */ "Pasyan, siyen la",
        /* PATIENT_UNAVAILABLE_DURING_THESE_HOURS */ null,
        /* PATIENT_VISITS */ null,
        /* PAUSE_READING */ null,
        /* PAYMENT_METHOD */ null,
        /* PAYROLL */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_TITLE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE */ null,
        /* PAYSTUB */ null,
        /* PAYSTUBS */ null,
        /* PAY_ME_NOW */ null,
        /* PAY_ME_NOW_X */ null,
        /* PENDING */ "En attente",
        /* PENDING_APPLICATION */ "DEMANDE EN ATENTE",
        /* PENDING_APPROVAL */ null,
        /* PENDING_CONFIRMATION */ null,
        /* PENDING_ISSUES */ null,
        /* PENDING_VERIFICATION */ null,
        /* PERMANENT_VISIT_DETAILS */ "Détails relatifs à la consultation régulière",
        /* PERMANENT_VISIT_FROM */ "Consultation régulière de",
        /* PERMANENT_VISIT_TYPE */ "Vizit ki pèmanan",
        /* PERMISSION_NEEDED_FOR_CAMERA */ null,
        /* PERMISSION_NEEDED_FOR_CAMERA_MESSAGE */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE */ null,
        /* PERMISSION_TO_CAMERA_DENIED */ null,
        /* PER_HOUR */ null,
        /* PER_SHIFT */ "Pa pòs",
        /* PER_VISIT */ "pa vizit",
        /* PER_WEEK */ null,
        /* PHONE */ "Telefòn",
        /* PHONES */ "Telefòn yo",
        /* PHONE_CALL_SUPPORT */ "Rele pou jwenn èd",
        /* PHOTO_LIBRARY */ null,
        /* PHYSICIAN_DETAILS */ null,
        /* PICK_A_DATE */ null,
        /* PICK_A_TIME */ "Chwazi yon lè",
        /* PLAN_OF_CARE */ "Plan swen",
        /* PLEASE_ASK_THE_PATIENT */ null,
        /* PLEASE_CALL_PATIENT_IN_NEXT_SCREEN */ "Tanpri rele pasyan an nan pwochen ekran an",
        /* PLEASE_CHAT_WITH_THE_AGENCY */ null,
        /* PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY */ null,
        /* PLEASE_CHOOSE_A_LANGUAGE */ "Veuillez choisir une langue",
        /* PLEASE_CHOOSE_A_TIME */ "Tanpri chwazi yon lè",
        /* PLEASE_CHOOSE_DATE_BETWEEN */ null,
        /* PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES */ null,
        /* PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT */ "Tanpri gade epi voye tès yo pou kontinye konfòme w.",
        /* PLEASE_CONFIRM_THE_TIMES_CHOSEN */ "Tanpri konfime lè w chwazi a",
        /* PLEASE_CONFIRM_YOUR_INFORMATION */ "Veuillez confirmer vos données",
        /* PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS */ "Tanpri kontakte ajans lan pou plis detay",
        /* PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY */ "Tanpri kontakte ajans ou an kounye a",
        /* PLEASE_CONTACT_YOUR_COORDINATOR */ "Tanpri kontakte kowòdonatè w la.",
        /* PLEASE_ENABLE_LOCATION */ "Aktive lokalizasyon an",
        /* PLEASE_ENTER_A_VALID_PHONE_NUMBER */ "Tanpri antre yon nimewo telefòn ki valid",
        /* PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME */ "Tanpri ekri non ak prenon pasyan an",
        /* PLEASE_ENTER_PATIENT_NAME */ "Tanpri ekri non pasyans an",
        /* PLEASE_ENTER_THE_PATIENT_PHONE */ "Tanpri antre nimewo telefòn pasyan an",
        /* PLEASE_ENTER_YOUR_PIN_CODE */ "Veuillez saisir votre code PIN",
        /* PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED */ null,
        /* PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER */ null,
        /* PLEASE_FILL_IN_YOUR_INFORMATION */ "Veuillez fournir les informations demandées",
        /* PLEASE_FILL_REQUIRED_FIELDS */ null,
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY */ "Tanpri asire w ou antre kòd la kòrèkteman",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY */ null,
        /* PLEASE_MARK_ALL_THE_REQUIRED_DUTIES */ null,
        /* PLEASE_NOTE */ "Tanpri note",
        /* PLEASE_PICK_VALID_DATES */ "Veuillez choisir des dates valides",
        /* PLEASE_REQUEST_EXACTLY */ "Tanpri mande egzakteman",
        /* PLEASE_SELECT_AN_OPTION */ null,
        /* PLEASE_SELECT_DATE_AND_TIME */ "Tanpri Chwazi dat ak lè",
        /* PLEASE_SELECT_THE_PATIENT_ADDRESS */ "Tanpri chwazi adrès pasyan an",
        /* PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT */ null,
        /* PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW */ "Veuillez définir une photo de profil en cliquant sur l'icône d'appareil-photo ci-dessous",
        /* PLEASE_SIGN_IN_AGAIN */ null,
        /* PLEASE_SPECIFY */ null,
        /* PLEASE_TAKE_A_SELFIE */ null,
        /* PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK */ null,
        /* PLEASE_TYPE_IN_YOUR_PHONE_NUMBER */ null,
        /* PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH */ "Veuillez taper le code de l'agence avec laquelle vous aimeriez travailler",
        /* PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER */ null,
        /* PLEASE_TYPE_THE_SMS_CODE */ "Veuillez saisir le code SMS",
        /* PLEASE_UPDATE_TO_OUR_NEWEST_VERSION */ "Veuillez installer la dernière mise à jour",
        /* PLEASE_UPDATE_YOUR_ADDRESS */ "Veuillez mettre à jour votre adresse",
        /* PLEASE_UPDATE_YOUR_FIRST_NAME */ "Veuillez mettre à jour votre prénom",
        /* PLEASE_UPDATE_YOUR_LAST_NAME */ "Veuillez mettre à jour votre nom de famille",
        /* PLEASE_WAIT */ null,
        /* PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION */ null,
        /* PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP */ null,
        /* POINTS */ "Points",
        /* POINTS_AND_REWARDS */ null,
        /* POSTED_DATE */ "Dat Piblikasyon",
        /* PREBLOCK_VISIT_EXPLANATION */ "Apre konfimasyon an, tan w pral limite pou kontakte pasyan an epi chwazi lè pou vizit la.",
        /* PRESENTATION */ "Prezantasyon",
        /* PREVIOUS */ null,
        /* PREVIOUS_CONVERSATIONS */ null,
        /* PREVIOUS_WINNERS */ null,
        /* PRE_TAXES */ null,
        /* PRICE */ "Pri",
        /* PRINCIPAL_DIAGNOSIS */ null,
        /* PRIORITY_CODE */ null,
        /* PRIVACY_POLICY */ "Politique de confidentialité",
        /* PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN */ null,
        /* PROBLEM_WITH_CASE_SETTINGS */ "sanble w gen yon pwoblèm pou konfigire ka w la",
        /* PROCESSING */ null,
        /* PROFESSIONAL_TYPE */ "Type de professionnel",
        /* PROFILE */ "Pwofil",
        /* PROGRESS */ "Pwogrè",
        /* PROXY_FIRST_NAME */ null,
        /* PROXY_LAST_NAME */ null,
        /* PROXY_PHONE */ null,
        /* PULSE */ null,
        /* QUESTION */ "Kesyon",
        /* QUESTIONS */ "Kesyon yo",
        /* QUESTIONS_TO_COPY_FROM */ "Kesyon pou kopye",
        /* QUESTION_NUMBER */ null,
        /* QUESTION_REJECTED */ null,
        /* QUIT */ null,
        /* RAFFLE_ENDED */ null,
        /* RAFFLE_INFO_1_DESCRIPTION */ null,
        /* RAFFLE_INFO_1_TITLE */ null,
        /* RAFFLE_INFO_2_DESCRIPTION */ null,
        /* RAFFLE_INFO_2_TITLE */ null,
        /* RAFFLE_INFO_3_DESCRIPTION */ null,
        /* RAFFLE_INFO_3_TITLE */ null,
        /* RAFFLE_INFO_4_DESCRIPTION */ null,
        /* RAFFLE_INFO_4_TITLE */ null,
        /* RAFFLE_NOW */ null,
        /* RAFFLE_PRIZE */ null,
        /* RANK_ACHIEVED */ null,
        /* REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION */ null,
        /* READY_FOR_YOUR_NEXT_TRAINING */ "Èske w pare pou pwochen fòmasyon an?",
        /* READY_TO_CLOCK_IN */ null,
        /* READY_TO_CLOCK_OUT */ null,
        /* READ_AND_CONFIRM */ "Li epi Konfime",
        /* READ_ONLY_MODE */ null,
        /* READ_TEXT */ null,
        /* REASON */ null,
        /* RECENT_VISITS */ null,
        /* RECOMMENDED */ null,
        /* RECRUITMENT_MAIN_1 */ "sanble ou",
        /* RECRUITMENT_MAIN_1_2 */ "pap",
        /* RECRUITMENT_MAIN_2 */ "avèk okenn ajans",
        /* RECRUITMENT_MAIN_2_1 */ "travay",
        /* RECRUITMENT_MAIN_3 */ "ajans yo kapab bay travay",
        /* RECRUITMENT_MAIN_4 */ "ranpli yon aplikasyon",
        /* REFERRAL_CODE */ "Code de parrainage",
        /* REFER_ME */ "Parrainez-moi !",
        /* REGISTRATION */ null,
        /* REGULAR_PAY */ null,
        /* REJECT */ "Rejte",
        /* REJECTED */ "Refusé",
        /* REJECT_THIS_TASK */ null,
        /* REJECT_THIS_VISIT */ "Rejte vizit sa",
        /* REMAINED */ null,
        /* REMAINING */ "rete",
        /* REMIND_ME_LATER */ null,
        /* REMOVE */ "Retire",
        /* REMOVE_PAGE */ "Deplase paj la",
        /* REMOVE_TASK */ null,
        /* REOPENED */ null,
        /* REPLAY */ null,
        /* REQUEST */ "Demann",
        /* REQUESTED */ "DEMANDÉ",
        /* REQUESTED_LABEL_IN_CASES_LIST */ "Etikèt yo\" solisite a\" nan lis ka sa yo",
        /* REQUESTED_TIMES */ "Solisite lè yo",
        /* REQUESTED_VISIT_CANCEL_EXPLANATION */ null,
        /* REQUESTING_REFERENCE_RESPONSE */ null,
        /* REQUEST_AGENCIES_MEMBERSHIP */ "Faire une demande d'inscription aux agences",
        /* REQUEST_AGENCY */ "Demann ajans lan",
        /* REQUEST_AGENCY_MEMBERSHIP */ "Mande pou vin manm ajans lan",
        /* REQUEST_DETAILS */ "Détails de la demande",
        /* REQUEST_FOR_APPOINTMENT */ "demande de rendez-vous",
        /* REQUEST_FRIENDSHIP */ "Demander en ami",
        /* REQUEST_MORE_VISITS */ "Mande plis vizit",
        /* REQUEST_MORE_VISITS_MESSAGE */ null,
        /* REQUEST_NUMBER_SHIFTS */ "Mande %pòs yo% pòs yo",
        /* REQUEST_SELECTED_SHIFT */ null,
        /* REQUEST_SELECTED_SHIFTS */ null,
        /* REQUEST_SHIFTS */ "mande pòs yo",
        /* REQUEST_SINGLE_SHIFT */ "Mande yon senp pòs",
        /* REQUEST_THE_TIMES_YOU_WANT */ "Mande lè w vle!",
        /* REQUEST_THIS_VISIT */ "Bezwen vizit sa",
        /* REQUEST_TO */ "Demander à",
        /* REQUEST_VISIT */ "Demander cette visite",
        /* REQUIRED */ "Obligatwa",
        /* REQUIRED_DOCUMENTS */ "Mande dokiman yo",
        /* REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC */ "Kèk domèn obligatwa nan dokiman an manke, tanpri retounen epi ranpli yo",
        /* REQUIRED_PATIENT_DOCUMENT_TEXT */ "Ou dwe ranpli dokiman sa yo nan vizit sa",
        /* REQUIRED_TASKS */ null,
        /* REQUIREMENTS */ null,
        /* RESCHEDULE */ "Reprogrammer",
        /* RESCHEDULED_SUCCESSFULLY */ "Reyisi repwograme l",
        /* RESCHEDULE_IN_THE_PAST_ERROR */ "Pa kapab repwograme yon vizit ki nan pase",
        /* RESCHEDULE_REQUESTS */ "Reprogrammer les demandes",
        /* RESET_PIN_CODE_MESSAGE */ null,
        /* RESPIRATION_RATE */ null,
        /* RESUBMISSION_BANNER_TITLE */ null,
        /* RETAKE */ "Repran l",
        /* RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION */ null,
        /* RETRY */ "Réessayer",
        /* REVIEW_PRIVACY_POLICY */ "Gade Polotik Privasite a",
        /* REVIEW_TASK */ null,
        /* REVIEW_TASKS */ null,
        /* RE_ENTER_YOUR_PIN_CODE */ "Confirmez votre code PIN",
        /* RN_FLEXIBLE_SHOWCASE_TEXT */ "Vizit ki Fleksib",
        /* RN_FLEX_EXPLANATION_PREFIX */ "Sa se yon",
        /* RN_FLEX_REQUESTED_EXPLANATION */ "Yo pral mande w pou chwazi dat ak lè ou ta renmen an",
        /* RN_FLEX_REQUESTED_EXPLANATION_LINE_2 */ "Dat limit pou egzekite vizit sa se fason sa",
        /* RN_PATIENT_CONTACT_EXPLANATION */ "Vizit sa mande pou pran yon ti tan avèk pasyan an.",
        /* RN_SIGN_HERE */ "RN, siyen la",
        /* ROUTING_NUMBER */ null,
        /* ROUTING_NUMBR */ null,
        /* SAFETY_AND_HEALTH */ null,
        /* SAVE */ "sovgade",
        /* SAVE_FOR_LATER */ null,
        /* SCAN_AND_UPLOAD_FILES */ "Eskane & telechaje fichye yo",
        /* SCAN_A_PHOTO */ null,
        /* SCAN_DOCUMENT */ "Eskane dokiman yo",
        /* SCAN_NEW_DOCUMENT */ "Eskane nouvo dokiman an",
        /* SCAN_WITH_CAMERA */ "eskane avèk lamera",
        /* SCHEDULE */ "Orè",
        /* SCHEDULED */ null,
        /* SCHEDULED_DATE */ null,
        /* SCHEDULED_FOR */ null,
        /* SCHEDULED_VISIT_COMPLETE */ "Orè vizit ki fèt",
        /* SCHEDULED_VISIT_NOT_FOUND */ "Yo pa jwenn vizit ki pwograme a, tanpri kontakte ajans lan",
        /* SCHEDULE_CONFIRMATION */ null,
        /* SCHEDULE_FOR */ null,
        /* SCHEDULE_TASK */ null,
        /* SCHEDULING_PROBLEM */ "Pwoblèm pwogramasyon",
        /* SCREENING */ "Retransmisyon",
        /* SCREENING_FOR */ "Retransmisyon pou",
        /* SEARCH */ null,
        /* SEARCH_AGENCY */ "Rechercher une agence",
        /* SEARCH_FOR_MEDICATIONS */ "chache medikaman yo",
        /* SEARCH_NEARY_VISITS */ null,
        /* SEARCH_PATIENT */ null,
        /* SECOND_SHIFT */ "Dezyèm pòs",
        /* SECTION_ALREADY_COMPLETED */ null,
        /* SECTION_COMPLETED_PROMPT */ null,
        /* SECTION_LOCKED_PROMPT */ null,
        /* SEE_ALL */ null,
        /* SEE_ALL_CONVERSATIONS */ null,
        /* SEE_IN_MAPS */ null,
        /* SEE_LIST_OF_VISITS */ "Gade lis vizit yo",
        /* SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT */ null,
        /* SEE_YOUR_PROGRESS */ null,
        /* SELECT */ "Chwazi",
        /* SELECTED */ null,
        /* SELECTED_VISIT */ null,
        /* SELECT_ALL */ "Chwazi tout",
        /* SELECT_CERTIFICATE */ null,
        /* SELECT_DATE */ "Chwazi",
        /* SELECT_DATE_AND_TIME */ null,
        /* SELECT_DOCUMENT */ null,
        /* SELECT_DX_CODE */ null,
        /* SELECT_FROM_LIST */ null,
        /* SELECT_PERTINENT_DIAGNOSIS */ null,
        /* SELECT_PHYSICIAN */ null,
        /* SELECT_PRINCIPAL_DIAGNOSIS */ null,
        /* SELECT_SHIFTS */ null,
        /* SELECT_START_TIME */ null,
        /* SELECT_SURGICAL_PROCEDURE */ null,
        /* SELECT_TIME */ "Chwazi lè",
        /* SELECT_TIME_SLOT */ null,
        /* SELECT_TIME_SLOT_INFO */ null,
        /* SELECT_VISITS_FOR_INSTAPAY */ null,
        /* SELECT_VISIT_DURATION */ null,
        /* SELECT_YOUR_SCHEDULE */ null,
        /* SELFIE_WITH_PATIENT */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT */ null,
        /* SEND_A_MESSAGE */ null,
        /* SEND_EMAIL */ "Voye Imel la",
        /* SEND_REPORT */ "Voye rapò a",
        /* SEND_US_A_MAIL */ "Envoyez-nous un e-mail",
        /* SEPTEMBER */ null,
        /* SETTINGS */ "Réglages",
        /* SETTINGS_AND_INFO */ null,
        /* SET_DOCUMENT_EXPIRY_DATE */ "Mete dat ekspirasyon dokiman an",
        /* SET_EXPIRATION_DATE */ "Mete dat ekspirasyon an",
        /* SET_YOUR_4_DIGIT_PIN_CODE */ "Veuillez définir votre code PIN à 4 chiffres",
        /* SHARE */ null,
        /* SHARE_IDEAS_AND_GET_A_CHANCE */ null,
        /* SHARE_REFERENCE_LINK */ null,
        /* SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP */ null,
        /* SHARE_WITH_YOUR_FRIENDS */ null,
        /* SHIFT */ "Pòs",
        /* SHIFTS */ null,
        /* SHIFTS_DETAILS */ null,
        /* SHIFT_HAS_FINISHED_IN */ null,
        /* SHIFT_HAS_STARTED_IN */ null,
        /* SHOULD_BE_HERE */ "li ta dwe la",
        /* SHOW_ALL_TASKS */ null,
        /* SHOW_DETAILS */ null,
        /* SHOW_LESS */ "Montre mwens",
        /* SHOW_ME_CASES_IN_THE_NEXT */ "Montre mwen pwochen ka yo",
        /* SHOW_ME_IN */ "Montrez-moi dans",
        /* SHOW_MORE */ "Montre plis",
        /* SHOW_OLD_PLAN_OF_CARE */ "Montre ansyen plan pou swen an",
        /* SHOW_TASKS_THAT_REQUIRE_FIXES */ null,
        /* SHOW_US_YOUR_SMILE */ null,
        /* SIGNATURES */ null,
        /* SIGNATURE_REQUIRED */ null,
        /* SIGN_DECLINATION_FORM */ null,
        /* SIGN_HERE */ "Siyen la",
        /* SIGN_IN */ "CONNEXION",
        /* SIGN_ORIENTATION_VIDEO */ "Tanpri siyen la anvan w voye l",
        /* SIGN_ORIENTATION_VIDEO_ERR */ "Tanpri siyen anvan w voye l",
        /* SIGN_OUT */ "Déconnexion",
        /* SIGN_UP_FREE */ null,
        /* SIGN_UP_ITS_FREE */ null,
        /* SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE */ null,
        /* SINGLE_FLEXIBLE_VISIT_EXPLANATION */ null,
        /* SINGLE_VISIT_DETAILS */ "Détails relatifs à la consultation unique",
        /* SINGLE_VISIT_FROM */ "Consultation unique de",
        /* SINGLE_VISIT_TYPE */ "Vizit ki senp",
        /* SIXTY_SECONDS_AND_YOU_ARE_DONE */ null,
        /* SKIP */ "Passer",
        /* SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION */ null,
        /* SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS */ null,
        /* SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN */ null,
        /* SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES */ null,
        /* SLIDE_MAIN_INFO_GO_NEXT_SCREENS */ null,
        /* SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW */ null,
        /* SLIDE_STEP_X_OF_COUNT */ null,
        /* SMILE_FOR_US */ null,
        /* SOCIAL */ "Social",
        /* SOCIAL_MEDIA */ null,
        /* SOMETHING_WENT_WRONG */ "Gen yon bagay ki pa t fonksyone, tanpri eseye pita ankò",
        /* SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS */ null,
        /* SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM */ null,
        /* SOME_TASKS_NEED_FIXES */ null,
        /* SORRY */ null,
        /* SORT */ "Separe",
        /* SPECIFIC_DAYS */ "jou espesifik yo",
        /* SPEECH_RECOGNITION */ null,
        /* SPLIT_SHIFTS_VISIT */ "divize pòs yo",
        /* SPREAD_THE_WORD */ "Parlez-en autour de vous",
        /* STAGE_APPROVED_MESSAGE */ null,
        /* STAGE_AWAITING_APPROVAL */ null,
        /* STAGE_COMPLETED_MESSAGE */ null,
        /* STAGE_X_OF_TOTAL_STAGES */ null,
        /* START */ null,
        /* STARTING_AT */ "Kòmanse nan",
        /* STARTS */ "Démarre",
        /* STARTS_NEXT_WEEK */ null,
        /* STARTS_TODAY_IN */ null,
        /* START_APPLICATION */ "Kòmanse Aplikasyon an",
        /* START_A_SURVEY */ null,
        /* START_DATE */ "Date de début",
        /* START_FILLING */ null,
        /* START_NOW */ null,
        /* START_SHIFT */ null,
        /* START_TIME */ "Heure de début",
        /* START_USING_MEDFLYT_PASSPORT */ null,
        /* START_WATCHING */ null,
        /* START_WATCHING_ORIENTATION_VIDEOS */ null,
        /* START_WORKING */ null,
        /* STATUS */ "kondisyon",
        /* STAY_ON_TRACK */ null,
        /* STAY_ON_TRACK_1_ANSWER */ null,
        /* STAY_ON_TRACK_1_QUESTION */ null,
        /* STAY_ON_TRACK_2_ANSWER */ null,
        /* STAY_ON_TRACK_2_QUESTION */ null,
        /* STAY_ON_TRACK_3_ANSWER */ null,
        /* STAY_ON_TRACK_3_QUESTION */ null,
        /* STAY_ON_TRACK_4_ANSWER */ null,
        /* STAY_ON_TRACK_4_QUESTION */ null,
        /* STAY_ON_TRACK_DESCRIPTION */ null,
        /* STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS */ null,
        /* STAY_TUNED_FOR_MORE_VISITS */ "Restez connecté pour obtenir d'autres visites",
        /* STAY_TUNED_FOR_THE_NEXT_RAFFLE */ null,
        /* STILL_WAITING_REFERENCE_ANSWER */ null,
        /* STOP */ null,
        /* STREAK_BREAK */ null,
        /* STREAK_BREAK_MESSAGE */ null,
        /* STREAK_BREAK_MESSAGE_2 */ null,
        /* SUBMIT */ "Voye l",
        /* SUBMITTED_AT */ null,
        /* SUBMITTED_DOCUMENTS */ "Li te voye dokiman yo",
        /* SUBMITTED_MANUALLY */ "voye l ak men",
        /* SUBMIT_AFTER */ "Voye l apre",
        /* SUBMIT_AT */ "Voye l nan",
        /* SUBMIT_BY */ "Voye pa",
        /* SUBMIT_DUTIES */ null,
        /* SUBMIT_DUTIES_BEFORE_CLOCK_OUT */ null,
        /* SUBMIT_FORM */ null,
        /* SUBMIT_FORMS */ null,
        /* SUBMIT_MANUAL_TIMESHEET */ null,
        /* SUBMIT_REQUIRED */ "Voye l se yon obligasyon",
        /* SUBMIT_TEST */ "voye tès la",
        /* SUBMIT_TIMESHEET */ null,
        /* SUBMIT_WITH_SCHEDULED_DATE */ "Voye l ak orè jodi a",
        /* SUBMIT_WITH_TODAY_DATE */ "voye l avèk dat jodi a",
        /* SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT */ null,
        /* SUBMIT_YOUR_SIGN */ "Voye siyati w",
        /* SUBMIT_YOUR_SIGNATURE */ "voye siyati w",
        /* SUCCESS */ "Reyisi repwograme l",
        /* SUCCESSFULLY_CLOCKED_IN */ null,
        /* SUCCESSFULLY_CLOCKED_OUT */ null,
        /* SUCCESSFULY_REQUESTED */ "Demann lan fèt!",
        /* SURGICAL_PROCEDURE */ null,
        /* SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS */ "Chanje lis pou wè a, gade vizit yo vin avè yo",
        /* SWITCH_VIEW */ "Chanje sa w wè",
        /* TAKE_A_DIFFERENT_PHOTO */ null,
        /* TAKE_A_PHOTO */ "Prendre une photo",
        /* TAKE_A_SURVEY */ null,
        /* TAKE_ME_TO_CASE_SETTINGS */ "naviguer moi vers les parametres du patient",
        /* TAKE_PHOTO */ null,
        /* TAKE_THIS_TASK */ null,
        /* TAP_HERE_TO_VIEW */ "Tape la pou wè",
        /* TAP_TO_CANCEL */ "Touchez pour annuler",
        /* TAP_TO_CHANGE_CASE_SETTINGS */ "Tapez pour modifier les paramètres du patient",
        /* TASK */ null,
        /* TASKS */ null,
        /* TASK_ALREADY_ASSIGNED */ null,
        /* TASK_COMPLETED_SUCCESSFULLY */ "Felisitasyon 🎉💪🏻ou fini travay sa.",
        /* TASK_INFORMATION */ null,
        /* TASK_SCHEDULED */ null,
        /* TASK_SCHEDULED_MESSAGE */ null,
        /* TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE */ null,
        /* TECHNICAL_SUPPORT */ "sipò Teknik",
        /* TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES */ "Dites-nous pourquoi vous n'êtes pas intéressé afin que nous vous transmettions de meilleurs patients",
        /* TELL_US_YOUR_AGENY_DESCRIPTION */ "Di nou non ajans ou an, non kowòdinatè a epi nou pral kontakte yo pou difize dosye ki ouvè yo",
        /* TEMPERATURE */ null,
        /* TEN_DOLLAR_STARBUCKS_GIFT_CARD */ null,
        /* TERMINATED */ "RÉSILIÉ",
        /* TERMS_OF_MEDFLYT_PRIVACY_POLICY */ null,
        /* TERMS_OF_USE */ "Conditions d'utilisation",
        /* TEST */ "tès la",
        /* TESTS */ null,
        /* TEST_COMPLETED */ null,
        /* TEST_FAILED */ "Tès la te echwe",
        /* TEST_REQUIRED */ "Tès obligatwa",
        /* THANKS */ null,
        /* THANK_YOU */ null,
        /* THANK_YOU_FOR_YOUR_FEEDBACK */ "Mèsi pou kòmantè w.",
        /* THATS_ME */ null,
        /* THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION */ null,
        /* THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS */ null,
        /* THERE_ARE_NO_AGENCIES_YET */ "Il n'y pas encore d'agences",
        /* THERE_ARE_NO_ASSIGNED_CASES */ null,
        /* THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION */ "Un problème concerne votre connexion internet",
        /* THERE_SEEMS_TO_BE_NOTHING_HERE */ "Il n'y a rien ici, apparemment...",
        /* THE_AWARDS_ARE_COMING_SOON */ null,
        /* THE_BEST_PLACE_FOR_CAREGIVERS */ null,
        /* THE_DUTY_SHEET_HAS_BEEN_SUBMITTED */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON */ null,
        /* THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS */ null,
        /* THE_NEXT_WINNERS_ANNOUNCEMENT */ "Annonce du prochain gagnant",
        /* THE_SELECTED_DATE_IS_EARLIER_THAN */ null,
        /* THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS */ "Vizit la kapab fèt nan jou sa yo",
        /* THE_VISIT_HAS_NOT_STARTED_YET */ null,
        /* THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS */ null,
        /* THIS_BUNDLE_INCLUDES */ null,
        /* THIS_CONVERSATION_HAS_BEEN_RESOLVED */ null,
        /* THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK */ "Kou sa gen ladan %d leson yo. Bòn chans!",
        /* THIS_FIELD_IS_CURRENTLY_DISABLED */ null,
        /* THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT */ "Ceci est une ancienne visite : vous ne pouvez pas effectuer le pointage d'arrivée / de départ.",
        /* THIS_IS_A_FUTURE_VISIT */ null,
        /* THIS_IS_A_LIVE_CLASS_SESSION */ null,
        /* THIS_MAY_TAKE_UP_TO_X_SECONDS */ null,
        /* THIS_PATIENT_BELONGS_TO_AGENCY */ null,
        /* THIS_PATIENT_HAS_NO_PHONE_NUMBERS */ null,
        /* THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER */ null,
        /* THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP */ null,
        /* THIS_VISIT_CAN_BE_PERFORMED_BETWEEN */ "Vizit sa ka fèt ant",
        /* THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE */ null,
        /* THIS_VISIT_IS_FOR_DIFFERENT_AGENCY */ null,
        /* THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET */ "Cette visite se déroulera prochainement : vous ne pouvez pas effectuer le pointage d'arrivée.",
        /* THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY */ null,
        /* THIS_WILL_MARK_THE_VISIT_AS_MISSED */ null,
        /* TIME */ "Lè",
        /* TIMESHEET_SUBMITTED */ null,
        /* TIME_ESTIMATION */ null,
        /* TIME_FRAME */ "Dèle",
        /* TIME_LEFT */ "Tan ki rete",
        /* TIME_VARIES */ "L'heure varie",
        /* TO */ "nan",
        /* TODAY */ null,
        /* TODAYS_DATE */ null,
        /* TOKENS */ null,
        /* TOO_MANY_HOURS */ "Trop d'heures",
        /* TOO_MANY_SHIFTS */ "Twòp pòs!",
        /* TOO_MANY_SHIFTS_MESSAGE */ "Yo pèmèt ou pran %pòs maksimòm yo%pòs yo. Si w vle pòs sa, w ap bezwen pa chwazi youn nan pòs ou te deja chwazi yo.",
        /* TOP_CAREGIVERS_IN_YOUR_AREA */ "Meilleurs professionnels de santé dans votre région",
        /* TOTAL_EARNED */ null,
        /* TOTAL_SPENT */ null,
        /* TO_FILL_IN_A_FORM_INSTEAD */ null,
        /* TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT */ null,
        /* TO_SEE_THIS_TASK_GO_TO_ASSIGNED */ null,
        /* TO_SEE_THIS_VISIT_GO_TO */ "Pou wè vizit sa, chache",
        /* TO_UPLOAD_A_FILE_INSTEAD */ null,
        /* TO_WIN_AN_IPHONE12 */ null,
        /* TRAINING */ null,
        /* TRAININGS_FOR */ "Fòmasyon pou",
        /* TRAINING_CENTER */ "Sant fòmasyon",
        /* TRAINING_CENTER_REMINDERS */ null,
        /* TRY_AGAIN */ null,
        /* TYPE_AGENCY_CODE */ "Tape kòd ajans lan",
        /* TYPE_MESSAGE */ "Saisir votre message",
        /* TYPE_YOUR_ADDRESS */ "Ekri adrès ou",
        /* UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET */ null,
        /* UNANSWERED_LAST_SECTION_FOR_NOW */ null,
        /* UNAUTHORIZED */ null,
        /* UNAVAILABLE_LOCATION_SERVICES_MESSAGE */ null,
        /* UNDER_REVIEW */ null,
        /* UNDO */ "Refè",
        /* UNIQUE_ERROR_CODE */ "Kòd erè ki inik",
        /* UNSCHEDULE */ null,
        /* UNSCHEDULE_TASK */ null,
        /* UNSPECIFIED */ null,
        /* UNTIL */ "Jiskaske",
        /* UPCOMING_VISITS */ null,
        /* UPDATED_AT */ null,
        /* UPDATE_INFORMATION */ null,
        /* UPLOAD */ "Telechaje",
        /* UPLOADED */ "te telechaje",
        /* UPLOADED_FILE_VIEW */ null,
        /* UPLOADING */ "telechajman",
        /* UPLOAD_A_DOCUMENT */ null,
        /* UPLOAD_A_FILE */ null,
        /* UPLOAD_DOCUMENT */ "Telechaje dokiman an",
        /* UPLOAD_DOCUMENTS */ "Telechaje dokiman yo",
        /* UPLOAD_ERROR */ "Telechaje erè yo",
        /* UPLOAD_FILES_TO_ENSURE */ "Telechaje dosye yo pou asire",
        /* UPLOAD_FLU_SHOT_DOCUMENT */ null,
        /* UPLOAD_FROM_GALLERY */ null,
        /* UPLOAD_NEW_DOCUMENT */ null,
        /* UPLOAD_VIDEO */ null,
        /* UPLOAD_YOUR_FILES_TO_ENSURE */ "Telechaje fichye yo pou asire",
        /* UP_COMING_REASSESSMENTS */ "Pwochen reevalyasyon",
        /* UP_TO */ null,
        /* URGENT */ null,
        /* USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY */ "Itilizatè sa bloke akoz yo sispèk yon aktivite",
        /* VALID */ "Valid",
        /* VERIFIED */ "Te verifye",
        /* VERIFY */ null,
        /* VERIFYING */ null,
        /* VERIFY_YOUR_LOCATION */ null,
        /* VERY_URGENT */ null,
        /* VIDEO */ "Videyo",
        /* VIDEOS */ null,
        /* VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION */ "Videyo yo ki nan sant fòmasyon an bezwen atansyon w.",
        /* VIDEO_COMPLETED_SUCCESSFULLY */ "Felisitasyon 🎉💪🏻èske w te fin gade videyo a.",
        /* VIEW */ "wè yo",
        /* VIEWED */ "Te wè yo",
        /* VIEW_ALL */ null,
        /* VIEW_ANSWERS */ null,
        /* VIEW_CERTIFICATE */ "Gade Sètifika a",
        /* VIEW_TASK */ null,
        /* VIEW_TASKS_PENDING_FOR_SCHEDULE */ null,
        /* VIEW_VISIT */ null,
        /* VIRTUAL_ID_CARD */ null,
        /* VISIT */ null,
        /* VISITS */ "Vizit yo",
        /* VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER */ null,
        /* VISITS_NEXT_MONTH */ null,
        /* VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* VISITS_PER_WEEK */ "Vizit pa semèn yo",
        /* VISITS_WITH_ISSUES */ null,
        /* VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE */ "Yo akòde vizit la, verifye orè w",
        /* VISIT_BY */ "Visite d'ici le",
        /* VISIT_CHAT */ "Tchat de la consultation",
        /* VISIT_COMPLETE */ null,
        /* VISIT_COMPLETED_SUCCESSFULLY */ null,
        /* VISIT_COUNTS */ null,
        /* VISIT_COUNTS_DESCRIPTION */ null,
        /* VISIT_DATE */ "Date de la visite",
        /* VISIT_DATES */ null,
        /* VISIT_DETAILS */ "Detay sou Vizit yo",
        /* VISIT_DURATION */ null,
        /* VISIT_INFORMATION */ null,
        /* VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU */ null,
        /* VISIT_LASTING */ "Durée de la visite",
        /* VISIT_NEXT_MONTH */ null,
        /* VISIT_NOTIFICATIONS_OFF */ "Notifications de visits est atteint",
        /* VISIT_NOTIFICATIONS_ON */ "Notifications de visits est allumé",
        /* VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE */ "ou potko pwograme vizit sa.Èske w sèten ou vle soti?",
        /* VISIT_NO_LONGER_AVAILABLE */ "Pa gen vizit ki disponib ankò",
        /* VISIT_RATE_REQUEST_CONFIRMATION */ null,
        /* VISIT_REMINDERS */ null,
        /* VISIT_REQUEST_CONFIRMATION_WARNING */ null,
        /* VISIT_SCHEDULE */ null,
        /* VISIT_STARTED_AT */ null,
        /* VISIT_STARTED_MISSING_CLOCK_IN */ null,
        /* VISIT_STARTS_AT */ null,
        /* VISIT_SUCESSFULLY_CANCELED */ "Reyisi anile vizit la",
        /* VISIT_TIME_ADJUSTMENT */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_EARLY */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_LATE */ null,
        /* VISIT_TOO_SHORT */ null,
        /* VISIT_TYPE */ null,
        /* VISIT_WITH */ null,
        /* VOUCHER */ null,
        /* WAITING_FOR_APPROVAL */ "Tann apwobasyon",
        /* WAITING_TO_BE_SCHEDULED */ null,
        /* WARNING */ "Attention!",
        /* WAS_DUE_BETWEEN */ null,
        /* WAS_DUE_ON */ null,
        /* WATCHED */ "Te gade",
        /* WATCH_HOW_IT_WORKS */ null,
        /* WATCH_REQUIRED */ "Gade obligatwa",
        /* WATCH_TRAINING_VIDEOS_TO_COMPLETE */ null,
        /* WEEKLY_DETAILS */ null,
        /* WELCOME */ null,
        /* WELCOME_BACK */ null,
        /* WELCOME_TO_CARE_MOMENTS */ null,
        /* WELCOME_TO_MEDFLYT */ null,
        /* WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE */ null,
        /* WELL_BE_IN_TOUCH_SHORTLY */ "N ap kontakte byen rapid.",
        /* WERE_YOU_REFERRED_BY_SOMEONE */ "Est-ce que quelqu'un vous a parrainé ?",
        /* WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM */ null,
        /* WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR */ "Nou pa kapab jwenn medikaman w ap chache a",
        /* WE_COULDNT_FIND_YOUR_AGENCY */ "Nou pa t kapab jwenn ajans ou an!",
        /* WE_GOT_YOUR_CONFIRMATION */ null,
        /* WE_GOT_YOUR_RESPONSE_WAIT_HH_MM */ null,
        /* WE_HAVE_ONE_MATCHING_ACCOUNT */ null,
        /* WE_HAVE_X_MATCHING_ACCOUNTS */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT */ null,
        /* WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT */ null,
        /* WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON */ null,
        /* WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE */ null,
        /* WHAT_BENEFITS_CAN_YOU_GET */ null,
        /* WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK */ null,
        /* WHAT_WOULD_YOU_LIKE_TO_DO_FIRST */ null,
        /* WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT */ "lè ou wè yon vizit ki fleksib, w ap kapab mande lè ki bon pou ou a",
        /* WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR */ null,
        /* WHOOPS */ "whoops",
        /* WHOS_THE_LUCKY_ONE */ null,
        /* WILL_BEGIN_SHORTLY */ null,
        /* WILL_EXPIRE_IN_DAYS */ null,
        /* WILL_EXPIRE_TOMORROW */ null,
        /* WINNER_ANNOUNCED_IN */ null,
        /* WITH_CAREGIVERS */ "Avec soignants",
        /* WORKING_WITH_AGENCY */ "M ap travay avèk yon ajans",
        /* WRONG_DATES_SELECTION */ null,
        /* WRONG_PHONE_NUMBER */ null,
        /* WRONG_PIN */ "PIN erroné",
        /* X_DAYS_SELECTED */ null,
        /* X_DAYS_TO_COMPLETE */ "%d jou yo pou fini",
        /* X_DAYS_TO_SELECT */ null,
        /* X_HOURS_SELECTED */ null,
        /* X_HOURS_TO_SELECT */ null,
        /* YAY_YOU_WERE_ASSIGNED_TO_A_VISIT */ null,
        /* YEAR */ null,
        /* YEARS_OLD */ null,
        /* YES */ "Oui",
        /* YES_ADJUST_TIMES */ null,
        /* YES_DELETE */ null,
        /* YES_I_AM_SURE */ null,
        /* YES_OVERRIDE_FORM */ null,
        /* YES_REQUEST_ANYWAY */ null,
        /* YES_SCHEDULE_VISIT */ null,
        /* YES_THATS_ME */ null,
        /* YES_UPDATE_ALL */ null,
        /* YOURE_ALL_DONE_LETS_GET_YOU_WORKING */ null,
        /* YOURE_IN_THE_RAFFLE */ null,
        /* YOURE_NOT_IN_THE_RAFFLE */ null,
        /* YOURSELF */ "ou menm",
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD */ null,
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE */ null,
        /* YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS */ "Ajans ou an ka poko ba w leson. tanpri eseye pita.",
        /* YOUR_ANSWER_IS_CORRECT */ "Repons ou an kòrèk!",
        /* YOUR_ANSWER_IS_INCORRECT */ "Repons ou an pa kòrèk!",
        /* YOUR_COMPLIANCE */ "Konfòmite w",
        /* YOUR_COMPLIANCE_ITEM_HAS_EXPIRED */ null,
        /* YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS */ null,
        /* YOUR_FILE_IS_BEING_UPLOADED */ "fichye w yo telechaje",
        /* YOUR_IN_SERVICE_IS_DUE_IN_DAYS */ null,
        /* YOUR_IN_SERVICE_IS_OVER_DUE */ null,
        /* YOUR_MOBILE */ "Votre téléphone portable",
        /* YOUR_REFERERAL_CODE */ "Votre code de parrainage",
        /* YOUR_TASK_HAS_BEEN_SCHEDULED_FOR */ null,
        /* YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY */ null,
        /* YOUVE_BEEN_SUCCESSFULLY_REFERRED */ "Vous avez été parrainé avec succès !",
        /* YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "Ou te fè tout travay yo pou kounye a",
        /* YOU_ALREADY_FAILED */ "Ou te deja echwe nan tès la",
        /* YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT */ "Ou deja gen yon vizit ki pwograme pou lè sa",
        /* YOU_ALREADY_REQUESTED_THIS_VISIT */ null,
        /* YOU_ALREADY_SUCCEEDED */ "Ou te deja pase tès la.",
        /* YOU_ARE_ALL_SET */ null,
        /* YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION */ null,
        /* YOU_ARE_COMPLIANT */ null,
        /* YOU_ARE_EXEMPT_FROM_THIS_TEST */ "Ou distribye tès sa",
        /* YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD */ null,
        /* YOU_ARE_NOT_COMPLIANT */ null,
        /* YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM */ null,
        /* YOU_ARE_OUT_OF_COMPLIANCE */ null,
        /* YOU_ARE_X_DAYS_LATE */ "Ou %d jou reta yo",
        /* YOU_CANNOT_EDIT_YOUR_ANSWERS */ null,
        /* YOU_CANT_EDIT_VISIT_WITH_CICO */ null,
        /* YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES */ null,
        /* YOU_CANT_SIGN_BEFORE_ALL_ANSWERED */ null,
        /* YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME */ null,
        /* YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED */ null,
        /* YOU_CAN_CONTINUE_TO_NEXT_SECTION */ null,
        /* YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY */ null,
        /* YOU_DIDNT_ANSWER_ALL_QUESTIONS */ null,
        /* YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN */ "Vous n'avez pas saisi le même code PIN. Veuillez réessayer.",
        /* YOU_DONT_HAVE_ANY_CASES_YET */ null,
        /* YOU_DONT_HAVE_ANY_PATIENTS_YET */ null,
        /* YOU_GET_POINTS */ null,
        /* YOU_GOT_THE_CASE */ null,
        /* YOU_GOT_THE_CERTIFICATE */ "Ou gen sètifika a!",
        /* YOU_HAVENT_CLOCKED_IN_YET */ "ou potko pwograme l",
        /* YOU_HAVENT_CLOCKED_OUT_YET */ "Ou potko soti",
        /* YOU_HAVENT_UPLOADED_ANYTHING_YET */ "Ou poko telechaje anyen",
        /* YOU_HAVE_COMPLETED_THIS_TEST */ null,
        /* YOU_HAVE_HH_MM_TO_CONFIRM_IT */ null,
        /* YOU_HAVE_MISSING_COMPLIANCE_ITEMS */ null,
        /* YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW */ null,
        /* YOU_HAVE_NOT_WATCHED */ "ou pa t gade l",
        /* YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY */ null,
        /* YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS */ null,
        /* YOU_HAVE_ONE_ATTEMPT_LEFT */ null,
        /* YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING */ "Ou gen yon jou pou fini fòmasyon sa!",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION */ null,
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING */ "Ou reyisi fini fòmasyon sa 🚀",
        /* YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY */ "Ou bezwen fini fòmasyon sa jodi a. Fè rapid!",
        /* YOU_HAVE_TO_ENROLL_FIRST */ null,
        /* YOU_HAVE_TO_PICK_A_CODE */ null,
        /* YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_LEFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST */ null,
        /* YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y */ null,
        /* YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING */ "Ou gen %d jou pou fini fòmasyon sa!",
        /* YOU_JUST_GOT_PAID */ null,
        /* YOU_JUST_GOT_PROMOTED_TO */ null,
        /* YOU_LOSE_POINTS */ null,
        /* YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS */ "Ou ka chanje konfigirasyon vizit ou a pou resevwa vizit ki pi enpòtan",
        /* YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE */ "Ou pa kapab reponn tès la paske",
        /* YOU_MAY_ONLY_SUBMIT_AFTER */ "Ou kapab sèlman voye l apre w fin",
        /* YOU_MISSED_A_SHIFT_WITHOUT_NOTICE */ null,
        /* YOU_MUST_ANSWER_ALL_THE_QUESTIONS */ "Ou dwe reponn tout kesyon yo.",
        /* YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT */ null,
        /* YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST */ "Ou dwe gade premye videyo anvan an",
        /* YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION */ null,
        /* YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE */ null,
        /* YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT */ null,
        /* YOU_RECENTLY_WON_A_RAFFLE */ null,
        /* YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT */ null,
        /* YOU_USED_THE_CODE */ "Vous avez utilisé le code",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE */ null,
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS */ null,
        /* YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS */ null
    ],
    "he": [
        /* ACCEPTED */ "מאושר",
        /* ACCEPT_THESE_HOURS */ null,
        /* ACCEPT_THE_VISIT_AT */ null,
        /* ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY */ null,
        /* ACCOUNT_NUMBER */ null,
        /* ACCOUNT_TYPE */ null,
        /* ACTIVE */ "פעיל",
        /* ACTIVE_DOCUMENT */ null,
        /* ADD */ null,
        /* ADDITIONAL_NOTES */ null,
        /* ADDRESS */ "כתובת",
        /* ADDRESS2 */ null,
        /* ADDRESS_ERROR */ "בעיה בכתובת",
        /* ADDRESS_IS_NEAR */ null,
        /* ADD_ANOTHER_DOCUMENT */ null,
        /* ADD_ANOTHER_PERTINENT_DIAGNOSIS */ null,
        /* ADD_IMAGE */ null,
        /* ADD_NEW_MEDICATION */ null,
        /* ADD_NOTES */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_BUTTON */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_TITLE */ null,
        /* ADD_PHYSICIAN */ null,
        /* ADD_YOUR_SIGNATURE */ null,
        /* ADVANCED_DIRECTIVES */ null,
        /* AGENCIES_CONTACT */ null,
        /* AGENCY */ null,
        /* AGENCY_CODE */ "קוד סוכנות",
        /* AGENCY_COORDINATOR */ null,
        /* AGENCY_DETAILS */ "פרטי הסוכנות",
        /* AGENCY_HANDBOOK */ null,
        /* AGENCY_ISSUES */ null,
        /* AGENCY_NAME */ null,
        /* AGENCY_NOTIFICATIONS */ null,
        /* AGENCY_NOT_FOUND */ null,
        /* AGREE_TO_MEDFLYT_TERMS */ null,
        /* AIDE */ null,
        /* AIRPODS */ null,
        /* ALLERGIES */ null,
        /* ALLOW_ACCESS_TO_MY_LOCATION */ null,
        /* ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP */ null,
        /* ALL_CHANGES_SAVED */ null,
        /* ALL_DAY */ "כל היום",
        /* ALL_DONE */ null,
        /* ALL_TRANSACTIONS */ null,
        /* ALL_VERIFIED_ITEMS */ null,
        /* ALREADY_CLOCKED_IN */ null,
        /* ALREADY_CLOCKED_IN_ANOTHER_VISIT */ null,
        /* ALREADY_CLOCKED_OUT */ null,
        /* ALREADY_HAVE_AN_ACCOUNT */ null,
        /* AND_AMPERSAND */ "ו",
        /* ANSWERED */ "השיב",
        /* ANSWERED_AT */ "נענה ב",
        /* ANSWER_INCOMPLETE_QUESTIONS */ null,
        /* ANY_DURATION */ "כל משך זמן",
        /* AN_ERROR_HAS_OCCURED */ null,
        /* AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET */ null,
        /* APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES */ "חברת Apple לא קשורה בשום צורה לתחרות",
        /* APPLICATION_DONE */ null,
        /* APPROVE */ null,
        /* APPROVED */ null,
        /* APPROVE_THIS_TASK */ null,
        /* APPROVE_THIS_VISIT */ null,
        /* APRIL */ null,
        /* ARENT_YOU_MISSING_SOMETHING */ null,
        /* ARE_YOU */ null,
        /* ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY */ null,
        /* ARE_YOU_SURE */ null,
        /* ARE_YOU_SURE_REQUEST_FAR_VISIT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST */ "האם אתה בטוח שאתה רוצה לבטל את הבקשה?",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT */ "האם אתה בטוח שאתה רוצה לבטל את הביקור?",
        /* ARE_YOU_SURE_YOU_WANT_TO_DELETE */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE */ "אתה בטוח שאתה רוצה לבקש את ה",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT */ "האם אתה בטוח שאתה רוצה לבקש את הביקור הזה?",
        /* ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT */ "האם באמת להתנתק?",
        /* ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK */ null,
        /* ASSIGNED */ "משובץ",
        /* ASSIST */ null,
        /* AS_NEEDED */ null,
        /* AS_REQUESTED_BY_THE_PATIENT */ "כשהלקוח מבקש",
        /* ATTACH_A_DOCUMENT */ null,
        /* AUGUST */ null,
        /* AUTHENTICATION_FAILED */ null,
        /* AUTH_VERIFICATION_FAIL_EXAPLINED */ null,
        /* AUTOPLAY */ null,
        /* AVAILABILITY */ "זמינות",
        /* AVAILABLE */ null,
        /* AVAILABLE_CARE_POINTS */ null,
        /* AVAILABLE_ON_THE_FOLLOWING_DAYS */ null,
        /* AVAILABLE_SHIFTS */ null,
        /* AVAILABLE_VISITS */ null,
        /* AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK */ null,
        /* AWAITING_PATIENT_CONTACT */ null,
        /* A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT */ "כבר קיימת פלאן אוף קאר",
        /* A_VERIFICATION_CODE_IS_BEING_SENT_TO */ "קוד אימות נשלח ל",
        /* A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE */ "קוד אימות יישלח אליך דרך סמס",
        /* A_VISIT_BY */ "ביקור של",
        /* BACK */ null,
        /* BACK_TO_ONBOARDING */ null,
        /* BANK_INFORMATION */ null,
        /* BANK_NAME */ null,
        /* BASICALLY_EVERY_ACTION_COUNTS */ null,
        /* BEFORE_SUBMITTING_THE_DUTIES */ null,
        /* BEGIN_NOW */ null,
        /* BEST_TASK_FOR_YOU */ null,
        /* BETWEEN */ "בין",
        /* BETWEEN_AND */ "וגם",
        /* BIRTHDAY */ "תאריך לידה",
        /* BLOOD_PRESSURE */ null,
        /* BOROUGH */ null,
        /* BUNDLES */ null,
        /* BUNDLE_DESCRIPTION */ null,
        /* BUNDLE_DESCRIPTION_P1 */ null,
        /* BUNDLE_DESCRIPTION_P2 */ null,
        /* BUNDLE_IS_LOCKED */ null,
        /* BUNDLE_ITEM_NOT_FOUND */ null,
        /* BUNDLE_NOT_FOUND */ null,
        /* BUNDLE_PROGRESS */ null,
        /* BUSY_ALL_DAY */ "אני עסוק כל היום",
        /* BY */ null,
        /* BY_ENROLLING_I_ACCEPT_THE */ null,
        /* BY_EXISTING_VISIT */ null,
        /* BY_PATIENT_NAME */ null,
        /* BY_SIGNING_HERE_I_ACCEPT_THE */ "אני חותם פה שאני מסכים ל",
        /* CALL */ null,
        /* CALL_AGENCY */ "התקשר לסוכנות",
        /* CALL_HOME */ null,
        /* CALL_MOBILE */ null,
        /* CALL_NOW */ null,
        /* CALL_PATIENT */ "התקשר למטופל",
        /* CALL_PATIENT_CONFIRMATION */ null,
        /* CALL_PATIENT_EXPLANATION */ null,
        /* CALL_PATIENT_HOME */ null,
        /* CALL_PATIENT_MOBILE */ null,
        /* CALL_PATIENT_NOTE */ "במסך הבא את תוכלי ליצור קשר עם המטופל",
        /* CALL_SUPPORT_FOR_MORE_INFO */ "התקשר לתמיכה בשביל עוד מידע",
        /* CANCEL */ "ביטול",
        /* CANCEL_REQUESTED_SHIFTS */ null,
        /* CANCEL_VISIT */ null,
        /* CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE */ null,
        /* CANT_CANCEL_24_HOURS_SCHEDULED_VISIT */ "אי אפשר לבטל ביקור המתחיל פחות מ 24 שעות",
        /* CANT_CANCEL_AT_THIS_TIME */ "לא יכול לבטל עכשיו...",
        /* CANT_CLOCK_IN */ "לא יכול להתחיל ביקור",
        /* CANT_CLOCK_IN_AT_THIS_TIME */ "לא יכול להתחיל ביקור עכשיו",
        /* CANT_CLOCK_OUT */ "לא יכול לסיים ביקור",
        /* CANT_CLOCK_OUT_AT_THIS_TIME */ null,
        /* CANT_CLOCK_OUT_BEFORE_VISIT_ENDED */ null,
        /* CANT_REJECT_VISIT_PENDING_STATUS */ null,
        /* CANT_REQUEST_JOIN_AGENCY */ null,
        /* CANT_REQUEST_VISIT_PENDING_STATUS */ null,
        /* CANT_SUBMIT_AN_EMPTY_FORM */ null,
        /* CANT_WATCH_ON_SHIFT */ "התוכן הנדרש לא יוצג במהלך המשמרת",
        /* CANT_WATCH_THIS_VIDEO */ null,
        /* CAREBACK_CASH_BONUS */ null,
        /* CAREBACK_POINTS */ null,
        /* CAREGIVER */ null,
        /* CAREGIVER_COMPLIANCE_PASSPORT */ null,
        /* CAREGIVER_NAME */ null,
        /* CAREGIVER_PHONE */ null,
        /* CAREGIVER_SIGNATURE */ null,
        /* CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG */ null,
        /* CAREGIVER_SIGNATURE_IS_REQUIRED */ null,
        /* CAREGIVER_SIGNATURE_REQUIRE_MSG */ null,
        /* CAREGIVER_STATUS_PENDING_ERROR */ null,
        /* CARE_MOMENTS */ null,
        /* CASE_INFO */ null,
        /* CASE_IS_TOO_FAR */ "ביקור רחוק מדי",
        /* CASE_SETTINGS */ "הגדרות ביקורים",
        /* CATALOGUE */ null,
        /* CERTIFICATION */ null,
        /* CERTIFICATIONS */ null,
        /* CHANGE */ null,
        /* CHANGES_TO_MY_VISITS */ null,
        /* CHANGES_WERE_SAVED_IN_THE_CLOUD */ "כל השינויים נשמרו בענן",
        /* CHANGE_DOCUMENT */ null,
        /* CHANGE_OF_RANKING */ null,
        /* CHANGE_PHONE_NUMBER */ "שנה מספר טלפון",
        /* CHANGE_SETTINGS */ null,
        /* CHANGE_SHIFTS */ null,
        /* CHANGE_TASK_TIME */ null,
        /* CHANGE_VISIT_TIMES */ "שנה זמני ביקור",
        /* CHAT */ null,
        /* CHATS */ "צ׳אטים",
        /* CHAT_MESSAGES */ null,
        /* CHAT_NOT_ACTIVE_MESSAGE */ null,
        /* CHAT_NOT_ACTIVE_TITLE */ null,
        /* CHAT_WITH_AGENCY */ "צ׳אט עם הסוכנות",
        /* CHAT_WITH_AGENCY_ABOUT_PATIENT */ null,
        /* CHAT_WITH_MEDFLYT */ null,
        /* CHAT_WITH_OTHER_AGENCIES */ null,
        /* CHAT_WITH_SUPPORT */ null,
        /* CHAT_WITH_US */ null,
        /* CHECK */ null,
        /* CHECK_AGAIN */ null,
        /* CHOOSE_ANOTHER_DATE */ "בחר תאריך אחר",
        /* CHOOSE_A_PHOTO */ null,
        /* CHOOSE_A_TIME_FOR_THE_VISIT */ null,
        /* CHOOSE_CLOCK_TIMES */ null,
        /* CHOOSE_DATE_TO_PERFORM_THIS_TASK */ null,
        /* CHOOSE_FOLDER_TO_UPLOAD */ "בחר תיקייה להעלאת קבצים",
        /* CHOOSE_START_TIME */ null,
        /* CHOOSE_THE_HOURS */ null,
        /* CHOOSE_TIME */ null,
        /* CHOOSE_WHEN_TO_PERFORM_THE_VISIT */ null,
        /* CHOOSE_WHEN_TO_VISIT_THE_PATIENT */ null,
        /* CHOOSE_WHO_TO_CONTACT */ null,
        /* CHOOSING_A_WINNER */ null,
        /* CHOOSING_A_WINNER_IN */ null,
        /* CLEAR */ null,
        /* CLICK_HERE */ null,
        /* CLICK_HERE_TO_DOWNLOAD */ "לחץ כאן להתקנה",
        /* CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE */ "לחץ כאן כדי לשתף את קוד ההפניה שלך",
        /* CLICK_HERE_TO_VIEW_CERTIFICATE */ null,
        /* CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE */ null,
        /* CLICK_TO_REQUEST */ "לחץ לבקש!",
        /* CLICK_TO_SCAN_UPLOAD */ "לחץ לסריקה והעלאה",
        /* CLICK_TO_TAKE_A_SELFIE */ null,
        /* CLIMB_THE_RANKS_BY_COMPLETING_VISITS */ null,
        /* CLINICAL_SUPPORT */ null,
        /* CLOCKED_IN */ "אצל ביקור",
        /* CLOCKED_IN_AND_OUT */ null,
        /* CLOCKED_IN_AT */ "התחיל ביקור ב",
        /* CLOCKED_OUT */ null,
        /* CLOCKED_OUT_AT */ "סיים ביקור ב",
        /* CLOCKING_IN */ "מתחיל ביקור...",
        /* CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES */ null,
        /* CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES */ null,
        /* CLOCKING_OUT */ "מסיים ביקור...",
        /* CLOCK_ADDRESS_IN_RANGE */ null,
        /* CLOCK_ADDRESS_NOT_IN_RANGE */ null,
        /* CLOCK_IN */ "התחל ביקור",
        /* CLOCK_IN_ANYWAY */ null,
        /* CLOCK_IN_AT */ null,
        /* CLOCK_IN_BETWEEN */ null,
        /* CLOCK_IN_OUT */ "התחל / סיים ביקור",
        /* CLOCK_IN_OUT_SUBMIT_DUTIES */ null,
        /* CLOCK_IN_TIME_IS_REQUIRED */ null,
        /* CLOCK_OUT */ "סיים ביקור",
        /* CLOCK_OUT_AFTER */ null,
        /* CLOCK_OUT_AT */ null,
        /* CLOCK_OUT_BETWEEN */ null,
        /* CLOCK_OUT_TIME_IS_REQUIRED */ null,
        /* CLOCK_TIMES_NOT_MOBILE */ null,
        /* CLOCK_TIME_IN_RANGE */ null,
        /* CLOCK_TIME_NOT_IN_RANGE */ null,
        /* CLOSE */ null,
        /* CLOSE_SURVEY */ null,
        /* CLUSTERED_VISIT_EXPLENATION */ "המערכת מצאה ששני הוזיתים האלה ואי איזה חרטות כתבו פהההה עומררררר ררררררררר ררררררררר ררררר ררררר רררר",
        /* CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE */ "קוד לא נמצא, אנא השתמש בקוד אחר",
        /* COMBINED_CASE */ "קייס מקומבן",
        /* COMING_SOON */ null,
        /* COMPLETED */ null,
        /* COMPLETED_DOCUMENTS */ "מסמכים שהוגשו",
        /* COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL */ null,
        /* COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS */ null,
        /* COMPLETE_PREVIOUS_SECTIONS_FIRST */ null,
        /* COMPLETE_REGISTRATION */ null,
        /* COMPLETE_REGISTRATION_PROCESS */ null,
        /* COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* COMPLETE_VISIT */ null,
        /* COMPLETE_YOUR_ONBOARDING_ANYTIME */ null,
        /* COMPLIANCE */ null,
        /* COMPLIANCE_EXPIRY */ null,
        /* COMPLIANCE_FORM */ null,
        /* COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY */ null,
        /* COMPLIANT */ null,
        /* COMPLIANT_ITEMS */ null,
        /* CONFIRM */ null,
        /* CONFIRM_ASSESSMENT */ "תאשר הערכה",
        /* CONFIRM_COPY_LAST */ null,
        /* CONFIRM_COPY_LAST_TITLE */ null,
        /* CONFIRM_DEPOSIT_DETAILS */ null,
        /* CONFIRM_PATIENT_AVAILABILITY */ null,
        /* CONFIRM_PATIENT_AVAILABILITY_MESSAGE */ null,
        /* CONFIRM_RN_FLEX_VISIT */ null,
        /* CONFIRM_WITHOUT_LOCATION */ null,
        /* CONGRATULATIONS */ null,
        /* CONGRATULATIONS_TO */ null,
        /* CONNECTING_HOME */ "מחבר בין",
        /* CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS */ null,
        /* CONNECT_WITH_US_ON_FACEBOOK */ null,
        /* CONNECT_WITH_US_ON_WHATSAPP */ null,
        /* CONTACT */ null,
        /* CONTACT_AGENCY_FOR_MORE_INFO */ "צור קשר עם הסוכנות למידע נוסף",
        /* CONTACT_PATIENT */ null,
        /* CONTACT_SUPPORT */ null,
        /* CONTINUE */ null,
        /* CONTINUE_LATER */ null,
        /* CONTINUE_TO_APP */ null,
        /* CONTINUE_TO_ORIENTATION */ null,
        /* CONTINUE_TO_SIGN_UP */ null,
        /* CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK */ null,
        /* COORDINATOR */ null,
        /* COORDINATOR_EMAIL */ null,
        /* COORDINATOR_IN_CHARGE */ "רכז אחראי",
        /* COORDINATOR_PHONE */ null,
        /* COPY */ "העתק",
        /* COPY_FROM_LAST_TIME */ null,
        /* COPY_FROM_MEDICATION */ null,
        /* COPY_FROM_OTHER_FORMS */ "העתק מטפסים אחרים",
        /* COPY_LAST_NO_DATE_FALLBACK_APPENDED */ null,
        /* COPY_MEDICATION_CHART */ null,
        /* COPY_PLAN_OF_CARE */ null,
        /* CORRECT */ null,
        /* COURSES */ null,
        /* COVID */ null,
        /* COVID_REQUIRED */ null,
        /* COVID_REQUIRED_EXPLAINED */ null,
        /* COVID_SCREENING_CLICK_HERE */ null,
        /* CREATED_AT */ "נוצר ב",
        /* CREATE_A_NEW_ACCOUNT */ null,
        /* CREATE_NEW_PLAN_OF_CARE */ "צור פלאן אוף קאר חדש",
        /* CRIMINAL_CONVICTIONS_RECORDS */ null,
        /* CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT */ "התחיל כבר ביקור אחר",
        /* CURRENT_BALANCE */ null,
        /* CURRENT_VISIT */ null,
        /* DATA_WILL_BE_LOST */ null,
        /* DATE */ null,
        /* DATES */ null,
        /* DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO */ null,
        /* DATE_NOT_SPECIFIED */ null,
        /* DATE_OF_BIRTH */ null,
        /* DATE_UNKNOWN */ null,
        /* DATE_VERIFICATION */ "וידוא תאריך",
        /* DAY */ null,
        /* DAYS */ null,
        /* DAYS_A_WEEK */ null,
        /* DAYS_LEFT */ null,
        /* DAYS_OF_WEEK */ "ימים בשבוע",
        /* DECEMBER */ null,
        /* DECLINED */ null,
        /* DELETE */ "מחק",
        /* DESCRIBE_THE_PROBLEM */ null,
        /* DETAILS */ "פרטים",
        /* DIRECTIONS */ null,
        /* DIRECT_DEPOSIT */ null,
        /* DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION */ "מנותק. בדוק את האינטרנט שלך",
        /* DISCOVER_YOUR_JOURNEY */ null,
        /* DISCRIMINATION */ null,
        /* DISMISS */ null,
        /* DISMISSED */ null,
        /* DISTANCE */ "מרחק",
        /* DOB */ null,
        /* DOCUMENT */ null,
        /* DOCUMENTS */ null,
        /* DOCUMENTS_TO_COMPLETE */ null,
        /* DOCUMENT_HAS_EXPIRED */ null,
        /* DOCUMENT_IS_MISSING */ null,
        /* DOCUMENT_REJECTED */ null,
        /* DOCUMENT_SELECTED */ null,
        /* DOESNT_EXPIRE */ null,
        /* DOES_NOT_FIT_MY_SCHEDULE */ "לא מתאים ללו״ז שלי",
        /* DONE */ null,
        /* DONT_FORGET_TO_CLOCK_IN */ null,
        /* DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS */ null,
        /* DONT_FORGET_TO_CLOCK_OUT */ "לא לשכוח לסיים ביקור",
        /* DONT_FORGET_TO_FILL_THE_DUTY_SHEET */ null,
        /* DONT_FORGET_TO_SMILE */ null,
        /* DONT_SCHEDULE_VISIT */ null,
        /* DONT_SHOW_AGAIN */ null,
        /* DOSE */ null,
        /* DOWNLOAD_PDF */ null,
        /* DO_YOU_HAVE_ANY_QUESTIONS_ASK */ null,
        /* DO_YOU_WANT_THIS_VISIT */ null,
        /* DUE_BETWEEN */ null,
        /* DUE_BY_DATETIME */ null,
        /* DUE_DATE */ null,
        /* DUE_ON */ null,
        /* DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO */ null,
        /* DURATION */ null,
        /* DURATION_PER_DAY */ null,
        /* DUTIES */ null,
        /* DUTIES_COMPLETED_SUCCESSFULLY */ null,
        /* DUTY_SHEET_SUBMITTED */ null,
        /* EACH_100_POINTS_DOLLAR */ null,
        /* EACH_INVITE */ "כל הזמנה",
        /* EARLY_OR_LATE_CLOCKS */ null,
        /* EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY */ null,
        /* EDIT */ null,
        /* EDIT_ACCOUNT_DETAILS */ null,
        /* EDIT_TIMES */ null,
        /* EDUCATION */ null,
        /* ELECTRIC_EQUIPMENT_DEPENDENCY */ null,
        /* ELIGIBLE_VISITS */ null,
        /* EMAIL */ null,
        /* EMAIL_QUESTION_PENDING_VERIFICATION */ null,
        /* EMAIL_SUPPORT */ null,
        /* EMAIL_SUPPORT_FOR_MORE_INFO */ "שלח אימייל למידע ליותר מידע",
        /* EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER */ null,
        /* EMAIL_VERIFICATION_QUESTION_LABEL */ null,
        /* EMERGENCY_CONTACTS */ null,
        /* EMPTY_DURATION */ null,
        /* EMPTY_PATIENT_MEDICATION_PROFILE */ null,
        /* ENABLE_LOCATION_MESSAGE */ null,
        /* ENABLE_LOCATION_TITLE */ null,
        /* ENDING_AT */ null,
        /* ENDS */ "נגמר",
        /* END_DATE */ "תאריך סיום",
        /* END_TIME */ "שעת סיום",
        /* ENROLLMENT_REQUESTED */ null,
        /* ENROLL_NOW */ null,
        /* ENTER_AGENCY_CODE */ null,
        /* ENTER_DOCUMENT_NAME */ null,
        /* ENTER_NUMBER_HERE */ null,
        /* ENTER_TEXT_HERE */ null,
        /* ENTER_YOUR_MOBILE_NUMBER */ "הכנס מספר טלפון נייד",
        /* ENTER_YOUR_PIN_CODE */ null,
        /* ENTITY_IS_MISSING */ null,
        /* ERROR */ "שגיאה",
        /* ERROR_FETCHING_SLOTS */ null,
        /* ERROR_LOADING_DATA */ null,
        /* ERROR_REMOVING_DOCUMENT */ null,
        /* ERROR_SCHEDULING_TASK */ null,
        /* ERROR_SCHEDULING_TASK_MESSAGE */ null,
        /* ESTIMATED_ADDRESS_WILL_BE_PROVIDED */ null,
        /* ESTIMATED_TIME_OF_CLOCKING_OUT_IS */ null,
        /* EVACUATION_LOCATION */ null,
        /* EVACUATION_ZONE */ null,
        /* EVERY_VISIT */ "כל ביקור",
        /* EVV */ null,
        /* EXCITING_NEWS_AHEAD */ null,
        /* EXEMPTED */ null,
        /* EXPIRED */ null,
        /* EXPIRED_COMPLIANCE */ null,
        /* EXPIRED_ON_DATE */ null,
        /* EXPIRES_AT */ null,
        /* EXPIRES_IN */ null,
        /* EXPIRES_IN_ONE_DAY */ null,
        /* EXPIRES_IN_X_DAYS */ null,
        /* EXPIRES_ON_DATE */ null,
        /* EXPIRING_COMPLIANCE */ null,
        /* EXPIRING_SOON */ null,
        /* EXPIRY_DATE */ null,
        /* EXPLORE */ null,
        /* EXPLORE_A_CAREER_ENHANCEMENTS */ null,
        /* FAILED_TO_IDENTIFY_PATIENT */ null,
        /* FAR_VISIT_WARNING_MODAL_TITLE */ null,
        /* FAX_NUMBER */ null,
        /* FEBRUARY */ null,
        /* FEMALE */ "נקבה",
        /* FIFTHY_DOLLAR_AMAZON_GIFT_CARD */ null,
        /* FILES */ null,
        /* FILE_NOT_FOUND_CONTACT_AGENCY */ null,
        /* FILL */ null,
        /* FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT */ null,
        /* FILL_IN_THE_QUESTIONNAIRE */ null,
        /* FILTERS */ null,
        /* FINAL_CONFIRMATION */ null,
        /* FIND_A_CARE_MOMENT */ null,
        /* FIND_A_CARE_MOMENT_DESCRIPTION */ null,
        /* FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FINISH_MY_ONBOARDING */ null,
        /* FINISH_ONBOARDING_AND_GET_DOLLARS */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2 */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE_STAGE_2 */ null,
        /* FINISH_SHIFT */ null,
        /* FINISH_THE_DOCUMENTS */ null,
        /* FIRST_NAME */ "שם פרטי",
        /* FIRST_SHIFT */ null,
        /* FIVE_THOUSAND_POINTS */ null,
        /* FIX */ null,
        /* FIX_DOCUMENTS_DESCRIPTION */ null,
        /* FIX_DOCUMENT_DESCRIPTION */ null,
        /* FIX_ISSUE */ null,
        /* FIX_ISSUES */ null,
        /* FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* FIX_SETTINGS */ null,
        /* FIX_THE_DOCUMENT */ null,
        /* FIX_THE_DOCUMENTS */ null,
        /* FIX_YOUR_DOCUMENT */ null,
        /* FIX_YOUR_DOCUMENTS */ null,
        /* FLEXIBLE */ null,
        /* FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_VISIT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT */ null,
        /* FLEXIBLE_HOURS_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_VISIT */ null,
        /* FLEXIBLE_VISIT */ null,
        /* FLEXIBLE_VISIT_DAY_TO_CHOOSE */ null,
        /* FLEXIBLE_VISIT_DETAILS */ null,
        /* FLEXIBLE_VISIT_TYPE */ null,
        /* FLU_SHOT */ null,
        /* FLU_SHOT_SUBMITTION_MESSAGE */ null,
        /* FOLLOW_US_ON_INSTAGRAM */ "עקבו אחרינו באינסטגרם",
        /* FOLLOW_US_ON_TWITTER */ "עקבו אחרינו בטוויטר",
        /* FORGOT_PIN_CODE_DIALOG_MESSAGE */ "שים לב: נקח אותך למסך הכניסה של האפליקצייה כדי להתחיל תהליך כניסה מחדש.",
        /* FORM_NAME */ "שם טופס",
        /* FOURTEEN_THOUSAND_POINTS */ null,
        /* FREQUENCY */ null,
        /* FRIEND */ null,
        /* FROM */ null,
        /* FROM_CAMERA */ "ממצלמה",
        /* FROM_GALLERY */ "מגלריה",
        /* FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE */ "תנאי שימוש מלאים - תחרות MedFlyt",
        /* FUTURE_VISITS */ null,
        /* GENDER */ "מין",
        /* GENERAL */ "כללי",
        /* GENERAL_FILES */ "קבצים כלליים",
        /* GENERAL_NOTES */ "מידע כללי",
        /* GENERAL_SUPPORT */ null,
        /* GET_INSTAPAY */ null,
        /* GET_IT_NOW */ null,
        /* GET_MONEY_FOR_THIS_VISIT_TODAY
 */ null,
        /* GET_NOW */ null,
        /* GET_STARTED */ null,
        /* GET_THE_APP */ null,
        /* GET_X_NOW */ null,
        /* GOOD_JOB */ null,
        /* GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ null,
        /* GOT_IT */ null,
        /* GO_BACK */ "אחורה",
        /* GO_TO */ null,
        /* GO_TO_MEDFLYT_PASSPORT */ null,
        /* GO_TO_PATIENT */ null,
        /* GO_TO_PATIENT_DETAILS */ null,
        /* GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION */ null,
        /* GO_TO_VISIT */ "הצג ביקור",
        /* GREAT_JOB */ null,
        /* GROSS_PAY */ null,
        /* HAS_DNR */ null,
        /* HAS_HEALTH_CARE_PROXY */ null,
        /* HAVE_A_NICE_WORKING_DAY */ null,
        /* HAVE_A_PLEASANT_VISIT */ null,
        /* HAVE_A_QUESTION_LETS_CHAT */ null,
        /* HEALTH_AGENCIES */ "סוכניות טיפול",
        /* HELP */ "עזרה",
        /* HELP_ME_FIND_MY_AGENCY */ null,
        /* HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY */ null,
        /* HEY */ "היי!",
        /* HEY_THERE */ null,
        /* HI */ null,
        /* HIRE_DATE */ null,
        /* HI_PLEASE_HELP_ME_FILL_MY_APPLICATION  */ null,
        /* HOME_PHONE */ "טלפון בבית",
        /* HOUR */ null,
        /* HOURS */ null,
        /* HOURS_PER_DAY */ "שעות ביום",
        /* HOURS_PER_VISIT */ "שעות בביקור",
        /* HOW_ARE_WE_CALCULATING_THE_RANK */ null,
        /* HOW_CAN_WE_HELP_YOU */ null,
        /* HOW_CARE_MOMENTS_WORKS */ null,
        /* HOW_DID_YOU_HEAR_ABOUT_US */ null,
        /* HOW_DOES_IT_WORK */ null,
        /* HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS */ null,
        /* HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN */ null,
        /* HOW_DO_YOU_RATE_MEDFLYT */ null,
        /* HOW_URGENT_IS_THE_ISSUE */ null,
        /* HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT */ null,
        /* HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE */ null,
        /* HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT */ null,
        /* HR_PER_VISIT */ null,
        /* HUNDRED_DOLLARS_GIFT_CARD */ null,
        /* ICD */ null,
        /* ID */ null,
        /* IF_YOU_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON */ null,
        /* IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE */ null,
        /* IF_YOU_STAY_COMPLIANT */ null,
        /* IMPORTANT_INFORMATION */ null,
        /* IMPORTED */ "מיובא",
        /* IM_AVAILABLE */ "אני זמין",
        /* IM_DONE_SUBMIT */ null,
        /* IM_NOT_INTERESTED */ null,
        /* IM_WORKING_WITH_AN_AGENCY */ null,
        /* INACTIVE */ "לא פעיל",
        /* INCOMPLETE */ null,
        /* INCORRECT */ null,
        /* INCORRECT_CODE */ "קוד שגוי",
        /* INCORRECT_DIGITS */ null,
        /* INCORRECT_DIGITS_EXPLAINED */ null,
        /* INCORRECT_DIGITS_MESSAGE */ null,
        /* INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN */ "קוד PIN שגוי. אנא נסה שנית",
        /* INCORRECT_SMS_CODE */ null,
        /* INCORRECT_SMS_CODE_EXPLAINED */ null,
        /* INFORMATION_CENTER */ null,
        /* INFORMATION_NOT_MATCH_PROFILE */ null,
        /* INSERT_THEIR_REFERRAL_CODE_HERE */ "הכנס את הקוד שלהם כאן!",
        /* INSERVICES */ null,
        /* INSTAPAY */ null,
        /* INSTAPAY_HISTORY */ null,
        /* INSTAPAY_TECHNICAL_ISSUE */ null,
        /* INSUFFICIENT_DUTIES */ null,
        /* INTERESTED_IN_THIS_BUNDLE */ null,
        /* INTRODUCING */ null,
        /* INVALID_DOCUMENT_NAME */ null,
        /* INVALID_EMAIL */ null,
        /* INVALID_FORM */ null,
        /* INVALID_PHONE */ null,
        /* INVALID_PHONENUMBER */ null,
        /* INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN */ null,
        /* INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES */ "הזמן קיירגיברס לMedFlyt וזכה בפרסים מדהימים",
        /* INVITE_FRIENDS */ "הזמן חברים",
        /* IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE */ null,
        /* IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT */ null,
        /* IN_PROGRESS */ null,
        /* ISSUES_TO_SOLVE */ null,
        /* IS_DUE_IN_DAYS */ null,
        /* IS_DUE_TOMORROW */ null,
        /* ITEMS_THAT_WILL_EXPIRE_SOON */ null,
        /* ITEMS_WITH_ISSUES */ null,
        /* ITEM_IS_MISSING */ null,
        /* ITEM_IS_NOT_COMPLIANT */ null,
        /* ITS_NOT_ME */ null,
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU */ null,
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU */ null,
        /* IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK */ null,
        /* IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE */ null,
        /* I_DONT_HAVE_MY_CODE */ null,
        /* I_DONT_WANT_THIS_CASE */ null,
        /* I_DONT_WANT_TO_CLOCK */ null,
        /* I_FORGOT_MY_PIN_CODE */ "שכחתי את קוד הPIN שלי",
        /* I_HAVE_CHANGED_MY_MIND */ null,
        /* I_HAVE_READ_AND_AGREE */ null,
        /* I_VERIFY_THE_TERMS */ null,
        /* I_WANT_TO_CLOCK_IN_ANYWAY */ null,
        /* I_WANT_TO_CLOCK_OUT_ANYWAY */ null,
        /* I_WANT_TO_FINISH_MY_ONBOARDING */ null,
        /* I_WILL_DO_IT_LATER */ null,
        /* JANUARY */ null,
        /* JOINED_DATE */ "הצטרף ב",
        /* JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT */ null,
        /* JULY */ null,
        /* JUNE */ null,
        /* JUST_ONE_MORE_THING */ null,
        /* JUST_TO_BE_SURE */ null,
        /* JUST_VERIFYING_ITS_YOU */ null,
        /* KEEP_UP_THE_GOOD_WORK */ null,
        /* LABELS */ null,
        /* LANGUAGE */ null,
        /* LANGUAGES */ "שפות",
        /* LAST_NAME */ "שם משפחה",
        /* LEARN_MORE */ null,
        /* LEAVE_WITHOUT_SAVING */ null,
        /* LEFT */ null,
        /* LESSON */ null,
        /* LESSONS */ null,
        /* LETS_CONTINUE_TO_NEXT_SECTION */ null,
        /* LETS_FIND_CASES */ null,
        /* LETS_FIND_YOUR_FIRST_CASE */ null,
        /* LETS_FIND_YOUR_FIRST_PATIENT */ null,
        /* LETS_FINISH_YOUR_SHIFT */ null,
        /* LETS_START */ null,
        /* LETS_START_YOUR_SHIFT */ null,
        /* LIKE_US_ON_FACEBOOK */ "תנו לנו Like בפייסבוק",
        /* LINKED_TO_ANOTHER_PATIENT */ null,
        /* LIST */ null,
        /* LISTENING___ */ null,
        /* LIST_OF_PATIENTS */ null,
        /* LIST_OF_TASKS */ null,
        /* LIST_OF_VISITS */ null,
        /* LIVE_CHAT_SUPPORT */ null,
        /* LIVE_CLASS */ null,
        /* LIVE_CLASS_EXPLANATION */ null,
        /* LIVE_EVENTS */ null,
        /* LOADING */ "טוען",
        /* LOADING_LOCATION */ "טוען מיקום...",
        /* LOCATION */ "מיקום",
        /* LOCKED */ null,
        /* LOGGING_YOU_IN */ null,
        /* LOGIN */ null,
        /* LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED */ null,
        /* LOOKS_LIKE_MORE_THAN */ null,
        /* LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION */ null,
        /* MAIN_TASKS */ null,
        /* MAKE_A_DIFFERENCE */ null,
        /* MAKE_SURE_PICTURE_IS_CLEAR */ null,
        /* MALE */ "זכר",
        /* MANUALLY_SUBMITTED_INFO */ null,
        /* MAP */ null,
        /* MARCH */ null,
        /* MAX_TRAVEL_DISTANCE */ "מרחק נסיעה מקסימלית",
        /* MAY */ null,
        /* MAYBE_LATER */ null,
        /* MAY_CLOCK_IN_AT */ "יכול להתחיל ביקור ב",
        /* MAY_CLOCK_OUT_FROM */ "יכול לסיים ביקור ב",
        /* MEC_WAIVER_INFORMATION */ null,
        /* MEDFLYT */ null,
        /* MEDFLYTS_MONTHLY_RAFFLE */ null,
        /* MEDFLYT_AGENCY_HANDBOOK */ null,
        /* MEDFLYT_AT_HOME_BENEFITS */ null,
        /* MEDFLYT_CHALLENGE */ "תחרות MedFlyt",
        /* MEDFLYT_HOME_CARE */ null,
        /* MEDFLYT_ID_CARD */ null,
        /* MEDFLYT_PASSPORT */ null,
        /* MEDFLYT_PASSPORT_TERMS */ null,
        /* MEDFLYT_RAFFLE */ null,
        /* MEDFLYT_TEAM */ null,
        /* MEDFLYT_VERSION */ "גרסת MedFlyt",
        /* MEDICAL_FILES */ "קבצי רפואה",
        /* MEDICAL_INFORMATION */ "מידע רפואי",
        /* MEDICAL_NOTES */ null,
        /* MEDICATIONS */ null,
        /* MESSAGE */ "הודעה",
        /* MESSAGE_FOR_THE_COORDINATOR */ "הודעה עבור הרכז",
        /* MIDDLE_NAME */ null,
        /* MILES_AWAY */ "מרחק במיילים",
        /* MILES_BETWEEN_PATIENTS */ "מרחק בין לקוחות",
        /* MILES_SHORT */ null,
        /* MINIMUM_WAGE */ null,
        /* MINUTE */ null,
        /* MINUTES */ null,
        /* MINUTE_VISIT */ null,
        /* MISSING */ null,
        /* MISSING_CLOCKS */ null,
        /* MISSING_PERSONAL_CARE_DUTY */ null,
        /* MM_DD_YYYY */ null,
        /* MOBILE_PHONE */ null,
        /* MOBILITY_STATUS */ null,
        /* MONTH */ null,
        /* MONTHLY_RAFFLE */ null,
        /* MORE_DETAILS */ "פרטים נוספים",
        /* MORE_DETAILS_BELOW */ null,
        /* MORE_SHIFTS_MORE_CHANCES */ null,
        /* MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* MUST_AGREE_TERMS */ null,
        /* MUST_BE_ATLEAST_3_CHARACTERS */ "חובה להיות לפחות 3 אותיות",
        /* MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS */ null,
        /* MUST_PICK_EXACTLY */ null,
        /* MUST_START_AT_OR_AFTER */ null,
        /* MUST_START_AT_OR_BEFORE */ null,
        /* MUST_UPDATE_ADDRESS_TO_SEE_CASES */ "עליך לעדכן את הכתובת שלך בשביל לראות קייסים",
        /* MY_AGENCIES */ "הסוכניות שלי",
        /* MY_ASSIGNED_VISITS */ "הביקורים שלי",
        /* MY_AVAILABILITY */ null,
        /* MY_BENEFITS_CARD_INFORMATION */ null,
        /* MY_MEDFLYT_COMPLIANCE */ null,
        /* MY_PASSPORT */ null,
        /* MY_PAYROLL_HISTORY */ null,
        /* MY_PAYROLL_INFORMATION */ null,
        /* MY_PROFILE */ null,
        /* MY_REQUESTED_VISITS */ "הביקרים שביקשתי",
        /* MY_STAFFING_PREFERENCES */ null,
        /* MY_UPCOMING_VISITS_REMINDERS */ null,
        /* MY_VIRTUAL_ID */ null,
        /* MY_VISITS */ null,
        /* NA */ "ל.ת.",
        /* NAME */ null,
        /* NEAR */ null,
        /* NEED_DIRECTIONS */ "צריך הוראות הגעה?",
        /* NET_PAY_FOR_PERIOD */ null,
        /* NEW */ "חדש",
        /* NEW_END_TIME_X */ null,
        /* NEW_MESSAGE */ null,
        /* NEW_TASK */ null,
        /* NEW_TASKS */ null,
        /* NEW_VISITS_AVAILABLE */ null,
        /* NEXT */ "הבא",
        /* NEXT_DUE */ null,
        /* NEXT_LESSON */ null,
        /* NEXT_SECTION */ null,
        /* NEXT_TOKEN_IN */ null,
        /* NEXT_YEAR */ null,
        /* NO */ "לא",
        /* NONE */ null,
        /* NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT */ null,
        /* NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU */ null,
        /* NOTES */ "הערות",
        /* NOTIFICATIONS */ "הודעות",
        /* NOTIFICATIONS_OFF */ null,
        /* NOTIFICATIONS_ON */ null,
        /* NOT_AVAILABLE */ "לא זמין",
        /* NOT_COMPLIANT */ null,
        /* NOT_DUE_YET */ null,
        /* NOT_ENOUGH_HOURS */ "לא מספיק שעות",
        /* NOT_ENOUGH_SHIFTS */ null,
        /* NOT_ENOUGH_SHIFTS_MESSAGE */ null,
        /* NOT_FOUND */ null,
        /* NOT_INTERESTED */ "לא מעוניין",
        /* NOT_SELECTED */ null,
        /* NOT_SET */ null,
        /* NOT_SIGNING */ null,
        /* NOT_STARTED */ null,
        /* NOT_URGENT */ null,
        /* NOVEMBER */ null,
        /* NO_ALLERGIES */ null,
        /* NO_ANSWERS_TO_COPY */ null,
        /* NO_ANSWERS_TO_COPY_TITLE */ null,
        /* NO_AVAILABLE_SLOTS */ null,
        /* NO_BALANCE */ null,
        /* NO_CHANGES_WERE_MADE */ "לא בוצעו שינויים",
        /* NO_COMPLIANT_ITEMS */ null,
        /* NO_DOCUMENTS */ null,
        /* NO_DOCUMENTS_AVAILABLE */ null,
        /* NO_DOCUMENTS_REQUIRED */ "אין טפסים הכרחיים",
        /* NO_DUTIES_REQUIRED_FOR_THIS_VISIT */ null,
        /* NO_EDUCATION_LINK */ null,
        /* NO_ELIGIBLE_VISITS */ null,
        /* NO_END_DATE */ null,
        /* NO_GENERAL_NOTES */ "אין הערות כלליות",
        /* NO_IN_SERVICE_VIDEOS_AVAILABLE */ null,
        /* NO_ISSUES_FOUND */ null,
        /* NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT */ null,
        /* NO_JUST_THIS_ONE */ null,
        /* NO_KEEP_THE_ORIGINAL_TIMES */ null,
        /* NO_KNOWN_ALLERGIES */ null,
        /* NO_LESSONS */ null,
        /* NO_LESSONS_FOR_YOU_YET */ null,
        /* NO_MEDICAL_INFORMATION */ "אין פרטים רפואיים",
        /* NO_NOTIFICATIONS */ "אין הודעות",
        /* NO_PAYSTUBS_FOUND_FOR_THIS_MONTH */ null,
        /* NO_PHONE */ "אין טלפון",
        /* NO_PHYSICIAN_SELECTED */ null,
        /* NO_PREVIOUS_CONVERSATIONS */ null,
        /* NO_SCHEDULED_VISITS_TODAY */ null,
        /* NO_SHIFTS_SELECTED */ null,
        /* NO_TAKE_ME_BACK */ null,
        /* NO_TESTS */ null,
        /* NO_THANKS */ "לא תודה",
        /* NO_TIME_LIMIT */ null,
        /* NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT */ null,
        /* NO_VIDEOS */ null,
        /* NO_VISITS_SCHEDULED */ null,
        /* NO_VISITS_SCHEDULED_MESSAGE */ null,
        /* NO_VISITS_SELECTED */ null,
        /* NPI */ null,
        /* NUM_COUNT_ITEMS */ null,
        /* NUM_SHIFTS_TO_GO */ null,
        /* NUM_SHIFTS_TO_WAGE */ null,
        /* N_A */ null,
        /* OCTOBER */ null,
        /* OF */ null,
        /* OF_THE_REQUIRED_PLEASE_CONTINUE */ null,
        /* OF_THE_VIDEO */ null,
        /* OK */ "אישור",
        /* OK_ILL_TRY_LATER */ null,
        /* OK_NO_PROBLEM */ null,
        /* OK_THANKS */ null,
        /* ON */ null,
        /* ONBOARDING */ null,
        /* ONBOARDING_COMPLETED */ null,
        /* ONBOARDING_COMPLETED_MESSAGE */ null,
        /* ONE_DAY_TO_COMPLETE */ null,
        /* ONE_DOCUMENT */ null,
        /* ONE_DOCUMENT_SELECTED */ null,
        /* ONE_HOUR */ null,
        /* ONE_LAST_STEP */ null,
        /* ONE_LESSON */ null,
        /* ONE_TEST */ null,
        /* ONE_THOUSAND_POINTS */ null,
        /* ONE_VIDEO */ null,
        /* ON_HOLD */ "בהמתנה",
        /* ON_LEAVE */ "בחופשה",
        /* OOPS */ "אופס",
        /* OPEN */ null,
        /* OPEN_CAMERA */ null,
        /* OPEN_CERTIFICATE */ null,
        /* OPEN_DEVICE_SETTINGS */ null,
        /* OPEN_MAPS */ null,
        /* OPEN_SETTINGS */ null,
        /* OPTIONAL_TASKS */ null,
        /* OR */ "או",
        /* OTHER */ null,
        /* OTHER_PERTINENT_DIAGNOSIS */ null,
        /* OTHER_REASON */ null,
        /* OTHER_TASKS */ null,
        /* OTHER_VISITS */ null,
        /* OUTBOUND_CALL_ERROR_MESSAGE */ null,
        /* OUTBOUND_CALL_ERROR_TITLE */ null,
        /* OUTBOUND_CALL_PROMPT_MESSAGE */ null,
        /* OUTBOUND_CALL_PROMPT_TITLE */ null,
        /* OUTBOUND_CALL_SUCCESS_MESSAGE */ null,
        /* OUTBOUND_CALL_SUCCESS_TITLE */ null,
        /* OUT_OF */ null,
        /* OUT_OF_RANGE */ null,
        /* OVERDUE */ null,
        /* OVERLAPPING_VISIT_ERROR */ null,
        /* OVERRIDE_FORM */ null,
        /* OVERRIDE_FORM_MESSAGE */ null,
        /* OVER_NIGHT */ null,
        /* PAGE */ null,
        /* PAID */ null,
        /* PAID_X_OUT_OF_Y */ null,
        /* PARTIAL_SELECTION */ null,
        /* PASSPORT */ null,
        /* PASSPORT_TERMS_TEXT */ null,
        /* PASTE */ "הדבק",
        /* PAST_DUE */ null,
        /* PAST_SINCE_THE_VISIT_STARTED */ null,
        /* PAST_UPLOADS */ null,
        /* PAST_VISITS */ null,
        /* PATIENT */ "מטופל",
        /* PATIENTS */ null,
        /* PATIENT_ADDRESS */ "כתובת של מטופל",
        /* PATIENT_CANT_PHISICALLY_SIGN */ null,
        /* PATIENT_CANT_SIGN */ null,
        /* PATIENT_CONTACTS */ null,
        /* PATIENT_DOC_NOT_SUBMITTED */ null,
        /* PATIENT_DOC_SUBMISSION_MISSMATCH */ "היום הוא לא יום התאריך הנקבע ליום הביקור, אנא בחר את התאריך הרצוי",
        /* PATIENT_DOC_SUBMITTED_SUCCESSFULY */ null,
        /* PATIENT_INFO */ "מידע על מטופל",
        /* PATIENT_IS_NOT_HOME */ null,
        /* PATIENT_IS_NOT_SIGNING */ null,
        /* PATIENT_NAME */ "שם מטופל",
        /* PATIENT_NOT_FOUND */ null,
        /* PATIENT_NOT_FOUND_EXPLAIN */ null,
        /* PATIENT_NUMBER */ "לקוח מספר",
        /* PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE */ null,
        /* PATIENT_PHONE */ "טלפון של מטופל",
        /* PATIENT_REFUSES_TO_SIGN */ null,
        /* PATIENT_REPORT */ null,
        /* PATIENT_REQUESTS */ null,
        /* PATIENT_SCHEDULE */ null,
        /* PATIENT_SIGNATURE */ null,
        /* PATIENT_SIGNATURE_IS_REQUIRED */ null,
        /* PATIENT_SIGNATURE_REQUIRE_MSG */ null,
        /* PATIENT_SIGN_HERE */ "לקוח חותם כאן",
        /* PATIENT_UNAVAILABLE_DURING_THESE_HOURS */ null,
        /* PATIENT_VISITS */ null,
        /* PAUSE_READING */ null,
        /* PAYMENT_METHOD */ null,
        /* PAYROLL */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_TITLE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE */ null,
        /* PAYSTUB */ null,
        /* PAYSTUBS */ null,
        /* PAY_ME_NOW */ null,
        /* PAY_ME_NOW_X */ null,
        /* PENDING */ "ממתין לתשובה",
        /* PENDING_APPLICATION */ "מחכה לתשובה",
        /* PENDING_APPROVAL */ null,
        /* PENDING_CONFIRMATION */ null,
        /* PENDING_ISSUES */ null,
        /* PENDING_VERIFICATION */ null,
        /* PERMANENT_VISIT_DETAILS */ "פרטים של ביקור קבוע",
        /* PERMANENT_VISIT_FROM */ "ביקור קבוע מ",
        /* PERMANENT_VISIT_TYPE */ null,
        /* PERMISSION_NEEDED_FOR_CAMERA */ null,
        /* PERMISSION_NEEDED_FOR_CAMERA_MESSAGE */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE */ null,
        /* PERMISSION_TO_CAMERA_DENIED */ null,
        /* PER_HOUR */ null,
        /* PER_SHIFT */ null,
        /* PER_VISIT */ null,
        /* PER_WEEK */ null,
        /* PHONE */ null,
        /* PHONES */ null,
        /* PHONE_CALL_SUPPORT */ null,
        /* PHOTO_LIBRARY */ null,
        /* PHYSICIAN_DETAILS */ null,
        /* PICK_A_DATE */ null,
        /* PICK_A_TIME */ null,
        /* PLAN_OF_CARE */ null,
        /* PLEASE_ASK_THE_PATIENT */ null,
        /* PLEASE_CALL_PATIENT_IN_NEXT_SCREEN */ null,
        /* PLEASE_CHAT_WITH_THE_AGENCY */ null,
        /* PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY */ null,
        /* PLEASE_CHOOSE_A_LANGUAGE */ "אנא בחר שפה",
        /* PLEASE_CHOOSE_A_TIME */ null,
        /* PLEASE_CHOOSE_DATE_BETWEEN */ null,
        /* PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES */ null,
        /* PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT */ null,
        /* PLEASE_CONFIRM_THE_TIMES_CHOSEN */ null,
        /* PLEASE_CONFIRM_YOUR_INFORMATION */ "אנא וודא את המידע שלך",
        /* PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS */ null,
        /* PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY */ null,
        /* PLEASE_CONTACT_YOUR_COORDINATOR */ null,
        /* PLEASE_ENABLE_LOCATION */ null,
        /* PLEASE_ENTER_A_VALID_PHONE_NUMBER */ null,
        /* PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME */ null,
        /* PLEASE_ENTER_PATIENT_NAME */ null,
        /* PLEASE_ENTER_THE_PATIENT_PHONE */ null,
        /* PLEASE_ENTER_YOUR_PIN_CODE */ "אנא הכנס את קוד הPIN שלך",
        /* PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED */ null,
        /* PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER */ null,
        /* PLEASE_FILL_IN_YOUR_INFORMATION */ "אנא מלא את המידע שלך",
        /* PLEASE_FILL_REQUIRED_FIELDS */ null,
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY */ null,
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY */ null,
        /* PLEASE_MARK_ALL_THE_REQUIRED_DUTIES */ null,
        /* PLEASE_NOTE */ null,
        /* PLEASE_PICK_VALID_DATES */ "אנא בחר תאריכים תקינים",
        /* PLEASE_REQUEST_EXACTLY */ null,
        /* PLEASE_SELECT_AN_OPTION */ null,
        /* PLEASE_SELECT_DATE_AND_TIME */ null,
        /* PLEASE_SELECT_THE_PATIENT_ADDRESS */ null,
        /* PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT */ null,
        /* PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW */ "אנא הכנס תמונת פרופיל על ידי לחיצת כפתור המצלמה למטה",
        /* PLEASE_SIGN_IN_AGAIN */ null,
        /* PLEASE_SPECIFY */ null,
        /* PLEASE_TAKE_A_SELFIE */ null,
        /* PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK */ null,
        /* PLEASE_TYPE_IN_YOUR_PHONE_NUMBER */ null,
        /* PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH */ "הכנס את הקוד של הסוכנות שאתה רוצה לעבוד איתה",
        /* PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER */ null,
        /* PLEASE_TYPE_THE_SMS_CODE */ "אנא הכנס את הקוד סמס",
        /* PLEASE_UPDATE_TO_OUR_NEWEST_VERSION */ "אנא עדכן לגרסא החדשה של האפליקצייה",
        /* PLEASE_UPDATE_YOUR_ADDRESS */ "אנא עדכן את הכתובת שלך",
        /* PLEASE_UPDATE_YOUR_FIRST_NAME */ "אנא עדכן את שם הפרטי שלך",
        /* PLEASE_UPDATE_YOUR_LAST_NAME */ "אנא עדכן את שם המשפחה שלך",
        /* PLEASE_WAIT */ null,
        /* PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION */ null,
        /* PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP */ null,
        /* POINTS */ "נקודות",
        /* POINTS_AND_REWARDS */ null,
        /* POSTED_DATE */ null,
        /* PREBLOCK_VISIT_EXPLANATION */ null,
        /* PRESENTATION */ null,
        /* PREVIOUS */ null,
        /* PREVIOUS_CONVERSATIONS */ null,
        /* PREVIOUS_WINNERS */ null,
        /* PRE_TAXES */ null,
        /* PRICE */ null,
        /* PRINCIPAL_DIAGNOSIS */ null,
        /* PRIORITY_CODE */ null,
        /* PRIVACY_POLICY */ "מדיניות פרטיות",
        /* PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN */ "בעיה באיתור מיקום. נסה להדליק GPS, או לצאת החוצה",
        /* PROBLEM_WITH_CASE_SETTINGS */ null,
        /* PROCESSING */ null,
        /* PROFESSIONAL_TYPE */ "מקצוע",
        /* PROFILE */ null,
        /* PROGRESS */ null,
        /* PROXY_FIRST_NAME */ null,
        /* PROXY_LAST_NAME */ null,
        /* PROXY_PHONE */ null,
        /* PULSE */ null,
        /* QUESTION */ null,
        /* QUESTIONS */ null,
        /* QUESTIONS_TO_COPY_FROM */ "שאלות להעתקה",
        /* QUESTION_NUMBER */ null,
        /* QUESTION_REJECTED */ null,
        /* QUIT */ null,
        /* RAFFLE_ENDED */ null,
        /* RAFFLE_INFO_1_DESCRIPTION */ null,
        /* RAFFLE_INFO_1_TITLE */ null,
        /* RAFFLE_INFO_2_DESCRIPTION */ null,
        /* RAFFLE_INFO_2_TITLE */ null,
        /* RAFFLE_INFO_3_DESCRIPTION */ null,
        /* RAFFLE_INFO_3_TITLE */ null,
        /* RAFFLE_INFO_4_DESCRIPTION */ null,
        /* RAFFLE_INFO_4_TITLE */ null,
        /* RAFFLE_NOW */ null,
        /* RAFFLE_PRIZE */ null,
        /* RANK_ACHIEVED */ null,
        /* REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION */ null,
        /* READY_FOR_YOUR_NEXT_TRAINING */ null,
        /* READY_TO_CLOCK_IN */ null,
        /* READY_TO_CLOCK_OUT */ null,
        /* READ_AND_CONFIRM */ "קרא ותאשר",
        /* READ_ONLY_MODE */ null,
        /* READ_TEXT */ null,
        /* REASON */ null,
        /* RECENT_VISITS */ null,
        /* RECOMMENDED */ null,
        /* RECRUITMENT_MAIN_1 */ null,
        /* RECRUITMENT_MAIN_1_2 */ null,
        /* RECRUITMENT_MAIN_2 */ null,
        /* RECRUITMENT_MAIN_2_1 */ null,
        /* RECRUITMENT_MAIN_3 */ null,
        /* RECRUITMENT_MAIN_4 */ null,
        /* REFERRAL_CODE */ "קוד הפניה",
        /* REFER_ME */ "הפנה אותי!",
        /* REGISTRATION */ null,
        /* REGULAR_PAY */ null,
        /* REJECT */ "דחה",
        /* REJECTED */ "נדחה",
        /* REJECT_THIS_TASK */ null,
        /* REJECT_THIS_VISIT */ null,
        /* REMAINED */ null,
        /* REMAINING */ null,
        /* REMIND_ME_LATER */ null,
        /* REMOVE */ null,
        /* REMOVE_PAGE */ null,
        /* REMOVE_TASK */ null,
        /* REOPENED */ null,
        /* REPLAY */ null,
        /* REQUEST */ "לבקש",
        /* REQUESTED */ "בקשה נשלחה",
        /* REQUESTED_LABEL_IN_CASES_LIST */ null,
        /* REQUESTED_TIMES */ null,
        /* REQUESTED_VISIT_CANCEL_EXPLANATION */ null,
        /* REQUESTING_REFERENCE_RESPONSE */ null,
        /* REQUEST_AGENCIES_MEMBERSHIP */ "בקש להצטרף לסוכנות",
        /* REQUEST_AGENCY */ null,
        /* REQUEST_AGENCY_MEMBERSHIP */ null,
        /* REQUEST_DETAILS */ "פרטי הבקשה",
        /* REQUEST_FOR_APPOINTMENT */ "בקש שעה",
        /* REQUEST_FRIENDSHIP */ "בקש חברות",
        /* REQUEST_MORE_VISITS */ "בקש עוד ביקורים",
        /* REQUEST_MORE_VISITS_MESSAGE */ null,
        /* REQUEST_NUMBER_SHIFTS */ null,
        /* REQUEST_SELECTED_SHIFT */ null,
        /* REQUEST_SELECTED_SHIFTS */ null,
        /* REQUEST_SHIFTS */ null,
        /* REQUEST_SINGLE_SHIFT */ null,
        /* REQUEST_THE_TIMES_YOU_WANT */ null,
        /* REQUEST_THIS_VISIT */ null,
        /* REQUEST_TO */ "בקש ל",
        /* REQUEST_VISIT */ "בקש את הביקור",
        /* REQUIRED */ null,
        /* REQUIRED_DOCUMENTS */ null,
        /* REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC */ null,
        /* REQUIRED_PATIENT_DOCUMENT_TEXT */ null,
        /* REQUIRED_TASKS */ null,
        /* REQUIREMENTS */ null,
        /* RESCHEDULE */ "קבע מועד חדש",
        /* RESCHEDULED_SUCCESSFULLY */ null,
        /* RESCHEDULE_IN_THE_PAST_ERROR */ null,
        /* RESCHEDULE_REQUESTS */ "בקשות קביעת מועד חדש",
        /* RESET_PIN_CODE_MESSAGE */ null,
        /* RESPIRATION_RATE */ null,
        /* RESUBMISSION_BANNER_TITLE */ null,
        /* RETAKE */ null,
        /* RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION */ null,
        /* RETRY */ "נסה שוב",
        /* REVIEW_PRIVACY_POLICY */ null,
        /* REVIEW_TASK */ null,
        /* REVIEW_TASKS */ null,
        /* RE_ENTER_YOUR_PIN_CODE */ "הכנס שוב את קוד הPIN שלך",
        /* RN_FLEXIBLE_SHOWCASE_TEXT */ null,
        /* RN_FLEX_EXPLANATION_PREFIX */ null,
        /* RN_FLEX_REQUESTED_EXPLANATION */ null,
        /* RN_FLEX_REQUESTED_EXPLANATION_LINE_2 */ null,
        /* RN_PATIENT_CONTACT_EXPLANATION */ null,
        /* RN_SIGN_HERE */ "אחות חותמת כאן",
        /* ROUTING_NUMBER */ null,
        /* ROUTING_NUMBR */ null,
        /* SAFETY_AND_HEALTH */ null,
        /* SAVE */ null,
        /* SAVE_FOR_LATER */ null,
        /* SCAN_AND_UPLOAD_FILES */ "סריקה והעלאת קבצים",
        /* SCAN_A_PHOTO */ null,
        /* SCAN_DOCUMENT */ null,
        /* SCAN_NEW_DOCUMENT */ null,
        /* SCAN_WITH_CAMERA */ null,
        /* SCHEDULE */ null,
        /* SCHEDULED */ null,
        /* SCHEDULED_DATE */ null,
        /* SCHEDULED_FOR */ null,
        /* SCHEDULED_VISIT_COMPLETE */ null,
        /* SCHEDULED_VISIT_NOT_FOUND */ "המשמרת לא נמצאה, בבקשה פנו לסוכנות",
        /* SCHEDULE_CONFIRMATION */ null,
        /* SCHEDULE_FOR */ null,
        /* SCHEDULE_TASK */ null,
        /* SCHEDULING_PROBLEM */ null,
        /* SCREENING */ null,
        /* SCREENING_FOR */ null,
        /* SEARCH */ null,
        /* SEARCH_AGENCY */ "חפש סוכנות",
        /* SEARCH_FOR_MEDICATIONS */ null,
        /* SEARCH_NEARY_VISITS */ null,
        /* SEARCH_PATIENT */ null,
        /* SECOND_SHIFT */ null,
        /* SECTION_ALREADY_COMPLETED */ null,
        /* SECTION_COMPLETED_PROMPT */ null,
        /* SECTION_LOCKED_PROMPT */ null,
        /* SEE_ALL */ null,
        /* SEE_ALL_CONVERSATIONS */ null,
        /* SEE_IN_MAPS */ null,
        /* SEE_LIST_OF_VISITS */ "הראה לי רשימה של ביקורים",
        /* SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT */ null,
        /* SEE_YOUR_PROGRESS */ null,
        /* SELECT */ null,
        /* SELECTED */ null,
        /* SELECTED_VISIT */ null,
        /* SELECT_ALL */ "בחר הכל",
        /* SELECT_CERTIFICATE */ null,
        /* SELECT_DATE */ "בחר תאריך",
        /* SELECT_DATE_AND_TIME */ null,
        /* SELECT_DOCUMENT */ null,
        /* SELECT_DX_CODE */ null,
        /* SELECT_FROM_LIST */ null,
        /* SELECT_PERTINENT_DIAGNOSIS */ null,
        /* SELECT_PHYSICIAN */ null,
        /* SELECT_PRINCIPAL_DIAGNOSIS */ null,
        /* SELECT_SHIFTS */ null,
        /* SELECT_START_TIME */ null,
        /* SELECT_SURGICAL_PROCEDURE */ null,
        /* SELECT_TIME */ null,
        /* SELECT_TIME_SLOT */ null,
        /* SELECT_TIME_SLOT_INFO */ null,
        /* SELECT_VISITS_FOR_INSTAPAY */ null,
        /* SELECT_VISIT_DURATION */ null,
        /* SELECT_YOUR_SCHEDULE */ null,
        /* SELFIE_WITH_PATIENT */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT */ null,
        /* SEND_A_MESSAGE */ null,
        /* SEND_EMAIL */ null,
        /* SEND_REPORT */ null,
        /* SEND_US_A_MAIL */ "שלח לנו מייל",
        /* SEPTEMBER */ null,
        /* SETTINGS */ "הגדרות",
        /* SETTINGS_AND_INFO */ null,
        /* SET_DOCUMENT_EXPIRY_DATE */ null,
        /* SET_EXPIRATION_DATE */ null,
        /* SET_YOUR_4_DIGIT_PIN_CODE */ "בחר קוד PIN באורך 4 ספרות",
        /* SHARE */ null,
        /* SHARE_IDEAS_AND_GET_A_CHANCE */ null,
        /* SHARE_REFERENCE_LINK */ null,
        /* SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP */ null,
        /* SHARE_WITH_YOUR_FRIENDS */ null,
        /* SHIFT */ null,
        /* SHIFTS */ null,
        /* SHIFTS_DETAILS */ null,
        /* SHIFT_HAS_FINISHED_IN */ null,
        /* SHIFT_HAS_STARTED_IN */ null,
        /* SHOULD_BE_HERE */ null,
        /* SHOW_ALL_TASKS */ null,
        /* SHOW_DETAILS */ null,
        /* SHOW_LESS */ null,
        /* SHOW_ME_CASES_IN_THE_NEXT */ null,
        /* SHOW_ME_IN */ "הצג לי ב",
        /* SHOW_MORE */ null,
        /* SHOW_OLD_PLAN_OF_CARE */ "תראה פלאן אוף קאר ישן",
        /* SHOW_TASKS_THAT_REQUIRE_FIXES */ null,
        /* SHOW_US_YOUR_SMILE */ null,
        /* SIGNATURES */ null,
        /* SIGNATURE_REQUIRED */ null,
        /* SIGN_DECLINATION_FORM */ null,
        /* SIGN_HERE */ null,
        /* SIGN_IN */ "התחבר",
        /* SIGN_ORIENTATION_VIDEO */ null,
        /* SIGN_ORIENTATION_VIDEO_ERR */ null,
        /* SIGN_OUT */ "התנתק",
        /* SIGN_UP_FREE */ null,
        /* SIGN_UP_ITS_FREE */ null,
        /* SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE */ null,
        /* SINGLE_FLEXIBLE_VISIT_EXPLANATION */ null,
        /* SINGLE_VISIT_DETAILS */ "פרטים של ביקור בודד",
        /* SINGLE_VISIT_FROM */ "ביקור בודד מ",
        /* SINGLE_VISIT_TYPE */ null,
        /* SIXTY_SECONDS_AND_YOU_ARE_DONE */ null,
        /* SKIP */ "דלג",
        /* SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION */ null,
        /* SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS */ null,
        /* SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN */ null,
        /* SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES */ null,
        /* SLIDE_MAIN_INFO_GO_NEXT_SCREENS */ null,
        /* SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW */ null,
        /* SLIDE_STEP_X_OF_COUNT */ null,
        /* SMILE_FOR_US */ null,
        /* SOCIAL */ "סוצ׳ל",
        /* SOCIAL_MEDIA */ null,
        /* SOMETHING_WENT_WRONG */ null,
        /* SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS */ null,
        /* SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM */ null,
        /* SOME_TASKS_NEED_FIXES */ null,
        /* SORRY */ null,
        /* SORT */ null,
        /* SPECIFIC_DAYS */ null,
        /* SPEECH_RECOGNITION */ null,
        /* SPLIT_SHIFTS_VISIT */ null,
        /* SPREAD_THE_WORD */ "תפיץ את המילה",
        /* STAGE_APPROVED_MESSAGE */ null,
        /* STAGE_AWAITING_APPROVAL */ null,
        /* STAGE_COMPLETED_MESSAGE */ null,
        /* STAGE_X_OF_TOTAL_STAGES */ null,
        /* START */ null,
        /* STARTING_AT */ null,
        /* STARTS */ "מתחיל",
        /* STARTS_NEXT_WEEK */ null,
        /* STARTS_TODAY_IN */ null,
        /* START_APPLICATION */ null,
        /* START_A_SURVEY */ null,
        /* START_DATE */ "תאריך התחלה",
        /* START_FILLING */ null,
        /* START_NOW */ null,
        /* START_SHIFT */ null,
        /* START_TIME */ "שעת התחלה",
        /* START_USING_MEDFLYT_PASSPORT */ null,
        /* START_WATCHING */ null,
        /* START_WATCHING_ORIENTATION_VIDEOS */ null,
        /* START_WORKING */ null,
        /* STATUS */ null,
        /* STAY_ON_TRACK */ null,
        /* STAY_ON_TRACK_1_ANSWER */ null,
        /* STAY_ON_TRACK_1_QUESTION */ null,
        /* STAY_ON_TRACK_2_ANSWER */ null,
        /* STAY_ON_TRACK_2_QUESTION */ null,
        /* STAY_ON_TRACK_3_ANSWER */ null,
        /* STAY_ON_TRACK_3_QUESTION */ null,
        /* STAY_ON_TRACK_4_ANSWER */ null,
        /* STAY_ON_TRACK_4_QUESTION */ null,
        /* STAY_ON_TRACK_DESCRIPTION */ null,
        /* STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS */ null,
        /* STAY_TUNED_FOR_MORE_VISITS */ "המשך לעקוב בשביל ביקורים נוספים",
        /* STAY_TUNED_FOR_THE_NEXT_RAFFLE */ null,
        /* STILL_WAITING_REFERENCE_ANSWER */ null,
        /* STOP */ null,
        /* STREAK_BREAK */ null,
        /* STREAK_BREAK_MESSAGE */ null,
        /* STREAK_BREAK_MESSAGE_2 */ null,
        /* SUBMIT */ "שלח",
        /* SUBMITTED_AT */ null,
        /* SUBMITTED_DOCUMENTS */ null,
        /* SUBMITTED_MANUALLY */ null,
        /* SUBMIT_AFTER */ null,
        /* SUBMIT_AT */ "הגש לתאריך",
        /* SUBMIT_BY */ null,
        /* SUBMIT_DUTIES */ null,
        /* SUBMIT_DUTIES_BEFORE_CLOCK_OUT */ null,
        /* SUBMIT_FORM */ null,
        /* SUBMIT_FORMS */ null,
        /* SUBMIT_MANUAL_TIMESHEET */ null,
        /* SUBMIT_REQUIRED */ null,
        /* SUBMIT_TEST */ null,
        /* SUBMIT_TIMESHEET */ null,
        /* SUBMIT_WITH_SCHEDULED_DATE */ null,
        /* SUBMIT_WITH_TODAY_DATE */ null,
        /* SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT */ null,
        /* SUBMIT_YOUR_SIGN */ null,
        /* SUBMIT_YOUR_SIGNATURE */ null,
        /* SUCCESS */ null,
        /* SUCCESSFULLY_CLOCKED_IN */ null,
        /* SUCCESSFULLY_CLOCKED_OUT */ null,
        /* SUCCESSFULY_REQUESTED */ "ביקש בהצלחה!",
        /* SURGICAL_PROCEDURE */ null,
        /* SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS */ null,
        /* SWITCH_VIEW */ null,
        /* TAKE_A_DIFFERENT_PHOTO */ null,
        /* TAKE_A_PHOTO */ "הוסף תמונת פרופיל",
        /* TAKE_A_SURVEY */ null,
        /* TAKE_ME_TO_CASE_SETTINGS */ "קח אותי להגדרות ביקור",
        /* TAKE_PHOTO */ null,
        /* TAKE_THIS_TASK */ null,
        /* TAP_HERE_TO_VIEW */ null,
        /* TAP_TO_CANCEL */ "לחץ לביטול",
        /* TAP_TO_CHANGE_CASE_SETTINGS */ "לחץ לשינוי הגדרות הביקורים",
        /* TASK */ null,
        /* TASKS */ null,
        /* TASK_ALREADY_ASSIGNED */ null,
        /* TASK_COMPLETED_SUCCESSFULLY */ "מזל טוב 🎉💪🏻 סיימת את המשימה.",
        /* TASK_INFORMATION */ null,
        /* TASK_SCHEDULED */ null,
        /* TASK_SCHEDULED_MESSAGE */ null,
        /* TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE */ null,
        /* TECHNICAL_SUPPORT */ null,
        /* TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES */ "ספר לנו למה אתה לא מעוניין כדי שנוכל להתאים לך ביקורים יותר רלוונטיים",
        /* TELL_US_YOUR_AGENY_DESCRIPTION */ null,
        /* TEMPERATURE */ null,
        /* TEN_DOLLAR_STARBUCKS_GIFT_CARD */ null,
        /* TERMINATED */ "פוטר",
        /* TERMS_OF_MEDFLYT_PRIVACY_POLICY */ null,
        /* TERMS_OF_USE */ "תנאי שימוש",
        /* TEST */ null,
        /* TESTS */ null,
        /* TEST_COMPLETED */ null,
        /* TEST_FAILED */ null,
        /* TEST_REQUIRED */ null,
        /* THANKS */ null,
        /* THANK_YOU */ null,
        /* THANK_YOU_FOR_YOUR_FEEDBACK */ null,
        /* THATS_ME */ null,
        /* THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION */ null,
        /* THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS */ null,
        /* THERE_ARE_NO_AGENCIES_YET */ "אין עדיין סוכניות",
        /* THERE_ARE_NO_ASSIGNED_CASES */ null,
        /* THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION */ "יש בעיה בחיבור אינטרנט שלך",
        /* THERE_SEEMS_TO_BE_NOTHING_HERE */ "אין כאן כלום...",
        /* THE_AWARDS_ARE_COMING_SOON */ null,
        /* THE_BEST_PLACE_FOR_CAREGIVERS */ null,
        /* THE_DUTY_SHEET_HAS_BEEN_SUBMITTED */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON */ null,
        /* THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS */ null,
        /* THE_NEXT_WINNERS_ANNOUNCEMENT */ "ההודעה על הזוכה הבא",
        /* THE_SELECTED_DATE_IS_EARLIER_THAN */ null,
        /* THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS */ null,
        /* THE_VISIT_HAS_NOT_STARTED_YET */ null,
        /* THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS */ null,
        /* THIS_BUNDLE_INCLUDES */ null,
        /* THIS_CONVERSATION_HAS_BEEN_RESOLVED */ null,
        /* THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK */ null,
        /* THIS_FIELD_IS_CURRENTLY_DISABLED */ null,
        /* THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT */ "זה ביקור ישן, אתה לא יכול להתחיל/לסיים אותו",
        /* THIS_IS_A_FUTURE_VISIT */ null,
        /* THIS_IS_A_LIVE_CLASS_SESSION */ null,
        /* THIS_MAY_TAKE_UP_TO_X_SECONDS */ null,
        /* THIS_PATIENT_BELONGS_TO_AGENCY */ null,
        /* THIS_PATIENT_HAS_NO_PHONE_NUMBERS */ null,
        /* THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER */ null,
        /* THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP */ null,
        /* THIS_VISIT_CAN_BE_PERFORMED_BETWEEN */ null,
        /* THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE */ null,
        /* THIS_VISIT_IS_FOR_DIFFERENT_AGENCY */ null,
        /* THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET */ "הביקור הוא העתיד, אתה לא יכול להתחיל אותו עדיין",
        /* THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY */ null,
        /* THIS_WILL_MARK_THE_VISIT_AS_MISSED */ null,
        /* TIME */ null,
        /* TIMESHEET_SUBMITTED */ null,
        /* TIME_ESTIMATION */ null,
        /* TIME_FRAME */ null,
        /* TIME_LEFT */ null,
        /* TIME_VARIES */ "זמנים שונים",
        /* TO */ null,
        /* TODAY */ null,
        /* TODAYS_DATE */ null,
        /* TOKENS */ null,
        /* TOO_MANY_HOURS */ "יותר מדי שעות",
        /* TOO_MANY_SHIFTS */ null,
        /* TOO_MANY_SHIFTS_MESSAGE */ null,
        /* TOP_CAREGIVERS_IN_YOUR_AREA */ "קיירגיברס מובילים באיזור שלך",
        /* TOTAL_EARNED */ null,
        /* TOTAL_SPENT */ null,
        /* TO_FILL_IN_A_FORM_INSTEAD */ null,
        /* TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT */ null,
        /* TO_SEE_THIS_TASK_GO_TO_ASSIGNED */ null,
        /* TO_SEE_THIS_VISIT_GO_TO */ "כדי לראות את הביקור הזה לך ל:",
        /* TO_UPLOAD_A_FILE_INSTEAD */ null,
        /* TO_WIN_AN_IPHONE12 */ null,
        /* TRAINING */ null,
        /* TRAININGS_FOR */ null,
        /* TRAINING_CENTER */ null,
        /* TRAINING_CENTER_REMINDERS */ null,
        /* TRY_AGAIN */ null,
        /* TYPE_AGENCY_CODE */ null,
        /* TYPE_MESSAGE */ "הקלד הודעה",
        /* TYPE_YOUR_ADDRESS */ null,
        /* UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET */ null,
        /* UNANSWERED_LAST_SECTION_FOR_NOW */ null,
        /* UNAUTHORIZED */ null,
        /* UNAVAILABLE_LOCATION_SERVICES_MESSAGE */ null,
        /* UNDER_REVIEW */ null,
        /* UNDO */ null,
        /* UNIQUE_ERROR_CODE */ null,
        /* UNSCHEDULE */ null,
        /* UNSCHEDULE_TASK */ null,
        /* UNSPECIFIED */ null,
        /* UNTIL */ null,
        /* UPCOMING_VISITS */ null,
        /* UPDATED_AT */ null,
        /* UPDATE_INFORMATION */ null,
        /* UPLOAD */ null,
        /* UPLOADED */ null,
        /* UPLOADED_FILE_VIEW */ null,
        /* UPLOADING */ null,
        /* UPLOAD_A_DOCUMENT */ null,
        /* UPLOAD_A_FILE */ null,
        /* UPLOAD_DOCUMENT */ null,
        /* UPLOAD_DOCUMENTS */ "העלה מסמכים",
        /* UPLOAD_ERROR */ "שגיאה בהעלאת קובץ",
        /* UPLOAD_FILES_TO_ENSURE */ null,
        /* UPLOAD_FLU_SHOT_DOCUMENT */ null,
        /* UPLOAD_FROM_GALLERY */ null,
        /* UPLOAD_NEW_DOCUMENT */ null,
        /* UPLOAD_VIDEO */ null,
        /* UPLOAD_YOUR_FILES_TO_ENSURE */ null,
        /* UP_COMING_REASSESSMENTS */ "הערכות מחדש עתידיות",
        /* UP_TO */ null,
        /* URGENT */ null,
        /* USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY */ "משתמש זה ננעל בגלל התנהגות חשודה",
        /* VALID */ null,
        /* VERIFIED */ null,
        /* VERIFY */ null,
        /* VERIFYING */ null,
        /* VERIFY_YOUR_LOCATION */ null,
        /* VERY_URGENT */ null,
        /* VIDEO */ null,
        /* VIDEOS */ null,
        /* VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION */ null,
        /* VIDEO_COMPLETED_SUCCESSFULLY */ "מזל טוב 🎉💪🏻 סיימת לראות את הסרטון.",
        /* VIEW */ null,
        /* VIEWED */ null,
        /* VIEW_ALL */ null,
        /* VIEW_ANSWERS */ null,
        /* VIEW_CERTIFICATE */ null,
        /* VIEW_TASK */ null,
        /* VIEW_TASKS_PENDING_FOR_SCHEDULE */ null,
        /* VIEW_VISIT */ null,
        /* VIRTUAL_ID_CARD */ null,
        /* VISIT */ null,
        /* VISITS */ "ביקורים",
        /* VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER */ null,
        /* VISITS_NEXT_MONTH */ null,
        /* VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* VISITS_PER_WEEK */ null,
        /* VISITS_WITH_ISSUES */ null,
        /* VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE */ null,
        /* VISIT_BY */ "ביקור של",
        /* VISIT_CHAT */ "צ׳אט של הביקור",
        /* VISIT_COMPLETE */ null,
        /* VISIT_COMPLETED_SUCCESSFULLY */ null,
        /* VISIT_COUNTS */ null,
        /* VISIT_COUNTS_DESCRIPTION */ null,
        /* VISIT_DATE */ "תאריך ביקור",
        /* VISIT_DATES */ null,
        /* VISIT_DETAILS */ null,
        /* VISIT_DURATION */ null,
        /* VISIT_INFORMATION */ null,
        /* VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU */ null,
        /* VISIT_LASTING */ "ביקור שאורכו",
        /* VISIT_NEXT_MONTH */ null,
        /* VISIT_NOTIFICATIONS_OFF */ "הודעות על ביקורים - מכובה",
        /* VISIT_NOTIFICATIONS_ON */ "הודעות על ביקורים - דלוק",
        /* VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE */ null,
        /* VISIT_NO_LONGER_AVAILABLE */ "ביקור כבר לא פנוי",
        /* VISIT_RATE_REQUEST_CONFIRMATION */ null,
        /* VISIT_REMINDERS */ null,
        /* VISIT_REQUEST_CONFIRMATION_WARNING */ null,
        /* VISIT_SCHEDULE */ null,
        /* VISIT_STARTED_AT */ null,
        /* VISIT_STARTED_MISSING_CLOCK_IN */ null,
        /* VISIT_STARTS_AT */ null,
        /* VISIT_SUCESSFULLY_CANCELED */ null,
        /* VISIT_TIME_ADJUSTMENT */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_EARLY */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_LATE */ null,
        /* VISIT_TOO_SHORT */ null,
        /* VISIT_TYPE */ null,
        /* VISIT_WITH */ null,
        /* VOUCHER */ null,
        /* WAITING_FOR_APPROVAL */ null,
        /* WAITING_TO_BE_SCHEDULED */ null,
        /* WARNING */ "אזהרה!",
        /* WAS_DUE_BETWEEN */ null,
        /* WAS_DUE_ON */ null,
        /* WATCHED */ null,
        /* WATCH_HOW_IT_WORKS */ null,
        /* WATCH_REQUIRED */ null,
        /* WATCH_TRAINING_VIDEOS_TO_COMPLETE */ null,
        /* WEEKLY_DETAILS */ null,
        /* WELCOME */ null,
        /* WELCOME_BACK */ null,
        /* WELCOME_TO_CARE_MOMENTS */ null,
        /* WELCOME_TO_MEDFLYT */ null,
        /* WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE */ null,
        /* WELL_BE_IN_TOUCH_SHORTLY */ null,
        /* WERE_YOU_REFERRED_BY_SOMEONE */ "האם מישהו הפנה אותך?",
        /* WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM */ null,
        /* WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR */ null,
        /* WE_COULDNT_FIND_YOUR_AGENCY */ null,
        /* WE_GOT_YOUR_CONFIRMATION */ null,
        /* WE_GOT_YOUR_RESPONSE_WAIT_HH_MM */ null,
        /* WE_HAVE_ONE_MATCHING_ACCOUNT */ null,
        /* WE_HAVE_X_MATCHING_ACCOUNTS */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT */ null,
        /* WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT */ null,
        /* WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON */ null,
        /* WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE */ null,
        /* WHAT_BENEFITS_CAN_YOU_GET */ null,
        /* WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK */ null,
        /* WHAT_WOULD_YOU_LIKE_TO_DO_FIRST */ null,
        /* WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT */ null,
        /* WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR */ null,
        /* WHOOPS */ null,
        /* WHOS_THE_LUCKY_ONE */ null,
        /* WILL_BEGIN_SHORTLY */ null,
        /* WILL_EXPIRE_IN_DAYS */ null,
        /* WILL_EXPIRE_TOMORROW */ null,
        /* WINNER_ANNOUNCED_IN */ null,
        /* WITH_CAREGIVERS */ "לקיירגיברס",
        /* WORKING_WITH_AGENCY */ null,
        /* WRONG_DATES_SELECTION */ null,
        /* WRONG_PHONE_NUMBER */ null,
        /* WRONG_PIN */ "קוד PIN שגוי",
        /* X_DAYS_SELECTED */ null,
        /* X_DAYS_TO_COMPLETE */ null,
        /* X_DAYS_TO_SELECT */ null,
        /* X_HOURS_SELECTED */ null,
        /* X_HOURS_TO_SELECT */ null,
        /* YAY_YOU_WERE_ASSIGNED_TO_A_VISIT */ null,
        /* YEAR */ null,
        /* YEARS_OLD */ null,
        /* YES */ "כן",
        /* YES_ADJUST_TIMES */ null,
        /* YES_DELETE */ null,
        /* YES_I_AM_SURE */ null,
        /* YES_OVERRIDE_FORM */ null,
        /* YES_REQUEST_ANYWAY */ null,
        /* YES_SCHEDULE_VISIT */ null,
        /* YES_THATS_ME */ null,
        /* YES_UPDATE_ALL */ null,
        /* YOURE_ALL_DONE_LETS_GET_YOU_WORKING */ null,
        /* YOURE_IN_THE_RAFFLE */ null,
        /* YOURE_NOT_IN_THE_RAFFLE */ null,
        /* YOURSELF */ null,
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD */ null,
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE */ null,
        /* YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS */ null,
        /* YOUR_ANSWER_IS_CORRECT */ null,
        /* YOUR_ANSWER_IS_INCORRECT */ null,
        /* YOUR_COMPLIANCE */ null,
        /* YOUR_COMPLIANCE_ITEM_HAS_EXPIRED */ null,
        /* YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS */ null,
        /* YOUR_FILE_IS_BEING_UPLOADED */ "הקובץ בהעלאה",
        /* YOUR_IN_SERVICE_IS_DUE_IN_DAYS */ null,
        /* YOUR_IN_SERVICE_IS_OVER_DUE */ null,
        /* YOUR_MOBILE */ "מספר טלפון שלך",
        /* YOUR_REFERERAL_CODE */ "קוד ההפניה שלך",
        /* YOUR_TASK_HAS_BEEN_SCHEDULED_FOR */ null,
        /* YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY */ null,
        /* YOUVE_BEEN_SUCCESSFULLY_REFERRED */ "אתה הופנית בהצלחה!",
        /* YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ null,
        /* YOU_ALREADY_FAILED */ null,
        /* YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT */ "כבר יש לך ביקור בזמנים האלה",
        /* YOU_ALREADY_REQUESTED_THIS_VISIT */ null,
        /* YOU_ALREADY_SUCCEEDED */ null,
        /* YOU_ARE_ALL_SET */ null,
        /* YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION */ null,
        /* YOU_ARE_COMPLIANT */ null,
        /* YOU_ARE_EXEMPT_FROM_THIS_TEST */ null,
        /* YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD */ null,
        /* YOU_ARE_NOT_COMPLIANT */ null,
        /* YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM */ null,
        /* YOU_ARE_OUT_OF_COMPLIANCE */ null,
        /* YOU_ARE_X_DAYS_LATE */ null,
        /* YOU_CANNOT_EDIT_YOUR_ANSWERS */ null,
        /* YOU_CANT_EDIT_VISIT_WITH_CICO */ null,
        /* YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES */ null,
        /* YOU_CANT_SIGN_BEFORE_ALL_ANSWERED */ null,
        /* YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME */ null,
        /* YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED */ null,
        /* YOU_CAN_CONTINUE_TO_NEXT_SECTION */ null,
        /* YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY */ null,
        /* YOU_DIDNT_ANSWER_ALL_QUESTIONS */ null,
        /* YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN */ "לא הכנסת את אותו הקוד. אנא נסה שנית",
        /* YOU_DONT_HAVE_ANY_CASES_YET */ null,
        /* YOU_DONT_HAVE_ANY_PATIENTS_YET */ null,
        /* YOU_GET_POINTS */ null,
        /* YOU_GOT_THE_CASE */ null,
        /* YOU_GOT_THE_CERTIFICATE */ null,
        /* YOU_HAVENT_CLOCKED_IN_YET */ null,
        /* YOU_HAVENT_CLOCKED_OUT_YET */ null,
        /* YOU_HAVENT_UPLOADED_ANYTHING_YET */ null,
        /* YOU_HAVE_COMPLETED_THIS_TEST */ null,
        /* YOU_HAVE_HH_MM_TO_CONFIRM_IT */ null,
        /* YOU_HAVE_MISSING_COMPLIANCE_ITEMS */ null,
        /* YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW */ null,
        /* YOU_HAVE_NOT_WATCHED */ null,
        /* YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY */ null,
        /* YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS */ null,
        /* YOU_HAVE_ONE_ATTEMPT_LEFT */ null,
        /* YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING */ null,
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION */ null,
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING */ null,
        /* YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY */ null,
        /* YOU_HAVE_TO_ENROLL_FIRST */ null,
        /* YOU_HAVE_TO_PICK_A_CODE */ null,
        /* YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_LEFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST */ null,
        /* YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y */ null,
        /* YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING */ null,
        /* YOU_JUST_GOT_PAID */ null,
        /* YOU_JUST_GOT_PROMOTED_TO */ null,
        /* YOU_LOSE_POINTS */ null,
        /* YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS */ "אתה יכול לשנות את הגדרות הביקור שלך כדי לקבל ביקורים יותר רלוונטיים",
        /* YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE */ null,
        /* YOU_MAY_ONLY_SUBMIT_AFTER */ null,
        /* YOU_MISSED_A_SHIFT_WITHOUT_NOTICE */ null,
        /* YOU_MUST_ANSWER_ALL_THE_QUESTIONS */ null,
        /* YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT */ null,
        /* YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST */ null,
        /* YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION */ null,
        /* YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE */ null,
        /* YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT */ null,
        /* YOU_RECENTLY_WON_A_RAFFLE */ null,
        /* YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT */ null,
        /* YOU_USED_THE_CODE */ "השתמשת בקוד",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE */ null,
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS */ null,
        /* YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS */ null
    ],
    "ht": [
        /* ACCEPTED */ "Aksepte",
        /* ACCEPT_THESE_HOURS */ "Aksepte èdtan sa yo",
        /* ACCEPT_THE_VISIT_AT */ "Aksepte vizit la nan",
        /* ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY */ null,
        /* ACCOUNT_NUMBER */ "Nimewo KONT",
        /* ACCOUNT_TYPE */ "Kalite Kont",
        /* ACTIVE */ "Aktif",
        /* ACTIVE_DOCUMENT */ "Dokiman aktif",
        /* ADD */ "Ajoute",
        /* ADDITIONAL_NOTES */ "Nòt Lòt ..",
        /* ADDRESS */ "Adrès",
        /* ADDRESS2 */ "Adrès Liy 2",
        /* ADDRESS_ERROR */ "Adrès erè",
        /* ADDRESS_IS_NEAR */ "Adrès se tou pre",
        /* ADD_ANOTHER_DOCUMENT */ "Ajoute yon lòt dokiman",
        /* ADD_ANOTHER_PERTINENT_DIAGNOSIS */ "Ajoute yon lòt dyagnostik enpòtan",
        /* ADD_IMAGE */ "Ajoute Imaj",
        /* ADD_NEW_MEDICATION */ "Ajoute nouvo medikaman",
        /* ADD_NOTES */ "Ajoute nòt",
        /* ADD_NOTE_TO_PATIENT_PROFILE_BUTTON */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_TITLE */ null,
        /* ADD_PHYSICIAN */ null,
        /* ADD_YOUR_SIGNATURE */ "Ajoute siyati ou",
        /* ADVANCED_DIRECTIVES */ null,
        /* AGENCIES_CONTACT */ "Ajans yo ap kontakte ou yon ti tan",
        /* AGENCY */ "Ajans",
        /* AGENCY_CODE */ "Kòd ajans",
        /* AGENCY_COORDINATOR */ "Koòdonatè Ajans",
        /* AGENCY_DETAILS */ "Detay Ajans lan",
        /* AGENCY_HANDBOOK */ "Manyèl Ajans",
        /* AGENCY_ISSUES */ null,
        /* AGENCY_NAME */ "Non ajans lan",
        /* AGENCY_NOTIFICATIONS */ "Notifikasyon ajans",
        /* AGENCY_NOT_FOUND */ "Ajans pa jwenn",
        /* AGREE_TO_MEDFLYT_TERMS */ "Pa klike sou apwouve, ou dakò ou te li epi mwen dakò ak kondisyon ki nan Meflyt Privacy Policy",
        /* AIDE */ null,
        /* AIRPODS */ "AirPods",
        /* ALLERGIES */ "Alèji",
        /* ALLOW_ACCESS_TO_MY_LOCATION */ "Pèmèt aksè nan kote mwen an",
        /* ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP */ "Yo nan lòd yo wè ka tou pre ou, tanpri ale nan anviwònman telefòn ou epi bay Medflyt pèmisyon jwenn aksè nan kote ou ye a.",
        /* ALL_CHANGES_SAVED */ "Tout chanjman sove",
        /* ALL_DAY */ "tout jounen an",
        /* ALL_DONE */ "Tout fè!",
        /* ALL_TRANSACTIONS */ null,
        /* ALL_VERIFIED_ITEMS */ null,
        /* ALREADY_CLOCKED_IN */ "Deja reusi nan.",
        /* ALREADY_CLOCKED_IN_ANOTHER_VISIT */ "Ou deja reusi nan yon lòt vizit.",
        /* ALREADY_CLOCKED_OUT */ "Deja reusi soti.",
        /* ALREADY_HAVE_AN_ACCOUNT */ "Deja genyen yon kont",
        /* AND_AMPERSAND */ "&",
        /* ANSWERED */ "Reponn",
        /* ANSWERED_AT */ "Reponn nan",
        /* ANSWER_INCOMPLETE_QUESTIONS */ "Reponn kesyon enkonplè",
        /* ANY_DURATION */ "Nenpòt dire",
        /* AN_ERROR_HAS_OCCURED */ "Yon erè te rive.",
        /* AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET */ "Yon erè ki te fèt pandan y ap soumèt fwa ou.",
        /* APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES */ "Apple pa patisipe nan okenn fason ak konpetisyon an oswa konkou",
        /* APPLICATION_DONE */ "Aplikasyon fè!",
        /* APPROVE */ "Konsanti",
        /* APPROVED */ "Apwouve",
        /* APPROVE_THIS_TASK */ "Apwouve travay sa a",
        /* APPROVE_THIS_VISIT */ "Apwouve vizit sa a",
        /* APRIL */ "Avril",
        /* ARENT_YOU_MISSING_SOMETHING */ null,
        /* ARE_YOU */ "Ou sè",
        /* ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY */ "Èske w ap travay kounye a ak yon ajans?",
        /* ARE_YOU_SURE */ null,
        /* ARE_YOU_SURE_REQUEST_FAR_VISIT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK */ "Èske ou sèten ou vle apwouve travay sa a?",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST */ "Èske ou sèten ou vle anile demann sa a?",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT */ "Èske ou sèten ou vle anile vizit sa a?",
        /* ARE_YOU_SURE_YOU_WANT_TO_DELETE */ "Èske ou sèten ou vle efase",
        /* ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE */ "Èske ou sèten ou vle enskri pake sa a?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT */ "Èske ou sèten ou vle retire dokiman sa a?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE */ "Èske ou sèten ou vle retire paj sa a?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE */ "Èske ou sèten ou vle mande sa yo",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT */ "Èske ou sèten ou vle mande vizit sa a?",
        /* ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT */ "Èske ou sèten ou vle siyen?",
        /* ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK */ "Èske ou sèten ou vle unschedule travay sa a",
        /* ASSIGNED */ "Yo deside",
        /* ASSIST */ "Asiste",
        /* AS_NEEDED */ "Jan sa nesesè",
        /* AS_REQUESTED_BY_THE_PATIENT */ "Jan pasyan an mande",
        /* ATTACH_A_DOCUMENT */ "Tache yon dokiman",
        /* AUGUST */ "Aut",
        /* AUTHENTICATION_FAILED */ "Otantifikasyon echwe",
        /* AUTH_VERIFICATION_FAIL_EXAPLINED */ "Nou pa t 'kapab verifye idantite ou. Tanpri rive jwenn youn nan ajans ou yo pou asistans.",
        /* AUTOPLAY */ "Atik nan pwochen ap kòmanse nan",
        /* AVAILABILITY */ "Disponibilite",
        /* AVAILABLE */ "Disponib",
        /* AVAILABLE_CARE_POINTS */ "Pwen swen ki disponib",
        /* AVAILABLE_ON_THE_FOLLOWING_DAYS */ "Disponib nan jou sa yo",
        /* AVAILABLE_SHIFTS */ "Orè ki disponib",
        /* AVAILABLE_VISITS */ "Vizit ki disponib",
        /* AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK */ null,
        /* AWAITING_PATIENT_CONTACT */ "Ap tann kontak",
        /* A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT */ "Yon plan swen deja egziste pou pasyan sa a",
        /* A_VERIFICATION_CODE_IS_BEING_SENT_TO */ "Se yon kòd verifikasyon ke yo te voye bay",
        /* A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE */ "Y ap voye yon kòd verifikasyon ba ou atravè mesaj tèks",
        /* A_VISIT_BY */ "Yon vizit pa",
        /* BACK */ null,
        /* BACK_TO_ONBOARDING */ "Retounen nan onboarding",
        /* BANK_INFORMATION */ null,
        /* BANK_NAME */ "Non labank",
        /* BASICALLY_EVERY_ACTION_COUNTS */ "Fondamantalman chak aksyon konte 😊",
        /* BEFORE_SUBMITTING_THE_DUTIES */ "Anvan ou soumèt devwa yo",
        /* BEGIN_NOW */ "Kòmanse kounye a",
        /* BEST_TASK_FOR_YOU */ null,
        /* BETWEEN */ "nanmitan",
        /* BETWEEN_AND */ "ak",
        /* BIRTHDAY */ "Fèt",
        /* BLOOD_PRESSURE */ "San presyon",
        /* BOROUGH */ null,
        /* BUNDLES */ "Pake",
        /* BUNDLE_DESCRIPTION */ "Sa a pake ap mache ou nan sou nenpòt bagay ou bezwen konnen sou {pake_name} soti nan {ajans_name}.",
        /* BUNDLE_DESCRIPTION_P1 */ "Sa a pake konsiste de",
        /* BUNDLE_DESCRIPTION_P2 */ "atik. Kèk atik ta ka gen ladan tou yon tès. Tanpri gade kontni ki nesesè yo. Yon fwa ou ranpli travay ki nesesè ou pral resevwa yon sètifika. Bon chans",
        /* BUNDLE_IS_LOCKED */ "Pake se fèmen",
        /* BUNDLE_ITEM_NOT_FOUND */ "Leson fòmasyon pa jwenn",
        /* BUNDLE_NOT_FOUND */ "Kou fòmasyon pa jwenn",
        /* BUNDLE_PROGRESS */ "Pake pwogrè",
        /* BUSY_ALL_DAY */ "Okipe tout jounen an",
        /* BY */ "Pa",
        /* BY_ENROLLING_I_ACCEPT_THE */ "Pa enskri mwen aksepte la",
        /* BY_EXISTING_VISIT */ "Pa vizit ki egziste deja:",
        /* BY_PATIENT_NAME */ "Pa non pasyan:",
        /* BY_SIGNING_HERE_I_ACCEPT_THE */ "Pa siyen isit la mwen aksepte la",
        /* CALL */ "Rele",
        /* CALL_AGENCY */ "Rele ajans",
        /* CALL_HOME */ "Rele lakay ou",
        /* CALL_MOBILE */ "Rele mobil",
        /* CALL_NOW */ "Rele kounye a:",
        /* CALL_PATIENT */ "Rele Pasyan",
        /* CALL_PATIENT_CONFIRMATION */ null,
        /* CALL_PATIENT_EXPLANATION */ "Ou pral resevwa yon apèl yon ti moman apre konfime mesaj sa a.",
        /* CALL_PATIENT_HOME */ "Rele kay pasyan an",
        /* CALL_PATIENT_MOBILE */ "Rele mobil pasyan an",
        /* CALL_PATIENT_NOTE */ "Kontakte pasyan nan pwochen ekran an",
        /* CALL_SUPPORT_FOR_MORE_INFO */ "Rele Sipò pou plis enfòmasyon",
        /* CANCEL */ "Anile",
        /* CANCEL_REQUESTED_SHIFTS */ "Anile orè yo mande yo",
        /* CANCEL_VISIT */ "Anile Vizit",
        /* CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE */ "Ou pa ka edite repons ou yo nan mòd li sèlman.",
        /* CANT_CANCEL_24_HOURS_SCHEDULED_VISIT */ "Erè: Vizite se mwens pase 24 èdtan lwen",
        /* CANT_CANCEL_AT_THIS_TIME */ "Pa ka anile nan moman sa a",
        /* CANT_CLOCK_IN */ "Pa ka revèy nan",
        /* CANT_CLOCK_IN_AT_THIS_TIME */ "Pa ka revèy nan moman sa a.",
        /* CANT_CLOCK_OUT */ "Pa ka revèy soti",
        /* CANT_CLOCK_OUT_AT_THIS_TIME */ "Pa ka revèy soti nan moman sa a.",
        /* CANT_CLOCK_OUT_BEFORE_VISIT_ENDED */ "Pa ka revèy anvan vizit la te fini.",
        /* CANT_REJECT_VISIT_PENDING_STATUS */ "Ou pa ka rejte vizit ankò. Tanpri ranpli pwosesis enskripsyon an",
        /* CANT_REQUEST_JOIN_AGENCY */ "Pa ka mande yo rantre nan ajans",
        /* CANT_REQUEST_VISIT_PENDING_STATUS */ "Ou pa ka mande vizit ankò. Tanpri ranpli pwosesis enskripsyon an",
        /* CANT_SUBMIT_AN_EMPTY_FORM */ "Pa ka soumèt yon fòm vid, tanpri reponn kesyon yo.",
        /* CANT_WATCH_ON_SHIFT */ "Fòmasyon sa a enfim pandan tout orè 👀",
        /* CANT_WATCH_THIS_VIDEO */ "Pa ka gade videyo sa a",
        /* CAREBACK_CASH_BONUS */ "Careback - Bonis Lajan Kach!",
        /* CAREBACK_POINTS */ "Pwen Careback",
        /* CAREGIVER */ "Kwoke",
        /* CAREGIVER_COMPLIANCE_PASSPORT */ "Moun kap bay swen konfòmite paspò",
        /* CAREGIVER_NAME */ "Non moun kap bay swen",
        /* CAREGIVER_PHONE */ "Telefòn moun kap bay swen",
        /* CAREGIVER_SIGNATURE */ "Siyati moun kap bay swen",
        /* CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG */ "Tanpri asire w ke tou de ou menm ak pasyan an te siyen plan an nan swen",
        /* CAREGIVER_SIGNATURE_IS_REQUIRED */ "Siyati moun kap bay swen yo obligatwa",
        /* CAREGIVER_SIGNATURE_REQUIRE_MSG */ "Tanpri asire w ke ou siyen sou plan swen an",
        /* CAREGIVER_STATUS_PENDING_ERROR */ "Kapab fè aksyon paske pwofil ou toujou ap tann.",
        /* CARE_MOMENTS */ null,
        /* CASE_INFO */ "Enfòmasyon ka",
        /* CASE_IS_TOO_FAR */ "Ka twò lwen",
        /* CASE_SETTINGS */ "Anviwònman Ka",
        /* CATALOGUE */ "Katalòg",
        /* CERTIFICATION */ "Sètifikasyon",
        /* CERTIFICATIONS */ "Sètifikasyon",
        /* CHANGE */ "Chanjman",
        /* CHANGES_TO_MY_VISITS */ "Chanjman nan vizit mwen yo",
        /* CHANGES_WERE_SAVED_IN_THE_CLOUD */ "Tout chanjman yo te sove nan nwaj la",
        /* CHANGE_DOCUMENT */ "Chanje Dokiman",
        /* CHANGE_OF_RANKING */ null,
        /* CHANGE_PHONE_NUMBER */ "Chanje nimewo telefòn",
        /* CHANGE_SETTINGS */ "Chanje Anviwònman",
        /* CHANGE_SHIFTS */ "Chanje orè",
        /* CHANGE_TASK_TIME */ null,
        /* CHANGE_VISIT_TIMES */ "Chanje fwa vizit",
        /* CHAT */ "Koze",
        /* CHATS */ "Gade",
        /* CHAT_MESSAGES */ "Chat mesaj",
        /* CHAT_NOT_ACTIVE_MESSAGE */ "Ou pa ka voye mesaj isit la.",
        /* CHAT_NOT_ACTIVE_TITLE */ "Chat pa aktif ankò",
        /* CHAT_WITH_AGENCY */ "Chat ak ajans",
        /* CHAT_WITH_AGENCY_ABOUT_PATIENT */ "Chat ak %s sou %s",
        /* CHAT_WITH_MEDFLYT */ "Chat ak medflyt",
        /* CHAT_WITH_OTHER_AGENCIES */ "Chat ak lòt ajans",
        /* CHAT_WITH_SUPPORT */ "Chat ak sipò",
        /* CHAT_WITH_US */ "Chat avèk nou",
        /* CHECK */ "Chèk",
        /* CHECK_AGAIN */ null,
        /* CHOOSE_ANOTHER_DATE */ "Chwazi yon lòt dat",
        /* CHOOSE_A_PHOTO */ "Chwazi yon foto",
        /* CHOOSE_A_TIME_FOR_THE_VISIT */ "Chwazi yon tan pou vizit la",
        /* CHOOSE_CLOCK_TIMES */ "Chwazi fwa revèy",
        /* CHOOSE_DATE_TO_PERFORM_THIS_TASK */ "Chwazi dat pou fè travay sa a",
        /* CHOOSE_FOLDER_TO_UPLOAD */ "Chwazi Dosye pou Upload",
        /* CHOOSE_START_TIME */ "Chwazi Tan Kòmanse",
        /* CHOOSE_THE_HOURS */ "Next (chwazi èdtan yo)",
        /* CHOOSE_TIME */ "Chwazi tan",
        /* CHOOSE_WHEN_TO_PERFORM_THE_VISIT */ "Chwazi lè pou fè vizit la",
        /* CHOOSE_WHEN_TO_VISIT_THE_PATIENT */ "Chwazi lè pou vizite pasyan an",
        /* CHOOSE_WHO_TO_CONTACT */ "Chwazi ki moun ki kontakte",
        /* CHOOSING_A_WINNER */ null,
        /* CHOOSING_A_WINNER_IN */ null,
        /* CLEAR */ "Klè",
        /* CLICK_HERE */ null,
        /* CLICK_HERE_TO_DOWNLOAD */ "Klike la a pou telechaje",
        /* CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE */ "Klike la a pou pataje kòd referans ou an",
        /* CLICK_HERE_TO_VIEW_CERTIFICATE */ "Klike la a pou wè sètifika",
        /* CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE */ "Konpliman pou premye sètifika ou 🏆🏆! Klike sou li pou wè nouvo sètifika ou",
        /* CLICK_TO_REQUEST */ "Klike sou pou mande!",
        /* CLICK_TO_SCAN_UPLOAD */ "Klike sou Scan & Upload",
        /* CLICK_TO_TAKE_A_SELFIE */ "Klike sou yo pran yon selfie",
        /* CLIMB_THE_RANKS_BY_COMPLETING_VISITS */ null,
        /* CLINICAL_SUPPORT */ "Sipò nan klinik",
        /* CLOCKED_IN */ "Reusi nan",
        /* CLOCKED_IN_AND_OUT */ "Relodi nan & soti",
        /* CLOCKED_IN_AT */ "Reusi nan nan",
        /* CLOCKED_OUT */ "Reloye",
        /* CLOCKED_OUT_AT */ "Reusi soti nan",
        /* CLOCKING_IN */ "Clocking nan ...",
        /* CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES */ "Clocking nan pa nan tan ki lakòz pwoblèm",
        /* CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES */ "Clocking nan / soti pa nan kote vizit la ka lakòz pwoblèm",
        /* CLOCKING_OUT */ "Clocking soti ...",
        /* CLOCK_ADDRESS_IN_RANGE */ "Revèy {clock_type} adrès se nan ranje",
        /* CLOCK_ADDRESS_NOT_IN_RANGE */ "Revèy {clock_type} adrès se pa nan ranje",
        /* CLOCK_IN */ "Revèy nan",
        /* CLOCK_IN_ANYWAY */ "Revèy nan de tout fason",
        /* CLOCK_IN_AT */ "Revèy nan nan",
        /* CLOCK_IN_BETWEEN */ "Revèy nan ant",
        /* CLOCK_IN_OUT */ "Revèy nan / soti",
        /* CLOCK_IN_OUT_SUBMIT_DUTIES */ "Revèy nan / soti epi soumèt devwa",
        /* CLOCK_IN_TIME_IS_REQUIRED */ "Revèy nan tan obligatwa",
        /* CLOCK_OUT */ "Revèy soti",
        /* CLOCK_OUT_AFTER */ "Revèy soti apre",
        /* CLOCK_OUT_AT */ "Revèy soti nan",
        /* CLOCK_OUT_BETWEEN */ "Revèy soti ant",
        /* CLOCK_OUT_TIME_IS_REQUIRED */ "Revèy soti tan obligatwa",
        /* CLOCK_TIMES_NOT_MOBILE */ null,
        /* CLOCK_TIME_IN_RANGE */ "Revèy {clock_type} tan se nan ranje.",
        /* CLOCK_TIME_NOT_IN_RANGE */ "Revèy {clock_type} tan se pa nan ranje.",
        /* CLOSE */ "Fèmen",
        /* CLOSE_SURVEY */ "Fèmen sondaj la",
        /* CLUSTERED_VISIT_EXPLENATION */ "Nou detekte ke 2 vizit sa yo fèmen ansanm ak anfòm orè chak jou ou. Nou rekòmande pou mande tou de vizit sa yo ansanm. Ou ka mande tou chak nan vizit yo endividyèlman",
        /* CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE */ "Kòd pa jwenn, tanpri itilize yon lòt",
        /* COMBINED_CASE */ "Ka konbine",
        /* COMING_SOON */ "Vini byento",
        /* COMPLETED */ "Konplete",
        /* COMPLETED_DOCUMENTS */ "Konplete dokiman yo",
        /* COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL */ "Ranpli tout dokiman yo anvan pewòl",
        /* COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS */ null,
        /* COMPLETE_PREVIOUS_SECTIONS_FIRST */ "Tanpri ranpli seksyon anvan an premye",
        /* COMPLETE_REGISTRATION */ "Ranpli Enskripsyon",
        /* COMPLETE_REGISTRATION_PROCESS */ "Ranpli pwosesis enskripsyon an",
        /* COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT */ "Ranpli aplikasyon an",
        /* COMPLETE_VISIT */ "Ranpli Vizite",
        /* COMPLETE_YOUR_ONBOARDING_ANYTIME */ "Ranpli onboarding ou nenpòt lè!",
        /* COMPLIANCE */ "Konfòmite",
        /* COMPLIANCE_EXPIRY */ "Videyo mande pou atansyon ou",
        /* COMPLIANCE_FORM */ "Fòm Konfòmite",
        /* COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY */ "Fòm konfòmite ou te soumèt avèk siksè!",
        /* COMPLIANT */ "Konfòme",
        /* COMPLIANT_ITEMS */ "Atik konfòme",
        /* CONFIRM */ "Konfime",
        /* CONFIRM_ASSESSMENT */ "Konfime evalyasyon",
        /* CONFIRM_COPY_LAST */ "Èske ou sèten ou vle kopye repons nan",
        /* CONFIRM_COPY_LAST_TITLE */ "Konfime kopi?",
        /* CONFIRM_DEPOSIT_DETAILS */ "Tanpri konfime enfòmasyon depo dirèk ou",
        /* CONFIRM_PATIENT_AVAILABILITY */ null,
        /* CONFIRM_PATIENT_AVAILABILITY_MESSAGE */ null,
        /* CONFIRM_RN_FLEX_VISIT */ "Mwen konfime vizit mwen an",
        /* CONFIRM_WITHOUT_LOCATION */ "Konfime san kote",
        /* CONGRATULATIONS */ "Konpliman!",
        /* CONGRATULATIONS_TO */ null,
        /* CONNECTING_HOME */ "Konekte lakay ou",
        /* CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS */ "Konekte ajans sante lakay yo ak moun kap bay swen",
        /* CONNECT_WITH_US_ON_FACEBOOK */ "Konekte avèk nou sou Facebook",
        /* CONNECT_WITH_US_ON_WHATSAPP */ "Konekte avèk nou sou WhatsApp",
        /* CONTACT */ "Kontak",
        /* CONTACT_AGENCY_FOR_MORE_INFO */ "Kontakte ajans lan pou plis enfòmasyon.",
        /* CONTACT_PATIENT */ "Kontakte pasyan",
        /* CONTACT_SUPPORT */ "Kontakte Sipò",
        /* CONTINUE */ "Kontinye",
        /* CONTINUE_LATER */ "Kontinye pita",
        /* CONTINUE_TO_APP */ "Kontinye app",
        /* CONTINUE_TO_ORIENTATION */ "Kontinye oryantasyon",
        /* CONTINUE_TO_SIGN_UP */ "Kontinye enskri",
        /* CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK */ null,
        /* COORDINATOR */ "Kòdonatè",
        /* COORDINATOR_EMAIL */ "Koòdonatè e-mail",
        /* COORDINATOR_IN_CHARGE */ "Koòdonatè an chaj",
        /* COORDINATOR_PHONE */ "Telefòn Koòdonatè",
        /* COPY */ "Kopye",
        /* COPY_FROM_LAST_TIME */ "Kopi nan dènye fwa",
        /* COPY_FROM_MEDICATION */ "Kopi nan medikaman",
        /* COPY_FROM_OTHER_FORMS */ "Kopi soti nan lòt fòm",
        /* COPY_LAST_NO_DATE_FALLBACK_APPENDED */ "Denye fwa",
        /* COPY_MEDICATION_CHART */ "Kopi tablo medikaman",
        /* COPY_PLAN_OF_CARE */ "Kopi Plan Swen",
        /* CORRECT */ "Kòrèk",
        /* COURSES */ "Kou",
        /* COVID */ "KOVID 19",
        /* COVID_REQUIRED */ "Kesyonè Covid-19 obligatwa",
        /* COVID_REQUIRED_EXPLAINED */ "Ou pa ranpli nan kesyonè a COVID-19 jodi a. Tanpri ranpli li yo nan lòd yo kontinye",
        /* COVID_SCREENING_CLICK_HERE */ "COVID -19 tès depistaj - Klike la a",
        /* CREATED_AT */ "Kreye nan",
        /* CREATE_A_NEW_ACCOUNT */ "Kreye yon nouvo kont",
        /* CREATE_NEW_PLAN_OF_CARE */ "Kreye yon nouvo plan swen",
        /* CRIMINAL_CONVICTIONS_RECORDS */ "Dosye kondanasyon kriminèl",
        /* CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT */ "Kounye a reusi nan yon vizit diferan",
        /* CURRENT_BALANCE */ null,
        /* CURRENT_VISIT */ "Vizit aktyèl la",
        /* DATA_WILL_BE_LOST */ "Done yo pral pèdi",
        /* DATE */ "Dat",
        /* DATES */ "Dat",
        /* DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO */ "Dat varye ranpli travay la: %kòmanse %nan %fini %",
        /* DATE_NOT_SPECIFIED */ "Dat pa espesifye",
        /* DATE_OF_BIRTH */ "Dat nesans",
        /* DATE_UNKNOWN */ "Dat enkoni",
        /* DATE_VERIFICATION */ "Dat verifikasyon",
        /* DAY */ "Jou",
        /* DAYS */ "jou",
        /* DAYS_A_WEEK */ "Jou nan yon semèn",
        /* DAYS_LEFT */ "Jou kite",
        /* DAYS_OF_WEEK */ "Jou nan yon semèn",
        /* DECEMBER */ "Desanm",
        /* DECLINED */ "Refize",
        /* DELETE */ "Efase",
        /* DESCRIBE_THE_PROBLEM */ "Dekri pwoblèm nan",
        /* DETAILS */ "Detay",
        /* DIRECTIONS */ "Enstriksyon",
        /* DIRECT_DEPOSIT */ "Depo dirèk",
        /* DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION */ "Dekonekte. Tcheke koneksyon entènèt ou an",
        /* DISCOVER_YOUR_JOURNEY */ null,
        /* DISCRIMINATION */ "Diskriminasyon",
        /* DISMISS */ "Revoke",
        /* DISMISSED */ "Rejte",
        /* DISTANCE */ "Distans",
        /* DOB */ "DOB",
        /* DOCUMENT */ "Dokiman",
        /* DOCUMENTS */ "Dokiman yo",
        /* DOCUMENTS_TO_COMPLETE */ null,
        /* DOCUMENT_HAS_EXPIRED */ "Dokiman ekspire",
        /* DOCUMENT_IS_MISSING */ "Dokiman ki manke",
        /* DOCUMENT_REJECTED */ "Dokiman rejte",
        /* DOCUMENT_SELECTED */ "Dokiman chwazi",
        /* DOESNT_EXPIRE */ "Pa ekspire",
        /* DOES_NOT_FIT_MY_SCHEDULE */ "Pa anfòm orè mwen an",
        /* DONE */ "Fè",
        /* DONT_FORGET_TO_CLOCK_IN */ "Pa bliye revèy nan",
        /* DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS */ "Pa bliye revèy, revèy ak ranpli tout travay yo",
        /* DONT_FORGET_TO_CLOCK_OUT */ "Pa bliye revèy",
        /* DONT_FORGET_TO_FILL_THE_DUTY_SHEET */ "Tan ranpli travay yo!",
        /* DONT_FORGET_TO_SMILE */ "Pa bliye souri 🙂",
        /* DONT_SCHEDULE_VISIT */ null,
        /* DONT_SHOW_AGAIN */ "Pa montre ankò",
        /* DOSE */ "Dòz",
        /* DOWNLOAD_PDF */ "Download PDF",
        /* DO_YOU_HAVE_ANY_QUESTIONS_ASK */ "w gen nenpòt kesyon? Mande",
        /* DO_YOU_WANT_THIS_VISIT */ "Ou vle vizit sa a?",
        /* DUE_BETWEEN */ null,
        /* DUE_BY_DATETIME */ null,
        /* DUE_DATE */ "Dat pou renmet",
        /* DUE_ON */ null,
        /* DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO */ null,
        /* DURATION */ "Dire",
        /* DURATION_PER_DAY */ "Duration pou chak jou",
        /* DUTIES */ "Devwa",
        /* DUTIES_COMPLETED_SUCCESSFULLY */ "Devwa ranpli avèk siksè",
        /* DUTY_SHEET_SUBMITTED */ "Fèy devwa soumèt",
        /* EACH_100_POINTS_DOLLAR */ "chak 100 pwen = $ 1",
        /* EACH_INVITE */ "Chak envite",
        /* EARLY_OR_LATE_CLOCKS */ null,
        /* EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY */ null,
        /* EDIT */ "Redije",
        /* EDIT_ACCOUNT_DETAILS */ null,
        /* EDIT_TIMES */ "Edit fwa",
        /* EDUCATION */ "Sant edikasyon",
        /* ELECTRIC_EQUIPMENT_DEPENDENCY */ "Depandans ekipman elektrik",
        /* ELIGIBLE_VISITS */ "Vizit ki kalifye yo",
        /* EMAIL */ "Imèl",
        /* EMAIL_QUESTION_PENDING_VERIFICATION */ "Kesyon sa a ap tann verifikasyon ou. Tcheke imèl la nou voye nan adrès sa a pou enstriksyon yo.",
        /* EMAIL_SUPPORT */ null,
        /* EMAIL_SUPPORT_FOR_MORE_INFO */ "Imèl sipò pou plis enfòmasyon",
        /* EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER */ null,
        /* EMAIL_VERIFICATION_QUESTION_LABEL */ "Y ap voye yon imèl verifikasyon nan adrès sa a. Tanpri verifye li ak 30 minit.",
        /* EMERGENCY_CONTACTS */ null,
        /* EMPTY_DURATION */ "Dire vid",
        /* EMPTY_PATIENT_MEDICATION_PROFILE */ "Pwofil medikaman pasyan an vid",
        /* ENABLE_LOCATION_MESSAGE */ null,
        /* ENABLE_LOCATION_TITLE */ null,
        /* ENDING_AT */ "Fini nan",
        /* ENDS */ "Fen",
        /* END_DATE */ "Dat fen",
        /* END_TIME */ "Fen tan",
        /* ENROLLMENT_REQUESTED */ "Enskripsyon mande",
        /* ENROLL_NOW */ "Enskri kounye a",
        /* ENTER_AGENCY_CODE */ "Antre nan kòd ajans lan",
        /* ENTER_DOCUMENT_NAME */ "Antre nan non dokiman",
        /* ENTER_NUMBER_HERE */ "Antre nan nimewo isit la",
        /* ENTER_TEXT_HERE */ "Antre nan tèks isit la",
        /* ENTER_YOUR_MOBILE_NUMBER */ "Mete nimewo mobil ou",
        /* ENTER_YOUR_PIN_CODE */ "Mete kòd PIN ou an",
        /* ENTITY_IS_MISSING */ "Jaden an ki manke. Tanpri asire w ke li plen ak Lè sa a, eseye ankò.",
        /* ERROR */ "Erè",
        /* ERROR_FETCHING_SLOTS */ null,
        /* ERROR_LOADING_DATA */ null,
        /* ERROR_REMOVING_DOCUMENT */ "Erè rive pandan y ap retire dokiman yo",
        /* ERROR_SCHEDULING_TASK */ null,
        /* ERROR_SCHEDULING_TASK_MESSAGE */ null,
        /* ESTIMATED_ADDRESS_WILL_BE_PROVIDED */ null,
        /* ESTIMATED_TIME_OF_CLOCKING_OUT_IS */ "Estime tan nan clocking soti se",
        /* EVACUATION_LOCATION */ "Kote Evakyasyon",
        /* EVACUATION_ZONE */ "Zòn evakyasyon",
        /* EVERY_VISIT */ "Chak vizit",
        /* EVV */ "EVV",
        /* EXCITING_NEWS_AHEAD */ null,
        /* EXEMPTED */ "Egzije",
        /* EXPIRED */ "Ekspire",
        /* EXPIRED_COMPLIANCE */ "Konfòmite ekspire",
        /* EXPIRED_ON_DATE */ "Ekspire sou %dat %",
        /* EXPIRES_AT */ "Ekspire nan",
        /* EXPIRES_IN */ "Ekspire nan",
        /* EXPIRES_IN_ONE_DAY */ "Ekspire nan yon sèl jou",
        /* EXPIRES_IN_X_DAYS */ "Ekspire nan %d jou",
        /* EXPIRES_ON_DATE */ "Ekspire sou %dat %",
        /* EXPIRING_COMPLIANCE */ "Ekspire konfòmite",
        /* EXPIRING_SOON */ null,
        /* EXPIRY_DATE */ "Dat ekspirasyon",
        /* EXPLORE */ "Esplore",
        /* EXPLORE_A_CAREER_ENHANCEMENTS */ null,
        /* FAILED_TO_IDENTIFY_PATIENT */ "Echwe pou pou idantifye pasyan an",
        /* FAR_VISIT_WARNING_MODAL_TITLE */ null,
        /* FAX_NUMBER */ null,
        /* FEBRUARY */ "fevriye",
        /* FEMALE */ "Femèl",
        /* FIFTHY_DOLLAR_AMAZON_GIFT_CARD */ "$ 50 Amazon Gift Card",
        /* FILES */ "dosye",
        /* FILE_NOT_FOUND_CONTACT_AGENCY */ "Ranpli pa jwenn, tanpri kontakte ajans ou an",
        /* FILL */ "Plen",
        /* FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT */ null,
        /* FILL_IN_THE_QUESTIONNAIRE */ "Ranpli kesyonè a",
        /* FILTERS */ "Filtè",
        /* FINAL_CONFIRMATION */ "Final konfimasyon",
        /* FIND_A_CARE_MOMENT */ null,
        /* FIND_A_CARE_MOMENT_DESCRIPTION */ null,
        /* FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE */ "Jwenn plis ka nan paj vizit ki disponib yo",
        /* FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE */ "Jwenn nouvo pasyan nan paj vizit ki disponib yo",
        /* FINISH_MY_ONBOARDING */ "Fini onboarding mwen an",
        /* FINISH_ONBOARDING_AND_GET_DOLLARS */ "Fini onboarding a epi pou yo jwenn $ 150",
        /* FINISH_ONBOARDING_MODAL_MESSAGE */ "Ou se yon etap pi pre jwenn anpil ka! Tanpri fini oboarding ou epi pou yo jwenn $!",
        /* FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2 */ "Ou kapab kounye a mande ka yo ou renmen, epi asire w ke ou ranpli tout dokiman adisyonèl yo anvan premye ka ou",
        /* FINISH_ONBOARDING_MODAL_TITLE */ "Nou eksite gen ou isit la, %non %!",
        /* FINISH_ONBOARDING_MODAL_TITLE_STAGE_2 */ "Kòmanse requsting ka! 🚀",
        /* FINISH_SHIFT */ "Fini chanjman",
        /* FINISH_THE_DOCUMENTS */ "Fini dokiman yo",
        /* FIRST_NAME */ "Premye non",
        /* FIRST_SHIFT */ "Premye chanjman",
        /* FIVE_THOUSAND_POINTS */ "5000 pwen",
        /* FIX */ "Fikse",
        /* FIX_DOCUMENTS_DESCRIPTION */ null,
        /* FIX_DOCUMENT_DESCRIPTION */ null,
        /* FIX_ISSUE */ null,
        /* FIX_ISSUES */ null,
        /* FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT */ "Ranje li kounye a!",
        /* FIX_SETTINGS */ "Ranje anviwònman",
        /* FIX_THE_DOCUMENT */ null,
        /* FIX_THE_DOCUMENTS */ null,
        /* FIX_YOUR_DOCUMENT */ null,
        /* FIX_YOUR_DOCUMENTS */ null,
        /* FLEXIBLE */ "Fleksib",
        /* FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT */ "Vizit sa a se {èdtan_per_week} èdtan pou chak semèn, chwazi ki jou ak èdtan ou vle travay 🙂",
        /* FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT */ "Vizit sa a mande pou {num_of_shifts} orè yon semèn, èdtan yo {start_time} {end_time}.\nChwazi jou yo ou vle travay",
        /* FLEXIBLE_DAYS_VISIT */ "Jou fleksib vizite",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT */ "Vizit sa a gen {total_shifts_number} orè:\n{StriveT_TO_CHOOSE} ak {LAST_SHIFT_TO_CHOOSE}.\nChwazi ki jou ak èdtan ou vle travay 🙂",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT */ "{Num_of_shifts} orè {num_of_hours} èdtan",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT */ "{Num_of_shifts} chanjman nan {num_of_hours} èdtan",
        /* FLEXIBLE_HOURS_EXPLANATION_TEXT */ "Vizit sa a se sou {jou_to_choose} ak {last_day_to_choose}.\nOrè yo se tou sa travay pou ou!",
        /* FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT */ "Vizit sa a se {figss_to_choose}.\nOrè yo se tou sa travay pou ou!",
        /* FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT */ "Vizit sa a se {striveT_TO_CHOOSE} ak {LAST_SHIFT_TO_CHOOSE}.\nOrè yo se tou sa travay pou ou!",
        /* FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT */ "Vizit sa a se sou {jou_to_choose}.\nOrè yo se tou sa travay pou ou!",
        /* FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT */ "Vizit sa a gen {figss_to_choose}.\nChwazi ki jou ak èdtan ou vle travay 🙂",
        /* FLEXIBLE_HOURS_PATTERN_SHIFT */ "{Num_of_hours} èdtan sou {day_of_week}",
        /* FLEXIBLE_HOURS_VISIT */ "Èdtan fleksib vizite",
        /* FLEXIBLE_VISIT */ "Vizit fleksib",
        /* FLEXIBLE_VISIT_DAY_TO_CHOOSE */ "{Jou} s",
        /* FLEXIBLE_VISIT_DETAILS */ "Detay vizit fleksib",
        /* FLEXIBLE_VISIT_TYPE */ "Vizit fleksib",
        /* FLU_SHOT */ null,
        /* FLU_SHOT_SUBMITTION_MESSAGE */ null,
        /* FOLLOW_US_ON_INSTAGRAM */ "Swiv nou sou Instagram",
        /* FOLLOW_US_ON_TWITTER */ "Swiv nou sou Twitter",
        /* FORGOT_PIN_CODE_DIALOG_MESSAGE */ "Ou pral pran nan ekran an login yo kòmanse yon pwosesis enskripsyon nouvo.",
        /* FORM_NAME */ "Non fòm",
        /* FOURTEEN_THOUSAND_POINTS */ "14000 pwen",
        /* FREQUENCY */ "Abitid",
        /* FRIEND */ "Zanmi",
        /* FROM */ "De",
        /* FROM_CAMERA */ "Soti nan kamera",
        /* FROM_GALLERY */ "Soti nan galri",
        /* FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE */ "Tèm konplè ak Kondisyon yo - Medflyt defi",
        /* FUTURE_VISITS */ "Vizit nan lavni",
        /* GENDER */ "Sèks",
        /* GENERAL */ "Jeneral",
        /* GENERAL_FILES */ "Dosye jeneral",
        /* GENERAL_NOTES */ "Nòt Jeneral",
        /* GENERAL_SUPPORT */ "Sipò jeneral",
        /* GET_INSTAPAY */ "Jwenn Instapay",
        /* GET_IT_NOW */ "Jwenn li kounye a",
        /* GET_MONEY_FOR_THIS_VISIT_TODAY
 */ "Jwenn peye pou vizit sa a kounye a!",
        /* GET_NOW */ "Jwenn kounye a!",
        /* GET_STARTED */ null,
        /* GET_THE_APP */ "Jwenn app a",
        /* GET_X_NOW */ "Jwenn {x} kounye a!",
        /* GOOD_JOB */ "Bon travay!",
        /* GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "Bon travay! Ou te konplete tout leson yo pou kounye a",
        /* GOT_IT */ "Te resevwa li",
        /* GO_BACK */ "Tounen",
        /* GO_TO */ "Ale nan",
        /* GO_TO_MEDFLYT_PASSPORT */ "Ale nan Medflyt Paspò",
        /* GO_TO_PATIENT */ "Ale nan pasyan",
        /* GO_TO_PATIENT_DETAILS */ "Ale nan detay pasyan yo",
        /* GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION */ null,
        /* GO_TO_VISIT */ "Ale nan Vizite",
        /* GREAT_JOB */ "Bon travay!",
        /* GROSS_PAY */ "Peye brit",
        /* HAS_DNR */ null,
        /* HAS_HEALTH_CARE_PROXY */ null,
        /* HAVE_A_NICE_WORKING_DAY */ "Pase yon bèl jounen travay!",
        /* HAVE_A_PLEASANT_VISIT */ "Fè yon vizit bèl!",
        /* HAVE_A_QUESTION_LETS_CHAT */ "Gen yon kesyon? Ann chat!",
        /* HEALTH_AGENCIES */ "Ajans sante",
        /* HELP */ "Ede",
        /* HELP_ME_FIND_MY_AGENCY */ "Ede m jwenn ajans mwen an",
        /* HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY */ "Isit la se sa ou bezwen konnen sou ajans nou an!",
        /* HEY */ "Hey!",
        /* HEY_THERE */ "Hey la",
        /* HI */ "Hi",
        /* HIRE_DATE */ "Anboche dat",
        /* HI_PLEASE_HELP_ME_FILL_MY_APPLICATION  */ null,
        /* HOME_PHONE */ "Telefòn lakay ou",
        /* HOUR */ null,
        /* HOURS */ "Èdtan",
        /* HOURS_PER_DAY */ "Orè pou chak jou",
        /* HOURS_PER_VISIT */ "Orè pou chak vizit",
        /* HOW_ARE_WE_CALCULATING_THE_RANK */ "Ki jan nou kalkile ran a?",
        /* HOW_CAN_WE_HELP_YOU */ "Ki jan nou ka ede ou?",
        /* HOW_CARE_MOMENTS_WORKS */ null,
        /* HOW_DID_YOU_HEAR_ABOUT_US */ "Ki jan ou te tande pale de nou",
        /* HOW_DOES_IT_WORK */ null,
        /* HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS */ "Kijan pasyan an santi? Ki sentòm prensipal yo?",
        /* HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN */ "Ki jan ou ankouraje yon pasyan ki santi yo desann?",
        /* HOW_DO_YOU_RATE_MEDFLYT */ "Ki jan ou fè pousantaj medflyt?",
        /* HOW_URGENT_IS_THE_ISSUE */ "Ki jan ijan se pwoblèm nan?",
        /* HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT */ "Ki jan ou ta renmen rele pasyan an?",
        /* HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE */ "Ki jan ou ta renmen Upload dosye a?",
        /* HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT */ null,
        /* HR_PER_VISIT */ "HR pou chak vizit",
        /* HUNDRED_DOLLARS_GIFT_CARD */ "$ 100 Amex Gift Card",
        /* ICD */ "ICD",
        /* ID */ "Id",
        /* IF_YOU_CLOCK_IN_AND_OUT_ON_TIME */ "Si ou revèy nan ak soti sou tan",
        /* IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME */ "Si ou pa revèy nan ak soti sou tan",
        /* IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON */ "Si ou rate yon vizit pou yon rezon ki pa lejit",
        /* IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE */ "Si ou mande plis vizit pandan y ap orè ou a gratis",
        /* IF_YOU_STAY_COMPLIANT */ "Si ou rete konfòme",
        /* IMPORTANT_INFORMATION */ "Enfòmasyon enpòtan",
        /* IMPORTED */ "Enpòte",
        /* IM_AVAILABLE */ "Mwen disponib",
        /* IM_DONE_SUBMIT */ "Mwen fini! Soumèt",
        /* IM_NOT_INTERESTED */ "Mwen pa enterese",
        /* IM_WORKING_WITH_AN_AGENCY */ "Mwen ap travay ak yon ajans",
        /* INACTIVE */ "Inaktif",
        /* INCOMPLETE */ "Enkonplè",
        /* INCORRECT */ "Fo",
        /* INCORRECT_CODE */ "Kòd kòrèk",
        /* INCORRECT_DIGITS */ "Chif ki pa kòrèk ...",
        /* INCORRECT_DIGITS_EXPLAINED */ "Dènye 4 chif ou te antre yo pa kòrèk. Tanpri kontakte ajans ou si ou gen pwoblèm.",
        /* INCORRECT_DIGITS_MESSAGE */ "Kat dènye chif ou te antre yo pa kòrèk. Tanpri kontakte ajans ou si w gen pwoblèm.",
        /* INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN */ "Kòd PIN kòrèk. Tanpri eseye ankò.",
        /* INCORRECT_SMS_CODE */ "Kò SMS kòrèk",
        /* INCORRECT_SMS_CODE_EXPLAINED */ "Kòd la ou te antre nan pa matche ak kòd la nou te voye ba ou. Tanpri eseye ankò.",
        /* INFORMATION_CENTER */ "Sant enfòmasyon",
        /* INFORMATION_NOT_MATCH_PROFILE */ "Enfòmasyon ki nan seksyon sa a pa matche ak pwofil pasyan an ankò",
        /* INSERT_THEIR_REFERRAL_CODE_HERE */ "Mete kòd referans yo isit la!",
        /* INSERVICES */ "Nan-sèvis yo",
        /* INSTAPAY */ "Instapay",
        /* INSTAPAY_HISTORY */ "Istwa instapay",
        /* INSTAPAY_TECHNICAL_ISSUE */ null,
        /* INSUFFICIENT_DUTIES */ null,
        /* INTERESTED_IN_THIS_BUNDLE */ "Enterese nan pake sa a?",
        /* INTRODUCING */ "Entwodwi",
        /* INVALID_DOCUMENT_NAME */ "Non dokiman ki pa valab",
        /* INVALID_EMAIL */ "Imèl valab",
        /* INVALID_FORM */ "Fòm valab",
        /* INVALID_PHONE */ "Telefòn valab",
        /* INVALID_PHONENUMBER */ "Nimewo telefòn valab",
        /* INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN */ "Valab SSN, tanpri tcheke epi eseye ankò",
        /* INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES */ "Envite moun kap bay swen Medflyt ak genyen prim etonan",
        /* INVITE_FRIENDS */ "Envite zanmi",
        /* IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE */ "Yo nan lòd yo reponn kesyon sa a tanpri mete ajou nan vèsyon dernye nou an soti nan magazen an",
        /* IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT */ "Yo nan lòd yo ka resevwa instapaid, ou bezwen chwazi omwen yon vizit.",
        /* IN_PROGRESS */ "Nan pwogrè",
        /* ISSUES_TO_SOLVE */ null,
        /* IS_DUE_IN_DAYS */ "Se akòz nan jou % jou",
        /* IS_DUE_TOMORROW */ "Se akòz demen",
        /* ITEMS_THAT_WILL_EXPIRE_SOON */ "Atik ki pral ekspire byento",
        /* ITEMS_WITH_ISSUES */ "Atik ki gen pwoblèm",
        /* ITEM_IS_MISSING */ "Atik ki manke",
        /* ITEM_IS_NOT_COMPLIANT */ "Atik pa konfòme",
        /* ITS_NOT_ME */ "Se pa mwen",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU */ "Li parèt ke nou deja gen yon kont ki egziste sou aparèy sa a. Sa se ou menm?",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU */ "Li parèt ke nou deja gen yon kont ki matche ak detay ou. Sa se ou menm?",
        /* IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK */ "Li parèt ou pa gen okenn vizit semèn sa a.",
        /* IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE */ "Li sanble ke ou pa ap travay ak nenpòt ki ajans. Èske ou ta renmen jwenn anboche pa ajans pa ranpli yon aplikasyon",
        /* I_DONT_HAVE_MY_CODE */ "Mwen pa gen yon kòd",
        /* I_DONT_WANT_THIS_CASE */ "Mwen pa vle ka sa a",
        /* I_DONT_WANT_TO_CLOCK */ "Mwen pa vle revèy",
        /* I_FORGOT_MY_PIN_CODE */ "Mwen bliye kòd PIN mwen an",
        /* I_HAVE_CHANGED_MY_MIND */ "Mwen chanje lide mwen",
        /* I_HAVE_READ_AND_AGREE */ "Mwen te li epi mwen dakò ak la",
        /* I_VERIFY_THE_TERMS */ "Mwen dakò ak tèm ak kondisyon yo",
        /* I_WANT_TO_CLOCK_IN_ANYWAY */ "Mwen vle revèy nan de tout fason",
        /* I_WANT_TO_CLOCK_OUT_ANYWAY */ "Mwen vle revèy de tout fason",
        /* I_WANT_TO_FINISH_MY_ONBOARDING */ "Mwen vle fini onboarding mwen an",
        /* I_WILL_DO_IT_LATER */ "Mwen pral fè li pita",
        /* JANUARY */ "Janvye",
        /* JOINED_DATE */ "Joined Dat",
        /* JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT */ null,
        /* JULY */ "Jiyè",
        /* JUNE */ "Jen",
        /* JUST_ONE_MORE_THING */ "Jis yon sèl bagay plis",
        /* JUST_TO_BE_SURE */ "Jis yo dwe asire ...",
        /* JUST_VERIFYING_ITS_YOU */ "Jis verifye li nan ou",
        /* KEEP_UP_THE_GOOD_WORK */ null,
        /* LABELS */ "Etikèt",
        /* LANGUAGE */ "Lang",
        /* LANGUAGES */ "Lang",
        /* LAST_NAME */ "Siyati",
        /* LEARN_MORE */ "Aprann plis",
        /* LEAVE_WITHOUT_SAVING */ "Kite san yo pa ekonomize?",
        /* LEFT */ "gòch",
        /* LESSON */ "Leson",
        /* LESSONS */ "Leson",
        /* LETS_CONTINUE_TO_NEXT_SECTION */ "Ann kontinye nan pwochen seksyon an!",
        /* LETS_FIND_CASES */ "Ann jwenn ka!",
        /* LETS_FIND_YOUR_FIRST_CASE */ "Ann jwenn premye ka ou!",
        /* LETS_FIND_YOUR_FIRST_PATIENT */ "Ann jwenn premye pasyan ou!",
        /* LETS_FINISH_YOUR_SHIFT */ null,
        /* LETS_START */ "Ann kòmanse!",
        /* LETS_START_YOUR_SHIFT */ "Ann kòmanse chanjman ou",
        /* LIKE_US_ON_FACEBOOK */ "Tankou nou sou Facebook",
        /* LINKED_TO_ANOTHER_PATIENT */ null,
        /* LIST */ "Lis",
        /* LISTENING___ */ null,
        /* LIST_OF_PATIENTS */ "Lis pasyan yo",
        /* LIST_OF_TASKS */ "Lis travay",
        /* LIST_OF_VISITS */ "Lis vizit",
        /* LIVE_CHAT_SUPPORT */ "Live chat sipò",
        /* LIVE_CLASS */ "Live klas",
        /* LIVE_CLASS_EXPLANATION */ "Ou pral kapab rantre nan klas la yon fwa li kòmanse. Nan ka ou rate li - ou yo pral kapab gade webinar la anrejistre",
        /* LIVE_EVENTS */ "Live evènman yo",
        /* LOADING */ "Charyal",
        /* LOADING_LOCATION */ "Loading Kote ...",
        /* LOCATION */ "Anplasman",
        /* LOCKED */ "Chi",
        /* LOGGING_YOU_IN */ "Antre ou nan",
        /* LOGIN */ "Ouvri sesyon an",
        /* LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED */ "Li sanble ke ou te ap eseye konekte soti nan yon aparèy diferan. Tanpri reponn kesyon sa yo",
        /* LOOKS_LIKE_MORE_THAN */ "Sanble plis pase",
        /* LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION */ "Sanble ou twò lwen kote vizit la!",
        /* MAIN_TASKS */ "Travay prensipal",
        /* MAKE_A_DIFFERENCE */ null,
        /* MAKE_SURE_PICTURE_IS_CLEAR */ "Asire w ke foto a pa twoub e ke ou ka li tèks la",
        /* MALE */ "Mal",
        /* MANUALLY_SUBMITTED_INFO */ "Manyèlman soumèt enfòmasyon",
        /* MAP */ "Plan",
        /* MARCH */ "Mache",
        /* MAX_TRAVEL_DISTANCE */ "Max distans vwayaj",
        /* MAY */ "Me",
        /* MAYBE_LATER */ "Petèt pita",
        /* MAY_CLOCK_IN_AT */ "Me revèy nan nan",
        /* MAY_CLOCK_OUT_FROM */ "Me revèy soti nan",
        /* MEC_WAIVER_INFORMATION */ "Enfòmasyon sou egzansyon MEC",
        /* MEDFLYT */ "Medflyt",
        /* MEDFLYTS_MONTHLY_RAFFLE */ null,
        /* MEDFLYT_AGENCY_HANDBOOK */ "Medflyt Manyèl Ajans",
        /* MEDFLYT_AT_HOME_BENEFITS */ "Medflyt nan benefis lakay yo",
        /* MEDFLYT_CHALLENGE */ "Medflyt defi",
        /* MEDFLYT_HOME_CARE */ "Medflyt Swen Kay",
        /* MEDFLYT_ID_CARD */ "Medflyt ID kat",
        /* MEDFLYT_PASSPORT */ "Medflyt Paspò",
        /* MEDFLYT_PASSPORT_TERMS */ "Medflyt tèm paspò",
        /* MEDFLYT_RAFFLE */ null,
        /* MEDFLYT_TEAM */ "Ekip Medflyt",
        /* MEDFLYT_VERSION */ "Medflyt vèsyon",
        /* MEDICAL_FILES */ "Dosye medikal",
        /* MEDICAL_INFORMATION */ "Enfòmasyon medikal",
        /* MEDICAL_NOTES */ "Nòt medikal",
        /* MEDICATIONS */ null,
        /* MESSAGE */ "Mesaj",
        /* MESSAGE_FOR_THE_COORDINATOR */ "Mesaj pou Koòdonatè a",
        /* MIDDLE_NAME */ "Non mwayen",
        /* MILES_AWAY */ "Kilomèt lwen",
        /* MILES_BETWEEN_PATIENTS */ "Kilomèt ant pasyan yo",
        /* MILES_SHORT */ "Mi.",
        /* MINIMUM_WAGE */ "Salè minimòm",
        /* MINUTE */ null,
        /* MINUTES */ "Minit",
        /* MINUTE_VISIT */ "Vizit minit",
        /* MISSING */ "Pèdi",
        /* MISSING_CLOCKS */ "Ki manke revèy",
        /* MISSING_PERSONAL_CARE_DUTY */ null,
        /* MM_DD_YYYY */ "mm/dd/yyyy",
        /* MOBILE_PHONE */ "Telefòn mobil",
        /* MOBILITY_STATUS */ "Estati Mobilite",
        /* MONTH */ "Mwa",
        /* MONTHLY_RAFFLE */ null,
        /* MORE_DETAILS */ "Plis detay",
        /* MORE_DETAILS_BELOW */ "Plis detay anba a",
        /* MORE_SHIFTS_MORE_CHANCES */ null,
        /* MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* MUST_AGREE_TERMS */ "Ou dwe dakò ak kondisyon ki nan Itilize ak Règleman sou enfòmasyon prive pa chwazi toulède kaz la.",
        /* MUST_BE_ATLEAST_3_CHARACTERS */ "Dwe atleast 3 karaktè",
        /* MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS */ "Dwe nan youn nan jou sa yo",
        /* MUST_PICK_EXACTLY */ "Dwe chwazi egzakteman",
        /* MUST_START_AT_OR_AFTER */ "dwe kòmanse nan oswa apre",
        /* MUST_START_AT_OR_BEFORE */ "dwe kòmanse nan oswa anvan",
        /* MUST_UPDATE_ADDRESS_TO_SEE_CASES */ "Ou dwe mete ajou adrès ou a wè ka!",
        /* MY_AGENCIES */ "Ajans mwen yo",
        /* MY_ASSIGNED_VISITS */ "Vizit mwen asiyen",
        /* MY_AVAILABILITY */ null,
        /* MY_BENEFITS_CARD_INFORMATION */ null,
        /* MY_MEDFLYT_COMPLIANCE */ "Konfòmite Medflyt mwen an",
        /* MY_PASSPORT */ "Paspò mwen an",
        /* MY_PAYROLL_HISTORY */ "Istwa Pewòl mwen an",
        /* MY_PAYROLL_INFORMATION */ "Enfòmasyon sou pewòl mwen an",
        /* MY_PROFILE */ "Pwofil mwen",
        /* MY_REQUESTED_VISITS */ "Vizit mwen yo mande yo",
        /* MY_STAFFING_PREFERENCES */ null,
        /* MY_UPCOMING_VISITS_REMINDERS */ "Vizite rapèl",
        /* MY_VIRTUAL_ID */ "ID vityèl mwen an",
        /* MY_VISITS */ "Vizit mwen yo",
        /* NA */ "N/a",
        /* NAME */ "Non",
        /* NEAR */ "Toupre",
        /* NEED_DIRECTIONS */ "Bezwen direksyon?",
        /* NET_PAY_FOR_PERIOD */ "Peye nèt pou peryòd",
        /* NEW */ "Nèf",
        /* NEW_END_TIME_X */ null,
        /* NEW_MESSAGE */ "Nouvo mesaj",
        /* NEW_TASK */ "Nouvo travay",
        /* NEW_TASKS */ "Nouvo travay",
        /* NEW_VISITS_AVAILABLE */ "Nouvo vizit ki disponib",
        /* NEXT */ "Apre",
        /* NEXT_DUE */ "Pwochen akòz",
        /* NEXT_LESSON */ "Pwochen leson",
        /* NEXT_SECTION */ "Pwochen etap",
        /* NEXT_TOKEN_IN */ null,
        /* NEXT_YEAR */ "ane pwochèn",
        /* NO */ "Okenn",
        /* NONE */ "Okenn",
        /* NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT */ "Okenn nan yo se mwen. Kreye nouvo kont",
        /* NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU */ "Okenn nan kont sa yo se ou",
        /* NOTES */ "Nòt",
        /* NOTIFICATIONS */ "Notifikasyon",
        /* NOTIFICATIONS_OFF */ "Notifikasyon Off",
        /* NOTIFICATIONS_ON */ "Notifikasyon sou",
        /* NOT_AVAILABLE */ "pa disponib",
        /* NOT_COMPLIANT */ "Pa konfòme",
        /* NOT_DUE_YET */ null,
        /* NOT_ENOUGH_HOURS */ "Pa ase èdtan",
        /* NOT_ENOUGH_SHIFTS */ "Pa ase orè ...",
        /* NOT_ENOUGH_SHIFTS_MESSAGE */ "Ou dwe chwazi omwen %Minshifts %orè yo nan lòd yo mande vizit sa a (ou te chwazi sèlman %currentshifts %).",
        /* NOT_FOUND */ "Pa jwenn",
        /* NOT_INTERESTED */ "Pa entèrese",
        /* NOT_SELECTED */ null,
        /* NOT_SET */ null,
        /* NOT_SIGNING */ "Pa siyen",
        /* NOT_STARTED */ "Pa kòmanse",
        /* NOT_URGENT */ "Pa ijan",
        /* NOVEMBER */ "Novanm",
        /* NO_ALLERGIES */ "Pa gen alèji li te ye",
        /* NO_ANSWERS_TO_COPY */ "Pa gen okenn repons a kopi soti nan.",
        /* NO_ANSWERS_TO_COPY_TITLE */ "Kopi echwe!",
        /* NO_AVAILABLE_SLOTS */ null,
        /* NO_BALANCE */ "Pa gen balans",
        /* NO_CHANGES_WERE_MADE */ "Pa gen chanjman yo te fè",
        /* NO_COMPLIANT_ITEMS */ null,
        /* NO_DOCUMENTS */ "Pa gen dokiman",
        /* NO_DOCUMENTS_AVAILABLE */ "Pa gen dokiman ki disponib",
        /* NO_DOCUMENTS_REQUIRED */ "Pa gen dokiman ki nesesè.",
        /* NO_DUTIES_REQUIRED_FOR_THIS_VISIT */ "Pa gen devwa ki nesesè pou vizit sa a",
        /* NO_EDUCATION_LINK */ "Èske ou vle edikasyon gratis? Kontakte ajans ou an",
        /* NO_ELIGIBLE_VISITS */ "Pa gen vizit ki kalifye",
        /* NO_END_DATE */ "Pa gen dat fen",
        /* NO_GENERAL_NOTES */ "Pa gen nòt jeneral",
        /* NO_IN_SERVICE_VIDEOS_AVAILABLE */ "Pa gen videyo nan sèvis ki disponib. Tanpri kontakte ajans ou pou plis detay.",
        /* NO_ISSUES_FOUND */ null,
        /* NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT */ "Non, se pa mwen. Kreye nouvo kont",
        /* NO_JUST_THIS_ONE */ null,
        /* NO_KEEP_THE_ORIGINAL_TIMES */ null,
        /* NO_KNOWN_ALLERGIES */ "Pa gen alèji li te ye",
        /* NO_LESSONS */ "Pa gen leson",
        /* NO_LESSONS_FOR_YOU_YET */ "Pa gen leson pou ou ankò",
        /* NO_MEDICAL_INFORMATION */ "Pa gen enfòmasyon medikal",
        /* NO_NOTIFICATIONS */ "Pa gen notifikasyon",
        /* NO_PAYSTUBS_FOUND_FOR_THIS_MONTH */ "Pa gen paystub yo te jwenn pou mwa sa a.",
        /* NO_PHONE */ "Pa gen telefòn",
        /* NO_PHYSICIAN_SELECTED */ null,
        /* NO_PREVIOUS_CONVERSATIONS */ "Pa gen konvèsasyon anvan yo",
        /* NO_SCHEDULED_VISITS_TODAY */ "Pa gen vizit pwograme jodi a",
        /* NO_SHIFTS_SELECTED */ "Pa orè chwazi",
        /* NO_TAKE_ME_BACK */ null,
        /* NO_TESTS */ "Pa gen tès",
        /* NO_THANKS */ "Non mèsi",
        /* NO_TIME_LIMIT */ "Pa gen limit tan",
        /* NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT */ null,
        /* NO_VIDEOS */ "Pa gen videyo",
        /* NO_VISITS_SCHEDULED */ null,
        /* NO_VISITS_SCHEDULED_MESSAGE */ null,
        /* NO_VISITS_SELECTED */ "Pa gen vizit chwazi",
        /* NPI */ null,
        /* NUM_COUNT_ITEMS */ null,
        /* NUM_SHIFTS_TO_GO */ null,
        /* NUM_SHIFTS_TO_WAGE */ null,
        /* N_A */ "N/a",
        /* OCTOBER */ "Oktòb",
        /* OF */ "de",
        /* OF_THE_REQUIRED_PLEASE_CONTINUE */ "nan tan ki nesesè yo. Tanpri kontinye.",
        /* OF_THE_VIDEO */ "nan videyo a.",
        /* OK */ "Ok",
        /* OK_ILL_TRY_LATER */ "Ok mwen pral eseye pita",
        /* OK_NO_PROBLEM */ "Oke pa gen pwoblèm!",
        /* OK_THANKS */ "OK mèsi!",
        /* ON */ "Sou",
        /* ONBOARDING */ "Onboarding",
        /* ONBOARDING_COMPLETED */ "Onboarding ranpli",
        /* ONBOARDING_COMPLETED_MESSAGE */ "Ou te konplete tout seksyon nan pwosesis la onboarding. Ou ka kòmanse gade videyo yo oryantasyon kounye a.",
        /* ONE_DAY_TO_COMPLETE */ "Yon jou pou konplete",
        /* ONE_DOCUMENT */ "Yon sèl dokiman",
        /* ONE_DOCUMENT_SELECTED */ "1 dokiman chwazi",
        /* ONE_HOUR */ "1 èdtan",
        /* ONE_LAST_STEP */ "Yon dènye etap",
        /* ONE_LESSON */ "Yon sèl leson",
        /* ONE_TEST */ "Yon sèl tès",
        /* ONE_THOUSAND_POINTS */ "1000 pwen",
        /* ONE_VIDEO */ "Yon sèl videyo",
        /* ON_HOLD */ "Sou kenbe",
        /* ON_LEAVE */ "Sou konje",
        /* OOPS */ "Oops",
        /* OPEN */ "Ouvè",
        /* OPEN_CAMERA */ "Louvri kamera",
        /* OPEN_CERTIFICATE */ "Louvri sètifika",
        /* OPEN_DEVICE_SETTINGS */ "Louvri Anviwònman Aparèy",
        /* OPEN_MAPS */ null,
        /* OPEN_SETTINGS */ "Louvri Anviwònman",
        /* OPTIONAL_TASKS */ null,
        /* OR */ "ou",
        /* OTHER */ "Lòt",
        /* OTHER_PERTINENT_DIAGNOSIS */ "Lòt dyagnostik enpòtan",
        /* OTHER_REASON */ null,
        /* OTHER_TASKS */ null,
        /* OTHER_VISITS */ null,
        /* OUTBOUND_CALL_ERROR_MESSAGE */ null,
        /* OUTBOUND_CALL_ERROR_TITLE */ null,
        /* OUTBOUND_CALL_PROMPT_MESSAGE */ null,
        /* OUTBOUND_CALL_PROMPT_TITLE */ null,
        /* OUTBOUND_CALL_SUCCESS_MESSAGE */ null,
        /* OUTBOUND_CALL_SUCCESS_TITLE */ null,
        /* OUT_OF */ "soti nan",
        /* OUT_OF_RANGE */ null,
        /* OVERDUE */ null,
        /* OVERLAPPING_VISIT_ERROR */ "Vizit yo sipèpoze, tanpri chwazi yon lòt dat oswa lè.",
        /* OVERRIDE_FORM */ null,
        /* OVERRIDE_FORM_MESSAGE */ null,
        /* OVER_NIGHT */ "Tout lannuit",
        /* PAGE */ "Paj",
        /* PAID */ "Peye",
        /* PAID_X_OUT_OF_Y */ "Peye {x} soti nan {y}",
        /* PARTIAL_SELECTION */ "Pasyèl seleksyon",
        /* PASSPORT */ "Paspò",
        /* PASSPORT_TERMS_TEXT */ "Fasil Upload tout konfòmite ou & dosye medikal yo pataje ak ajans ou yo ap travay avèk yo.",
        /* PASTE */ "Kole",
        /* PAST_DUE */ "Sot pase yo",
        /* PAST_SINCE_THE_VISIT_STARTED */ "sot pase depi vizit la te kòmanse",
        /* PAST_UPLOADS */ "Uploads sot pase yo",
        /* PAST_VISITS */ "Vizit sot pase yo",
        /* PATIENT */ "Pasyan",
        /* PATIENTS */ "Pasyan",
        /* PATIENT_ADDRESS */ "Adrès pasyan an",
        /* PATIENT_CANT_PHISICALLY_SIGN */ null,
        /* PATIENT_CANT_SIGN */ null,
        /* PATIENT_CONTACTS */ null,
        /* PATIENT_DOC_NOT_SUBMITTED */ "Dokiman pasyan an pa te soumèt akòz yon erè",
        /* PATIENT_DOC_SUBMISSION_MISSMATCH */ "Ou se sou yo soumèt fòm lan, men dat ki pwograme nan vizit la se diferan pase jodi an. Tanpri chwazi dat ou ta renmen genyen sou fòm lan",
        /* PATIENT_DOC_SUBMITTED_SUCCESSFULY */ "Dokiman pasyan an te soumèt avèk siksè",
        /* PATIENT_INFO */ "Enfòmasyon pasyan yo",
        /* PATIENT_IS_NOT_HOME */ null,
        /* PATIENT_IS_NOT_SIGNING */ "Pasyan an pa siyen",
        /* PATIENT_NAME */ "Non pasyan",
        /* PATIENT_NOT_FOUND */ "Pasyan pa jwenn",
        /* PATIENT_NOT_FOUND_EXPLAIN */ "Padon, li sanble pasyan an ou te kap chèche pa asiyen ou.",
        /* PATIENT_NUMBER */ "Nimewo pasyan",
        /* PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE */ "Pasyan sa a toujou annatant apwobasyon nan konpayi asirans lan. Dat kòmanse ta ka chanje",
        /* PATIENT_PHONE */ "Telefòn pasyan",
        /* PATIENT_REFUSES_TO_SIGN */ null,
        /* PATIENT_REPORT */ "Rapò pasyan an",
        /* PATIENT_REQUESTS */ "Demann pasyan yo",
        /* PATIENT_SCHEDULE */ null,
        /* PATIENT_SIGNATURE */ "Siyati pasyan an",
        /* PATIENT_SIGNATURE_IS_REQUIRED */ "Siyati pasyan yo obligatwa",
        /* PATIENT_SIGNATURE_REQUIRE_MSG */ "Tanpri presize yon rezon ki fè siyati pasyan an siyen",
        /* PATIENT_SIGN_HERE */ "Siyen pasyan isit la",
        /* PATIENT_UNAVAILABLE_DURING_THESE_HOURS */ null,
        /* PATIENT_VISITS */ null,
        /* PAUSE_READING */ "Li pran yon poz",
        /* PAYMENT_METHOD */ "Metòd peman",
        /* PAYROLL */ "Peròl",
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE */ "Pwoblèm nan ka manke enfòmasyon EVV, revèy-an / soti èdtan pa matche ak, revèy nan / soti kote se soti nan ranje ak plis ankò.",
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE */ "Gen yon pwoblèm ki anpeche peman pou vizit sa a",
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE */ "Nou te resevwa demann retrè ou epi nou nan mitan pwosesis li (li ta dwe pran kèk minit). 🥰",
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_TITLE */ "Nan pwogrè",
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE */ "Li sanble tankou vizit sa a ki manke swa revèy nan oswa soti.",
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE */ "Ki manke revèy nan oswa soti",
        /* PAYROLL_STATUS_PAID_MODAL_MESSAGE */ "Rès la nan kantite lajan an pral peye sou chèk la chak semèn",
        /* PAYROLL_STATUS_PAID_MODAL_TITLE */ "Vizit sa a te 80% peye nan sèvis instapay nou an ({x})",
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE */ "Pwoblèm nan ka manke enfòmasyon EVV, revèy-an / soti èdtan pa matche ak, revèy nan / soti kote se soti nan ranje ak plis ankò.",
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE */ "Gen yon pwoblèm ki anpeche peman pou vizit sa a",
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE */ "Tanpri note ke kantite lajan ki prezante a se anvan rediksyon taks.",
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE */ "Vizit sa a pral peye nan chèk chak semèn ou",
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE */ "Yon fwa chanjman an pral sou yo ak nou pral jwenn done ki nesesè EVV ou ka reklame vizit sa a pou Instapay.",
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE */ "Ou toujou pa te patisipe nan vizit sa a.",
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE */ null,
        /* PAYSTUB */ "Paystub",
        /* PAYSTUBS */ "Peman",
        /* PAY_ME_NOW */ "Peye mwen kounye a!",
        /* PAY_ME_NOW_X */ "Peye mwen kounye a {x} !!!",
        /* PENDING */ "Jiska",
        /* PENDING_APPLICATION */ "Annatandan aplikasyon an",
        /* PENDING_APPROVAL */ "Annatandan apwobasyon",
        /* PENDING_CONFIRMATION */ "Annatant konfimasyon",
        /* PENDING_ISSUES */ "Annatandan pwoblèm",
        /* PENDING_VERIFICATION */ "Annatandan verifikasyon",
        /* PERMANENT_VISIT_DETAILS */ "Detay vizit pèmanan",
        /* PERMANENT_VISIT_FROM */ "Vizit pèmanan nan",
        /* PERMANENT_VISIT_TYPE */ "Vizit pèmanan",
        /* PERMISSION_NEEDED_FOR_CAMERA */ null,
        /* PERMISSION_NEEDED_FOR_CAMERA_MESSAGE */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE */ null,
        /* PERMISSION_TO_CAMERA_DENIED */ null,
        /* PER_HOUR */ null,
        /* PER_SHIFT */ "Pou chak chanjman",
        /* PER_VISIT */ "pou chak vizit",
        /* PER_WEEK */ "pou chak semèn",
        /* PHONE */ "Telefòn",
        /* PHONES */ "Telefòn",
        /* PHONE_CALL_SUPPORT */ "Rele Sipò",
        /* PHOTO_LIBRARY */ "Bibliyotèk Photo",
        /* PHYSICIAN_DETAILS */ null,
        /* PICK_A_DATE */ "Chwazi yon dat",
        /* PICK_A_TIME */ "Chwazi yon tan",
        /* PLAN_OF_CARE */ "Plan Swen",
        /* PLEASE_ASK_THE_PATIENT */ "Tanpri mande pasyan an",
        /* PLEASE_CALL_PATIENT_IN_NEXT_SCREEN */ "Tanpri rele pasyan an nan pwochen ekran an",
        /* PLEASE_CHAT_WITH_THE_AGENCY */ "Tanpri chat ak ajans lan",
        /* PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY */ "Tanpri tcheke ke ou te antre nan li kòrèkteman.",
        /* PLEASE_CHOOSE_A_LANGUAGE */ "Tanpri chwazi yon langaj",
        /* PLEASE_CHOOSE_A_TIME */ "Tanpri chwazi yon tan",
        /* PLEASE_CHOOSE_DATE_BETWEEN */ "Tanpri chwazi dat ant",
        /* PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES */ "Tanpri ranpli ane anvan yo pake",
        /* PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT */ "Tanpri gade epi soumèt tès yo rete konfòme.",
        /* PLEASE_CONFIRM_THE_TIMES_CHOSEN */ "Tanpri konfime fwa yo chwazi",
        /* PLEASE_CONFIRM_YOUR_INFORMATION */ "Tanpri konfime enfòmasyon ou yo",
        /* PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS */ "Tanpri kontakte ajans lan pou plis detay",
        /* PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY */ "Tanpri kontakte ajans ou imedyatman",
        /* PLEASE_CONTACT_YOUR_AGENCY */ "Tanpri kontakte ajans ou an",
        /* PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS */ "Tanpri kontakte ajans ou pou yon adrès",
        /* PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY */ "Tanpri kontakte ajans ou imedyatman",
        /* PLEASE_CONTACT_YOUR_COORDINATOR */ "Tanpri kontakte koòdonatè ou a.",
        /* PLEASE_ENABLE_LOCATION */ "Tanpri pèmèt kote",
        /* PLEASE_ENTER_A_VALID_PHONE_NUMBER */ "Tanpri antre yon nimewo telefòn valab",
        /* PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME */ "Tanpri antre premye non ak dènye pasyan an",
        /* PLEASE_ENTER_PATIENT_NAME */ "Tanpri antre non pasyan an",
        /* PLEASE_ENTER_THE_PATIENT_PHONE */ "Tanpri antre nan telefòn pasyan an",
        /* PLEASE_ENTER_YOUR_PIN_CODE */ "Tanpri antre kòd PIN ou an",
        /* PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED */ "Tanpri eksplike poukisa li pa te konplete",
        /* PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER */ "Tanpri ranpli nan 4 dènye chif yo nan nimewo telefòn lan",
        /* PLEASE_FILL_IN_YOUR_INFORMATION */ "Tanpri ranpli enfòmasyon ou yo",
        /* PLEASE_FILL_REQUIRED_FIELDS */ "Tanpri ranpli tout jaden yo mande yo",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY */ "Tanpri asire w ke ou te antre nan kòd la kòrèkteman",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY */ "Tanpri asire w ke ou te antre nan nimewo telefòn ou kòrèkteman",
        /* PLEASE_MARK_ALL_THE_REQUIRED_DUTIES */ null,
        /* PLEASE_NOTE */ "Tanpri sonje",
        /* PLEASE_PICK_VALID_DATES */ "Tanpri chwazi dat valab",
        /* PLEASE_REQUEST_EXACTLY */ "Tanpri mande egzakteman",
        /* PLEASE_SELECT_AN_OPTION */ "Tanpri chwazi yon opsyon",
        /* PLEASE_SELECT_DATE_AND_TIME */ "Tanpri chwazi dat ak lè",
        /* PLEASE_SELECT_THE_PATIENT_ADDRESS */ "Tanpri chwazi adrès pasyan an",
        /* PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT */ null,
        /* PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW */ "Tanpri mete kanpe foto pwofil ou pa klike sou icon nan kamera anba a",
        /* PLEASE_SIGN_IN_AGAIN */ "Tanpri siyen ankò",
        /* PLEASE_SPECIFY */ null,
        /* PLEASE_TAKE_A_SELFIE */ "Tanpri pran yon selfie",
        /* PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK */ "Tanpri, di nou ki lè ou fè plan pou fè travay sa a?",
        /* PLEASE_TYPE_IN_YOUR_PHONE_NUMBER */ "Tanpri tape nimewo telefòn ou",
        /* PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH */ "Tanpri tape kòd ajans lan ou ta renmen travay avèk yo",
        /* PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER */ "Tanpri tape dènye 4 chif nimewo telefòn sa a",
        /* PLEASE_TYPE_THE_SMS_CODE */ "Tanpri tape kòd SMS la",
        /* PLEASE_UPDATE_TO_OUR_NEWEST_VERSION */ "Tanpri mete ajou nan vèsyon dernye nou an",
        /* PLEASE_UPDATE_YOUR_ADDRESS */ "Tanpri mete ajou adrès ou",
        /* PLEASE_UPDATE_YOUR_FIRST_NAME */ "Tanpri mete ajou premye non ou",
        /* PLEASE_UPDATE_YOUR_LAST_NAME */ "Tanpri mete ajou non ou",
        /* PLEASE_WAIT */ "Souple tann",
        /* PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION */ null,
        /* PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP */ "Tanpri gade videyo a plen pou li ale nan app a",
        /* POINTS */ "Pwen",
        /* POINTS_AND_REWARDS */ "Pwen & Rekonpans",
        /* POSTED_DATE */ "Afiche dat",
        /* PREBLOCK_VISIT_EXPLANATION */ "Apre konfime, ou pral gen tan limite yo kontakte pasyan an epi chwazi tan an pou vizit la.",
        /* PRESENTATION */ "Prezantasyon",
        /* PREVIOUS */ "Presedan",
        /* PREVIOUS_CONVERSATIONS */ "Konvèsasyon anvan yo",
        /* PREVIOUS_WINNERS */ null,
        /* PRE_TAXES */ "Pre taks",
        /* PRICE */ "Pri",
        /* PRINCIPAL_DIAGNOSIS */ "Dyagnostik Direktè",
        /* PRIORITY_CODE */ "Kòd priyorite",
        /* PRIVACY_POLICY */ "Règleman sou enfòmasyon prive",
        /* PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN */ "Pwoblèm ap resevwa kote ou ye, tanpri eseye ankò. Eseye vire sèvis kote sou, oswa ale deyò.",
        /* PROBLEM_WITH_CASE_SETTINGS */ "Sanble ou gen yon pwoblèm ak anviwònman ka ou",
        /* PROCESSING */ "Teknik",
        /* PROFESSIONAL_TYPE */ "Kalite pwofesyonèl",
        /* PROFILE */ "Profil",
        /* PROGRESS */ "Progrè",
        /* PROXY_FIRST_NAME */ null,
        /* PROXY_LAST_NAME */ null,
        /* PROXY_PHONE */ null,
        /* PULSE */ "Batman kè",
        /* QUESTION */ "Kesyònen",
        /* QUESTIONS */ "Kesyon",
        /* QUESTIONS_TO_COPY_FROM */ "Kesyon yo kopye soti nan",
        /* QUESTION_NUMBER */ "Nimewo kesyon",
        /* QUESTION_REJECTED */ "Kesyon rejte",
        /* QUIT */ "Kite",
        /* RAFFLE_ENDED */ null,
        /* RAFFLE_INFO_1_DESCRIPTION */ null,
        /* RAFFLE_INFO_1_TITLE */ null,
        /* RAFFLE_INFO_2_DESCRIPTION */ null,
        /* RAFFLE_INFO_2_TITLE */ null,
        /* RAFFLE_INFO_3_DESCRIPTION */ null,
        /* RAFFLE_INFO_3_TITLE */ null,
        /* RAFFLE_INFO_4_DESCRIPTION */ null,
        /* RAFFLE_INFO_4_TITLE */ null,
        /* RAFFLE_NOW */ null,
        /* RAFFLE_PRIZE */ null,
        /* RANK_ACHIEVED */ null,
        /* REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION */ null,
        /* READY_FOR_YOUR_NEXT_TRAINING */ "Pare pou pwochen fòmasyon ou an?",
        /* READY_TO_CLOCK_IN */ "Pare revèy nan",
        /* READY_TO_CLOCK_OUT */ "Pare revèy soti",
        /* READ_AND_CONFIRM */ "Li & Konfime",
        /* READ_ONLY_MODE */ "Li sèlman mòd",
        /* READ_TEXT */ "Li tèks",
        /* REASON */ "Rezon",
        /* RECENT_VISITS */ "Vizit resan yo",
        /* RECOMMENDED */ null,
        /* RECRUITMENT_MAIN_1 */ "Sanble ou ye",
        /* RECRUITMENT_MAIN_1_2 */ "pa",
        /* RECRUITMENT_MAIN_2 */ "Avèk nenpòt ajans",
        /* RECRUITMENT_MAIN_2_1 */ "travay",
        /* RECRUITMENT_MAIN_3 */ "Jwenn anplwaye pa ajans yo",
        /* RECRUITMENT_MAIN_4 */ "Pa ranpli yon aplikasyon",
        /* REFERRAL_CODE */ "Kòd referans",
        /* REFER_ME */ "Refere mwen!",
        /* REGISTRATION */ "Anrejistreman",
        /* REGULAR_PAY */ "Regilye peye",
        /* REJECT */ "Rejte",
        /* REJECTED */ "Rejte",
        /* REJECT_THIS_TASK */ "Rejte travay sa a",
        /* REJECT_THIS_VISIT */ "Rejte vizit sa a",
        /* REMAINED */ "rete",
        /* REMAINING */ "Restan",
        /* REMIND_ME_LATER */ "Fèm sonje",
        /* REMOVE */ "Deplase",
        /* REMOVE_PAGE */ "Retire paj",
        /* REMOVE_TASK */ null,
        /* REOPENED */ null,
        /* REPLAY */ "Reparèt",
        /* REQUEST */ "Reklame",
        /* REQUESTED */ "Demann",
        /* REQUESTED_LABEL_IN_CASES_LIST */ "\"Mande\" etikèt nan ka lis.",
        /* REQUESTED_TIMES */ "Mande fwa",
        /* REQUESTED_VISIT_CANCEL_EXPLANATION */ null,
        /* REQUESTING_REFERENCE_RESPONSE */ "Mande repons referans",
        /* REQUEST_AGENCIES_MEMBERSHIP */ "Mande manm ajans yo",
        /* REQUEST_AGENCY */ "Mande ajans",
        /* REQUEST_AGENCY_MEMBERSHIP */ "Mande manm ajans lan",
        /* REQUEST_DETAILS */ "Mande detay",
        /* REQUEST_FOR_APPOINTMENT */ "Demann pou randevou",
        /* REQUEST_FRIENDSHIP */ "Mande amitye",
        /* REQUEST_MORE_VISITS */ "Mande plis vizit",
        /* REQUEST_MORE_VISITS_MESSAGE */ "Li sanble ke ou pa asiyen nan nenpòt ki vizit semèn sa a, tounen vin pita! 🙂",
        /* REQUEST_NUMBER_SHIFTS */ "Demann % orè orè",
        /* REQUEST_SELECTED_SHIFT */ "Mande chanjman chwazi",
        /* REQUEST_SELECTED_SHIFTS */ "Mande orè yo chwazi",
        /* REQUEST_SHIFTS */ "Mande orè",
        /* REQUEST_SINGLE_SHIFT */ "Mande yon sèl chanjman",
        /* REQUEST_THE_TIMES_YOU_WANT */ "Mande fwa ou vle!",
        /* REQUEST_THIS_VISIT */ "Mande vizit sa a",
        /* REQUEST_TO */ "Mande pou",
        /* REQUEST_VISIT */ "Mande Vizite",
        /* REQUIRED */ "Obligatwa",
        /* REQUIRED_DOCUMENTS */ "Dokiman obligatwa yo",
        /* REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC */ "Gen kèk jaden ki nesesè nan dokiman an ki manke, tanpri ale retounen lakay yo epi ranpli yo",
        /* REQUIRED_PATIENT_DOCUMENT_TEXT */ "Ou oblije ranpli dokiman sa yo sou vizit sa a",
        /* REQUIRED_TASKS */ "Travay obligatwa",
        /* REQUIREMENTS */ "Kondisyon",
        /* RESCHEDULE */ "Rapòte",
        /* RESCHEDULED_SUCCESSFULLY */ "Repwograme avèk siksè",
        /* RESCHEDULE_IN_THE_PAST_ERROR */ "Pa ka pran yon lòt randevou pou yon vizit yo dwe nan tan lontan an.",
        /* RESCHEDULE_REQUESTS */ "Demann pou pran yon lòt randevou",
        /* RESET_PIN_CODE_MESSAGE */ "Ou pral pran nan ekran an login yo kòmanse yon nouvo pwosesis otantifikasyon",
        /* RESPIRATION_RATE */ "To respirasyon",
        /* RESUBMISSION_BANNER_TITLE */ null,
        /* RETAKE */ "Reprann",
        /* RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION */ "Aksyon vanjans pa patwon yo; defans",
        /* RETRY */ "Recry",
        /* REVIEW_PRIVACY_POLICY */ "View Privacy Policy",
        /* REVIEW_TASK */ "Revize travay",
        /* REVIEW_TASKS */ "Revize travay",
        /* RE_ENTER_YOUR_PIN_CODE */ "Re-antre nan kòd PIN ou",
        /* RN_FLEXIBLE_SHOWCASE_TEXT */ "Vizit fleksib",
        /* RN_FLEX_EXPLANATION_PREFIX */ "Sa a se yon",
        /* RN_FLEX_REQUESTED_EXPLANATION */ "Ou pral mande yo chwazi dat la ak lè ki kostim ou",
        /* RN_FLEX_REQUESTED_EXPLANATION_LINE_2 */ "Tan ki defini nan fè vizit sa a se sa ki annapre yo",
        /* RN_PATIENT_CONTACT_EXPLANATION */ "Vizit sa a mande pou ou kowòdone yon tan ak pasyan an.\n\nKlike sou bouton ki sou anba ekran an pou kontakte pasyan an.",
        /* RN_SIGN_HERE */ "RN siyen isit la",
        /* ROUTING_NUMBER */ "Nimewo routage",
        /* ROUTING_NUMBR */ "Nimewo routage",
        /* SAFETY_AND_HEALTH */ "Sekirite & Sante",
        /* SAVE */ "Sove",
        /* SAVE_FOR_LATER */ "Sove pou pita!",
        /* SCAN_AND_UPLOAD_FILES */ "Scan & Upload dosye",
        /* SCAN_A_PHOTO */ "Fè enspeksyon yon foto",
        /* SCAN_DOCUMENT */ "Eskanè dokiman yo",
        /* SCAN_NEW_DOCUMENT */ "Fè enspeksyon nouvo dokiman",
        /* SCAN_WITH_CAMERA */ "Fè enspeksyon ak kamera",
        /* SCHEDULE */ "Orè",
        /* SCHEDULED */ null,
        /* SCHEDULED_DATE */ "Dat pwograme yo",
        /* SCHEDULED_FOR */ "Pwograme pou",
        /* SCHEDULED_VISIT_COMPLETE */ "Vizit pwograme ranpli",
        /* SCHEDULED_VISIT_NOT_FOUND */ "Vizit pwograme pa jwenn, tanpri kontakte ajans lan",
        /* SCHEDULE_CONFIRMATION */ null,
        /* SCHEDULE_FOR */ null,
        /* SCHEDULE_TASK */ null,
        /* SCHEDULING_PROBLEM */ "Pwoblèm orè",
        /* SCREENING */ "Depistaj",
        /* SCREENING_FOR */ "Depistaj pou:",
        /* SEARCH */ "Rechèch",
        /* SEARCH_AGENCY */ "Rechèch ajans",
        /* SEARCH_FOR_MEDICATIONS */ "Rechèch pou medikaman ...",
        /* SEARCH_NEARY_VISITS */ "Search vizit ki tou pre ...",
        /* SEARCH_PATIENT */ null,
        /* SECOND_SHIFT */ "Dezyèm chanjman",
        /* SECTION_ALREADY_COMPLETED */ "Seksyon sa a te deja fini",
        /* SECTION_COMPLETED_PROMPT */ "Ou te deja ranpli seksyon sa a",
        /* SECTION_LOCKED_PROMPT */ "Tanpri ranpli rès aplikasyon an anvan ou kòmanse seksyon sa a",
        /* SEE_ALL */ "Wè tout",
        /* SEE_ALL_CONVERSATIONS */ "Wè tout konvèsasyon",
        /* SEE_IN_MAPS */ null,
        /* SEE_LIST_OF_VISITS */ "Gade lis vizit yo",
        /* SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT */ "Gade plis enfòmasyon sou kondisyon pre-screeining",
        /* SEE_YOUR_PROGRESS */ null,
        /* SELECT */ "Chwazi",
        /* SELECTED */ null,
        /* SELECTED_VISIT */ "Chwazi vizit",
        /* SELECT_ALL */ "Seleksyone tout",
        /* SELECT_CERTIFICATE */ "Chwazi sètifika",
        /* SELECT_DATE */ "Chwazi Dat",
        /* SELECT_DATE_AND_TIME */ "Chwazi Dat ak lè",
        /* SELECT_DOCUMENT */ "Chwazi Dokiman",
        /* SELECT_DX_CODE */ "Chwazi Kòd DX",
        /* SELECT_FROM_LIST */ null,
        /* SELECT_PERTINENT_DIAGNOSIS */ "Chwazi dyagnostik enpòtan",
        /* SELECT_PHYSICIAN */ null,
        /* SELECT_PRINCIPAL_DIAGNOSIS */ "Chwazi Dyagnostik Direktè",
        /* SELECT_SHIFTS */ "Chwazi orè",
        /* SELECT_START_TIME */ null,
        /* SELECT_SURGICAL_PROCEDURE */ "Chwazi pwosedi chirijikal",
        /* SELECT_TIME */ "Chwazi Tan",
        /* SELECT_TIME_SLOT */ null,
        /* SELECT_TIME_SLOT_INFO */ null,
        /* SELECT_VISITS_FOR_INSTAPAY */ "Chwazi vizit pou Instapay",
        /* SELECT_VISIT_DURATION */ "Chwazi Vizite Duration",
        /* SELECT_YOUR_SCHEDULE */ "Chwazi orè ou",
        /* SELFIE_WITH_PATIENT */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT */ null,
        /* SEND_A_MESSAGE */ "Voye yon mesaj",
        /* SEND_EMAIL */ "Voye Imèl",
        /* SEND_REPORT */ "Voye rapò",
        /* SEND_US_A_MAIL */ "Voye nou yon imèl",
        /* SEPTEMBER */ "Septanm",
        /* SETTINGS */ "Se",
        /* SETTINGS_AND_INFO */ "Anviwònman ak enfòmasyon",
        /* SET_DOCUMENT_EXPIRY_DATE */ "Mete dat ekspirasyon dokiman",
        /* SET_EXPIRATION_DATE */ "Mete dat ekspirasyon",
        /* SET_YOUR_4_DIGIT_PIN_CODE */ "Mete kòd PIN 4-chif ou a",
        /* SHARE */ "Pa",
        /* SHARE_IDEAS_AND_GET_A_CHANCE */ "Pataje lide epi pou yo jwenn yon chans",
        /* SHARE_REFERENCE_LINK */ null,
        /* SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP */ null,
        /* SHARE_WITH_YOUR_FRIENDS */ "Pataje ak zanmi ou yo!",
        /* SHIFT */ "Pòs",
        /* SHIFTS */ "Deplase",
        /* SHIFTS_DETAILS */ "Orè detay",
        /* SHIFT_HAS_FINISHED_IN */ "Chanjman te fini nan",
        /* SHIFT_HAS_STARTED_IN */ "Chanjman te kòmanse nan",
        /* SHOULD_BE_HERE */ "ta dwe isit la",
        /* SHOW_ALL_TASKS */ null,
        /* SHOW_DETAILS */ "Montre Detay",
        /* SHOW_LESS */ "Montre mwens",
        /* SHOW_ME_CASES_IN_THE_NEXT */ "Montre m ka nan pwochen an",
        /* SHOW_ME_IN */ "Montre m nan",
        /* SHOW_MORE */ "Montre plis",
        /* SHOW_OLD_PLAN_OF_CARE */ "Montre ansyen plan swen",
        /* SHOW_TASKS_THAT_REQUIRE_FIXES */ null,
        /* SHOW_US_YOUR_SMILE */ "Montre nou souri ou! 😊",
        /* SIGNATURES */ "Siyati",
        /* SIGNATURE_REQUIRED */ "Siyati obligatwa",
        /* SIGN_DECLINATION_FORM */ null,
        /* SIGN_HERE */ "Siyen isit la",
        /* SIGN_IN */ "Siyen an",
        /* SIGN_ORIENTATION_VIDEO */ "Tanpri siyen isit la anvan ou soumèt",
        /* SIGN_ORIENTATION_VIDEO_ERR */ "Tanpri siyen anvan ou soumèt",
        /* SIGN_OUT */ "Dekonekte",
        /* SIGN_UP_FREE */ "Enskri gratis",
        /* SIGN_UP_ITS_FREE */ "Enskri. li gratis!",
        /* SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE */ "Depi ou reusi nan & soti sou tan ou ka jwenn 80% nan peman chanjman an jodi a :)",
        /* SINGLE_FLEXIBLE_VISIT_EXPLANATION */ null,
        /* SINGLE_VISIT_DETAILS */ "Detay sèl vizit",
        /* SINGLE_VISIT_FROM */ "Single vizit nan",
        /* SINGLE_VISIT_TYPE */ "Single vizit",
        /* SIXTY_SECONDS_AND_YOU_ARE_DONE */ null,
        /* SKIP */ "Sote",
        /* SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION */ "Yo pral bay adrès la egzak apre konfimasyon final la",
        /* SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS */ "Nou bezwen jwenn konfimasyon nan men plis moun kòm byen ki ta ka chanje vizit la, nou pral mete ou ajou nan kèk èdtan kap vini yo",
        /* SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN */ "Ou ka wè tout enfòmasyon sou ekran an vizit asiyen. Bon chans!",
        /* SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES */ "Tanpri remake - si ou pa montre jiska vizit la (sof si pou rezon espesifik) ou pa pral kapab jwenn plis ka nan ajans sa a epi ou pral sispann!",
        /* SLIDE_MAIN_INFO_GO_NEXT_SCREENS */ "Tanpri ale sou enfòmasyon ki nan pwochen ekran yo asire w ke ou ka kòmanse travay sou ka sa a",
        /* SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW */ "Tout sa ou bezwen konnen sou nouvo vizit ou!",
        /* SLIDE_STEP_X_OF_COUNT */ "Etap etap %nan %steps_count %",
        /* SMILE_FOR_US */ "Souri pou nou! 📷",
        /* SOCIAL */ "Sosyal",
        /* SOCIAL_MEDIA */ "Medya sosyal",
        /* SOMETHING_WENT_WRONG */ "Yon bagay ale mal, tanpri eseye ankò pita",
        /* SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS */ null,
        /* SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM */ null,
        /* SOME_TASKS_NEED_FIXES */ null,
        /* SORRY */ "Regrèt",
        /* SORT */ "Triye",
        /* SPECIFIC_DAYS */ "Jou espesifik",
        /* SPEECH_RECOGNITION */ null,
        /* SPLIT_SHIFTS_VISIT */ "Split orè",
        /* SPREAD_THE_WORD */ "Gaye Pawòl la",
        /* STAGE_APPROVED_MESSAGE */ "Nou te apwouve kesyon sa a",
        /* STAGE_AWAITING_APPROVAL */ "Kesyon sa a ap tann apwobasyon nan ajans lan. Ekip nou an pral revize li yon ti tan",
        /* STAGE_COMPLETED_MESSAGE */ "Ou fin fè kesyon sa a",
        /* STAGE_X_OF_TOTAL_STAGES */ "de",
        /* START */ "Depa",
        /* STARTING_AT */ "Kòmanse nan",
        /* STARTS */ "Kòmanse",
        /* STARTS_NEXT_WEEK */ null,
        /* STARTS_TODAY_IN */ null,
        /* START_APPLICATION */ "Kòmanse aplikasyon",
        /* START_A_SURVEY */ "Kòmanse sondaj!",
        /* START_DATE */ "Kòmanse dat",
        /* START_FILLING */ "Kòmanse ranpli",
        /* START_NOW */ "Kòmanse kounye a",
        /* START_SHIFT */ "Kòmanse chanjman",
        /* START_TIME */ "Kòmanse tan",
        /* START_USING_MEDFLYT_PASSPORT */ "Kòmanse lè l sèvi avèk Medflyt Paspò",
        /* START_WATCHING */ "Kòmanse gade!",
        /* START_WATCHING_ORIENTATION_VIDEOS */ "Kòmanse gade videyo oryantasyon ou yo",
        /* START_WORKING */ "Kòmanse travay",
        /* STATUS */ "Kondisyon",
        /* STAY_ON_TRACK */ null,
        /* STAY_ON_TRACK_1_ANSWER */ null,
        /* STAY_ON_TRACK_1_QUESTION */ null,
        /* STAY_ON_TRACK_2_ANSWER */ null,
        /* STAY_ON_TRACK_2_QUESTION */ null,
        /* STAY_ON_TRACK_3_ANSWER */ null,
        /* STAY_ON_TRACK_3_QUESTION */ null,
        /* STAY_ON_TRACK_4_ANSWER */ null,
        /* STAY_ON_TRACK_4_QUESTION */ null,
        /* STAY_ON_TRACK_DESCRIPTION */ null,
        /* STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS */ "Rete branche pou plis ka oswa tiyo pou chanje anviwònman ka yo",
        /* STAY_TUNED_FOR_MORE_VISITS */ "Rete branche pou plis vizit",
        /* STAY_TUNED_FOR_THE_NEXT_RAFFLE */ null,
        /* STILL_WAITING_REFERENCE_ANSWER */ "Nou toujou ap tann pou repons nan referans ou - {Reference_Name} - {Reference_Phone_Number} Tanpri kontakte yo epi asire yo ke yo ap reponn a Imèl nou an 🙏🏼",
        /* STOP */ null,
        /* STREAK_BREAK */ null,
        /* STREAK_BREAK_MESSAGE */ null,
        /* STREAK_BREAK_MESSAGE_2 */ null,
        /* SUBMIT */ "Soumèt",
        /* SUBMITTED_AT */ "Soumèt nan",
        /* SUBMITTED_DOCUMENTS */ "Dokiman soumèt",
        /* SUBMITTED_MANUALLY */ "Soumèt manyèlman",
        /* SUBMIT_AFTER */ "Soumèt apre",
        /* SUBMIT_AT */ "Soumèt nan",
        /* SUBMIT_BY */ "Soumèt pa",
        /* SUBMIT_DUTIES */ "Soumèt devwa",
        /* SUBMIT_DUTIES_BEFORE_CLOCK_OUT */ "Tanpri soumèt devwa vizit la anvan clocking soti",
        /* SUBMIT_FORM */ "Soumèt fòm",
        /* SUBMIT_FORMS */ null,
        /* SUBMIT_MANUAL_TIMESHEET */ "Soumèt manyèl fwa",
        /* SUBMIT_REQUIRED */ "Soumèt obligatwa",
        /* SUBMIT_TEST */ "Soumèt tès",
        /* SUBMIT_TIMESHEET */ "Soumèt fwa",
        /* SUBMIT_WITH_SCHEDULED_DATE */ "Soumèt ak dat ki pwograme a",
        /* SUBMIT_WITH_TODAY_DATE */ "Soumèt ak dat jodi a",
        /* SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT */ null,
        /* SUBMIT_YOUR_SIGN */ "Soumèt siy ou",
        /* SUBMIT_YOUR_SIGNATURE */ "Soumèt siyati ou",
        /* SUCCESS */ "Reisit",
        /* SUCCESSFULLY_CLOCKED_IN */ "Avèk siksè reusi nan",
        /* SUCCESSFULLY_CLOCKED_OUT */ "Avèk siksè reusi",
        /* SUCCESSFULY_REQUESTED */ "Avèk siksè mande!",
        /* SURGICAL_PROCEDURE */ "Pwosedi chirijikal",
        /* SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS */ "Chanje nan lis View yo wè vizit enpòte ou",
        /* SWITCH_VIEW */ "Chanje View",
        /* TAKE_A_DIFFERENT_PHOTO */ "Pran yon foto diferan",
        /* TAKE_A_PHOTO */ "Pran yon foto",
        /* TAKE_A_SURVEY */ "Pran yon sondaj ak genyen yon chans jwenn yon",
        /* TAKE_ME_TO_CASE_SETTINGS */ "Mennen m 'nan anviwònman ka",
        /* TAKE_PHOTO */ "Pran foto",
        /* TAKE_THIS_TASK */ null,
        /* TAP_HERE_TO_VIEW */ "Tape isit la pou wè",
        /* TAP_TO_CANCEL */ "Tape Anile",
        /* TAP_TO_CHANGE_CASE_SETTINGS */ "Tape chanje anviwònman ka",
        /* TASK */ "Devwa",
        /* TASKS */ "Travay",
        /* TASK_ALREADY_ASSIGNED */ null,
        /* TASK_COMPLETED_SUCCESSFULLY */ "Konpliman 💪🏻ou ranpli travay sa a.",
        /* TASK_INFORMATION */ null,
        /* TASK_SCHEDULED */ null,
        /* TASK_SCHEDULED_MESSAGE */ null,
        /* TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE */ null,
        /* TECHNICAL_SUPPORT */ "Sipo teknik",
        /* TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES */ "Di nou poukisa ou pa enterese pou nou ka voye ba ou pi bon ka",
        /* TELL_US_YOUR_AGENY_DESCRIPTION */ "Di nou non ajans ou, non koòdonatè epi nou pral kontakte yo pou emèt ka louvri yo.",
        /* TEMPERATURE */ "Tanperati",
        /* TEN_DOLLAR_STARBUCKS_GIFT_CARD */ "$ 10 Starbuck kat kado",
        /* TERMINATED */ "Sispann",
        /* TERMS_OF_MEDFLYT_PRIVACY_POLICY */ "Regleman pou Medflyt Privacy Policy",
        /* TERMS_OF_USE */ "Tèm itilizasyon",
        /* TEST */ "Tès",
        /* TESTS */ "Tès",
        /* TEST_COMPLETED */ "Tès ranpli",
        /* TEST_FAILED */ "Tès echwe",
        /* TEST_REQUIRED */ "Tès obligatwa",
        /* THANKS */ "Mèsi!",
        /* THANK_YOU */ "Mèsi!",
        /* THANK_YOU_FOR_YOUR_FEEDBACK */ "Mèsi pou fidbak ou.",
        /* THATS_ME */ "Sa se mwen",
        /* THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION */ null,
        /* THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS */ null,
        /* THERE_ARE_NO_AGENCIES_YET */ "Pa gen okenn ajans ankò",
        /* THERE_ARE_NO_ASSIGNED_CASES */ "Pa gen okenn ka asiyen",
        /* THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION */ "Gen yon pwoblèm ak koneksyon entènèt ou an",
        /* THERE_SEEMS_TO_BE_NOTHING_HERE */ "Sanble pa gen anyen isit la ...",
        /* THE_AWARDS_ARE_COMING_SOON */ "Prim yo ap vini byento!",
        /* THE_BEST_PLACE_FOR_CAREGIVERS */ "Pi bon kote pou moun kap bay swen",
        /* THE_DUTY_SHEET_HAS_BEEN_SUBMITTED */ "Byen fè! Fèy devwa a te soumèt.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY */ "Lajan an pral transfere pa 12:30 pm jodi a.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW */ "Lajan an pral transfere pa 12:30 pm demen.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY */ "Lajan an pral transfere pa 6 pm jodi a.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING */ "Lajan an pral transfere pa Lendi maten.",
        /* THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON */ "Lajan an pral transfere nan ou byento.",
        /* THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS */ null,
        /* THE_NEXT_WINNERS_ANNOUNCEMENT */ "Anons gayan kap vini an",
        /* THE_SELECTED_DATE_IS_EARLIER_THAN */ null,
        /* THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS */ "Ka vizit la dwe fèt nan jou sa yo",
        /* THE_VISIT_HAS_NOT_STARTED_YET */ "Vizit la pa te kòmanse ankò!",
        /* THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS */ null,
        /* THIS_BUNDLE_INCLUDES */ "Pake sa a gen ladan",
        /* THIS_CONVERSATION_HAS_BEEN_RESOLVED */ "Konvèsasyon sa a te rezoud. Tanpri kòmanse yon nouvo konvèsasyon pou kontinye",
        /* THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK */ "Kou sa a konsiste de %D leson yo. Bon chans!",
        /* THIS_FIELD_IS_CURRENTLY_DISABLED */ "Jaden sa a kounye a enfim.",
        /* THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT */ "Sa a se yon vizit fin vye granmoun, kapab revèy nan/soti",
        /* THIS_IS_A_FUTURE_VISIT */ "Sa a se yon vizit nan lavni, ou ka sèlman kòmanse vizit sa a sou {start_date} nan {start_time}.",
        /* THIS_IS_A_LIVE_CLASS_SESSION */ "Sa a se yon {dire} sesyon klas viv ({dat_time})",
        /* THIS_MAY_TAKE_UP_TO_X_SECONDS */ null,
        /* THIS_PATIENT_BELONGS_TO_AGENCY */ null,
        /* THIS_PATIENT_HAS_NO_PHONE_NUMBERS */ "Pasyan sa a pa gen nimewo telefòn",
        /* THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER */ "Kesyon sa a li sèlman. Ou pa gen dwa reponn.",
        /* THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP */ null,
        /* THIS_VISIT_CAN_BE_PERFORMED_BETWEEN */ "Ka vizit sa a dwe fèt ant",
        /* THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE */ "Vizit sa a pa egzije okenn travay yo dwe fè",
        /* THIS_VISIT_IS_FOR_DIFFERENT_AGENCY */ null,
        /* THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET */ "Vizit sa a se nan tan kap vini an, ou pa ka revèy nan ankò",
        /* THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY */ null,
        /* THIS_WILL_MARK_THE_VISIT_AS_MISSED */ null,
        /* TIME */ "Tan",
        /* TIMESHEET_SUBMITTED */ "Timesheet soumèt",
        /* TIME_ESTIMATION */ "Tan estimasyon",
        /* TIME_FRAME */ "Ankadreman tan",
        /* TIME_LEFT */ "Tan ki rete",
        /* TIME_VARIES */ "Tan varye",
        /* TO */ "Pou",
        /* TODAY */ "Jodi a",
        /* TODAYS_DATE */ "Dat jodi a",
        /* TOKENS */ null,
        /* TOO_MANY_HOURS */ "Twòp èdtan",
        /* TOO_MANY_SHIFTS */ "Twòp orè!",
        /* TOO_MANY_SHIFTS_MESSAGE */ "Ou gen dwa ranmase nan % maxshifts % orè. Si ou vle chwazi chanjman sa a, ou pral gen désactivez youn nan orè deja chwazi ou.",
        /* TOP_CAREGIVERS_IN_YOUR_AREA */ "Top moun kap bay swen nan zòn ou an",
        /* TOTAL_EARNED */ null,
        /* TOTAL_SPENT */ null,
        /* TO_FILL_IN_A_FORM_INSTEAD */ null,
        /* TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT */ "Pou jwenn peye sou tan - ou bezwen revèy nan ak soti.",
        /* TO_SEE_THIS_TASK_GO_TO_ASSIGNED */ "Pou wè travay sa a ale nan \"asiyen\" tab",
        /* TO_SEE_THIS_VISIT_GO_TO */ "Pou wè vizit sa a gade pou",
        /* TO_UPLOAD_A_FILE_INSTEAD */ null,
        /* TO_WIN_AN_IPHONE12 */ "Genyen yon iPhone 12",
        /* TRAINING */ "Antrenman",
        /* TRAININGS_FOR */ "Fòmasyon pou",
        /* TRAINING_CENTER */ "Sant fòmasyon",
        /* TRAINING_CENTER_REMINDERS */ "Rapèl sant fòmasyon",
        /* TRY_AGAIN */ "Eseye anko",
        /* TYPE_AGENCY_CODE */ "Tape Kòd Ajans",
        /* TYPE_MESSAGE */ "Tape mesaj",
        /* TYPE_YOUR_ADDRESS */ "Tape adrès ou",
        /* UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET */ "Fèy devwa a te soumèt. Ou pa gen dwa edite li.",
        /* UNANSWERED_LAST_SECTION_FOR_NOW */ "Sa a se seksyon ki sot pase a pou kounye a, epi ou pa t 'reponn tout kesyon yo. Ou ka ale retounen lakay yo epi ranpli yo oswa tounen vin pita",
        /* UNAUTHORIZED */ "Inotorize",
        /* UNAVAILABLE_LOCATION_SERVICES_MESSAGE */ "Li sanble ke nou pa ka jwenn aksè nan kote aparèy ou an. Tanpri asire w ke sèvis kote ou yo vire sou yo epi yo disponib.",
        /* UNDER_REVIEW */ "Anba revizyon",
        /* UNDO */ "Defèt",
        /* UNIQUE_ERROR_CODE */ "Kòd erè inik",
        /* UNSCHEDULE */ "Unschedule",
        /* UNSCHEDULE_TASK */ "Travay unschedule",
        /* UNSPECIFIED */ "Specified",
        /* UNTIL */ "Jouk",
        /* UPCOMING_VISITS */ "Vizit kap vini yo",
        /* UPDATED_AT */ null,
        /* UPDATE_INFORMATION */ "Mete ajou enfòmasyon",
        /* UPLOAD */ "Upload",
        /* UPLOADED */ "Uploaded",
        /* UPLOADED_FILE_VIEW */ "View dosye Uploaded",
        /* UPLOADING */ "Uploading",
        /* UPLOAD_A_DOCUMENT */ null,
        /* UPLOAD_A_FILE */ null,
        /* UPLOAD_DOCUMENT */ "Voye dokiman",
        /* UPLOAD_DOCUMENTS */ "Voye dokiman yo",
        /* UPLOAD_ERROR */ "Voye erè",
        /* UPLOAD_FILES_TO_ENSURE */ "Voye dosye pou asire",
        /* UPLOAD_FLU_SHOT_DOCUMENT */ null,
        /* UPLOAD_FROM_GALLERY */ "Upload soti nan galri",
        /* UPLOAD_NEW_DOCUMENT */ null,
        /* UPLOAD_VIDEO */ "Videyo Upload",
        /* UPLOAD_YOUR_FILES_TO_ENSURE */ "Voye dosye ou yo asire",
        /* UP_COMING_REASSESSMENTS */ "Re -evalyasyon kap vini yo",
        /* UP_TO */ "Jiska",
        /* URGENT */ null,
        /* USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY */ "Itilizatè sa a te fèmen akòz aktivite sispèk",
        /* VALID */ "Valid",
        /* VERIFIED */ "Verifye",
        /* VERIFY */ "Verifye",
        /* VERIFYING */ "Verifye",
        /* VERIFY_YOUR_LOCATION */ "Verifye kote ou ye",
        /* VERY_URGENT */ "Trè ijan",
        /* VIDEO */ "Videyo",
        /* VIDEOS */ "Videyo",
        /* VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION */ "Videyo nan sant fòmasyon mande pou atansyon ou.",
        /* VIDEO_COMPLETED_SUCCESSFULLY */ "Konpliman 💪🏻ou ranpli gade videyo a.",
        /* VIEW */ "Vi",
        /* VIEWED */ "Wè",
        /* VIEW_ALL */ null,
        /* VIEW_ANSWERS */ "View Repons",
        /* VIEW_CERTIFICATE */ "Gade sètifika",
        /* VIEW_TASK */ null,
        /* VIEW_TASKS_PENDING_FOR_SCHEDULE */ "Gade travay annatant pou orè",
        /* VIEW_VISIT */ null,
        /* VIRTUAL_ID_CARD */ "Kat ID Virtual",
        /* VISIT */ "Vizite",
        /* VISITS */ "vizit",
        /* VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER */ "Chèche adrès ou pou vizit tou pre ou ...",
        /* VISITS_NEXT_MONTH */ null,
        /* VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* VISITS_PER_WEEK */ "Vizit pou chak semèn",
        /* VISITS_WITH_ISSUES */ null,
        /* VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE */ "Vizite asiyen, tcheke li soti nan orè ou",
        /* VISIT_BY */ "Vizite pa",
        /* VISIT_CHAT */ "Vizite Chat",
        /* VISIT_COMPLETE */ "Ou fin fè vizit sa a!",
        /* VISIT_COMPLETED_SUCCESSFULLY */ "Vizite ranpli avèk siksè",
        /* VISIT_COUNTS */ null,
        /* VISIT_COUNTS_DESCRIPTION */ null,
        /* VISIT_DATE */ "Vizite dat",
        /* VISIT_DATES */ "Vizite dat",
        /* VISIT_DETAILS */ "Vizite detay",
        /* VISIT_DURATION */ "Vizite dire",
        /* VISIT_INFORMATION */ "Vizite Enfòmasyon",
        /* VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU */ null,
        /* VISIT_LASTING */ "Vizite ki dire lontan",
        /* VISIT_NEXT_MONTH */ null,
        /* VISIT_NOTIFICATIONS_OFF */ "Vizite Notifikasyon - Off",
        /* VISIT_NOTIFICATIONS_ON */ "Vizite Notifikasyon - Sou",
        /* VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE */ "Ou poko reusi nan vizit sa a. Èske ou sèten ou vle revèy soti?",
        /* VISIT_NO_LONGER_AVAILABLE */ "Vizite pa disponib ankò",
        /* VISIT_RATE_REQUEST_CONFIRMATION */ "Pousantaj la se {visit_rate} $, estime {estimasyon_salary} $ pou chak semèn.",
        /* VISIT_REMINDERS */ "Vizite rapèl",
        /* VISIT_REQUEST_CONFIRMATION_WARNING */ "Sèlman mande ka a si ou entansyon pran li. Refize yon ka apre ou fin mande ka efè Rating ou nan ajans lan.",
        /* VISIT_SCHEDULE */ "Vizite Orè",
        /* VISIT_STARTED_AT */ "Vizite te kòmanse nan",
        /* VISIT_STARTED_MISSING_CLOCK_IN */ "Vizite te kòmanse, ki manke revèy nan",
        /* VISIT_STARTS_AT */ "Vizite kòmanse nan",
        /* VISIT_SUCESSFULLY_CANCELED */ "Vizite avèk siksè anile",
        /* VISIT_TIME_ADJUSTMENT */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_EARLY */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_LATE */ null,
        /* VISIT_TOO_SHORT */ null,
        /* VISIT_TYPE */ null,
        /* VISIT_WITH */ "Vizite ak",
        /* VOUCHER */ "Koupon",
        /* WAITING_FOR_APPROVAL */ "Ap tann pou apwobasyon",
        /* WAITING_TO_BE_SCHEDULED */ "ap tann yo dwe pwograme yo",
        /* WARNING */ "Avètisman!",
        /* WAS_DUE_BETWEEN */ null,
        /* WAS_DUE_ON */ null,
        /* WATCHED */ "Veye",
        /* WATCH_HOW_IT_WORKS */ "Gade ki jan li fonksyone",
        /* WATCH_REQUIRED */ "Gade obligatwa",
        /* WATCH_TRAINING_VIDEOS_TO_COMPLETE */ null,
        /* WEEKLY_DETAILS */ "Detay chak semèn",
        /* WELCOME */ "Byenveni",
        /* WELCOME_BACK */ "Bon retou",
        /* WELCOME_TO_CARE_MOMENTS */ null,
        /* WELCOME_TO_MEDFLYT */ "Byenveni nan Medflyt!",
        /* WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE */ "Nou pral kontan bay ou nan vizit sa a! Men, anvan, ou dwe fini onboarding la.\r\n            Li vrèman fasil 🥰",
        /* WELL_BE_IN_TOUCH_SHORTLY */ "Nou pral an kontak yon ti tan.",
        /* WERE_YOU_REFERRED_BY_SOMEONE */ "Èske ou te refere pa yon moun?",
        /* WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM */ "Nou manke dosye a pou %konfòmite ou_item. Tanpri jwenn yon nouvo ak Upload nan app a",
        /* WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR */ "Nou pa t 'kapab jwenn medikaman an ou ap chèche pou",
        /* WE_COULDNT_FIND_YOUR_AGENCY */ "Nou pa t 'kapab jwenn ajans ou!",
        /* WE_GOT_YOUR_CONFIRMATION */ null,
        /* WE_GOT_YOUR_RESPONSE_WAIT_HH_MM */ "Nou te resevwa repons ou! Ou gen % dekont % jiskaske konfimasyon final la 🤩",
        /* WE_HAVE_ONE_MATCHING_ACCOUNT */ "Nou jwenn yon sèl kont matche ki baze sou detay ou te bay la. sa se ou menm?",
        /* WE_HAVE_X_MATCHING_ACCOUNTS */ "Èske gen yon chans ke youn nan kont sa yo se ou?",
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN */ "Nou bezwen yon selfie verifye idantite ou anvan ou revèy nan",
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT */ "Nou bezwen yon selfie pou verifye idantite ou anvan ou revèy",
        /* WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT */ "Nou pa t 'kapab ouvri sesyon an. Tanpri kontakte Medflyt Sipò",
        /* WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON */ "Nou pral voye ba ou konfimasyon final la byento",
        /* WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE */ "Ki sa ki yon bèl foto! Èske nou ta dwe kontinye?",
        /* WHAT_BENEFITS_CAN_YOU_GET */ null,
        /* WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK */ null,
        /* WHAT_WOULD_YOU_LIKE_TO_DO_FIRST */ "Ki sa ou ta renmen fè premye?",
        /* WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT */ "Chak fwa ou wè yon vizit fleksib ou pral kapab mande fwa yo ki anfòm ou",
        /* WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR */ "Ki vizit ou ta renmen jwenn Instapay pou?",
        /* WHOOPS */ "Whoops",
        /* WHOS_THE_LUCKY_ONE */ null,
        /* WILL_BEGIN_SHORTLY */ "ap kòmanse yon ti tan",
        /* WILL_EXPIRE_IN_DAYS */ "Ap ekspire nan % jou % jou",
        /* WILL_EXPIRE_TOMORROW */ "Ap ekspire demen",
        /* WINNER_ANNOUNCED_IN */ null,
        /* WITH_CAREGIVERS */ "Avèk moun kap bay swen",
        /* WORKING_WITH_AGENCY */ "Mwen ap travay ak yon ajans",
        /* WRONG_DATES_SELECTION */ "Dat seleksyon mal",
        /* WRONG_PHONE_NUMBER */ "Nimewo telefòn mal",
        /* WRONG_PIN */ "PIN mal",
        /* X_DAYS_SELECTED */ "% x jou chwazi",
        /* X_DAYS_TO_COMPLETE */ "%d jou yo fini",
        /* X_DAYS_TO_SELECT */ "% x jou yo chwazi",
        /* X_HOURS_SELECTED */ "% x èdtan chwazi",
        /* X_HOURS_TO_SELECT */ "% x èdtan yo chwazi",
        /* YAY_YOU_WERE_ASSIGNED_TO_A_VISIT */ "Yay ou te asiyen nan yon vizit",
        /* YEAR */ "Ane",
        /* YEARS_OLD */ "Zan",
        /* YES */ "Wi",
        /* YES_ADJUST_TIMES */ null,
        /* YES_DELETE */ "Wi, efase",
        /* YES_I_AM_SURE */ "Wi, mwen sèten",
        /* YES_OVERRIDE_FORM */ null,
        /* YES_REQUEST_ANYWAY */ null,
        /* YES_SCHEDULE_VISIT */ null,
        /* YES_THATS_ME */ "Wi, se mwen",
        /* YES_UPDATE_ALL */ null,
        /* YOURE_ALL_DONE_LETS_GET_YOU_WORKING */ "Ou tout fè! Ann fè ou travay! 😁",
        /* YOURE_IN_THE_RAFFLE */ null,
        /* YOURE_NOT_IN_THE_RAFFLE */ null,
        /* YOURSELF */ "Ou menm",
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD */ null,
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE */ null,
        /* YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS */ "Ajans ou an ka pa gen leson ou. Tanpri eseye pita.",
        /* YOUR_ANSWER_IS_CORRECT */ "Repons ou a kòrèk!",
        /* YOUR_ANSWER_IS_INCORRECT */ "Repons ou an pa kòrèk",
        /* YOUR_COMPLIANCE */ "Konfòmite ou",
        /* YOUR_COMPLIANCE_ITEM_HAS_EXPIRED */ "% Konfòmite ou te ekspire. Tanpri jwenn yon nouvo ak Upload nan app a",
        /* YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS */ "% Konfòmite ou_item se akòz nan % jou % jou. Tanpri jwenn yon nouvo ak Upload nan app a",
        /* YOUR_FILE_IS_BEING_UPLOADED */ "Se dosye ou ke yo te Uploaded",
        /* YOUR_IN_SERVICE_IS_DUE_IN_DAYS */ null,
        /* YOUR_IN_SERVICE_IS_OVER_DUE */ null,
        /* YOUR_MOBILE */ "Mobil ou",
        /* YOUR_REFERERAL_CODE */ "Kòd referans ou",
        /* YOUR_TASK_HAS_BEEN_SCHEDULED_FOR */ null,
        /* YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY */ "Te fwa ou te soumèt avèk siksè.",
        /* YOUVE_BEEN_SUCCESSFULLY_REFERRED */ "Ou te refere avèk siksè!",
        /* YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "Ou te konplete tout leson yo pou kounye a",
        /* YOU_ALREADY_FAILED */ "Ou deja echwe tès la.",
        /* YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT */ "Ou deja gen yon vizit pwograme pou plas tan sa a",
        /* YOU_ALREADY_REQUESTED_THIS_VISIT */ null,
        /* YOU_ALREADY_SUCCEEDED */ "Ou deja reyisi tès la.",
        /* YOU_ARE_ALL_SET */ null,
        /* YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION */ "Ou ap reyorante resous nan pwochen seksyon an!",
        /* YOU_ARE_COMPLIANT */ "Ou konfòme",
        /* YOU_ARE_EXEMPT_FROM_THIS_TEST */ "Ou egzante de tès sa a",
        /* YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD */ "Ou pa gen dwa edite jaden sa a.",
        /* YOU_ARE_NOT_COMPLIANT */ "Ou pa konfòme",
        /* YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM */ null,
        /* YOU_ARE_OUT_OF_COMPLIANCE */ "Ou se soti nan konfòmite. Ale nan paj konfòmite a pou aprann plis",
        /* YOU_ARE_X_DAYS_LATE */ "Ou se %d jou an reta.",
        /* YOU_CANNOT_EDIT_YOUR_ANSWERS */ "Ou pa ka edite repons ou yo",
        /* YOU_CANT_EDIT_VISIT_WITH_CICO */ null,
        /* YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES */ "Ou pa ka gen plis pase yon sèl direktè lekòl oswa dyagnostik chirijikal.",
        /* YOU_CANT_SIGN_BEFORE_ALL_ANSWERED */ "Ou ka siyen dokiman sa a sèlman lè tout kesyon yo fini",
        /* YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE */ "Ou pa ka itilize menm kòd la ICD plis pase yon fwa.",
        /* YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT */ "Ou ka chwazi ki jou ak èdtan!",
        /* YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT */ "Ou ka chwazi ki jou!",
        /* YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT */ "Ou ka chwazi ki èdtan!",
        /* YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME */ "Ou ka kolekte pwen ou yo nan entre -temps la 🥳",
        /* YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED */ "Ou ka kontakte pasyan an si sa nesesè",
        /* YOU_CAN_CONTINUE_TO_NEXT_SECTION */ "Antretan ou ka kontinye nan pwochen seksyon an!",
        /* YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY */ "Ou kounye a pa gen ase balans yo ka resevwa instapaid.",
        /* YOU_DIDNT_ANSWER_ALL_QUESTIONS */ "Ou pa t 'reponn tout kesyon yo, ou ka tounen vin jwenn yo pita.",
        /* YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN */ "Ou pa t 'antre nan kòd la PIN menm. Tanpri eseye ankò.",
        /* YOU_DONT_HAVE_ANY_CASES_YET */ "Ou pa gen okenn ka ankò",
        /* YOU_DONT_HAVE_ANY_PATIENTS_YET */ "Ou poko gen pasyan",
        /* YOU_GET_POINTS */ "Ou jwenn pwen:",
        /* YOU_GOT_THE_CASE */ "Ou te resevwa ka a!",
        /* YOU_GOT_THE_CERTIFICATE */ "Ou te resevwa sètifika a!",
        /* YOU_HAVENT_CLOCKED_IN_YET */ "Ou poko reusi",
        /* YOU_HAVENT_CLOCKED_OUT_YET */ "Ou poko reusi",
        /* YOU_HAVENT_UPLOADED_ANYTHING_YET */ "Ou poko telechaje anyen",
        /* YOU_HAVE_COMPLETED_THIS_TEST */ "Ou fin fè tès sa a",
        /* YOU_HAVE_HH_MM_TO_CONFIRM_IT */ "Ou gen % Countdown konfime li!",
        /* YOU_HAVE_MISSING_COMPLIANCE_ITEMS */ "Ou gen atik konfòmite ki manke. Ale nan paj konfòmite a pou aprann plis",
        /* YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW */ "Ou gen plis pase 1 chanjman ki aktif kounye a",
        /* YOU_HAVE_NOT_WATCHED */ "Ou pa gade",
        /* YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY */ "Ou pa gen okenn tantativ kite. Tanpri kontakte ajans ou an",
        /* YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS */ null,
        /* YOU_HAVE_ONE_ATTEMPT_LEFT */ "Ou gen yon sèl tantativ kite",
        /* YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING */ "Ou gen yon sèl jou a ranpli fòmasyon sa a!",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION */ "Ou te konplete avèk siksè seksyon %a",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING */ "Ou te konplete avèk siksè fòmasyon sa a 🚀",
        /* YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY */ "Ou dwe ranpli fòmasyon sa a jodi a. Fè vit!",
        /* YOU_HAVE_TO_ENROLL_FIRST */ "Yo nan lòd yo gade leson sa a, ou gen enskri an premye",
        /* YOU_HAVE_TO_PICK_A_CODE */ "Ou dwe chwazi yon kòd.",
        /* YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT */ "Ou dwe chwazi omwen yon chanjman",
        /* YOU_HAVE_X_ATTEMPTS_LEFT */ "Ou gen %D tantativ kite",
        /* YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST */ "Ou gen %D eseye reponn tès sa a",
        /* YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y */ "Ou gen %d repons kòrèk soti nan %d",
        /* YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING */ "Ou gen %d jou pou konplete fòmasyon sa a!",
        /* YOU_JUST_GOT_PAID */ "Ou jis te peye 🥳",
        /* YOU_JUST_GOT_PROMOTED_TO */ null,
        /* YOU_LOSE_POINTS */ "Ou pèdi pwen:",
        /* YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS */ "Ou ka chanje anviwònman vizit ou yo resevwa vizit ki pi enpòtan",
        /* YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE */ "Ou ka pa reponn tès la paske",
        /* YOU_MAY_ONLY_SUBMIT_AFTER */ "Ou ka sèlman soumèt apre ou fin ranpli",
        /* YOU_MISSED_A_SHIFT_WITHOUT_NOTICE */ null,
        /* YOU_MUST_ANSWER_ALL_THE_QUESTIONS */ "Ou dwe reponn tout kesyon yo.",
        /* YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT */ null,
        /* YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST */ "Ou dwe gade videyo anvan yo an premye",
        /* YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION */ "Ou bezwen pèmèt aksè nan kote GPS ou. Sinon, ou pa pral kapab revèy nan oswa soti.",
        /* YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE */ null,
        /* YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS */ "Ou bezwen antre nan yon nòt nan tout travay ki nesesè yo ki pa ranpli, eksplike poukisa ou pa t 'ranpli travay sa a 🙏🏼",
        /* YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS */ "Ou bezwen make tout travay ki nesesè yo kòm ranpli oswa pa ranpli 🙏🏼",
        /* YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT */ null,
        /* YOU_RECENTLY_WON_A_RAFFLE */ null,
        /* YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT */ "Ou ta dwe mete mask ou vizit la tout antye",
        /* YOU_USED_THE_CODE */ "Ou te itilize kòd la",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE */ "Ou pral tonbe soti nan konfòmite nan % jou % jou. Ale nan paj konfòmite a pou aprann plis",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS */ null,
        /* YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS */ "Ou pral wè lajan an nan kont ou nan pwochen 24 èdtan yo."
    ],
    "kr": [
        /* ACCEPTED */ "받아 들여졌다",
        /* ACCEPT_THESE_HOURS */ "이 시간을 받아들이십시오",
        /* ACCEPT_THE_VISIT_AT */ "방문을 수락하십시오",
        /* ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY */ null,
        /* ACCOUNT_NUMBER */ null,
        /* ACCOUNT_TYPE */ null,
        /* ACTIVE */ "활동적인",
        /* ACTIVE_DOCUMENT */ "활성 문서",
        /* ADD */ "추가하다",
        /* ADDITIONAL_NOTES */ null,
        /* ADDRESS */ "주소",
        /* ADDRESS2 */ "주소 2",
        /* ADDRESS_ERROR */ "주소 오류",
        /* ADDRESS_IS_NEAR */ null,
        /* ADD_ANOTHER_DOCUMENT */ null,
        /* ADD_ANOTHER_PERTINENT_DIAGNOSIS */ "다른 관련 진단을 추가하십시오",
        /* ADD_IMAGE */ "이미지 추가",
        /* ADD_NEW_MEDICATION */ "새로운 약을 추가하십시오",
        /* ADD_NOTES */ "메모 추가",
        /* ADD_NOTE_TO_PATIENT_PROFILE_BUTTON */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_TITLE */ null,
        /* ADD_PHYSICIAN */ null,
        /* ADD_YOUR_SIGNATURE */ null,
        /* ADVANCED_DIRECTIVES */ null,
        /* AGENCIES_CONTACT */ "대행사는 곧 연락 할 것입니다",
        /* AGENCY */ "대행사",
        /* AGENCY_CODE */ "대행사 코드",
        /* AGENCY_COORDINATOR */ "대행사 코디네이터",
        /* AGENCY_DETAILS */ "대행사 세부 사항",
        /* AGENCY_HANDBOOK */ null,
        /* AGENCY_ISSUES */ null,
        /* AGENCY_NAME */ "대행사 이름",
        /* AGENCY_NOTIFICATIONS */ "대행사 알림",
        /* AGENCY_NOT_FOUND */ "대행사는 찾을 수 없습니다",
        /* AGREE_TO_MEDFLYT_TERMS */ "승인을 클릭함으로써 귀하는 귀하가 Meflyt 개인 정보 보호 정책의 조건을 읽고 동의했다는 데 동의합니다.",
        /* AIDE */ null,
        /* AIRPODS */ null,
        /* ALLERGIES */ "알레르기",
        /* ALLOW_ACCESS_TO_MY_LOCATION */ null,
        /* ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP */ null,
        /* ALL_CHANGES_SAVED */ null,
        /* ALL_DAY */ "하루 종일",
        /* ALL_DONE */ "다 끝났어!",
        /* ALL_TRANSACTIONS */ null,
        /* ALL_VERIFIED_ITEMS */ null,
        /* ALREADY_CLOCKED_IN */ "이미 시계에 들어갔다.",
        /* ALREADY_CLOCKED_IN_ANOTHER_VISIT */ "당신은 이미 다른 방문에서 시계를 기록하고 있습니다.",
        /* ALREADY_CLOCKED_OUT */ "이미 시계가 나왔습니다.",
        /* ALREADY_HAVE_AN_ACCOUNT */ "이미 계정이 있습니다",
        /* AND_AMPERSAND */ "&이었다.",
        /* ANSWERED */ "대답했다",
        /* ANSWERED_AT */ "대답했다",
        /* ANSWER_INCOMPLETE_QUESTIONS */ null,
        /* ANY_DURATION */ "모든 기간",
        /* AN_ERROR_HAS_OCCURED */ "오류가 발생했습니다.",
        /* AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET */ null,
        /* APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES */ "Apple은 컨테스트 나 경품 행사에 어떤 식 으로든 관여하지 않습니다.",
        /* APPLICATION_DONE */ "응용 프로그램이 완료되었습니다!",
        /* APPROVE */ "승인하다",
        /* APPROVED */ null,
        /* APPROVE_THIS_TASK */ null,
        /* APPROVE_THIS_VISIT */ "이 방문을 승인하십시오",
        /* APRIL */ "4월",
        /* ARENT_YOU_MISSING_SOMETHING */ null,
        /* ARE_YOU */ "당신은",
        /* ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY */ "현재 대행사와 협력하고 있습니까?",
        /* ARE_YOU_SURE */ null,
        /* ARE_YOU_SURE_REQUEST_FAR_VISIT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST */ "이 요청을 취소 하시겠습니까?",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT */ "이번 방문을 취소 하시겠습니까?",
        /* ARE_YOU_SURE_YOU_WANT_TO_DELETE */ "삭제 하시겠습니까",
        /* ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE */ "이 번들을 등록 하시겠습니까?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE */ "이 페이지를 제거 하시겠습니까?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE */ "당신이 이것들을 요청하고 싶습니까?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT */ "이 방문을 요청 하시겠습니까?",
        /* ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT */ "가입 하시겠습니까?",
        /* ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK */ null,
        /* ASSIGNED */ "할당된",
        /* ASSIST */ "돕다",
        /* AS_NEEDED */ "필요에 따라",
        /* AS_REQUESTED_BY_THE_PATIENT */ "환자가 요청한대로",
        /* ATTACH_A_DOCUMENT */ null,
        /* AUGUST */ "augusy",
        /* AUTHENTICATION_FAILED */ "인증 실패",
        /* AUTH_VERIFICATION_FAIL_EXAPLINED */ "우리는 당신의 신원을 확인할 수 없었습니다. 도움을 받으려면 대행사 중 하나에 연락하십시오.",
        /* AUTOPLAY */ "다음 항목이 시작됩니다",
        /* AVAILABILITY */ "유효성",
        /* AVAILABLE */ "사용 가능",
        /* AVAILABLE_CARE_POINTS */ null,
        /* AVAILABLE_ON_THE_FOLLOWING_DAYS */ "다음 날에 사용할 수 있습니다",
        /* AVAILABLE_SHIFTS */ "사용 가능한 교대",
        /* AVAILABLE_VISITS */ "사용 가능한 방문",
        /* AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK */ null,
        /* AWAITING_PATIENT_CONTACT */ "대기하는 연락처",
        /* A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT */ "이 환자에게는 치료 계획이 이미 존재합니다",
        /* A_VERIFICATION_CODE_IS_BEING_SENT_TO */ "확인 코드가 전송되고 있습니다",
        /* A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE */ "문자 메시지를 통해 확인 코드가 귀하에게 전송됩니다.",
        /* A_VISIT_BY */ "방문",
        /* BACK */ null,
        /* BACK_TO_ONBOARDING */ null,
        /* BANK_INFORMATION */ null,
        /* BANK_NAME */ null,
        /* BASICALLY_EVERY_ACTION_COUNTS */ null,
        /* BEFORE_SUBMITTING_THE_DUTIES */ null,
        /* BEGIN_NOW */ "지금 시작하십시오",
        /* BEST_TASK_FOR_YOU */ null,
        /* BETWEEN */ "~ 사이",
        /* BETWEEN_AND */ "그리고",
        /* BIRTHDAY */ "생신",
        /* BLOOD_PRESSURE */ "혈압",
        /* BOROUGH */ null,
        /* BUNDLES */ "묶음",
        /* BUNDLE_DESCRIPTION */ "이 번들은 {agen",
        /* BUNDLE_DESCRIPTION_P1 */ "이 번들은 구성됩니다",
        /* BUNDLE_DESCRIPTION_P2 */ "항목. 일부 항목에는 테스트가 포함될 수도 있습니다. 필요한 내용을 시청하십시오. 필요한 작업을 완료하면 인증서를 받게됩니다. 행운을 빌어요",
        /* BUNDLE_IS_LOCKED */ "번들이 잠겨 있습니다",
        /* BUNDLE_ITEM_NOT_FOUND */ "훈련 수업을 찾을 수 없습니다",
        /* BUNDLE_NOT_FOUND */ "교육 과정을 찾을 수 없습니다",
        /* BUNDLE_PROGRESS */ "번들 진행 상황",
        /* BUSY_ALL_DAY */ "하루 종일 바쁘다",
        /* BY */ "에 의해",
        /* BY_ENROLLING_I_ACCEPT_THE */ null,
        /* BY_EXISTING_VISIT */ "기존 방문으로 :",
        /* BY_PATIENT_NAME */ "환자 이름으로 :",
        /* BY_SIGNING_HERE_I_ACCEPT_THE */ "여기에 서명함으로써 나는 그것을 받아들이다",
        /* CALL */ "부르다",
        /* CALL_AGENCY */ "전화 대행사",
        /* CALL_HOME */ "집에 전화 해",
        /* CALL_MOBILE */ "모바일에 전화하십시오",
        /* CALL_NOW */ "지금 전화 :",
        /* CALL_PATIENT */ "환자에게 전화하십시오",
        /* CALL_PATIENT_CONFIRMATION */ null,
        /* CALL_PATIENT_EXPLANATION */ "이 메시지를 확인한 후 잠시 전화를받습니다.",
        /* CALL_PATIENT_HOME */ "환자의 집에 전화하십시오",
        /* CALL_PATIENT_MOBILE */ "환자의 모바일을 호출하십시오",
        /* CALL_PATIENT_NOTE */ "다음 화면에서 환자에게 연락하십시오",
        /* CALL_SUPPORT_FOR_MORE_INFO */ "자세한 정보는 지원을 요청하십시오",
        /* CANCEL */ "취소",
        /* CANCEL_REQUESTED_SHIFTS */ null,
        /* CANCEL_VISIT */ null,
        /* CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE */ null,
        /* CANT_CANCEL_24_HOURS_SCHEDULED_VISIT */ "오류 : 방문은 24 시간 미만입니다",
        /* CANT_CANCEL_AT_THIS_TIME */ "이 시간에 취소 할 수 없습니다",
        /* CANT_CLOCK_IN */ "시계를 넣을 수 없습니다",
        /* CANT_CLOCK_IN_AT_THIS_TIME */ "이 시점에서는 시계를 보낼 수 없습니다.",
        /* CANT_CLOCK_OUT */ "시간이 떨어질 수 없습니다",
        /* CANT_CLOCK_OUT_AT_THIS_TIME */ "이 시점에서는 시간이 떨어질 수 없습니다.",
        /* CANT_CLOCK_OUT_BEFORE_VISIT_ENDED */ "방문이 끝나기 전에는 시간이 걸리지 않습니다.",
        /* CANT_REJECT_VISIT_PENDING_STATUS */ null,
        /* CANT_REQUEST_JOIN_AGENCY */ "대행사 가입을 요청할 수 없습니다",
        /* CANT_REQUEST_VISIT_PENDING_STATUS */ null,
        /* CANT_SUBMIT_AN_EMPTY_FORM */ "빈 양식을 제출할 수 없습니다. 질문에 답하십시오.",
        /* CANT_WATCH_ON_SHIFT */ "이 훈련은 모든 교대 중에 비활성화됩니다",
        /* CANT_WATCH_THIS_VIDEO */ "이 비디오를 볼 수 없습니다",
        /* CAREBACK_CASH_BONUS */ null,
        /* CAREBACK_POINTS */ null,
        /* CAREGIVER */ "간병인",
        /* CAREGIVER_COMPLIANCE_PASSPORT */ "간병인 준수 여권",
        /* CAREGIVER_NAME */ "간병인 이름",
        /* CAREGIVER_PHONE */ "간병인 전화",
        /* CAREGIVER_SIGNATURE */ null,
        /* CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG */ "귀하와 환자가 치료 계획에 서명했는지 확인하십시오.",
        /* CAREGIVER_SIGNATURE_IS_REQUIRED */ null,
        /* CAREGIVER_SIGNATURE_REQUIRE_MSG */ "치료 계획에 서명하십시오.",
        /* CAREGIVER_STATUS_PENDING_ERROR */ "프로필이 아직 보류 중이기 때문에 작업을 수행 할 수 없습니다.",
        /* CARE_MOMENTS */ null,
        /* CASE_INFO */ null,
        /* CASE_IS_TOO_FAR */ "케이스가 너무 멀다",
        /* CASE_SETTINGS */ "케이스 설정",
        /* CATALOGUE */ "목록",
        /* CERTIFICATION */ "인증",
        /* CERTIFICATIONS */ "인증",
        /* CHANGE */ "변화",
        /* CHANGES_TO_MY_VISITS */ "내 방문 변경",
        /* CHANGES_WERE_SAVED_IN_THE_CLOUD */ "모든 변경 사항은 클라우드에 저장되었습니다",
        /* CHANGE_DOCUMENT */ null,
        /* CHANGE_OF_RANKING */ null,
        /* CHANGE_PHONE_NUMBER */ "전화 번호를 변경하십시오",
        /* CHANGE_SETTINGS */ null,
        /* CHANGE_SHIFTS */ null,
        /* CHANGE_TASK_TIME */ null,
        /* CHANGE_VISIT_TIMES */ "방문 시간을 변경하십시오",
        /* CHAT */ "채팅",
        /* CHATS */ "채팅",
        /* CHAT_MESSAGES */ "채팅 메시지",
        /* CHAT_NOT_ACTIVE_MESSAGE */ "여기에서 메시지를 보낼 수 없습니다.",
        /* CHAT_NOT_ACTIVE_TITLE */ "채팅은 더 이상 활성화되지 않습니다",
        /* CHAT_WITH_AGENCY */ "대행사와 채팅",
        /* CHAT_WITH_AGENCY_ABOUT_PATIENT */ "%s와 약 %s와 채팅",
        /* CHAT_WITH_MEDFLYT */ null,
        /* CHAT_WITH_OTHER_AGENCIES */ null,
        /* CHAT_WITH_SUPPORT */ "지원과 채팅",
        /* CHAT_WITH_US */ "우리와 채팅",
        /* CHECK */ null,
        /* CHECK_AGAIN */ null,
        /* CHOOSE_ANOTHER_DATE */ "다른 날짜를 선택하십시오",
        /* CHOOSE_A_PHOTO */ "사진을 선택하십시오",
        /* CHOOSE_A_TIME_FOR_THE_VISIT */ "방문 시간을 선택하십시오",
        /* CHOOSE_CLOCK_TIMES */ null,
        /* CHOOSE_DATE_TO_PERFORM_THIS_TASK */ "이 작업을 수행하려면 날짜를 선택하십시오",
        /* CHOOSE_FOLDER_TO_UPLOAD */ "업로드 할 폴더를 선택하십시오",
        /* CHOOSE_START_TIME */ "시작 시간을 선택하십시오",
        /* CHOOSE_THE_HOURS */ "다음 (시간 선택)",
        /* CHOOSE_TIME */ "시간을 선택하십시오",
        /* CHOOSE_WHEN_TO_PERFORM_THE_VISIT */ "방문시기를 선택하십시오",
        /* CHOOSE_WHEN_TO_VISIT_THE_PATIENT */ "환자를 방문 할시기를 선택하십시오",
        /* CHOOSE_WHO_TO_CONTACT */ "연락 할 사람을 선택하십시오",
        /* CHOOSING_A_WINNER */ null,
        /* CHOOSING_A_WINNER_IN */ null,
        /* CLEAR */ "분명한",
        /* CLICK_HERE */ null,
        /* CLICK_HERE_TO_DOWNLOAD */ "다운로드하려면 여기를 클릭하십시오",
        /* CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE */ "추천 코드를 공유하려면 여기를 클릭하십시오",
        /* CLICK_HERE_TO_VIEW_CERTIFICATE */ "인증서를 보려면 여기를 클릭하십시오",
        /* CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE */ "첫 번째 인증서를 축하합니다! 새 인증서를 보려면 클릭하십시오",
        /* CLICK_TO_REQUEST */ "요청하려면 클릭하십시오!",
        /* CLICK_TO_SCAN_UPLOAD */ "스캔하고 업로드하려면 클릭하십시오",
        /* CLICK_TO_TAKE_A_SELFIE */ null,
        /* CLIMB_THE_RANKS_BY_COMPLETING_VISITS */ null,
        /* CLINICAL_SUPPORT */ "임상 지원",
        /* CLOCKED_IN */ "시계",
        /* CLOCKED_IN_AND_OUT */ null,
        /* CLOCKED_IN_AT */ "at",
        /* CLOCKED_OUT */ "시계",
        /* CLOCKED_OUT_AT */ "시계에서",
        /* CLOCKING_IN */ "시계 ...",
        /* CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES */ null,
        /* CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES */ null,
        /* CLOCKING_OUT */ "시계 ...",
        /* CLOCK_ADDRESS_IN_RANGE */ null,
        /* CLOCK_ADDRESS_NOT_IN_RANGE */ null,
        /* CLOCK_IN */ "시계",
        /* CLOCK_IN_ANYWAY */ null,
        /* CLOCK_IN_AT */ "시계",
        /* CLOCK_IN_BETWEEN */ null,
        /* CLOCK_IN_OUT */ "시계 인 / 아웃",
        /* CLOCK_IN_OUT_SUBMIT_DUTIES */ null,
        /* CLOCK_IN_TIME_IS_REQUIRED */ null,
        /* CLOCK_OUT */ "시계",
        /* CLOCK_OUT_AFTER */ "후시",
        /* CLOCK_OUT_AT */ "시계에서",
        /* CLOCK_OUT_BETWEEN */ null,
        /* CLOCK_OUT_TIME_IS_REQUIRED */ null,
        /* CLOCK_TIMES_NOT_MOBILE */ null,
        /* CLOCK_TIME_IN_RANGE */ null,
        /* CLOCK_TIME_NOT_IN_RANGE */ null,
        /* CLOSE */ "닫다",
        /* CLOSE_SURVEY */ "면밀한 설문 조사",
        /* CLUSTERED_VISIT_EXPLENATION */ "우리는이 2 번의 방문이 함께 가깝고 일일 일정에 맞는 것을 감지했습니다. 이 두 방문을 함께 요청하는 것이 좋습니다. 각 방문을 개별적으로 요청할 수도 있습니다",
        /* CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE */ "코드를 찾을 수 없습니다. 다른 코드를 사용하십시오",
        /* COMBINED_CASE */ "결합 된 케이스",
        /* COMING_SOON */ "곧 올 것입니다",
        /* COMPLETED */ "완전한",
        /* COMPLETED_DOCUMENTS */ "완성 된 문서",
        /* COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL */ null,
        /* COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS */ null,
        /* COMPLETE_PREVIOUS_SECTIONS_FIRST */ null,
        /* COMPLETE_REGISTRATION */ null,
        /* COMPLETE_REGISTRATION_PROCESS */ null,
        /* COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* COMPLETE_VISIT */ null,
        /* COMPLETE_YOUR_ONBOARDING_ANYTIME */ null,
        /* COMPLIANCE */ "규정 준수",
        /* COMPLIANCE_EXPIRY */ "비디오는주의가 필요합니다",
        /* COMPLIANCE_FORM */ null,
        /* COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY */ null,
        /* COMPLIANT */ "준수",
        /* COMPLIANT_ITEMS */ null,
        /* CONFIRM */ "확인하다",
        /* CONFIRM_ASSESSMENT */ "평가 확인",
        /* CONFIRM_COPY_LAST */ "답변을 복사하고 싶습니까?",
        /* CONFIRM_COPY_LAST_TITLE */ "사본 확인?",
        /* CONFIRM_DEPOSIT_DETAILS */ null,
        /* CONFIRM_PATIENT_AVAILABILITY */ null,
        /* CONFIRM_PATIENT_AVAILABILITY_MESSAGE */ null,
        /* CONFIRM_RN_FLEX_VISIT */ "나는 내 방문을 확인합니다",
        /* CONFIRM_WITHOUT_LOCATION */ "위치없이 확인하십시오",
        /* CONGRATULATIONS */ null,
        /* CONGRATULATIONS_TO */ null,
        /* CONNECTING_HOME */ "집에 연결",
        /* CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS */ "가정 보건 기관을 간병인과 연결합니다",
        /* CONNECT_WITH_US_ON_FACEBOOK */ "Facebook에서 우리와 연결하십시오",
        /* CONNECT_WITH_US_ON_WHATSAPP */ "WhatsApp에서 우리와 연결하십시오",
        /* CONTACT */ "연락하다",
        /* CONTACT_AGENCY_FOR_MORE_INFO */ "자세한 내용은 기관에 문의하십시오.",
        /* CONTACT_PATIENT */ "연락 환자",
        /* CONTACT_SUPPORT */ "연락처 지원",
        /* CONTINUE */ "계속하다",
        /* CONTINUE_LATER */ "나중에 계속하십시오",
        /* CONTINUE_TO_APP */ null,
        /* CONTINUE_TO_ORIENTATION */ null,
        /* CONTINUE_TO_SIGN_UP */ "계속 가입하십시오",
        /* CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK */ null,
        /* COORDINATOR */ "조정자",
        /* COORDINATOR_EMAIL */ "코디네이터 이메일",
        /* COORDINATOR_IN_CHARGE */ "코디네이터",
        /* COORDINATOR_PHONE */ "코디네이터 전화",
        /* COPY */ "복사",
        /* COPY_FROM_LAST_TIME */ "마지막으로 복사하십시오",
        /* COPY_FROM_MEDICATION */ "약물에서 복사하십시오",
        /* COPY_FROM_OTHER_FORMS */ "다른 형식에서 복사하십시오",
        /* COPY_LAST_NO_DATE_FALLBACK_APPENDED */ "마지막으로",
        /* COPY_MEDICATION_CHART */ "약물 차트를 복사하십시오",
        /* COPY_PLAN_OF_CARE */ "치료 계획을 복사하십시오",
        /* CORRECT */ "옳은",
        /* COURSES */ "과정",
        /* COVID */ "코로나바이러스감염증-19 : 코로나19",
        /* COVID_REQUIRED */ "Covid-19 설문지가 필요합니다",
        /* COVID_REQUIRED_EXPLAINED */ "오늘 Covid-19 설문지를 작성하지 않았습니다. 계속하려면 채우십시오",
        /* COVID_SCREENING_CLICK_HERE */ "COVID -19 스크리닝 - 여기를 클릭하십시오",
        /* CREATED_AT */ "만들어졌습니다",
        /* CREATE_A_NEW_ACCOUNT */ "새 계정 생성",
        /* CREATE_NEW_PLAN_OF_CARE */ "새로운 치료 계획을 세우십시오",
        /* CRIMINAL_CONVICTIONS_RECORDS */ null,
        /* CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT */ "현재 다른 방문으로 클럭되었습니다",
        /* CURRENT_BALANCE */ null,
        /* CURRENT_VISIT */ null,
        /* DATA_WILL_BE_LOST */ "데이터가 손실됩니다",
        /* DATE */ "날짜",
        /* DATES */ "날짜",
        /* DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO */ null,
        /* DATE_NOT_SPECIFIED */ "날짜가 지정되지 않았습니다",
        /* DATE_OF_BIRTH */ "생일",
        /* DATE_UNKNOWN */ null,
        /* DATE_VERIFICATION */ "날짜 확인",
        /* DAY */ "요일",
        /* DAYS */ "날",
        /* DAYS_A_WEEK */ "일주일에 며칠",
        /* DAYS_LEFT */ "남은 날",
        /* DAYS_OF_WEEK */ "일주일에 며칠",
        /* DECEMBER */ "12 월",
        /* DECLINED */ "거절했다",
        /* DELETE */ "삭제",
        /* DESCRIBE_THE_PROBLEM */ "문제를 설명하십시오",
        /* DETAILS */ "세부",
        /* DIRECTIONS */ "지도",
        /* DIRECT_DEPOSIT */ null,
        /* DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION */ "연결이 끊어졌습니다. 인터넷 연결을 확인하십시오",
        /* DISCOVER_YOUR_JOURNEY */ null,
        /* DISCRIMINATION */ null,
        /* DISMISS */ "해고하다",
        /* DISMISSED */ null,
        /* DISTANCE */ "거리",
        /* DOB */ null,
        /* DOCUMENT */ "문서",
        /* DOCUMENTS */ "서류",
        /* DOCUMENTS_TO_COMPLETE */ null,
        /* DOCUMENT_HAS_EXPIRED */ "문서가 만료되었습니다",
        /* DOCUMENT_IS_MISSING */ "문서가 누락되었습니다",
        /* DOCUMENT_REJECTED */ "문서가 거부되었습니다",
        /* DOCUMENT_SELECTED */ null,
        /* DOESNT_EXPIRE */ null,
        /* DOES_NOT_FIT_MY_SCHEDULE */ "내 일정에 맞지 않습니다",
        /* DONE */ "완료",
        /* DONT_FORGET_TO_CLOCK_IN */ null,
        /* DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS */ null,
        /* DONT_FORGET_TO_CLOCK_OUT */ "시계를 잊지 마십시오",
        /* DONT_FORGET_TO_FILL_THE_DUTY_SHEET */ null,
        /* DONT_FORGET_TO_SMILE */ null,
        /* DONT_SCHEDULE_VISIT */ null,
        /* DONT_SHOW_AGAIN */ "다시는 표시하지 마십시오",
        /* DOSE */ "정량",
        /* DOWNLOAD_PDF */ null,
        /* DO_YOU_HAVE_ANY_QUESTIONS_ASK */ null,
        /* DO_YOU_WANT_THIS_VISIT */ null,
        /* DUE_BETWEEN */ null,
        /* DUE_BY_DATETIME */ null,
        /* DUE_DATE */ "마감일",
        /* DUE_ON */ null,
        /* DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO */ null,
        /* DURATION */ "지속",
        /* DURATION_PER_DAY */ "하루에 기간",
        /* DUTIES */ null,
        /* DUTIES_COMPLETED_SUCCESSFULLY */ null,
        /* DUTY_SHEET_SUBMITTED */ "의무 시트 제출",
        /* EACH_100_POINTS_DOLLAR */ null,
        /* EACH_INVITE */ "각 초대",
        /* EARLY_OR_LATE_CLOCKS */ null,
        /* EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY */ null,
        /* EDIT */ "편집하다",
        /* EDIT_ACCOUNT_DETAILS */ null,
        /* EDIT_TIMES */ "시간 편집",
        /* EDUCATION */ "교육 센터",
        /* ELECTRIC_EQUIPMENT_DEPENDENCY */ null,
        /* ELIGIBLE_VISITS */ null,
        /* EMAIL */ null,
        /* EMAIL_QUESTION_PENDING_VERIFICATION */ null,
        /* EMAIL_SUPPORT */ null,
        /* EMAIL_SUPPORT_FOR_MORE_INFO */ "자세한 정보를 위해 이메일 지원",
        /* EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER */ null,
        /* EMAIL_VERIFICATION_QUESTION_LABEL */ null,
        /* EMERGENCY_CONTACTS */ null,
        /* EMPTY_DURATION */ null,
        /* EMPTY_PATIENT_MEDICATION_PROFILE */ "환자 약물 프로파일은 비어 있습니다",
        /* ENABLE_LOCATION_MESSAGE */ null,
        /* ENABLE_LOCATION_TITLE */ null,
        /* ENDING_AT */ "끝나는",
        /* ENDS */ "끝",
        /* END_DATE */ "종료 날짜",
        /* END_TIME */ "종료 시간",
        /* ENROLLMENT_REQUESTED */ "등록 요청",
        /* ENROLL_NOW */ "지금 등록",
        /* ENTER_AGENCY_CODE */ "대행사 코드를 입력하십시오",
        /* ENTER_DOCUMENT_NAME */ "문서 이름을 입력하십시오",
        /* ENTER_NUMBER_HERE */ "여기에 번호를 입력하십시오",
        /* ENTER_TEXT_HERE */ "여기에 텍스트를 입력하십시오",
        /* ENTER_YOUR_MOBILE_NUMBER */ "당신의 휴대폰 번호를 입력하십시오",
        /* ENTER_YOUR_PIN_CODE */ "PIN 코드를 입력하십시오",
        /* ENTITY_IS_MISSING */ "%s 필드가 누락되었습니다. 채워 졌는지 확인한 다음 다시 시도하십시오.",
        /* ERROR */ "오류",
        /* ERROR_FETCHING_SLOTS */ null,
        /* ERROR_LOADING_DATA */ null,
        /* ERROR_REMOVING_DOCUMENT */ "문서를 제거하는 동안 오류가 발생했습니다",
        /* ERROR_SCHEDULING_TASK */ null,
        /* ERROR_SCHEDULING_TASK_MESSAGE */ null,
        /* ESTIMATED_ADDRESS_WILL_BE_PROVIDED */ null,
        /* ESTIMATED_TIME_OF_CLOCKING_OUT_IS */ null,
        /* EVACUATION_LOCATION */ null,
        /* EVACUATION_ZONE */ null,
        /* EVERY_VISIT */ "방문마다",
        /* EVV */ null,
        /* EXCITING_NEWS_AHEAD */ null,
        /* EXEMPTED */ "면제되었습니다",
        /* EXPIRED */ "만료되었습니다",
        /* EXPIRED_COMPLIANCE */ null,
        /* EXPIRED_ON_DATE */ null,
        /* EXPIRES_AT */ "만료",
        /* EXPIRES_IN */ "만료",
        /* EXPIRES_IN_ONE_DAY */ "하루 만에 만료됩니다",
        /* EXPIRES_IN_X_DAYS */ "%d 일에 만료됩니다",
        /* EXPIRES_ON_DATE */ null,
        /* EXPIRING_COMPLIANCE */ null,
        /* EXPIRING_SOON */ null,
        /* EXPIRY_DATE */ "만료일",
        /* EXPLORE */ null,
        /* EXPLORE_A_CAREER_ENHANCEMENTS */ null,
        /* FAILED_TO_IDENTIFY_PATIENT */ "환자를 식별하지 못했습니다",
        /* FAR_VISIT_WARNING_MODAL_TITLE */ null,
        /* FAX_NUMBER */ null,
        /* FEBRUARY */ "2월",
        /* FEMALE */ "여성",
        /* FIFTHY_DOLLAR_AMAZON_GIFT_CARD */ null,
        /* FILES */ "파일",
        /* FILE_NOT_FOUND_CONTACT_AGENCY */ null,
        /* FILL */ null,
        /* FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT */ null,
        /* FILL_IN_THE_QUESTIONNAIRE */ "설문지를 작성하십시오",
        /* FILTERS */ "필터",
        /* FINAL_CONFIRMATION */ null,
        /* FIND_A_CARE_MOMENT */ null,
        /* FIND_A_CARE_MOMENT_DESCRIPTION */ null,
        /* FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FINISH_MY_ONBOARDING */ null,
        /* FINISH_ONBOARDING_AND_GET_DOLLARS */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2 */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE_STAGE_2 */ null,
        /* FINISH_SHIFT */ null,
        /* FINISH_THE_DOCUMENTS */ null,
        /* FIRST_NAME */ "이름",
        /* FIRST_SHIFT */ "첫 번째 교대",
        /* FIVE_THOUSAND_POINTS */ null,
        /* FIX */ null,
        /* FIX_DOCUMENTS_DESCRIPTION */ null,
        /* FIX_DOCUMENT_DESCRIPTION */ null,
        /* FIX_ISSUE */ null,
        /* FIX_ISSUES */ null,
        /* FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* FIX_SETTINGS */ "설정을 수정하십시오",
        /* FIX_THE_DOCUMENT */ null,
        /* FIX_THE_DOCUMENTS */ null,
        /* FIX_YOUR_DOCUMENT */ null,
        /* FIX_YOUR_DOCUMENTS */ null,
        /* FLEXIBLE */ null,
        /* FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_VISIT */ "유연한 날 방문",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT */ null,
        /* FLEXIBLE_HOURS_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_VISIT */ "유연한 시간 방문",
        /* FLEXIBLE_VISIT */ "유연한 방문",
        /* FLEXIBLE_VISIT_DAY_TO_CHOOSE */ null,
        /* FLEXIBLE_VISIT_DETAILS */ "유연한 방문 세부 정보",
        /* FLEXIBLE_VISIT_TYPE */ "유연한 방문",
        /* FLU_SHOT */ null,
        /* FLU_SHOT_SUBMITTION_MESSAGE */ null,
        /* FOLLOW_US_ON_INSTAGRAM */ "Instagram에서 우리를 따르십시오",
        /* FOLLOW_US_ON_TWITTER */ "트위터에서 우리를 따르십시오",
        /* FORGOT_PIN_CODE_DIALOG_MESSAGE */ "새 등록 프로세스를 시작하려면 로그인 화면으로 이동합니다.",
        /* FORM_NAME */ "양식 이름",
        /* FOURTEEN_THOUSAND_POINTS */ null,
        /* FREQUENCY */ "빈도",
        /* FRIEND */ "친구",
        /* FROM */ "에서",
        /* FROM_CAMERA */ "카메라에서",
        /* FROM_GALLERY */ "갤러리에서",
        /* FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE */ "전체 이용 약관 - Medflyt Challenge",
        /* FUTURE_VISITS */ null,
        /* GENDER */ "성별",
        /* GENERAL */ "일반적인",
        /* GENERAL_FILES */ "일반 파일",
        /* GENERAL_NOTES */ "일반 노트",
        /* GENERAL_SUPPORT */ null,
        /* GET_INSTAPAY */ null,
        /* GET_IT_NOW */ "지금 사세요",
        /* GET_MONEY_FOR_THIS_VISIT_TODAY
 */ null,
        /* GET_NOW */ null,
        /* GET_STARTED */ null,
        /* GET_THE_APP */ "앱을 얻으십시오",
        /* GET_X_NOW */ null,
        /* GOOD_JOB */ "잘 했어!",
        /* GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "잘 했어! 지금은 모든 수업을 완료했습니다",
        /* GOT_IT */ "알았다",
        /* GO_BACK */ "돌아 가라",
        /* GO_TO */ "이동",
        /* GO_TO_MEDFLYT_PASSPORT */ "Medflyt 여권으로 가십시오",
        /* GO_TO_PATIENT */ "환자에게 가십시오",
        /* GO_TO_PATIENT_DETAILS */ "환자 세부 정보로 이동하십시오",
        /* GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION */ null,
        /* GO_TO_VISIT */ "방문하러 가십시오",
        /* GREAT_JOB */ "잘 했어!",
        /* GROSS_PAY */ null,
        /* HAS_DNR */ null,
        /* HAS_HEALTH_CARE_PROXY */ null,
        /* HAVE_A_NICE_WORKING_DAY */ null,
        /* HAVE_A_PLEASANT_VISIT */ null,
        /* HAVE_A_QUESTION_LETS_CHAT */ null,
        /* HEALTH_AGENCIES */ "보건 기관",
        /* HELP */ "돕다",
        /* HELP_ME_FIND_MY_AGENCY */ "내 대행사를 찾도록 도와주세요",
        /* HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY */ null,
        /* HEY */ "여기요!",
        /* HEY_THERE */ "이봐",
        /* HI */ "안녕",
        /* HIRE_DATE */ null,
        /* HI_PLEASE_HELP_ME_FILL_MY_APPLICATION  */ null,
        /* HOME_PHONE */ "집 전화",
        /* HOUR */ null,
        /* HOURS */ "시간",
        /* HOURS_PER_DAY */ "하루에 시간",
        /* HOURS_PER_VISIT */ "방문 당 시간",
        /* HOW_ARE_WE_CALCULATING_THE_RANK */ null,
        /* HOW_CAN_WE_HELP_YOU */ "어떻게 도와 드릴까요?",
        /* HOW_CARE_MOMENTS_WORKS */ null,
        /* HOW_DID_YOU_HEAR_ABOUT_US */ "우리에 대해 어떻게 들었습니까?",
        /* HOW_DOES_IT_WORK */ null,
        /* HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS */ "환자는 어떻게 느끼나요? 주요 증상은 무엇입니까?",
        /* HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN */ "기분이 좋아지는 환자를 어떻게 격려합니까?",
        /* HOW_DO_YOU_RATE_MEDFLYT */ "Medflyt를 어떻게 평가합니까?",
        /* HOW_URGENT_IS_THE_ISSUE */ "문제는 얼마나 시급합니까?",
        /* HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT */ "환자에게 어떻게 전화하고 싶습니까?",
        /* HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE */ "파일을 어떻게 업로드 하시겠습니까?",
        /* HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT */ null,
        /* HR_PER_VISIT */ "방문당 HR",
        /* HUNDRED_DOLLARS_GIFT_CARD */ "$ 100 amex 기프트 카드",
        /* ICD */ "ICD",
        /* ID */ null,
        /* IF_YOU_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON */ null,
        /* IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE */ null,
        /* IF_YOU_STAY_COMPLIANT */ null,
        /* IMPORTANT_INFORMATION */ null,
        /* IMPORTED */ "수입",
        /* IM_AVAILABLE */ "가능합니다",
        /* IM_DONE_SUBMIT */ null,
        /* IM_NOT_INTERESTED */ "난 관심 없어",
        /* IM_WORKING_WITH_AN_AGENCY */ "대행사와 함께 일하고 있습니다",
        /* INACTIVE */ "비활성",
        /* INCOMPLETE */ null,
        /* INCORRECT */ "잘못된",
        /* INCORRECT_CODE */ "틀린 코드",
        /* INCORRECT_DIGITS */ "잘못된 숫자 ...",
        /* INCORRECT_DIGITS_EXPLAINED */ "입력 한 마지막 4 자리는 올바르지 않습니다. 문제가있는 경우 대행사에 문의하십시오.",
        /* INCORRECT_DIGITS_MESSAGE */ "입력 한 마지막 네 자리는 올바르지 않습니다. 문제가있는 경우 대행사에 문의하십시오.",
        /* INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN */ "잘못된 핀 코드. 다시 시도하십시오.",
        /* INCORRECT_SMS_CODE */ "잘못된 SMS 코드",
        /* INCORRECT_SMS_CODE_EXPLAINED */ "입력 한 코드는 귀하에게 보낸 코드와 일치하지 않습니다. 다시 시도하십시오.",
        /* INFORMATION_CENTER */ null,
        /* INFORMATION_NOT_MATCH_PROFILE */ null,
        /* INSERT_THEIR_REFERRAL_CODE_HERE */ "여기에 추천 코드를 삽입하십시오!",
        /* INSERVICES */ null,
        /* INSTAPAY */ null,
        /* INSTAPAY_HISTORY */ null,
        /* INSTAPAY_TECHNICAL_ISSUE */ null,
        /* INSUFFICIENT_DUTIES */ null,
        /* INTERESTED_IN_THIS_BUNDLE */ "이 번들에 관심이 있으십니까?",
        /* INTRODUCING */ "소개",
        /* INVALID_DOCUMENT_NAME */ "잘못된 문서 이름",
        /* INVALID_EMAIL */ "잘못된 이메일",
        /* INVALID_FORM */ null,
        /* INVALID_PHONE */ "잘못된 전화",
        /* INVALID_PHONENUMBER */ "유효하지 않은 전화 번호",
        /* INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN */ null,
        /* INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES */ "간병인을 Medflyt에 초대하고 놀라운 상을 받으십시오",
        /* INVITE_FRIENDS */ "친구를 초대",
        /* IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE */ null,
        /* IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT */ null,
        /* IN_PROGRESS */ null,
        /* ISSUES_TO_SOLVE */ null,
        /* IS_DUE_IN_DAYS */ null,
        /* IS_DUE_TOMORROW */ null,
        /* ITEMS_THAT_WILL_EXPIRE_SOON */ null,
        /* ITEMS_WITH_ISSUES */ null,
        /* ITEM_IS_MISSING */ null,
        /* ITEM_IS_NOT_COMPLIANT */ null,
        /* ITS_NOT_ME */ "내가 아니야",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU */ "이 장치에 이미 존재하는 계정이있는 것으로 보입니다. 그게 너야?",
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU */ "우리는 이미 귀하의 세부 사항과 일치하는 계정이있는 것으로 보입니다. 그게 너야?",
        /* IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK */ null,
        /* IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE */ "대행사와 함께 일하지 않는 것 같습니다. 신청서를 작성하여 대행사가 고용 하시겠습니까?",
        /* I_DONT_HAVE_MY_CODE */ "코드가 없습니다",
        /* I_DONT_WANT_THIS_CASE */ null,
        /* I_DONT_WANT_TO_CLOCK */ null,
        /* I_FORGOT_MY_PIN_CODE */ "핀 코드를 잊어 버렸습니다",
        /* I_HAVE_CHANGED_MY_MIND */ null,
        /* I_HAVE_READ_AND_AGREE */ "나는 읽고 동의합니다",
        /* I_VERIFY_THE_TERMS */ null,
        /* I_WANT_TO_CLOCK_IN_ANYWAY */ null,
        /* I_WANT_TO_CLOCK_OUT_ANYWAY */ null,
        /* I_WANT_TO_FINISH_MY_ONBOARDING */ null,
        /* I_WILL_DO_IT_LATER */ null,
        /* JANUARY */ "1월",
        /* JOINED_DATE */ "가입 날짜",
        /* JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT */ null,
        /* JULY */ "칠월",
        /* JUNE */ "6월",
        /* JUST_ONE_MORE_THING */ null,
        /* JUST_TO_BE_SURE */ null,
        /* JUST_VERIFYING_ITS_YOU */ "당신이 당신인지 확인합니다",
        /* KEEP_UP_THE_GOOD_WORK */ null,
        /* LABELS */ "라벨",
        /* LANGUAGE */ "언어",
        /* LANGUAGES */ "언어",
        /* LAST_NAME */ "성",
        /* LEARN_MORE */ null,
        /* LEAVE_WITHOUT_SAVING */ "저축없이 떠나?",
        /* LEFT */ null,
        /* LESSON */ "수업",
        /* LESSONS */ "수업",
        /* LETS_CONTINUE_TO_NEXT_SECTION */ null,
        /* LETS_FIND_CASES */ null,
        /* LETS_FIND_YOUR_FIRST_CASE */ null,
        /* LETS_FIND_YOUR_FIRST_PATIENT */ null,
        /* LETS_FINISH_YOUR_SHIFT */ null,
        /* LETS_START */ "시작하자!",
        /* LETS_START_YOUR_SHIFT */ null,
        /* LIKE_US_ON_FACEBOOK */ "페이스 북에서 좋아요를 눌러주세요",
        /* LINKED_TO_ANOTHER_PATIENT */ null,
        /* LIST */ "목록",
        /* LISTENING___ */ null,
        /* LIST_OF_PATIENTS */ "환자 목록",
        /* LIST_OF_TASKS */ "작업 목록",
        /* LIST_OF_VISITS */ "방문 목록",
        /* LIVE_CHAT_SUPPORT */ "라이브 채팅 지원",
        /* LIVE_CLASS */ "라이브 클래스",
        /* LIVE_CLASS_EXPLANATION */ "수업이 시작되면 수업에 참여할 수 있습니다. 당신이 그것을 놓친 경우 - 녹음 된 웹 세미나를 볼 수 있습니다",
        /* LIVE_EVENTS */ "라이브 이벤트",
        /* LOADING */ "로딩",
        /* LOADING_LOCATION */ "로딩 위치 ...",
        /* LOCATION */ "위치",
        /* LOCKED */ "잠겨 있습니다",
        /* LOGGING_YOU_IN */ "로그인",
        /* LOGIN */ "로그인",
        /* LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED */ "다른 장치에서 로그인하려고 시도한 것 같습니다. 다음 질문에 답하십시오",
        /* LOOKS_LIKE_MORE_THAN */ null,
        /* LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION */ null,
        /* MAIN_TASKS */ null,
        /* MAKE_A_DIFFERENCE */ null,
        /* MAKE_SURE_PICTURE_IS_CLEAR */ null,
        /* MALE */ "남성",
        /* MANUALLY_SUBMITTED_INFO */ null,
        /* MAP */ "지도",
        /* MARCH */ "3월",
        /* MAX_TRAVEL_DISTANCE */ "최대 여행 거리",
        /* MAY */ "5월",
        /* MAYBE_LATER */ "나중에",
        /* MAY_CLOCK_IN_AT */ "May Clock In At",
        /* MAY_CLOCK_OUT_FROM */ "May May Clock Out",
        /* MEC_WAIVER_INFORMATION */ null,
        /* MEDFLYT */ null,
        /* MEDFLYTS_MONTHLY_RAFFLE */ null,
        /* MEDFLYT_AGENCY_HANDBOOK */ null,
        /* MEDFLYT_AT_HOME_BENEFITS */ null,
        /* MEDFLYT_CHALLENGE */ "Medflyt 도전",
        /* MEDFLYT_HOME_CARE */ null,
        /* MEDFLYT_ID_CARD */ null,
        /* MEDFLYT_PASSPORT */ "Medflyt 여권",
        /* MEDFLYT_PASSPORT_TERMS */ "Medflyt 여권 용어",
        /* MEDFLYT_RAFFLE */ null,
        /* MEDFLYT_TEAM */ null,
        /* MEDFLYT_VERSION */ "Medflyt 버전",
        /* MEDICAL_FILES */ "의료 파일",
        /* MEDICAL_INFORMATION */ "의학 정보",
        /* MEDICAL_NOTES */ "의료 노트",
        /* MEDICATIONS */ null,
        /* MESSAGE */ "메시지",
        /* MESSAGE_FOR_THE_COORDINATOR */ "코디네이터를위한 메시지",
        /* MIDDLE_NAME */ "중간 이름",
        /* MILES_AWAY */ "몇 마일 떨어져 있습니다",
        /* MILES_BETWEEN_PATIENTS */ "환자들 사이의 마일",
        /* MILES_SHORT */ "미.",
        /* MINIMUM_WAGE */ null,
        /* MINUTE */ null,
        /* MINUTES */ "분",
        /* MINUTE_VISIT */ "미세한 방문",
        /* MISSING */ "잃어버린",
        /* MISSING_CLOCKS */ null,
        /* MISSING_PERSONAL_CARE_DUTY */ null,
        /* MM_DD_YYYY */ null,
        /* MOBILE_PHONE */ "휴대 전화",
        /* MOBILITY_STATUS */ null,
        /* MONTH */ "월",
        /* MONTHLY_RAFFLE */ null,
        /* MORE_DETAILS */ "자세한 내용은",
        /* MORE_DETAILS_BELOW */ null,
        /* MORE_SHIFTS_MORE_CHANCES */ null,
        /* MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* MUST_AGREE_TERMS */ null,
        /* MUST_BE_ATLEAST_3_CHARACTERS */ "적당한 3 자 여야합니다",
        /* MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS */ "다음 날 중 하나 여야합니다",
        /* MUST_PICK_EXACTLY */ "정확히 선택해야합니다",
        /* MUST_START_AT_OR_AFTER */ "시작 또는 후에 시작해야합니다",
        /* MUST_START_AT_OR_BEFORE */ "또는 그 전에 시작해야합니다",
        /* MUST_UPDATE_ADDRESS_TO_SEE_CASES */ "케이스를 확인하려면 주소를 업데이트해야합니다!",
        /* MY_AGENCIES */ "내 대행사",
        /* MY_ASSIGNED_VISITS */ "배정 된 방문",
        /* MY_AVAILABILITY */ null,
        /* MY_BENEFITS_CARD_INFORMATION */ null,
        /* MY_MEDFLYT_COMPLIANCE */ null,
        /* MY_PASSPORT */ "내 여권",
        /* MY_PAYROLL_HISTORY */ null,
        /* MY_PAYROLL_INFORMATION */ null,
        /* MY_PROFILE */ null,
        /* MY_REQUESTED_VISITS */ "요청한 방문",
        /* MY_STAFFING_PREFERENCES */ null,
        /* MY_UPCOMING_VISITS_REMINDERS */ "알림을 방문하십시오",
        /* MY_VIRTUAL_ID */ null,
        /* MY_VISITS */ null,
        /* NA */ "N/A",
        /* NAME */ "이름",
        /* NEAR */ null,
        /* NEED_DIRECTIONS */ "지시가 필요하십니까?",
        /* NET_PAY_FOR_PERIOD */ null,
        /* NEW */ "새로운",
        /* NEW_END_TIME_X */ null,
        /* NEW_MESSAGE */ null,
        /* NEW_TASK */ "새 작업",
        /* NEW_TASKS */ "새로운 작업",
        /* NEW_VISITS_AVAILABLE */ "새로운 방문 가능",
        /* NEXT */ "다음",
        /* NEXT_DUE */ "다음으로",
        /* NEXT_LESSON */ "다음 수업",
        /* NEXT_SECTION */ null,
        /* NEXT_TOKEN_IN */ null,
        /* NEXT_YEAR */ null,
        /* NO */ "아니요",
        /* NONE */ "없음",
        /* NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT */ "그들 중 누구도 나가 아닙니다. 새 계정을 만들",
        /* NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU */ "다음 계정 중 어느 것도 당신이 아닙니다",
        /* NOTES */ "메모",
        /* NOTIFICATIONS */ "알림",
        /* NOTIFICATIONS_OFF */ "알림 꺼짐",
        /* NOTIFICATIONS_ON */ "알림",
        /* NOT_AVAILABLE */ "사용 불가",
        /* NOT_COMPLIANT */ "준수하지 않습니다",
        /* NOT_DUE_YET */ null,
        /* NOT_ENOUGH_HOURS */ "시간이 충분하지 않습니다",
        /* NOT_ENOUGH_SHIFTS */ "교대가 충분하지 않습니다 ...",
        /* NOT_ENOUGH_SHIFTS_MESSAGE */ "이 방문을 요청하기 위해 최소 %의 최소값 %교대를 선택해야합니다 (현재 Shifts %만 선택했습니다).",
        /* NOT_FOUND */ "찾을 수 없습니다",
        /* NOT_INTERESTED */ "관심이 없다",
        /* NOT_SELECTED */ null,
        /* NOT_SET */ null,
        /* NOT_SIGNING */ null,
        /* NOT_STARTED */ null,
        /* NOT_URGENT */ "긴급하지 않습니다",
        /* NOVEMBER */ "십일월",
        /* NO_ALLERGIES */ "알려진 알레르기가 없습니다",
        /* NO_ANSWERS_TO_COPY */ "사본에 대한 답이 없습니다.",
        /* NO_ANSWERS_TO_COPY_TITLE */ "사본 실패!",
        /* NO_AVAILABLE_SLOTS */ null,
        /* NO_BALANCE */ null,
        /* NO_CHANGES_WERE_MADE */ "변경되지 않았습니다",
        /* NO_COMPLIANT_ITEMS */ null,
        /* NO_DOCUMENTS */ "문서가 없습니다",
        /* NO_DOCUMENTS_AVAILABLE */ "사용 가능한 문서가 없습니다",
        /* NO_DOCUMENTS_REQUIRED */ "문서가 필요하지 않습니다.",
        /* NO_DUTIES_REQUIRED_FOR_THIS_VISIT */ null,
        /* NO_EDUCATION_LINK */ "무료 교육을 원하십니까? 대행사에게 연락하십시오",
        /* NO_ELIGIBLE_VISITS */ null,
        /* NO_END_DATE */ "종료 날짜가 없습니다",
        /* NO_GENERAL_NOTES */ "일반적인 메모가 없습니다",
        /* NO_IN_SERVICE_VIDEOS_AVAILABLE */ "서비스를 사용할 수 없습니다. 자세한 내용은 기관에 문의하십시오.",
        /* NO_ISSUES_FOUND */ null,
        /* NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT */ "아뇨, 내가 아니야. 새 계정을 만들",
        /* NO_JUST_THIS_ONE */ null,
        /* NO_KEEP_THE_ORIGINAL_TIMES */ null,
        /* NO_KNOWN_ALLERGIES */ null,
        /* NO_LESSONS */ "수업이 없습니다",
        /* NO_LESSONS_FOR_YOU_YET */ "아직 당신을위한 교훈이 없습니다",
        /* NO_MEDICAL_INFORMATION */ "의료 정보가 없습니다",
        /* NO_NOTIFICATIONS */ "알림이 없습니다",
        /* NO_PAYSTUBS_FOUND_FOR_THIS_MONTH */ null,
        /* NO_PHONE */ "전화가 없습니다",
        /* NO_PHYSICIAN_SELECTED */ null,
        /* NO_PREVIOUS_CONVERSATIONS */ null,
        /* NO_SCHEDULED_VISITS_TODAY */ "오늘 예정된 방문이 없습니다",
        /* NO_SHIFTS_SELECTED */ null,
        /* NO_TAKE_ME_BACK */ null,
        /* NO_TESTS */ "테스트가 없습니다",
        /* NO_THANKS */ "고맙지 만 사양 할게",
        /* NO_TIME_LIMIT */ "시간 제한 없음",
        /* NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT */ null,
        /* NO_VIDEOS */ "비디오가 없습니다",
        /* NO_VISITS_SCHEDULED */ null,
        /* NO_VISITS_SCHEDULED_MESSAGE */ null,
        /* NO_VISITS_SELECTED */ null,
        /* NPI */ null,
        /* NUM_COUNT_ITEMS */ null,
        /* NUM_SHIFTS_TO_GO */ null,
        /* NUM_SHIFTS_TO_WAGE */ null,
        /* N_A */ "N/A",
        /* OCTOBER */ "십월",
        /* OF */ "의",
        /* OF_THE_REQUIRED_PLEASE_CONTINUE */ "필요한 시간의. 계속하십시오.",
        /* OF_THE_VIDEO */ "비디오의.",
        /* OK */ "확인",
        /* OK_ILL_TRY_LATER */ null,
        /* OK_NO_PROBLEM */ "알겠습니다. 문제 없습니다!",
        /* OK_THANKS */ null,
        /* ON */ "에",
        /* ONBOARDING */ null,
        /* ONBOARDING_COMPLETED */ null,
        /* ONBOARDING_COMPLETED_MESSAGE */ null,
        /* ONE_DAY_TO_COMPLETE */ "하루를 완료합니다",
        /* ONE_DOCUMENT */ "하나의 문서",
        /* ONE_DOCUMENT_SELECTED */ null,
        /* ONE_HOUR */ null,
        /* ONE_LAST_STEP */ null,
        /* ONE_LESSON */ "하나의 교훈",
        /* ONE_TEST */ "하나의 테스트",
        /* ONE_THOUSAND_POINTS */ null,
        /* ONE_VIDEO */ "하나의 비디오",
        /* ON_HOLD */ "보류 중",
        /* ON_LEAVE */ "휴가에",
        /* OOPS */ "죄송합니다",
        /* OPEN */ "열려 있는",
        /* OPEN_CAMERA */ null,
        /* OPEN_CERTIFICATE */ null,
        /* OPEN_DEVICE_SETTINGS */ null,
        /* OPEN_MAPS */ null,
        /* OPEN_SETTINGS */ null,
        /* OPTIONAL_TASKS */ null,
        /* OR */ "또는",
        /* OTHER */ "다른",
        /* OTHER_PERTINENT_DIAGNOSIS */ "다른 관련 진단",
        /* OTHER_REASON */ null,
        /* OTHER_TASKS */ null,
        /* OTHER_VISITS */ null,
        /* OUTBOUND_CALL_ERROR_MESSAGE */ null,
        /* OUTBOUND_CALL_ERROR_TITLE */ null,
        /* OUTBOUND_CALL_PROMPT_MESSAGE */ null,
        /* OUTBOUND_CALL_PROMPT_TITLE */ null,
        /* OUTBOUND_CALL_SUCCESS_MESSAGE */ null,
        /* OUTBOUND_CALL_SUCCESS_TITLE */ null,
        /* OUT_OF */ "밖으로",
        /* OUT_OF_RANGE */ null,
        /* OVERDUE */ null,
        /* OVERLAPPING_VISIT_ERROR */ "방문은 겹치며 다른 날짜 또는 시간을 선택하십시오.",
        /* OVERRIDE_FORM */ null,
        /* OVERRIDE_FORM_MESSAGE */ null,
        /* OVER_NIGHT */ "밤새",
        /* PAGE */ "페이지",
        /* PAID */ null,
        /* PAID_X_OUT_OF_Y */ null,
        /* PARTIAL_SELECTION */ null,
        /* PASSPORT */ "여권",
        /* PASSPORT_TERMS_TEXT */ "모든 규정 준수 및 의료 파일을 쉽게 업로드하여 작업중인 대행사와 공유하십시오.",
        /* PASTE */ "반죽",
        /* PAST_DUE */ "과거",
        /* PAST_SINCE_THE_VISIT_STARTED */ null,
        /* PAST_UPLOADS */ "과거 업로드",
        /* PAST_VISITS */ null,
        /* PATIENT */ "인내심 있는",
        /* PATIENTS */ "환자",
        /* PATIENT_ADDRESS */ "환자 주소",
        /* PATIENT_CANT_PHISICALLY_SIGN */ null,
        /* PATIENT_CANT_SIGN */ null,
        /* PATIENT_CONTACTS */ null,
        /* PATIENT_DOC_NOT_SUBMITTED */ "오류로 인해 환자 문서가 제출되지 않았습니다.",
        /* PATIENT_DOC_SUBMISSION_MISSMATCH */ "양식을 제출하려고하지만 방문 예정일은 오늘과 다릅니다. 양식에 원하는 날짜를 선택하십시오.",
        /* PATIENT_DOC_SUBMITTED_SUCCESSFULY */ "환자 문서는 성공적으로 제출되었습니다",
        /* PATIENT_INFO */ "환자 정보",
        /* PATIENT_IS_NOT_HOME */ null,
        /* PATIENT_IS_NOT_SIGNING */ null,
        /* PATIENT_NAME */ "환자 이름",
        /* PATIENT_NOT_FOUND */ "환자를 찾을 수 없습니다",
        /* PATIENT_NOT_FOUND_EXPLAIN */ "죄송합니다. 찾고있는 환자가 당신에게 할당되지 않은 것 같습니다.",
        /* PATIENT_NUMBER */ "환자 번호",
        /* PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE */ null,
        /* PATIENT_PHONE */ "환자 전화",
        /* PATIENT_REFUSES_TO_SIGN */ null,
        /* PATIENT_REPORT */ "환자 보고서",
        /* PATIENT_REQUESTS */ null,
        /* PATIENT_SCHEDULE */ null,
        /* PATIENT_SIGNATURE */ null,
        /* PATIENT_SIGNATURE_IS_REQUIRED */ null,
        /* PATIENT_SIGNATURE_REQUIRE_MSG */ "환자 서명이 서명되지 않은 이유를 지정하십시오.",
        /* PATIENT_SIGN_HERE */ "여기에 환자 사인",
        /* PATIENT_UNAVAILABLE_DURING_THESE_HOURS */ null,
        /* PATIENT_VISITS */ null,
        /* PAUSE_READING */ "일시 정지 읽기",
        /* PAYMENT_METHOD */ null,
        /* PAYROLL */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_TITLE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE */ null,
        /* PAYSTUB */ null,
        /* PAYSTUBS */ null,
        /* PAY_ME_NOW */ null,
        /* PAY_ME_NOW_X */ null,
        /* PENDING */ "보류 중",
        /* PENDING_APPLICATION */ "보류중인 신청서",
        /* PENDING_APPROVAL */ null,
        /* PENDING_CONFIRMATION */ null,
        /* PENDING_ISSUES */ null,
        /* PENDING_VERIFICATION */ null,
        /* PERMANENT_VISIT_DETAILS */ "영구 방문 세부 정보",
        /* PERMANENT_VISIT_FROM */ "영구 방문",
        /* PERMANENT_VISIT_TYPE */ "영구 방문",
        /* PERMISSION_NEEDED_FOR_CAMERA */ null,
        /* PERMISSION_NEEDED_FOR_CAMERA_MESSAGE */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE */ null,
        /* PERMISSION_TO_CAMERA_DENIED */ null,
        /* PER_HOUR */ null,
        /* PER_SHIFT */ "교대 당",
        /* PER_VISIT */ "방문 당",
        /* PER_WEEK */ null,
        /* PHONE */ "핸드폰",
        /* PHONES */ "전화",
        /* PHONE_CALL_SUPPORT */ "호출 지원",
        /* PHOTO_LIBRARY */ "사진 라이브러리",
        /* PHYSICIAN_DETAILS */ null,
        /* PICK_A_DATE */ "날짜를 선택하십시오",
        /* PICK_A_TIME */ "시간을 선택하십시오",
        /* PLAN_OF_CARE */ "치료 계획",
        /* PLEASE_ASK_THE_PATIENT */ null,
        /* PLEASE_CALL_PATIENT_IN_NEXT_SCREEN */ "다음 화면에서 환자에게 전화하십시오",
        /* PLEASE_CHAT_WITH_THE_AGENCY */ "대행사와 채팅 해주세요",
        /* PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY */ "올바르게 입력했는지 확인하십시오.",
        /* PLEASE_CHOOSE_A_LANGUAGE */ "언어를 선택하십시오",
        /* PLEASE_CHOOSE_A_TIME */ "시간을 선택하십시오",
        /* PLEASE_CHOOSE_DATE_BETWEEN */ "사이의 날짜를 선택하십시오",
        /* PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES */ "지난 몇 년간 번들을 완성하십시오",
        /* PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT */ "준수하는 상태를 유지하려면 테스트를보고 제출하십시오.",
        /* PLEASE_CONFIRM_THE_TIMES_CHOSEN */ "선택한 시간을 확인하십시오",
        /* PLEASE_CONFIRM_YOUR_INFORMATION */ "정보를 확인하십시오",
        /* PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS */ "자세한 내용은 기관에 문의하십시오",
        /* PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY */ "대행사에 즉시 연락하십시오",
        /* PLEASE_CONTACT_YOUR_AGENCY */ "대행사에 문의하십시오",
        /* PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS */ "주소는 대행사에게 문의하십시오",
        /* PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY */ "대행사에 즉시 연락하십시오",
        /* PLEASE_CONTACT_YOUR_COORDINATOR */ "코디네이터에게 문의하십시오.",
        /* PLEASE_ENABLE_LOCATION */ "위치를 활성화하십시오",
        /* PLEASE_ENTER_A_VALID_PHONE_NUMBER */ "유효한 전화 번호를 입력하세요",
        /* PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME */ "환자의 이름과 성을 입력하십시오",
        /* PLEASE_ENTER_PATIENT_NAME */ "환자 이름을 입력하십시오",
        /* PLEASE_ENTER_THE_PATIENT_PHONE */ "환자 전화를 입력하십시오",
        /* PLEASE_ENTER_YOUR_PIN_CODE */ "PIN 코드를 입력하십시오",
        /* PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED */ null,
        /* PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER */ "전화 번호의 마지막 4 자리를 작성하십시오.",
        /* PLEASE_FILL_IN_YOUR_INFORMATION */ "정보를 작성하십시오",
        /* PLEASE_FILL_REQUIRED_FIELDS */ null,
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY */ "코드를 올바르게 입력했는지 확인하십시오",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY */ "전화 번호를 올바르게 입력했는지 확인하십시오.",
        /* PLEASE_MARK_ALL_THE_REQUIRED_DUTIES */ null,
        /* PLEASE_NOTE */ "참고하십시오",
        /* PLEASE_PICK_VALID_DATES */ "유효한 날짜를 선택하십시오",
        /* PLEASE_REQUEST_EXACTLY */ "정확히 요청하십시오",
        /* PLEASE_SELECT_AN_OPTION */ "옵션을 선택하십시오",
        /* PLEASE_SELECT_DATE_AND_TIME */ "날짜와 시간을 선택하십시오",
        /* PLEASE_SELECT_THE_PATIENT_ADDRESS */ "환자 주소를 선택하십시오",
        /* PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT */ null,
        /* PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW */ "아래 카메라 아이콘을 클릭하여 프로필 사진을 설정하십시오.",
        /* PLEASE_SIGN_IN_AGAIN */ "다시 로그인하십시오",
        /* PLEASE_SPECIFY */ null,
        /* PLEASE_TAKE_A_SELFIE */ null,
        /* PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK */ "이 작업을 언제 수행 할 계획입니까?",
        /* PLEASE_TYPE_IN_YOUR_PHONE_NUMBER */ null,
        /* PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH */ "함께 일하고 싶은 대행사의 코드를 입력하십시오.",
        /* PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER */ "이 전화 번호의 마지막 4 자리를 입력하십시오",
        /* PLEASE_TYPE_THE_SMS_CODE */ "SMS 코드를 입력하십시오",
        /* PLEASE_UPDATE_TO_OUR_NEWEST_VERSION */ "최신 버전으로 업데이트하십시오",
        /* PLEASE_UPDATE_YOUR_ADDRESS */ "주소를 업데이트하십시오",
        /* PLEASE_UPDATE_YOUR_FIRST_NAME */ "이름을 업데이트하십시오",
        /* PLEASE_UPDATE_YOUR_LAST_NAME */ "성을 업데이트하십시오",
        /* PLEASE_WAIT */ "기다리세요",
        /* PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION */ null,
        /* PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP */ null,
        /* POINTS */ "포인트들",
        /* POINTS_AND_REWARDS */ null,
        /* POSTED_DATE */ "게시 날짜",
        /* PREBLOCK_VISIT_EXPLANATION */ "확인 후 환자에게 연락하여 방문 시간을 선택할 시간이 제한되어 있습니다.",
        /* PRESENTATION */ "프레젠테이션",
        /* PREVIOUS */ null,
        /* PREVIOUS_CONVERSATIONS */ null,
        /* PREVIOUS_WINNERS */ null,
        /* PRE_TAXES */ null,
        /* PRICE */ "가격",
        /* PRINCIPAL_DIAGNOSIS */ "주요 진단",
        /* PRIORITY_CODE */ null,
        /* PRIVACY_POLICY */ "개인 정보 정책",
        /* PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN */ "귀하의 위치를 얻는 데 문제가 있습니다. 다시 시도하십시오. 위치 서비스를 켜거나 밖으로 나가십시오.",
        /* PROBLEM_WITH_CASE_SETTINGS */ "케이스 설정에 문제가있는 것 같습니다.",
        /* PROCESSING */ null,
        /* PROFESSIONAL_TYPE */ "전문 유형",
        /* PROFILE */ "프로필",
        /* PROGRESS */ "진전",
        /* PROXY_FIRST_NAME */ null,
        /* PROXY_LAST_NAME */ null,
        /* PROXY_PHONE */ null,
        /* PULSE */ "맥박",
        /* QUESTION */ "문제",
        /* QUESTIONS */ "질문",
        /* QUESTIONS_TO_COPY_FROM */ "복사 할 질문",
        /* QUESTION_NUMBER */ null,
        /* QUESTION_REJECTED */ null,
        /* QUIT */ null,
        /* RAFFLE_ENDED */ null,
        /* RAFFLE_INFO_1_DESCRIPTION */ null,
        /* RAFFLE_INFO_1_TITLE */ null,
        /* RAFFLE_INFO_2_DESCRIPTION */ null,
        /* RAFFLE_INFO_2_TITLE */ null,
        /* RAFFLE_INFO_3_DESCRIPTION */ null,
        /* RAFFLE_INFO_3_TITLE */ null,
        /* RAFFLE_INFO_4_DESCRIPTION */ null,
        /* RAFFLE_INFO_4_TITLE */ null,
        /* RAFFLE_NOW */ null,
        /* RAFFLE_PRIZE */ null,
        /* RANK_ACHIEVED */ null,
        /* REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION */ null,
        /* READY_FOR_YOUR_NEXT_TRAINING */ "다음 훈련 준비가 되셨습니까?",
        /* READY_TO_CLOCK_IN */ "시계를 준비 할 준비가되었습니다",
        /* READY_TO_CLOCK_OUT */ "시계를 준비 할 준비가되었습니다",
        /* READ_AND_CONFIRM */ "읽고 확인하십시오",
        /* READ_ONLY_MODE */ null,
        /* READ_TEXT */ "텍스트를 읽으십시오",
        /* REASON */ null,
        /* RECENT_VISITS */ null,
        /* RECOMMENDED */ null,
        /* RECRUITMENT_MAIN_1 */ "당신이있는 것 같습니다",
        /* RECRUITMENT_MAIN_1_2 */ "~ 아니다",
        /* RECRUITMENT_MAIN_2 */ "모든 대행사와 함께",
        /* RECRUITMENT_MAIN_2_1 */ "일하고 있는",
        /* RECRUITMENT_MAIN_3 */ "대행사가 고용하십시오",
        /* RECRUITMENT_MAIN_4 */ "응용 프로그램을 작성하여",
        /* REFERRAL_CODE */ "추천 코드",
        /* REFER_ME */ "나를 참조하십시오!",
        /* REGISTRATION */ null,
        /* REGULAR_PAY */ null,
        /* REJECT */ "거부하다",
        /* REJECTED */ "거부",
        /* REJECT_THIS_TASK */ null,
        /* REJECT_THIS_VISIT */ "이 방문을 거부하십시오",
        /* REMAINED */ "남아 있었다",
        /* REMAINING */ "남아 있습니다",
        /* REMIND_ME_LATER */ "나중에 상기시켜 줘",
        /* REMOVE */ "제거하다",
        /* REMOVE_PAGE */ "페이지를 제거하십시오",
        /* REMOVE_TASK */ null,
        /* REOPENED */ null,
        /* REPLAY */ null,
        /* REQUEST */ "요구",
        /* REQUESTED */ "요청",
        /* REQUESTED_LABEL_IN_CASES_LIST */ "\"요청 된\"라벨은 케이스 목록입니다.",
        /* REQUESTED_TIMES */ "요청 된 시간",
        /* REQUESTED_VISIT_CANCEL_EXPLANATION */ null,
        /* REQUESTING_REFERENCE_RESPONSE */ null,
        /* REQUEST_AGENCIES_MEMBERSHIP */ "요청 대행사 멤버십",
        /* REQUEST_AGENCY */ "요청 대행사",
        /* REQUEST_AGENCY_MEMBERSHIP */ "요청 대행사 멤버십",
        /* REQUEST_DETAILS */ "요청 세부 정보",
        /* REQUEST_FOR_APPOINTMENT */ "약속 요청",
        /* REQUEST_FRIENDSHIP */ "우정을 요청하십시오",
        /* REQUEST_MORE_VISITS */ "더 많은 방문을 요청하십시오",
        /* REQUEST_MORE_VISITS_MESSAGE */ null,
        /* REQUEST_NUMBER_SHIFTS */ "요청 % 교대 % 변화",
        /* REQUEST_SELECTED_SHIFT */ null,
        /* REQUEST_SELECTED_SHIFTS */ null,
        /* REQUEST_SHIFTS */ "요청 이동을 요청합니다",
        /* REQUEST_SINGLE_SHIFT */ "단일 교대를 요청하십시오",
        /* REQUEST_THE_TIMES_YOU_WANT */ "원하는 시간을 요청하십시오!",
        /* REQUEST_THIS_VISIT */ "이 방문을 요청하십시오",
        /* REQUEST_TO */ "요청",
        /* REQUEST_VISIT */ "방문 방문",
        /* REQUIRED */ "필수의",
        /* REQUIRED_DOCUMENTS */ "필요한 서류",
        /* REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC */ "문서에 필요한 필드가 누락되었습니다. 돌아가서 채우십시오.",
        /* REQUIRED_PATIENT_DOCUMENT_TEXT */ "이 방문시 다음 문서를 작성해야합니다.",
        /* REQUIRED_TASKS */ "필요한 작업",
        /* REQUIREMENTS */ null,
        /* RESCHEDULE */ "일정 조정",
        /* RESCHEDULED_SUCCESSFULLY */ "성공적으로 일정을 변경했습니다",
        /* RESCHEDULE_IN_THE_PAST_ERROR */ "과거에 방문을 할 수는 없습니다.",
        /* RESCHEDULE_REQUESTS */ "재조정 요청",
        /* RESET_PIN_CODE_MESSAGE */ "새로운 인증 프로세스를 시작하려면 로그인 화면으로 이동합니다.",
        /* RESPIRATION_RATE */ "호흡 속도",
        /* RESUBMISSION_BANNER_TITLE */ null,
        /* RETAKE */ "다시 잡다",
        /* RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION */ null,
        /* RETRY */ "다시 해 보다",
        /* REVIEW_PRIVACY_POLICY */ "개인 정보 보호 정책보기",
        /* REVIEW_TASK */ "작업을 검토하십시오",
        /* REVIEW_TASKS */ "작업을 검토하십시오",
        /* RE_ENTER_YOUR_PIN_CODE */ "핀 코드를 다시 입력하십시오",
        /* RN_FLEXIBLE_SHOWCASE_TEXT */ "유연한 방문",
        /* RN_FLEX_EXPLANATION_PREFIX */ "이것은",
        /* RN_FLEX_REQUESTED_EXPLANATION */ "귀하에게 적합한 날짜와 시간을 선택하도록 요청 받게됩니다.",
        /* RN_FLEX_REQUESTED_EXPLANATION_LINE_2 */ "이 방문을 수행하는 기간은 다음과 같습니다.",
        /* RN_PATIENT_CONTACT_EXPLANATION */ "이 방문은 환자와 시간을 조정해야합니다.\n\n화면 하단의 버튼을 클릭하여 환자에게 연락하십시오.",
        /* RN_SIGN_HERE */ "여기에 RN 사인",
        /* ROUTING_NUMBER */ null,
        /* ROUTING_NUMBR */ null,
        /* SAFETY_AND_HEALTH */ null,
        /* SAVE */ "구하다",
        /* SAVE_FOR_LATER */ null,
        /* SCAN_AND_UPLOAD_FILES */ "파일 스캔 및 업로드",
        /* SCAN_A_PHOTO */ "사진을 스캔하십시오",
        /* SCAN_DOCUMENT */ "문서를 스캔합니다",
        /* SCAN_NEW_DOCUMENT */ "새 문서를 스캔하십시오",
        /* SCAN_WITH_CAMERA */ "카메라로 스캔하십시오",
        /* SCHEDULE */ "일정",
        /* SCHEDULED */ null,
        /* SCHEDULED_DATE */ null,
        /* SCHEDULED_FOR */ "예약",
        /* SCHEDULED_VISIT_COMPLETE */ "예정된 방문이 완료되었습니다",
        /* SCHEDULED_VISIT_NOT_FOUND */ "예정된 방문을 찾지 못하면 대행사에게 문의하십시오",
        /* SCHEDULE_CONFIRMATION */ null,
        /* SCHEDULE_FOR */ null,
        /* SCHEDULE_TASK */ null,
        /* SCHEDULING_PROBLEM */ "스케줄링 문제",
        /* SCREENING */ "상영",
        /* SCREENING_FOR */ "심사 :",
        /* SEARCH */ "찾다",
        /* SEARCH_AGENCY */ "검색 대행사",
        /* SEARCH_FOR_MEDICATIONS */ "약물 검색 ...",
        /* SEARCH_NEARY_VISITS */ null,
        /* SEARCH_PATIENT */ null,
        /* SECOND_SHIFT */ "두 번째 교대",
        /* SECTION_ALREADY_COMPLETED */ null,
        /* SECTION_COMPLETED_PROMPT */ null,
        /* SECTION_LOCKED_PROMPT */ null,
        /* SEE_ALL */ null,
        /* SEE_ALL_CONVERSATIONS */ null,
        /* SEE_IN_MAPS */ null,
        /* SEE_LIST_OF_VISITS */ "방문 목록을 참조하십시오",
        /* SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT */ "사전 크리니어링 요구 사항에 대한 자세한 내용을 참조하십시오",
        /* SEE_YOUR_PROGRESS */ null,
        /* SELECT */ "고르다",
        /* SELECTED */ null,
        /* SELECTED_VISIT */ null,
        /* SELECT_ALL */ "모두 선택",
        /* SELECT_CERTIFICATE */ "인증서를 선택하십시오",
        /* SELECT_DATE */ "날짜를 선택하십시오",
        /* SELECT_DATE_AND_TIME */ null,
        /* SELECT_DOCUMENT */ null,
        /* SELECT_DX_CODE */ "DX 코드를 선택하십시오",
        /* SELECT_FROM_LIST */ null,
        /* SELECT_PERTINENT_DIAGNOSIS */ "관련 진단을 선택하십시오",
        /* SELECT_PHYSICIAN */ null,
        /* SELECT_PRINCIPAL_DIAGNOSIS */ "주요 진단을 선택하십시오",
        /* SELECT_SHIFTS */ null,
        /* SELECT_START_TIME */ null,
        /* SELECT_SURGICAL_PROCEDURE */ "수술 절차를 선택하십시오",
        /* SELECT_TIME */ "시간을 선택하십시오",
        /* SELECT_TIME_SLOT */ null,
        /* SELECT_TIME_SLOT_INFO */ null,
        /* SELECT_VISITS_FOR_INSTAPAY */ null,
        /* SELECT_VISIT_DURATION */ null,
        /* SELECT_YOUR_SCHEDULE */ null,
        /* SELFIE_WITH_PATIENT */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT */ null,
        /* SEND_A_MESSAGE */ null,
        /* SEND_EMAIL */ "이메일을 보내",
        /* SEND_REPORT */ "보고서를 보내십시오",
        /* SEND_US_A_MAIL */ "우리에게 이메일 보내기",
        /* SEPTEMBER */ "구월",
        /* SETTINGS */ "설정",
        /* SETTINGS_AND_INFO */ null,
        /* SET_DOCUMENT_EXPIRY_DATE */ "문서 만료 날짜를 설정하십시오",
        /* SET_EXPIRATION_DATE */ "만료 날짜를 설정하십시오",
        /* SET_YOUR_4_DIGIT_PIN_CODE */ "4 자리 핀 코드를 설정하십시오",
        /* SHARE */ "공유하다",
        /* SHARE_IDEAS_AND_GET_A_CHANCE */ "아이디어를 공유하고 기회를 얻으십시오",
        /* SHARE_REFERENCE_LINK */ null,
        /* SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP */ null,
        /* SHARE_WITH_YOUR_FRIENDS */ null,
        /* SHIFT */ "옮기다",
        /* SHIFTS */ null,
        /* SHIFTS_DETAILS */ null,
        /* SHIFT_HAS_FINISHED_IN */ null,
        /* SHIFT_HAS_STARTED_IN */ null,
        /* SHOULD_BE_HERE */ "여기 있어야합니다",
        /* SHOW_ALL_TASKS */ null,
        /* SHOW_DETAILS */ null,
        /* SHOW_LESS */ "덜 보여주십시오",
        /* SHOW_ME_CASES_IN_THE_NEXT */ "다음에 사례를 보여주세요",
        /* SHOW_ME_IN */ "보여주세요",
        /* SHOW_MORE */ "자세히보기",
        /* SHOW_OLD_PLAN_OF_CARE */ "오래된 치료 계획을 보여줍니다",
        /* SHOW_TASKS_THAT_REQUIRE_FIXES */ null,
        /* SHOW_US_YOUR_SMILE */ "당신의 미소를 보여주세요! 😊",
        /* SIGNATURES */ null,
        /* SIGNATURE_REQUIRED */ "서명이 필요합니다",
        /* SIGN_DECLINATION_FORM */ null,
        /* SIGN_HERE */ "여기에 서명하십시오",
        /* SIGN_IN */ "로그인",
        /* SIGN_ORIENTATION_VIDEO */ "제출하기 전에 여기에 서명하십시오",
        /* SIGN_ORIENTATION_VIDEO_ERR */ "제출하기 전에 서명하십시오",
        /* SIGN_OUT */ "로그 아웃하십시오",
        /* SIGN_UP_FREE */ "무료로 가입하십시오",
        /* SIGN_UP_ITS_FREE */ "가입하기. 무료입니다!",
        /* SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE */ null,
        /* SINGLE_FLEXIBLE_VISIT_EXPLANATION */ null,
        /* SINGLE_VISIT_DETAILS */ "단일 방문 세부 정보",
        /* SINGLE_VISIT_FROM */ "단일 방문",
        /* SINGLE_VISIT_TYPE */ "단일 방문",
        /* SIXTY_SECONDS_AND_YOU_ARE_DONE */ null,
        /* SKIP */ "건너뛰다",
        /* SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION */ null,
        /* SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS */ null,
        /* SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN */ null,
        /* SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES */ null,
        /* SLIDE_MAIN_INFO_GO_NEXT_SCREENS */ null,
        /* SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW */ null,
        /* SLIDE_STEP_X_OF_COUNT */ null,
        /* SMILE_FOR_US */ "우리를 위해 미소! 📷",
        /* SOCIAL */ "사회의",
        /* SOCIAL_MEDIA */ "소셜 미디어",
        /* SOMETHING_WENT_WRONG */ "뭔가 잘못되었고 나중에 다시 시도 해주세요",
        /* SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS */ null,
        /* SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM */ null,
        /* SOME_TASKS_NEED_FIXES */ null,
        /* SORRY */ null,
        /* SORT */ "종류",
        /* SPECIFIC_DAYS */ "특정 날",
        /* SPEECH_RECOGNITION */ null,
        /* SPLIT_SHIFTS_VISIT */ "분할 변화",
        /* SPREAD_THE_WORD */ "말씀을 전하십시오",
        /* STAGE_APPROVED_MESSAGE */ null,
        /* STAGE_AWAITING_APPROVAL */ null,
        /* STAGE_COMPLETED_MESSAGE */ null,
        /* STAGE_X_OF_TOTAL_STAGES */ null,
        /* START */ null,
        /* STARTING_AT */ "시작",
        /* STARTS */ "시작",
        /* STARTS_NEXT_WEEK */ null,
        /* STARTS_TODAY_IN */ null,
        /* START_APPLICATION */ "응용 프로그램을 시작하십시오",
        /* START_A_SURVEY */ "설문 조사를 시작하십시오!",
        /* START_DATE */ "시작 날짜",
        /* START_FILLING */ null,
        /* START_NOW */ null,
        /* START_SHIFT */ null,
        /* START_TIME */ "시작 시간",
        /* START_USING_MEDFLYT_PASSPORT */ "Medflyt 여권 사용을 시작하십시오",
        /* START_WATCHING */ null,
        /* START_WATCHING_ORIENTATION_VIDEOS */ null,
        /* START_WORKING */ null,
        /* STATUS */ "상태",
        /* STAY_ON_TRACK */ null,
        /* STAY_ON_TRACK_1_ANSWER */ null,
        /* STAY_ON_TRACK_1_QUESTION */ null,
        /* STAY_ON_TRACK_2_ANSWER */ null,
        /* STAY_ON_TRACK_2_QUESTION */ null,
        /* STAY_ON_TRACK_3_ANSWER */ null,
        /* STAY_ON_TRACK_3_QUESTION */ null,
        /* STAY_ON_TRACK_4_ANSWER */ null,
        /* STAY_ON_TRACK_4_QUESTION */ null,
        /* STAY_ON_TRACK_DESCRIPTION */ null,
        /* STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS */ null,
        /* STAY_TUNED_FOR_MORE_VISITS */ "더 많은 방문을 위해 계속 지켜봐 주시기 바랍니다",
        /* STAY_TUNED_FOR_THE_NEXT_RAFFLE */ null,
        /* STILL_WAITING_REFERENCE_ANSWER */ null,
        /* STOP */ null,
        /* STREAK_BREAK */ null,
        /* STREAK_BREAK_MESSAGE */ null,
        /* STREAK_BREAK_MESSAGE_2 */ null,
        /* SUBMIT */ "제출하다",
        /* SUBMITTED_AT */ null,
        /* SUBMITTED_DOCUMENTS */ "제출 된 서류",
        /* SUBMITTED_MANUALLY */ "수동으로 제출되었습니다",
        /* SUBMIT_AFTER */ "제출",
        /* SUBMIT_AT */ "제출하십시오",
        /* SUBMIT_BY */ "제출",
        /* SUBMIT_DUTIES */ null,
        /* SUBMIT_DUTIES_BEFORE_CLOCK_OUT */ null,
        /* SUBMIT_FORM */ null,
        /* SUBMIT_FORMS */ null,
        /* SUBMIT_MANUAL_TIMESHEET */ null,
        /* SUBMIT_REQUIRED */ "필수 제출",
        /* SUBMIT_TEST */ "테스트를 제출하십시오",
        /* SUBMIT_TIMESHEET */ null,
        /* SUBMIT_WITH_SCHEDULED_DATE */ "예정된 날짜와 함께 제출하십시오",
        /* SUBMIT_WITH_TODAY_DATE */ "오늘 날짜와 함께 제출하십시오",
        /* SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT */ null,
        /* SUBMIT_YOUR_SIGN */ "사인을 제출하십시오",
        /* SUBMIT_YOUR_SIGNATURE */ "서명을 제출하십시오",
        /* SUCCESS */ "성공",
        /* SUCCESSFULLY_CLOCKED_IN */ null,
        /* SUCCESSFULLY_CLOCKED_OUT */ null,
        /* SUCCESSFULY_REQUESTED */ "성공적으로 요청했습니다!",
        /* SURGICAL_PROCEDURE */ "수술 절차",
        /* SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS */ "수입 된 방문을 보려면 목록보기로 전환하십시오",
        /* SWITCH_VIEW */ "스위치 뷰",
        /* TAKE_A_DIFFERENT_PHOTO */ null,
        /* TAKE_A_PHOTO */ "사진을 찍다",
        /* TAKE_A_SURVEY */ "설문 조사를하고 기회를 얻으십시오",
        /* TAKE_ME_TO_CASE_SETTINGS */ "케이스 설정으로 데려가십시오",
        /* TAKE_PHOTO */ "사진을 찍다",
        /* TAKE_THIS_TASK */ null,
        /* TAP_HERE_TO_VIEW */ "여기를 탭하여 볼 수 있습니다",
        /* TAP_TO_CANCEL */ "취소하려면 탭합니다",
        /* TAP_TO_CHANGE_CASE_SETTINGS */ "케이스 설정을 변경하려면 탭합니다",
        /* TASK */ null,
        /* TASKS */ null,
        /* TASK_ALREADY_ASSIGNED */ null,
        /* TASK_COMPLETED_SUCCESSFULLY */ "축하합니다.이 작업을 완료했습니다.",
        /* TASK_INFORMATION */ null,
        /* TASK_SCHEDULED */ null,
        /* TASK_SCHEDULED_MESSAGE */ null,
        /* TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE */ null,
        /* TECHNICAL_SUPPORT */ "기술적 지원",
        /* TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES */ "더 나은 케이스를 보낼 수 있도록 관심이없는 이유를 알려주십시오.",
        /* TELL_US_YOUR_AGENY_DESCRIPTION */ "대행사 이름, 코디네이터 이름을 알려 주시면 공개 케이스를 방송하기 위해 연락 드리겠습니다.",
        /* TEMPERATURE */ "온도",
        /* TEN_DOLLAR_STARBUCKS_GIFT_CARD */ null,
        /* TERMINATED */ "종료",
        /* TERMS_OF_MEDFLYT_PRIVACY_POLICY */ "Medflyt 약관 개인   정보 보호 정책",
        /* TERMS_OF_USE */ "이용 약관",
        /* TEST */ "시험",
        /* TESTS */ "테스트",
        /* TEST_COMPLETED */ "테스트가 완료되었습니다",
        /* TEST_FAILED */ "테스트 실패",
        /* TEST_REQUIRED */ "테스트가 필요합니다",
        /* THANKS */ null,
        /* THANK_YOU */ "고맙습니다!",
        /* THANK_YOU_FOR_YOUR_FEEDBACK */ "의견을 보내 주셔서 감사합니다.",
        /* THATS_ME */ "그게 나야",
        /* THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION */ null,
        /* THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS */ null,
        /* THERE_ARE_NO_AGENCIES_YET */ "아직 대행사가 없습니다",
        /* THERE_ARE_NO_ASSIGNED_CASES */ null,
        /* THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION */ "인터넷 연결에 문제가 있습니다",
        /* THERE_SEEMS_TO_BE_NOTHING_HERE */ "여기에는 아무것도없는 것 같습니다 ...",
        /* THE_AWARDS_ARE_COMING_SOON */ null,
        /* THE_BEST_PLACE_FOR_CAREGIVERS */ null,
        /* THE_DUTY_SHEET_HAS_BEEN_SUBMITTED */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON */ null,
        /* THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS */ null,
        /* THE_NEXT_WINNERS_ANNOUNCEMENT */ "다음 우승자 발표",
        /* THE_SELECTED_DATE_IS_EARLIER_THAN */ null,
        /* THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS */ "방문은 다음 날에 수행 할 수 있습니다",
        /* THE_VISIT_HAS_NOT_STARTED_YET */ null,
        /* THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS */ null,
        /* THIS_BUNDLE_INCLUDES */ "이 번들에는 포함됩니다",
        /* THIS_CONVERSATION_HAS_BEEN_RESOLVED */ null,
        /* THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK */ "이 과정은 %D 레슨으로 구성됩니다. 행운을 빌어요!",
        /* THIS_FIELD_IS_CURRENTLY_DISABLED */ "이 필드는 현재 비활성화되어 있습니다.",
        /* THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT */ "이것은 오래된 방문이며, 시계를 넣을 수 없습니다.",
        /* THIS_IS_A_FUTURE_VISIT */ null,
        /* THIS_IS_A_LIVE_CLASS_SESSION */ "이것은 {duration} 라이브 클래스 세션 ({date_time})입니다.",
        /* THIS_MAY_TAKE_UP_TO_X_SECONDS */ null,
        /* THIS_PATIENT_BELONGS_TO_AGENCY */ null,
        /* THIS_PATIENT_HAS_NO_PHONE_NUMBERS */ "이 환자는 전화 번호가 없습니다",
        /* THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER */ "이 질문은 읽습니다. 당신은 대답 할 수 없습니다.",
        /* THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP */ null,
        /* THIS_VISIT_CAN_BE_PERFORMED_BETWEEN */ "이 방문은 사이에 수행 될 수 있습니다",
        /* THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE */ null,
        /* THIS_VISIT_IS_FOR_DIFFERENT_AGENCY */ null,
        /* THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET */ "이 방문은 미래에 있습니다. 아직 시계를 보낼 수 없습니다.",
        /* THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY */ null,
        /* THIS_WILL_MARK_THE_VISIT_AS_MISSED */ null,
        /* TIME */ "시간",
        /* TIMESHEET_SUBMITTED */ null,
        /* TIME_ESTIMATION */ null,
        /* TIME_FRAME */ "시간 프레임",
        /* TIME_LEFT */ "시간이 남았습니다",
        /* TIME_VARIES */ "시간이 다릅니다",
        /* TO */ "에게",
        /* TODAY */ "오늘",
        /* TODAYS_DATE */ null,
        /* TOKENS */ null,
        /* TOO_MANY_HOURS */ "너무 많은 시간",
        /* TOO_MANY_SHIFTS */ "너무 많은 변화!",
        /* TOO_MANY_SHIFTS_MESSAGE */ "당신은 의 %maxShifts% 의 변화에   데리러 사용할 수 있습니다. 이 변화를 선택하려는 경우, 당신은 당신이 선택 변화 중 하나를 선택 해제해야합니다.",
        /* TOP_CAREGIVERS_IN_YOUR_AREA */ "해당 지역의 최고 간병인",
        /* TOTAL_EARNED */ null,
        /* TOTAL_SPENT */ null,
        /* TO_FILL_IN_A_FORM_INSTEAD */ null,
        /* TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT */ null,
        /* TO_SEE_THIS_TASK_GO_TO_ASSIGNED */ null,
        /* TO_SEE_THIS_VISIT_GO_TO */ "이 방문을 보려면 찾아보십시오",
        /* TO_UPLOAD_A_FILE_INSTEAD */ null,
        /* TO_WIN_AN_IPHONE12 */ "iPhone 12를 얻으십시오",
        /* TRAINING */ "훈련",
        /* TRAININGS_FOR */ "훈련",
        /* TRAINING_CENTER */ "훈련 센터",
        /* TRAINING_CENTER_REMINDERS */ "훈련 센터 알림",
        /* TRY_AGAIN */ "다시 시도하십시오",
        /* TYPE_AGENCY_CODE */ "대행사 코드 유형",
        /* TYPE_MESSAGE */ "메시지를 입력하십시오",
        /* TYPE_YOUR_ADDRESS */ "주소를 입력하십시오",
        /* UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET */ null,
        /* UNANSWERED_LAST_SECTION_FOR_NOW */ null,
        /* UNAUTHORIZED */ "무단",
        /* UNAVAILABLE_LOCATION_SERVICES_MESSAGE */ null,
        /* UNDER_REVIEW */ null,
        /* UNDO */ "실행 취소",
        /* UNIQUE_ERROR_CODE */ "고유 한 오류 코드",
        /* UNSCHEDULE */ null,
        /* UNSCHEDULE_TASK */ null,
        /* UNSPECIFIED */ "지정되지 않은",
        /* UNTIL */ "까지",
        /* UPCOMING_VISITS */ null,
        /* UPDATED_AT */ null,
        /* UPDATE_INFORMATION */ null,
        /* UPLOAD */ "업로드",
        /* UPLOADED */ "업로드",
        /* UPLOADED_FILE_VIEW */ null,
        /* UPLOADING */ "업로드",
        /* UPLOAD_A_DOCUMENT */ null,
        /* UPLOAD_A_FILE */ null,
        /* UPLOAD_DOCUMENT */ "문서 업로드",
        /* UPLOAD_DOCUMENTS */ "문서를 업로드하십시오",
        /* UPLOAD_ERROR */ "오류를 업로드하십시오",
        /* UPLOAD_FILES_TO_ENSURE */ "파일을 업로드하여 확인하십시오",
        /* UPLOAD_FLU_SHOT_DOCUMENT */ null,
        /* UPLOAD_FROM_GALLERY */ "갤러리에서 업로드하십시오",
        /* UPLOAD_NEW_DOCUMENT */ null,
        /* UPLOAD_VIDEO */ null,
        /* UPLOAD_YOUR_FILES_TO_ENSURE */ "파일을 업로드하여 확인하십시오",
        /* UP_COMING_REASSESSMENTS */ "다가오는 재평가",
        /* UP_TO */ null,
        /* URGENT */ null,
        /* USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY */ "이 사용자는 의심스러운 활동으로 인해 잠겨 있습니다",
        /* VALID */ "유효한",
        /* VERIFIED */ "확인",
        /* VERIFY */ "확인하다",
        /* VERIFYING */ "확인",
        /* VERIFY_YOUR_LOCATION */ null,
        /* VERY_URGENT */ "매우 긴급한",
        /* VIDEO */ "동영상",
        /* VIDEOS */ "비디오",
        /* VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION */ "교육 센터의 비디오는주의가 필요합니다.",
        /* VIDEO_COMPLETED_SUCCESSFULLY */ "축하합니다. 비디오 시청을 완료했습니다.",
        /* VIEW */ "보다",
        /* VIEWED */ "보았습니다",
        /* VIEW_ALL */ null,
        /* VIEW_ANSWERS */ null,
        /* VIEW_CERTIFICATE */ "인증서를 봅니다",
        /* VIEW_TASK */ null,
        /* VIEW_TASKS_PENDING_FOR_SCHEDULE */ "일정에 대한 보류중인 작업을 봅니다",
        /* VIEW_VISIT */ null,
        /* VIRTUAL_ID_CARD */ null,
        /* VISIT */ "방문하다",
        /* VISITS */ "방문",
        /* VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER */ null,
        /* VISITS_NEXT_MONTH */ null,
        /* VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* VISITS_PER_WEEK */ "주당 방문",
        /* VISITS_WITH_ISSUES */ null,
        /* VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE */ "방문이 지정되고 일정에 확인하십시오.",
        /* VISIT_BY */ "방문",
        /* VISIT_CHAT */ "채팅을 방문하십시오",
        /* VISIT_COMPLETE */ null,
        /* VISIT_COMPLETED_SUCCESSFULLY */ null,
        /* VISIT_COUNTS */ null,
        /* VISIT_COUNTS_DESCRIPTION */ null,
        /* VISIT_DATE */ "방문 날짜",
        /* VISIT_DATES */ null,
        /* VISIT_DETAILS */ "세부 정보를 방문하십시오",
        /* VISIT_DURATION */ null,
        /* VISIT_INFORMATION */ null,
        /* VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU */ null,
        /* VISIT_LASTING */ "지속적인 방문",
        /* VISIT_NEXT_MONTH */ null,
        /* VISIT_NOTIFICATIONS_OFF */ "알림 방문 - 꺼짐",
        /* VISIT_NOTIFICATIONS_ON */ "알림 방문 - on",
        /* VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE */ "이 방문에서 아직 시계를 보지 못했습니다. 시계를 시계하고 싶습니까?",
        /* VISIT_NO_LONGER_AVAILABLE */ "더 이상 사용할 수 없습니다",
        /* VISIT_RATE_REQUEST_CONFIRMATION */ null,
        /* VISIT_REMINDERS */ null,
        /* VISIT_REQUEST_CONFIRMATION_WARNING */ null,
        /* VISIT_SCHEDULE */ null,
        /* VISIT_STARTED_AT */ null,
        /* VISIT_STARTED_MISSING_CLOCK_IN */ null,
        /* VISIT_STARTS_AT */ null,
        /* VISIT_SUCESSFULLY_CANCELED */ "성공적으로 취소 된 방문",
        /* VISIT_TIME_ADJUSTMENT */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_EARLY */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_LATE */ null,
        /* VISIT_TOO_SHORT */ null,
        /* VISIT_TYPE */ null,
        /* VISIT_WITH */ null,
        /* VOUCHER */ null,
        /* WAITING_FOR_APPROVAL */ "승인 대기 중",
        /* WAITING_TO_BE_SCHEDULED */ "예약을 기다리고 있습니다",
        /* WARNING */ "경고!",
        /* WAS_DUE_BETWEEN */ null,
        /* WAS_DUE_ON */ null,
        /* WATCHED */ "보았다",
        /* WATCH_HOW_IT_WORKS */ "작동 방식을보십시오",
        /* WATCH_REQUIRED */ "필수 시청",
        /* WATCH_TRAINING_VIDEOS_TO_COMPLETE */ null,
        /* WEEKLY_DETAILS */ null,
        /* WELCOME */ "어서 오십시오",
        /* WELCOME_BACK */ "다시 오신 것을 환영합니다",
        /* WELCOME_TO_CARE_MOMENTS */ null,
        /* WELCOME_TO_MEDFLYT */ "Medflyt에 오신 것을 환영합니다!",
        /* WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE */ null,
        /* WELL_BE_IN_TOUCH_SHORTLY */ "우리는 곧 연락 할 것입니다.",
        /* WERE_YOU_REFERRED_BY_SOMEONE */ "당신은 누군가에 의해 추천 되었습니까?",
        /* WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM */ null,
        /* WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR */ "우리는 당신이 찾고있는 약을 찾을 수 없었습니다",
        /* WE_COULDNT_FIND_YOUR_AGENCY */ "대행사를 찾을 수 없었습니다!",
        /* WE_GOT_YOUR_CONFIRMATION */ null,
        /* WE_GOT_YOUR_RESPONSE_WAIT_HH_MM */ null,
        /* WE_HAVE_ONE_MATCHING_ACCOUNT */ "우리는 귀하가 제공 한 세부 정보를 기반으로 하나의 일치 계정을 찾았습니다. 그게 너야?",
        /* WE_HAVE_X_MATCHING_ACCOUNTS */ "다음 계정 중 하나가 당신 일 가능성이 있습니까?",
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT */ null,
        /* WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT */ "로그인 할 수 없었습니다. Medflyt Support에 문의하십시오.",
        /* WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON */ null,
        /* WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE */ "멋진 사진! 계속해야합니까?",
        /* WHAT_BENEFITS_CAN_YOU_GET */ null,
        /* WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK */ null,
        /* WHAT_WOULD_YOU_LIKE_TO_DO_FIRST */ null,
        /* WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT */ "유연한 방문을 볼 때마다 자신에게 맞는 시간을 요청할 수 있습니다.",
        /* WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR */ null,
        /* WHOOPS */ "우회",
        /* WHOS_THE_LUCKY_ONE */ null,
        /* WILL_BEGIN_SHORTLY */ "곧 시작됩니다",
        /* WILL_EXPIRE_IN_DAYS */ null,
        /* WILL_EXPIRE_TOMORROW */ null,
        /* WINNER_ANNOUNCED_IN */ null,
        /* WITH_CAREGIVERS */ "간병인과 함께",
        /* WORKING_WITH_AGENCY */ "대행사와 함께 일하고 있습니다",
        /* WRONG_DATES_SELECTION */ "잘못된 날짜 선택",
        /* WRONG_PHONE_NUMBER */ "잘못된 전화 번호",
        /* WRONG_PIN */ "잘못된 핀",
        /* X_DAYS_SELECTED */ null,
        /* X_DAYS_TO_COMPLETE */ "완료해야 할 %d",
        /* X_DAYS_TO_SELECT */ null,
        /* X_HOURS_SELECTED */ null,
        /* X_HOURS_TO_SELECT */ null,
        /* YAY_YOU_WERE_ASSIGNED_TO_A_VISIT */ null,
        /* YEAR */ "년도",
        /* YEARS_OLD */ null,
        /* YES */ "예",
        /* YES_ADJUST_TIMES */ null,
        /* YES_DELETE */ null,
        /* YES_I_AM_SURE */ null,
        /* YES_OVERRIDE_FORM */ null,
        /* YES_REQUEST_ANYWAY */ null,
        /* YES_SCHEDULE_VISIT */ null,
        /* YES_THATS_ME */ "그래 그게 나야",
        /* YES_UPDATE_ALL */ null,
        /* YOURE_ALL_DONE_LETS_GET_YOU_WORKING */ null,
        /* YOURE_IN_THE_RAFFLE */ null,
        /* YOURE_NOT_IN_THE_RAFFLE */ null,
        /* YOURSELF */ "당신 자신",
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD */ null,
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE */ null,
        /* YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS */ "귀하의 대행사는 귀하에게 수업을 할당하지 않았을 수 있습니다. 나중에 다시 시도 해주세요.",
        /* YOUR_ANSWER_IS_CORRECT */ "당신의 대답은 맞습니다!",
        /* YOUR_ANSWER_IS_INCORRECT */ "귀하의 대답이 잘못되었습니다",
        /* YOUR_COMPLIANCE */ "귀하의 규정 준수",
        /* YOUR_COMPLIANCE_ITEM_HAS_EXPIRED */ null,
        /* YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS */ null,
        /* YOUR_FILE_IS_BEING_UPLOADED */ "파일이 업로드됩니다",
        /* YOUR_IN_SERVICE_IS_DUE_IN_DAYS */ null,
        /* YOUR_IN_SERVICE_IS_OVER_DUE */ null,
        /* YOUR_MOBILE */ "당신의 모바일",
        /* YOUR_REFERERAL_CODE */ "추천 코드",
        /* YOUR_TASK_HAS_BEEN_SCHEDULED_FOR */ null,
        /* YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY */ null,
        /* YOUVE_BEEN_SUCCESSFULLY_REFERRED */ "당신은 성공적으로 추천되었습니다!",
        /* YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "지금은 모든 수업을 완료했습니다",
        /* YOU_ALREADY_FAILED */ "당신은 이미 테스트에 실패했습니다.",
        /* YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT */ "당신은 이미 그 시간 슬롯을 위해 예정된 방문이 있습니다",
        /* YOU_ALREADY_REQUESTED_THIS_VISIT */ null,
        /* YOU_ALREADY_SUCCEEDED */ "당신은 이미 시험에 성공했습니다.",
        /* YOU_ARE_ALL_SET */ null,
        /* YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION */ null,
        /* YOU_ARE_COMPLIANT */ null,
        /* YOU_ARE_EXEMPT_FROM_THIS_TEST */ "이 테스트에서 면제됩니다",
        /* YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD */ "이 필드를 편집 할 수 없습니다.",
        /* YOU_ARE_NOT_COMPLIANT */ null,
        /* YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM */ null,
        /* YOU_ARE_OUT_OF_COMPLIANCE */ null,
        /* YOU_ARE_X_DAYS_LATE */ "당신은 %d days 늦었습니다.",
        /* YOU_CANNOT_EDIT_YOUR_ANSWERS */ null,
        /* YOU_CANT_EDIT_VISIT_WITH_CICO */ null,
        /* YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES */ "여러 교장 또는 외과 진단을 가질 수 없습니다.",
        /* YOU_CANT_SIGN_BEFORE_ALL_ANSWERED */ null,
        /* YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE */ "동일한 ICD 코드를 두 번 이상 사용할 수 없습니다.",
        /* YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME */ null,
        /* YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED */ "필요한 경우 환자에게 연락 할 수 있습니다",
        /* YOU_CAN_CONTINUE_TO_NEXT_SECTION */ null,
        /* YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY */ null,
        /* YOU_DIDNT_ANSWER_ALL_QUESTIONS */ null,
        /* YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN */ "동일한 핀 코드를 입력하지 않았습니다. 다시 시도하십시오.",
        /* YOU_DONT_HAVE_ANY_CASES_YET */ null,
        /* YOU_DONT_HAVE_ANY_PATIENTS_YET */ null,
        /* YOU_GET_POINTS */ null,
        /* YOU_GOT_THE_CASE */ null,
        /* YOU_GOT_THE_CERTIFICATE */ "인증서를 받았습니다!",
        /* YOU_HAVENT_CLOCKED_IN_YET */ "당신은 아직 시계를 보지 않았습니다",
        /* YOU_HAVENT_CLOCKED_OUT_YET */ "당신은 아직 시계를 보지 않았습니다",
        /* YOU_HAVENT_UPLOADED_ANYTHING_YET */ "당신은 아직 아무것도 업로드하지 않았습니다",
        /* YOU_HAVE_COMPLETED_THIS_TEST */ "이 테스트를 완료했습니다",
        /* YOU_HAVE_HH_MM_TO_CONFIRM_IT */ null,
        /* YOU_HAVE_MISSING_COMPLIANCE_ITEMS */ null,
        /* YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW */ null,
        /* YOU_HAVE_NOT_WATCHED */ "당신은 보지 않았습니다",
        /* YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY */ "당신은 남은 시도가 없습니다. 대행사에 문의하십시오",
        /* YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS */ null,
        /* YOU_HAVE_ONE_ATTEMPT_LEFT */ "하나의 시도가 남았습니다",
        /* YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING */ "이 훈련을 완료 할 하루가 있습니다!",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION */ null,
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING */ "이 교육을 성공적으로 완료했습니다",
        /* YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY */ "오늘이 교육을 완료해야합니다. 서둘러요!",
        /* YOU_HAVE_TO_ENROLL_FIRST */ "이 레슨을 보려면 먼저 등록해야합니다.",
        /* YOU_HAVE_TO_PICK_A_CODE */ "코드를 선택해야합니다.",
        /* YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_LEFT */ "%d 시도가 남았습니다",
        /* YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST */ "이 테스트에 답하려는 %D 시도가 있습니다",
        /* YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y */ "%d 중의 %d가 있습니다.",
        /* YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING */ "이 훈련을 완료하는 데 %D 일이 있습니다!",
        /* YOU_JUST_GOT_PAID */ null,
        /* YOU_JUST_GOT_PROMOTED_TO */ null,
        /* YOU_LOSE_POINTS */ null,
        /* YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS */ "더 관련성있는 방문을 받으려면 방문 설정을 변경할 수 있습니다.",
        /* YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE */ "테스트에 응답 할 수 없습니다",
        /* YOU_MAY_ONLY_SUBMIT_AFTER */ "완료 후에 만 제출할 수 있습니다",
        /* YOU_MISSED_A_SHIFT_WITHOUT_NOTICE */ null,
        /* YOU_MUST_ANSWER_ALL_THE_QUESTIONS */ "모든 질문에 대답해야합니다.",
        /* YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT */ null,
        /* YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST */ "먼저 이전 비디오를보아야합니다",
        /* YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION */ null,
        /* YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE */ null,
        /* YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT */ null,
        /* YOU_RECENTLY_WON_A_RAFFLE */ null,
        /* YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT */ null,
        /* YOU_USED_THE_CODE */ "코드를 사용했습니다",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE */ null,
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS */ null,
        /* YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS */ null
    ],
    "ru": [
        /* ACCEPTED */ "Принято",
        /* ACCEPT_THESE_HOURS */ "Согласиться с этими часами",
        /* ACCEPT_THE_VISIT_AT */ "Согласиться на визит в",
        /* ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY */ null,
        /* ACCOUNT_NUMBER */ null,
        /* ACCOUNT_TYPE */ null,
        /* ACTIVE */ "Активно",
        /* ACTIVE_DOCUMENT */ "Активный документ",
        /* ADD */ "Добавить",
        /* ADDITIONAL_NOTES */ null,
        /* ADDRESS */ "Адрес",
        /* ADDRESS2 */ "2-я строка адреса",
        /* ADDRESS_ERROR */ "Ошибка в адресе",
        /* ADDRESS_IS_NEAR */ null,
        /* ADD_ANOTHER_DOCUMENT */ null,
        /* ADD_ANOTHER_PERTINENT_DIAGNOSIS */ null,
        /* ADD_IMAGE */ "Добавить изображение",
        /* ADD_NEW_MEDICATION */ "Добавить новое лекарство",
        /* ADD_NOTES */ "Добавить примечания",
        /* ADD_NOTE_TO_PATIENT_PROFILE_BUTTON */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_TITLE */ null,
        /* ADD_PHYSICIAN */ null,
        /* ADD_YOUR_SIGNATURE */ null,
        /* ADVANCED_DIRECTIVES */ null,
        /* AGENCIES_CONTACT */ "Агентства скоро свяжутся с вами",
        /* AGENCY */ "Агентство",
        /* AGENCY_CODE */ "Код агентства",
        /* AGENCY_COORDINATOR */ "Координатор от агентства",
        /* AGENCY_DETAILS */ "Сведения об агентстве",
        /* AGENCY_HANDBOOK */ null,
        /* AGENCY_ISSUES */ null,
        /* AGENCY_NAME */ "Название агентства",
        /* AGENCY_NOTIFICATIONS */ null,
        /* AGENCY_NOT_FOUND */ null,
        /* AGREE_TO_MEDFLYT_TERMS */ "Нажимая «Одобрить», вы подтверждаете, что прочитали положения Политики конфиденциальности Meflyt и согласились с ними",
        /* AIDE */ null,
        /* AIRPODS */ null,
        /* ALLERGIES */ null,
        /* ALLOW_ACCESS_TO_MY_LOCATION */ null,
        /* ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP */ null,
        /* ALL_CHANGES_SAVED */ null,
        /* ALL_DAY */ "весь день",
        /* ALL_DONE */ null,
        /* ALL_TRANSACTIONS */ null,
        /* ALL_VERIFIED_ITEMS */ null,
        /* ALREADY_CLOCKED_IN */ "Время прихода уже отмечено.",
        /* ALREADY_CLOCKED_IN_ANOTHER_VISIT */ "Вы уже отметили время прихода на другой визит.",
        /* ALREADY_CLOCKED_OUT */ "Время ухода уже отмечено.",
        /* ALREADY_HAVE_AN_ACCOUNT */ null,
        /* AND_AMPERSAND */ "и",
        /* ANSWERED */ "Отвечено",
        /* ANSWERED_AT */ "Отвечено в",
        /* ANSWER_INCOMPLETE_QUESTIONS */ null,
        /* ANY_DURATION */ "любая продолжительность",
        /* AN_ERROR_HAS_OCCURED */ "Произошла ошибка.",
        /* AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET */ null,
        /* APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES */ "Apple никоим образом не участвует в конкурсе или розыгрышах",
        /* APPLICATION_DONE */ "Заявка подана!",
        /* APPROVE */ "Одобрить",
        /* APPROVED */ null,
        /* APPROVE_THIS_TASK */ null,
        /* APPROVE_THIS_VISIT */ null,
        /* APRIL */ null,
        /* ARENT_YOU_MISSING_SOMETHING */ null,
        /* ARE_YOU */ null,
        /* ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY */ "Вы сейчас работаете в агентстве?",
        /* ARE_YOU_SURE */ null,
        /* ARE_YOU_SURE_REQUEST_FAR_VISIT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST */ "Уверены, что хотите отменить этот запрос?",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT */ "Вы уверены, что хотите отменить этот визит?",
        /* ARE_YOU_SURE_YOU_WANT_TO_DELETE */ "Вы точно хотите удалить",
        /* ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE */ "Вы точно хотите удалить эту страницу?",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE */ "Вы уверены, что хотите запросить эти",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT */ "Уверены, что хотите запросить этот визит?",
        /* ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT */ "Вы уверены, что хотите выйти из системы?",
        /* ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK */ null,
        /* ASSIGNED */ "Назначено",
        /* ASSIST */ "Помочь",
        /* AS_NEEDED */ null,
        /* AS_REQUESTED_BY_THE_PATIENT */ "По просьбе пациента",
        /* ATTACH_A_DOCUMENT */ null,
        /* AUGUST */ null,
        /* AUTHENTICATION_FAILED */ null,
        /* AUTH_VERIFICATION_FAIL_EXAPLINED */ null,
        /* AUTOPLAY */ "Следующий параграф начнется через",
        /* AVAILABILITY */ "Ваша доступность",
        /* AVAILABLE */ "Доступен",
        /* AVAILABLE_CARE_POINTS */ null,
        /* AVAILABLE_ON_THE_FOLLOWING_DAYS */ "Доступен в следующие дни",
        /* AVAILABLE_SHIFTS */ "Доступные смены",
        /* AVAILABLE_VISITS */ "Доступные Визиты",
        /* AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK */ null,
        /* AWAITING_PATIENT_CONTACT */ "В ожидании контакта",
        /* A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT */ "План ухода за этим пациентом уже существует",
        /* A_VERIFICATION_CODE_IS_BEING_SENT_TO */ "Проверочный код будет отправлен на",
        /* A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE */ "Проверочный код будет отправлен вам в СМС.",
        /* A_VISIT_BY */ "Визит выполняется",
        /* BACK */ null,
        /* BACK_TO_ONBOARDING */ null,
        /* BANK_INFORMATION */ null,
        /* BANK_NAME */ null,
        /* BASICALLY_EVERY_ACTION_COUNTS */ null,
        /* BEFORE_SUBMITTING_THE_DUTIES */ null,
        /* BEGIN_NOW */ null,
        /* BEST_TASK_FOR_YOU */ null,
        /* BETWEEN */ "от",
        /* BETWEEN_AND */ "до",
        /* BIRTHDAY */ "Дата рождения",
        /* BLOOD_PRESSURE */ null,
        /* BOROUGH */ null,
        /* BUNDLES */ null,
        /* BUNDLE_DESCRIPTION */ null,
        /* BUNDLE_DESCRIPTION_P1 */ "Пакет включает в себя",
        /* BUNDLE_DESCRIPTION_P2 */ "параграфа(-ов). Некоторые параграфы также могут содержать тест. Посмотрите необходимое содержание. После выполнения обязательного задания вы получите сертификат. Удачи",
        /* BUNDLE_IS_LOCKED */ null,
        /* BUNDLE_ITEM_NOT_FOUND */ null,
        /* BUNDLE_NOT_FOUND */ null,
        /* BUNDLE_PROGRESS */ "Прогресс изучения пакета",
        /* BUSY_ALL_DAY */ "Занят весь день",
        /* BY */ null,
        /* BY_ENROLLING_I_ACCEPT_THE */ null,
        /* BY_EXISTING_VISIT */ "По существующему визиту:",
        /* BY_PATIENT_NAME */ "По имени пациента:",
        /* BY_SIGNING_HERE_I_ACCEPT_THE */ "Моя подпись здесь означает, что я принимаю",
        /* CALL */ null,
        /* CALL_AGENCY */ "Позвонить в агентство",
        /* CALL_HOME */ "Звонок на домашний телефон",
        /* CALL_MOBILE */ "Звонок на мобильный телефон",
        /* CALL_NOW */ "Позвоните сейчас:",
        /* CALL_PATIENT */ "Позвонить пациенту",
        /* CALL_PATIENT_CONFIRMATION */ null,
        /* CALL_PATIENT_EXPLANATION */ "Вам позвонят через несколько мгновений после подтверждения этого сообщения.",
        /* CALL_PATIENT_HOME */ "Позвонить пациенту на домашний телефон",
        /* CALL_PATIENT_MOBILE */ "Позвонить пациенту на мобильный телефон",
        /* CALL_PATIENT_NOTE */ "Свяжитесь с пациентом на следующем экране",
        /* CALL_SUPPORT_FOR_MORE_INFO */ "Позвоните в службу поддержки для получения дополнительной информации",
        /* CANCEL */ "Отмена",
        /* CANCEL_REQUESTED_SHIFTS */ null,
        /* CANCEL_VISIT */ null,
        /* CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE */ null,
        /* CANT_CANCEL_24_HOURS_SCHEDULED_VISIT */ "Ошибка: До визита осталось менее 24 часов",
        /* CANT_CANCEL_AT_THIS_TIME */ "Сейчас невозможно отменить",
        /* CANT_CLOCK_IN */ "Невозможно отметить время прихода",
        /* CANT_CLOCK_IN_AT_THIS_TIME */ "Сейчас невозможно отметить время прихода.",
        /* CANT_CLOCK_OUT */ "Невозможно отметить время ухода",
        /* CANT_CLOCK_OUT_AT_THIS_TIME */ "Сейчас невозможно отметить время ухода.",
        /* CANT_CLOCK_OUT_BEFORE_VISIT_ENDED */ "Невозможно отметить время ухода до окончания визита.",
        /* CANT_REJECT_VISIT_PENDING_STATUS */ null,
        /* CANT_REQUEST_JOIN_AGENCY */ "Невозможно запросить членство в агентстве",
        /* CANT_REQUEST_VISIT_PENDING_STATUS */ null,
        /* CANT_SUBMIT_AN_EMPTY_FORM */ null,
        /* CANT_WATCH_ON_SHIFT */ "Это обучение не доступно во время смен 👀",
        /* CANT_WATCH_THIS_VIDEO */ "Не удается посмотреть это видео",
        /* CAREBACK_CASH_BONUS */ null,
        /* CAREBACK_POINTS */ null,
        /* CAREGIVER */ "Специалист по уходу",
        /* CAREGIVER_COMPLIANCE_PASSPORT */ "Паспорт соответствия требованиям для специалиста по уходу",
        /* CAREGIVER_NAME */ "Имя помощника по уходу",
        /* CAREGIVER_PHONE */ "Телефон помощника по уходу",
        /* CAREGIVER_SIGNATURE */ null,
        /* CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG */ "Убедитесь, что вы и пациент подписали план ухода",
        /* CAREGIVER_SIGNATURE_IS_REQUIRED */ null,
        /* CAREGIVER_SIGNATURE_REQUIRE_MSG */ "Убедитесь, что вы зарегистрировались в плане ухода",
        /* CAREGIVER_STATUS_PENDING_ERROR */ "Невозможно выполнить действие, поскольку ваш профиль все еще находится на рассмотрении.",
        /* CARE_MOMENTS */ null,
        /* CASE_INFO */ null,
        /* CASE_IS_TOO_FAR */ "Случай слишком далеко",
        /* CASE_SETTINGS */ "Настройки случая",
        /* CATALOGUE */ null,
        /* CERTIFICATION */ null,
        /* CERTIFICATIONS */ null,
        /* CHANGE */ null,
        /* CHANGES_TO_MY_VISITS */ null,
        /* CHANGES_WERE_SAVED_IN_THE_CLOUD */ "Все изменения были сохранены в облаке",
        /* CHANGE_DOCUMENT */ null,
        /* CHANGE_OF_RANKING */ null,
        /* CHANGE_PHONE_NUMBER */ "Сменить номер телефона",
        /* CHANGE_SETTINGS */ null,
        /* CHANGE_SHIFTS */ null,
        /* CHANGE_TASK_TIME */ null,
        /* CHANGE_VISIT_TIMES */ "Изменить сроки визита",
        /* CHAT */ "Чат",
        /* CHATS */ "Чаты",
        /* CHAT_MESSAGES */ null,
        /* CHAT_NOT_ACTIVE_MESSAGE */ "Вы не можете отправлять здесь сообщения.",
        /* CHAT_NOT_ACTIVE_TITLE */ "Чат больше не активен",
        /* CHAT_WITH_AGENCY */ "Чат с агентством",
        /* CHAT_WITH_AGENCY_ABOUT_PATIENT */ null,
        /* CHAT_WITH_MEDFLYT */ null,
        /* CHAT_WITH_OTHER_AGENCIES */ null,
        /* CHAT_WITH_SUPPORT */ "Чат со службой поддержки",
        /* CHAT_WITH_US */ null,
        /* CHECK */ null,
        /* CHECK_AGAIN */ null,
        /* CHOOSE_ANOTHER_DATE */ "Выберите другую дату",
        /* CHOOSE_A_PHOTO */ null,
        /* CHOOSE_A_TIME_FOR_THE_VISIT */ "Выберите время визита",
        /* CHOOSE_CLOCK_TIMES */ null,
        /* CHOOSE_DATE_TO_PERFORM_THIS_TASK */ null,
        /* CHOOSE_FOLDER_TO_UPLOAD */ "Выберите папку для загрузки.",
        /* CHOOSE_START_TIME */ "Выберите время начала",
        /* CHOOSE_THE_HOURS */ "Далее (выберите часы)",
        /* CHOOSE_TIME */ null,
        /* CHOOSE_WHEN_TO_PERFORM_THE_VISIT */ "Выберите время выполнения визита",
        /* CHOOSE_WHEN_TO_VISIT_THE_PATIENT */ "Выберите время визита к пациенту",
        /* CHOOSE_WHO_TO_CONTACT */ "Выберите контакт для связи",
        /* CHOOSING_A_WINNER */ null,
        /* CHOOSING_A_WINNER_IN */ null,
        /* CLEAR */ "Очистить",
        /* CLICK_HERE */ null,
        /* CLICK_HERE_TO_DOWNLOAD */ "Нажмите сюда для загрузки",
        /* CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE */ "Нажмите сюда, чтобы поделиться своим реферальным кодом",
        /* CLICK_HERE_TO_VIEW_CERTIFICATE */ "НАЖМИТЕ СЮДА ДЛЯ ПРОСМОТРА СЕРТИФИКАТА",
        /* CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE */ "Поздравляем с получением вашего первого сертификата🏆🏆! Нажмите для просмотра вашего нового сертификата",
        /* CLICK_TO_REQUEST */ "Запросите",
        /* CLICK_TO_SCAN_UPLOAD */ "Нажмите для сканирования и загрузки",
        /* CLICK_TO_TAKE_A_SELFIE */ null,
        /* CLIMB_THE_RANKS_BY_COMPLETING_VISITS */ null,
        /* CLINICAL_SUPPORT */ "Клиническая поддержка",
        /* CLOCKED_IN */ "Отметил(а) время прихода в",
        /* CLOCKED_IN_AND_OUT */ null,
        /* CLOCKED_IN_AT */ "Отметил(а) время прихода в",
        /* CLOCKED_OUT */ "Время ухода отмечено",
        /* CLOCKED_OUT_AT */ "Отметил(а) время ухода в",
        /* CLOCKING_IN */ "Фиксация времени прихода...",
        /* CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES */ null,
        /* CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES */ null,
        /* CLOCKING_OUT */ "Фиксация времени ухода...",
        /* CLOCK_ADDRESS_IN_RANGE */ null,
        /* CLOCK_ADDRESS_NOT_IN_RANGE */ null,
        /* CLOCK_IN */ "Отметить время прихода",
        /* CLOCK_IN_ANYWAY */ null,
        /* CLOCK_IN_AT */ "Отметить время прихода в",
        /* CLOCK_IN_BETWEEN */ null,
        /* CLOCK_IN_OUT */ "Отметка времени прихода/ухода",
        /* CLOCK_IN_OUT_SUBMIT_DUTIES */ null,
        /* CLOCK_IN_TIME_IS_REQUIRED */ null,
        /* CLOCK_OUT */ "Отметить времени ухода",
        /* CLOCK_OUT_AFTER */ "Отметить время ухода после",
        /* CLOCK_OUT_AT */ "Отметить время ухода в",
        /* CLOCK_OUT_BETWEEN */ null,
        /* CLOCK_OUT_TIME_IS_REQUIRED */ null,
        /* CLOCK_TIMES_NOT_MOBILE */ null,
        /* CLOCK_TIME_IN_RANGE */ null,
        /* CLOCK_TIME_NOT_IN_RANGE */ null,
        /* CLOSE */ null,
        /* CLOSE_SURVEY */ null,
        /* CLUSTERED_VISIT_EXPLENATION */ "Мы обнаружили, что пункты назначения этих 2 визитов находятся близко друг к другу и эти визиты соответствуют вашему дневному графику. Мы рекомендуем запросить оба эти визита вместе. Вы также можете запросить каждый из визитов отдельно",
        /* CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE */ "Код не найден, используйте другой",
        /* COMBINED_CASE */ "Объединенный случай",
        /* COMING_SOON */ null,
        /* COMPLETED */ "Завершено",
        /* COMPLETED_DOCUMENTS */ "Заполненные документы",
        /* COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL */ null,
        /* COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS */ null,
        /* COMPLETE_PREVIOUS_SECTIONS_FIRST */ null,
        /* COMPLETE_REGISTRATION */ null,
        /* COMPLETE_REGISTRATION_PROCESS */ null,
        /* COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* COMPLETE_VISIT */ null,
        /* COMPLETE_YOUR_ONBOARDING_ANYTIME */ null,
        /* COMPLIANCE */ "Соблюдение правил",
        /* COMPLIANCE_EXPIRY */ "Вам нужно посмотреть видеозаписи",
        /* COMPLIANCE_FORM */ null,
        /* COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY */ null,
        /* COMPLIANT */ "Соответствует",
        /* COMPLIANT_ITEMS */ null,
        /* CONFIRM */ "Подтвердить",
        /* CONFIRM_ASSESSMENT */ "Подтвердить оценку",
        /* CONFIRM_COPY_LAST */ "Вы точно хотите скопировать ответы из",
        /* CONFIRM_COPY_LAST_TITLE */ "Подтверждаете копирование?",
        /* CONFIRM_DEPOSIT_DETAILS */ null,
        /* CONFIRM_PATIENT_AVAILABILITY */ null,
        /* CONFIRM_PATIENT_AVAILABILITY_MESSAGE */ null,
        /* CONFIRM_RN_FLEX_VISIT */ "Я подтверждаю свой визит",
        /* CONFIRM_WITHOUT_LOCATION */ "Подтвердить без места",
        /* CONGRATULATIONS */ null,
        /* CONGRATULATIONS_TO */ null,
        /* CONNECTING_HOME */ "Устанавливаем контакты",
        /* CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS */ null,
        /* CONNECT_WITH_US_ON_FACEBOOK */ null,
        /* CONNECT_WITH_US_ON_WHATSAPP */ null,
        /* CONTACT */ "Связаться",
        /* CONTACT_AGENCY_FOR_MORE_INFO */ "Свяжитесь с агентством для получения более подробной информации.",
        /* CONTACT_PATIENT */ "Связаться с пациентом",
        /* CONTACT_SUPPORT */ "Связаться со службой поддержки",
        /* CONTINUE */ null,
        /* CONTINUE_LATER */ "Продолжить позже",
        /* CONTINUE_TO_APP */ null,
        /* CONTINUE_TO_ORIENTATION */ null,
        /* CONTINUE_TO_SIGN_UP */ null,
        /* CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK */ null,
        /* COORDINATOR */ null,
        /* COORDINATOR_EMAIL */ "Эл. почта координатора",
        /* COORDINATOR_IN_CHARGE */ "Ответственный координатор",
        /* COORDINATOR_PHONE */ "Телефон координатора",
        /* COPY */ "Копировать",
        /* COPY_FROM_LAST_TIME */ "Копировать из прошлого раза",
        /* COPY_FROM_MEDICATION */ "Копировать из лекарства",
        /* COPY_FROM_OTHER_FORMS */ "Копировать из других форм",
        /* COPY_LAST_NO_DATE_FALLBACK_APPENDED */ "последний раз",
        /* COPY_MEDICATION_CHART */ "Скопировать график приема лекарств",
        /* COPY_PLAN_OF_CARE */ "Скопировать план ухода",
        /* CORRECT */ "Верно",
        /* COURSES */ null,
        /* COVID */ "COVID-19",
        /* COVID_REQUIRED */ "Требуется анкета о COVID-19",
        /* COVID_REQUIRED_EXPLAINED */ "Сегодня вы не заполнили анкету о COVID-19. Заполните ее, чтобы продолжить",
        /* COVID_SCREENING_CLICK_HERE */ "Скрининг на COVID-19 – нажмите сюда",
        /* CREATED_AT */ "Создано в",
        /* CREATE_A_NEW_ACCOUNT */ null,
        /* CREATE_NEW_PLAN_OF_CARE */ "Создать новый план ухода",
        /* CRIMINAL_CONVICTIONS_RECORDS */ null,
        /* CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT */ "Сейчас отметил(а) приход в процессе другого визита",
        /* CURRENT_BALANCE */ null,
        /* CURRENT_VISIT */ null,
        /* DATA_WILL_BE_LOST */ "Данные будут потеряны",
        /* DATE */ "Дата",
        /* DATES */ "Даты",
        /* DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO */ null,
        /* DATE_NOT_SPECIFIED */ null,
        /* DATE_OF_BIRTH */ null,
        /* DATE_UNKNOWN */ null,
        /* DATE_VERIFICATION */ "Проверка даты",
        /* DAY */ null,
        /* DAYS */ "дня(-ей)",
        /* DAYS_A_WEEK */ "Дней в неделю",
        /* DAYS_LEFT */ "Осталось дней",
        /* DAYS_OF_WEEK */ "Дней в неделю",
        /* DECEMBER */ null,
        /* DECLINED */ "Отклонен",
        /* DELETE */ "Удалить",
        /* DESCRIBE_THE_PROBLEM */ null,
        /* DETAILS */ "сведения",
        /* DIRECTIONS */ "Указания",
        /* DIRECT_DEPOSIT */ null,
        /* DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION */ "Разъединено. Проверьте свое подключение к Интернету",
        /* DISCOVER_YOUR_JOURNEY */ null,
        /* DISCRIMINATION */ null,
        /* DISMISS */ null,
        /* DISMISSED */ null,
        /* DISTANCE */ "Расстояние",
        /* DOB */ null,
        /* DOCUMENT */ null,
        /* DOCUMENTS */ "Документы",
        /* DOCUMENTS_TO_COMPLETE */ null,
        /* DOCUMENT_HAS_EXPIRED */ "Срок действия документа истек",
        /* DOCUMENT_IS_MISSING */ "Отсутствует документ",
        /* DOCUMENT_REJECTED */ "Документ отклонен",
        /* DOCUMENT_SELECTED */ null,
        /* DOESNT_EXPIRE */ null,
        /* DOES_NOT_FIT_MY_SCHEDULE */ "Не соответствует моему графику",
        /* DONE */ "Готово",
        /* DONT_FORGET_TO_CLOCK_IN */ null,
        /* DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS */ null,
        /* DONT_FORGET_TO_CLOCK_OUT */ "Не забудьте отметить уход",
        /* DONT_FORGET_TO_FILL_THE_DUTY_SHEET */ null,
        /* DONT_FORGET_TO_SMILE */ null,
        /* DONT_SCHEDULE_VISIT */ null,
        /* DONT_SHOW_AGAIN */ null,
        /* DOSE */ "Дозировка",
        /* DOWNLOAD_PDF */ null,
        /* DO_YOU_HAVE_ANY_QUESTIONS_ASK */ null,
        /* DO_YOU_WANT_THIS_VISIT */ null,
        /* DUE_BETWEEN */ null,
        /* DUE_BY_DATETIME */ null,
        /* DUE_DATE */ null,
        /* DUE_ON */ null,
        /* DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO */ null,
        /* DURATION */ null,
        /* DURATION_PER_DAY */ "Продолжительность в день",
        /* DUTIES */ null,
        /* DUTIES_COMPLETED_SUCCESSFULLY */ null,
        /* DUTY_SHEET_SUBMITTED */ "Табель выполненных работ отправлен",
        /* EACH_100_POINTS_DOLLAR */ null,
        /* EACH_INVITE */ "Каждое приглашение",
        /* EARLY_OR_LATE_CLOCKS */ null,
        /* EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY */ null,
        /* EDIT */ "Изменить",
        /* EDIT_ACCOUNT_DETAILS */ null,
        /* EDIT_TIMES */ "Изменить время",
        /* EDUCATION */ "Учебный центр",
        /* ELECTRIC_EQUIPMENT_DEPENDENCY */ null,
        /* ELIGIBLE_VISITS */ null,
        /* EMAIL */ null,
        /* EMAIL_QUESTION_PENDING_VERIFICATION */ null,
        /* EMAIL_SUPPORT */ null,
        /* EMAIL_SUPPORT_FOR_MORE_INFO */ "Напишите по эл. почте в службу поддержки для получения дополнительной информации",
        /* EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER */ null,
        /* EMAIL_VERIFICATION_QUESTION_LABEL */ null,
        /* EMERGENCY_CONTACTS */ null,
        /* EMPTY_DURATION */ null,
        /* EMPTY_PATIENT_MEDICATION_PROFILE */ "Профиль лекарств пациента пуст",
        /* ENABLE_LOCATION_MESSAGE */ null,
        /* ENABLE_LOCATION_TITLE */ null,
        /* ENDING_AT */ "Заканчивается в",
        /* ENDS */ "Заканчивается",
        /* END_DATE */ "Дата окончания",
        /* END_TIME */ "Время окончания",
        /* ENROLLMENT_REQUESTED */ null,
        /* ENROLL_NOW */ null,
        /* ENTER_AGENCY_CODE */ "Введите код агентства",
        /* ENTER_DOCUMENT_NAME */ "Введите название документа",
        /* ENTER_NUMBER_HERE */ "Введите номер сюда",
        /* ENTER_TEXT_HERE */ "Введите текст сюда",
        /* ENTER_YOUR_MOBILE_NUMBER */ "Введите свой номер мобильного телефона",
        /* ENTER_YOUR_PIN_CODE */ null,
        /* ENTITY_IS_MISSING */ null,
        /* ERROR */ "Ошибка",
        /* ERROR_FETCHING_SLOTS */ null,
        /* ERROR_LOADING_DATA */ null,
        /* ERROR_REMOVING_DOCUMENT */ "При удалении документа возникла ошибка",
        /* ERROR_SCHEDULING_TASK */ null,
        /* ERROR_SCHEDULING_TASK_MESSAGE */ null,
        /* ESTIMATED_ADDRESS_WILL_BE_PROVIDED */ null,
        /* ESTIMATED_TIME_OF_CLOCKING_OUT_IS */ null,
        /* EVACUATION_LOCATION */ null,
        /* EVACUATION_ZONE */ null,
        /* EVERY_VISIT */ "Каждый визит",
        /* EVV */ null,
        /* EXCITING_NEWS_AHEAD */ null,
        /* EXEMPTED */ "Освобожден(-а)",
        /* EXPIRED */ "Срок истек",
        /* EXPIRED_COMPLIANCE */ null,
        /* EXPIRED_ON_DATE */ null,
        /* EXPIRES_AT */ "Срок истекает в",
        /* EXPIRES_IN */ "Истекает через",
        /* EXPIRES_IN_ONE_DAY */ "Срок действия истекает через один день",
        /* EXPIRES_IN_X_DAYS */ "Срок действия истекает через %d дня (дней)",
        /* EXPIRES_ON_DATE */ null,
        /* EXPIRING_COMPLIANCE */ null,
        /* EXPIRING_SOON */ null,
        /* EXPIRY_DATE */ "Дата истечения срока действия",
        /* EXPLORE */ null,
        /* EXPLORE_A_CAREER_ENHANCEMENTS */ null,
        /* FAILED_TO_IDENTIFY_PATIENT */ "Не удалось установить личность пациента",
        /* FAR_VISIT_WARNING_MODAL_TITLE */ null,
        /* FAX_NUMBER */ null,
        /* FEBRUARY */ null,
        /* FEMALE */ "Женщина",
        /* FIFTHY_DOLLAR_AMAZON_GIFT_CARD */ null,
        /* FILES */ null,
        /* FILE_NOT_FOUND_CONTACT_AGENCY */ null,
        /* FILL */ null,
        /* FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT */ null,
        /* FILL_IN_THE_QUESTIONNAIRE */ "Заполните анкету",
        /* FILTERS */ "Фильтры",
        /* FINAL_CONFIRMATION */ null,
        /* FIND_A_CARE_MOMENT */ null,
        /* FIND_A_CARE_MOMENT_DESCRIPTION */ null,
        /* FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FINISH_MY_ONBOARDING */ null,
        /* FINISH_ONBOARDING_AND_GET_DOLLARS */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2 */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE_STAGE_2 */ null,
        /* FINISH_SHIFT */ null,
        /* FINISH_THE_DOCUMENTS */ null,
        /* FIRST_NAME */ "Имя",
        /* FIRST_SHIFT */ "Первая смена",
        /* FIVE_THOUSAND_POINTS */ null,
        /* FIX */ null,
        /* FIX_DOCUMENTS_DESCRIPTION */ null,
        /* FIX_DOCUMENT_DESCRIPTION */ null,
        /* FIX_ISSUE */ null,
        /* FIX_ISSUES */ null,
        /* FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* FIX_SETTINGS */ "Исправить настройки",
        /* FIX_THE_DOCUMENT */ null,
        /* FIX_THE_DOCUMENTS */ null,
        /* FIX_YOUR_DOCUMENT */ null,
        /* FIX_YOUR_DOCUMENTS */ null,
        /* FLEXIBLE */ null,
        /* FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_VISIT */ "Визит с изменяемыми днями",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT */ null,
        /* FLEXIBLE_HOURS_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_VISIT */ "Визит с изменяемым временем",
        /* FLEXIBLE_VISIT */ "Визит с изменяемым сроком",
        /* FLEXIBLE_VISIT_DAY_TO_CHOOSE */ null,
        /* FLEXIBLE_VISIT_DETAILS */ "Сведения о визите с изменяемым сроком",
        /* FLEXIBLE_VISIT_TYPE */ "Визит с изменяемым сроком",
        /* FLU_SHOT */ null,
        /* FLU_SHOT_SUBMITTION_MESSAGE */ null,
        /* FOLLOW_US_ON_INSTAGRAM */ "Подпишитесь на нас в Instagram",
        /* FOLLOW_US_ON_TWITTER */ "Подпишитесь на нас в Twitter",
        /* FORGOT_PIN_CODE_DIALOG_MESSAGE */ "Обратите внимание: вы перейдете в окно входа в систему и начнется новая процедура регистрации.",
        /* FORM_NAME */ "Имя формы",
        /* FOURTEEN_THOUSAND_POINTS */ null,
        /* FREQUENCY */ "Частота",
        /* FRIEND */ null,
        /* FROM */ "От",
        /* FROM_CAMERA */ "С камеры",
        /* FROM_GALLERY */ "Из галереи",
        /* FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE */ "Полный текст положений и условий — конкурс MedFlyt",
        /* FUTURE_VISITS */ null,
        /* GENDER */ "Пол",
        /* GENERAL */ "Общие сведения",
        /* GENERAL_FILES */ "Общие файлы",
        /* GENERAL_NOTES */ "Общие примечания",
        /* GENERAL_SUPPORT */ null,
        /* GET_INSTAPAY */ null,
        /* GET_IT_NOW */ null,
        /* GET_MONEY_FOR_THIS_VISIT_TODAY
 */ null,
        /* GET_NOW */ null,
        /* GET_STARTED */ null,
        /* GET_THE_APP */ null,
        /* GET_X_NOW */ null,
        /* GOOD_JOB */ "Хорошая работа!",
        /* GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "Хорошая работа! На текущий момент вы изучили все уроки",
        /* GOT_IT */ "Понятно",
        /* GO_BACK */ "Назад",
        /* GO_TO */ "Перейти к",
        /* GO_TO_MEDFLYT_PASSPORT */ null,
        /* GO_TO_PATIENT */ "Перейти к пациенту",
        /* GO_TO_PATIENT_DETAILS */ "Перейти к сведениям о пациенте",
        /* GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION */ null,
        /* GO_TO_VISIT */ "Перейти к визиту",
        /* GREAT_JOB */ "Отличная работа!",
        /* GROSS_PAY */ null,
        /* HAS_DNR */ null,
        /* HAS_HEALTH_CARE_PROXY */ null,
        /* HAVE_A_NICE_WORKING_DAY */ null,
        /* HAVE_A_PLEASANT_VISIT */ null,
        /* HAVE_A_QUESTION_LETS_CHAT */ null,
        /* HEALTH_AGENCIES */ "между агентствами медпомощи на дому",
        /* HELP */ "Помощь",
        /* HELP_ME_FIND_MY_AGENCY */ "Помогите мне найти мое агентство",
        /* HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY */ null,
        /* HEY */ "Эй!",
        /* HEY_THERE */ null,
        /* HI */ "Здравствуйте!",
        /* HIRE_DATE */ null,
        /* HI_PLEASE_HELP_ME_FILL_MY_APPLICATION  */ null,
        /* HOME_PHONE */ "Домашний телефон",
        /* HOUR */ null,
        /* HOURS */ null,
        /* HOURS_PER_DAY */ "Часов в день",
        /* HOURS_PER_VISIT */ "Длительность визита в часах",
        /* HOW_ARE_WE_CALCULATING_THE_RANK */ null,
        /* HOW_CAN_WE_HELP_YOU */ "Как мы можем вам помочь?",
        /* HOW_CARE_MOMENTS_WORKS */ null,
        /* HOW_DID_YOU_HEAR_ABOUT_US */ null,
        /* HOW_DOES_IT_WORK */ null,
        /* HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS */ null,
        /* HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN */ null,
        /* HOW_DO_YOU_RATE_MEDFLYT */ "Как вы оцениваете Medflyt?",
        /* HOW_URGENT_IS_THE_ISSUE */ null,
        /* HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT */ "Как вы хотели бы обращаться к пациенту?",
        /* HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE */ null,
        /* HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT */ null,
        /* HR_PER_VISIT */ "Часов на визит",
        /* HUNDRED_DOLLARS_GIFT_CARD */ "подарочную карту American Express номиналом $100!",
        /* ICD */ null,
        /* ID */ null,
        /* IF_YOU_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON */ null,
        /* IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE */ null,
        /* IF_YOU_STAY_COMPLIANT */ null,
        /* IMPORTANT_INFORMATION */ null,
        /* IMPORTED */ "Импортировано",
        /* IM_AVAILABLE */ "Я доступен(на)",
        /* IM_DONE_SUBMIT */ null,
        /* IM_NOT_INTERESTED */ "Это меня не интересует",
        /* IM_WORKING_WITH_AN_AGENCY */ null,
        /* INACTIVE */ "Неактивно",
        /* INCOMPLETE */ null,
        /* INCORRECT */ "Неверно",
        /* INCORRECT_CODE */ "Неверный код",
        /* INCORRECT_DIGITS */ null,
        /* INCORRECT_DIGITS_EXPLAINED */ null,
        /* INCORRECT_DIGITS_MESSAGE */ null,
        /* INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN */ "Неверный пин-код. Повторите попытку.",
        /* INCORRECT_SMS_CODE */ null,
        /* INCORRECT_SMS_CODE_EXPLAINED */ null,
        /* INFORMATION_CENTER */ null,
        /* INFORMATION_NOT_MATCH_PROFILE */ null,
        /* INSERT_THEIR_REFERRAL_CODE_HERE */ "Вставьте его или ее реферальный код сюда!",
        /* INSERVICES */ null,
        /* INSTAPAY */ null,
        /* INSTAPAY_HISTORY */ null,
        /* INSTAPAY_TECHNICAL_ISSUE */ null,
        /* INSUFFICIENT_DUTIES */ null,
        /* INTERESTED_IN_THIS_BUNDLE */ null,
        /* INTRODUCING */ null,
        /* INVALID_DOCUMENT_NAME */ "Неверное имя документа",
        /* INVALID_EMAIL */ "Неверный адрес эл. почты",
        /* INVALID_FORM */ null,
        /* INVALID_PHONE */ "Неверный телефон",
        /* INVALID_PHONENUMBER */ null,
        /* INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN */ null,
        /* INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES */ "Пригласите помощников по уходу в MedFlyt и выиграйте потрясающие призы",
        /* INVITE_FRIENDS */ "Пригласите друзей",
        /* IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE */ null,
        /* IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT */ null,
        /* IN_PROGRESS */ null,
        /* ISSUES_TO_SOLVE */ null,
        /* IS_DUE_IN_DAYS */ null,
        /* IS_DUE_TOMORROW */ null,
        /* ITEMS_THAT_WILL_EXPIRE_SOON */ null,
        /* ITEMS_WITH_ISSUES */ null,
        /* ITEM_IS_MISSING */ null,
        /* ITEM_IS_NOT_COMPLIANT */ null,
        /* ITS_NOT_ME */ null,
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU */ null,
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU */ null,
        /* IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK */ null,
        /* IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE */ null,
        /* I_DONT_HAVE_MY_CODE */ "У меня нет кода",
        /* I_DONT_WANT_THIS_CASE */ null,
        /* I_DONT_WANT_TO_CLOCK */ null,
        /* I_FORGOT_MY_PIN_CODE */ "Я забыл(а) пин-код",
        /* I_HAVE_CHANGED_MY_MIND */ null,
        /* I_HAVE_READ_AND_AGREE */ null,
        /* I_VERIFY_THE_TERMS */ null,
        /* I_WANT_TO_CLOCK_IN_ANYWAY */ null,
        /* I_WANT_TO_CLOCK_OUT_ANYWAY */ null,
        /* I_WANT_TO_FINISH_MY_ONBOARDING */ null,
        /* I_WILL_DO_IT_LATER */ null,
        /* JANUARY */ null,
        /* JOINED_DATE */ "Дата регистрации",
        /* JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT */ null,
        /* JULY */ null,
        /* JUNE */ null,
        /* JUST_ONE_MORE_THING */ null,
        /* JUST_TO_BE_SURE */ null,
        /* JUST_VERIFYING_ITS_YOU */ null,
        /* KEEP_UP_THE_GOOD_WORK */ null,
        /* LABELS */ "Ярлыки",
        /* LANGUAGE */ "Язык",
        /* LANGUAGES */ "Языки",
        /* LAST_NAME */ "Фамилия",
        /* LEARN_MORE */ null,
        /* LEAVE_WITHOUT_SAVING */ "Выйти без сохранения?",
        /* LEFT */ null,
        /* LESSON */ null,
        /* LESSONS */ "Уроки",
        /* LETS_CONTINUE_TO_NEXT_SECTION */ null,
        /* LETS_FIND_CASES */ null,
        /* LETS_FIND_YOUR_FIRST_CASE */ null,
        /* LETS_FIND_YOUR_FIRST_PATIENT */ null,
        /* LETS_FINISH_YOUR_SHIFT */ null,
        /* LETS_START */ null,
        /* LETS_START_YOUR_SHIFT */ null,
        /* LIKE_US_ON_FACEBOOK */ "Поставьте нам «лайк» на Facebook",
        /* LINKED_TO_ANOTHER_PATIENT */ null,
        /* LIST */ "Список",
        /* LISTENING___ */ null,
        /* LIST_OF_PATIENTS */ null,
        /* LIST_OF_TASKS */ null,
        /* LIST_OF_VISITS */ null,
        /* LIVE_CHAT_SUPPORT */ "Поддержка в онлайн-чате",
        /* LIVE_CLASS */ null,
        /* LIVE_CLASS_EXPLANATION */ null,
        /* LIVE_EVENTS */ null,
        /* LOADING */ "Загрузка",
        /* LOADING_LOCATION */ "Местоположение загрузки...",
        /* LOCATION */ "Местоположение",
        /* LOCKED */ "Заблокировано",
        /* LOGGING_YOU_IN */ null,
        /* LOGIN */ null,
        /* LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED */ null,
        /* LOOKS_LIKE_MORE_THAN */ null,
        /* LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION */ null,
        /* MAIN_TASKS */ null,
        /* MAKE_A_DIFFERENCE */ null,
        /* MAKE_SURE_PICTURE_IS_CLEAR */ null,
        /* MALE */ "Мужчина",
        /* MANUALLY_SUBMITTED_INFO */ null,
        /* MAP */ "Карта",
        /* MARCH */ null,
        /* MAX_TRAVEL_DISTANCE */ "Макс. длина пути",
        /* MAY */ null,
        /* MAYBE_LATER */ "может быть, позже",
        /* MAY_CLOCK_IN_AT */ "Может отметить приход в",
        /* MAY_CLOCK_OUT_FROM */ "Может отметить время ухода в",
        /* MEC_WAIVER_INFORMATION */ null,
        /* MEDFLYT */ null,
        /* MEDFLYTS_MONTHLY_RAFFLE */ null,
        /* MEDFLYT_AGENCY_HANDBOOK */ null,
        /* MEDFLYT_AT_HOME_BENEFITS */ null,
        /* MEDFLYT_CHALLENGE */ "Конкурс MedFlyt",
        /* MEDFLYT_HOME_CARE */ null,
        /* MEDFLYT_ID_CARD */ null,
        /* MEDFLYT_PASSPORT */ "Паспорт Medflyt",
        /* MEDFLYT_PASSPORT_TERMS */ null,
        /* MEDFLYT_RAFFLE */ null,
        /* MEDFLYT_TEAM */ null,
        /* MEDFLYT_VERSION */ "Версия MedFlyt",
        /* MEDICAL_FILES */ "Медицинские файлы",
        /* MEDICAL_INFORMATION */ "Медицинская информация",
        /* MEDICAL_NOTES */ null,
        /* MEDICATIONS */ null,
        /* MESSAGE */ "Сообщение",
        /* MESSAGE_FOR_THE_COORDINATOR */ "Сообщение для координатора",
        /* MIDDLE_NAME */ "Среднее имя",
        /* MILES_AWAY */ "Миль до места назначения",
        /* MILES_BETWEEN_PATIENTS */ "Миль между пациентами",
        /* MILES_SHORT */ "миль",
        /* MINIMUM_WAGE */ null,
        /* MINUTE */ null,
        /* MINUTES */ "Минуты",
        /* MINUTE_VISIT */ "-минутный визит",
        /* MISSING */ "Отсутствует",
        /* MISSING_CLOCKS */ null,
        /* MISSING_PERSONAL_CARE_DUTY */ null,
        /* MM_DD_YYYY */ null,
        /* MOBILE_PHONE */ "Мобильный телефон",
        /* MOBILITY_STATUS */ null,
        /* MONTH */ "Месяц",
        /* MONTHLY_RAFFLE */ null,
        /* MORE_DETAILS */ "Подробнее",
        /* MORE_DETAILS_BELOW */ null,
        /* MORE_SHIFTS_MORE_CHANCES */ null,
        /* MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* MUST_AGREE_TERMS */ null,
        /* MUST_BE_ATLEAST_3_CHARACTERS */ "Должно содержать минимум 3 символа",
        /* MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS */ "Должен состояться в один из следующих дней",
        /* MUST_PICK_EXACTLY */ "Необходимо выбрать точно",
        /* MUST_START_AT_OR_AFTER */ "должен начинаться В или ПОСЛЕ",
        /* MUST_START_AT_OR_BEFORE */ "должен начинаться В или ДО",
        /* MUST_UPDATE_ADDRESS_TO_SEE_CASES */ "Для просмотра случаев вам нужно обновить свой адрес!",
        /* MY_AGENCIES */ "Мои агентства",
        /* MY_ASSIGNED_VISITS */ "Мои порученные визиты",
        /* MY_AVAILABILITY */ null,
        /* MY_BENEFITS_CARD_INFORMATION */ null,
        /* MY_MEDFLYT_COMPLIANCE */ null,
        /* MY_PASSPORT */ "Мой паспорт",
        /* MY_PAYROLL_HISTORY */ null,
        /* MY_PAYROLL_INFORMATION */ null,
        /* MY_PROFILE */ null,
        /* MY_REQUESTED_VISITS */ "Мои запрошенные визита",
        /* MY_STAFFING_PREFERENCES */ null,
        /* MY_UPCOMING_VISITS_REMINDERS */ null,
        /* MY_VIRTUAL_ID */ null,
        /* MY_VISITS */ null,
        /* NA */ "Н/д",
        /* NAME */ "Имя",
        /* NEAR */ null,
        /* NEED_DIRECTIONS */ "Нужны указания?",
        /* NET_PAY_FOR_PERIOD */ null,
        /* NEW */ "НОВОЕ",
        /* NEW_END_TIME_X */ null,
        /* NEW_MESSAGE */ null,
        /* NEW_TASK */ null,
        /* NEW_TASKS */ null,
        /* NEW_VISITS_AVAILABLE */ null,
        /* NEXT */ "ДАЛЕЕ",
        /* NEXT_DUE */ "Следующий срок",
        /* NEXT_LESSON */ null,
        /* NEXT_SECTION */ null,
        /* NEXT_TOKEN_IN */ null,
        /* NEXT_YEAR */ null,
        /* NO */ "Нет",
        /* NONE */ "Нет",
        /* NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT */ null,
        /* NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU */ null,
        /* NOTES */ "Примечания",
        /* NOTIFICATIONS */ "Уведомления",
        /* NOTIFICATIONS_OFF */ null,
        /* NOTIFICATIONS_ON */ null,
        /* NOT_AVAILABLE */ "не доступен(на)",
        /* NOT_COMPLIANT */ "Не соответствует требованиям",
        /* NOT_DUE_YET */ null,
        /* NOT_ENOUGH_HOURS */ "Недостаточно часов",
        /* NOT_ENOUGH_SHIFTS */ "Недостаточно смен...",
        /* NOT_ENOUGH_SHIFTS_MESSAGE */ "Вам нужно выбрать по крайней мере %minShifts% смен(-ы), чтобы запросить этот визит (вы выбрали только %currentShifts%).",
        /* NOT_FOUND */ null,
        /* NOT_INTERESTED */ "Не интересует",
        /* NOT_SELECTED */ null,
        /* NOT_SET */ null,
        /* NOT_SIGNING */ null,
        /* NOT_STARTED */ null,
        /* NOT_URGENT */ null,
        /* NOVEMBER */ null,
        /* NO_ALLERGIES */ null,
        /* NO_ANSWERS_TO_COPY */ "Нет ответов для копирования.",
        /* NO_ANSWERS_TO_COPY_TITLE */ "Не удалось скопировать!",
        /* NO_AVAILABLE_SLOTS */ null,
        /* NO_BALANCE */ null,
        /* NO_CHANGES_WERE_MADE */ "Изменения не внесены",
        /* NO_COMPLIANT_ITEMS */ null,
        /* NO_DOCUMENTS */ null,
        /* NO_DOCUMENTS_AVAILABLE */ "Нет доступных документов",
        /* NO_DOCUMENTS_REQUIRED */ "Документы не требуются.",
        /* NO_DUTIES_REQUIRED_FOR_THIS_VISIT */ null,
        /* NO_EDUCATION_LINK */ "Вам нужно бесплатное обучение? Обратитесь агентство",
        /* NO_ELIGIBLE_VISITS */ null,
        /* NO_END_DATE */ "Нет даты окончания",
        /* NO_GENERAL_NOTES */ "Нет общих примечаний",
        /* NO_IN_SERVICE_VIDEOS_AVAILABLE */ "Нет видео, записанных по время обслуживания. Свяжитесь со своим агентством для получения подробной информации.",
        /* NO_ISSUES_FOUND */ null,
        /* NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT */ null,
        /* NO_JUST_THIS_ONE */ null,
        /* NO_KEEP_THE_ORIGINAL_TIMES */ null,
        /* NO_KNOWN_ALLERGIES */ null,
        /* NO_LESSONS */ null,
        /* NO_LESSONS_FOR_YOU_YET */ "Для вас пока нет уроков",
        /* NO_MEDICAL_INFORMATION */ "Нет медицинской информации",
        /* NO_NOTIFICATIONS */ "Нет уведомлений",
        /* NO_PAYSTUBS_FOUND_FOR_THIS_MONTH */ null,
        /* NO_PHONE */ "Не указан телефон",
        /* NO_PHYSICIAN_SELECTED */ null,
        /* NO_PREVIOUS_CONVERSATIONS */ null,
        /* NO_SCHEDULED_VISITS_TODAY */ "Нет запланированных на сегодня визитов",
        /* NO_SHIFTS_SELECTED */ null,
        /* NO_TAKE_ME_BACK */ null,
        /* NO_TESTS */ null,
        /* NO_THANKS */ "Нет, спасибо",
        /* NO_TIME_LIMIT */ null,
        /* NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT */ null,
        /* NO_VIDEOS */ null,
        /* NO_VISITS_SCHEDULED */ null,
        /* NO_VISITS_SCHEDULED_MESSAGE */ null,
        /* NO_VISITS_SELECTED */ null,
        /* NPI */ null,
        /* NUM_COUNT_ITEMS */ null,
        /* NUM_SHIFTS_TO_GO */ null,
        /* NUM_SHIFTS_TO_WAGE */ null,
        /* N_A */ null,
        /* OCTOBER */ null,
        /* OF */ "Из",
        /* OF_THE_REQUIRED_PLEASE_CONTINUE */ "необходимого времени. Продолжайте, пожалуйста.",
        /* OF_THE_VIDEO */ "видео.",
        /* OK */ "OK",
        /* OK_ILL_TRY_LATER */ null,
        /* OK_NO_PROBLEM */ "Хорошо, никаких проблем!",
        /* OK_THANKS */ null,
        /* ON */ "В(о)",
        /* ONBOARDING */ null,
        /* ONBOARDING_COMPLETED */ null,
        /* ONBOARDING_COMPLETED_MESSAGE */ null,
        /* ONE_DAY_TO_COMPLETE */ "Один день для завершения.",
        /* ONE_DOCUMENT */ null,
        /* ONE_DOCUMENT_SELECTED */ null,
        /* ONE_HOUR */ null,
        /* ONE_LAST_STEP */ null,
        /* ONE_LESSON */ null,
        /* ONE_TEST */ null,
        /* ONE_THOUSAND_POINTS */ null,
        /* ONE_VIDEO */ null,
        /* ON_HOLD */ "Временно заблокировано",
        /* ON_LEAVE */ "В отпуске",
        /* OOPS */ "Ой",
        /* OPEN */ null,
        /* OPEN_CAMERA */ null,
        /* OPEN_CERTIFICATE */ null,
        /* OPEN_DEVICE_SETTINGS */ null,
        /* OPEN_MAPS */ null,
        /* OPEN_SETTINGS */ null,
        /* OPTIONAL_TASKS */ null,
        /* OR */ "или",
        /* OTHER */ "Иное",
        /* OTHER_PERTINENT_DIAGNOSIS */ null,
        /* OTHER_REASON */ null,
        /* OTHER_TASKS */ null,
        /* OTHER_VISITS */ null,
        /* OUTBOUND_CALL_ERROR_MESSAGE */ null,
        /* OUTBOUND_CALL_ERROR_TITLE */ null,
        /* OUTBOUND_CALL_PROMPT_MESSAGE */ null,
        /* OUTBOUND_CALL_PROMPT_TITLE */ null,
        /* OUTBOUND_CALL_SUCCESS_MESSAGE */ null,
        /* OUTBOUND_CALL_SUCCESS_TITLE */ null,
        /* OUT_OF */ "из",
        /* OUT_OF_RANGE */ null,
        /* OVERDUE */ null,
        /* OVERLAPPING_VISIT_ERROR */ "Визиты накладываются друг на друга, выберите другую дату или время.",
        /* OVERRIDE_FORM */ null,
        /* OVERRIDE_FORM_MESSAGE */ null,
        /* OVER_NIGHT */ "Ночлег",
        /* PAGE */ "Страница",
        /* PAID */ null,
        /* PAID_X_OUT_OF_Y */ null,
        /* PARTIAL_SELECTION */ null,
        /* PASSPORT */ null,
        /* PASSPORT_TERMS_TEXT */ null,
        /* PASTE */ "Вставить",
        /* PAST_DUE */ "Просрочено",
        /* PAST_SINCE_THE_VISIT_STARTED */ null,
        /* PAST_UPLOADS */ "Прошлые загрузки",
        /* PAST_VISITS */ null,
        /* PATIENT */ "Пациент",
        /* PATIENTS */ null,
        /* PATIENT_ADDRESS */ "Адрес пациента",
        /* PATIENT_CANT_PHISICALLY_SIGN */ null,
        /* PATIENT_CANT_SIGN */ null,
        /* PATIENT_CONTACTS */ null,
        /* PATIENT_DOC_NOT_SUBMITTED */ "Документ пациента не отправлен из-за ошибки",
        /* PATIENT_DOC_SUBMISSION_MISSMATCH */ "Вы собираетесь отправить форму, но запланированная дата визита не совпадает с сегодняшней датой. Выберите дату, которую хотите указать в форме",
        /* PATIENT_DOC_SUBMITTED_SUCCESSFULY */ "Документ пациента успешно отправлен",
        /* PATIENT_INFO */ "Сведения о пациенте",
        /* PATIENT_IS_NOT_HOME */ null,
        /* PATIENT_IS_NOT_SIGNING */ null,
        /* PATIENT_NAME */ "Имя пациента",
        /* PATIENT_NOT_FOUND */ null,
        /* PATIENT_NOT_FOUND_EXPLAIN */ null,
        /* PATIENT_NUMBER */ "Номер пациента",
        /* PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE */ null,
        /* PATIENT_PHONE */ "Телефон пациента",
        /* PATIENT_REFUSES_TO_SIGN */ null,
        /* PATIENT_REPORT */ null,
        /* PATIENT_REQUESTS */ null,
        /* PATIENT_SCHEDULE */ null,
        /* PATIENT_SIGNATURE */ null,
        /* PATIENT_SIGNATURE_IS_REQUIRED */ null,
        /* PATIENT_SIGNATURE_REQUIRE_MSG */ "Укажите причину отсутствия подписи пациента",
        /* PATIENT_SIGN_HERE */ "Подпись пациента здесь",
        /* PATIENT_UNAVAILABLE_DURING_THESE_HOURS */ null,
        /* PATIENT_VISITS */ null,
        /* PAUSE_READING */ null,
        /* PAYMENT_METHOD */ null,
        /* PAYROLL */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_TITLE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE */ null,
        /* PAYSTUB */ null,
        /* PAYSTUBS */ null,
        /* PAY_ME_NOW */ null,
        /* PAY_ME_NOW_X */ null,
        /* PENDING */ "В ожидании",
        /* PENDING_APPLICATION */ "Заявление на рассмотрении",
        /* PENDING_APPROVAL */ null,
        /* PENDING_CONFIRMATION */ null,
        /* PENDING_ISSUES */ null,
        /* PENDING_VERIFICATION */ null,
        /* PERMANENT_VISIT_DETAILS */ "Сведения о непрерывном визите",
        /* PERMANENT_VISIT_FROM */ "Непрерывный визит от",
        /* PERMANENT_VISIT_TYPE */ "Регулярный визит",
        /* PERMISSION_NEEDED_FOR_CAMERA */ null,
        /* PERMISSION_NEEDED_FOR_CAMERA_MESSAGE */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE */ null,
        /* PERMISSION_TO_CAMERA_DENIED */ null,
        /* PER_HOUR */ null,
        /* PER_SHIFT */ "На смену",
        /* PER_VISIT */ "за визит",
        /* PER_WEEK */ null,
        /* PHONE */ "Телефон",
        /* PHONES */ "Телефоны",
        /* PHONE_CALL_SUPPORT */ "Позвонить в службу поддержки",
        /* PHOTO_LIBRARY */ null,
        /* PHYSICIAN_DETAILS */ null,
        /* PICK_A_DATE */ null,
        /* PICK_A_TIME */ "Выбрать время",
        /* PLAN_OF_CARE */ "План ухода",
        /* PLEASE_ASK_THE_PATIENT */ null,
        /* PLEASE_CALL_PATIENT_IN_NEXT_SCREEN */ "Позвоните пациенту на следующем экране",
        /* PLEASE_CHAT_WITH_THE_AGENCY */ null,
        /* PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY */ null,
        /* PLEASE_CHOOSE_A_LANGUAGE */ "Выберите язык",
        /* PLEASE_CHOOSE_A_TIME */ "Выберите время",
        /* PLEASE_CHOOSE_DATE_BETWEEN */ null,
        /* PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES */ null,
        /* PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT */ "Посмотрите их и пройдите тесты, чтобы по-прежнему удовлетворять требованиям.",
        /* PLEASE_CONFIRM_THE_TIMES_CHOSEN */ "Подтвердите выбранное время",
        /* PLEASE_CONFIRM_YOUR_INFORMATION */ "Подтвердите свою информацию",
        /* PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS */ "Свяжитесь с агентством для получения более подробной информации",
        /* PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY */ "Немедленно свяжитесь со своим агентством",
        /* PLEASE_CONTACT_YOUR_COORDINATOR */ "Обратитесь к своему координатору.",
        /* PLEASE_ENABLE_LOCATION */ "Включите определение местоположения",
        /* PLEASE_ENTER_A_VALID_PHONE_NUMBER */ "Введите действительный номер телефона",
        /* PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME */ "Введите имя и фамилию пациента",
        /* PLEASE_ENTER_PATIENT_NAME */ "Введите имя пациента",
        /* PLEASE_ENTER_THE_PATIENT_PHONE */ "Введите номер телефона пациента",
        /* PLEASE_ENTER_YOUR_PIN_CODE */ "Введите пин-код",
        /* PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED */ null,
        /* PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER */ null,
        /* PLEASE_FILL_IN_YOUR_INFORMATION */ "Введите свои данные",
        /* PLEASE_FILL_REQUIRED_FIELDS */ null,
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY */ "Убедитесь, что вы верно ввели код",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY */ null,
        /* PLEASE_MARK_ALL_THE_REQUIRED_DUTIES */ null,
        /* PLEASE_NOTE */ "Обратите внимание",
        /* PLEASE_PICK_VALID_DATES */ "Выберите действительные даты",
        /* PLEASE_REQUEST_EXACTLY */ "Запросите точно",
        /* PLEASE_SELECT_AN_OPTION */ null,
        /* PLEASE_SELECT_DATE_AND_TIME */ "Укажите дату и время",
        /* PLEASE_SELECT_THE_PATIENT_ADDRESS */ "Укажите адрес пациента",
        /* PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT */ null,
        /* PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW */ "Добавьте свое фото профиля, нажав на значок камеры ниже",
        /* PLEASE_SIGN_IN_AGAIN */ null,
        /* PLEASE_SPECIFY */ null,
        /* PLEASE_TAKE_A_SELFIE */ null,
        /* PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK */ null,
        /* PLEASE_TYPE_IN_YOUR_PHONE_NUMBER */ null,
        /* PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH */ "Введите код агентства, с которым вы хотели бы работать",
        /* PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER */ null,
        /* PLEASE_TYPE_THE_SMS_CODE */ "Введите код из СМС",
        /* PLEASE_UPDATE_TO_OUR_NEWEST_VERSION */ "Обновите до нашей новейшей версии",
        /* PLEASE_UPDATE_YOUR_ADDRESS */ "Обновите свой адрес",
        /* PLEASE_UPDATE_YOUR_FIRST_NAME */ "Обновите свое имя",
        /* PLEASE_UPDATE_YOUR_LAST_NAME */ "Обновите свою фамилию",
        /* PLEASE_WAIT */ null,
        /* PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION */ null,
        /* PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP */ null,
        /* POINTS */ "Баллы",
        /* POINTS_AND_REWARDS */ null,
        /* POSTED_DATE */ "Дата публикации",
        /* PREBLOCK_VISIT_EXPLANATION */ "После подтверждения вам предоставляется ограниченное время для того, чтобы связаться с пациентом и выбрать время визита.",
        /* PRESENTATION */ "Презентация",
        /* PREVIOUS */ null,
        /* PREVIOUS_CONVERSATIONS */ null,
        /* PREVIOUS_WINNERS */ null,
        /* PRE_TAXES */ null,
        /* PRICE */ "Цена",
        /* PRINCIPAL_DIAGNOSIS */ null,
        /* PRIORITY_CODE */ null,
        /* PRIVACY_POLICY */ "Политика конфиденциальности",
        /* PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN */ "Проблема с получением данных о местоположении, повторите попытку. Попробуйте включить службу определения местоположения или выйти на улицу.",
        /* PROBLEM_WITH_CASE_SETTINGS */ "Похоже, у вас имеется проблема с настройками случая",
        /* PROCESSING */ null,
        /* PROFESSIONAL_TYPE */ "Тип специалиста",
        /* PROFILE */ "Профиль",
        /* PROGRESS */ null,
        /* PROXY_FIRST_NAME */ null,
        /* PROXY_LAST_NAME */ null,
        /* PROXY_PHONE */ null,
        /* PULSE */ null,
        /* QUESTION */ "Вопрос",
        /* QUESTIONS */ "Вопросы",
        /* QUESTIONS_TO_COPY_FROM */ "Вопросы для копирования из",
        /* QUESTION_NUMBER */ null,
        /* QUESTION_REJECTED */ null,
        /* QUIT */ null,
        /* RAFFLE_ENDED */ null,
        /* RAFFLE_INFO_1_DESCRIPTION */ null,
        /* RAFFLE_INFO_1_TITLE */ null,
        /* RAFFLE_INFO_2_DESCRIPTION */ null,
        /* RAFFLE_INFO_2_TITLE */ null,
        /* RAFFLE_INFO_3_DESCRIPTION */ null,
        /* RAFFLE_INFO_3_TITLE */ null,
        /* RAFFLE_INFO_4_DESCRIPTION */ null,
        /* RAFFLE_INFO_4_TITLE */ null,
        /* RAFFLE_NOW */ null,
        /* RAFFLE_PRIZE */ null,
        /* RANK_ACHIEVED */ null,
        /* REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION */ null,
        /* READY_FOR_YOUR_NEXT_TRAINING */ "Готовы к следующему тренингу?",
        /* READY_TO_CLOCK_IN */ null,
        /* READY_TO_CLOCK_OUT */ null,
        /* READ_AND_CONFIRM */ "Прочитать и подтвердить",
        /* READ_ONLY_MODE */ null,
        /* READ_TEXT */ null,
        /* REASON */ null,
        /* RECENT_VISITS */ null,
        /* RECOMMENDED */ null,
        /* RECRUITMENT_MAIN_1 */ "Похоже, вы",
        /* RECRUITMENT_MAIN_1_2 */ "не",
        /* RECRUITMENT_MAIN_2 */ "в агентстве",
        /* RECRUITMENT_MAIN_2_1 */ "работаете",
        /* RECRUITMENT_MAIN_3 */ "Устройтесь на работу в агентства,",
        /* RECRUITMENT_MAIN_4 */ "заполнив заявку",
        /* REFERRAL_CODE */ "Реферальный код",
        /* REFER_ME */ "Направить меня!",
        /* REGISTRATION */ null,
        /* REGULAR_PAY */ null,
        /* REJECT */ "Отклонить",
        /* REJECTED */ "Отклонено",
        /* REJECT_THIS_TASK */ null,
        /* REJECT_THIS_VISIT */ "Отказаться от этого визита",
        /* REMAINED */ null,
        /* REMAINING */ "Остается",
        /* REMIND_ME_LATER */ null,
        /* REMOVE */ "Удалить",
        /* REMOVE_PAGE */ "Удалить страницу",
        /* REMOVE_TASK */ null,
        /* REOPENED */ null,
        /* REPLAY */ null,
        /* REQUEST */ "Запросить",
        /* REQUESTED */ "Запрошен",
        /* REQUESTED_LABEL_IN_CASES_LIST */ "ярлык «Запрошен» в списке случаев.",
        /* REQUESTED_TIMES */ "Запрошенное время",
        /* REQUESTED_VISIT_CANCEL_EXPLANATION */ null,
        /* REQUESTING_REFERENCE_RESPONSE */ null,
        /* REQUEST_AGENCIES_MEMBERSHIP */ "Отправить заявление о регистрации в агентстве",
        /* REQUEST_AGENCY */ "Запросить агентство",
        /* REQUEST_AGENCY_MEMBERSHIP */ "Запросить членство в агентстве",
        /* REQUEST_DETAILS */ "Запросить сведения",
        /* REQUEST_FOR_APPOINTMENT */ "запрос о встрече",
        /* REQUEST_FRIENDSHIP */ "Запрос о дружбе",
        /* REQUEST_MORE_VISITS */ "Запросить больше визитов",
        /* REQUEST_MORE_VISITS_MESSAGE */ null,
        /* REQUEST_NUMBER_SHIFTS */ "Запросить %shifts% смен(-ы)",
        /* REQUEST_SELECTED_SHIFT */ null,
        /* REQUEST_SELECTED_SHIFTS */ null,
        /* REQUEST_SHIFTS */ "Запросить смены",
        /* REQUEST_SINGLE_SHIFT */ "Запросить одну смену",
        /* REQUEST_THE_TIMES_YOU_WANT */ "Запросите желаемое время!",
        /* REQUEST_THIS_VISIT */ "Запросить этот визит",
        /* REQUEST_TO */ "Запрос в адрес",
        /* REQUEST_VISIT */ "Запросить визит",
        /* REQUIRED */ "требуется",
        /* REQUIRED_DOCUMENTS */ "Требуемые документы",
        /* REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC */ "Некоторые обязательные поля документа остались пустыми. Вернитесь и заполните их",
        /* REQUIRED_PATIENT_DOCUMENT_TEXT */ "Вам нужно заполнить следующие документы об этом визите",
        /* REQUIRED_TASKS */ null,
        /* REQUIREMENTS */ null,
        /* RESCHEDULE */ "Перепланировать",
        /* RESCHEDULED_SUCCESSFULLY */ "Успешно перенесен",
        /* RESCHEDULE_IN_THE_PAST_ERROR */ "Не удается перенести визит в прошлое.",
        /* RESCHEDULE_REQUESTS */ "Перепланировать запросы",
        /* RESET_PIN_CODE_MESSAGE */ null,
        /* RESPIRATION_RATE */ null,
        /* RESUBMISSION_BANNER_TITLE */ null,
        /* RETAKE */ "Переснять",
        /* RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION */ null,
        /* RETRY */ "Повтор",
        /* REVIEW_PRIVACY_POLICY */ "Просмотреть Политику конфиденциальности",
        /* REVIEW_TASK */ null,
        /* REVIEW_TASKS */ null,
        /* RE_ENTER_YOUR_PIN_CODE */ "Повторно введите пин-код",
        /* RN_FLEXIBLE_SHOWCASE_TEXT */ "Визит с изменяемым сроком",
        /* RN_FLEX_EXPLANATION_PREFIX */ "Это",
        /* RN_FLEX_REQUESTED_EXPLANATION */ "Вас попросят выбрать удобные вам дату и время",
        /* RN_FLEX_REQUESTED_EXPLANATION_LINE_2 */ "Временной интервал выполнения этого визита —",
        /* RN_PATIENT_CONTACT_EXPLANATION */ "Для выполнения этого визита необходимо согласовать время с пациентом.\n \n Нажмите на кнопку в нижней части экрана, чтобы связаться с пациентом.",
        /* RN_SIGN_HERE */ "Подпись зарегистрированной(-ого) медсестры (медбрата) здесь",
        /* ROUTING_NUMBER */ null,
        /* ROUTING_NUMBR */ null,
        /* SAFETY_AND_HEALTH */ null,
        /* SAVE */ "Сохранить",
        /* SAVE_FOR_LATER */ null,
        /* SCAN_AND_UPLOAD_FILES */ "Сканировать и загрузить файлы",
        /* SCAN_A_PHOTO */ null,
        /* SCAN_DOCUMENT */ "Сканировать документы",
        /* SCAN_NEW_DOCUMENT */ "Сканировать новый документ",
        /* SCAN_WITH_CAMERA */ "Сканировать с помощью камеры",
        /* SCHEDULE */ "Расписание",
        /* SCHEDULED */ null,
        /* SCHEDULED_DATE */ null,
        /* SCHEDULED_FOR */ null,
        /* SCHEDULED_VISIT_COMPLETE */ "Запланированный визит закончен",
        /* SCHEDULED_VISIT_NOT_FOUND */ "Назначенный визит не найден, свяжитесь с агентством",
        /* SCHEDULE_CONFIRMATION */ null,
        /* SCHEDULE_FOR */ null,
        /* SCHEDULE_TASK */ null,
        /* SCHEDULING_PROBLEM */ "Проблема с планированием",
        /* SCREENING */ "Скрининг",
        /* SCREENING_FOR */ "Скрининг на:",
        /* SEARCH */ null,
        /* SEARCH_AGENCY */ "Поиск агентства",
        /* SEARCH_FOR_MEDICATIONS */ "Поиск лекарств...",
        /* SEARCH_NEARY_VISITS */ null,
        /* SEARCH_PATIENT */ null,
        /* SECOND_SHIFT */ "Вторая смена",
        /* SECTION_ALREADY_COMPLETED */ null,
        /* SECTION_COMPLETED_PROMPT */ null,
        /* SECTION_LOCKED_PROMPT */ null,
        /* SEE_ALL */ null,
        /* SEE_ALL_CONVERSATIONS */ null,
        /* SEE_IN_MAPS */ null,
        /* SEE_LIST_OF_VISITS */ "Посмотреть список визитов",
        /* SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT */ null,
        /* SEE_YOUR_PROGRESS */ null,
        /* SELECT */ "Выбрать",
        /* SELECTED */ null,
        /* SELECTED_VISIT */ null,
        /* SELECT_ALL */ "Выбрать все",
        /* SELECT_CERTIFICATE */ null,
        /* SELECT_DATE */ "Выбор даты",
        /* SELECT_DATE_AND_TIME */ null,
        /* SELECT_DOCUMENT */ null,
        /* SELECT_DX_CODE */ null,
        /* SELECT_FROM_LIST */ null,
        /* SELECT_PERTINENT_DIAGNOSIS */ null,
        /* SELECT_PHYSICIAN */ null,
        /* SELECT_PRINCIPAL_DIAGNOSIS */ null,
        /* SELECT_SHIFTS */ null,
        /* SELECT_START_TIME */ null,
        /* SELECT_SURGICAL_PROCEDURE */ null,
        /* SELECT_TIME */ "Укажите время",
        /* SELECT_TIME_SLOT */ null,
        /* SELECT_TIME_SLOT_INFO */ null,
        /* SELECT_VISITS_FOR_INSTAPAY */ null,
        /* SELECT_VISIT_DURATION */ null,
        /* SELECT_YOUR_SCHEDULE */ null,
        /* SELFIE_WITH_PATIENT */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT */ null,
        /* SEND_A_MESSAGE */ null,
        /* SEND_EMAIL */ "Отправить электронное письмо",
        /* SEND_REPORT */ "Отправить отчет",
        /* SEND_US_A_MAIL */ "Отправьте нам письмо",
        /* SEPTEMBER */ null,
        /* SETTINGS */ "Настройки",
        /* SETTINGS_AND_INFO */ null,
        /* SET_DOCUMENT_EXPIRY_DATE */ "Задайте дату истечения срока действия документа",
        /* SET_EXPIRATION_DATE */ "Укажите дату истечения срока действия",
        /* SET_YOUR_4_DIGIT_PIN_CODE */ "Задайте пин-код из 4 цифр",
        /* SHARE */ null,
        /* SHARE_IDEAS_AND_GET_A_CHANCE */ null,
        /* SHARE_REFERENCE_LINK */ null,
        /* SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP */ null,
        /* SHARE_WITH_YOUR_FRIENDS */ null,
        /* SHIFT */ "Переместить",
        /* SHIFTS */ null,
        /* SHIFTS_DETAILS */ null,
        /* SHIFT_HAS_FINISHED_IN */ null,
        /* SHIFT_HAS_STARTED_IN */ null,
        /* SHOULD_BE_HERE */ "должен быть здесь",
        /* SHOW_ALL_TASKS */ null,
        /* SHOW_DETAILS */ null,
        /* SHOW_LESS */ "Показать меньше",
        /* SHOW_ME_CASES_IN_THE_NEXT */ "Покажите мне случаи в следующем",
        /* SHOW_ME_IN */ "Покажите мне в",
        /* SHOW_MORE */ "Показать больше",
        /* SHOW_OLD_PLAN_OF_CARE */ "Показать старый план ухода",
        /* SHOW_TASKS_THAT_REQUIRE_FIXES */ null,
        /* SHOW_US_YOUR_SMILE */ null,
        /* SIGNATURES */ null,
        /* SIGNATURE_REQUIRED */ null,
        /* SIGN_DECLINATION_FORM */ null,
        /* SIGN_HERE */ "Подпишите здесь",
        /* SIGN_IN */ "ВХОД",
        /* SIGN_ORIENTATION_VIDEO */ "Подпишите здесь перед отправкой",
        /* SIGN_ORIENTATION_VIDEO_ERR */ "Подпишите перед отправкой",
        /* SIGN_OUT */ "Выход",
        /* SIGN_UP_FREE */ null,
        /* SIGN_UP_ITS_FREE */ null,
        /* SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE */ null,
        /* SINGLE_FLEXIBLE_VISIT_EXPLANATION */ null,
        /* SINGLE_VISIT_DETAILS */ "Сведения об однократном визите",
        /* SINGLE_VISIT_FROM */ "Однократный визит от",
        /* SINGLE_VISIT_TYPE */ "Однократный визит",
        /* SIXTY_SECONDS_AND_YOU_ARE_DONE */ null,
        /* SKIP */ "Пропустить",
        /* SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION */ null,
        /* SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS */ null,
        /* SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN */ null,
        /* SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES */ null,
        /* SLIDE_MAIN_INFO_GO_NEXT_SCREENS */ null,
        /* SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW */ null,
        /* SLIDE_STEP_X_OF_COUNT */ null,
        /* SMILE_FOR_US */ null,
        /* SOCIAL */ "Социальные сети",
        /* SOCIAL_MEDIA */ null,
        /* SOMETHING_WENT_WRONG */ "Возникла какая-то проблема, повторите попытку позже",
        /* SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS */ null,
        /* SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM */ null,
        /* SOME_TASKS_NEED_FIXES */ null,
        /* SORRY */ null,
        /* SORT */ "Сортировать",
        /* SPECIFIC_DAYS */ "Определенные дни",
        /* SPEECH_RECOGNITION */ null,
        /* SPLIT_SHIFTS_VISIT */ "Разделить смены",
        /* SPREAD_THE_WORD */ "Расскажите другим",
        /* STAGE_APPROVED_MESSAGE */ null,
        /* STAGE_AWAITING_APPROVAL */ null,
        /* STAGE_COMPLETED_MESSAGE */ null,
        /* STAGE_X_OF_TOTAL_STAGES */ null,
        /* START */ null,
        /* STARTING_AT */ "Начинается в",
        /* STARTS */ "Начинается",
        /* STARTS_NEXT_WEEK */ null,
        /* STARTS_TODAY_IN */ null,
        /* START_APPLICATION */ "Подать заявку",
        /* START_A_SURVEY */ "Начать",
        /* START_DATE */ "Дата начала",
        /* START_FILLING */ null,
        /* START_NOW */ null,
        /* START_SHIFT */ null,
        /* START_TIME */ "Время начала",
        /* START_USING_MEDFLYT_PASSPORT */ null,
        /* START_WATCHING */ null,
        /* START_WATCHING_ORIENTATION_VIDEOS */ null,
        /* START_WORKING */ null,
        /* STATUS */ "Статус",
        /* STAY_ON_TRACK */ null,
        /* STAY_ON_TRACK_1_ANSWER */ null,
        /* STAY_ON_TRACK_1_QUESTION */ null,
        /* STAY_ON_TRACK_2_ANSWER */ null,
        /* STAY_ON_TRACK_2_QUESTION */ null,
        /* STAY_ON_TRACK_3_ANSWER */ null,
        /* STAY_ON_TRACK_3_QUESTION */ null,
        /* STAY_ON_TRACK_4_ANSWER */ null,
        /* STAY_ON_TRACK_4_QUESTION */ null,
        /* STAY_ON_TRACK_DESCRIPTION */ null,
        /* STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS */ null,
        /* STAY_TUNED_FOR_MORE_VISITS */ "Следите за новостями о новых визитах",
        /* STAY_TUNED_FOR_THE_NEXT_RAFFLE */ null,
        /* STILL_WAITING_REFERENCE_ANSWER */ null,
        /* STOP */ null,
        /* STREAK_BREAK */ null,
        /* STREAK_BREAK_MESSAGE */ null,
        /* STREAK_BREAK_MESSAGE_2 */ null,
        /* SUBMIT */ "Отправить",
        /* SUBMITTED_AT */ null,
        /* SUBMITTED_DOCUMENTS */ "Отправленные документы",
        /* SUBMITTED_MANUALLY */ "Отправлено вручную",
        /* SUBMIT_AFTER */ "Отправить после",
        /* SUBMIT_AT */ "Отправить в",
        /* SUBMIT_BY */ "Отправить до",
        /* SUBMIT_DUTIES */ null,
        /* SUBMIT_DUTIES_BEFORE_CLOCK_OUT */ null,
        /* SUBMIT_FORM */ null,
        /* SUBMIT_FORMS */ null,
        /* SUBMIT_MANUAL_TIMESHEET */ null,
        /* SUBMIT_REQUIRED */ "Необходимо отправить",
        /* SUBMIT_TEST */ "Отправить тест",
        /* SUBMIT_TIMESHEET */ null,
        /* SUBMIT_WITH_SCHEDULED_DATE */ "Отправить с запланированной датой",
        /* SUBMIT_WITH_TODAY_DATE */ "Отправить с сегодняшней датой",
        /* SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT */ null,
        /* SUBMIT_YOUR_SIGN */ "Подпишите",
        /* SUBMIT_YOUR_SIGNATURE */ "Подпишите",
        /* SUCCESS */ "Успешно выполнено",
        /* SUCCESSFULLY_CLOCKED_IN */ null,
        /* SUCCESSFULLY_CLOCKED_OUT */ null,
        /* SUCCESSFULY_REQUESTED */ "Успешно запрошен!",
        /* SURGICAL_PROCEDURE */ null,
        /* SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS */ "Переключитесь на представление списка, чтобы увидеть импортированные визиты",
        /* SWITCH_VIEW */ "Переключить представление",
        /* TAKE_A_DIFFERENT_PHOTO */ null,
        /* TAKE_A_PHOTO */ "Сфотографировать",
        /* TAKE_A_SURVEY */ "Пройдите опрос и получите возможность выиграть",
        /* TAKE_ME_TO_CASE_SETTINGS */ "Перейти в настройки случая",
        /* TAKE_PHOTO */ null,
        /* TAKE_THIS_TASK */ null,
        /* TAP_HERE_TO_VIEW */ "Нажмите сюда для просмотра",
        /* TAP_TO_CANCEL */ "нажмите, чтобы отменить",
        /* TAP_TO_CHANGE_CASE_SETTINGS */ "Нажмите для изменения настроек случая",
        /* TASK */ null,
        /* TASKS */ null,
        /* TASK_ALREADY_ASSIGNED */ null,
        /* TASK_COMPLETED_SUCCESSFULLY */ "Поздравляем 🎉💪🏻 Вы выполнили это задание.",
        /* TASK_INFORMATION */ null,
        /* TASK_SCHEDULED */ null,
        /* TASK_SCHEDULED_MESSAGE */ null,
        /* TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE */ null,
        /* TECHNICAL_SUPPORT */ "Техническая поддержка",
        /* TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES */ "Расскажите нам, почему вы не заинтересованы, чтобы вы смогли отправлять нам лучшие случаи",
        /* TELL_US_YOUR_AGENY_DESCRIPTION */ "Сообщите нам название своего агентства и имя координатора, и мы свяжемся с ними для передачи открытых дел.",
        /* TEMPERATURE */ null,
        /* TEN_DOLLAR_STARBUCKS_GIFT_CARD */ null,
        /* TERMINATED */ "Расторгнуто",
        /* TERMS_OF_MEDFLYT_PRIVACY_POLICY */ null,
        /* TERMS_OF_USE */ "Условия использования",
        /* TEST */ "Тест",
        /* TESTS */ null,
        /* TEST_COMPLETED */ null,
        /* TEST_FAILED */ "Тест не пройден",
        /* TEST_REQUIRED */ "Требуется тест",
        /* THANKS */ null,
        /* THANK_YOU */ null,
        /* THANK_YOU_FOR_YOUR_FEEDBACK */ "Спасибо за ваш отзыв.",
        /* THATS_ME */ null,
        /* THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION */ null,
        /* THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS */ null,
        /* THERE_ARE_NO_AGENCIES_YET */ "Пока нет агентств",
        /* THERE_ARE_NO_ASSIGNED_CASES */ null,
        /* THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION */ "C вашим интернет-подключением возникла проблема",
        /* THERE_SEEMS_TO_BE_NOTHING_HERE */ "Кажется, здесь ничего нет...",
        /* THE_AWARDS_ARE_COMING_SOON */ null,
        /* THE_BEST_PLACE_FOR_CAREGIVERS */ null,
        /* THE_DUTY_SHEET_HAS_BEEN_SUBMITTED */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON */ null,
        /* THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS */ null,
        /* THE_NEXT_WINNERS_ANNOUNCEMENT */ "Объявление очередного победителя",
        /* THE_SELECTED_DATE_IS_EARLIER_THAN */ null,
        /* THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS */ "Визит может быть выполнен в следующие дни",
        /* THE_VISIT_HAS_NOT_STARTED_YET */ null,
        /* THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS */ null,
        /* THIS_BUNDLE_INCLUDES */ null,
        /* THIS_CONVERSATION_HAS_BEEN_RESOLVED */ null,
        /* THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK */ "Этот курс состоит из %d уроков. Удачи!",
        /* THIS_FIELD_IS_CURRENTLY_DISABLED */ null,
        /* THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT */ "Это старый визит, невозможно отметить приход/уход",
        /* THIS_IS_A_FUTURE_VISIT */ null,
        /* THIS_IS_A_LIVE_CLASS_SESSION */ null,
        /* THIS_MAY_TAKE_UP_TO_X_SECONDS */ null,
        /* THIS_PATIENT_BELONGS_TO_AGENCY */ null,
        /* THIS_PATIENT_HAS_NO_PHONE_NUMBERS */ null,
        /* THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER */ null,
        /* THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP */ null,
        /* THIS_VISIT_CAN_BE_PERFORMED_BETWEEN */ "Этот визит может быть выполнен между",
        /* THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE */ null,
        /* THIS_VISIT_IS_FOR_DIFFERENT_AGENCY */ null,
        /* THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET */ "Этот визит в будущем, вы пока не можете отметить приход",
        /* THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY */ null,
        /* THIS_WILL_MARK_THE_VISIT_AS_MISSED */ null,
        /* TIME */ "Время",
        /* TIMESHEET_SUBMITTED */ null,
        /* TIME_ESTIMATION */ null,
        /* TIME_FRAME */ "Временной интервал",
        /* TIME_LEFT */ "Оставшееся время",
        /* TIME_VARIES */ "Время меняется",
        /* TO */ "До",
        /* TODAY */ null,
        /* TODAYS_DATE */ null,
        /* TOKENS */ null,
        /* TOO_MANY_HOURS */ "Слишком много часов",
        /* TOO_MANY_SHIFTS */ "Слишком много смен!",
        /* TOO_MANY_SHIFTS_MESSAGE */ "Вам разрешается выбрать до %maxShifts% смен. Если вы хотите выбрать эту смену, вам придется отменить одну из уже выбранных вами смен.",
        /* TOP_CAREGIVERS_IN_YOUR_AREA */ "Лучшие помощники по уходу в вашем районе",
        /* TOTAL_EARNED */ null,
        /* TOTAL_SPENT */ null,
        /* TO_FILL_IN_A_FORM_INSTEAD */ null,
        /* TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT */ null,
        /* TO_SEE_THIS_TASK_GO_TO_ASSIGNED */ null,
        /* TO_SEE_THIS_VISIT_GO_TO */ "Чтобы увидеть этот визит, ищите",
        /* TO_UPLOAD_A_FILE_INSTEAD */ null,
        /* TO_WIN_AN_IPHONE12 */ null,
        /* TRAINING */ null,
        /* TRAININGS_FOR */ "Тренинги по",
        /* TRAINING_CENTER */ "Учебный центр",
        /* TRAINING_CENTER_REMINDERS */ null,
        /* TRY_AGAIN */ null,
        /* TYPE_AGENCY_CODE */ "Введите код агентства",
        /* TYPE_MESSAGE */ "Введите сообщение...",
        /* TYPE_YOUR_ADDRESS */ "Введите свой адрес",
        /* UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET */ null,
        /* UNANSWERED_LAST_SECTION_FOR_NOW */ null,
        /* UNAUTHORIZED */ null,
        /* UNAVAILABLE_LOCATION_SERVICES_MESSAGE */ null,
        /* UNDER_REVIEW */ null,
        /* UNDO */ "Отмена",
        /* UNIQUE_ERROR_CODE */ "Уникальный код ошибки",
        /* UNSCHEDULE */ null,
        /* UNSCHEDULE_TASK */ null,
        /* UNSPECIFIED */ null,
        /* UNTIL */ "До",
        /* UPCOMING_VISITS */ null,
        /* UPDATED_AT */ null,
        /* UPDATE_INFORMATION */ null,
        /* UPLOAD */ "Загрузить",
        /* UPLOADED */ "Загружено",
        /* UPLOADED_FILE_VIEW */ null,
        /* UPLOADING */ "Загрузка...",
        /* UPLOAD_A_DOCUMENT */ null,
        /* UPLOAD_A_FILE */ null,
        /* UPLOAD_DOCUMENT */ "Загрузить документ",
        /* UPLOAD_DOCUMENTS */ "Загрузить документы",
        /* UPLOAD_ERROR */ "Ошибка загрузки",
        /* UPLOAD_FILES_TO_ENSURE */ "Загрузите файлы, чтобы обеспечить",
        /* UPLOAD_FLU_SHOT_DOCUMENT */ null,
        /* UPLOAD_FROM_GALLERY */ null,
        /* UPLOAD_NEW_DOCUMENT */ null,
        /* UPLOAD_VIDEO */ null,
        /* UPLOAD_YOUR_FILES_TO_ENSURE */ "Загрузите свои файлы, чтобы обеспечить",
        /* UP_COMING_REASSESSMENTS */ "Предстоящие переоценки",
        /* UP_TO */ null,
        /* URGENT */ null,
        /* USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY */ "Этот пользователь заблокирован из-за подозрительной деятельности",
        /* VALID */ "Действительный",
        /* VERIFIED */ "Проверено",
        /* VERIFY */ null,
        /* VERIFYING */ null,
        /* VERIFY_YOUR_LOCATION */ null,
        /* VERY_URGENT */ null,
        /* VIDEO */ "Видео",
        /* VIDEOS */ null,
        /* VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION */ "вам нужно посмотреть видеозаписи в учебном центре.",
        /* VIDEO_COMPLETED_SUCCESSFULLY */ "Поздравляем! Вы завершили просмотр видео.",
        /* VIEW */ "Просмотр",
        /* VIEWED */ "Просмотрено",
        /* VIEW_ALL */ null,
        /* VIEW_ANSWERS */ null,
        /* VIEW_CERTIFICATE */ "Посмотреть сертификат",
        /* VIEW_TASK */ null,
        /* VIEW_TASKS_PENDING_FOR_SCHEDULE */ null,
        /* VIEW_VISIT */ null,
        /* VIRTUAL_ID_CARD */ null,
        /* VISIT */ null,
        /* VISITS */ "визита(-ов)",
        /* VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER */ null,
        /* VISITS_NEXT_MONTH */ null,
        /* VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* VISITS_PER_WEEK */ "Визитов в неделю",
        /* VISITS_WITH_ISSUES */ null,
        /* VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE */ "Визит назначен, проверьте его в своем расписании",
        /* VISIT_BY */ "Визит",
        /* VISIT_CHAT */ "Посетить чат",
        /* VISIT_COMPLETE */ null,
        /* VISIT_COMPLETED_SUCCESSFULLY */ null,
        /* VISIT_COUNTS */ null,
        /* VISIT_COUNTS_DESCRIPTION */ null,
        /* VISIT_DATE */ "Дата визита",
        /* VISIT_DATES */ null,
        /* VISIT_DETAILS */ "Сведения о визите",
        /* VISIT_DURATION */ null,
        /* VISIT_INFORMATION */ null,
        /* VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU */ null,
        /* VISIT_LASTING */ "Визит, продолжающийся",
        /* VISIT_NEXT_MONTH */ null,
        /* VISIT_NOTIFICATIONS_OFF */ "Уведомления о визите — ВЫКЛ.",
        /* VISIT_NOTIFICATIONS_ON */ "Уведомления о визите — ВКЛ.",
        /* VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE */ "Вы еще не отметили время прихода на этот визит. Вы точно хотите отметить время ухода?",
        /* VISIT_NO_LONGER_AVAILABLE */ "Визит больше не доступен",
        /* VISIT_RATE_REQUEST_CONFIRMATION */ null,
        /* VISIT_REMINDERS */ null,
        /* VISIT_REQUEST_CONFIRMATION_WARNING */ null,
        /* VISIT_SCHEDULE */ null,
        /* VISIT_STARTED_AT */ null,
        /* VISIT_STARTED_MISSING_CLOCK_IN */ null,
        /* VISIT_STARTS_AT */ null,
        /* VISIT_SUCESSFULLY_CANCELED */ "Визит успешно отменен",
        /* VISIT_TIME_ADJUSTMENT */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_EARLY */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_LATE */ null,
        /* VISIT_TOO_SHORT */ null,
        /* VISIT_TYPE */ null,
        /* VISIT_WITH */ null,
        /* VOUCHER */ null,
        /* WAITING_FOR_APPROVAL */ "В ожидании утверждения",
        /* WAITING_TO_BE_SCHEDULED */ null,
        /* WARNING */ "Внимание!",
        /* WAS_DUE_BETWEEN */ null,
        /* WAS_DUE_ON */ null,
        /* WATCHED */ "Просмотрено",
        /* WATCH_HOW_IT_WORKS */ null,
        /* WATCH_REQUIRED */ "Требуется наблюдение",
        /* WATCH_TRAINING_VIDEOS_TO_COMPLETE */ null,
        /* WEEKLY_DETAILS */ null,
        /* WELCOME */ null,
        /* WELCOME_BACK */ null,
        /* WELCOME_TO_CARE_MOMENTS */ null,
        /* WELCOME_TO_MEDFLYT */ null,
        /* WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE */ null,
        /* WELL_BE_IN_TOUCH_SHORTLY */ "Мы скоро свяжемся с вами.",
        /* WERE_YOU_REFERRED_BY_SOMEONE */ "Вас кто-то направил сюда?",
        /* WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM */ null,
        /* WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR */ "Мы не можем найти лекарство, которое вы ищете",
        /* WE_COULDNT_FIND_YOUR_AGENCY */ "Не удалось найти ваше агентство!",
        /* WE_GOT_YOUR_CONFIRMATION */ null,
        /* WE_GOT_YOUR_RESPONSE_WAIT_HH_MM */ null,
        /* WE_HAVE_ONE_MATCHING_ACCOUNT */ null,
        /* WE_HAVE_X_MATCHING_ACCOUNTS */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT */ null,
        /* WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT */ null,
        /* WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON */ null,
        /* WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE */ null,
        /* WHAT_BENEFITS_CAN_YOU_GET */ null,
        /* WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK */ null,
        /* WHAT_WOULD_YOU_LIKE_TO_DO_FIRST */ null,
        /* WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT */ "Всякий раз, когда вы видите визит с изменяемым сроком, вы сможете запросить подходящее вам время",
        /* WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR */ null,
        /* WHOOPS */ "Ой",
        /* WHOS_THE_LUCKY_ONE */ null,
        /* WILL_BEGIN_SHORTLY */ null,
        /* WILL_EXPIRE_IN_DAYS */ null,
        /* WILL_EXPIRE_TOMORROW */ null,
        /* WINNER_ANNOUNCED_IN */ null,
        /* WITH_CAREGIVERS */ "и помощниками по уходу",
        /* WORKING_WITH_AGENCY */ "Я работаю в агентстве",
        /* WRONG_DATES_SELECTION */ null,
        /* WRONG_PHONE_NUMBER */ null,
        /* WRONG_PIN */ "Неверный пин-код",
        /* X_DAYS_SELECTED */ null,
        /* X_DAYS_TO_COMPLETE */ "%d дня (дней) для завершения",
        /* X_DAYS_TO_SELECT */ null,
        /* X_HOURS_SELECTED */ null,
        /* X_HOURS_TO_SELECT */ null,
        /* YAY_YOU_WERE_ASSIGNED_TO_A_VISIT */ null,
        /* YEAR */ null,
        /* YEARS_OLD */ null,
        /* YES */ "Да",
        /* YES_ADJUST_TIMES */ null,
        /* YES_DELETE */ null,
        /* YES_I_AM_SURE */ null,
        /* YES_OVERRIDE_FORM */ null,
        /* YES_REQUEST_ANYWAY */ null,
        /* YES_SCHEDULE_VISIT */ null,
        /* YES_THATS_ME */ null,
        /* YES_UPDATE_ALL */ null,
        /* YOURE_ALL_DONE_LETS_GET_YOU_WORKING */ null,
        /* YOURE_IN_THE_RAFFLE */ null,
        /* YOURE_NOT_IN_THE_RAFFLE */ null,
        /* YOURSELF */ "Вы",
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD */ null,
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE */ null,
        /* YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS */ "За вашим агентством не могут быть закреплены уроки. Повторите попытку позже.",
        /* YOUR_ANSWER_IS_CORRECT */ "Вы ответили правильно!",
        /* YOUR_ANSWER_IS_INCORRECT */ "Вы ответили неправильно",
        /* YOUR_COMPLIANCE */ "Соблюдение вами требований",
        /* YOUR_COMPLIANCE_ITEM_HAS_EXPIRED */ null,
        /* YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS */ null,
        /* YOUR_FILE_IS_BEING_UPLOADED */ "Ваш файл загружается",
        /* YOUR_IN_SERVICE_IS_DUE_IN_DAYS */ null,
        /* YOUR_IN_SERVICE_IS_OVER_DUE */ null,
        /* YOUR_MOBILE */ "Ваш мобильный телефон",
        /* YOUR_REFERERAL_CODE */ "Ваш реферальный код",
        /* YOUR_TASK_HAS_BEEN_SCHEDULED_FOR */ null,
        /* YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY */ null,
        /* YOUVE_BEEN_SUCCESSFULLY_REFERRED */ "Вы успешно направлены!",
        /* YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "На текущий момент вы изучили все уроки",
        /* YOU_ALREADY_FAILED */ "вы уже не прошли этот тест.",
        /* YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT */ "У вас уже запланирован визит на этот временной интервал",
        /* YOU_ALREADY_REQUESTED_THIS_VISIT */ null,
        /* YOU_ALREADY_SUCCEEDED */ "вы успешно прошли тест.",
        /* YOU_ARE_ALL_SET */ null,
        /* YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION */ null,
        /* YOU_ARE_COMPLIANT */ null,
        /* YOU_ARE_EXEMPT_FROM_THIS_TEST */ "вы освобождены от прохождения этого теста",
        /* YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD */ null,
        /* YOU_ARE_NOT_COMPLIANT */ null,
        /* YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM */ null,
        /* YOU_ARE_OUT_OF_COMPLIANCE */ null,
        /* YOU_ARE_X_DAYS_LATE */ "Вы опоздали на %d дня (дней).",
        /* YOU_CANNOT_EDIT_YOUR_ANSWERS */ null,
        /* YOU_CANT_EDIT_VISIT_WITH_CICO */ null,
        /* YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES */ null,
        /* YOU_CANT_SIGN_BEFORE_ALL_ANSWERED */ null,
        /* YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME */ null,
        /* YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED */ null,
        /* YOU_CAN_CONTINUE_TO_NEXT_SECTION */ null,
        /* YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY */ null,
        /* YOU_DIDNT_ANSWER_ALL_QUESTIONS */ null,
        /* YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN */ "Вы ввели иной пин-код. Повторите попытку.",
        /* YOU_DONT_HAVE_ANY_CASES_YET */ null,
        /* YOU_DONT_HAVE_ANY_PATIENTS_YET */ null,
        /* YOU_GET_POINTS */ null,
        /* YOU_GOT_THE_CASE */ null,
        /* YOU_GOT_THE_CERTIFICATE */ "Вы получили сертификат!",
        /* YOU_HAVENT_CLOCKED_IN_YET */ "Вы еще не отметили время прихода",
        /* YOU_HAVENT_CLOCKED_OUT_YET */ "Вы еще не отметили время ухода",
        /* YOU_HAVENT_UPLOADED_ANYTHING_YET */ "Вы пока еще ничего не загрузили",
        /* YOU_HAVE_COMPLETED_THIS_TEST */ null,
        /* YOU_HAVE_HH_MM_TO_CONFIRM_IT */ null,
        /* YOU_HAVE_MISSING_COMPLIANCE_ITEMS */ null,
        /* YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW */ null,
        /* YOU_HAVE_NOT_WATCHED */ "вы не просмотрели",
        /* YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY */ null,
        /* YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS */ null,
        /* YOU_HAVE_ONE_ATTEMPT_LEFT */ null,
        /* YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING */ "У вас есть один день для завершения этого тренинга!",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION */ null,
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING */ "Вы успешно завершили этот тренинг",
        /* YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY */ "Вы обязаны завершить этот тренинг сегодня. Поторопитесь!",
        /* YOU_HAVE_TO_ENROLL_FIRST */ null,
        /* YOU_HAVE_TO_PICK_A_CODE */ null,
        /* YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_LEFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST */ null,
        /* YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y */ null,
        /* YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING */ "У вас имеется %d дня (дней) для завершения этого тренинга!",
        /* YOU_JUST_GOT_PAID */ null,
        /* YOU_JUST_GOT_PROMOTED_TO */ null,
        /* YOU_LOSE_POINTS */ null,
        /* YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS */ "Вы можете изменить свои настройки визитов, чтобы получить более релевантные визиты",
        /* YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE */ "Вы не можете ответить на вопросы этого теста, потому что",
        /* YOU_MAY_ONLY_SUBMIT_AFTER */ "Вы можете отправить только после завершения",
        /* YOU_MISSED_A_SHIFT_WITHOUT_NOTICE */ null,
        /* YOU_MUST_ANSWER_ALL_THE_QUESTIONS */ "Вы должны ответить на все вопросы.",
        /* YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT */ null,
        /* YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST */ "Вам сначала нужно посмотреть предыдущие видео",
        /* YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION */ null,
        /* YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE */ null,
        /* YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT */ null,
        /* YOU_RECENTLY_WON_A_RAFFLE */ null,
        /* YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT */ null,
        /* YOU_USED_THE_CODE */ "Вы использовали код",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE */ null,
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS */ null,
        /* YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS */ null
    ],
    "zh": [
        /* ACCEPTED */ "已接受",
        /* ACCEPT_THESE_HOURS */ "接受这些时间",
        /* ACCEPT_THE_VISIT_AT */ "于此时间接受出勤",
        /* ACCOUNT_INFORMATION_UPDATED_SUCCESSFULLY */ null,
        /* ACCOUNT_NUMBER */ null,
        /* ACCOUNT_TYPE */ null,
        /* ACTIVE */ "活跃的",
        /* ACTIVE_DOCUMENT */ "活动文档",
        /* ADD */ "添加",
        /* ADDITIONAL_NOTES */ null,
        /* ADDRESS */ "地址",
        /* ADDRESS2 */ null,
        /* ADDRESS_ERROR */ "地址错误",
        /* ADDRESS_IS_NEAR */ null,
        /* ADD_ANOTHER_DOCUMENT */ null,
        /* ADD_ANOTHER_PERTINENT_DIAGNOSIS */ null,
        /* ADD_IMAGE */ "添加图像",
        /* ADD_NEW_MEDICATION */ "添加新药物",
        /* ADD_NOTES */ "添加备注",
        /* ADD_NOTE_TO_PATIENT_PROFILE_BUTTON */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_ERROR_MESSAGE */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_PLACEHOLDER */ null,
        /* ADD_NOTE_TO_PATIENT_PROFILE_TITLE */ null,
        /* ADD_PHYSICIAN */ null,
        /* ADD_YOUR_SIGNATURE */ null,
        /* ADVANCED_DIRECTIVES */ null,
        /* AGENCIES_CONTACT */ "机构会尽快与您联系",
        /* AGENCY */ "机构",
        /* AGENCY_CODE */ "机构代码",
        /* AGENCY_COORDINATOR */ "机构协调员",
        /* AGENCY_DETAILS */ "机构详情",
        /* AGENCY_HANDBOOK */ null,
        /* AGENCY_ISSUES */ null,
        /* AGENCY_NAME */ "机构名称",
        /* AGENCY_NOTIFICATIONS */ null,
        /* AGENCY_NOT_FOUND */ null,
        /* AGREE_TO_MEDFLYT_TERMS */ "点击批准，即表示您已阅读并同意Meflyt隐私政策的条款",
        /* AIDE */ null,
        /* AIRPODS */ null,
        /* ALLERGIES */ null,
        /* ALLOW_ACCESS_TO_MY_LOCATION */ null,
        /* ALLOW_LOCATION_MESSAGE_FOR_MEDFLYT_MAP */ null,
        /* ALL_CHANGES_SAVED */ null,
        /* ALL_DAY */ "整天",
        /* ALL_DONE */ null,
        /* ALL_TRANSACTIONS */ null,
        /* ALL_VERIFIED_ITEMS */ null,
        /* ALREADY_CLOCKED_IN */ "已经打卡上班。",
        /* ALREADY_CLOCKED_IN_ANOTHER_VISIT */ "您已经在另一次出勤中打卡上班。",
        /* ALREADY_CLOCKED_OUT */ "已经打卡下班。",
        /* ALREADY_HAVE_AN_ACCOUNT */ null,
        /* AND_AMPERSAND */ "和",
        /* ANSWERED */ "已回答",
        /* ANSWERED_AT */ "答复时间",
        /* ANSWER_INCOMPLETE_QUESTIONS */ null,
        /* ANY_DURATION */ "任何时间长度",
        /* AN_ERROR_HAS_OCCURED */ "发生了错误。",
        /* AN_ERROR_OCCURED_WHILE_SUBMITTING_YOUR_TIMESHEET */ null,
        /* APPLE_IS_NOT_INVOLVED_IN_ANY_WAY_WITH_THE_CONTEST_OR_SWEEPSTAKES */ "Apple并无以任何方式参与比赛或抽奖",
        /* APPLICATION_DONE */ "申请完成！",
        /* APPROVE */ "批准",
        /* APPROVED */ null,
        /* APPROVE_THIS_TASK */ null,
        /* APPROVE_THIS_VISIT */ null,
        /* APRIL */ null,
        /* ARENT_YOU_MISSING_SOMETHING */ null,
        /* ARE_YOU */ null,
        /* ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY */ "您目前在一家机构工作吗？",
        /* ARE_YOU_SURE */ null,
        /* ARE_YOU_SURE_REQUEST_FAR_VISIT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_APPROVE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_REQUEST */ "您确定要取消此请求吗？",
        /* ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_VISIT */ "确定要取消这次出勤吗？",
        /* ARE_YOU_SURE_YOU_WANT_TO_DELETE */ "确定要删除吗",
        /* ARE_YOU_SURE_YOU_WANT_TO_ENROLL_THIS_BUNDLE */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_DOCUMENT */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PAGE */ "确定要移除此页吗？",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THESE */ "您确定要请求这些吗",
        /* ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT */ "您确定要请求此次拜访吗？",
        /* ARE_YOU_SURE_YOU_WANT_TO_SIGN_OUT */ "您确定要退出吗？",
        /* ARE_YOU_SURE_YOU_WANT_TO_TAKE_THIS_TASK */ null,
        /* ARE_YOU_SURE_YOU_WANT_TO_UNSCHEDULE_THIS_TASK */ null,
        /* ASSIGNED */ "已分配",
        /* ASSIST */ "协助",
        /* AS_NEEDED */ null,
        /* AS_REQUESTED_BY_THE_PATIENT */ "根据患者的请求",
        /* ATTACH_A_DOCUMENT */ null,
        /* AUGUST */ null,
        /* AUTHENTICATION_FAILED */ null,
        /* AUTH_VERIFICATION_FAIL_EXAPLINED */ null,
        /* AUTOPLAY */ "下一个项目开始时间",
        /* AVAILABILITY */ "可服务性",
        /* AVAILABLE */ "可提供",
        /* AVAILABLE_CARE_POINTS */ null,
        /* AVAILABLE_ON_THE_FOLLOWING_DAYS */ "于下列日期提供",
        /* AVAILABLE_SHIFTS */ "可提供的班次",
        /* AVAILABLE_VISITS */ "可提供的出勤",
        /* AVOID_MISSED_VISITS_TO_KEEP_YOUR_RANK */ null,
        /* AWAITING_PATIENT_CONTACT */ "正在等待联系",
        /* A_PLAN_OF_CARE_ALREADY_EXSITS_FOR_THIS_PATIENT */ "这个患者已有护理计划",
        /* A_VERIFICATION_CODE_IS_BEING_SENT_TO */ "正在将验证码发送至",
        /* A_VERIFICATION_CODE_WILL_BE_SENT_TO_YOU_VIA_TEXT_MESSAGE */ "验证码已通过短消息发送给您",
        /* A_VISIT_BY */ "出勤机构",
        /* BACK */ null,
        /* BACK_TO_ONBOARDING */ null,
        /* BANK_INFORMATION */ null,
        /* BANK_NAME */ null,
        /* BASICALLY_EVERY_ACTION_COUNTS */ null,
        /* BEFORE_SUBMITTING_THE_DUTIES */ null,
        /* BEGIN_NOW */ null,
        /* BEST_TASK_FOR_YOU */ null,
        /* BETWEEN */ "从",
        /* BETWEEN_AND */ "到",
        /* BIRTHDAY */ "生日",
        /* BLOOD_PRESSURE */ null,
        /* BOROUGH */ null,
        /* BUNDLES */ null,
        /* BUNDLE_DESCRIPTION */ null,
        /* BUNDLE_DESCRIPTION_P1 */ "此捆绑包中有",
        /* BUNDLE_DESCRIPTION_P2 */ "个项目。有些项目可能还包括考试。请观看所需内容。完成所需任务后，您将会收到证书。祝您好运",
        /* BUNDLE_IS_LOCKED */ null,
        /* BUNDLE_ITEM_NOT_FOUND */ null,
        /* BUNDLE_NOT_FOUND */ null,
        /* BUNDLE_PROGRESS */ "捆绑包进度",
        /* BUSY_ALL_DAY */ "全天忙碌",
        /* BY */ null,
        /* BY_ENROLLING_I_ACCEPT_THE */ null,
        /* BY_EXISTING_VISIT */ "按现有出勤：",
        /* BY_PATIENT_NAME */ "按患者姓名：",
        /* BY_SIGNING_HERE_I_ACCEPT_THE */ "在此签名即表示本人接受",
        /* CALL */ null,
        /* CALL_AGENCY */ "致电机构",
        /* CALL_HOME */ "拨打家中电话",
        /* CALL_MOBILE */ "拨打手机",
        /* CALL_NOW */ "立即致电：",
        /* CALL_PATIENT */ "致电患者",
        /* CALL_PATIENT_CONFIRMATION */ null,
        /* CALL_PATIENT_EXPLANATION */ "确认此消息后，您很快就会收到电话。",
        /* CALL_PATIENT_HOME */ "拨打患者家中电话",
        /* CALL_PATIENT_MOBILE */ "拨打患者手机",
        /* CALL_PATIENT_NOTE */ "在下一个画面联系患者",
        /* CALL_SUPPORT_FOR_MORE_INFO */ "如需更多信息，请致电客服",
        /* CANCEL */ "取消",
        /* CANCEL_REQUESTED_SHIFTS */ null,
        /* CANCEL_VISIT */ null,
        /* CANNOT_EDIT_ANSWERS_IN_READ_ONLY_MODE */ null,
        /* CANT_CANCEL_24_HOURS_SCHEDULED_VISIT */ "错误：出勤时间距今不到24小时",
        /* CANT_CANCEL_AT_THIS_TIME */ "目前无法取消",
        /* CANT_CLOCK_IN */ "无法开始工作",
        /* CANT_CLOCK_IN_AT_THIS_TIME */ "目前无法开始工作。",
        /* CANT_CLOCK_OUT */ "无法结束工作",
        /* CANT_CLOCK_OUT_AT_THIS_TIME */ "这个时候不能打卡下班。",
        /* CANT_CLOCK_OUT_BEFORE_VISIT_ENDED */ "在出勤结束前不能打卡下班。",
        /* CANT_REJECT_VISIT_PENDING_STATUS */ null,
        /* CANT_REQUEST_JOIN_AGENCY */ "无法申请加入机构",
        /* CANT_REQUEST_VISIT_PENDING_STATUS */ null,
        /* CANT_SUBMIT_AN_EMPTY_FORM */ null,
        /* CANT_WATCH_ON_SHIFT */ "此培训在所有班次都被禁用👀",
        /* CANT_WATCH_THIS_VIDEO */ "无法观看此视频",
        /* CAREBACK_CASH_BONUS */ null,
        /* CAREBACK_POINTS */ null,
        /* CAREGIVER */ "护理员",
        /* CAREGIVER_COMPLIANCE_PASSPORT */ "护理员合规护照",
        /* CAREGIVER_NAME */ "护理员姓名",
        /* CAREGIVER_PHONE */ "护理员电话",
        /* CAREGIVER_SIGNATURE */ null,
        /* CAREGIVER_SIGNATURE_AND_PATIENT_SIGNATURE_REQUIRE_MSG */ "您和患者都必须签署护理计划",
        /* CAREGIVER_SIGNATURE_IS_REQUIRED */ null,
        /* CAREGIVER_SIGNATURE_REQUIRE_MSG */ "您必须签署护理计划",
        /* CAREGIVER_STATUS_PENDING_ERROR */ "无法执行操作，因为您的档案仍处于待定状态。",
        /* CARE_MOMENTS */ null,
        /* CASE_INFO */ null,
        /* CASE_IS_TOO_FAR */ "病例太远",
        /* CASE_SETTINGS */ "病例设置",
        /* CATALOGUE */ null,
        /* CERTIFICATION */ null,
        /* CERTIFICATIONS */ null,
        /* CHANGE */ null,
        /* CHANGES_TO_MY_VISITS */ null,
        /* CHANGES_WERE_SAVED_IN_THE_CLOUD */ "所有更改都保存在云中",
        /* CHANGE_DOCUMENT */ null,
        /* CHANGE_OF_RANKING */ null,
        /* CHANGE_PHONE_NUMBER */ "更改电话号码",
        /* CHANGE_SETTINGS */ null,
        /* CHANGE_SHIFTS */ null,
        /* CHANGE_TASK_TIME */ null,
        /* CHANGE_VISIT_TIMES */ "更改拜访次数",
        /* CHAT */ "交谈",
        /* CHATS */ "聊天",
        /* CHAT_MESSAGES */ null,
        /* CHAT_NOT_ACTIVE_MESSAGE */ "您不能在这里发消息。",
        /* CHAT_NOT_ACTIVE_TITLE */ "交谈不再处于活动状态",
        /* CHAT_WITH_AGENCY */ "与机构的人员聊天",
        /* CHAT_WITH_AGENCY_ABOUT_PATIENT */ null,
        /* CHAT_WITH_MEDFLYT */ null,
        /* CHAT_WITH_OTHER_AGENCIES */ null,
        /* CHAT_WITH_SUPPORT */ "与客服交谈",
        /* CHAT_WITH_US */ null,
        /* CHECK */ null,
        /* CHECK_AGAIN */ null,
        /* CHOOSE_ANOTHER_DATE */ "选择其他日期",
        /* CHOOSE_A_PHOTO */ null,
        /* CHOOSE_A_TIME_FOR_THE_VISIT */ "选择出勤时间",
        /* CHOOSE_CLOCK_TIMES */ null,
        /* CHOOSE_DATE_TO_PERFORM_THIS_TASK */ null,
        /* CHOOSE_FOLDER_TO_UPLOAD */ "选择上传文件夹",
        /* CHOOSE_START_TIME */ "选择开始时间",
        /* CHOOSE_THE_HOURS */ "下一步（选择时间）",
        /* CHOOSE_TIME */ null,
        /* CHOOSE_WHEN_TO_PERFORM_THE_VISIT */ "选择何时进行出勤",
        /* CHOOSE_WHEN_TO_VISIT_THE_PATIENT */ "选择何时到患者家中",
        /* CHOOSE_WHO_TO_CONTACT */ "选择要联系的人",
        /* CHOOSING_A_WINNER */ null,
        /* CHOOSING_A_WINNER_IN */ null,
        /* CLEAR */ "清除",
        /* CLICK_HERE */ null,
        /* CLICK_HERE_TO_DOWNLOAD */ "点击这里下载",
        /* CLICK_HERE_TO_SHARE_YOUR_REFERRAL_CODE */ "点击这里分享您的推荐码",
        /* CLICK_HERE_TO_VIEW_CERTIFICATE */ "点击这里查看证书",
        /* CLICK_ON_THE_MEDAL_TO_VIEW_YOUR_NEW_CERTIFICATE */ "恭喜您获得第一张证书🏆🏆！请点击查看您的新证书",
        /* CLICK_TO_REQUEST */ "点击请求！",
        /* CLICK_TO_SCAN_UPLOAD */ "点击以扫描和上传",
        /* CLICK_TO_TAKE_A_SELFIE */ null,
        /* CLIMB_THE_RANKS_BY_COMPLETING_VISITS */ null,
        /* CLINICAL_SUPPORT */ "临床支持",
        /* CLOCKED_IN */ "已开始工作",
        /* CLOCKED_IN_AND_OUT */ null,
        /* CLOCKED_IN_AT */ "已于...开始工作",
        /* CLOCKED_OUT */ "打卡下班",
        /* CLOCKED_OUT_AT */ "已于...结束工作",
        /* CLOCKING_IN */ "正在开始工作...",
        /* CLOCKING_IN_NOT_IN_TIME_CAUSES_ISSUES */ null,
        /* CLOCKING_IN_OUT_NOT_IN_THE_VISITS_LOCATION_CAN_CAUSE_ISSUES */ null,
        /* CLOCKING_OUT */ "正在结束工作...",
        /* CLOCK_ADDRESS_IN_RANGE */ null,
        /* CLOCK_ADDRESS_NOT_IN_RANGE */ null,
        /* CLOCK_IN */ "开始工作",
        /* CLOCK_IN_ANYWAY */ null,
        /* CLOCK_IN_AT */ "打卡上班时间",
        /* CLOCK_IN_BETWEEN */ null,
        /* CLOCK_IN_OUT */ "开始/结束工作",
        /* CLOCK_IN_OUT_SUBMIT_DUTIES */ null,
        /* CLOCK_IN_TIME_IS_REQUIRED */ null,
        /* CLOCK_OUT */ "结束工作",
        /* CLOCK_OUT_AFTER */ "在此时间后打卡下班",
        /* CLOCK_OUT_AT */ "打卡下班时间",
        /* CLOCK_OUT_BETWEEN */ null,
        /* CLOCK_OUT_TIME_IS_REQUIRED */ null,
        /* CLOCK_TIMES_NOT_MOBILE */ null,
        /* CLOCK_TIME_IN_RANGE */ null,
        /* CLOCK_TIME_NOT_IN_RANGE */ null,
        /* CLOSE */ null,
        /* CLOSE_SURVEY */ null,
        /* CLUSTERED_VISIT_EXPLENATION */ "我们发现这两次出勤的地点很接近，并且符合您的每天日程。我们建议同时请求这两次出勤。您也可以单独请求每次出勤",
        /* CODE_NOT_FOUND_PLEASE_USE_ANOTHER_ONE */ "代码找不到，请使用另一个",
        /* COMBINED_CASE */ "合并的工作",
        /* COMING_SOON */ null,
        /* COMPLETED */ "已完成",
        /* COMPLETED_DOCUMENTS */ "已完成的文档",
        /* COMPLETE_ALL_DOCUMENTS_BEFORE_PAYROLL */ null,
        /* COMPLETE_MORE_SHIFTS_TO_EARN_MORE_TOKENS */ null,
        /* COMPLETE_PREVIOUS_SECTIONS_FIRST */ null,
        /* COMPLETE_REGISTRATION */ null,
        /* COMPLETE_REGISTRATION_PROCESS */ null,
        /* COMPLETE_THE_APPLICATION_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* COMPLETE_VISIT */ null,
        /* COMPLETE_YOUR_ONBOARDING_ANYTIME */ null,
        /* COMPLIANCE */ "合规性",
        /* COMPLIANCE_EXPIRY */ "视频需要您的注意",
        /* COMPLIANCE_FORM */ null,
        /* COMPLIANCE_FORM_SUBMITTED_SUCCESSFULLY */ null,
        /* COMPLIANT */ "合规",
        /* COMPLIANT_ITEMS */ null,
        /* CONFIRM */ "确认",
        /* CONFIRM_ASSESSMENT */ "确认评估",
        /* CONFIRM_COPY_LAST */ "是否要从这里复制答案",
        /* CONFIRM_COPY_LAST_TITLE */ "确定要复制吗？",
        /* CONFIRM_DEPOSIT_DETAILS */ null,
        /* CONFIRM_PATIENT_AVAILABILITY */ null,
        /* CONFIRM_PATIENT_AVAILABILITY_MESSAGE */ null,
        /* CONFIRM_RN_FLEX_VISIT */ "我确认我的出勤",
        /* CONFIRM_WITHOUT_LOCATION */ "在无位置的情况下确认",
        /* CONGRATULATIONS */ null,
        /* CONGRATULATIONS_TO */ null,
        /* CONNECTING_HOME */ "联系家庭",
        /* CONNECTING_HOME_HEALTH_AGENCIES_WITH_CAREGIVERS */ null,
        /* CONNECT_WITH_US_ON_FACEBOOK */ null,
        /* CONNECT_WITH_US_ON_WHATSAPP */ null,
        /* CONTACT */ "联系",
        /* CONTACT_AGENCY_FOR_MORE_INFO */ "联系机构以获取更多信息。",
        /* CONTACT_PATIENT */ "联系患者",
        /* CONTACT_SUPPORT */ "联系客服",
        /* CONTINUE */ null,
        /* CONTINUE_LATER */ "稍后继续",
        /* CONTINUE_TO_APP */ null,
        /* CONTINUE_TO_ORIENTATION */ null,
        /* CONTINUE_TO_SIGN_UP */ null,
        /* CONTINUE_WITH_YOUR_VISITS_STREAK_AND_YOU_WILL_GET_BACK_TO_THE_NEXT_RANK */ null,
        /* COORDINATOR */ null,
        /* COORDINATOR_EMAIL */ "协调员电子邮箱",
        /* COORDINATOR_IN_CHARGE */ "负责协调员",
        /* COORDINATOR_PHONE */ "协调员电话",
        /* COPY */ "复制",
        /* COPY_FROM_LAST_TIME */ "复制自上次",
        /* COPY_FROM_MEDICATION */ "复制自药物",
        /* COPY_FROM_OTHER_FORMS */ "从其他表格复制",
        /* COPY_LAST_NO_DATE_FALLBACK_APPENDED */ "上次",
        /* COPY_MEDICATION_CHART */ "复制药物图表",
        /* COPY_PLAN_OF_CARE */ "复制护理计划",
        /* CORRECT */ "正确",
        /* COURSES */ null,
        /* COVID */ "COVID-19",
        /* COVID_REQUIRED */ "需要COVID-19问卷",
        /* COVID_REQUIRED_EXPLAINED */ "您今天尚未填写COVID-19问卷。请填写以继续",
        /* COVID_SCREENING_CLICK_HERE */ "COVID-19筛查 - 点击这里",
        /* CREATED_AT */ "创建于",
        /* CREATE_A_NEW_ACCOUNT */ null,
        /* CREATE_NEW_PLAN_OF_CARE */ "制定新的护理计划",
        /* CRIMINAL_CONVICTIONS_RECORDS */ null,
        /* CURRENTLY_CLOCKED_IN_TO_A_DIFFERENT_VISIT */ "目前已进行另一项拜访工作",
        /* CURRENT_BALANCE */ null,
        /* CURRENT_VISIT */ null,
        /* DATA_WILL_BE_LOST */ "数据将会丢失",
        /* DATE */ "日期",
        /* DATES */ "日期",
        /* DATES_RANGE_TO_COMPLETE_TASKS_FROM_TO */ null,
        /* DATE_NOT_SPECIFIED */ null,
        /* DATE_OF_BIRTH */ null,
        /* DATE_UNKNOWN */ null,
        /* DATE_VERIFICATION */ "日期验证",
        /* DAY */ null,
        /* DAYS */ "天",
        /* DAYS_A_WEEK */ "每周天数",
        /* DAYS_LEFT */ "尚余天数",
        /* DAYS_OF_WEEK */ "每周的天数",
        /* DECEMBER */ null,
        /* DECLINED */ "被拒绝",
        /* DELETE */ "删除",
        /* DESCRIBE_THE_PROBLEM */ null,
        /* DETAILS */ "详细信息",
        /* DIRECTIONS */ "路线",
        /* DIRECT_DEPOSIT */ null,
        /* DISCONNECTED_CHECK_YOUR_INTERNET_CONNECTION */ "连接已断开。请检查您的网络连接",
        /* DISCOVER_YOUR_JOURNEY */ null,
        /* DISCRIMINATION */ null,
        /* DISMISS */ null,
        /* DISMISSED */ null,
        /* DISTANCE */ "距离",
        /* DOB */ null,
        /* DOCUMENT */ null,
        /* DOCUMENTS */ "文档",
        /* DOCUMENTS_TO_COMPLETE */ null,
        /* DOCUMENT_HAS_EXPIRED */ "文档已过期",
        /* DOCUMENT_IS_MISSING */ "文档缺失",
        /* DOCUMENT_REJECTED */ "文档被拒绝",
        /* DOCUMENT_SELECTED */ null,
        /* DOESNT_EXPIRE */ null,
        /* DOES_NOT_FIT_MY_SCHEDULE */ "不符合我的安排",
        /* DONE */ "完成",
        /* DONT_FORGET_TO_CLOCK_IN */ null,
        /* DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS */ null,
        /* DONT_FORGET_TO_CLOCK_OUT */ "不要忘记结束工作",
        /* DONT_FORGET_TO_FILL_THE_DUTY_SHEET */ null,
        /* DONT_FORGET_TO_SMILE */ null,
        /* DONT_SCHEDULE_VISIT */ null,
        /* DONT_SHOW_AGAIN */ null,
        /* DOSE */ "剂量",
        /* DOWNLOAD_PDF */ null,
        /* DO_YOU_HAVE_ANY_QUESTIONS_ASK */ null,
        /* DO_YOU_WANT_THIS_VISIT */ null,
        /* DUE_BETWEEN */ null,
        /* DUE_BY_DATETIME */ null,
        /* DUE_DATE */ null,
        /* DUE_ON */ null,
        /* DUE_TO_A_MISSED_VISIT_YOUR_RANK_HAS_CHANGED_TO */ null,
        /* DURATION */ null,
        /* DURATION_PER_DAY */ "每天的时间长度",
        /* DUTIES */ null,
        /* DUTIES_COMPLETED_SUCCESSFULLY */ null,
        /* DUTY_SHEET_SUBMITTED */ "已提交工作表",
        /* EACH_100_POINTS_DOLLAR */ null,
        /* EACH_INVITE */ "每次邀请",
        /* EARLY_OR_LATE_CLOCKS */ null,
        /* EARN_MORE_HIGHER_RANKS_MEANS_HIGHER_PAY */ null,
        /* EDIT */ "编辑",
        /* EDIT_ACCOUNT_DETAILS */ null,
        /* EDIT_TIMES */ "编辑时间",
        /* EDUCATION */ "教育中心",
        /* ELECTRIC_EQUIPMENT_DEPENDENCY */ null,
        /* ELIGIBLE_VISITS */ null,
        /* EMAIL */ null,
        /* EMAIL_QUESTION_PENDING_VERIFICATION */ null,
        /* EMAIL_SUPPORT */ null,
        /* EMAIL_SUPPORT_FOR_MORE_INFO */ "如需更多信息，请给客服发送电子邮件",
        /* EMAIL_SUPPORT_TO_CHANGE_PHONE_NUMBER */ null,
        /* EMAIL_VERIFICATION_QUESTION_LABEL */ null,
        /* EMERGENCY_CONTACTS */ null,
        /* EMPTY_DURATION */ null,
        /* EMPTY_PATIENT_MEDICATION_PROFILE */ "患者药物档案为空",
        /* ENABLE_LOCATION_MESSAGE */ null,
        /* ENABLE_LOCATION_TITLE */ null,
        /* ENDING_AT */ "结束于",
        /* ENDS */ "结束",
        /* END_DATE */ "结束日期",
        /* END_TIME */ "结束时间",
        /* ENROLLMENT_REQUESTED */ null,
        /* ENROLL_NOW */ null,
        /* ENTER_AGENCY_CODE */ "输入机构代码",
        /* ENTER_DOCUMENT_NAME */ "输入文档名",
        /* ENTER_NUMBER_HERE */ "在这里输入数字",
        /* ENTER_TEXT_HERE */ "在这里输入文字",
        /* ENTER_YOUR_MOBILE_NUMBER */ "输入您的手机号码",
        /* ENTER_YOUR_PIN_CODE */ null,
        /* ENTITY_IS_MISSING */ null,
        /* ERROR */ "错误",
        /* ERROR_FETCHING_SLOTS */ null,
        /* ERROR_LOADING_DATA */ null,
        /* ERROR_REMOVING_DOCUMENT */ "移除文档时出错",
        /* ERROR_SCHEDULING_TASK */ null,
        /* ERROR_SCHEDULING_TASK_MESSAGE */ null,
        /* ESTIMATED_ADDRESS_WILL_BE_PROVIDED */ null,
        /* ESTIMATED_TIME_OF_CLOCKING_OUT_IS */ null,
        /* EVACUATION_LOCATION */ null,
        /* EVACUATION_ZONE */ null,
        /* EVERY_VISIT */ "每次出勤",
        /* EVV */ null,
        /* EXCITING_NEWS_AHEAD */ null,
        /* EXEMPTED */ "豁免",
        /* EXPIRED */ "已到期",
        /* EXPIRED_COMPLIANCE */ null,
        /* EXPIRED_ON_DATE */ null,
        /* EXPIRES_AT */ "到期日",
        /* EXPIRES_IN */ "尚余时间",
        /* EXPIRES_IN_ONE_DAY */ "一天后过期",
        /* EXPIRES_IN_X_DAYS */ "%d天后过期",
        /* EXPIRES_ON_DATE */ null,
        /* EXPIRING_COMPLIANCE */ null,
        /* EXPIRING_SOON */ null,
        /* EXPIRY_DATE */ "到期日",
        /* EXPLORE */ null,
        /* EXPLORE_A_CAREER_ENHANCEMENTS */ null,
        /* FAILED_TO_IDENTIFY_PATIENT */ "无法识别患者",
        /* FAR_VISIT_WARNING_MODAL_TITLE */ null,
        /* FAX_NUMBER */ null,
        /* FEBRUARY */ null,
        /* FEMALE */ "女",
        /* FIFTHY_DOLLAR_AMAZON_GIFT_CARD */ null,
        /* FILES */ null,
        /* FILE_NOT_FOUND_CONTACT_AGENCY */ null,
        /* FILL */ null,
        /* FILL_IN_THE_FORM_TO_SUBMIT_THE_DOCUMENT */ null,
        /* FILL_IN_THE_QUESTIONNAIRE */ "填写问卷",
        /* FILTERS */ "筛选器",
        /* FINAL_CONFIRMATION */ null,
        /* FIND_A_CARE_MOMENT */ null,
        /* FIND_A_CARE_MOMENT_DESCRIPTION */ null,
        /* FIND_MORE_CASES_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FIND_NEW_PATIENTS_IN_THE_AVAILABLE_VISITS_PAGE */ null,
        /* FINISH_MY_ONBOARDING */ null,
        /* FINISH_ONBOARDING_AND_GET_DOLLARS */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE */ null,
        /* FINISH_ONBOARDING_MODAL_MESSAGE_STAGE_2 */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE */ null,
        /* FINISH_ONBOARDING_MODAL_TITLE_STAGE_2 */ null,
        /* FINISH_SHIFT */ null,
        /* FINISH_THE_DOCUMENTS */ null,
        /* FIRST_NAME */ "名字",
        /* FIRST_SHIFT */ "第一班",
        /* FIVE_THOUSAND_POINTS */ null,
        /* FIX */ null,
        /* FIX_DOCUMENTS_DESCRIPTION */ null,
        /* FIX_DOCUMENT_DESCRIPTION */ null,
        /* FIX_ISSUE */ null,
        /* FIX_ISSUES */ null,
        /* FIX_IT_NOW_ONBOARDING_MESSAGE_BUTTON_TEXT */ null,
        /* FIX_SETTINGS */ "修复设置",
        /* FIX_THE_DOCUMENT */ null,
        /* FIX_THE_DOCUMENTS */ null,
        /* FIX_YOUR_DOCUMENT */ null,
        /* FIX_YOUR_DOCUMENTS */ null,
        /* FLEXIBLE */ null,
        /* FLEXIBLE_DAYS_AND_HOURS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_PER_WEEK_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_DAYS_VISIT */ "灵活日期出勤",
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_AND_DAYS_PATTERN_SINGLE_SHIFT */ null,
        /* FLEXIBLE_HOURS_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_FIXED_DAYS_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_DAY_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_ONE_PATTERN_EXPLANATION_TEXT */ null,
        /* FLEXIBLE_HOURS_PATTERN_SHIFT */ null,
        /* FLEXIBLE_HOURS_VISIT */ "灵活时间出勤",
        /* FLEXIBLE_VISIT */ "灵活出勤",
        /* FLEXIBLE_VISIT_DAY_TO_CHOOSE */ null,
        /* FLEXIBLE_VISIT_DETAILS */ "灵活出勤详细信息",
        /* FLEXIBLE_VISIT_TYPE */ "灵活出勤",
        /* FLU_SHOT */ null,
        /* FLU_SHOT_SUBMITTION_MESSAGE */ null,
        /* FOLLOW_US_ON_INSTAGRAM */ "在 Instagram 上关注我们",
        /* FOLLOW_US_ON_TWITTER */ "在 Twitter 上关注我们",
        /* FORGOT_PIN_CODE_DIALOG_MESSAGE */ "请注意：您将被转到登录界面，开始新的注册流程。",
        /* FORM_NAME */ "表格名称",
        /* FOURTEEN_THOUSAND_POINTS */ null,
        /* FREQUENCY */ "日期",
        /* FRIEND */ null,
        /* FROM */ "从",
        /* FROM_CAMERA */ "从相机",
        /* FROM_GALLERY */ "从图库",
        /* FULL_TERMS_AND_CONDITIONS_MEDFLYT_CHALLENGE */ "完整的条款和条件 - MedFlyt挑战",
        /* FUTURE_VISITS */ null,
        /* GENDER */ "性别",
        /* GENERAL */ "通用",
        /* GENERAL_FILES */ "一般文件",
        /* GENERAL_NOTES */ "一般注意事项",
        /* GENERAL_SUPPORT */ null,
        /* GET_INSTAPAY */ null,
        /* GET_IT_NOW */ null,
        /* GET_MONEY_FOR_THIS_VISIT_TODAY
 */ null,
        /* GET_NOW */ null,
        /* GET_STARTED */ null,
        /* GET_THE_APP */ null,
        /* GET_X_NOW */ null,
        /* GOOD_JOB */ "做得很好！",
        /* GOOD_JOB_YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "做得很好！您已经完成了所有的课",
        /* GOT_IT */ "知道了",
        /* GO_BACK */ "后退",
        /* GO_TO */ "转到",
        /* GO_TO_MEDFLYT_PASSPORT */ null,
        /* GO_TO_PATIENT */ "转到患者",
        /* GO_TO_PATIENT_DETAILS */ "转到患者详细信息",
        /* GO_TO_SETTINGS_AND_ENALBE_CAMERA_PERMISSION */ null,
        /* GO_TO_VISIT */ "转到出勤",
        /* GREAT_JOB */ "做得很好！",
        /* GROSS_PAY */ null,
        /* HAS_DNR */ null,
        /* HAS_HEALTH_CARE_PROXY */ null,
        /* HAVE_A_NICE_WORKING_DAY */ null,
        /* HAVE_A_PLEASANT_VISIT */ null,
        /* HAVE_A_QUESTION_LETS_CHAT */ null,
        /* HEALTH_AGENCIES */ "卫生机构",
        /* HELP */ "帮助",
        /* HELP_ME_FIND_MY_AGENCY */ "帮我查找我的机构",
        /* HERE_IS_WHAT_YOU_NEED_TO_KNOW_ABOUT_OUR_AGENCY */ null,
        /* HEY */ "嘿！",
        /* HEY_THERE */ null,
        /* HI */ "您好",
        /* HIRE_DATE */ null,
        /* HI_PLEASE_HELP_ME_FILL_MY_APPLICATION  */ null,
        /* HOME_PHONE */ "住宅电话",
        /* HOUR */ null,
        /* HOURS */ null,
        /* HOURS_PER_DAY */ "每天的小时数",
        /* HOURS_PER_VISIT */ "每次拜访的时长",
        /* HOW_ARE_WE_CALCULATING_THE_RANK */ null,
        /* HOW_CAN_WE_HELP_YOU */ "我们可以怎样帮助您？",
        /* HOW_CARE_MOMENTS_WORKS */ null,
        /* HOW_DID_YOU_HEAR_ABOUT_US */ null,
        /* HOW_DOES_IT_WORK */ null,
        /* HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS */ null,
        /* HOW_DO_YOU_ENCOURAGE_A_PATIENT_WHO_IS_FEELING_DOWN */ null,
        /* HOW_DO_YOU_RATE_MEDFLYT */ "您觉得Medflyt怎么样？",
        /* HOW_URGENT_IS_THE_ISSUE */ null,
        /* HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT */ "您想如何致电患者？",
        /* HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE */ null,
        /* HOW_WOULD_YOU_LIKE_TO_UPLOAD_THE_DOCUMENT */ null,
        /* HR_PER_VISIT */ "每次出勤的小时数",
        /* HUNDRED_DOLLARS_GIFT_CARD */ null,
        /* ICD */ null,
        /* ID */ null,
        /* IF_YOU_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_DONT_CLOCK_IN_AND_OUT_ON_TIME */ null,
        /* IF_YOU_MISS_A_VISIT_FOR_NON_LEGIT_REASON */ null,
        /* IF_YOU_REQUEST_MORE_VISITS_WHILE_YOUR_SCHEDULE_IS_FREE */ null,
        /* IF_YOU_STAY_COMPLIANT */ null,
        /* IMPORTANT_INFORMATION */ null,
        /* IMPORTED */ "已导入",
        /* IM_AVAILABLE */ "我有空",
        /* IM_DONE_SUBMIT */ null,
        /* IM_NOT_INTERESTED */ null,
        /* IM_WORKING_WITH_AN_AGENCY */ null,
        /* INACTIVE */ "不活跃的",
        /* INCOMPLETE */ null,
        /* INCORRECT */ "不正确",
        /* INCORRECT_CODE */ "不正确的代码",
        /* INCORRECT_DIGITS */ null,
        /* INCORRECT_DIGITS_EXPLAINED */ null,
        /* INCORRECT_DIGITS_MESSAGE */ null,
        /* INCORRECT_PIN_CODE_PLEASE_TRY_AGAIN */ "不正确的PIN码。请重试。",
        /* INCORRECT_SMS_CODE */ null,
        /* INCORRECT_SMS_CODE_EXPLAINED */ null,
        /* INFORMATION_CENTER */ null,
        /* INFORMATION_NOT_MATCH_PROFILE */ null,
        /* INSERT_THEIR_REFERRAL_CODE_HERE */ "在这里输入他们的推荐码！",
        /* INSERVICES */ null,
        /* INSTAPAY */ null,
        /* INSTAPAY_HISTORY */ null,
        /* INSTAPAY_TECHNICAL_ISSUE */ null,
        /* INSUFFICIENT_DUTIES */ null,
        /* INTERESTED_IN_THIS_BUNDLE */ null,
        /* INTRODUCING */ null,
        /* INVALID_DOCUMENT_NAME */ "文档名无效",
        /* INVALID_EMAIL */ "电子邮箱无效",
        /* INVALID_FORM */ null,
        /* INVALID_PHONE */ "电话号码无效",
        /* INVALID_PHONENUMBER */ null,
        /* INVALID_SSN_PLEASE_CHECK_AND_TRY_AGAIN */ null,
        /* INVITE_CAREGIVERS_TO_MEDFLYT_AND_WIN_AMAZING_PRIZES */ "邀请护理员来MedFlyt以赢取精彩奖品",
        /* INVITE_FRIENDS */ "邀请朋友",
        /* IN_ORDER_TO_ANSWER_THIS_QUESTION_PLEASE_UPDATE_TO_OUR_NEWEST_VERSION_FROM_THE_STORE */ null,
        /* IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT */ null,
        /* IN_PROGRESS */ null,
        /* ISSUES_TO_SOLVE */ null,
        /* IS_DUE_IN_DAYS */ null,
        /* IS_DUE_TOMORROW */ null,
        /* ITEMS_THAT_WILL_EXPIRE_SOON */ null,
        /* ITEMS_WITH_ISSUES */ null,
        /* ITEM_IS_MISSING */ null,
        /* ITEM_IS_NOT_COMPLIANT */ null,
        /* ITS_NOT_ME */ null,
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_EXISTS_ON_THIS_DEVICE_IS_THAT_YOU */ null,
        /* IT_APPEARS_THAT_WE_ALREADY_HAVE_AN_ACCOUNT_THAT_MATCHES_YOUR_DETAILS_IS_THAT_YOU */ null,
        /* IT_APPEARS_YOU_HAVE_NO_VISITS_THIS_WEEK */ null,
        /* IT_LOOKS_LIKE_YOURE_NO_WORKING_WITH_ANY_AGENCY_MESSAGE */ null,
        /* I_DONT_HAVE_MY_CODE */ "我没有代码",
        /* I_DONT_WANT_THIS_CASE */ null,
        /* I_DONT_WANT_TO_CLOCK */ null,
        /* I_FORGOT_MY_PIN_CODE */ "我忘记了我的PIN码",
        /* I_HAVE_CHANGED_MY_MIND */ null,
        /* I_HAVE_READ_AND_AGREE */ null,
        /* I_VERIFY_THE_TERMS */ null,
        /* I_WANT_TO_CLOCK_IN_ANYWAY */ null,
        /* I_WANT_TO_CLOCK_OUT_ANYWAY */ null,
        /* I_WANT_TO_FINISH_MY_ONBOARDING */ null,
        /* I_WILL_DO_IT_LATER */ null,
        /* JANUARY */ null,
        /* JOINED_DATE */ "加入日期",
        /* JOIN_NOW_TO_GET_THIS_LIMITED_TIME_BENEFIT */ null,
        /* JULY */ null,
        /* JUNE */ null,
        /* JUST_ONE_MORE_THING */ null,
        /* JUST_TO_BE_SURE */ null,
        /* JUST_VERIFYING_ITS_YOU */ null,
        /* KEEP_UP_THE_GOOD_WORK */ null,
        /* LABELS */ "标签",
        /* LANGUAGE */ "语言",
        /* LANGUAGES */ "语言",
        /* LAST_NAME */ "姓氏",
        /* LEARN_MORE */ null,
        /* LEAVE_WITHOUT_SAVING */ "退出而不保存吗？",
        /* LEFT */ null,
        /* LESSON */ null,
        /* LESSONS */ "课程",
        /* LETS_CONTINUE_TO_NEXT_SECTION */ null,
        /* LETS_FIND_CASES */ null,
        /* LETS_FIND_YOUR_FIRST_CASE */ null,
        /* LETS_FIND_YOUR_FIRST_PATIENT */ null,
        /* LETS_FINISH_YOUR_SHIFT */ null,
        /* LETS_START */ null,
        /* LETS_START_YOUR_SHIFT */ null,
        /* LIKE_US_ON_FACEBOOK */ "在Facebook上为我们点赞",
        /* LINKED_TO_ANOTHER_PATIENT */ null,
        /* LIST */ "列表",
        /* LISTENING___ */ null,
        /* LIST_OF_PATIENTS */ null,
        /* LIST_OF_TASKS */ null,
        /* LIST_OF_VISITS */ null,
        /* LIVE_CHAT_SUPPORT */ "实时交谈支持",
        /* LIVE_CLASS */ null,
        /* LIVE_CLASS_EXPLANATION */ null,
        /* LIVE_EVENTS */ null,
        /* LOADING */ "正在加载",
        /* LOADING_LOCATION */ "正在加载地点...",
        /* LOCATION */ "地点",
        /* LOCKED */ "已锁定",
        /* LOGGING_YOU_IN */ null,
        /* LOGIN */ null,
        /* LOGIN_FROM_DIFFERENT_DEVICE_EXPLAINED */ null,
        /* LOOKS_LIKE_MORE_THAN */ null,
        /* LOOKS_LIKE_YOU_ARE_TOO_FAR_FROM_THE_VISITS_LOCATION */ null,
        /* MAIN_TASKS */ null,
        /* MAKE_A_DIFFERENCE */ null,
        /* MAKE_SURE_PICTURE_IS_CLEAR */ null,
        /* MALE */ "男",
        /* MANUALLY_SUBMITTED_INFO */ null,
        /* MAP */ "地图",
        /* MARCH */ null,
        /* MAX_TRAVEL_DISTANCE */ "最长的行程",
        /* MAY */ null,
        /* MAYBE_LATER */ "也许以后再说吧",
        /* MAY_CLOCK_IN_AT */ "可以在...开始工作",
        /* MAY_CLOCK_OUT_FROM */ "可以从...结束工作",
        /* MEC_WAIVER_INFORMATION */ null,
        /* MEDFLYT */ null,
        /* MEDFLYTS_MONTHLY_RAFFLE */ null,
        /* MEDFLYT_AGENCY_HANDBOOK */ null,
        /* MEDFLYT_AT_HOME_BENEFITS */ null,
        /* MEDFLYT_CHALLENGE */ "MedFlyt挑战",
        /* MEDFLYT_HOME_CARE */ null,
        /* MEDFLYT_ID_CARD */ null,
        /* MEDFLYT_PASSPORT */ "Medflyt护照",
        /* MEDFLYT_PASSPORT_TERMS */ null,
        /* MEDFLYT_RAFFLE */ null,
        /* MEDFLYT_TEAM */ null,
        /* MEDFLYT_VERSION */ "MedFlyt版本",
        /* MEDICAL_FILES */ "医疗文件",
        /* MEDICAL_INFORMATION */ "医疗信息",
        /* MEDICAL_NOTES */ null,
        /* MEDICATIONS */ null,
        /* MESSAGE */ "消息",
        /* MESSAGE_FOR_THE_COORDINATOR */ "给协调员的消息",
        /* MIDDLE_NAME */ null,
        /* MILES_AWAY */ "英里远",
        /* MILES_BETWEEN_PATIENTS */ "患者之间的英里数",
        /* MILES_SHORT */ "英里",
        /* MINIMUM_WAGE */ null,
        /* MINUTE */ null,
        /* MINUTES */ "分钟",
        /* MINUTE_VISIT */ "分钟的出勤",
        /* MISSING */ "缺失",
        /* MISSING_CLOCKS */ null,
        /* MISSING_PERSONAL_CARE_DUTY */ null,
        /* MM_DD_YYYY */ null,
        /* MOBILE_PHONE */ "手机",
        /* MOBILITY_STATUS */ null,
        /* MONTH */ "月",
        /* MONTHLY_RAFFLE */ null,
        /* MORE_DETAILS */ "更多详情",
        /* MORE_DETAILS_BELOW */ null,
        /* MORE_SHIFTS_MORE_CHANCES */ null,
        /* MORE_VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* MUST_AGREE_TERMS */ null,
        /* MUST_BE_ATLEAST_3_CHARACTERS */ "必须至少包含3个字符",
        /* MUST_BE_IN_ONE_OF_THE_FOLLOWING_DAYS */ "必须在下列的其中一天",
        /* MUST_PICK_EXACTLY */ "必须选择确切的",
        /* MUST_START_AT_OR_AFTER */ "必须在此时间或之后开始",
        /* MUST_START_AT_OR_BEFORE */ "必须在此时间或之前开始",
        /* MUST_UPDATE_ADDRESS_TO_SEE_CASES */ "您必须更新您的地址才能看到工作！",
        /* MY_AGENCIES */ "我的机构",
        /* MY_ASSIGNED_VISITS */ "我分配到的拜访",
        /* MY_AVAILABILITY */ null,
        /* MY_BENEFITS_CARD_INFORMATION */ null,
        /* MY_MEDFLYT_COMPLIANCE */ null,
        /* MY_PASSPORT */ "我的护照",
        /* MY_PAYROLL_HISTORY */ null,
        /* MY_PAYROLL_INFORMATION */ null,
        /* MY_PROFILE */ null,
        /* MY_REQUESTED_VISITS */ "我请求的拜访",
        /* MY_STAFFING_PREFERENCES */ null,
        /* MY_UPCOMING_VISITS_REMINDERS */ null,
        /* MY_VIRTUAL_ID */ null,
        /* MY_VISITS */ null,
        /* NA */ "不适用",
        /* NAME */ "姓名",
        /* NEAR */ null,
        /* NEED_DIRECTIONS */ "需要指导？",
        /* NET_PAY_FOR_PERIOD */ null,
        /* NEW */ "新",
        /* NEW_END_TIME_X */ null,
        /* NEW_MESSAGE */ null,
        /* NEW_TASK */ null,
        /* NEW_TASKS */ null,
        /* NEW_VISITS_AVAILABLE */ null,
        /* NEXT */ "下一步",
        /* NEXT_DUE */ "下一个到期日",
        /* NEXT_LESSON */ null,
        /* NEXT_SECTION */ null,
        /* NEXT_TOKEN_IN */ null,
        /* NEXT_YEAR */ null,
        /* NO */ "否",
        /* NONE */ "没有",
        /* NONE_OF_THEM_IS_ME_CREATE_NEW_ACCOUNT */ null,
        /* NONE_OF_THE_FOLLOWING_ACCOUNTS_IS_YOU */ null,
        /* NOTES */ "备注",
        /* NOTIFICATIONS */ "通知",
        /* NOTIFICATIONS_OFF */ null,
        /* NOTIFICATIONS_ON */ null,
        /* NOT_AVAILABLE */ "没空",
        /* NOT_COMPLIANT */ "不合规",
        /* NOT_DUE_YET */ null,
        /* NOT_ENOUGH_HOURS */ "时间不够",
        /* NOT_ENOUGH_SHIFTS */ "班次不够...",
        /* NOT_ENOUGH_SHIFTS_MESSAGE */ "您必须选择至少%minShifts%个班次，才能请求此次出勤（您只选择了%currentShifts%个）。",
        /* NOT_FOUND */ null,
        /* NOT_INTERESTED */ "不感兴趣",
        /* NOT_SELECTED */ null,
        /* NOT_SET */ null,
        /* NOT_SIGNING */ null,
        /* NOT_STARTED */ null,
        /* NOT_URGENT */ null,
        /* NOVEMBER */ null,
        /* NO_ALLERGIES */ null,
        /* NO_ANSWERS_TO_COPY */ "没有可复制的答案。",
        /* NO_ANSWERS_TO_COPY_TITLE */ "复制失败！",
        /* NO_AVAILABLE_SLOTS */ null,
        /* NO_BALANCE */ null,
        /* NO_CHANGES_WERE_MADE */ "未作更改",
        /* NO_COMPLIANT_ITEMS */ null,
        /* NO_DOCUMENTS */ null,
        /* NO_DOCUMENTS_AVAILABLE */ "没有可用的文档",
        /* NO_DOCUMENTS_REQUIRED */ "不需要文档。",
        /* NO_DUTIES_REQUIRED_FOR_THIS_VISIT */ null,
        /* NO_EDUCATION_LINK */ "您想要免费教育吗？请联系您的机构",
        /* NO_ELIGIBLE_VISITS */ null,
        /* NO_END_DATE */ "无结束日期",
        /* NO_GENERAL_NOTES */ "无一般备注",
        /* NO_IN_SERVICE_VIDEOS_AVAILABLE */ "没有可用的视频提供。要了解详情，请与您的机构联系。",
        /* NO_ISSUES_FOUND */ null,
        /* NO_ITS_NOT_ME_CREATE_NEW_ACCOUNT */ null,
        /* NO_JUST_THIS_ONE */ null,
        /* NO_KEEP_THE_ORIGINAL_TIMES */ null,
        /* NO_KNOWN_ALLERGIES */ null,
        /* NO_LESSONS */ null,
        /* NO_LESSONS_FOR_YOU_YET */ "尚未有课程提供给您",
        /* NO_MEDICAL_INFORMATION */ "无医疗信息",
        /* NO_NOTIFICATIONS */ "无通知",
        /* NO_PAYSTUBS_FOUND_FOR_THIS_MONTH */ null,
        /* NO_PHONE */ "没有电话",
        /* NO_PHYSICIAN_SELECTED */ null,
        /* NO_PREVIOUS_CONVERSATIONS */ null,
        /* NO_SCHEDULED_VISITS_TODAY */ "今天没有预定的出勤",
        /* NO_SHIFTS_SELECTED */ null,
        /* NO_TAKE_ME_BACK */ null,
        /* NO_TESTS */ null,
        /* NO_THANKS */ "不用了，谢谢",
        /* NO_TIME_LIMIT */ null,
        /* NO_UPCOMING_EXIPRATION_DATES_TO_WORRY_ABOUT */ null,
        /* NO_VIDEOS */ null,
        /* NO_VISITS_SCHEDULED */ null,
        /* NO_VISITS_SCHEDULED_MESSAGE */ null,
        /* NO_VISITS_SELECTED */ null,
        /* NPI */ null,
        /* NUM_COUNT_ITEMS */ null,
        /* NUM_SHIFTS_TO_GO */ null,
        /* NUM_SHIFTS_TO_WAGE */ null,
        /* N_A */ null,
        /* OCTOBER */ null,
        /* OF */ "的",
        /* OF_THE_REQUIRED_PLEASE_CONTINUE */ "后才能提交。请继续。",
        /* OF_THE_VIDEO */ "视频。",
        /* OK */ "确认",
        /* OK_ILL_TRY_LATER */ null,
        /* OK_NO_PROBLEM */ "好的，没问题！",
        /* OK_THANKS */ null,
        /* ON */ "在",
        /* ONBOARDING */ null,
        /* ONBOARDING_COMPLETED */ null,
        /* ONBOARDING_COMPLETED_MESSAGE */ null,
        /* ONE_DAY_TO_COMPLETE */ "尚有一天时间去完成",
        /* ONE_DOCUMENT */ null,
        /* ONE_DOCUMENT_SELECTED */ null,
        /* ONE_HOUR */ null,
        /* ONE_LAST_STEP */ null,
        /* ONE_LESSON */ null,
        /* ONE_TEST */ null,
        /* ONE_THOUSAND_POINTS */ null,
        /* ONE_VIDEO */ null,
        /* ON_HOLD */ "暂缓",
        /* ON_LEAVE */ "请假",
        /* OOPS */ "哎哟",
        /* OPEN */ null,
        /* OPEN_CAMERA */ null,
        /* OPEN_CERTIFICATE */ null,
        /* OPEN_DEVICE_SETTINGS */ null,
        /* OPEN_MAPS */ null,
        /* OPEN_SETTINGS */ null,
        /* OPTIONAL_TASKS */ null,
        /* OR */ "或者",
        /* OTHER */ "其他",
        /* OTHER_PERTINENT_DIAGNOSIS */ null,
        /* OTHER_REASON */ null,
        /* OTHER_TASKS */ null,
        /* OTHER_VISITS */ null,
        /* OUTBOUND_CALL_ERROR_MESSAGE */ null,
        /* OUTBOUND_CALL_ERROR_TITLE */ null,
        /* OUTBOUND_CALL_PROMPT_MESSAGE */ null,
        /* OUTBOUND_CALL_PROMPT_TITLE */ null,
        /* OUTBOUND_CALL_SUCCESS_MESSAGE */ null,
        /* OUTBOUND_CALL_SUCCESS_TITLE */ null,
        /* OUT_OF */ "于此之中",
        /* OUT_OF_RANGE */ null,
        /* OVERDUE */ null,
        /* OVERLAPPING_VISIT_ERROR */ "出勤重叠了，请选择其他日期或时间。",
        /* OVERRIDE_FORM */ null,
        /* OVERRIDE_FORM_MESSAGE */ null,
        /* OVER_NIGHT */ "过夜",
        /* PAGE */ "页",
        /* PAID */ null,
        /* PAID_X_OUT_OF_Y */ null,
        /* PARTIAL_SELECTION */ null,
        /* PASSPORT */ null,
        /* PASSPORT_TERMS_TEXT */ null,
        /* PASTE */ "粘贴",
        /* PAST_DUE */ "逾期",
        /* PAST_SINCE_THE_VISIT_STARTED */ null,
        /* PAST_UPLOADS */ "过去的上传",
        /* PAST_VISITS */ null,
        /* PATIENT */ "患者",
        /* PATIENTS */ null,
        /* PATIENT_ADDRESS */ "患者地址",
        /* PATIENT_CANT_PHISICALLY_SIGN */ null,
        /* PATIENT_CANT_SIGN */ null,
        /* PATIENT_CONTACTS */ null,
        /* PATIENT_DOC_NOT_SUBMITTED */ "由于发生错误，未能提交患者文档",
        /* PATIENT_DOC_SUBMISSION_MISSMATCH */ "您即将提交表格，但预定的出勤日期与今天不同。请在表格上选择您想要的日期",
        /* PATIENT_DOC_SUBMITTED_SUCCESSFULY */ "已成功提交患者文档",
        /* PATIENT_INFO */ "患者信息",
        /* PATIENT_IS_NOT_HOME */ null,
        /* PATIENT_IS_NOT_SIGNING */ null,
        /* PATIENT_NAME */ "患者姓名",
        /* PATIENT_NOT_FOUND */ null,
        /* PATIENT_NOT_FOUND_EXPLAIN */ null,
        /* PATIENT_NUMBER */ "患者编号",
        /* PATIENT_PENDING_APPROVAL_START_DATE_MIGHT_CHANGE */ null,
        /* PATIENT_PHONE */ "患者电话",
        /* PATIENT_REFUSES_TO_SIGN */ null,
        /* PATIENT_REPORT */ null,
        /* PATIENT_REQUESTS */ null,
        /* PATIENT_SCHEDULE */ null,
        /* PATIENT_SIGNATURE */ null,
        /* PATIENT_SIGNATURE_IS_REQUIRED */ null,
        /* PATIENT_SIGNATURE_REQUIRE_MSG */ "请说明患者没有签署的原因",
        /* PATIENT_SIGN_HERE */ "患者在此签名",
        /* PATIENT_UNAVAILABLE_DURING_THESE_HOURS */ null,
        /* PATIENT_VISITS */ null,
        /* PAUSE_READING */ null,
        /* PAYMENT_METHOD */ null,
        /* PAYROLL */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_CLOCK_TIMES_NOT_MOBILE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_EARLY_OR_LATE_CLOCK_TIMES_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_ILLEGIBLE_INSTAPAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_MESSAGE_HOLIDAY_DELAY */ null,
        /* PAYROLL_STATUS_IN_PROGRESS_TITLE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_MESSAGE */ null,
        /* PAYROLL_STATUS_MISSING_CLOCK_TIMES_TITLE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PAID_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_PENDING_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_REGULAR_PAY_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_TECHNICAL_ISSUE_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_NOT_COMPLETED_MODAL_TITLE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_MESSAGE */ null,
        /* PAYROLL_STATUS_VISIT_TOO_SHORT_MODAL_TITLE */ null,
        /* PAYSTUB */ null,
        /* PAYSTUBS */ null,
        /* PAY_ME_NOW */ null,
        /* PAY_ME_NOW_X */ null,
        /* PENDING */ "待定",
        /* PENDING_APPLICATION */ "待批的申请",
        /* PENDING_APPROVAL */ null,
        /* PENDING_CONFIRMATION */ null,
        /* PENDING_ISSUES */ null,
        /* PENDING_VERIFICATION */ null,
        /* PERMANENT_VISIT_DETAILS */ "永久拜访详情",
        /* PERMANENT_VISIT_FROM */ "永久拜访从",
        /* PERMANENT_VISIT_TYPE */ "固定的出勤",
        /* PERMISSION_NEEDED_FOR_CAMERA */ null,
        /* PERMISSION_NEEDED_FOR_CAMERA_MESSAGE */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS */ null,
        /* PERMISSION_NEEDED_FOR_PHOTOS_MESSAGE */ null,
        /* PERMISSION_TO_CAMERA_DENIED */ null,
        /* PER_HOUR */ null,
        /* PER_SHIFT */ "每班",
        /* PER_VISIT */ "每次出勤",
        /* PER_WEEK */ null,
        /* PHONE */ "电话",
        /* PHONES */ "电话",
        /* PHONE_CALL_SUPPORT */ "致电客服",
        /* PHOTO_LIBRARY */ null,
        /* PHYSICIAN_DETAILS */ null,
        /* PICK_A_DATE */ null,
        /* PICK_A_TIME */ "选择一个时间",
        /* PLAN_OF_CARE */ "护理计划",
        /* PLEASE_ASK_THE_PATIENT */ null,
        /* PLEASE_CALL_PATIENT_IN_NEXT_SCREEN */ "在下一个画面致电患者",
        /* PLEASE_CHAT_WITH_THE_AGENCY */ null,
        /* PLEASE_CHECK_THAT_YOU_HAVE_ENTERED_IT_CORRECTLY */ null,
        /* PLEASE_CHOOSE_A_LANGUAGE */ "请选择一种语言",
        /* PLEASE_CHOOSE_A_TIME */ "请选择时间",
        /* PLEASE_CHOOSE_DATE_BETWEEN */ null,
        /* PLEASE_COMPLETE_PREVIOUS_YEARS_BUNDLES */ null,
        /* PLEASE_COMPLETE_THEM_TO_REMAIN_COMPLIANT */ "请观看并提交考试，以保持合规性。",
        /* PLEASE_CONFIRM_THE_TIMES_CHOSEN */ "请确认选择的时间",
        /* PLEASE_CONFIRM_YOUR_INFORMATION */ "请确认您的信息",
        /* PLEASE_CONTACT_THE_AGENCY_FOR_MORE_DETAILS */ "要了解详情，请联系机构",
        /* PLEASE_CONTACT_YOUR_AGENCIES_IMMEDIATELY */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS */ null,
        /* PLEASE_CONTACT_YOUR_AGENCY_IMMEDIATELY */ "请立即联系您的机构",
        /* PLEASE_CONTACT_YOUR_COORDINATOR */ "请联系您的协调员。",
        /* PLEASE_ENABLE_LOCATION */ "请启用位置",
        /* PLEASE_ENTER_A_VALID_PHONE_NUMBER */ "请输入有效的电话号码",
        /* PLEASE_ENTER_PATIENT_FIRST_AND_LAST_NAME */ "请输入患者的姓名",
        /* PLEASE_ENTER_PATIENT_NAME */ "请输入患者姓名",
        /* PLEASE_ENTER_THE_PATIENT_PHONE */ "请输入患者电话",
        /* PLEASE_ENTER_YOUR_PIN_CODE */ "请输入您的PIN码",
        /* PLEASE_EXPLAIN_WHY_IT_WAS_NOT_COMPLETED */ null,
        /* PLEASE_FILL_IN_THE_LAST_FOUR_DIGITS_OF_THE_PHONE_NUMBER */ null,
        /* PLEASE_FILL_IN_YOUR_INFORMATION */ "请填写您的信息",
        /* PLEASE_FILL_REQUIRED_FIELDS */ null,
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY */ "请确保您输入的代码正确",
        /* PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_YOUR_PHONE_NUMBER_CORRECTLY */ null,
        /* PLEASE_MARK_ALL_THE_REQUIRED_DUTIES */ null,
        /* PLEASE_NOTE */ "请注意",
        /* PLEASE_PICK_VALID_DATES */ "请选择有效的日期",
        /* PLEASE_REQUEST_EXACTLY */ "必须请求确切的",
        /* PLEASE_SELECT_AN_OPTION */ null,
        /* PLEASE_SELECT_DATE_AND_TIME */ "请选择日期和时间",
        /* PLEASE_SELECT_THE_PATIENT_ADDRESS */ "请选择患者地址",
        /* PLEASE_SEND_US_A_MESSAGE_TO_REINSTATE_IT */ null,
        /* PLEASE_SET_UP_YOUR_PROFILE_PHOTO_BY_CLICKING_ON_THE_CAMERA_ICON_BELOW */ "请点击下方的摄像头图标以设置您的个人资料图片",
        /* PLEASE_SIGN_IN_AGAIN */ null,
        /* PLEASE_SPECIFY */ null,
        /* PLEASE_TAKE_A_SELFIE */ null,
        /* PLEASE_TELL_US_WHEN_DO_YOU_PLAN_TO_PERFORM_THIS_TASK */ null,
        /* PLEASE_TYPE_IN_YOUR_PHONE_NUMBER */ null,
        /* PLEASE_TYPE_THE_CODE_OF_THE_AGENCY_YOU_WOULD_LIKE_TO_WORK_WITH */ "请输入您想要合作的机构代码",
        /* PLEASE_TYPE_THE_LAST_FOUR_DIGITS_OF_THIS_PHONENUMBER */ null,
        /* PLEASE_TYPE_THE_SMS_CODE */ "请输入短消息中的代码",
        /* PLEASE_UPDATE_TO_OUR_NEWEST_VERSION */ "请更新至我们的最新版本",
        /* PLEASE_UPDATE_YOUR_ADDRESS */ "请更新您的地址",
        /* PLEASE_UPDATE_YOUR_FIRST_NAME */ "请更新您的名字",
        /* PLEASE_UPDATE_YOUR_LAST_NAME */ "请更新您的姓氏",
        /* PLEASE_WAIT */ null,
        /* PLEASE_WAIT_WHILE_WERE_VALIDATING_YOUR_LOCATION */ null,
        /* PLEASE_WATCH_THE_FULL_VIDEO_TO_PROCEED_TO_THE_APP */ null,
        /* POINTS */ "点",
        /* POINTS_AND_REWARDS */ null,
        /* POSTED_DATE */ "发布日期",
        /* PREBLOCK_VISIT_EXPLANATION */ "确认后，您要在有限的时间内联系患者，并选择出勤时间。",
        /* PRESENTATION */ "演示",
        /* PREVIOUS */ null,
        /* PREVIOUS_CONVERSATIONS */ null,
        /* PREVIOUS_WINNERS */ null,
        /* PRE_TAXES */ null,
        /* PRICE */ "价格",
        /* PRINCIPAL_DIAGNOSIS */ null,
        /* PRIORITY_CODE */ null,
        /* PRIVACY_POLICY */ "隐私政策",
        /* PROBLEM_GETTING_YOUR_LOCATION_PLEASE_TRY_AGAIN */ "获取您的位置信息出现问题，请重试。请尝试开启位置服务，或者到外面去。",
        /* PROBLEM_WITH_CASE_SETTINGS */ "看起来您的工作设置有问题",
        /* PROCESSING */ null,
        /* PROFESSIONAL_TYPE */ "职业类别",
        /* PROFILE */ "档案",
        /* PROGRESS */ "进度",
        /* PROXY_FIRST_NAME */ null,
        /* PROXY_LAST_NAME */ null,
        /* PROXY_PHONE */ null,
        /* PULSE */ null,
        /* QUESTION */ "问题",
        /* QUESTIONS */ "问题",
        /* QUESTIONS_TO_COPY_FROM */ "要复制的问题",
        /* QUESTION_NUMBER */ null,
        /* QUESTION_REJECTED */ null,
        /* QUIT */ null,
        /* RAFFLE_ENDED */ null,
        /* RAFFLE_INFO_1_DESCRIPTION */ null,
        /* RAFFLE_INFO_1_TITLE */ null,
        /* RAFFLE_INFO_2_DESCRIPTION */ null,
        /* RAFFLE_INFO_2_TITLE */ null,
        /* RAFFLE_INFO_3_DESCRIPTION */ null,
        /* RAFFLE_INFO_3_TITLE */ null,
        /* RAFFLE_INFO_4_DESCRIPTION */ null,
        /* RAFFLE_INFO_4_TITLE */ null,
        /* RAFFLE_NOW */ null,
        /* RAFFLE_PRIZE */ null,
        /* RANK_ACHIEVED */ null,
        /* REACH_NEW_RANKS_FOR_EXCITING_REWARDS_AND_RECOGNITION */ null,
        /* READY_FOR_YOUR_NEXT_TRAINING */ "准备好接受下次培训了吗？",
        /* READY_TO_CLOCK_IN */ null,
        /* READY_TO_CLOCK_OUT */ null,
        /* READ_AND_CONFIRM */ "阅读并确认",
        /* READ_ONLY_MODE */ null,
        /* READ_TEXT */ null,
        /* REASON */ null,
        /* RECENT_VISITS */ null,
        /* RECOMMENDED */ null,
        /* RECRUITMENT_MAIN_1 */ "看来您并",
        /* RECRUITMENT_MAIN_1_2 */ "无",
        /* RECRUITMENT_MAIN_2 */ "工作",
        /* RECRUITMENT_MAIN_2_1 */ "于任何机构",
        /* RECRUITMENT_MAIN_3 */ "要被机构雇用",
        /* RECRUITMENT_MAIN_4 */ "请填写申请表格",
        /* REFERRAL_CODE */ "推荐码",
        /* REFER_ME */ "推荐我！",
        /* REGISTRATION */ null,
        /* REGULAR_PAY */ null,
        /* REJECT */ "拒绝",
        /* REJECTED */ "已拒绝",
        /* REJECT_THIS_TASK */ null,
        /* REJECT_THIS_VISIT */ "拒绝此出勤",
        /* REMAINED */ null,
        /* REMAINING */ "余下的",
        /* REMIND_ME_LATER */ null,
        /* REMOVE */ "移除",
        /* REMOVE_PAGE */ "移除页面",
        /* REMOVE_TASK */ null,
        /* REOPENED */ null,
        /* REPLAY */ null,
        /* REQUEST */ "请求",
        /* REQUESTED */ "已请求",
        /* REQUESTED_LABEL_IN_CASES_LIST */ "工作列表中的“请求”标签。",
        /* REQUESTED_TIMES */ "请求的时间",
        /* REQUESTED_VISIT_CANCEL_EXPLANATION */ null,
        /* REQUESTING_REFERENCE_RESPONSE */ null,
        /* REQUEST_AGENCIES_MEMBERSHIP */ "请求成为机构会员",
        /* REQUEST_AGENCY */ "申请机构",
        /* REQUEST_AGENCY_MEMBERSHIP */ "申请机构会员资格",
        /* REQUEST_DETAILS */ "请求详情",
        /* REQUEST_FOR_APPOINTMENT */ "请求预约",
        /* REQUEST_FRIENDSHIP */ "申请加为好友",
        /* REQUEST_MORE_VISITS */ "请求更多出勤",
        /* REQUEST_MORE_VISITS_MESSAGE */ null,
        /* REQUEST_NUMBER_SHIFTS */ "请求%shifts%个班次",
        /* REQUEST_SELECTED_SHIFT */ null,
        /* REQUEST_SELECTED_SHIFTS */ null,
        /* REQUEST_SHIFTS */ "请求班次",
        /* REQUEST_SINGLE_SHIFT */ "请求一个班次",
        /* REQUEST_THE_TIMES_YOU_WANT */ "请求您想要的时间！",
        /* REQUEST_THIS_VISIT */ "请求此出勤",
        /* REQUEST_TO */ "请求",
        /* REQUEST_VISIT */ "请求拜访",
        /* REQUIRED */ "必需",
        /* REQUIRED_DOCUMENTS */ "所需文档",
        /* REQUIRED_FIELDS_MISSING_IN_PATIENT_DOC */ "文档中的一些必填字段缺失，请返回并填写",
        /* REQUIRED_PATIENT_DOCUMENT_TEXT */ "您这次出勤时必须填写下列文档",
        /* REQUIRED_TASKS */ null,
        /* REQUIREMENTS */ null,
        /* RESCHEDULE */ "重新安排",
        /* RESCHEDULED_SUCCESSFULLY */ "更改日期成功",
        /* RESCHEDULE_IN_THE_PAST_ERROR */ "不能把出勤日期更改为过去的日期。",
        /* RESCHEDULE_REQUESTS */ "重新安排请求",
        /* RESET_PIN_CODE_MESSAGE */ null,
        /* RESPIRATION_RATE */ null,
        /* RESUBMISSION_BANNER_TITLE */ null,
        /* RETAKE */ "重考",
        /* RETALIATORY_ACTION_BY_EMPLOYERS_PROHIBITION */ null,
        /* RETRY */ "重试",
        /* REVIEW_PRIVACY_POLICY */ "查看隐私政策",
        /* REVIEW_TASK */ null,
        /* REVIEW_TASKS */ null,
        /* RE_ENTER_YOUR_PIN_CODE */ "重新输入您的PIN码",
        /* RN_FLEXIBLE_SHOWCASE_TEXT */ "灵活出勤",
        /* RN_FLEX_EXPLANATION_PREFIX */ "这是",
        /* RN_FLEX_REQUESTED_EXPLANATION */ "您将会被要求选择适合您的日期和时间",
        /* RN_FLEX_REQUESTED_EXPLANATION_LINE_2 */ "这次出勤的时间范围如下",
        /* RN_PATIENT_CONTACT_EXPLANATION */ "这次出勤需要您与患者协调时间。",
        /* RN_SIGN_HERE */ "注册护士在此签名",
        /* ROUTING_NUMBER */ null,
        /* ROUTING_NUMBR */ null,
        /* SAFETY_AND_HEALTH */ null,
        /* SAVE */ "保存",
        /* SAVE_FOR_LATER */ null,
        /* SCAN_AND_UPLOAD_FILES */ "扫描和上传文件",
        /* SCAN_A_PHOTO */ null,
        /* SCAN_DOCUMENT */ "扫描文档",
        /* SCAN_NEW_DOCUMENT */ "扫描新文档",
        /* SCAN_WITH_CAMERA */ "用相机扫描",
        /* SCHEDULE */ "日程表",
        /* SCHEDULED */ null,
        /* SCHEDULED_DATE */ null,
        /* SCHEDULED_FOR */ null,
        /* SCHEDULED_VISIT_COMPLETE */ "预定的出勤已完成",
        /* SCHEDULED_VISIT_NOT_FOUND */ "未找到预定的出勤，请与机构联系",
        /* SCHEDULE_CONFIRMATION */ null,
        /* SCHEDULE_FOR */ null,
        /* SCHEDULE_TASK */ null,
        /* SCHEDULING_PROBLEM */ "日程问题",
        /* SCREENING */ "筛查",
        /* SCREENING_FOR */ "筛查：",
        /* SEARCH */ null,
        /* SEARCH_AGENCY */ "搜索机构",
        /* SEARCH_FOR_MEDICATIONS */ "搜索药物...",
        /* SEARCH_NEARY_VISITS */ null,
        /* SEARCH_PATIENT */ null,
        /* SECOND_SHIFT */ "第二班",
        /* SECTION_ALREADY_COMPLETED */ null,
        /* SECTION_COMPLETED_PROMPT */ null,
        /* SECTION_LOCKED_PROMPT */ null,
        /* SEE_ALL */ null,
        /* SEE_ALL_CONVERSATIONS */ null,
        /* SEE_IN_MAPS */ null,
        /* SEE_LIST_OF_VISITS */ "查看出勤列表",
        /* SEE_MORE_INFORMATION_ABOUT_PRE_SCREENING_REQUIREMENT */ null,
        /* SEE_YOUR_PROGRESS */ null,
        /* SELECT */ "选择",
        /* SELECTED */ null,
        /* SELECTED_VISIT */ null,
        /* SELECT_ALL */ "全选",
        /* SELECT_CERTIFICATE */ null,
        /* SELECT_DATE */ "选择频率",
        /* SELECT_DATE_AND_TIME */ null,
        /* SELECT_DOCUMENT */ null,
        /* SELECT_DX_CODE */ null,
        /* SELECT_FROM_LIST */ null,
        /* SELECT_PERTINENT_DIAGNOSIS */ null,
        /* SELECT_PHYSICIAN */ null,
        /* SELECT_PRINCIPAL_DIAGNOSIS */ null,
        /* SELECT_SHIFTS */ null,
        /* SELECT_START_TIME */ null,
        /* SELECT_SURGICAL_PROCEDURE */ null,
        /* SELECT_TIME */ "选择时间",
        /* SELECT_TIME_SLOT */ null,
        /* SELECT_TIME_SLOT_INFO */ null,
        /* SELECT_VISITS_FOR_INSTAPAY */ null,
        /* SELECT_VISIT_DURATION */ null,
        /* SELECT_YOUR_SCHEDULE */ null,
        /* SELFIE_WITH_PATIENT */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_IN */ null,
        /* SELFIE_WITH_PATIENT_MESSAGE_CLOCK_OUT */ null,
        /* SEND_A_MESSAGE */ null,
        /* SEND_EMAIL */ "发送电子邮件",
        /* SEND_REPORT */ "发送报告",
        /* SEND_US_A_MAIL */ "给我们发邮件",
        /* SEPTEMBER */ null,
        /* SETTINGS */ "设置",
        /* SETTINGS_AND_INFO */ null,
        /* SET_DOCUMENT_EXPIRY_DATE */ "设置文档过期日",
        /* SET_EXPIRATION_DATE */ "设置过期日",
        /* SET_YOUR_4_DIGIT_PIN_CODE */ "请设置您的4位数PIN码",
        /* SHARE */ null,
        /* SHARE_IDEAS_AND_GET_A_CHANCE */ null,
        /* SHARE_REFERENCE_LINK */ null,
        /* SHARE_THE_REFERENCE_LINK_TO_SPEED_THINGS_UP */ null,
        /* SHARE_WITH_YOUR_FRIENDS */ null,
        /* SHIFT */ "轮班",
        /* SHIFTS */ null,
        /* SHIFTS_DETAILS */ null,
        /* SHIFT_HAS_FINISHED_IN */ null,
        /* SHIFT_HAS_STARTED_IN */ null,
        /* SHOULD_BE_HERE */ "应该在这里",
        /* SHOW_ALL_TASKS */ null,
        /* SHOW_DETAILS */ null,
        /* SHOW_LESS */ "收起",
        /* SHOW_ME_CASES_IN_THE_NEXT */ "展示工作于下一",
        /* SHOW_ME_IN */ "在...中向我展示",
        /* SHOW_MORE */ "展开",
        /* SHOW_OLD_PLAN_OF_CARE */ "显示旧的护理计划",
        /* SHOW_TASKS_THAT_REQUIRE_FIXES */ null,
        /* SHOW_US_YOUR_SMILE */ null,
        /* SIGNATURES */ null,
        /* SIGNATURE_REQUIRED */ null,
        /* SIGN_DECLINATION_FORM */ null,
        /* SIGN_HERE */ "在这里签名",
        /* SIGN_IN */ "登录",
        /* SIGN_ORIENTATION_VIDEO */ "提交前请在这里签名",
        /* SIGN_ORIENTATION_VIDEO_ERR */ "提交前请签名",
        /* SIGN_OUT */ "退出",
        /* SIGN_UP_FREE */ null,
        /* SIGN_UP_ITS_FREE */ null,
        /* SINCE_YOU_CLOCKED_IN_INSTAPAY_POPUP_MESSAGE */ null,
        /* SINGLE_FLEXIBLE_VISIT_EXPLANATION */ null,
        /* SINGLE_VISIT_DETAILS */ "单次拜访详情",
        /* SINGLE_VISIT_FROM */ "单次拜访从",
        /* SINGLE_VISIT_TYPE */ "单次出勤",
        /* SIXTY_SECONDS_AND_YOU_ARE_DONE */ null,
        /* SKIP */ "跳过",
        /* SLIDE_ADDRESS_EXACT_ADDRESS_AFTER_CONFIRMATION */ null,
        /* SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS */ null,
        /* SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN */ null,
        /* SLIDE_FINAL_CONFIRMATION_NOTICE_IF_YOU_DONT_SHOW_UP_VISIT_NO_MORE_CASES */ null,
        /* SLIDE_MAIN_INFO_GO_NEXT_SCREENS */ null,
        /* SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW */ null,
        /* SLIDE_STEP_X_OF_COUNT */ null,
        /* SMILE_FOR_US */ null,
        /* SOCIAL */ "社交媒体",
        /* SOCIAL_MEDIA */ null,
        /* SOMETHING_WENT_WRONG */ "出了问题，请稍后再试",
        /* SOME_QUESTIONS_CHANGED_APPEARS_ON_OTHER_DOCUMENTS */ null,
        /* SOME_QUESTIONS_YOU_CHANGED_APPEARS_IN_X_DOCUMENTS_SHOULD_WE_UPDATE_THEM */ null,
        /* SOME_TASKS_NEED_FIXES */ null,
        /* SORRY */ null,
        /* SORT */ "排序",
        /* SPECIFIC_DAYS */ "特定日期",
        /* SPEECH_RECOGNITION */ null,
        /* SPLIT_SHIFTS_VISIT */ "分段值班",
        /* SPREAD_THE_WORD */ "传播消息",
        /* STAGE_APPROVED_MESSAGE */ null,
        /* STAGE_AWAITING_APPROVAL */ null,
        /* STAGE_COMPLETED_MESSAGE */ null,
        /* STAGE_X_OF_TOTAL_STAGES */ null,
        /* START */ null,
        /* STARTING_AT */ "开始于",
        /* STARTS */ "开始",
        /* STARTS_NEXT_WEEK */ null,
        /* STARTS_TODAY_IN */ null,
        /* START_APPLICATION */ "开始申请",
        /* START_A_SURVEY */ null,
        /* START_DATE */ "开始日期",
        /* START_FILLING */ null,
        /* START_NOW */ null,
        /* START_SHIFT */ null,
        /* START_TIME */ "开始时间",
        /* START_USING_MEDFLYT_PASSPORT */ null,
        /* START_WATCHING */ null,
        /* START_WATCHING_ORIENTATION_VIDEOS */ null,
        /* START_WORKING */ null,
        /* STATUS */ "状态",
        /* STAY_ON_TRACK */ null,
        /* STAY_ON_TRACK_1_ANSWER */ null,
        /* STAY_ON_TRACK_1_QUESTION */ null,
        /* STAY_ON_TRACK_2_ANSWER */ null,
        /* STAY_ON_TRACK_2_QUESTION */ null,
        /* STAY_ON_TRACK_3_ANSWER */ null,
        /* STAY_ON_TRACK_3_QUESTION */ null,
        /* STAY_ON_TRACK_4_ANSWER */ null,
        /* STAY_ON_TRACK_4_QUESTION */ null,
        /* STAY_ON_TRACK_DESCRIPTION */ null,
        /* STAY_TUNED_FOR_MORE_CASES_OR_TAP_TO_CAHNGE_SETTINGS */ null,
        /* STAY_TUNED_FOR_MORE_VISITS */ "敬请关注更多拜访",
        /* STAY_TUNED_FOR_THE_NEXT_RAFFLE */ null,
        /* STILL_WAITING_REFERENCE_ANSWER */ null,
        /* STOP */ null,
        /* STREAK_BREAK */ null,
        /* STREAK_BREAK_MESSAGE */ null,
        /* STREAK_BREAK_MESSAGE_2 */ null,
        /* SUBMIT */ "提交",
        /* SUBMITTED_AT */ null,
        /* SUBMITTED_DOCUMENTS */ "已提交的文档",
        /* SUBMITTED_MANUALLY */ "手动提交",
        /* SUBMIT_AFTER */ "在此之后提交",
        /* SUBMIT_AT */ "提交时间",
        /* SUBMIT_BY */ "提交者",
        /* SUBMIT_DUTIES */ null,
        /* SUBMIT_DUTIES_BEFORE_CLOCK_OUT */ null,
        /* SUBMIT_FORM */ null,
        /* SUBMIT_FORMS */ null,
        /* SUBMIT_MANUAL_TIMESHEET */ null,
        /* SUBMIT_REQUIRED */ "必需提交",
        /* SUBMIT_TEST */ "提交考试",
        /* SUBMIT_TIMESHEET */ null,
        /* SUBMIT_WITH_SCHEDULED_DATE */ "以预定日期提交",
        /* SUBMIT_WITH_TODAY_DATE */ "以今天的日期提交",
        /* SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT */ null,
        /* SUBMIT_YOUR_SIGN */ "提交您的签名",
        /* SUBMIT_YOUR_SIGNATURE */ "提交您的签名",
        /* SUCCESS */ "成功",
        /* SUCCESSFULLY_CLOCKED_IN */ null,
        /* SUCCESSFULLY_CLOCKED_OUT */ null,
        /* SUCCESSFULY_REQUESTED */ "请求成功！",
        /* SURGICAL_PROCEDURE */ null,
        /* SWITCH_TO_LIST_VIEW_TO_SEE_IMPORTED_VISITS */ "切换到列表视图以查看导入的出勤",
        /* SWITCH_VIEW */ "切换视图",
        /* TAKE_A_DIFFERENT_PHOTO */ null,
        /* TAKE_A_PHOTO */ "拍照",
        /* TAKE_A_SURVEY */ null,
        /* TAKE_ME_TO_CASE_SETTINGS */ "带我到工作设置",
        /* TAKE_PHOTO */ null,
        /* TAKE_THIS_TASK */ null,
        /* TAP_HERE_TO_VIEW */ "点击这里查看",
        /* TAP_TO_CANCEL */ "点击以取消",
        /* TAP_TO_CHANGE_CASE_SETTINGS */ "点击更改病例设置",
        /* TASK */ null,
        /* TASKS */ null,
        /* TASK_ALREADY_ASSIGNED */ null,
        /* TASK_COMPLETED_SUCCESSFULLY */ "恭喜🎉💪🏻您已完成此任务。",
        /* TASK_INFORMATION */ null,
        /* TASK_SCHEDULED */ null,
        /* TASK_SCHEDULED_MESSAGE */ null,
        /* TASK_WAS_REMOVED_FROM_YOUR_SCHEDULE */ null,
        /* TECHNICAL_SUPPORT */ "技术支持",
        /* TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES */ "告诉我们您不感兴趣的原因，以便我们能够给您发送更好的病例",
        /* TELL_US_YOUR_AGENY_DESCRIPTION */ "告诉我们您的机构名称、协调员的姓名，我们会联系他们，发布可提供的工作。",
        /* TEMPERATURE */ null,
        /* TEN_DOLLAR_STARBUCKS_GIFT_CARD */ null,
        /* TERMINATED */ "已终止",
        /* TERMS_OF_MEDFLYT_PRIVACY_POLICY */ null,
        /* TERMS_OF_USE */ "使用条款",
        /* TEST */ "考试",
        /* TESTS */ null,
        /* TEST_COMPLETED */ null,
        /* TEST_FAILED */ "考试不合格",
        /* TEST_REQUIRED */ "所需考试",
        /* THANKS */ null,
        /* THANK_YOU */ null,
        /* THANK_YOU_FOR_YOUR_FEEDBACK */ "谢谢您的反馈。",
        /* THATS_ME */ null,
        /* THERES_X_HOURS_UNTIL_FINAL_CONFIRMATION */ null,
        /* THERE_ARE_ISSUES_WITH_SOME_OF_YOUR_VISITS */ null,
        /* THERE_ARE_NO_AGENCIES_YET */ "还没有机构",
        /* THERE_ARE_NO_ASSIGNED_CASES */ null,
        /* THERE_IS_A_PROBLEM_WITH_YOUR_INTERNET_CONNECTION */ "您的网络连接有问题",
        /* THERE_SEEMS_TO_BE_NOTHING_HERE */ "这里似乎什么也没有...",
        /* THE_AWARDS_ARE_COMING_SOON */ null,
        /* THE_BEST_PLACE_FOR_CAREGIVERS */ null,
        /* THE_DUTY_SHEET_HAS_BEEN_SUBMITTED */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_1230PM_TOMORROW */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_6PM_TODAY */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_BY_MONDAY_MORNING */ null,
        /* THE_MONEY_WILL_BE_TRANSFERRED_TO_YOU_SOON */ null,
        /* THE_MORE_VISITS_YOU_COMPLETE_THE_HIGHER_YOUR_EARNINGS */ null,
        /* THE_NEXT_WINNERS_ANNOUNCEMENT */ "下一位赢家的公布",
        /* THE_SELECTED_DATE_IS_EARLIER_THAN */ null,
        /* THE_VISIT_CAN_BE_PERFORMED_ON_THE_FOLLOWING_DAYS */ "出勤可以在下列日期进行",
        /* THE_VISIT_HAS_NOT_STARTED_YET */ null,
        /* THIS_BENEFIT_WILL_BE_OFFERED_FOR_THE_NEXT_FEW_MONTHS */ null,
        /* THIS_BUNDLE_INCLUDES */ null,
        /* THIS_CONVERSATION_HAS_BEEN_RESOLVED */ null,
        /* THIS_COURSE_CONSISTS_OF_X_LESSONS_GOOD_LUCK */ "本课程包含%d节课。祝您好运！",
        /* THIS_FIELD_IS_CURRENTLY_DISABLED */ null,
        /* THIS_IS_AN_OLD_VISIT_UNABLE_TO_CLOCK_IN_OUT */ "这是过时的拜访，无法开始/结束工作",
        /* THIS_IS_A_FUTURE_VISIT */ null,
        /* THIS_IS_A_LIVE_CLASS_SESSION */ null,
        /* THIS_MAY_TAKE_UP_TO_X_SECONDS */ null,
        /* THIS_PATIENT_BELONGS_TO_AGENCY */ null,
        /* THIS_PATIENT_HAS_NO_PHONE_NUMBERS */ null,
        /* THIS_QUESTION_IS_READ_ONLY_YOU_ARE_NOT_ALLOWED_TO_ANSWER */ null,
        /* THIS_TASK_IS_OVERDUE_SCHEDULE_ASAP */ null,
        /* THIS_VISIT_CAN_BE_PERFORMED_BETWEEN */ "这次出勤可以在下列时间内进行",
        /* THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE */ null,
        /* THIS_VISIT_IS_FOR_DIFFERENT_AGENCY */ null,
        /* THIS_VISIT_IS_IN_THE_FUTURE_YOU_CAN_NOT_CLOCK_IN_YET */ "此拜访时间未到，您还不可以开始工作",
        /* THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY */ null,
        /* THIS_WILL_MARK_THE_VISIT_AS_MISSED */ null,
        /* TIME */ "时间",
        /* TIMESHEET_SUBMITTED */ null,
        /* TIME_ESTIMATION */ null,
        /* TIME_FRAME */ "时间范围",
        /* TIME_LEFT */ "余下的时间",
        /* TIME_VARIES */ "时间会有所不同",
        /* TO */ "到",
        /* TODAY */ null,
        /* TODAYS_DATE */ null,
        /* TOKENS */ null,
        /* TOO_MANY_HOURS */ "时间太长",
        /* TOO_MANY_SHIFTS */ "班次太多了！",
        /* TOO_MANY_SHIFTS_MESSAGE */ "您最多可以选择%maxShifts%个班次。如果您想选择这个班次，您必须取消选择您已经选择的其中一个班次。",
        /* TOP_CAREGIVERS_IN_YOUR_AREA */ "您所处区域的顶级护理员",
        /* TOTAL_EARNED */ null,
        /* TOTAL_SPENT */ null,
        /* TO_FILL_IN_A_FORM_INSTEAD */ null,
        /* TO_GET_PAID_ON_TIME_YOU_NEED_TO_CLOCK_IN_AND_OUT */ null,
        /* TO_SEE_THIS_TASK_GO_TO_ASSIGNED */ null,
        /* TO_SEE_THIS_VISIT_GO_TO */ "要查看这次出勤，请查找",
        /* TO_UPLOAD_A_FILE_INSTEAD */ null,
        /* TO_WIN_AN_IPHONE12 */ null,
        /* TRAINING */ null,
        /* TRAININGS_FOR */ "培训内容是",
        /* TRAINING_CENTER */ "培训中心",
        /* TRAINING_CENTER_REMINDERS */ null,
        /* TRY_AGAIN */ null,
        /* TYPE_AGENCY_CODE */ "输入机构代码",
        /* TYPE_MESSAGE */ "输入消息",
        /* TYPE_YOUR_ADDRESS */ "输入您的地址",
        /* UNABLE_TO_EDIT_SUBMITTED_DUTY_SHEET */ null,
        /* UNANSWERED_LAST_SECTION_FOR_NOW */ null,
        /* UNAUTHORIZED */ null,
        /* UNAVAILABLE_LOCATION_SERVICES_MESSAGE */ null,
        /* UNDER_REVIEW */ null,
        /* UNDO */ "还原",
        /* UNIQUE_ERROR_CODE */ "唯一的错误代码",
        /* UNSCHEDULE */ null,
        /* UNSCHEDULE_TASK */ null,
        /* UNSPECIFIED */ null,
        /* UNTIL */ "直到",
        /* UPCOMING_VISITS */ null,
        /* UPDATED_AT */ null,
        /* UPDATE_INFORMATION */ null,
        /* UPLOAD */ "上传",
        /* UPLOADED */ "已上传",
        /* UPLOADED_FILE_VIEW */ null,
        /* UPLOADING */ "正在上传",
        /* UPLOAD_A_DOCUMENT */ null,
        /* UPLOAD_A_FILE */ null,
        /* UPLOAD_DOCUMENT */ "上传文档",
        /* UPLOAD_DOCUMENTS */ "上传文档",
        /* UPLOAD_ERROR */ "上传错误",
        /* UPLOAD_FILES_TO_ENSURE */ "上传文件以确保",
        /* UPLOAD_FLU_SHOT_DOCUMENT */ null,
        /* UPLOAD_FROM_GALLERY */ null,
        /* UPLOAD_NEW_DOCUMENT */ null,
        /* UPLOAD_VIDEO */ null,
        /* UPLOAD_YOUR_FILES_TO_ENSURE */ "上传您的文件以确保",
        /* UP_COMING_REASSESSMENTS */ "即将进行的重新评估",
        /* UP_TO */ null,
        /* URGENT */ null,
        /* USER_HAS_BEEN_LOCKED_DUE_TO_SUSPICIOUS_ACTIVITY */ "由于可疑活动，此用户已被锁定",
        /* VALID */ "有效",
        /* VERIFIED */ "已验证",
        /* VERIFY */ null,
        /* VERIFYING */ null,
        /* VERIFY_YOUR_LOCATION */ null,
        /* VERY_URGENT */ null,
        /* VIDEO */ "视频",
        /* VIDEOS */ null,
        /* VIDEOS_IN_TRAINING_CENTER_REQUIRE_YOUR_ATTENTION */ "培训中心的视频需要您的注意。",
        /* VIDEO_COMPLETED_SUCCESSFULLY */ "恭喜🎉💪🏻您已看完视频。",
        /* VIEW */ "查看",
        /* VIEWED */ "已查看",
        /* VIEW_ALL */ null,
        /* VIEW_ANSWERS */ null,
        /* VIEW_CERTIFICATE */ "查看证书",
        /* VIEW_TASK */ null,
        /* VIEW_TASKS_PENDING_FOR_SCHEDULE */ null,
        /* VIEW_VISIT */ null,
        /* VIRTUAL_ID_CARD */ null,
        /* VISIT */ null,
        /* VISITS */ "出勤",
        /* VISITS_MAP_SEARCH_ADDRESS_PLACEHOLDER */ null,
        /* VISITS_NEXT_MONTH */ null,
        /* VISITS_OUTSIDE_YOUR_AVAILABILITY */ null,
        /* VISITS_PER_WEEK */ "每周出勤次数",
        /* VISITS_WITH_ISSUES */ null,
        /* VISIT_ASSIGNED_CHECK_IT_OUT_IN_YOUR_SCHEDULE */ "出勤已分配，请在您的日程中查看",
        /* VISIT_BY */ "拜访人",
        /* VISIT_CHAT */ "拜访聊天",
        /* VISIT_COMPLETE */ null,
        /* VISIT_COMPLETED_SUCCESSFULLY */ null,
        /* VISIT_COUNTS */ null,
        /* VISIT_COUNTS_DESCRIPTION */ null,
        /* VISIT_DATE */ "拜访日期",
        /* VISIT_DATES */ null,
        /* VISIT_DETAILS */ "出勤详细信息",
        /* VISIT_DURATION */ null,
        /* VISIT_INFORMATION */ null,
        /* VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU */ null,
        /* VISIT_LASTING */ "拜访时间",
        /* VISIT_NEXT_MONTH */ null,
        /* VISIT_NOTIFICATIONS_OFF */ "出勤通知 - 关闭",
        /* VISIT_NOTIFICATIONS_ON */ "出勤通知 - 打开",
        /* VISIT_NOT_CLOCKED_IN_ARE_YOU_SURE */ "这次出勤您尚未打卡上班。您确定要打卡下班吗？",
        /* VISIT_NO_LONGER_AVAILABLE */ "此出勤不再提供",
        /* VISIT_RATE_REQUEST_CONFIRMATION */ null,
        /* VISIT_REMINDERS */ null,
        /* VISIT_REQUEST_CONFIRMATION_WARNING */ null,
        /* VISIT_SCHEDULE */ null,
        /* VISIT_STARTED_AT */ null,
        /* VISIT_STARTED_MISSING_CLOCK_IN */ null,
        /* VISIT_STARTS_AT */ null,
        /* VISIT_SUCESSFULLY_CANCELED */ "出勤已成功取消",
        /* VISIT_TIME_ADJUSTMENT */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_EARLY */ null,
        /* VISIT_TIME_ADJUSTMENT_CONTENT_LATE */ null,
        /* VISIT_TOO_SHORT */ null,
        /* VISIT_TYPE */ null,
        /* VISIT_WITH */ null,
        /* VOUCHER */ null,
        /* WAITING_FOR_APPROVAL */ "正在等待批准",
        /* WAITING_TO_BE_SCHEDULED */ null,
        /* WARNING */ "警告！",
        /* WAS_DUE_BETWEEN */ null,
        /* WAS_DUE_ON */ null,
        /* WATCHED */ "已观看",
        /* WATCH_HOW_IT_WORKS */ null,
        /* WATCH_REQUIRED */ "需要观看",
        /* WATCH_TRAINING_VIDEOS_TO_COMPLETE */ null,
        /* WEEKLY_DETAILS */ null,
        /* WELCOME */ null,
        /* WELCOME_BACK */ null,
        /* WELCOME_TO_CARE_MOMENTS */ null,
        /* WELCOME_TO_MEDFLYT */ null,
        /* WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE */ null,
        /* WELL_BE_IN_TOUCH_SHORTLY */ "我们很快就会联系您。",
        /* WERE_YOU_REFERRED_BY_SOMEONE */ "您是别人推荐的吗？",
        /* WE_ARE_MISSING_THE_RECORD_FOR_YOUR_COMPLIANCE_ITEM */ null,
        /* WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR */ "我们找不到您要找的药物",
        /* WE_COULDNT_FIND_YOUR_AGENCY */ "我们找不到您的机构！",
        /* WE_GOT_YOUR_CONFIRMATION */ null,
        /* WE_GOT_YOUR_RESPONSE_WAIT_HH_MM */ null,
        /* WE_HAVE_ONE_MATCHING_ACCOUNT */ null,
        /* WE_HAVE_X_MATCHING_ACCOUNTS */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_IN */ null,
        /* WE_NEED_SELFIE_TO_VERIFY_BEFORE_CLOCK_OUT */ null,
        /* WE_WERE_UNABLE_TO_LOG_YOU_IN_PLEASE_CONTACT_MEDFLYT_SUPPORT */ null,
        /* WE_WILL_SEND_YOU_THE_FINAL_CONFIRMATION_SOON */ null,
        /* WHAT_A_NICE_PHOTO_SHOULD_WE_CONTINUE */ null,
        /* WHAT_BENEFITS_CAN_YOU_GET */ null,
        /* WHAT_IS_THE_REASON_YOU_WANT_TO_REMOVE_THE_TASK */ null,
        /* WHAT_WOULD_YOU_LIKE_TO_DO_FIRST */ null,
        /* WHENEVER_YOU_SEE_A_FLEXIBLE_VISIT */ "每当看到灵活出勤，您就可以请求适合您的时间",
        /* WHICH_VISITS_WOULD_YOU_LIKE_TO_GET_INSTAPAY_FOR */ null,
        /* WHOOPS */ "哎呀",
        /* WHOS_THE_LUCKY_ONE */ null,
        /* WILL_BEGIN_SHORTLY */ null,
        /* WILL_EXPIRE_IN_DAYS */ null,
        /* WILL_EXPIRE_TOMORROW */ null,
        /* WINNER_ANNOUNCED_IN */ null,
        /* WITH_CAREGIVERS */ "与护理员",
        /* WORKING_WITH_AGENCY */ "我在一家机构工作",
        /* WRONG_DATES_SELECTION */ null,
        /* WRONG_PHONE_NUMBER */ null,
        /* WRONG_PIN */ "错误的PIN码",
        /* X_DAYS_SELECTED */ null,
        /* X_DAYS_TO_COMPLETE */ "尚有%d天时间去完成",
        /* X_DAYS_TO_SELECT */ null,
        /* X_HOURS_SELECTED */ null,
        /* X_HOURS_TO_SELECT */ null,
        /* YAY_YOU_WERE_ASSIGNED_TO_A_VISIT */ null,
        /* YEAR */ null,
        /* YEARS_OLD */ null,
        /* YES */ "是",
        /* YES_ADJUST_TIMES */ null,
        /* YES_DELETE */ null,
        /* YES_I_AM_SURE */ null,
        /* YES_OVERRIDE_FORM */ null,
        /* YES_REQUEST_ANYWAY */ null,
        /* YES_SCHEDULE_VISIT */ null,
        /* YES_THATS_ME */ null,
        /* YES_UPDATE_ALL */ null,
        /* YOURE_ALL_DONE_LETS_GET_YOU_WORKING */ null,
        /* YOURE_IN_THE_RAFFLE */ null,
        /* YOURE_NOT_IN_THE_RAFFLE */ null,
        /* YOURSELF */ "您本人",
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_HOLD */ null,
        /* YOUR_ACCOUNT_IS_CURRENTLY_ON_LEAVE */ null,
        /* YOUR_AGENCY_MAY_NOT_HAVE_ASSIGNED_YOU_LESSONS */ "您的机构可能没有分配课程给您。请稍后再试。",
        /* YOUR_ANSWER_IS_CORRECT */ "您的答案是正确的！",
        /* YOUR_ANSWER_IS_INCORRECT */ "您的答案不正确",
        /* YOUR_COMPLIANCE */ "您的合规性",
        /* YOUR_COMPLIANCE_ITEM_HAS_EXPIRED */ null,
        /* YOUR_COMPLIANCE_ITEM_IS_DUE_IN_DAYS */ null,
        /* YOUR_FILE_IS_BEING_UPLOADED */ "正在上传您的文件",
        /* YOUR_IN_SERVICE_IS_DUE_IN_DAYS */ null,
        /* YOUR_IN_SERVICE_IS_OVER_DUE */ null,
        /* YOUR_MOBILE */ "您的手机",
        /* YOUR_REFERERAL_CODE */ "您的推荐码",
        /* YOUR_TASK_HAS_BEEN_SCHEDULED_FOR */ null,
        /* YOUR_TIMESHEET_HAS_BEEN_SUBMITTED_SUCCESSFULLY */ null,
        /* YOUVE_BEEN_SUCCESSFULLY_REFERRED */ "您已被成功推荐",
        /* YOUVE_COMPLETED_ALL_THE_LESSONS_FOR_NOW */ "您现在已经完成了所有的课",
        /* YOU_ALREADY_FAILED */ "您的考试已经不合格。",
        /* YOU_ALREADY_HAVE_A_VISIT_SCHEDULED_FOR_THAT_TIME_SLOT */ "您在该时间段已有一次出勤",
        /* YOU_ALREADY_REQUESTED_THIS_VISIT */ null,
        /* YOU_ALREADY_SUCCEEDED */ "您已经通过了考试。",
        /* YOU_ARE_ALL_SET */ null,
        /* YOU_ARE_BEING_REDIRECTED_TO_NEXT_SECTION */ null,
        /* YOU_ARE_COMPLIANT */ null,
        /* YOU_ARE_EXEMPT_FROM_THIS_TEST */ "您可以豁免此考试",
        /* YOU_ARE_NOT_ALLOWED_TO_EDIT_THIS_FIELD */ null,
        /* YOU_ARE_NOT_COMPLIANT */ null,
        /* YOU_ARE_NOT_COMPLIANT_AND_IT_MAY_PREVENT_YOU_FROM */ null,
        /* YOU_ARE_OUT_OF_COMPLIANCE */ null,
        /* YOU_ARE_X_DAYS_LATE */ "您迟了%d天。",
        /* YOU_CANNOT_EDIT_YOUR_ANSWERS */ null,
        /* YOU_CANT_EDIT_VISIT_WITH_CICO */ null,
        /* YOU_CANT_HAVE_MORE_THAN_ONE_PRINCIPAL_OR_SURGICAL_DIAGNOSES */ null,
        /* YOU_CANT_SIGN_BEFORE_ALL_ANSWERED */ null,
        /* YOU_CANT_USE_THE_SAME_ICD_CODE_MORE_THAN_ONCE */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_AND_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_DAYS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_CHOOSE_WHICH_HOURS_FLEXIBLE_VISIT */ null,
        /* YOU_CAN_COLLECT_YOUR_POINTS_IN_THE_MEANTIME */ null,
        /* YOU_CAN_CONTACT_THE_PATIENT_IF_NEEDED */ null,
        /* YOU_CAN_CONTINUE_TO_NEXT_SECTION */ null,
        /* YOU_CURRENTLY_DONT_HAVE_ENOUGH_BALANCE_FOR_INSTAPAY */ null,
        /* YOU_DIDNT_ANSWER_ALL_QUESTIONS */ null,
        /* YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN */ "您未输入相同的PIN码。请重试。",
        /* YOU_DONT_HAVE_ANY_CASES_YET */ null,
        /* YOU_DONT_HAVE_ANY_PATIENTS_YET */ null,
        /* YOU_GET_POINTS */ null,
        /* YOU_GOT_THE_CASE */ null,
        /* YOU_GOT_THE_CERTIFICATE */ "您拿到证书了！",
        /* YOU_HAVENT_CLOCKED_IN_YET */ "您尚未打卡上班",
        /* YOU_HAVENT_CLOCKED_OUT_YET */ "您尚未打卡下班",
        /* YOU_HAVENT_UPLOADED_ANYTHING_YET */ "您尚未上传任何内容",
        /* YOU_HAVE_COMPLETED_THIS_TEST */ null,
        /* YOU_HAVE_HH_MM_TO_CONFIRM_IT */ null,
        /* YOU_HAVE_MISSING_COMPLIANCE_ITEMS */ null,
        /* YOU_HAVE_MORE_THAN_ONE_SHIFT_THAT_IS_ACTIVE_NOW */ null,
        /* YOU_HAVE_NOT_WATCHED */ "您没有观看",
        /* YOU_HAVE_NO_ATTEMPTS_LEFT_PLEASE_CONTACT_YOUR_AGENCY */ null,
        /* YOU_HAVE_NO_TOKENS_COMPLETE_MORE_SHIFTS */ null,
        /* YOU_HAVE_ONE_ATTEMPT_LEFT */ null,
        /* YOU_HAVE_ONE_DAY_TO_COMPLETE_THIS_TRAINING */ "您有一天时间来完成这项培训！",
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_SECTION */ null,
        /* YOU_HAVE_SUCCESSFULLY_COMPLETED_THIS_TRAINING */ "您已成功完成这项培训🚀",
        /* YOU_HAVE_TO_COMPLETE_THIS_TRAINING_TODAY */ "您必须在今天内完成这项培训。请趕快！",
        /* YOU_HAVE_TO_ENROLL_FIRST */ null,
        /* YOU_HAVE_TO_PICK_A_CODE */ null,
        /* YOU_HAVE_TO_SELECT_AT_LEAST_ONE_SHIFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_LEFT */ null,
        /* YOU_HAVE_X_ATTEMPTS_TO_ANSWER_THIS_TEST */ null,
        /* YOU_HAVE_X_CORRECT_ANSWERS_OUT_OF_Y */ null,
        /* YOU_HAVE_X_DAYS_TO_COMPLETE_THIS_TRAINING */ "您有%d天时间来完成这项培训！",
        /* YOU_JUST_GOT_PAID */ null,
        /* YOU_JUST_GOT_PROMOTED_TO */ null,
        /* YOU_LOSE_POINTS */ null,
        /* YOU_MAY_CHANGE_YOUR_VISIT_SETTINGS_TO_RECEIVE_MORE_RELEVANT_VISITS */ "您可以更改出勤设置以接收更多适合的出勤",
        /* YOU_MAY_NOT_ANSWER_THE_TEST_BECAUSE */ "您不能接受考试，因为",
        /* YOU_MAY_ONLY_SUBMIT_AFTER */ "您只能在完成所需时间的",
        /* YOU_MISSED_A_SHIFT_WITHOUT_NOTICE */ null,
        /* YOU_MUST_ANSWER_ALL_THE_QUESTIONS */ "您必须回答所有的问题。",
        /* YOU_MUST_SUBMIT_ALL_THE_DUTIES_BEFORE_CLOCKING_OUT */ null,
        /* YOU_MUST_WATCH_PREVIOUS_VIDEOS_FIRST */ "您必须先看前面的视频",
        /* YOU_NEED_TO_ALLOW_ACCESS_TO_YOUR_GPS_LOCATION */ null,
        /* YOU_NEED_TO_COMPLETE_MORE_SHIFTS_TO_ENTER_THE_RAFFLE */ null,
        /* YOU_NEED_TO_ENTER_A_NOTE_TO_ALL_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_MARK_ALL_THE_REQUIRED_TASKS */ null,
        /* YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT */ null,
        /* YOU_RECENTLY_WON_A_RAFFLE */ null,
        /* YOU_SHOULD_WEAR_YOUR_MASK_THE_WHOLE_VISIT */ null,
        /* YOU_USED_THE_CODE */ "您使用了该代码",
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE */ null,
        /* YOU_WILL_FALL_OUT_OF_COMPLIANCE_IN_DAYS */ null,
        /* YOU_WILL_SEE_THE_MONEY_IN_YOUR_ACCOUNT_IN_THE_NEXT_HOURS */ null
    ]
};
